import 'animate.css';
import classNames67 from 'classnames';
import * as React from 'react';
import React__default, { forwardRef, createContext, useCallback, useRef, useMemo, memo, useEffect, useState, useContext, Children, isValidElement, createElement } from 'react';
import { Provider, Root, Trigger, Portal, Content } from '@radix-ui/react-tooltip';
import { jsx, jsxs, Fragment } from 'react/jsx-runtime';
import { property, debounce, map, keyBy, castArray, isEmpty, get, pick } from 'es-toolkit/compat';
import { useTranslation, initReactI18next } from 'react-i18next';
export { Trans, initReactI18next, useTranslation } from 'react-i18next';
import { usePopper } from 'react-popper';
export { usePopper } from 'react-popper';
import { toast } from 'react-toastify';
export { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import i18n from 'i18next';
export { default as i18n } from 'i18next';
export { default as LanguageDetector } from 'i18next-browser-languagedetector';
import 'intl-pluralrules';
import Backend from 'i18next-http-backend';
export { default as Backend } from 'i18next-http-backend';
import { formatDistanceToNow, format } from 'date-fns';
export { format as dateFormat, format, formatDistanceToNow } from 'date-fns';
import { createPortal } from 'react-dom';
export { CSSTransition, SwitchTransition, Transition, TransitionGroup } from 'react-transition-group';
import * as yup from 'yup';
export { yup };
import { Calendar as Calendar$1 } from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import { CellMeasurerCache, AutoSizer, List, InfiniteLoader, CellMeasurer } from 'react-virtualized';
export { AutoSizer, Column as VirtualizedColumn, Table as VirtualizedTable } from 'react-virtualized';
import { noop, identity } from 'es-toolkit/function';
import { Chart, ArcElement, Tooltip, Legend, Title, SubTitle, CategoryScale, LinearScale, PointElement, LineElement, BarElement } from 'chart.js';
import { Pie, Line, Doughnut, Bar } from 'react-chartjs-2';
import '@testsigmainc/phoenix/dist/css/index.css';
import { Slot, Slottable } from '@radix-ui/react-slot';
import { cva } from 'class-variance-authority';
import { clsx } from 'clsx';
import * as LabelPrimitive from '@radix-ui/react-label';
import * as RadixSlider from '@radix-ui/react-slider';
import OtpInput from 'react-otp-input';
import { compact } from 'es-toolkit/array';
import { omit } from 'es-toolkit';
import { capitalize } from 'es-toolkit/string';
import { Tree as Tree$1 } from 'react-arborist';
export { NodeApi, TreeApi } from 'react-arborist';

var __defProp = Object.defineProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var matchIconName = /^[a-z0-9]+(-[a-z0-9]+)*$/;
var stringToIcon = (value, validate, allowSimpleName, provider = "") => {
  const colonSeparated = value.split(":");
  if (value.slice(0, 1) === "@") {
    if (colonSeparated.length < 2 || colonSeparated.length > 3) {
      return null;
    }
    provider = colonSeparated.shift().slice(1);
  }
  if (colonSeparated.length > 3 || !colonSeparated.length) {
    return null;
  }
  if (colonSeparated.length > 1) {
    const name2 = colonSeparated.pop();
    const prefix = colonSeparated.pop();
    const result = {
      // Allow provider without '@': "provider:prefix:name"
      provider: colonSeparated.length > 0 ? colonSeparated[0] : provider,
      prefix,
      name: name2
    };
    return validate && !validateIconName(result) ? null : result;
  }
  const name = colonSeparated[0];
  const dashSeparated = name.split("-");
  if (dashSeparated.length > 1) {
    const result = {
      provider,
      prefix: dashSeparated.shift(),
      name: dashSeparated.join("-")
    };
    return validate && !validateIconName(result) ? null : result;
  }
  if (allowSimpleName && provider === "") {
    const result = {
      provider,
      prefix: "",
      name
    };
    return validate && !validateIconName(result, allowSimpleName) ? null : result;
  }
  return null;
};
var validateIconName = (icon, allowSimpleName) => {
  if (!icon) {
    return false;
  }
  return !!((icon.provider === "" || icon.provider.match(matchIconName)) && (allowSimpleName && icon.prefix === "" || icon.prefix.match(matchIconName)) && icon.name.match(matchIconName));
};
var defaultIconDimensions = Object.freeze(
  {
    left: 0,
    top: 0,
    width: 16,
    height: 16
  }
);
var defaultIconTransformations = Object.freeze({
  rotate: 0,
  vFlip: false,
  hFlip: false
});
var defaultIconProps = Object.freeze({
  ...defaultIconDimensions,
  ...defaultIconTransformations
});
var defaultExtendedIconProps = Object.freeze({
  ...defaultIconProps,
  body: "",
  hidden: false
});
function mergeIconTransformations(obj1, obj2) {
  const result = {};
  if (!obj1.hFlip !== !obj2.hFlip) {
    result.hFlip = true;
  }
  if (!obj1.vFlip !== !obj2.vFlip) {
    result.vFlip = true;
  }
  const rotate = ((obj1.rotate || 0) + (obj2.rotate || 0)) % 4;
  if (rotate) {
    result.rotate = rotate;
  }
  return result;
}
function mergeIconData(parent, child) {
  const result = mergeIconTransformations(parent, child);
  for (const key in defaultExtendedIconProps) {
    if (key in defaultIconTransformations) {
      if (key in parent && !(key in result)) {
        result[key] = defaultIconTransformations[key];
      }
    } else if (key in child) {
      result[key] = child[key];
    } else if (key in parent) {
      result[key] = parent[key];
    }
  }
  return result;
}
function getIconsTree(data, names) {
  const icons = data.icons;
  const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
  const resolved = /* @__PURE__ */ Object.create(null);
  function resolve(name) {
    if (icons[name]) {
      return resolved[name] = [];
    }
    if (!(name in resolved)) {
      resolved[name] = null;
      const parent = aliases[name] && aliases[name].parent;
      const value = parent && resolve(parent);
      if (value) {
        resolved[name] = [parent].concat(value);
      }
    }
    return resolved[name];
  }
  (Object.keys(icons).concat(Object.keys(aliases))).forEach(resolve);
  return resolved;
}
function internalGetIconData(data, name, tree) {
  const icons = data.icons;
  const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
  let currentProps = {};
  function parse(name2) {
    currentProps = mergeIconData(
      icons[name2] || aliases[name2],
      currentProps
    );
  }
  parse(name);
  tree.forEach(parse);
  return mergeIconData(data, currentProps);
}
function parseIconSet(data, callback) {
  const names = [];
  if (typeof data !== "object" || typeof data.icons !== "object") {
    return names;
  }
  if (data.not_found instanceof Array) {
    data.not_found.forEach((name) => {
      callback(name, null);
      names.push(name);
    });
  }
  const tree = getIconsTree(data);
  for (const name in tree) {
    const item = tree[name];
    if (item) {
      callback(name, internalGetIconData(data, name, item));
      names.push(name);
    }
  }
  return names;
}
var optionalPropertyDefaults = {
  provider: "",
  aliases: {},
  not_found: {},
  ...defaultIconDimensions
};
function checkOptionalProps(item, defaults) {
  for (const prop in defaults) {
    if (prop in item && typeof item[prop] !== typeof defaults[prop]) {
      return false;
    }
  }
  return true;
}
function quicklyValidateIconSet(obj) {
  if (typeof obj !== "object" || obj === null) {
    return null;
  }
  const data = obj;
  if (typeof data.prefix !== "string" || !obj.icons || typeof obj.icons !== "object") {
    return null;
  }
  if (!checkOptionalProps(obj, optionalPropertyDefaults)) {
    return null;
  }
  const icons = data.icons;
  for (const name in icons) {
    const icon = icons[name];
    if (!name.match(matchIconName) || typeof icon.body !== "string" || !checkOptionalProps(
      icon,
      defaultExtendedIconProps
    )) {
      return null;
    }
  }
  const aliases = data.aliases || /* @__PURE__ */ Object.create(null);
  for (const name in aliases) {
    const icon = aliases[name];
    const parent = icon.parent;
    if (!name.match(matchIconName) || typeof parent !== "string" || !icons[parent] && !aliases[parent] || !checkOptionalProps(
      icon,
      defaultExtendedIconProps
    )) {
      return null;
    }
  }
  return data;
}
var dataStorage = /* @__PURE__ */ Object.create(null);
function newStorage(provider, prefix) {
  return {
    provider,
    prefix,
    icons: /* @__PURE__ */ Object.create(null),
    missing: /* @__PURE__ */ new Set()
  };
}
function getStorage(provider, prefix) {
  const providerStorage = dataStorage[provider] || (dataStorage[provider] = /* @__PURE__ */ Object.create(null));
  return providerStorage[prefix] || (providerStorage[prefix] = newStorage(provider, prefix));
}
function addIconSet(storage2, data) {
  if (!quicklyValidateIconSet(data)) {
    return [];
  }
  return parseIconSet(data, (name, icon) => {
    if (icon) {
      storage2.icons[name] = icon;
    } else {
      storage2.missing.add(name);
    }
  });
}
function addIconToStorage(storage2, name, icon) {
  try {
    if (typeof icon.body === "string") {
      storage2.icons[name] = { ...icon };
      return true;
    }
  } catch (err) {
  }
  return false;
}
var simpleNames = false;
function allowSimpleNames(allow) {
  if (typeof allow === "boolean") {
    simpleNames = allow;
  }
  return simpleNames;
}
function getIconData(name) {
  const icon = typeof name === "string" ? stringToIcon(name, true, simpleNames) : name;
  if (icon) {
    const storage2 = getStorage(icon.provider, icon.prefix);
    const iconName = icon.name;
    return storage2.icons[iconName] || (storage2.missing.has(iconName) ? null : void 0);
  }
}
function addIcon(name, data) {
  const icon = stringToIcon(name, true, simpleNames);
  if (!icon) {
    return false;
  }
  const storage2 = getStorage(icon.provider, icon.prefix);
  return addIconToStorage(storage2, icon.name, data);
}
function addCollection(data, provider) {
  if (typeof data !== "object") {
    return false;
  }
  if (typeof provider !== "string") {
    provider = data.provider || "";
  }
  if (simpleNames && !provider && !data.prefix) {
    let added = false;
    if (quicklyValidateIconSet(data)) {
      data.prefix = "";
      parseIconSet(data, (name, icon) => {
        if (icon && addIcon(name, icon)) {
          added = true;
        }
      });
    }
    return added;
  }
  const prefix = data.prefix;
  if (!validateIconName({
    provider,
    prefix,
    name: "a"
  })) {
    return false;
  }
  const storage2 = getStorage(provider, prefix);
  return !!addIconSet(storage2, data);
}
var defaultIconSizeCustomisations = Object.freeze({
  width: null,
  height: null
});
var defaultIconCustomisations = Object.freeze({
  // Dimensions
  ...defaultIconSizeCustomisations,
  // Transformations
  ...defaultIconTransformations
});
var unitsSplit = /(-?[0-9.]*[0-9]+[0-9.]*)/g;
var unitsTest = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
function calculateSize(size, ratio, precision) {
  if (ratio === 1) {
    return size;
  }
  precision = precision || 100;
  if (typeof size === "number") {
    return Math.ceil(size * ratio * precision) / precision;
  }
  if (typeof size !== "string") {
    return size;
  }
  const oldParts = size.split(unitsSplit);
  if (oldParts === null || !oldParts.length) {
    return size;
  }
  const newParts = [];
  let code = oldParts.shift();
  let isNumber = unitsTest.test(code);
  while (true) {
    if (isNumber) {
      const num = parseFloat(code);
      if (isNaN(num)) {
        newParts.push(code);
      } else {
        newParts.push(Math.ceil(num * ratio * precision) / precision);
      }
    } else {
      newParts.push(code);
    }
    code = oldParts.shift();
    if (code === void 0) {
      return newParts.join("");
    }
    isNumber = !isNumber;
  }
}
var isUnsetKeyword = (value) => value === "unset" || value === "undefined" || value === "none";
function iconToSVG(icon, customisations) {
  const fullIcon = {
    ...defaultIconProps,
    ...icon
  };
  const fullCustomisations = {
    ...defaultIconCustomisations,
    ...customisations
  };
  const box = {
    left: fullIcon.left,
    top: fullIcon.top,
    width: fullIcon.width,
    height: fullIcon.height
  };
  let body = fullIcon.body;
  [fullIcon, fullCustomisations].forEach((props) => {
    const transformations = [];
    const hFlip = props.hFlip;
    const vFlip = props.vFlip;
    let rotation = props.rotate;
    if (hFlip) {
      if (vFlip) {
        rotation += 2;
      } else {
        transformations.push(
          "translate(" + (box.width + box.left).toString() + " " + (0 - box.top).toString() + ")"
        );
        transformations.push("scale(-1 1)");
        box.top = box.left = 0;
      }
    } else if (vFlip) {
      transformations.push(
        "translate(" + (0 - box.left).toString() + " " + (box.height + box.top).toString() + ")"
      );
      transformations.push("scale(1 -1)");
      box.top = box.left = 0;
    }
    let tempValue;
    if (rotation < 0) {
      rotation -= Math.floor(rotation / 4) * 4;
    }
    rotation = rotation % 4;
    switch (rotation) {
      case 1:
        tempValue = box.height / 2 + box.top;
        transformations.unshift(
          "rotate(90 " + tempValue.toString() + " " + tempValue.toString() + ")"
        );
        break;
      case 2:
        transformations.unshift(
          "rotate(180 " + (box.width / 2 + box.left).toString() + " " + (box.height / 2 + box.top).toString() + ")"
        );
        break;
      case 3:
        tempValue = box.width / 2 + box.left;
        transformations.unshift(
          "rotate(-90 " + tempValue.toString() + " " + tempValue.toString() + ")"
        );
        break;
    }
    if (rotation % 2 === 1) {
      if (box.left !== box.top) {
        tempValue = box.left;
        box.left = box.top;
        box.top = tempValue;
      }
      if (box.width !== box.height) {
        tempValue = box.width;
        box.width = box.height;
        box.height = tempValue;
      }
    }
    if (transformations.length) {
      body = '<g transform="' + transformations.join(" ") + '">' + body + "</g>";
    }
  });
  const customisationsWidth = fullCustomisations.width;
  const customisationsHeight = fullCustomisations.height;
  const boxWidth = box.width;
  const boxHeight = box.height;
  let width;
  let height;
  if (customisationsWidth === null) {
    height = customisationsHeight === null ? "1em" : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
    width = calculateSize(height, boxWidth / boxHeight);
  } else {
    width = customisationsWidth === "auto" ? boxWidth : customisationsWidth;
    height = customisationsHeight === null ? calculateSize(width, boxHeight / boxWidth) : customisationsHeight === "auto" ? boxHeight : customisationsHeight;
  }
  const attributes = {};
  const setAttr = (prop, value) => {
    if (!isUnsetKeyword(value)) {
      attributes[prop] = value.toString();
    }
  };
  setAttr("width", width);
  setAttr("height", height);
  attributes.viewBox = box.left.toString() + " " + box.top.toString() + " " + boxWidth.toString() + " " + boxHeight.toString();
  return {
    attributes,
    body
  };
}
var regex = /\sid="(\S+)"/g;
var randomPrefix = "IconifyId" + Date.now().toString(16) + (Math.random() * 16777216 | 0).toString(16);
var counter = 0;
function replaceIDs(body, prefix = randomPrefix) {
  const ids = [];
  let match;
  while (match = regex.exec(body)) {
    ids.push(match[1]);
  }
  if (!ids.length) {
    return body;
  }
  const suffix = "suffix" + (Math.random() * 16777216 | Date.now()).toString(16);
  ids.forEach((id) => {
    const newID = typeof prefix === "function" ? prefix(id) : prefix + (counter++).toString();
    const escapedID = id.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
    body = body.replace(
      // Allowed characters before id: [#;"]
      // Allowed characters after id: [)"], .[a-z]
      new RegExp('([#;"])(' + escapedID + ')([")]|\\.[a-z])', "g"),
      "$1" + newID + suffix + "$3"
    );
  });
  body = body.replace(new RegExp(suffix, "g"), "");
  return body;
}
var storage = /* @__PURE__ */ Object.create(null);
function setAPIModule(provider, item) {
  storage[provider] = item;
}
function getAPIModule(provider) {
  return storage[provider] || storage[""];
}
function createAPIConfig(source) {
  let resources;
  if (typeof source.resources === "string") {
    resources = [source.resources];
  } else {
    resources = source.resources;
    if (!(resources instanceof Array) || !resources.length) {
      return null;
    }
  }
  const result = {
    // API hosts
    resources,
    // Root path
    path: source.path || "/",
    // URL length limit
    maxURL: source.maxURL || 500,
    // Timeout before next host is used.
    rotate: source.rotate || 750,
    // Timeout before failing query.
    timeout: source.timeout || 5e3,
    // Randomise default API end point.
    random: source.random === true,
    // Start index
    index: source.index || 0,
    // Receive data after time out (used if time out kicks in first, then API module sends data anyway).
    dataAfterTimeout: source.dataAfterTimeout !== false
  };
  return result;
}
var configStorage = /* @__PURE__ */ Object.create(null);
var fallBackAPISources = [
  "https://api.simplesvg.com",
  "https://api.unisvg.com"
];
var fallBackAPI = [];
while (fallBackAPISources.length > 0) {
  if (fallBackAPISources.length === 1) {
    fallBackAPI.push(fallBackAPISources.shift());
  } else {
    if (Math.random() > 0.5) {
      fallBackAPI.push(fallBackAPISources.shift());
    } else {
      fallBackAPI.push(fallBackAPISources.pop());
    }
  }
}
configStorage[""] = createAPIConfig({
  resources: ["https://api.iconify.design"].concat(fallBackAPI)
});
function addAPIProvider(provider, customConfig) {
  const config = createAPIConfig(customConfig);
  if (config === null) {
    return false;
  }
  configStorage[provider] = config;
  return true;
}
function getAPIConfig(provider) {
  return configStorage[provider];
}
var detectFetch = () => {
  let callback;
  try {
    callback = fetch;
    if (typeof callback === "function") {
      return callback;
    }
  } catch (err) {
  }
};
var fetchModule = detectFetch();
function calculateMaxLength(provider, prefix) {
  const config = getAPIConfig(provider);
  if (!config) {
    return 0;
  }
  let result;
  if (!config.maxURL) {
    result = 0;
  } else {
    let maxHostLength = 0;
    config.resources.forEach((item) => {
      const host = item;
      maxHostLength = Math.max(maxHostLength, host.length);
    });
    const url = prefix + ".json?icons=";
    result = config.maxURL - maxHostLength - config.path.length - url.length;
  }
  return result;
}
function shouldAbort(status) {
  return status === 404;
}
var prepare = (provider, prefix, icons) => {
  const results = [];
  const maxLength = calculateMaxLength(provider, prefix);
  const type = "icons";
  let item = {
    type,
    provider,
    prefix,
    icons: []
  };
  let length = 0;
  icons.forEach((name, index) => {
    length += name.length + 1;
    if (length >= maxLength && index > 0) {
      results.push(item);
      item = {
        type,
        provider,
        prefix,
        icons: []
      };
      length = name.length;
    }
    item.icons.push(name);
  });
  results.push(item);
  return results;
};
function getPath(provider) {
  if (typeof provider === "string") {
    const config = getAPIConfig(provider);
    if (config) {
      return config.path;
    }
  }
  return "/";
}
var send = (host, params, callback) => {
  if (!fetchModule) {
    callback("abort", 424);
    return;
  }
  let path = getPath(params.provider);
  switch (params.type) {
    case "icons": {
      const prefix = params.prefix;
      const icons = params.icons;
      const iconsList = icons.join(",");
      const urlParams = new URLSearchParams({
        icons: iconsList
      });
      path += prefix + ".json?" + urlParams.toString();
      break;
    }
    case "custom": {
      const uri = params.uri;
      path += uri.slice(0, 1) === "/" ? uri.slice(1) : uri;
      break;
    }
    default:
      callback("abort", 400);
      return;
  }
  let defaultError = 503;
  fetchModule(host + path).then((response) => {
    const status = response.status;
    if (status !== 200) {
      setTimeout(() => {
        callback(shouldAbort(status) ? "abort" : "next", status);
      });
      return;
    }
    defaultError = 501;
    return response.json();
  }).then((data) => {
    if (typeof data !== "object" || data === null) {
      setTimeout(() => {
        if (data === 404) {
          callback("abort", data);
        } else {
          callback("next", defaultError);
        }
      });
      return;
    }
    setTimeout(() => {
      callback("success", data);
    });
  }).catch(() => {
    callback("next", defaultError);
  });
};
var fetchAPIModule = {
  prepare,
  send
};
function sortIcons(icons) {
  const result = {
    loaded: [],
    missing: [],
    pending: []
  };
  const storage2 = /* @__PURE__ */ Object.create(null);
  icons.sort((a, b) => {
    if (a.provider !== b.provider) {
      return a.provider.localeCompare(b.provider);
    }
    if (a.prefix !== b.prefix) {
      return a.prefix.localeCompare(b.prefix);
    }
    return a.name.localeCompare(b.name);
  });
  let lastIcon = {
    provider: "",
    prefix: "",
    name: ""
  };
  icons.forEach((icon) => {
    if (lastIcon.name === icon.name && lastIcon.prefix === icon.prefix && lastIcon.provider === icon.provider) {
      return;
    }
    lastIcon = icon;
    const provider = icon.provider;
    const prefix = icon.prefix;
    const name = icon.name;
    const providerStorage = storage2[provider] || (storage2[provider] = /* @__PURE__ */ Object.create(null));
    const localStorage = providerStorage[prefix] || (providerStorage[prefix] = getStorage(provider, prefix));
    let list;
    if (name in localStorage.icons) {
      list = result.loaded;
    } else if (prefix === "" || localStorage.missing.has(name)) {
      list = result.missing;
    } else {
      list = result.pending;
    }
    const item = {
      provider,
      prefix,
      name
    };
    list.push(item);
  });
  return result;
}
function removeCallback(storages, id) {
  storages.forEach((storage2) => {
    const items2 = storage2.loaderCallbacks;
    if (items2) {
      storage2.loaderCallbacks = items2.filter((row) => row.id !== id);
    }
  });
}
function updateCallbacks(storage2) {
  if (!storage2.pendingCallbacksFlag) {
    storage2.pendingCallbacksFlag = true;
    setTimeout(() => {
      storage2.pendingCallbacksFlag = false;
      const items2 = storage2.loaderCallbacks ? storage2.loaderCallbacks.slice(0) : [];
      if (!items2.length) {
        return;
      }
      let hasPending = false;
      const provider = storage2.provider;
      const prefix = storage2.prefix;
      items2.forEach((item) => {
        const icons = item.icons;
        const oldLength = icons.pending.length;
        icons.pending = icons.pending.filter((icon) => {
          if (icon.prefix !== prefix) {
            return true;
          }
          const name = icon.name;
          if (storage2.icons[name]) {
            icons.loaded.push({
              provider,
              prefix,
              name
            });
          } else if (storage2.missing.has(name)) {
            icons.missing.push({
              provider,
              prefix,
              name
            });
          } else {
            hasPending = true;
            return true;
          }
          return false;
        });
        if (icons.pending.length !== oldLength) {
          if (!hasPending) {
            removeCallback([storage2], item.id);
          }
          item.callback(
            icons.loaded.slice(0),
            icons.missing.slice(0),
            icons.pending.slice(0),
            item.abort
          );
        }
      });
    });
  }
}
var idCounter = 0;
function storeCallback(callback, icons, pendingSources) {
  const id = idCounter++;
  const abort = removeCallback.bind(null, pendingSources, id);
  if (!icons.pending.length) {
    return abort;
  }
  const item = {
    id,
    icons,
    callback,
    abort
  };
  pendingSources.forEach((storage2) => {
    (storage2.loaderCallbacks || (storage2.loaderCallbacks = [])).push(item);
  });
  return abort;
}
function listToIcons(list, validate = true, simpleNames2 = false) {
  const result = [];
  list.forEach((item) => {
    const icon = typeof item === "string" ? stringToIcon(item, validate, simpleNames2) : item;
    if (icon) {
      result.push(icon);
    }
  });
  return result;
}
var defaultConfig = {
  resources: [],
  index: 0,
  timeout: 2e3,
  rotate: 750,
  random: false,
  dataAfterTimeout: false
};
function sendQuery(config, payload, query, done) {
  const resourcesCount = config.resources.length;
  const startIndex = config.random ? Math.floor(Math.random() * resourcesCount) : config.index;
  let resources;
  if (config.random) {
    let list = config.resources.slice(0);
    resources = [];
    while (list.length > 1) {
      const nextIndex = Math.floor(Math.random() * list.length);
      resources.push(list[nextIndex]);
      list = list.slice(0, nextIndex).concat(list.slice(nextIndex + 1));
    }
    resources = resources.concat(list);
  } else {
    resources = config.resources.slice(startIndex).concat(config.resources.slice(0, startIndex));
  }
  const startTime = Date.now();
  let status = "pending";
  let queriesSent = 0;
  let lastError;
  let timer = null;
  let queue = [];
  let doneCallbacks = [];
  if (typeof done === "function") {
    doneCallbacks.push(done);
  }
  function resetTimer() {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  }
  function abort() {
    if (status === "pending") {
      status = "aborted";
    }
    resetTimer();
    queue.forEach((item) => {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }
  function subscribe(callback, overwrite) {
    if (overwrite) {
      doneCallbacks = [];
    }
    if (typeof callback === "function") {
      doneCallbacks.push(callback);
    }
  }
  function getQueryStatus() {
    return {
      startTime,
      payload,
      status,
      queriesSent,
      queriesPending: queue.length,
      subscribe,
      abort
    };
  }
  function failQuery() {
    status = "failed";
    doneCallbacks.forEach((callback) => {
      callback(void 0, lastError);
    });
  }
  function clearQueue() {
    queue.forEach((item) => {
      if (item.status === "pending") {
        item.status = "aborted";
      }
    });
    queue = [];
  }
  function moduleResponse(item, response, data) {
    const isError2 = response !== "success";
    queue = queue.filter((queued) => queued !== item);
    switch (status) {
      case "pending":
        break;
      case "failed":
        if (isError2 || !config.dataAfterTimeout) {
          return;
        }
        break;
      default:
        return;
    }
    if (response === "abort") {
      lastError = data;
      failQuery();
      return;
    }
    if (isError2) {
      lastError = data;
      if (!queue.length) {
        if (!resources.length) {
          failQuery();
        } else {
          execNext();
        }
      }
      return;
    }
    resetTimer();
    clearQueue();
    if (!config.random) {
      const index = config.resources.indexOf(item.resource);
      if (index !== -1 && index !== config.index) {
        config.index = index;
      }
    }
    status = "completed";
    doneCallbacks.forEach((callback) => {
      callback(data);
    });
  }
  function execNext() {
    if (status !== "pending") {
      return;
    }
    resetTimer();
    const resource = resources.shift();
    if (resource === void 0) {
      if (queue.length) {
        timer = setTimeout(() => {
          resetTimer();
          if (status === "pending") {
            clearQueue();
            failQuery();
          }
        }, config.timeout);
        return;
      }
      failQuery();
      return;
    }
    const item = {
      status: "pending",
      resource,
      callback: (status2, data) => {
        moduleResponse(item, status2, data);
      }
    };
    queue.push(item);
    queriesSent++;
    timer = setTimeout(execNext, config.rotate);
    query(resource, payload, item.callback);
  }
  setTimeout(execNext);
  return getQueryStatus;
}
function initRedundancy(cfg) {
  const config = {
    ...defaultConfig,
    ...cfg
  };
  let queries = [];
  function cleanup() {
    queries = queries.filter((item) => item().status === "pending");
  }
  function query(payload, queryCallback, doneCallback) {
    const query2 = sendQuery(
      config,
      payload,
      queryCallback,
      (data, error) => {
        cleanup();
        if (doneCallback) {
          doneCallback(data, error);
        }
      }
    );
    queries.push(query2);
    return query2;
  }
  function find2(callback) {
    return queries.find((value) => {
      return callback(value);
    }) || null;
  }
  const instance = {
    query,
    find: find2,
    setIndex: (index) => {
      config.index = index;
    },
    getIndex: () => config.index,
    cleanup
  };
  return instance;
}
function emptyCallback$1() {
}
var redundancyCache = /* @__PURE__ */ Object.create(null);
function getRedundancyCache(provider) {
  if (!redundancyCache[provider]) {
    const config = getAPIConfig(provider);
    if (!config) {
      return;
    }
    const redundancy = initRedundancy(config);
    const cachedReundancy = {
      config,
      redundancy
    };
    redundancyCache[provider] = cachedReundancy;
  }
  return redundancyCache[provider];
}
function sendAPIQuery(target, query, callback) {
  let redundancy;
  let send2;
  if (typeof target === "string") {
    const api = getAPIModule(target);
    if (!api) {
      callback(void 0, 424);
      return emptyCallback$1;
    }
    send2 = api.send;
    const cached = getRedundancyCache(target);
    if (cached) {
      redundancy = cached.redundancy;
    }
  } else {
    const config = createAPIConfig(target);
    if (config) {
      redundancy = initRedundancy(config);
      const moduleKey = target.resources ? target.resources[0] : "";
      const api = getAPIModule(moduleKey);
      if (api) {
        send2 = api.send;
      }
    }
  }
  if (!redundancy || !send2) {
    callback(void 0, 424);
    return emptyCallback$1;
  }
  return redundancy.query(query, send2, callback)().abort;
}
var browserCacheVersion = "iconify2";
var browserCachePrefix = "iconify";
var browserCacheCountKey = browserCachePrefix + "-count";
var browserCacheVersionKey = browserCachePrefix + "-version";
var browserStorageHour = 36e5;
var browserStorageCacheExpiration = 168;
function getStoredItem(func, key) {
  try {
    return func.getItem(key);
  } catch (err) {
  }
}
function setStoredItem(func, key, value) {
  try {
    func.setItem(key, value);
    return true;
  } catch (err) {
  }
}
function removeStoredItem(func, key) {
  try {
    func.removeItem(key);
  } catch (err) {
  }
}
function setBrowserStorageItemsCount(storage2, value) {
  return setStoredItem(storage2, browserCacheCountKey, value.toString());
}
function getBrowserStorageItemsCount(storage2) {
  return parseInt(getStoredItem(storage2, browserCacheCountKey)) || 0;
}
var browserStorageConfig = {
  local: true,
  session: true
};
var browserStorageEmptyItems = {
  local: /* @__PURE__ */ new Set(),
  session: /* @__PURE__ */ new Set()
};
var browserStorageStatus = false;
function setBrowserStorageStatus(status) {
  browserStorageStatus = status;
}
var _window = typeof window === "undefined" ? {} : window;
function getBrowserStorage(key) {
  const attr = key + "Storage";
  try {
    if (_window && _window[attr] && typeof _window[attr].length === "number") {
      return _window[attr];
    }
  } catch (err) {
  }
  browserStorageConfig[key] = false;
}
function iterateBrowserStorage(key, callback) {
  const func = getBrowserStorage(key);
  if (!func) {
    return;
  }
  const version = getStoredItem(func, browserCacheVersionKey);
  if (version !== browserCacheVersion) {
    if (version) {
      const total2 = getBrowserStorageItemsCount(func);
      for (let i = 0; i < total2; i++) {
        removeStoredItem(func, browserCachePrefix + i.toString());
      }
    }
    setStoredItem(func, browserCacheVersionKey, browserCacheVersion);
    setBrowserStorageItemsCount(func, 0);
    return;
  }
  const minTime = Math.floor(Date.now() / browserStorageHour) - browserStorageCacheExpiration;
  const parseItem = (index) => {
    const name = browserCachePrefix + index.toString();
    const item = getStoredItem(func, name);
    if (typeof item !== "string") {
      return;
    }
    try {
      const data = JSON.parse(item);
      if (typeof data === "object" && typeof data.cached === "number" && data.cached > minTime && typeof data.provider === "string" && typeof data.data === "object" && typeof data.data.prefix === "string" && // Valid item: run callback
      callback(data, index)) {
        return true;
      }
    } catch (err) {
    }
    removeStoredItem(func, name);
  };
  let total = getBrowserStorageItemsCount(func);
  for (let i = total - 1; i >= 0; i--) {
    if (!parseItem(i)) {
      if (i === total - 1) {
        total--;
        setBrowserStorageItemsCount(func, total);
      } else {
        browserStorageEmptyItems[key].add(i);
      }
    }
  }
}
function initBrowserStorage() {
  if (browserStorageStatus) {
    return;
  }
  setBrowserStorageStatus(true);
  for (const key in browserStorageConfig) {
    iterateBrowserStorage(key, (item) => {
      const iconSet = item.data;
      const provider = item.provider;
      const prefix = iconSet.prefix;
      const storage2 = getStorage(
        provider,
        prefix
      );
      if (!addIconSet(storage2, iconSet).length) {
        return false;
      }
      const lastModified = iconSet.lastModified || -1;
      storage2.lastModifiedCached = storage2.lastModifiedCached ? Math.min(storage2.lastModifiedCached, lastModified) : lastModified;
      return true;
    });
  }
}
function updateLastModified(storage2, lastModified) {
  const lastValue = storage2.lastModifiedCached;
  if (
    // Matches or newer
    lastValue && lastValue >= lastModified
  ) {
    return lastValue === lastModified;
  }
  storage2.lastModifiedCached = lastModified;
  if (lastValue) {
    for (const key in browserStorageConfig) {
      iterateBrowserStorage(key, (item) => {
        const iconSet = item.data;
        return item.provider !== storage2.provider || iconSet.prefix !== storage2.prefix || iconSet.lastModified === lastModified;
      });
    }
  }
  return true;
}
function storeInBrowserStorage(storage2, data) {
  if (!browserStorageStatus) {
    initBrowserStorage();
  }
  function store(key) {
    let func;
    if (!browserStorageConfig[key] || !(func = getBrowserStorage(key))) {
      return;
    }
    const set = browserStorageEmptyItems[key];
    let index;
    if (set.size) {
      set.delete(index = Array.from(set).shift());
    } else {
      index = getBrowserStorageItemsCount(func);
      if (!setBrowserStorageItemsCount(func, index + 1)) {
        return;
      }
    }
    const item = {
      cached: Math.floor(Date.now() / browserStorageHour),
      provider: storage2.provider,
      data
    };
    return setStoredItem(
      func,
      browserCachePrefix + index.toString(),
      JSON.stringify(item)
    );
  }
  if (data.lastModified && !updateLastModified(storage2, data.lastModified)) {
    return;
  }
  if (!Object.keys(data.icons).length) {
    return;
  }
  if (data.not_found) {
    data = Object.assign({}, data);
    delete data.not_found;
  }
  if (!store("local")) {
    store("session");
  }
}
function emptyCallback() {
}
function loadedNewIcons(storage2) {
  if (!storage2.iconsLoaderFlag) {
    storage2.iconsLoaderFlag = true;
    setTimeout(() => {
      storage2.iconsLoaderFlag = false;
      updateCallbacks(storage2);
    });
  }
}
function loadNewIcons(storage2, icons) {
  if (!storage2.iconsToLoad) {
    storage2.iconsToLoad = icons;
  } else {
    storage2.iconsToLoad = storage2.iconsToLoad.concat(icons).sort();
  }
  if (!storage2.iconsQueueFlag) {
    storage2.iconsQueueFlag = true;
    setTimeout(() => {
      storage2.iconsQueueFlag = false;
      const { provider, prefix } = storage2;
      const icons2 = storage2.iconsToLoad;
      delete storage2.iconsToLoad;
      let api;
      if (!icons2 || !(api = getAPIModule(provider))) {
        return;
      }
      const params = api.prepare(provider, prefix, icons2);
      params.forEach((item) => {
        sendAPIQuery(provider, item, (data) => {
          if (typeof data !== "object") {
            item.icons.forEach((name) => {
              storage2.missing.add(name);
            });
          } else {
            try {
              const parsed = addIconSet(
                storage2,
                data
              );
              if (!parsed.length) {
                return;
              }
              const pending = storage2.pendingIcons;
              if (pending) {
                parsed.forEach((name) => {
                  pending.delete(name);
                });
              }
              storeInBrowserStorage(storage2, data);
            } catch (err) {
              console.error(err);
            }
          }
          loadedNewIcons(storage2);
        });
      });
    });
  }
}
var loadIcons = (icons, callback) => {
  const cleanedIcons = listToIcons(icons, true, allowSimpleNames());
  const sortedIcons = sortIcons(cleanedIcons);
  if (!sortedIcons.pending.length) {
    let callCallback = true;
    if (callback) {
      setTimeout(() => {
        if (callCallback) {
          callback(
            sortedIcons.loaded,
            sortedIcons.missing,
            sortedIcons.pending,
            emptyCallback
          );
        }
      });
    }
    return () => {
      callCallback = false;
    };
  }
  const newIcons = /* @__PURE__ */ Object.create(null);
  const sources = [];
  let lastProvider, lastPrefix;
  sortedIcons.pending.forEach((icon) => {
    const { provider, prefix } = icon;
    if (prefix === lastPrefix && provider === lastProvider) {
      return;
    }
    lastProvider = provider;
    lastPrefix = prefix;
    sources.push(getStorage(provider, prefix));
    const providerNewIcons = newIcons[provider] || (newIcons[provider] = /* @__PURE__ */ Object.create(null));
    if (!providerNewIcons[prefix]) {
      providerNewIcons[prefix] = [];
    }
  });
  sortedIcons.pending.forEach((icon) => {
    const { provider, prefix, name } = icon;
    const storage2 = getStorage(provider, prefix);
    const pendingQueue = storage2.pendingIcons || (storage2.pendingIcons = /* @__PURE__ */ new Set());
    if (!pendingQueue.has(name)) {
      pendingQueue.add(name);
      newIcons[provider][prefix].push(name);
    }
  });
  sources.forEach((storage2) => {
    const { provider, prefix } = storage2;
    if (newIcons[provider][prefix].length) {
      loadNewIcons(storage2, newIcons[provider][prefix]);
    }
  });
  return callback ? storeCallback(callback, sortedIcons, sources) : emptyCallback;
};
function mergeCustomisations(defaults, item) {
  const result = {
    ...defaults
  };
  for (const key in item) {
    const value = item[key];
    const valueType = typeof value;
    if (key in defaultIconSizeCustomisations) {
      if (value === null || value && (valueType === "string" || valueType === "number")) {
        result[key] = value;
      }
    } else if (valueType === typeof result[key]) {
      result[key] = key === "rotate" ? value % 4 : value;
    }
  }
  return result;
}
var separator = /[\s,]+/;
function flipFromString(custom, flip) {
  flip.split(separator).forEach((str) => {
    const value = str.trim();
    switch (value) {
      case "horizontal":
        custom.hFlip = true;
        break;
      case "vertical":
        custom.vFlip = true;
        break;
    }
  });
}
function rotateFromString(value, defaultValue = 0) {
  const units = value.replace(/^-?[0-9.]*/, "");
  function cleanup(value2) {
    while (value2 < 0) {
      value2 += 4;
    }
    return value2 % 4;
  }
  if (units === "") {
    const num = parseInt(value);
    return isNaN(num) ? 0 : cleanup(num);
  } else if (units !== value) {
    let split = 0;
    switch (units) {
      case "%":
        split = 25;
        break;
      case "deg":
        split = 90;
    }
    if (split) {
      let num = parseFloat(value.slice(0, value.length - units.length));
      if (isNaN(num)) {
        return 0;
      }
      num = num / split;
      return num % 1 === 0 ? cleanup(num) : 0;
    }
  }
  return defaultValue;
}
function iconToHTML(body, attributes) {
  let renderAttribsHTML = body.indexOf("xlink:") === -1 ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
  for (const attr in attributes) {
    renderAttribsHTML += " " + attr + '="' + attributes[attr] + '"';
  }
  return '<svg xmlns="http://www.w3.org/2000/svg"' + renderAttribsHTML + ">" + body + "</svg>";
}
function encodeSVGforURL(svg) {
  return svg.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
}
function svgToData(svg) {
  return "data:image/svg+xml," + encodeSVGforURL(svg);
}
function svgToURL(svg) {
  return 'url("' + svgToData(svg) + '")';
}
var policy;
function createPolicy() {
  try {
    policy = window.trustedTypes.createPolicy("iconify", {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      createHTML: (s) => s
    });
  } catch (err) {
    policy = null;
  }
}
function cleanUpInnerHTML(html2) {
  if (policy === void 0) {
    createPolicy();
  }
  return policy ? policy.createHTML(html2) : html2;
}
var defaultExtendedIconCustomisations = {
  ...defaultIconCustomisations,
  inline: false
};
var svgDefaults = {
  "xmlns": "http://www.w3.org/2000/svg",
  "xmlnsXlink": "http://www.w3.org/1999/xlink",
  "aria-hidden": true,
  "role": "img"
};
var commonProps = {
  display: "inline-block"
};
var monotoneProps = {
  backgroundColor: "currentColor"
};
var coloredProps = {
  backgroundColor: "transparent"
};
var propsToAdd = {
  Image: "var(--svg)",
  Repeat: "no-repeat",
  Size: "100% 100%"
};
var propsToAddTo = {
  WebkitMask: monotoneProps,
  mask: monotoneProps,
  background: coloredProps
};
for (const prefix in propsToAddTo) {
  const list = propsToAddTo[prefix];
  for (const prop in propsToAdd) {
    list[prefix + prop] = propsToAdd[prop];
  }
}
var inlineDefaults = {
  ...defaultExtendedIconCustomisations,
  inline: true
};
function fixSize(value) {
  return value + (value.match(/^[-0-9.]+$/) ? "px" : "");
}
var render = (icon, props, inline, ref) => {
  const defaultProps = inline ? inlineDefaults : defaultExtendedIconCustomisations;
  const customisations = mergeCustomisations(defaultProps, props);
  const mode = props.mode || "svg";
  const style = {};
  const customStyle = props.style || {};
  const componentProps = {
    ...mode === "svg" ? svgDefaults : {},
    ref
  };
  for (let key in props) {
    const value = props[key];
    if (value === void 0) {
      continue;
    }
    switch (key) {
      // Properties to ignore
      case "icon":
      case "style":
      case "children":
      case "onLoad":
      case "mode":
      case "_ref":
      case "_inline":
        break;
      // Boolean attributes
      case "inline":
      case "hFlip":
      case "vFlip":
        customisations[key] = value === true || value === "true" || value === 1;
        break;
      // Flip as string: 'horizontal,vertical'
      case "flip":
        if (typeof value === "string") {
          flipFromString(customisations, value);
        }
        break;
      // Color: copy to style
      case "color":
        style.color = value;
        break;
      // Rotation as string
      case "rotate":
        if (typeof value === "string") {
          customisations[key] = rotateFromString(value);
        } else if (typeof value === "number") {
          customisations[key] = value;
        }
        break;
      // Remove aria-hidden
      case "ariaHidden":
      case "aria-hidden":
        if (value !== true && value !== "true") {
          delete componentProps["aria-hidden"];
        }
        break;
      // Copy missing property if it does not exist in customisations
      default:
        if (defaultProps[key] === void 0) {
          componentProps[key] = value;
        }
    }
  }
  const item = iconToSVG(icon, customisations);
  const renderAttribs = item.attributes;
  if (customisations.inline) {
    style.verticalAlign = "-0.125em";
  }
  if (mode === "svg") {
    componentProps.style = {
      ...style,
      ...customStyle
    };
    Object.assign(componentProps, renderAttribs);
    let localCounter = 0;
    let id = props.id;
    if (typeof id === "string") {
      id = id.replace(/-/g, "_");
    }
    componentProps.dangerouslySetInnerHTML = {
      __html: cleanUpInnerHTML(replaceIDs(item.body, id ? () => id + "ID" + localCounter++ : "iconifyReact"))
    };
    return React__default.createElement("svg", componentProps);
  }
  const { body, width, height } = icon;
  const useMask = mode === "mask" || (mode === "bg" ? false : body.indexOf("currentColor") !== -1);
  const html2 = iconToHTML(body, {
    ...renderAttribs,
    width: width + "",
    height: height + ""
  });
  componentProps.style = {
    ...style,
    "--svg": svgToURL(html2),
    "width": fixSize(renderAttribs.width),
    "height": fixSize(renderAttribs.height),
    ...commonProps,
    ...useMask ? monotoneProps : coloredProps,
    ...customStyle
  };
  return React__default.createElement("span", componentProps);
};
allowSimpleNames(true);
setAPIModule("", fetchAPIModule);
if (typeof document !== "undefined" && typeof window !== "undefined") {
  initBrowserStorage();
  const _window2 = window;
  if (_window2.IconifyPreload !== void 0) {
    const preload = _window2.IconifyPreload;
    const err = "Invalid IconifyPreload syntax.";
    if (typeof preload === "object" && preload !== null) {
      (preload instanceof Array ? preload : [preload]).forEach((item) => {
        try {
          if (
            // Check if item is an object and not null/array
            typeof item !== "object" || item === null || item instanceof Array || // Check for 'icons' and 'prefix'
            typeof item.icons !== "object" || typeof item.prefix !== "string" || // Add icon set
            !addCollection(item)
          ) {
            console.error(err);
          }
        } catch (e) {
          console.error(err);
        }
      });
    }
  }
  if (_window2.IconifyProviders !== void 0) {
    const providers = _window2.IconifyProviders;
    if (typeof providers === "object" && providers !== null) {
      for (let key in providers) {
        const err = "IconifyProviders[" + key + "] is invalid.";
        try {
          const value = providers[key];
          if (typeof value !== "object" || !value || value.resources === void 0) {
            continue;
          }
          if (!addAPIProvider(key, value)) {
            console.error(err);
          }
        } catch (e) {
          console.error(err);
        }
      }
    }
  }
}
var IconComponent = class extends React__default.Component {
  constructor(props) {
    super(props);
    this.state = {
      // Render placeholder before component is mounted
      icon: null
    };
  }
  /**
   * Abort loading icon
   */
  _abortLoading() {
    if (this._loading) {
      this._loading.abort();
      this._loading = null;
    }
  }
  /**
   * Update state
   */
  _setData(icon) {
    if (this.state.icon !== icon) {
      this.setState({
        icon
      });
    }
  }
  /**
   * Check if icon should be loaded
   */
  _checkIcon(changed) {
    const state = this.state;
    const icon = this.props.icon;
    if (typeof icon === "object" && icon !== null && typeof icon.body === "string") {
      this._icon = "";
      this._abortLoading();
      if (changed || state.icon === null) {
        this._setData({
          data: icon
        });
      }
      return;
    }
    let iconName;
    if (typeof icon !== "string" || (iconName = stringToIcon(icon, false, true)) === null) {
      this._abortLoading();
      this._setData(null);
      return;
    }
    const data = getIconData(iconName);
    if (!data) {
      if (!this._loading || this._loading.name !== icon) {
        this._abortLoading();
        this._icon = "";
        this._setData(null);
        if (data !== null) {
          this._loading = {
            name: icon,
            abort: loadIcons([iconName], this._checkIcon.bind(this, false))
          };
        }
      }
      return;
    }
    if (this._icon !== icon || state.icon === null) {
      this._abortLoading();
      this._icon = icon;
      const classes = ["iconify"];
      if (iconName.prefix !== "") {
        classes.push("iconify--" + iconName.prefix);
      }
      if (iconName.provider !== "") {
        classes.push("iconify--" + iconName.provider);
      }
      this._setData({
        data,
        classes
      });
      if (this.props.onLoad) {
        this.props.onLoad(icon);
      }
    }
  }
  /**
   * Component mounted
   */
  componentDidMount() {
    this._checkIcon(false);
  }
  /**
   * Component updated
   */
  componentDidUpdate(oldProps) {
    if (oldProps.icon !== this.props.icon) {
      this._checkIcon(true);
    }
  }
  /**
   * Abort loading
   */
  componentWillUnmount() {
    this._abortLoading();
  }
  /**
   * Render
   */
  render() {
    const props = this.props;
    const icon = this.state.icon;
    if (icon === null) {
      return props.children ? props.children : React__default.createElement("span", {});
    }
    let newProps = props;
    if (icon.classes) {
      newProps = {
        ...props,
        className: (typeof props.className === "string" ? props.className + " " : "") + icon.classes.join(" ")
      };
    }
    return render({
      ...defaultIconProps,
      ...icon.data
    }, newProps, props._inline, props._ref);
  }
};
var Icon = React__default.forwardRef(function Icon2(props, ref) {
  const newProps = {
    ...props,
    _ref: ref,
    _inline: false
  };
  return React__default.createElement(IconComponent, newProps);
});
React__default.forwardRef(function InlineIcon2(props, ref) {
  const newProps = {
    ...props,
    _ref: ref,
    _inline: true
  };
  return React__default.createElement(IconComponent, newProps);
});
var ToolTip = ({
  placement = "top",
  children,
  content,
  tooltipClassName,
  className: className2 = "",
  align,
  delayDuration = 500,
  keepTooltipOnClick = false
}) => {
  if (!content) {
    return /* @__PURE__ */ jsx("span", { className: classNames67("popper__reference", className2), children });
  }
  return /* @__PURE__ */ jsx(Provider, { delayDuration, skipDelayDuration: delayDuration, children: /* @__PURE__ */ jsxs(Root, { defaultOpen: false, children: [
    /* @__PURE__ */ jsx(Trigger, { asChild: true, children: /* @__PURE__ */ jsx("span", { className: classNames67("popper__reference", className2), children }) }),
    /* @__PURE__ */ jsx(Portal, { children: /* @__PURE__ */ jsx(
      Content,
      {
        side: placement,
        align: align ? align : placement === "bottom" ? "start" : "center",
        sideOffset: 5,
        alignOffset: 10,
        hideWhenDetached: true,
        role: "tooltip",
        className: classNames67(
          "popper max-w-md rounded-md break-normal",
          tooltipClassName
        ),
        onPointerDownOutside: (event) => {
          if (keepTooltipOnClick) {
            event.preventDefault();
          }
        },
        children: content
      }
    ) })
  ] }) });
};
var ErrorToolTip = ({
  children,
  content,
  tooltipClassName = "",
  placement = "bottom",
  className: className2 = ""
}) => {
  const combinedClassName = classNames67(
    "!bg-[#FFEDEB] !border border-[#FFD2CC] text-sm font-normal leading-5 !text-[#CA3521]",
    tooltipClassName
  );
  return /* @__PURE__ */ jsx(
    ToolTip,
    {
      tooltipClassName: combinedClassName,
      content,
      className: className2,
      placement,
      children
    }
  );
};
var PopoverTooltip = (props) => {
  const { triggerPoint, tooltipView, popoverClassName } = props;
  const [showDropdown, toggleDropdown] = useState(false);
  let isInsideChild = false;
  const waitTime = triggerPoint ? 150 : 400;
  const debounceMouseOut = debounce(() => {
    toggleDropdown(isInsideChild);
  }, waitTime);
  return /* @__PURE__ */ jsx(
    popover_default,
    {
      trigger: /* @__PURE__ */ jsx(
        "div",
        {
          onMouseOver: () => toggleDropdown(true),
          onMouseOut: debounceMouseOut,
          className: "flex items-center w-full",
          children: triggerPoint ? triggerPoint : /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "info",
              className: "text-unique-800 ml-1 items-center flex"
            }
          )
        }
      ),
      fillWidth: false,
      className: "!border-0 !bg-transparent !px-0 !py-0 flex",
      wrapperClassName: `cursor-pointer ${triggerPoint ? "w-full" : "w-fit"}`,
      dropdownClassName: classNames67(
        "!p-2 !w-[300px] !shadow-modal-md !rounded",
        "!bg-secondary-800 !text-secondary-100 !text-xs",
        popoverClassName
      ),
      placement: "bottom-start",
      show: showDropdown,
      children: /* @__PURE__ */ jsx(
        "span",
        {
          className: "flex flex-col gap-6",
          onMouseOver: () => {
            isInsideChild = true;
            toggleDropdown(true);
          },
          onMouseLeave: () => {
            isInsideChild = false;
            toggleDropdown(false);
          },
          children: tooltipView
        }
      )
    }
  );
};

// assets/iconify-bundle.json
var iconify_bundle_default = { prefix: "", lastModified: 1770894411, icons: { "123": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6.289 14.847a.58.58 0 01-.597-.597v-3.903H4.79a.58.58 0 01-.597-.596.58.58 0 01.597-.597h1.19q.383 0 .644.26.26.26.26.644v4.192a.58.58 0 01-.596.597m3.75 0a.87.87 0 01-.644-.26.88.88 0 01-.26-.644v-1.5q0-.376.254-.63.255-.255.63-.255h2.135v-1.211H9.73a.58.58 0 01-.596-.596.58.58 0 01.596-.597h2.73q.377 0 .63.255.255.255.255.63v1.52q0 .375-.254.63a.86.86 0 01-.63.254h-2.135v1.211h2.423a.58.58 0 01.596.596.58.58 0 01-.596.597zm5.653 0a.58.58 0 01-.596-.596.58.58 0 01.596-.597h2.424v-1.211h-1.578a.42.42 0 01-.31-.133.424.424 0 010-.62.43.43 0 01.31-.132h1.578v-1.211h-2.424a.58.58 0 01-.596-.596.58.58 0 01.596-.597h2.731q.375 0 .63.255t.255.63v3.923q0 .375-.255.63a.86.86 0 01-.63.255z"/></g></g>', width: 24, height: 24 }, abc: { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M17.02 14.847a.86.86 0 01-.631-.255.86.86 0 01-.254-.63v-3.923q0-.375.254-.63.255-.255.63-.255h2.923q.376 0 .63.255.255.255.255.63v.365a.58.58 0 01-.596.596.6.6 0 01-.364-.115.53.53 0 01-.202-.327v-.211h-2.338v3.307h2.338v-.211a.53.53 0 01.202-.327.6.6 0 01.364-.116.58.58 0 01.596.597v.365q0 .375-.254.63a.86.86 0 01-.63.255zm-6.462 0a.87.87 0 01-.644-.26.87.87 0 01-.26-.644v-3.885q0-.383.26-.644a.87.87 0 01.644-.26h2.903q.376 0 .63.255.255.255.255.63v1.115q0 .359-.21.588-.21.23-.578.258.367.03.578.26.21.228.21.587v1.115q0 .375-.254.63a.86.86 0 01-.63.255zm.288-3.443h2.308v-1.057h-2.308zm0 2.25h2.308v-1.057h-2.308zM3.77 14.847a.58.58 0 01-.597-.597v-4.21q0-.375.254-.63.255-.255.63-.255h2.924q.375 0 .63.255t.254.63v4.211a.58.58 0 01-.595.597.58.58 0 01-.597-.597v-1H4.365v1a.58.58 0 01-.595.597m.595-2.789h2.308v-1.711H4.365z"/></g></g>', width: 24, height: 24 }, "abort-circle-outline": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4 6.5h4.012a.46.46 0 00.35-.144A.5.5 0 008.5 6a.48.48 0 00-.144-.356A.48.48 0 008 5.5H3.988a.46.46 0 00-.35.144A.5.5 0 003.5 6q0 .213.143.356A.48.48 0 004 6.5M6 11a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069q-.675-.675-1.069-1.587A4.9 4.9 0 011 6q0-1.038.394-1.95a5 5 0 011.069-1.587q.675-.675 1.587-1.07A4.9 4.9 0 016 1q1.038 0 1.95.393a5 5 0 011.587 1.07q.675.675 1.069 1.587T11 6t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 016 11m0-1q1.662 0 2.832-1.168Q10 7.662 10 6T8.832 3.169 6 2Q4.338 2 3.169 3.168 1.999 4.339 2 6t1.169 2.832Q4.338 10 6 10"/></g>', width: 12, height: 12 }, "accepted-tc": { body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.33"><path d="M17 10V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h3M7 7h6m-6 3h3"/><path stroke-linejoin="round" d="m11 15.5 2.333 2.5L18 13"/></g>', width: 20, height: 20 }, "account-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.02 14.41a9 9 0 012.314-1.245A7.7 7.7 0 0110 12.708q1.413 0 2.666.457t2.315 1.245a6.6 6.6 0 001.231-1.977q.455-1.124.455-2.433 0-2.77-1.948-4.719Q12.77 3.333 10 3.333T5.281 5.281Q3.333 7.23 3.333 10q0 1.31.455 2.433a6.6 6.6 0 001.231 1.977M10 10.625q-1.14 0-1.925-.783-.783-.784-.783-1.925t.783-1.925T10 5.208q1.14 0 1.925.784.783.783.783 1.924t-.783 1.925-1.925.784m0 7.292a7.8 7.8 0 01-3.094-.62 8 8 0 01-2.513-1.69 8 8 0 01-1.69-2.513A7.8 7.8 0 012.084 10q0-1.649.62-3.094a8 8 0 011.69-2.513 8 8 0 012.513-1.69A7.8 7.8 0 0110 2.084q1.649 0 3.094.62a8 8 0 012.513 1.69 8 8 0 011.69 2.513 7.8 7.8 0 01.62 3.094q0 1.649-.62 3.094a8 8 0 01-1.69 2.513 8 8 0 01-2.513 1.69 7.8 7.8 0 01-3.094.62m0-1.25q1.128 0 2.175-.363a6.2 6.2 0 001.86-1.015 6.3 6.3 0 00-1.835-.98 6.7 6.7 0 00-2.2-.35q-1.176 0-2.204.346a6 6 0 00-1.831.984 6.2 6.2 0 001.86 1.015 6.6 6.6 0 002.175.363m0-7.292q.622 0 1.04-.418.418-.42.418-1.04 0-.623-.418-1.04a1.4 1.4 0 00-1.04-.42q-.622 0-1.04.419a1.4 1.4 0 00-.418 1.04q0 .62.418 1.04.418.418 1.04.418"/></g>', width: 20, height: 20 }, "account-circle-off": { body: '<mask id="svgID0" width="17" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.286 0h16v16h-16z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.285 13.333q.89 0 1.714-.28a5.1 5.1 0 001.515-.822 5.37 5.37 0 00-3.229-1.064q-.888 0-1.713.264a4.9 4.9 0 00-1.515.8 5.1 5.1 0 001.515.822q.825.28 1.713.28m1.639-5.575-.713-.713a1.2 1.2 0 00.241-.712q0-.48-.343-.823a1.12 1.12 0 00-.824-.343 1.2 1.2 0 00-.712.241l-.712-.713q.295-.264.66-.396.363-.132.767-.132.9 0 1.532.632t.632 1.532q0 .402-.132.767t-.396.66m3.685 3.684-.73-.73q.367-.622.553-1.306.187-.683.187-1.406 0-2.234-1.55-3.783-1.55-1.55-3.784-1.55a5.3 5.3 0 00-2.712.74l-.73-.73a6.37 6.37 0 013.442-1.01q1.315 0 2.47.499 1.156.498 2.011 1.353T14.12 5.53 14.619 8q0 .921-.258 1.796a6.4 6.4 0 01-.753 1.646m-5.326 2.891a6.15 6.15 0 01-2.467-.499 6.4 6.4 0 01-2.01-1.354 6.4 6.4 0 01-1.355-2.01A6.2 6.2 0 011.952 8q0-1.002.3-1.949.301-.945.892-1.76l-1.653-1.67a.48.48 0 01-.147-.354.5.5 0 01.157-.36.5.5 0 01.356-.154.5.5 0 01.357.155l12.295 12.305q.149.149.146.353a.5.5 0 01-.157.36.48.48 0 01-.351.155.48.48 0 01-.351-.155L3.878 5.024A5.2 5.2 0 002.952 8q0 .99.346 1.895.345.904 1.003 1.633a7.3 7.3 0 011.89-1.003 6.2 6.2 0 012.094-.358 5.6 5.6 0 011.501.204q.74.204 1.416.552l1.563 1.563a6.1 6.1 0 01-2.058 1.376 6.4 6.4 0 01-2.424.471"/></g>', width: 17 }, "account-tree": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.167 12.82v-.987H8.705q-.498 0-.852-.354a1.16 1.16 0 01-.353-.851V5.166H5.833v.987q0 .421-.295.718a.98.98 0 01-.718.295H2.514a.98.98 0 01-.717-.295.98.98 0 01-.296-.718V3.18q0-.422.296-.717a.98.98 0 01.717-.296H4.82q.42 0 .717.296a.98.98 0 01.295.717v.987h4.334V3.18q0-.422.295-.717a.98.98 0 01.718-.296h2.307q.422 0 .717.296a.98.98 0 01.296.717v2.974q0 .421-.296.718a.98.98 0 01-.717.295H11.18a.98.98 0 01-.718-.295.98.98 0 01-.295-.718v-.987H8.5v5.461q0 .09.058.148a.2.2 0 00.147.058h1.462v-.987q0-.422.295-.718a.98.98 0 01.718-.295h2.307q.422 0 .717.295a.98.98 0 01.296.718v2.974q0 .422-.296.717a.98.98 0 01-.717.296H11.18a.98.98 0 01-.718-.296.98.98 0 01-.295-.717m1-6.654H13.5v-3h-2.333zm0 6.667H13.5v-3h-2.333zM2.5 6.166h2.333v-3H2.5z"/></g>' }, add: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 12.5a.485.485 0 01-.5-.5V8.5H4a.484.484 0 01-.5-.5.486.486 0 01.5-.5h3.5V4a.484.484 0 01.5-.5.486.486 0 01.5.5v3.5H12q.216 0 .359.141A.5.5 0 0112.5 8a.485.485 0 01-.5.5H8.5V12a.5.5 0 01-.141.359A.5.5 0 018 12.5"/></g>' }, "add-box": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 11.166a.5.5 0 00.359-.141.5.5 0 00.141-.359V8.5h2.167a.486.486 0 00.5-.5.5.5 0 00-.142-.359.5.5 0 00-.358-.141H8.5V5.333a.485.485 0 00-.5-.5.484.484 0 00-.5.5V7.5H5.333a.485.485 0 00-.5.5.484.484 0 00.5.5H7.5v2.166a.486.486 0 00.5.5m-4.467 2.5q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.533q0-.5.35-.85t.85-.35h8.934q.5 0 .85.35t.35.85v8.933q0 .5-.35.85t-.85.35zm0-1h8.934q.083 0 .142-.058a.2.2 0 00.058-.142V3.533a.2.2 0 00-.058-.141.2.2 0 00-.142-.059H3.533a.2.2 0 00-.141.059.2.2 0 00-.059.141v8.933q0 .084.059.142a.2.2 0 00.141.058"/></g>' }, "add-circle": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#01593D" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 11.167a.5.5 0 00.36-.142.5.5 0 00.14-.358V8.5h2.184a.485.485 0 00.483-.5.5.5 0 00-.141-.359.5.5 0 00-.359-.14H8.501V5.316a.486.486 0 00-.5-.483.484.484 0 00-.5.5V7.5H5.317a.486.486 0 00-.483.5.484.484 0 00.5.5H7.5v2.183q0 .201.142.342a.5.5 0 00.358.142m0 3.166a6.2 6.2 0 01-2.474-.5 6.4 6.4 0 01-2.009-1.35 6.4 6.4 0 01-1.35-2.008A6.2 6.2 0 011.667 8q0-1.317.5-2.475a6.4 6.4 0 011.35-2.008 6.4 6.4 0 012.009-1.35A6.2 6.2 0 018 1.667a6.2 6.2 0 012.475.5 6.4 6.4 0 012.008 1.35 6.4 6.4 0 011.35 2.008q.5 1.158.5 2.475t-.5 2.475a6.4 6.4 0 01-1.35 2.008 6.4 6.4 0 01-2.008 1.35 6.2 6.2 0 01-2.475.5m0-1q2.217 0 3.776-1.558T13.334 8t-1.558-3.775Q10.216 2.667 8 2.667q-2.217 0-3.775 1.558Q2.666 5.783 2.667 8t1.559 3.775T8 13.333"/></g>' }, "add-circle-filled": { body: '<mask id="svgID0" width="15" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h14v14H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.062 7.437v1.896q0 .186.126.312a.42.42 0 00.312.125.42.42 0 00.312-.125.42.42 0 00.125-.312V7.437h1.896a.42.42 0 00.312-.126.42.42 0 00.126-.312.42.42 0 00-.126-.311.42.42 0 00-.312-.126H7.937V4.666a.42.42 0 00-.125-.311.42.42 0 00-.312-.126.42.42 0 00-.312.126.42.42 0 00-.126.311v1.896H5.167a.42.42 0 00-.312.126.42.42 0 00-.126.312q0 .186.126.312a.42.42 0 00.312.125zm.439 5.104a5.4 5.4 0 01-2.161-.436 5.6 5.6 0 01-1.76-1.184 5.6 5.6 0 01-1.185-1.76 5.4 5.4 0 01-.437-2.16q0-1.15.437-2.162a5.6 5.6 0 011.184-1.76 5.6 5.6 0 011.76-1.184 5.4 5.4 0 012.16-.437q1.15 0 2.161.436 1.012.437 1.76 1.185a5.6 5.6 0 011.185 1.759q.437 1.011.437 2.16t-.437 2.162a5.6 5.6 0 01-1.184 1.76 5.6 5.6 0 01-1.76 1.185 5.4 5.4 0 01-2.16.436"/></g>', width: 15, height: 14 }, "add-notes": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M14.632 15.417v1.714q0 .148.11.258a.354.354 0 00.516 0 .35.35 0 00.11-.258v-1.714h1.715a.35.35 0 00.258-.111.354.354 0 000-.516.35.35 0 00-.258-.11H15.37v-1.715a.35.35 0 00-.11-.258.354.354 0 00-.517 0 .35.35 0 00-.11.258v1.714h-1.715a.35.35 0 00-.258.111.354.354 0 000 .516q.11.11.258.11zM4.423 17.083a1.45 1.45 0 01-1.064-.442 1.45 1.45 0 01-.442-1.064V4.423q0-.621.442-1.064a1.45 1.45 0 011.064-.442h11.154q.621 0 1.064.442.442.443.442 1.064v4.215q0 .265-.18.445a.6.6 0 01-.445.18.6.6 0 01-.445-.18.6.6 0 01-.18-.445V4.423a.25.25 0 00-.08-.176.25.25 0 00-.176-.08H4.423a.25.25 0 00-.176.08.25.25 0 00-.08.176v11.154q0 .096.08.176t.176.08h4.215q.265 0 .445.18t.18.445q0 .267-.18.446a.6.6 0 01-.445.18zm-.256-1.25V4.167v5.158-.062zm1.875-2.596q0 .267.18.446.18.18.445.18h2.098q.265 0 .445-.18t.18-.446a.6.6 0 00-.18-.445.6.6 0 00-.445-.18H6.667a.6.6 0 00-.446.18.6.6 0 00-.18.445m0-3.237q0 .266.18.445.18.18.445.18h4.783q.267 0 .446-.18.18-.18.18-.445a.6.6 0 00-.18-.446.6.6 0 00-.446-.179H6.667a.6.6 0 00-.446.18.6.6 0 00-.18.445m0-3.237q0 .266.18.445.18.18.445.18h6.666q.267 0 .446-.18.18-.18.18-.446a.6.6 0 00-.18-.445.6.6 0 00-.446-.18H6.667a.6.6 0 00-.446.18.6.6 0 00-.18.446M15 18.798q-1.56 0-2.655-1.095t-1.095-2.655 1.095-2.655T15 11.298t2.656 1.095q1.095 1.094 1.094 2.655t-1.094 2.655Q16.56 18.798 15 18.798"/></g>', width: 20, height: 20 }, "add-task": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 16.125a6.9 6.9 0 01-2.779-.561 7.2 7.2 0 01-2.262-1.523 7.2 7.2 0 01-1.523-2.261A6.9 6.9 0 011.875 9q0-1.477.561-2.779A7.2 7.2 0 013.96 3.96a7.2 7.2 0 012.262-1.524A6.9 6.9 0 019 1.875q.936 0 1.814.239.879.239 1.68.69.218.12.283.349a.47.47 0 01-.077.425.65.65 0 01-.84.176 6 6 0 00-1.384-.56A5.7 5.7 0 009 3Q6.487 3 4.744 4.744T3 9t1.744 4.256Q6.487 15 9 15a6 6 0 002.081-.372.86.86 0 01.471-.013.57.57 0 01.358.27q.113.195.048.423a.45.45 0 01-.296.312 6.7 6.7 0 01-1.308.382A7.5 7.5 0 019 16.125m5.438-3.562H12.75a.54.54 0 01-.4-.162.55.55 0 01-.162-.401q0-.24.161-.401a.55.55 0 01.401-.162h1.688V9.75q0-.24.161-.4A.55.55 0 0115 9.187q.24 0 .4.161a.55.55 0 01.162.401v1.688h1.688q.24 0 .4.161a.55.55 0 01.163.401q0 .24-.162.4a.55.55 0 01-.401.162h-1.687v1.688q0 .24-.162.4a.55.55 0 01-.401.162.54.54 0 01-.401-.161.55.55 0 01-.162-.401zM7.936 10.61l7.003-7.016a.54.54 0 01.392-.16.53.53 0 01.399.16q.162.163.163.395a.54.54 0 01-.163.396l-7.32 7.33a.65.65 0 01-.474.204.65.65 0 01-.475-.203L5.403 9.658a.54.54 0 01-.16-.392.53.53 0 01.16-.399.54.54 0 01.395-.163q.233 0 .395.163z"/></g>', width: 18, height: 18 }, "add-to-queue": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 12.292q.267 0 .446-.18.18-.18.18-.445V9.792H12.5q.265 0 .445-.18t.18-.446a.6.6 0 00-.18-.445.6.6 0 00-.445-.18h-1.875V6.668a.6.6 0 00-.18-.446.6.6 0 00-.446-.18.6.6 0 00-.445.18.6.6 0 00-.18.446v1.875H7.502a.6.6 0 00-.446.18.6.6 0 00-.18.445q0 .266.18.445.18.18.446.18h1.875v1.875q0 .265.18.445t.445.18m-2.163 4.791a.73.73 0 01-.536-.216.73.73 0 01-.217-.537v-.913H3.59a1.45 1.45 0 01-1.063-.443 1.45 1.45 0 01-.443-1.064V4.423q0-.621.443-1.064a1.45 1.45 0 011.063-.442h12.82q.622 0 1.065.442.442.443.442 1.064v9.487q0 .623-.442 1.064a1.45 1.45 0 01-1.064.443h-3.494v.913a.73.73 0 01-.216.537.73.73 0 01-.537.216zM3.59 14.167h12.82a.25.25 0 00.185-.072.25.25 0 00.072-.185V4.423a.25.25 0 00-.072-.184.25.25 0 00-.184-.072H3.59a.25.25 0 00-.185.072.25.25 0 00-.072.184v9.487a.25.25 0 00.072.185.25.25 0 00.184.072"/></g>', width: 20, height: 20 }, addons: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.656 15.375H3.749q-.468 0-.796-.328a1.08 1.08 0 01-.329-.797v-2.906a2.22 2.22 0 001.323-.638q.552-.543.552-1.33 0-.789-.552-1.332a2.22 2.22 0 00-1.323-.638V4.5q0-.468.329-.796.327-.33.796-.329h3q.095-.713.62-1.181.525-.47 1.255-.469.732 0 1.257.469t.618 1.181h3q.469 0 .797.329.328.327.328.796v3q.713.094 1.182.619t.468 1.256-.468 1.256-1.182.62v3q0 .468-.328.796a1.08 1.08 0 01-.797.328h-2.906a2.13 2.13 0 00-.656-1.34 1.85 1.85 0 00-1.313-.535q-.75 0-1.312.534a2.13 2.13 0 00-.656 1.341M3.749 14.25h2.025q.394-.993 1.229-1.435.834-.44 1.621-.44t1.623.44 1.227 1.435H13.5v-4.087h.92q.355-.038.543-.272a.8.8 0 00.187-.516.8.8 0 00-.187-.516q-.187-.234-.544-.271H13.5V4.5H9.412v-.919q-.038-.356-.272-.543a.8.8 0 00-.516-.188.8.8 0 00-.516.188q-.234.188-.271.543v.92H3.749v2.062a2.84 2.84 0 011.37 1.106q.505.768.505 1.706 0 .919-.506 1.688a2.95 2.95 0 01-1.369 1.125z"/></g>', width: 18, height: 18 }, "ads-click": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.625 14.563a4.47 4.47 0 01-2.99-1.448Q5.418 11.812 5.418 10q0-1.917 1.333-3.25T10 5.417q1.813 0 3.115 1.208 1.302 1.209 1.447 3l-1.312-.396a3.3 3.3 0 00-1.167-1.843A3.23 3.23 0 0010 6.666a3.2 3.2 0 00-2.354.98A3.2 3.2 0 006.666 10q0 1.188.72 2.083a3.3 3.3 0 001.843 1.167zM10 17.917a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.624 1.448.625 3.094v.302q0 .156-.042.323l-1.208-.375V10q0-2.791-1.938-4.73Q12.792 3.335 10 3.334T5.27 5.272Q3.335 7.209 3.334 10q0 2.792 1.938 4.73Q7.209 16.665 10 16.666h.25l.375 1.208a1 1 0 01-.302.042zm6.52-.146L13 14.25l-.52 1.583q-.084.271-.365.26-.282-.01-.365-.28l-1.542-5.126q-.062-.207.104-.374.168-.167.376-.105l5.124 1.542q.272.084.281.364.011.282-.26.365L14.25 13l3.52 3.52q.126.105.126.26a.33.33 0 01-.125.262l-.73.729a.33.33 0 01-.26.125.33.33 0 01-.26-.125"/></g>', width: 20, height: 20 }, "after-list": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M20 0H0v20h20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M15.833 10.208a.605.605 0 00.625-.625.61.61 0 00-.625-.625H5.625a2.8 2.8 0 00-2.063.854 2.8 2.8 0 00-.854 2.063q0 1.209.854 2.063a2.8 2.8 0 002.063.854h2.52l-.833.833a.6.6 0 00-.187.438.6.6 0 00.187.437q.188.208.438.208t.458-.208l1.813-1.812q.103-.105.155-.24a.77.77 0 00-.155-.802l-1.834-1.834a.55.55 0 00-.427-.187.58.58 0 00-.448.208.6.6 0 00-.187.448q0 .26.208.448l.813.813H5.625q-.688 0-1.178-.49a1.6 1.6 0 01-.489-1.177q0-.686.49-1.178.489-.489 1.177-.489zm0-4.583A.605.605 0 0016.458 5a.605.605 0 00-.625-.625H4.166A.61.61 0 003.541 5a.606.606 0 00.625.625zm0 9.167a.606.606 0 00.625-.625.61.61 0 00-.625-.625h-2.52a.58.58 0 00-.428.176.6.6 0 00-.177.449q0 .27.177.448a.6.6 0 00.448.177z"/></g>', width: 20, height: 20 }, agents: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.58 15.375a.67.67 0 01-.477-.187.62.62 0 01-.197-.47V8.832q0-.281.197-.478a.65.65 0 01.478-.197h2.906q.281 0 .478.197a.65.65 0 01.197.478v5.888a.62.62 0 01-.197.469.67.67 0 01-.478.187zm0-1.406h2.907V9.58H12.58zM6.6 15.375a.55.55 0 01-.404-.159.55.55 0 01-.16-.403q0-.244.16-.404a.55.55 0 01.403-.159h1.05v-1.875H3.206q-.582 0-.975-.394a1.3 1.3 0 01-.394-.956v-7.05q0-.563.394-.956.393-.394.975-.394h10.03q.564 0 .957.394.394.393.394.956v2.119a.546.546 0 01-.563.562.56.56 0 01-.393-.16.53.53 0 01-.17-.402V3.975a.24.24 0 00-.055-.159q-.056-.066-.17-.066H3.207a.24.24 0 00-.179.066.22.22 0 00-.065.16v7.05q0 .093.065.158a.24.24 0 00.179.066h6.637q.244 0 .404.16a.55.55 0 01.159.403.55.55 0 01-.16.403.55.55 0 01-.403.16h-1.07v1.874h1.07q.243 0 .403.16a.55.55 0 01.159.403.55.55 0 01-.16.403.55.55 0 01-.403.16zm.9-5.962.712-.563.712.563q.207.168.423.018.215-.15.14-.393l-.281-.92.806-.655q.206-.17.112-.394-.093-.225-.318-.225H8.83l-.282-.881a.34.34 0 00-.13-.178.324.324 0 00-.395 0 .34.34 0 00-.13.178l-.282.88h-.975q-.244 0-.328.226-.084.225.103.394l.825.656-.281.919q-.075.243.14.393t.403-.018"/></g>', width: 18, height: 18 }, "ai-add": { body: '<path fill="currentColor" d="m5.1 0 .938 2.204a3.7 3.7 0 001.958 1.959L10.2 5.1l-2.204.938a3.7 3.7 0 00-1.958 1.958L5.1 10.2l-.937-2.204a3.7 3.7 0 00-1.959-1.958L0 5.1l2.204-.937a3.7 3.7 0 001.959-1.959zm4.098 10.135H7.801a.45.45 0 01-.33-.137.45.45 0 01-.138-.331.45.45 0 01.137-.33.45.45 0 01.331-.138h1.397V7.802a.45.45 0 01.138-.331.45.45 0 01.33-.138.45.45 0 01.331.138.45.45 0 01.137.33V9.2h1.398a.45.45 0 01.33.137.45.45 0 01.138.33.45.45 0 01-.138.332.45.45 0 01-.33.137h-1.398v1.397a.45.45 0 01-.137.33.45.45 0 01-.33.138.45.45 0 01-.331-.137.45.45 0 01-.138-.331z"/>', width: 12, height: 12 }, "ai-agentic": { body: '<g fill="none"><g clip-path="url(#svgID5)"><path fill="url(#svgID0)" d="M10.152 8.008A1.994 1.994 0 008.16 10c0 1.098.894 1.992 1.992 1.992A1.994 1.994 0 0012.145 10a1.994 1.994 0 00-1.993-1.992"/><path fill="url(#svgID1)" d="M3.398 12.45a1.25 1.25 0 10-2.5 0 1.25 1.25 0 002.5 0"/><path fill="url(#svgID2)" d="M17.148 10q.3-.33.56-.66C19.05 7.634 19.442 6.092 18.811 5c-.63-1.092-2.161-1.523-4.31-1.213-1.334.192-2.828.653-4.35 1.333a20 20 0 00-2.362-.885q.115-.35.244-.673c.47-1.175 1.059-1.978 1.642-2.269.117-.502.39-.944.765-1.273a2 2 0 00-.29-.02C8.89 0 7.751 1.11 6.945 3.127q-.156.39-.292.814-.435-.093-.851-.154c-2.15-.31-3.68.12-4.311 1.213s-.238 2.634 1.105 4.34c.833 1.06 1.979 2.122 3.328 3.1.09.873.23 1.71.415 2.488q-.36.075-.704.125c-1.251.18-2.24.073-2.784-.286a2.4 2.4 0 01-1.487-.026q.055.133.127.259c.497.861 1.554 1.311 3.033 1.311q.595 0 1.278-.098.416-.06.851-.154.136.423.292.814C7.752 18.89 8.89 20 10.152 20s2.4-1.11 3.206-3.127c.5-1.251.849-2.775 1.021-4.433a20 20 0 001.947-1.603q.245.274.46.547c.784.997 1.185 1.91 1.144 2.561.362.34.62.79.72 1.297q.09-.116.162-.242c.63-1.092.238-2.633-1.104-4.34q-.26-.33-.56-.66m-2.48-5.053c1.596-.23 2.766.009 3.13.639s-.015 1.763-1.011 3.03q-.216.274-.461.547c-1.108-1.046-2.477-2.053-3.998-2.931a25 25 0 00-.774-.429c1.095-.424 2.152-.718 3.114-.856M3.518 8.616c-.997-1.267-1.375-2.4-1.011-3.03s1.533-.87 3.129-.64q.345.051.704.126C5.988 6.554 5.8 8.243 5.8 10q0 .446.017.884c-.915-.735-1.698-1.505-2.3-2.268M6.972 10c0-1.661.175-3.251.503-4.637 1.364.41 2.828 1.053 4.267 1.883S14.47 9.023 15.507 10c-1.037.977-2.326 1.923-3.765 2.754-1.439.83-2.903 1.474-4.267 1.883-.328-1.386-.503-2.976-.503-4.637m5.298 6.438c-.599 1.497-1.39 2.39-2.118 2.39s-1.52-.893-2.118-2.39q-.13-.324-.244-.673c1.46-.436 3.016-1.118 4.538-1.997q.386-.222.758-.456c-.18 1.16-.455 2.223-.816 3.126"/><path fill="url(#svgID3)" d="M16.273 14.46a1.251 1.251 0 000 2.5 1.251 1.251 0 000-2.5"/><path fill="url(#svgID4)" d="M12.035 3.091a1.25 1.25 0 100-2.5 1.25 1.25 0 000 2.5"/></g><defs><linearGradient id="svgID0" x1="10.11" x2="14.833" y1="6.638" y2="9.273" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><linearGradient id="svgID1" x1="2.122" x2="5.086" y1="10.34" y2="11.993" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><linearGradient id="svgID2" x1="9.961" x2="32.239" y1="-6.875" y2="4.253" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><linearGradient id="svgID3" x1="16.247" x2="19.211" y1="13.6" y2="15.254" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><linearGradient id="svgID4" x1="12.008" x2="14.972" y1="-.268" y2="1.385" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><clipPath id="svgID5"><path fill="#fff" d="M0 0h20v20H0z"/></clipPath></defs></g>', width: 20, height: 20 }, "ai-analyzer-agent": { body: '<path fill="currentColor" fill-rule="evenodd" d="M10 3.75c1.955 0 3.7.898 4.847 2.304l.252.011a4.3 4.3 0 011.484.339A7.5 7.5 0 0010 2.5a7.5 7.5 0 00-6.584 3.904 4.3 4.3 0 011.485-.339l.252-.011A6.24 6.24 0 0110 3.75m0 12.5a6.23 6.23 0 01-4.25-1.667h-.656q-.599-.001-1.15-.157A7.49 7.49 0 0010 17.5a7.49 7.49 0 006.055-3.074 4.3 4.3 0 01-1.15.157h-.656a6.23 6.23 0 01-4.25 1.667M4.778 6.872c-1.737.068-3.111 1.54-3.111 3.334 0 1.842 1.448 3.336 3.235 3.336h1.571c.941 0 1.862-.287 2.645-.824a1.55 1.55 0 011.764 0 4.67 4.67 0 002.644.824h1.572c1.787 0 3.235-1.494 3.235-3.336 0-1.794-1.374-3.266-3.112-3.334L10 6.667zM17.396 10A2.396 2.396 0 0115 12.396a.104.104 0 100 .208A2.604 2.604 0 0017.604 10a.104.104 0 10-.208 0M4.166 8.889l.006.029c.085.412.413.731.828.804a1.03 1.03 0 00-.828.805l-.006.029-.005-.03a1.03 1.03 0 00-.828-.804c.415-.073.743-.392.828-.804z" clip-rule="evenodd"/>', width: 20, height: 20 }, "ai-article": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.308 20.5q-.758 0-1.283-.525a1.75 1.75 0 01-.525-1.283V5.308q0-.758.525-1.283T5.308 3.5h13.384q.758 0 1.283.525t.525 1.283v13.384q0 .758-.525 1.283t-1.283.525zM8 16.75h5q.319 0 .534-.216A.73.73 0 0013.75 16a.73.73 0 00-.216-.534.73.73 0 00-.534-.216H8a.73.73 0 00-.534.216.73.73 0 00-.216.534q0 .32.216.535A.73.73 0 008 16.75m0-4h8q.318 0 .534-.216A.73.73 0 0016.75 12a.73.73 0 00-.216-.534.73.73 0 00-.534-.216H8a.73.73 0 00-.534.216.73.73 0 00-.216.534q0 .32.216.534A.73.73 0 008 12.75m0-4h8q.318 0 .534-.216A.73.73 0 0016.75 8a.73.73 0 00-.216-.535A.73.73 0 0016 7.25H8a.73.73 0 00-.534.216A.73.73 0 007.25 8q0 .32.216.534A.73.73 0 008 8.75"/></g>', width: 24, height: 24 }, "ai-atto-agent": { body: '<g fill="currentColor"><path d="M2.622 10.658c.21.145.442.267.691.355q.565.199 1.14.348a4.88 4.88 0 003.549 1.529 4.88 4.88 0 003.547-1.529q.575-.15 1.14-.348c.249-.088.48-.21.69-.354a6 6 0 01-5.377 3.342l-.309-.008a6 6 0 01-5.071-3.335m5.688-8.65a6 6 0 015.16 3.523 2.7 2.7 0 00-1.551-.456 4.88 4.88 0 00-3.917-1.963 4.88 4.88 0 00-3.918 1.963 2.7 2.7 0 00-1.552.456 6 6 0 015.47-3.53z"/><path d="M12.058 6.01A1.76 1.76 0 0114 7.76c0 1.067-.72 2-1.753 2.27l-.548.143a14.6 14.6 0 01-7.398 0l-.548-.144A2.346 2.346 0 012 7.76a1.76 1.76 0 011.942-1.75l1.42.15a25.4 25.4 0 005.277 0zM5.653 7.62h-.21v1.226h.21v.292h.424v-.292h.213v-.307h.105v-.613H6.29v-.307h-.213v-.286h-.424zm4.395-.287v.286h-.211v1.227h.21v.292h.425v-.292h.213v-.307h.105v-.613h-.105v-.307h-.213v-.286zM5.333 8.539h.106v-.613h-.106zm4.396-.613v.613h.105v-.613z"/></g>' }, "ai-cancel": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m12 13.054 3.073 3.073q.208.208.522.213a.7.7 0 00.532-.213.72.72 0 00.217-.527.72.72 0 00-.217-.527L13.054 12l3.073-3.073a.73.73 0 00.213-.522.7.7 0 00-.213-.532.72.72 0 00-.527-.217.72.72 0 00-.527.217L12 10.946 8.927 7.873a.73.73 0 00-.522-.213.7.7 0 00-.532.213.72.72 0 00-.217.527q0 .31.217.527L10.946 12l-3.073 3.073a.73.73 0 00-.213.522.7.7 0 00.213.532q.217.217.527.217a.72.72 0 00.527-.217zm.002 8.446a9.3 9.3 0 01-3.706-.748 9.6 9.6 0 01-3.016-2.03 9.6 9.6 0 01-2.032-3.016 9.25 9.25 0 01-.748-3.704q0-1.972.748-3.706a9.6 9.6 0 012.03-3.016 9.6 9.6 0 013.016-2.032 9.25 9.25 0 013.704-.748q1.972 0 3.706.748a9.6 9.6 0 013.017 2.03 9.6 9.6 0 012.03 3.016 9.25 9.25 0 01.749 3.704q0 1.972-.748 3.706a9.6 9.6 0 01-2.03 3.017 9.6 9.6 0 01-3.016 2.03 9.25 9.25 0 01-3.704.749"/></g>', width: 24, height: 24 }, "ai-capture": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.654 2.744a.52.52 0 01-.384-.155.52.52 0 01-.154-.384q0-.228.154-.383a.52.52 0 01.384-.155q.229 0 .384.155a.52.52 0 01.155.383q0 .229-.155.384a.52.52 0 01-.384.155m2.539 0a.52.52 0 01-.384-.155.52.52 0 01-.155-.384q0-.228.155-.383a.52.52 0 01.384-.155q.228 0 .383.155a.52.52 0 01.155.383q0 .229-.155.384a.52.52 0 01-.383.155m2.538 0a.52.52 0 01-.384-.155.52.52 0 01-.154-.384q0-.228.154-.383a.52.52 0 01.384-.155q.229 0 .384.155a.52.52 0 01.154.383q0 .229-.154.384a.52.52 0 01-.384.155m2.538 0a.52.52 0 01-.383-.155.52.52 0 01-.155-.384q0-.228.155-.383a.52.52 0 01.383-.155q.229 0 .384.155a.52.52 0 01.155.383q0 .229-.155.384a.52.52 0 01-.384.155m2.539 0a.52.52 0 01-.384-.155.52.52 0 01-.155-.384q0-.228.155-.383a.52.52 0 01.384-.155q.228 0 .384.155a.52.52 0 01.154.383q0 .229-.154.384a.52.52 0 01-.384.155m2.538 0a.52.52 0 01-.383-.155.52.52 0 01-.155-.384q0-.228.155-.383a.52.52 0 01.383-.155q.229 0 .384.155a.52.52 0 01.155.383q0 .229-.155.384a.52.52 0 01-.384.155M1.654 5.282a.52.52 0 01-.384-.155.52.52 0 01-.154-.383q0-.229.154-.384a.52.52 0 01.384-.155q.229 0 .384.155a.52.52 0 01.155.384.52.52 0 01-.155.383.52.52 0 01-.384.155m0 2.539a.52.52 0 01-.384-.155.52.52 0 01-.154-.384q0-.228.154-.384a.52.52 0 01.384-.154q.229 0 .384.154a.52.52 0 01.155.384q0 .229-.155.384a.52.52 0 01-.384.155m2.539 0a.52.52 0 01-.384-.155.52.52 0 01-.155-.384q0-.228.155-.384a.52.52 0 01.384-.154q.228 0 .383.154a.52.52 0 01.155.384q0 .229-.155.384a.52.52 0 01-.383.155m7.615 0a.52.52 0 01-.384-.155.52.52 0 01-.155-.384q0-.228.155-.384a.52.52 0 01.384-.154q.228 0 .384.154a.52.52 0 01.154.384q0 .229-.154.384a.52.52 0 01-.384.155m2.538 0a.52.52 0 01-.383-.155.52.52 0 01-.155-.384q0-.228.155-.384a.52.52 0 01.383-.154q.229 0 .384.154a.52.52 0 01.155.384q0 .229-.155.384a.52.52 0 01-.384.155m0-2.539a.52.52 0 01-.383-.155.52.52 0 01-.155-.383q0-.229.155-.384a.52.52 0 01.383-.155q.229 0 .384.155a.52.52 0 01.155.384.52.52 0 01-.155.383.52.52 0 01-.384.155m-6.515 9.545a1.8 1.8 0 01-1.294-.537l-2.734-2.74a.52.52 0 01-.16-.44.78.78 0 01.211-.459.93.93 0 01.464-.255q.27-.062.545.01l1.253.32V5.333q0-.212.143-.356a.48.48 0 01.357-.144q.213 0 .356.144a.48.48 0 01.144.356v5.93a.57.57 0 01-.233.474.58.58 0 01-.528.102l-1.136-.294 2.025 2.037a.86.86 0 00.588.245h2.553q.627 0 1.063-.437.437-.435.437-1.063V9.936q0-.212.144-.356a.48.48 0 01.356-.144q.213 0 .356.144a.48.48 0 01.144.356v2.39q0 1.037-.732 1.769a2.4 2.4 0 01-1.768.732zM8.54 7.18q.213 0 .356.143a.48.48 0 01.144.357v2.173q0 .212-.144.356a.48.48 0 01-.357.144.48.48 0 01-.356-.144.5.5 0 01-.143-.356V7.68q0-.212.144-.357a.48.48 0 01.356-.143m1.923.794q.212 0 .356.144a.48.48 0 01.144.356v1.379q0 .212-.144.356a.48.48 0 01-.356.144.48.48 0 01-.357-.144.48.48 0 01-.143-.356V8.474q0-.212.144-.356a.48.48 0 01.356-.144"/></g>' }, "ai-check-circle": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.948 10.35 6.336 8.738a.7.7 0 00-.525-.207.7.7 0 00-.525.207.7.7 0 00-.207.524q0 .32.207.525l2.137 2.138a.72.72 0 00.525.225.72.72 0 00.525-.225l4.237-4.238a.7.7 0 00.207-.525.7.7 0 00-.207-.524.7.7 0 00-.525-.207.7.7 0 00-.524.207zm1.05 6.15a7.3 7.3 0 01-2.925-.59 7.6 7.6 0 01-2.381-1.604 7.6 7.6 0 01-1.603-2.381A7.3 7.3 0 011.499 9q-.001-1.556.59-2.925a7.6 7.6 0 011.603-2.381A7.6 7.6 0 016.073 2.09a7.3 7.3 0 012.925-.59q1.557 0 2.925.59a7.6 7.6 0 012.381 1.604 7.6 7.6 0 011.603 2.381q.591 1.369.591 2.925a7.3 7.3 0 01-.59 2.925 7.6 7.6 0 01-1.604 2.381 7.6 7.6 0 01-2.381 1.603 7.3 7.3 0 01-2.925.591"/></g>', width: 18, height: 18 }, "ai-check-square": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m7.163 11.363 6.357-6.357a.72.72 0 01.524-.225q.3 0 .525.225a.73.73 0 01.225.535.73.73 0 01-.225.534l-6.88 6.9a.72.72 0 01-.526.225.72.72 0 01-.525-.225L3.413 9.75a.7.7 0 01-.215-.534.77.77 0 01.234-.535.73.73 0 01.534-.225.73.73 0 01.535.225z"/></g>', width: 18, height: 18 }, "ai-close": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 8.933 4.735 12.2a.63.63 0 01-.467.183.63.63 0 01-.466-.183.63.63 0 01-.184-.467q0-.283.184-.466L7.067 8 3.801 4.733a.63.63 0 01-.184-.466q0-.285.184-.467a.63.63 0 01.466-.183q.285 0 .467.183L8 7.067 11.267 3.8a.63.63 0 01.467-.183q.283 0 .466.183a.63.63 0 01.184.467.63.63 0 01-.184.466L8.935 8l3.267 3.267a.63.63 0 01.183.466.63.63 0 01-.184.467.63.63 0 01-.466.183.63.63 0 01-.467-.183z"/></g>' }, "ai-conversion": { body: '<g fill="none"><path fill="url(#svgID0)" d="m7.65.5 1.601 3.764a4.32 4.32 0 002.285 2.285L15.3 8.15l-3.764 1.601a4.32 4.32 0 00-2.285 2.285L7.65 15.8l-1.601-3.764A4.32 4.32 0 003.764 9.75L0 8.15l3.764-1.601A4.32 4.32 0 006.05 4.264z"/><path fill="url(#svgID1)" d="m14.4 11.3.393.923a4.32 4.32 0 002.285 2.285L18 14.9l-.923.393a4.32 4.32 0 00-2.285 2.284l-.392.923-.393-.923a4.32 4.32 0 00-2.284-2.284L10.8 14.9l.923-.392a4.32 4.32 0 002.284-2.285z"/><defs><linearGradient id="svgID0" x1="0" x2="15.661" y1="3.2" y2="3.665" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".687" stop-color="currentColor"/></linearGradient><linearGradient id="svgID1" x1="10.801" x2="18.17" y1="12.571" y2="12.79" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".687" stop-color="currentColor"/></linearGradient></defs></g>', width: 18, height: 19 }, "ai-copilot": { body: '<g fill="currentColor"><path d="M12.88 4.593a.9.9 0 00-.274-.214.7.7 0 00-.323-.069 1 1 0 01-.448-.105 1.2 1.2 0 01-.383-.296 1.4 1.4 0 01-.253-.446 1.6 1.6 0 01-.09-.525q0-.19-.058-.369a1 1 0 00-.176-.314.8.8 0 00-.265-.215.7.7 0 00-.315-.077H3.69a.7.7 0 00-.316.077.8.8 0 00-.265.215 1 1 0 00-.176.314 1.2 1.2 0 00-.058.37c0 .364-.125.715-.343.97a1.09 1.09 0 01-.83.401.7.7 0 00-.32.069.8.8 0 00-.273.21 1 1 0 00-.183.314 1.1 1.1 0 00-.063.374v2.466c0 .127.02.255.063.373q.065.178.183.315a.78.78 0 00.592.273c.312 0 .608.146.83.401.223.256.344.607.348.971v2.507q.002.106.054.196.053.09.14.123a.23.23 0 00.176.005.27.27 0 00.144-.114l1.19-1.741h5.71q.165-.002.316-.078a.8.8 0 00.265-.214 1 1 0 00.176-.314q.058-.178.058-.37c0-.76.523-1.372 1.174-1.372a.7.7 0 00.32-.068.8.8 0 00.272-.21q.118-.136.184-.314a1.1 1.1 0 00.062-.374v-2.47a1.07 1.07 0 00-.242-.684zM11.475 7.77c0 .36-.129.706-.347.962a1.1 1.1 0 01-.827.396H3.687c-.308 0-.609-.141-.827-.396a1.5 1.5 0 01-.347-.962V5.25c0-.36.129-.707.347-.962a1.09 1.09 0 01.827-.397h6.612c.307 0 .608.141.826.397.218.255.347.601.347.961v2.52z"/><path d="m5.732 6.973-.14.427a.093.093 0 01-.178 0l-.14-.427a.28.28 0 00-.179-.179l-.426-.14a.093.093 0 010-.177l.426-.14a.28.28 0 00.18-.18l.14-.425a.093.093 0 01.177 0l.14.426a.28.28 0 00.179.179l.426.14a.093.093 0 010 .177l-.426.14a.28.28 0 00-.18.18m2.932-.001-.14.427a.093.093 0 01-.177 0l-.14-.427a.28.28 0 00-.18-.179l-.425-.14a.093.093 0 010-.177l.426-.14a.28.28 0 00.179-.18l.14-.425a.093.093 0 01.177 0l.14.426a.28.28 0 00.18.179l.426.14a.093.093 0 010 .177l-.427.14a.28.28 0 00-.179.18"/></g>', width: 14, height: 14 }, "ai-ellipse": { body: '<circle cx="2.5" cy="3" r="2.5" fill="currentColor"/>', width: 5, height: 6 }, "ai-feather": { body: '<g fill="none"><path fill="url(#svgID0)" d="M15.215 1.969c-9.37-.86-12.514 7.093-13.06 12.146-.023.204.285.27.377.086 1.177-2.344 3.076-3.196 3.982-3.325 5.686-1.003 6.836-2.61 6.706-3.413-.014-.085-.1-.13-.185-.114-1.584.305-1.765.129-1.646-.014a.1.1 0 01.031-.025c2.678-1.681 3.72-4.018 3.951-5.142.02-.099-.056-.19-.156-.2"/><path fill="url(#svgID1)" d="m2.597.679.176.413c.27.635.776 1.14 1.41 1.41l.414.177-.414.176c-.634.27-1.14.775-1.41 1.41l-.176.414-.176-.414a2.67 2.67 0 00-1.41-1.41l-.414-.176.414-.176a2.67 2.67 0 001.41-1.41z"/><path fill="url(#svgID2)" d="m13.333 11.333.176.414c.27.635.775 1.14 1.41 1.41l.414.176-.414.176c-.635.27-1.14.775-1.41 1.41l-.176.414-.176-.414a2.67 2.67 0 00-1.41-1.41l-.414-.176.414-.176a2.67 2.67 0 001.41-1.41z"/><defs><linearGradient id="svgID0" x1="2.069" x2="15.717" y1="4.272" y2="4.675" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".687" stop-color="currentColor"/></linearGradient><linearGradient id="svgID1" x1=".597" x2="4.692" y1="1.385" y2="1.506" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".687" stop-color="currentColor"/></linearGradient><linearGradient id="svgID2" x1="11.333" x2="15.427" y1="12.039" y2="12.161" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".687" stop-color="currentColor"/></linearGradient></defs></g>' }, "ai-feather1": { body: '<path fill="currentColor" d="m4.896 0 1.016 2.388A2.82 2.82 0 007.403 3.88l2.389 1.016-2.389 1.016a2.82 2.82 0 00-1.491 1.49l-1.016 2.39-1.016-2.39a2.82 2.82 0 00-1.491-1.49L0 4.896 2.389 3.88A2.82 2.82 0 003.88 2.388zm4.766 7.05.334.785a2.82 2.82 0 001.491 1.491l.786.335-.786.334a2.82 2.82 0 00-1.491 1.491l-.335.786-.334-.786a2.82 2.82 0 00-1.491-1.491L7.05 9.66l.786-.335a2.82 2.82 0 001.491-1.491z"/>', width: 13, height: 13 }, "ai-files": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.5 10.3v2.456q0 .212.144.357a.48.48 0 00.356.143q.212 0 .356-.143a.48.48 0 00.144-.357V10.3l.882.882q.075.075.167.111a.4.4 0 00.186.033.6.6 0 00.184-.043.52.52 0 00.316-.463.47.47 0 00-.15-.351L9.422 8.806A.55.55 0 009 8.636a.55.55 0 00-.422.17L6.915 10.47a.47.47 0 00-.146.348.5.5 0 00.157.355q.155.144.351.15a.47.47 0 00.351-.15zm-3.295 5.033q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855V3.872q0-.506.35-.855.35-.35.855-.35h4.796q.242 0 .464.093.222.094.386.258l2.798 2.797q.165.164.257.387.094.222.094.463v7.463q0 .505-.35.855t-.855.35zM10 6.063V3.668H5.205a.2.2 0 00-.14.064.2.2 0 00-.065.14v10.257q0 .077.064.141t.141.064h7.59a.2.2 0 00.14-.064.2.2 0 00.065-.141V6.667h-2.397a.58.58 0 01-.43-.173.58.58 0 01-.173-.43"/></g>', width: 18, height: 18 }, "ai-indicator": { body: '<path fill="currentColor" fill-rule="evenodd" d="M2.336 1.158a.25.25 0 01.465 0l.293.744a.25.25 0 00.141.14l.744.294a.25.25 0 010 .465l-.744.293a.25.25 0 00-.14.141L2.8 3.98a.25.25 0 01-.465 0l-.293-.744a.25.25 0 00-.141-.14L1.158 2.8a.25.25 0 010-.465l.744-.293a.25.25 0 00.14-.141zm12.085 1.475c-8.527-.856-11.335 7.008-11.789 11.9-.015.165.234.214.302.063 1.055-2.356 2.807-3.207 3.635-3.334 5.16-.98 6.169-2.555 6.032-3.327-.013-.07-.084-.107-.154-.092-1.441.299-1.6.125-1.49-.014a.1.1 0 01.025-.021c2.436-1.646 3.37-3.94 3.564-5.017.014-.078-.046-.15-.125-.158m-.62 9.525a.25.25 0 00-.465 0l-.293.744a.25.25 0 01-.141.14l-.744.294a.25.25 0 000 .465l.744.293a.25.25 0 01.14.141l.294.744a.25.25 0 00.465 0l.293-.744a.25.25 0 01.141-.14l.744-.294a.25.25 0 000-.465l-.744-.293a.25.25 0 01-.14-.141z" clip-rule="evenodd"/>' }, "ai-pending": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4E36B2" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.999 13.25q.52 0 .886-.364.365-.365.365-.885t-.364-.885A1.2 1.2 0 007 10.75q-.52 0-.886.364A1.2 1.2 0 005.75 12q0 .52.364.885.364.366.885.366m5 0q.52 0 .885-.364.366-.365.366-.885t-.364-.885A1.2 1.2 0 0012 10.75q-.52 0-.885.364a1.2 1.2 0 00-.366.885q0 .52.364.885.365.366.885.366m5 0q.52 0 .886-.364.365-.365.365-.885t-.364-.885A1.2 1.2 0 0017 10.75q-.52 0-.886.364a1.2 1.2 0 00-.365.885q0 .52.364.885.364.366.885.366m-4.997 8.25a9.3 9.3 0 01-3.706-.748 9.6 9.6 0 01-3.016-2.03 9.6 9.6 0 01-2.032-3.016 9.25 9.25 0 01-.748-3.704q0-1.972.748-3.706a9.6 9.6 0 012.03-3.016 9.6 9.6 0 013.016-2.032 9.25 9.25 0 013.704-.748q1.972 0 3.706.748a9.6 9.6 0 013.017 2.03 9.6 9.6 0 012.03 3.016 9.25 9.25 0 01.749 3.704q0 1.972-.748 3.706a9.6 9.6 0 01-2.03 3.017 9.6 9.6 0 01-3.016 2.03 9.25 9.25 0 01-3.704.749"/></g>', width: 24, height: 24 }, "ai-side-navigation": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.98 15.375q-.567 0-.961-.394a1.3 1.3 0 01-.394-.962V3.981q0-.57.394-.962.393-.394.962-.394h10.038q.57 0 .962.394.394.393.394.962v10.038q0 .57-.394.962a1.3 1.3 0 01-.962.394zM9 14.25h5.02a.22.22 0 00.158-.072.22.22 0 00.072-.159V3.981a.22.22 0 00-.072-.159.22.22 0 00-.159-.072H9z"/></g>', width: 18, height: 18 }, "ai-star": { body: '<path fill="currentColor" d="m9 0 .266 1.51A11.15 11.15 0 0018 10.5a11.15 11.15 0 00-8.734 8.99L9 21l-.266-1.51A11.15 11.15 0 000 10.5a11.15 11.15 0 008.734-8.99z"/>', width: 18, height: 21 }, "ai-stars-plain": { body: '<path fill="currentColor" d="M5.653.333 6.9 3.268c.217.511.625.919 1.136 1.136l2.935 1.248-2.935 1.249A2.15 2.15 0 006.9 8.037l-1.248 2.935-1.249-2.935A2.15 2.15 0 003.268 6.9L.333 5.652l2.935-1.248a2.15 2.15 0 001.136-1.136zm5.177 7.658.508 1.194c.217.511.624.918 1.136 1.136l1.193.507-1.193.508a2.15 2.15 0 00-1.136 1.136l-.508 1.193-.507-1.193a2.15 2.15 0 00-1.137-1.136l-1.193-.508 1.193-.507a2.15 2.15 0 001.137-1.136z"/>', width: 14, height: 14 }, "alarm-clock": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.625 10.58V7.292a.6.6 0 00-.18-.446.6.6 0 00-.445-.18.6.6 0 00-.445.18.6.6 0 00-.18.446v3.48q0 .152.055.287.054.137.171.254l2.438 2.437q.173.174.435.177a.6.6 0 00.443-.177.6.6 0 00.18-.44.6.6 0 00-.18-.438zM10 17.917a6.9 6.9 0 01-2.763-.558 7.2 7.2 0 01-2.246-1.516 7.2 7.2 0 01-1.516-2.247 6.9 6.9 0 01-.558-2.763q0-1.474.558-2.762A7.2 7.2 0 014.99 5.824a7.2 7.2 0 012.246-1.516A6.9 6.9 0 0110 3.75q1.474 0 2.763.558t2.247 1.516a7.2 7.2 0 011.516 2.247q.558 1.289.558 2.762 0 1.475-.558 2.763a7.2 7.2 0 01-1.516 2.247 7.2 7.2 0 01-2.247 1.516 6.9 6.9 0 01-2.763.558M2.013 6.067a.6.6 0 01-.181-.439q0-.258.181-.439l2.343-2.343a.6.6 0 01.435-.177.6.6 0 01.443.177q.18.181.181.44 0 .257-.18.438L2.89 6.067a.6.6 0 01-.435.177.6.6 0 01-.443-.177m15.974 0a.6.6 0 01-.439.181.6.6 0 01-.439-.18l-2.343-2.344a.6.6 0 01-.177-.435.6.6 0 01.177-.443.6.6 0 01.44-.181q.257 0 .438.181l2.343 2.343q.174.173.177.435a.6.6 0 01-.177.443M10 16.667q2.43 0 4.132-1.702t1.702-4.132-1.702-4.131T10 5 5.87 6.702q-1.702 1.703-1.702 4.131 0 2.43 1.702 4.132T10 16.667"/></g>', width: 20, height: 20 }, "alert-exists": { body: '<path fill="currentColor" d="M445.717 62.108H214.679a7.5 7.5 0 00-7.5 7.5v71.25h-96.095a7.5 7.5 0 00-7.5 7.5v71.244H7.5a7.5 7.5 0 00-7.5 7.5v156.506a7.5 7.5 0 007.5 7.5h231.039a7.5 7.5 0 007.5-7.5v-71.244h96.084a7.5 7.5 0 007.5-7.5v-71.247h96.094a7.5 7.5 0 007.5-7.5V69.608a7.5 7.5 0 00-7.5-7.5m-327.133 93.751h88.595v12.25h-88.595zM15 234.602h88.584v12.25H15zm216.039 141.506H15V261.852h88.584v43.013a7.5 7.5 0 007.5 7.5h119.955zm103.584-78.743H118.584V183.108h88.595v43.009a7.5 7.5 0 007.5 7.5h119.944zm103.594-78.747H222.179V104.362h216.038zm0-129.256H222.179V77.108h216.038z"/>', width: 453.217, height: 453.217 }, "alternate-email": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M11.692 22a7.9 7.9 0 01-3.387-.744 8.7 8.7 0 01-2.767-2.03 9.6 9.6 0 01-1.857-3.024A10.1 10.1 0 013 12.5q0-1.989.68-3.714a9.7 9.7 0 011.858-3.012 8.7 8.7 0 012.767-2.03A7.9 7.9 0 0111.692 3a7.9 7.9 0 013.398.744 8.8 8.8 0 012.755 2.03 9.7 9.7 0 011.857 3.012q.68 1.725.68 3.714v1.22q0 1.368-.86 2.324T17.41 17a2.7 2.7 0 01-1.537-.443 3.14 3.14 0 01-1.057-1.18 4.6 4.6 0 01-1.325 1.178q-.759.445-1.8.445-1.713 0-2.915-1.313-1.202-1.314-1.202-3.187t1.202-3.187T11.691 8q1.715 0 2.916 1.313 1.201 1.314 1.202 3.187v1.22q0 .79.473 1.286.473.495 1.128.494.654 0 1.127-.494.474-.495.474-1.287V12.5q0-3.275-2.162-5.638Q14.69 4.5 11.691 4.5q-2.995 0-5.157 2.362T4.372 12.5t2.162 5.637q2.16 2.363 5.158 2.363h3.888q.291 0 .489.215a.76.76 0 01.197.535.76.76 0 01-.197.535.64.64 0 01-.49.215zm0-6.5q1.143 0 1.944-.875t.8-2.125-.8-2.125q-.801-.875-1.944-.875-1.144 0-1.945.875-.8.875-.8 2.125t.8 2.125 1.944.875"/></g></g>', width: 24, height: 24 }, android: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.23 11.673q.144-1.649 1.012-3.032a6.4 6.4 0 012.313-2.198L3.418 4.476a.34.34 0 01-.047-.294.4.4 0 01.2-.234.34.34 0 01.281-.03.45.45 0 01.24.185L5.23 6.075A7.1 7.1 0 018 5.52q1.446 0 2.769.555l1.138-1.972a.45.45 0 01.24-.185.34.34 0 01.28.03q.154.083.202.234.045.15-.047.294l-1.138 1.967a6.4 6.4 0 012.313 2.198 6.7 6.7 0 011.012 3.032zm3.694-1.692a.74.74 0 00.546-.223.75.75 0 00.222-.547.74.74 0 00-.223-.546.75.75 0 00-.547-.222.74.74 0 00-.546.223.75.75 0 00-.222.547.74.74 0 00.223.546.75.75 0 00.547.222m6.154 0a.74.74 0 00.545-.223.75.75 0 00.223-.547.74.74 0 00-.224-.546.75.75 0 00-.546-.222.74.74 0 00-.546.223.75.75 0 00-.223.547.74.74 0 00.224.546.75.75 0 00.547.222"/></g>' }, "angle-bottom": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 11.212a.8.8 0 01-.281-.047.65.65 0 01-.244-.159L5.006 7.537a.67.67 0 01-.196-.516.73.73 0 01.215-.515.7.7 0 01.525-.206q.32 0 .525.206L9 9.431l2.944-2.944a.67.67 0 01.516-.197.73.73 0 01.515.216.7.7 0 01.206.525.7.7 0 01-.206.525l-3.45 3.45a.65.65 0 01-.244.16.8.8 0 01-.281.046"/></g>', width: 18, height: 18 }, "angle-bottom-large": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 18V0h18v18z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m15.703 6.526-6.228 6.24a.62.62 0 01-.475.192.62.62 0 01-.474-.192L2.279 6.519A.7.7 0 012.067 6q0-.307.23-.538a.72.72 0 01.527-.224.72.72 0 01.527.224L9 11.112l5.656-5.657a.73.73 0 011.046.019.72.72 0 01.223.526.72.72 0 01-.223.526"/></g>', width: 18, height: 18 }, "angle-left": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m11.23 14.27-3.75-3.75a.7.7 0 01-.157-.24.78.78 0 010-.562.7.7 0 01.156-.239l3.75-3.75a.6.6 0 01.438-.187.6.6 0 01.437.187.6.6 0 01.188.438.6.6 0 01-.188.437L8.708 10l3.396 3.396a.6.6 0 01.188.437.6.6 0 01-.188.438.6.6 0 01-.437.187.6.6 0 01-.438-.187"/></g>', width: 20, height: 20 }, "angle-right": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M20 0H0v20h20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m8.77 14.27 3.75-3.75q.105-.104.157-.24a.78.78 0 000-.562.7.7 0 00-.156-.239l-3.75-3.75a.6.6 0 00-.438-.187.6.6 0 00-.437.187.6.6 0 00-.188.438.6.6 0 00.188.437L11.29 10l-3.395 3.396a.6.6 0 00-.188.437.6.6 0 00.188.438.6.6 0 00.437.187.6.6 0 00.438-.187"/></g>', width: 20, height: 20 }, "angle-right-large": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M18 18H0V0h18z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m6.526 2.298 6.24 6.228a.62.62 0 01.191.474.62.62 0 01-.192.475L6.52 15.72a.7.7 0 01-.52.212.74.74 0 01-.537-.23.72.72 0 01-.224-.527.72.72 0 01.224-.526L11.112 9 5.454 3.343a.73.73 0 01.019-1.046A.72.72 0 016 2.075a.72.72 0 01.526.224"/></g>', width: 18, height: 18 }, "angle-top": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M18 18H0V0h18z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 6.788q.15 0 .281.047a.65.65 0 01.244.159l3.469 3.469q.206.206.196.516a.73.73 0 01-.215.515.7.7 0 01-.525.206.7.7 0 01-.525-.206L9 8.569l-2.944 2.944a.67.67 0 01-.516.197.73.73 0 01-.515-.216.7.7 0 01-.206-.525q0-.32.206-.525l3.45-3.45a.65.65 0 01.244-.16A.8.8 0 019 6.789"/></g>', width: 18, height: 18 }, "api-key": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.25 10.219q-.507 0-.862-.356A1.18 1.18 0 014.03 9q0-.506.357-.863.355-.356.862-.356t.862.356q.357.357.357.863t-.357.863a1.18 1.18 0 01-.862.356m0 2.906q-1.725 0-2.925-1.2T1.125 9t1.2-2.925 2.925-1.2q1.2 0 2.175.619.975.618 1.5 1.631h6.469q.131 0 .253.046a.7.7 0 01.234.16l1.181 1.2a.53.53 0 01.16.215.7.7 0 010 .507.5.5 0 01-.16.216l-1.968 1.987q-.094.075-.207.132a.8.8 0 01-.243.075 1 1 0 01-.225-.029.6.6 0 01-.225-.122l-.919-.693-1.05.787a1.3 1.3 0 01-.187.094.6.6 0 01-.207.038.7.7 0 01-.206-.038.7.7 0 01-.187-.094l-1.07-.731H8.926a4.3 4.3 0 01-1.5 1.622 3.93 3.93 0 01-2.175.628m0-1.125q1.087 0 1.875-.656a3.03 3.03 0 001.03-1.594h2.569l1.088.75 1.462-1.069 1.275.975L15.956 9l-.75-.75h-7.05a3.03 3.03 0 00-1.031-1.594Q6.337 6 5.25 6q-1.237 0-2.119.881A2.9 2.9 0 002.25 9q0 1.237.881 2.119A2.9 2.9 0 005.25 12"/></g>', width: 18, height: 18 }, apple: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.86 5.158q-.338.095-.947.147.027-1.29.71-2.224.673-.927 2.273-1.281.01.026.023.095a1 1 0 00.024.095q0 .034.005.087l.003.087q0 .528-.264 1.176-.271.649-.845 1.194-.492.467-.983.624m4.074 6.066a3.2 3.2 0 01-.627-1.93q0-.979.59-1.79.32-.443 1.038-1.023a4.6 4.6 0 00-.946-.865 3.46 3.46 0 00-1.939-.562q-.645 0-1.572.293-.892.296-1.301.295-.309 0-1.255-.26-.955-.26-1.61-.259-1.565 0-2.585 1.246Q2.7 7.633 2.7 9.605q0 2.095 1.338 4.354 1.355 2.24 2.737 2.24.464 0 1.2-.293.738-.286 1.293-.286.591 0 1.373.277.827.276 1.274.277 1.164 0 2.338-1.696.763-1.082 1.119-2.163-.811-.234-1.438-1.091"/></g>', width: 18, height: 18 }, apps: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.5 14.719q-.507 0-.862-.356a1.18 1.18 0 01-.357-.863q0-.506.357-.863.355-.356.862-.356t.862.356q.357.356.357.863 0 .506-.357.863a1.18 1.18 0 01-.862.356m4.5 0q-.506 0-.863-.356a1.18 1.18 0 01-.356-.863q0-.506.356-.863.357-.356.863-.356t.863.356.356.863-.356.863a1.18 1.18 0 01-.863.356m4.5 0q-.506 0-.863-.356a1.18 1.18 0 01-.356-.863q0-.506.356-.863.356-.356.863-.356.506 0 .863.356.356.356.356.863 0 .506-.356.863a1.18 1.18 0 01-.863.356m-9-4.5q-.507 0-.862-.356A1.18 1.18 0 013.28 9q0-.506.357-.863.355-.356.862-.356t.862.356q.357.357.357.863t-.357.863a1.18 1.18 0 01-.862.356m4.5 0q-.506 0-.863-.356A1.18 1.18 0 017.781 9q0-.506.356-.863.357-.356.863-.356t.863.356.356.863-.356.863a1.18 1.18 0 01-.863.356m4.5 0q-.506 0-.863-.356A1.18 1.18 0 0112.282 9q0-.506.356-.863.356-.356.863-.356.506 0 .863.356.356.357.356.863t-.356.863a1.18 1.18 0 01-.863.356m-9-4.5q-.507 0-.862-.357A1.18 1.18 0 013.28 4.5q0-.507.357-.862.355-.357.862-.357t.862.357q.357.355.357.862t-.357.862a1.18 1.18 0 01-.862.357m4.5 0q-.506 0-.863-.357A1.18 1.18 0 017.78 4.5q0-.507.356-.862.357-.357.863-.357t.863.357.356.862-.356.862A1.18 1.18 0 019 5.72m4.5 0q-.506 0-.863-.357a1.18 1.18 0 01-.356-.862q0-.507.356-.862.356-.357.863-.357.506 0 .863.357.356.355.356.862t-.356.862a1.18 1.18 0 01-.863.357"/></g>', width: 18, height: 18 }, "arrow-back": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="m10.875 19.3-6.6-6.6a.9.9 0 01-.213-.325A1.1 1.1 0 014 12q0-.2.063-.375a.9.9 0 01.212-.325l6.6-6.6a.98.98 0 01.688-.287.93.93 0 01.712.287q.3.275.313.688a.93.93 0 01-.288.712L7.4 11h11.175q.424 0 .713.288.287.287.287.712 0 .424-.287.713a.97.97 0 01-.713.287H7.4l4.9 4.9q.275.275.287.7a.87.87 0 01-.287.7q-.275.3-.7.3a1 1 0 01-.725-.3"/></g></g>', width: 24, height: 24 }, "arrow-backward": { body: '<path fill="currentColor" d="M3.692 8.007c0-.242.093-.484.268-.681L10.497.33a1.07 1.07 0 011.468-.072.996.996 0 01.074 1.426l-5.9 6.314 5.9 6.314a.99.99 0 01-.074 1.427 1.06 1.06 0 01-1.468-.072L3.96 8.67a.95.95 0 01-.268-.664"/>' }, "arrow-down": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M20 20H0V0h20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m10 11.289 3.394-3.395a.6.6 0 01.435-.177.6.6 0 01.443.177q.18.181.181.44 0 .257-.18.438l-3.746 3.746a.72.72 0 01-.527.225.72.72 0 01-.528-.225L5.727 8.772a.6.6 0 01-.177-.435.6.6 0 01.177-.443.6.6 0 01.44-.18q.257 0 .438.18z"/></g>', width: 20, height: 20 }, "arrow-downward": { body: '<path fill="currentColor" d="M8 13.15a.58.58 0 01-.4-.166L3.017 8.4A.55.55 0 012.85 8q0-.234.167-.4a.6.6 0 01.408-.167q.224 0 .392.167l3.616 3.616V3.184q0-.234.167-.4a.55.55 0 01.4-.167q.25 0 .408.167a.56.56 0 01.159.4v8.033l3.616-3.616a.54.54 0 01.392-.167q.225 0 .408.167a.55.55 0 01.167.4.55.55 0 01-.167.4L8.4 12.984a1 1 0 01-.192.125.5.5 0 01-.208.041"/>' }, "arrow-downward-alt": { body: '<path fill="currentColor" d="M5 6.864V1a.48.48 0 00-.144-.356A.48.48 0 004.5.5a.48.48 0 00-.356.144A.48.48 0 004 1v5.864L1.785 4.65a.48.48 0 00-.349-.142.47.47 0 00-.354.142.48.48 0 00-.145.35q0 .207.145.351l2.996 2.997q.18.18.422.18.24 0 .422-.18L7.918 5.35a.48.48 0 00.142-.348.47.47 0 00-.142-.354.48.48 0 00-.351-.145.48.48 0 00-.352.145z"/>', width: 9, height: 9 }, "arrow-downward-filled": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M16 0v16H0V0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.373 7.488q-.392-.39-.177-.9.214-.508.77-.508h4.067q.557 0 .771.508.214.51-.177.9L8.58 9.535a.9.9 0 01-.272.189.8.8 0 01-.308.06.8.8 0 01-.308-.06.9.9 0 01-.272-.189z"/></g>' }, "arrow-forward": { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M12.308 7.993c0 .242-.092.484-.268.681L5.503 15.67a1.07 1.07 0 01-1.467.072.996.996 0 01-.074-1.426l5.9-6.314-5.9-6.314A.99.99 0 014.036.26a1.06 1.06 0 011.467.072L12.04 7.33c.176.18.268.422.268.664"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, "arrow-forward-alt": { body: '<path fill="currentColor" d="M6.65 11.346a.52.52 0 01-.131-.357q0-.212.131-.343l3.15-3.15H2.785a.5.5 0 01-.35-.139A.47.47 0 012.29 7a.47.47 0 01.145-.357.5.5 0 01.35-.139H9.8l-3.15-3.15a.47.47 0 01-.131-.35q0-.219.131-.364a.52.52 0 01.357-.132q.212 0 .343.132l4.01 4.01a.8.8 0 01.11.168.45.45 0 010 .357.7.7 0 01-.11.175l-4.01 4.01a.44.44 0 01-.343.124.54.54 0 01-.357-.138"/>', width: 14, height: 14 }, "arrow-left-alt": { body: '<path fill="currentColor" d="m2.291 4.5 2.195 2.195q.15.149.147.348a.5.5 0 01-.147.354.5.5 0 01-.356.16.47.47 0 01-.357-.15L.787 4.422A.58.58 0 01.607 4q0-.24.18-.422L3.773.592q.15-.148.353-.147a.5.5 0 01.36.157q.146.155.15.352a.47.47 0 01-.15.351L2.29 3.5h7.844q.213 0 .356.143a.48.48 0 01.144.357q0 .212-.144.356a.48.48 0 01-.356.144z"/>', width: 11, height: 8 }, "arrow-right-long": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M18.775 13.75H4a.726.726 0 01-.75-.75.73.73 0 01.75-.75h14.775l-1.825-1.825a.77.77 0 01-.2-.525q0-.3.25-.525a.65.65 0 01.512-.225q.313 0 .538.225l2.975 3q.125.126.2.287.075.165.05.338 0 .176-.062.337a.8.8 0 01-.188.288l-3 3a.72.72 0 01-.525.225.72.72 0 01-.525-.225.72.72 0 01-.225-.525q0-.3.2-.525z"/></g>', width: 24, height: 24 }, "arrow-upward": { body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" d="m40.039 13.17.004 25.793m0 .037v28M12 39l24.288-24.287a5.25 5.25 0 017.424 0L68 39"/>', width: 80, height: 80 }, "arrow-upward-alt": { body: '<path fill="currentColor" d="m5 2.405 2.215 2.216q.14.139.349.141a.47.47 0 00.354-.141.48.48 0 00.145-.352.48.48 0 00-.145-.35L4.922.921A.58.58 0 004.5.742q-.24 0-.422.18L1.082 3.918a.48.48 0 00-.142.348.47.47 0 00.142.355.48.48 0 00.351.145.48.48 0 00.352-.145L4 2.405V8.27q0 .213.144.357a.48.48 0 00.356.143q.212 0 .356-.143A.48.48 0 005 8.269z"/>', width: 9, height: 9 }, "arrow-upwardthick": { body: '<path fill="currentColor" d="M8 13.383a.54.54 0 01-.408-.167.56.56 0 01-.159-.4V4.783L3.817 8.4a.54.54 0 01-.392.166.6.6 0 01-.408-.166.55.55 0 01-.167-.4q0-.234.167-.4L7.6 3.016A.58.58 0 018 2.85q.117 0 .208.042.092.042.192.125L12.983 7.6a.55.55 0 01.167.4.55.55 0 01-.167.4.55.55 0 01-.4.166.55.55 0 01-.4-.166L8.567 4.783v8.033a.55.55 0 01-.167.4.55.55 0 01-.4.167"/>' }, article: { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.275 11.667a.9.9 0 01-.672-.27.9.9 0 01-.27-.673V3.276q0-.403.27-.673t.672-.27h7.449q.402 0 .673.27.27.27.27.673v7.448q0 .403-.27.673a.9.9 0 01-.673.27zm0-.584h7.449q.135 0 .247-.112a.34.34 0 00.112-.247V3.276a.34.34 0 00-.112-.247.34.34 0 00-.247-.112H3.275a.34.34 0 00-.247.112.34.34 0 00-.112.247v7.448q0 .135.112.247a.34.34 0 00.247.112m1.391-1.458h2.917a.28.28 0 00.208-.084.28.28 0 00.084-.208.28.28 0 00-.084-.208.28.28 0 00-.208-.083H4.666a.28.28 0 00-.208.083.28.28 0 00-.083.208q0 .125.083.208a.28.28 0 00.208.084m0-2.333h4.667a.28.28 0 00.208-.084A.28.28 0 009.625 7a.28.28 0 00-.084-.208.28.28 0 00-.208-.084H4.666a.28.28 0 00-.208.084.28.28 0 00-.083.208q0 .124.083.208a.28.28 0 00.208.084m0-2.334h4.667a.28.28 0 00.208-.083.28.28 0 00.084-.208.28.28 0 00-.084-.208.28.28 0 00-.208-.084H4.666a.28.28 0 00-.208.084.28.28 0 00-.083.208q0 .124.083.208a.28.28 0 00.208.083"/></g>', width: 14, height: 14 }, attachments: { body: '<path fill="currentColor" d="M3.502 12.794q-1.107-1.107-1.13-2.651-.025-1.545 1.083-2.652l5.103-5.103a2.54 2.54 0 011.88-.772q1.102.006 1.891.796.79.79.79 1.885 0 1.096-.79 1.886L7.663 10.85a1.55 1.55 0 01-1.108.471 1.5 1.5 0 01-1.12-.46A1.44 1.44 0 015 9.718a1.7 1.7 0 01.507-1.143l4.372-4.372a.38.38 0 01.265-.112.36.36 0 01.277.112q.106.106.1.265a.38.38 0 01-.111.265L6 9.141a.83.83 0 00-.253.595.77.77 0 00.23.583q.234.236.577.236t.577-.236l4.679-4.678q.566-.566.56-1.35a1.86 1.86 0 00-.572-1.35 1.86 1.86 0 00-1.35-.57 1.82 1.82 0 00-1.349.56L3.974 8.056q-.872.871-.843 2.092.03 1.22.914 2.103.896.896 2.115.913t2.104-.866l4.855-4.855a.37.37 0 01.271-.106q.165 0 .271.106.106.105.106.27t-.106.272L8.818 12.83q-1.109 1.107-2.658 1.09-1.55-.018-2.658-1.126"/>', width: 17 }, "atto-stop": { body: '<path fill="currentColor" d="M7 9.712q1.137 0 1.925-.787.787-.788.787-1.925t-.787-1.925T7 4.287t-1.925.788T4.287 7t.788 1.925T7 9.712m0 3.209a5.8 5.8 0 01-2.297-.467 6 6 0 01-1.888-1.269 6 6 0 01-1.27-1.888A5.8 5.8 0 011.08 7q0-1.21.467-2.297a6 6 0 011.269-1.888 6 6 0 011.888-1.27A5.8 5.8 0 017 1.08q1.21 0 2.297.467a6 6 0 011.888 1.269 6 6 0 011.27 1.888Q12.92 5.79 12.92 7t-.467 2.297a6 6 0 01-1.269 1.888 6 6 0 01-1.88 1.27A5.7 5.7 0 017 12.92m0-.992q2.026 0 3.478-1.444Q11.928 9.042 11.93 7q0-2.026-1.45-3.478Q9.026 2.07 6.998 2.07q-2.026 0-3.477 1.45Q2.07 4.974 2.07 7q0 2.042 1.45 3.485Q4.974 11.93 7 11.93"/>', width: 14, height: 14 }, "auto-awesome-mosaic": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.333 13.667H3.538q-.506 0-.855-.35a1.16 1.16 0 01-.35-.856V3.538q0-.504.35-.855.35-.35.855-.35h3.795zm-1-1V3.333H3.538a.2.2 0 00-.147.058.2.2 0 00-.058.147v8.923q0 .09.058.148a.2.2 0 00.147.058zm2.333-5.334v-5h3.795q.505 0 .855.35.35.351.35.855v3.795zm1-1h3V3.538a.2.2 0 00-.057-.147.2.2 0 00-.148-.058H9.666zm-1 7.334v-5h5v3.794q0 .505-.35.856-.35.35-.855.35zm1-1h2.795a.2.2 0 00.148-.058.2.2 0 00.057-.148V9.667h-3z"/></g>' }, "auto-fix": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m16.474 5.69-.695-1.501-1.5-.695 1.5-.696.695-1.5.695 1.5 1.5.696-1.5.695zm-9.375 0-.695-1.501-1.5-.695 1.5-.696.695-1.5.696 1.5 1.5.696-1.5.695zm9.375 9.374-.695-1.5-1.5-.695 1.5-.696.695-1.5.695 1.5 1.5.696-1.5.695zM4.282 17.57l-1.885-1.884a.73.73 0 01-.218-.534q0-.312.218-.53l8.86-8.843a.73.73 0 01.533-.218q.312 0 .53.218l1.885 1.884a.73.73 0 01.218.534.72.72 0 01-.218.53L5.346 17.57a.73.73 0 01-.533.218.72.72 0 01-.531-.218m.545-1.237 5.974-6-1.166-1.166-6 5.974z"/></g>', width: 20, height: 20 }, "auto-mode": { body: '<g fill="none"><mask id="svgID0" width="32" height="32" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h32v32H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="m14.19 17.81-2.831-1.261a.55.55 0 01-.361-.549q0-.394.361-.549l2.83-1.295 1.262-2.81a.55.55 0 01.549-.361q.395 0 .549.361l1.295 2.81 2.81 1.295a.55.55 0 01.361.55q0 .393-.361.548l-2.81 1.261-1.295 2.831a.55.55 0 01-.549.362.55.55 0 01-.549-.362zM4 23.054v3.28a.97.97 0 01-.287.712.97.97 0 01-.713.287.97.97 0 01-.713-.287.97.97 0 01-.287-.713V20.95q0-.515.345-.86t.86-.345h5.372q.425 0 .713.287.287.287.287.713a.97.97 0 01-.287.712.97.97 0 01-.713.288h-3.01q1.623 2.91 4.387 4.583T16 28q3.608 0 6.558-1.967a11.9 11.9 0 004.38-5.218q.21-.45.572-.72t.854-.162q.459.108.591.53t-.078.914q-1.62 3.892-5.097 6.258T16 30q-3.741 0-6.885-1.823Q5.973 26.354 4 23.054m-.913-8.387a.82.82 0 01-.68-.327.94.94 0 01-.179-.765q.308-1.593.854-2.929t1.472-2.682q.255-.385.661-.451.406-.067.736.264.352.351.345.767-.006.415-.283.84A10.2 10.2 0 004.94 11.4q-.391 1.008-.67 2.208-.109.459-.416.759t-.767.3m11.58-11.575q0 .48-.294.777-.294.299-.786.393-1.192.232-2.177.657a12 12 0 00-1.992 1.107q-.405.277-.82.256-.416-.02-.767-.372-.297-.31-.248-.698.05-.39.402-.666a15.2 15.2 0 012.64-1.461q1.316-.556 2.921-.844.46-.074.79.176t.33.675m9.53 2.831q-.351.351-.776.355t-.831-.286a9.8 9.8 0 00-1.99-1.08 14 14 0 00-2.208-.65 1.4 1.4 0 01-.765-.403 1.07 1.07 0 01-.294-.767q0-.425.314-.675t.753-.176q1.626.288 2.945.833 1.32.547 2.665 1.472.365.257.431.662t-.244.715m4.71 8.744q-.479 0-.77-.3t-.399-.793q-.266-1.212-.668-2.21a9.6 9.6 0 00-1.121-2 1.3 1.3 0 01-.263-.808q.015-.415.365-.766.31-.31.699-.25t.665.411a13.5 13.5 0 011.504 2.666q.553 1.332.84 2.957.075.452-.17.772-.243.32-.681.32"/></g></g>', width: 32, height: 32 }, "auto-stories": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M11.98 19.002a1.76 1.76 0 01-.862-.227 9 9 0 00-2.22-.955A9 9 0 006.5 17.5a8 8 0 00-3.5.8.99.99 0 01-1.017-.073 1.02 1.02 0 01-.483-.904V6.485q0-.324.171-.598a1 1 0 01.475-.399 9.7 9.7 0 012.117-.741Q5.363 4.5 6.5 4.5q1.46 0 2.842.413 1.383.414 2.658 1.164V17.56a9.7 9.7 0 012.67-1.18 10.8 10.8 0 014.458-.26q.766.12 1.584.383.105.028.197.005.09-.025.091-.16V5.12q.26.076.507.171t.481.237q.256.125.384.365t.128.516v10.896q0 .585-.497.899-.498.314-1.06.078a8 8 0 00-1.679-.583A8 8 0 0017.5 17.5a9.2 9.2 0 00-2.426.32 9 9 0 00-2.241.955 1.8 1.8 0 01-.852.227m2.787-4.694q-.23.205-.499.082a.435.435 0 01-.268-.429v-7.77q0-.042.14-.331l4.077-4.077q.231-.231.507-.111t.276.441v8.181q0 .09-.156.346zM10.5 16.836V6.985a10 10 0 00-1.948-.726A8.2 8.2 0 006.5 6q-.925 0-1.757.171a8.5 8.5 0 00-1.56.472.4.4 0 00-.13.082.18.18 0 00-.053.13v9.53q0 .135.091.16.092.023.197-.015a8.7 8.7 0 011.526-.398A10 10 0 016.5 16q1.121 0 2.142.232t1.858.604"/></g></g>', width: 24, height: 24 }, "autoheal-warning": { body: '<mask id="svgID0" width="18" height="19" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .857h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 12.569a.6.6 0 00.432-.174.6.6 0 00.174-.432.6.6 0 00-.174-.432.6.6 0 00-.432-.174.6.6 0 00-.432.174.6.6 0 00-.174.432q0 .258.174.432.175.174.432.174m0-2.553q.24 0 .4-.162a.55.55 0 00.162-.4V6.957a.54.54 0 00-.161-.4A.55.55 0 009 6.395a.54.54 0 00-.4.161.55.55 0 00-.162.401v2.495q0 .24.161.401a.55.55 0 00.401.162m0 6.87a1.4 1.4 0 01-.447-.076q-2.373-.844-3.775-2.991-1.403-2.149-1.403-4.637V5.804q0-.427.246-.769a1.4 1.4 0 01.635-.496l4.27-1.593q.24-.087.474-.087t.475.087l4.269 1.593a1.4 1.4 0 01.635.496q.246.341.246.77v3.377q0 2.488-1.403 4.637-1.402 2.148-3.775 2.991a1.3 1.3 0 01-.447.075"/></g>', width: 18, height: 19 }, autoplay: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6.5 10.14V5.86q0-.18.156-.268a.28.28 0 01.31.017l3.331 2.133a.3.3 0 01.138.258q0 .164-.138.258L6.965 10.39a.28.28 0 01-.31.017.29.29 0 01-.155-.268M2 11.527v1.64q0 .213-.144.356a.48.48 0 01-.356.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356v-2.693q0-.257.172-.43a.58.58 0 01.43-.172h2.686q.213 0 .357.143a.48.48 0 01.143.357q0 .212-.143.356a.48.48 0 01-.357.144H2.783a6.1 6.1 0 002.194 2.291A5.73 5.73 0 008 14a5.8 5.8 0 003.279-.983 5.96 5.96 0 002.19-2.61q.106-.225.286-.36a.5.5 0 01.427-.08.38.38 0 01.296.264q.066.211-.04.457a6.93 6.93 0 01-2.548 3.13Q10.15 15 8 15a6.74 6.74 0 01-3.442-.912Q2.987 13.178 2 11.527m-.456-4.194a.41.41 0 01-.34-.163.47.47 0 01-.09-.383q.154-.796.427-1.464t.736-1.34a.48.48 0 01.33-.227q.203-.033.369.132a.52.52 0 01.172.384.8.8 0 01-.142.42A5 5 0 002.47 5.7q-.195.504-.335 1.104a.76.76 0 01-.208.38q-.154.15-.383.15m5.79-5.787a.53.53 0 01-.147.389.73.73 0 01-.393.196q-.596.116-1.089.329-.492.211-.996.553a.66.66 0 01-.41.128.58.58 0 01-.384-.186.41.41 0 01-.123-.35.5.5 0 01.2-.332 7.6 7.6 0 011.32-.73 6.8 6.8 0 011.461-.422.5.5 0 01.395.087q.165.126.165.338m4.765 1.416a.55.55 0 01-.389.177.7.7 0 01-.415-.143 5 5 0 00-.995-.54 7 7 0 00-1.104-.325.7.7 0 01-.383-.202.53.53 0 01-.146-.383q0-.212.157-.338a.46.46 0 01.376-.087 7 7 0 011.472.416q.66.274 1.333.736a.5.5 0 01.215.33.4.4 0 01-.121.359m2.355 4.371a.5.5 0 01-.385-.15.8.8 0 01-.2-.396 7 7 0 00-.334-1.105 4.8 4.8 0 00-.56-1 .65.65 0 01-.132-.404.56.56 0 01.183-.383.39.39 0 01.349-.125q.194.03.333.206.475.666.752 1.332.276.666.42 1.48a.48.48 0 01-.085.385.4.4 0 01-.341.16"/></g></g>' }, "back-space": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m6.358 12.75 3.323 3.323q.208.207.212.522a.7.7 0 01-.212.532.72.72 0 01-.527.217.72.72 0 01-.527-.217l-4.494-4.495A.83.83 0 013.877 12q0-.18.058-.337a.8.8 0 01.198-.296l4.494-4.494a.73.73 0 01.522-.213.7.7 0 01.532.213q.217.217.217.527a.72.72 0 01-.217.527L6.358 11.25H19.75q.32 0 .535.215A.73.73 0 0120.5 12a.73.73 0 01-.215.534.73.73 0 01-.535.216z"/></g>', width: 24, height: 24 }, backup: { body: '<mask id="svgID0" width="21" height="21" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.333.167h20v20h-20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.8 16.265q-1.679 0-2.864-1.167-1.185-1.166-1.185-2.86 0-1.509.991-2.654.99-1.145 2.437-1.34A5.04 5.04 0 017 5.24a5.16 5.16 0 013.332-1.171q2.21 0 3.746 1.539t1.536 3.733v.477h.257a3.02 3.02 0 012.163.993q.88.94.88 2.219 0 1.35-.932 2.294-.933.942-2.274.942h-4.535a1.37 1.37 0 01-1.009-.415 1.38 1.38 0 01-.413-1.007V10.25L8.2 11.784l-.817-.809 2.95-2.96 2.96 2.96-.816.81-1.559-1.534v4.592q0 .096.078.176.079.08.178.08h4.518q.863 0 1.46-.595.597-.594.597-1.466 0-.87-.598-1.462a2 2 0 00-1.464-.592h-1.238V9.35q0-1.709-1.203-2.912-1.205-1.204-2.912-1.204-1.709 0-2.912 1.204Q6.218 7.64 6.218 9.35h-.431q-1.176 0-2.023.834a2.75 2.75 0 00-.847 2.032q0 1.198.843 2.04a2.78 2.78 0 002.04.843h2.161v1.166z"/></g>', width: 21, height: 21 }, "backup-restore": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.984 17.083q-2.513 0-4.433-1.537-1.92-1.538-2.461-3.921a.5.5 0 01.09-.457.6.6 0 01.423-.242.64.64 0 01.454.101q.203.135.283.396a5.66 5.66 0 002.05 3.17 5.65 5.65 0 003.594 1.24q2.438 0 4.135-1.698 1.698-1.698 1.698-4.135 0-2.438-1.698-4.136T9.984 4.166q-1.365 0-2.56.607a6.3 6.3 0 00-2.055 1.67h1.554q.266 0 .445.179.18.18.18.445 0 .266-.18.446a.6.6 0 01-.445.18H4.071a.73.73 0 01-.537-.217.73.73 0 01-.217-.537V4.086q0-.265.18-.445t.446-.18.445.18.18.445v1.35a7.1 7.1 0 012.429-1.858 7 7 0 012.987-.661 6.9 6.9 0 012.763.557 7.2 7.2 0 012.247 1.516 7.2 7.2 0 011.516 2.247q.557 1.288.557 2.762a6.9 6.9 0 01-.557 2.764 7.2 7.2 0 01-1.516 2.246 7.2 7.2 0 01-2.247 1.516 6.9 6.9 0 01-2.763.558m0-5.833q-.51 0-.88-.37a1.2 1.2 0 01-.37-.88q0-.512.37-.88.37-.37.88-.37t.88.37.37.88-.37.88-.88.37"/></g>', width: 20, height: 20 }, badge: { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M5.128 14.76h4.744v-.247q0-.32-.177-.59a1.17 1.17 0 00-.493-.423 4.2 4.2 0 00-1.702-.359 4.2 4.2 0 00-1.702.36q-.316.15-.493.421a1.06 1.06 0 00-.177.591zm7.036-1.266h2.34a.483.483 0 00.496-.497.483.483 0 00-.497-.497h-2.34a.483.483 0 00-.496.497.483.483 0 00.497.497M7.498 12.5q.466 0 .795-.326.33-.327.329-.794 0-.466-.327-.795a1.08 1.08 0 00-.793-.328q-.466 0-.795.326a1.08 1.08 0 00-.329.793q0 .468.327.796t.793.328m4.666-1.25h2.34a.483.483 0 00.496-.496.483.483 0 00-.497-.497h-2.34a.483.483 0 00-.496.496.483.483 0 00.497.497M3.59 17.917q-.631 0-1.07-.438a1.45 1.45 0 01-.437-1.069V7.757q0-.632.438-1.07A1.45 1.45 0 013.59 6.25h4.327V3.333q0-.515.367-.882.367-.368.883-.368h1.666q.516 0 .883.368.367.367.367.882V6.25h4.327q.631 0 1.07.438.436.437.437 1.069v8.653q0 .632-.438 1.07a1.45 1.45 0 01-1.069.437zm0-1.25h12.82a.25.25 0 00.185-.072.25.25 0 00.072-.185V7.757a.25.25 0 00-.072-.185.25.25 0 00-.185-.072h-4.327v.32q0 .512-.37.881-.368.37-.88.37H9.167q-.512 0-.88-.37a1.2 1.2 0 01-.37-.88V7.5H3.59a.25.25 0 00-.185.071.25.25 0 00-.072.185v8.653a.25.25 0 00.072.185.25.25 0 00.185.072M9.167 7.82h1.666V3.333H9.167z"/></g></g>', width: 20, height: 20 }, ballot: { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M10.625 8.333h2.75A.605.605 0 0014 7.708a.607.607 0 00-.625-.625h-2.75a.607.607 0 00-.625.625.605.605 0 00.625.625m0 4.584h2.75a.605.605 0 00.625-.625.607.607 0 00-.625-.625h-2.75a.606.606 0 00-.625.625.605.605 0 00.625.625M6.917 9.063h1.166a.75.75 0 00.553-.219.75.75 0 00.218-.552V7.125a.75.75 0 00-.218-.552.75.75 0 00-.553-.219H6.917a.75.75 0 00-.771.771v1.167a.75.75 0 00.77.77m0 4.583h1.166a.75.75 0 00.553-.219.75.75 0 00.218-.552v-1.167a.75.75 0 00-.218-.552.75.75 0 00-.553-.219H6.917a.75.75 0 00-.771.771v1.167a.75.75 0 00.77.77m-2.5 3.437q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063V4.417q0-.625.437-1.063a1.45 1.45 0 011.063-.437h11.166q.625 0 1.063.437.437.438.437 1.063v11.166q0 .625-.437 1.063a1.45 1.45 0 01-1.063.437zm0-1.25h11.166q.083 0 .167-.083t.083-.167V4.417q0-.084-.083-.167-.083-.084-.167-.083H4.417q-.084 0-.167.083-.084.083-.083.167v11.166q0 .083.083.167t.167.083"/></g></g>', width: 20, height: 20 }, "bar-graph": { body: '<g fill="currentColor"><path d="M9.88.733a7.32 7.32 0 016.44 7.296L9 8z"/><path d="M15.32 9a7.32 7.32 0 11-6.46-7.27L8 9z"/></g>', width: 17, height: 17 }, "bg-ripples": { body: '<g fill="none" stroke="currentColor"><circle cx="-10" cy="-12" r="47.5"/><circle cx="-10" cy="-12" r="47.5"/><circle cx="-10" cy="-12" r="71.5"/><circle cx="-10" cy="-12" r="95.5"/><circle cx="-10" cy="-12" r="119.5"/><circle cx="-10" cy="-12" r="143.5"/><circle cx="-10" cy="-12" r="167.5"/></g>', width: 158, height: 156 }, block: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 17.917a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.687-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.625 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.688 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625m0-1.25q2.792 0 4.73-1.938 1.937-1.937 1.937-4.729a6.6 6.6 0 00-1.542-4.25L5.75 15.125q.895.75 1.99 1.146a6.6 6.6 0 002.26.396M4.875 14.25l9.375-9.375A6.6 6.6 0 0010 3.333q-2.791 0-4.729 1.938Q3.334 7.209 3.334 10q0 1.167.395 2.26.396 1.095 1.146 1.99"/></g>', width: 20, height: 20 }, "blur-off": { body: '<path fill="currentColor" d="M10.588 11.4.72 1.532a.55.55 0 01-.16-.406Q.56.879.72.72a.55.55 0 01.406-.16q.246 0 .406.16l9.868 9.868a.55.55 0 01.16.406.55.55 0 01-.16.406.55.55 0 01-.406.16.55.55 0 01-.406-.16"/>', width: 12, height: 12 }, bolt: { body: '<path fill="currentColor" d="M3.725 17.818a.52.52 0 01-.413-.188.49.49 0 01-.112-.437l.85-6H.95q-.375 0-.45-.187t.125-.513l5.175-9.4q.05-.125.2-.2t.275-.075q.25 0 .413.188.162.187.112.437l-.85 6h3.1q.35 0 .438.187.087.189-.113.513l-5.175 9.4a.4.4 0 01-.2.2.6.6 0 01-.275.075"/>', width: 10, height: 18 }, "brand-logo": { body: '<g fill="currentColor"><path d="M23.507 9.012a1.3 1.3 0 00-.943-.588c-.187-.023-.381-.055-.566-.084-.235-.036-.478-.074-.716-.1-.637-.065-1.028-.33-1.264-.85-.162-.355-.18-.672-.059-.985l.092-.235c.157-.41.322-.837.497-1.25a1.34 1.34 0 00-.039-1.176 2.84 2.84 0 00-1.656-1.438 1.34 1.34 0 00-1.216.158c-.18.117-.368.23-.551.34-.256.155-.52.316-.77.49a1.1 1.1 0 01-.633.188c-.597 0-1.176-.394-1.318-.895a14 14 0 00-.252-.788 17 17 0 01-.22-.662 1.41 1.41 0 00-.914-.962 4 4 0 00-.41-.12c-.055-.016-.116-.032-.172-.049L12.368 0h-.772l-.03.01q-.021.006-.044.016a.4.4 0 01-.061.016c-.788.143-1.26.543-1.435 1.234-.077.304-.186.61-.29.904q-.083.239-.162.476c-.155.471-.714.843-1.273.843-.222 0-.433-.061-.603-.181-.314-.214-.64-.414-.957-.604q-.228-.139-.452-.278a1.18 1.18 0 00-.936-.158c-.868.212-1.504.742-1.895 1.572a1.3 1.3 0 00-.013 1.06q.1.246.197.497c.097.255.197.517.31.772.232.523.207.986-.088 1.447-.2.317-.462.504-.8.569a23 23 0 01-1.558.24 1.39 1.39 0 00-1.069.68 2.97 2.97 0 00-.427 1.829c.049.627.35 1.075.892 1.334.197.094.39.207.582.314.21.119.423.242.65.348.323.149.564.491.642.908.08.433-.029.872-.291 1.14-.365.38-.723.791-1.063 1.218-.155.19-.265.43-.307.659-.158.9.598 2.235 1.445 2.551.209.078.474.1.717.064.455-.07.927-.164 1.44-.29.527-.13.934-.02 1.325.365.293.29.426.604.416.994a85 85 0 01-.048 1.58c-.02.41.123.766.417 1.054.469.458 1.057.73 1.754.804q.116.014.226.013c.53 0 .96-.226 1.267-.672.123-.172.255-.333.397-.504.146-.178.294-.358.43-.552.222-.33.633-.526 1.092-.526.449 0 .856.194 1.085.513.188.265.394.52.592.766q.185.223.362.455c.226.294.533.465.878.498.84.077 1.593-.181 2.232-.766.307-.281.453-.643.43-1.078-.013-.19-.016-.392-.02-.582-.006-.252-.013-.51-.032-.766-.045-.6.143-1.033.585-1.36.293-.213.581-.29.895-.24.565.094 1.07.198 1.544.318.49.12.943.006 1.337-.343a2.95 2.95 0 00.956-1.638c.117-.545-.013-1.017-.384-1.401a11 11 0 01-.424-.475 10 10 0 00-.427-.482c-.406-.419-.52-.852-.367-1.4.103-.386.293-.644.59-.812a40 40 0 011.396-.762c.362-.19.594-.484.688-.875a2.8 2.8 0 00-.402-2.304"/><path d="m11.948 9.142-.003.049-.029.647.558-.241 2.75-1.361a.5.5 0 01.41-.02.54.54 0 01.306.282l.372.809a.56.56 0 01-.252.736l-4.246 2.1-.09 2.004-.01.377v.133c0 .305 0 .36.05.616.028.136.065.165.223.247.173.088.387.143.549.143h.055c.115 0 .22 0 .341-.026.347-.068.56-.15.942-.35a.21.21 0 01.225.022c.065.051.096.14.078.224a9 9 0 00-.105.752l-.004.033a22 22 0 01-.093.737.22.22 0 01-.162.182q-.59.142-.944.182a7 7 0 01-.666.036c-.53 0-.966-.071-1.298-.218a1.67 1.67 0 01-.811-.73c-.183-.327-.276-.768-.276-1.307q0-.108.01-.357c.005-.169.033-.736.086-1.74l.001-.022-1.013.501a.5.5 0 01-.41.02.54.54 0 01-.304-.282l-1.045-2.285a.56.56 0 01.254-.738l.781-.383a.5.5 0 01.41-.021c.134.05.244.152.304.283l.446.974.695-.345.088-1.682v-.007l.084-1.068c.012-.146.017-.207.024-.274.01-.106.021-.226.059-.715.009-.101.074-.189.173-.208.524-.104.973-.205 1.335-.299a.2.2 0 01.183.042c.053.046.08.114.078.182-.018.415-.033.625-.045.78-.012.17-.02.276-.02.515l-.004.05c-.004.055-.01.137-.006.165z"/></g>', width: 24, height: 24 }, "broken-image": { body: '<path fill="currentColor" d="M4.737 48.66q-2.02 0-3.34-1.324t-1.32-3.351V5.335q0-2.025 1.32-3.35T4.737.66h38.526q2.02 0 3.34 1.325t1.32 3.35v38.65q0 2.025-1.32 3.35t-3.34 1.325zm.621-19.324 10.797-10.832q.389-.39.777-.545t.854-.156.854.156q.39.156.777.545l10.797 10.831 10.796-10.83q.39-.39.777-.546.389-.156.855-.156t.854.156.777.545l1.475 1.48V5.336q0-1.09-.699-1.792-.699-.7-1.786-.701H4.737q-1.087 0-1.786.701-.7.702-.7 1.792V26.22zM2.252 43.985q0 1.091.699 1.792t1.786.701h38.526q1.087 0 1.786-.701.7-.702.7-1.792V23.102l-3.108-3.117-10.796 10.831q-.389.39-.777.546a2.3 2.3 0 01-.854.155q-.466 0-.855-.155-.388-.156-.776-.546L17.786 19.985 6.99 30.816q-.39.39-.777.546a2.3 2.3 0 01-.855.155q-.465 0-.854-.155-.388-.156-.777-.546l-1.475-1.48zm0 0v2.493-23.376 2.182V2.842z"/>', width: 48, height: 49 }, "browserstack-logo": { body: '<g fill="currentColor"><path d="M93 186c51.362 0 93-41.638 93-93S144.362 0 93 0C77.715 0 63.292 3.687 50.57 10.22c9.898-4.183 20.779-6.496 32.2-6.496 45.713 0 82.77 37.058 82.77 82.77 0 45.713-37.057 82.77-82.77 82.77-44.655 0-81.05-35.363-82.71-79.612A95 95 0 000 93c0 51.362 41.638 93 93 93"/><path d="M84 163c41.974 0 76-34.026 76-76q0-.915-.021-1.823c-.866 33.588-28.365 60.55-62.161 60.55-34.342 0-62.182-27.84-62.182-62.182s27.84-62.182 62.182-62.182c23.217 0 43.462 12.724 54.142 31.579C139.471 28.069 113.729 11 84 11 42.026 11 8 45.026 8 87s34.026 76 76 76"/><path d="M97.5 141c31.204 0 56.5-25.296 56.5-56.5S128.704 28 97.5 28q-1.77 0-3.51.107c25.038 1.665 44.831 22.501 44.831 47.96 0 26.547-21.521 48.067-48.067 48.067-26.547 0-48.068-21.52-48.068-48.067 0-2.527.195-5.008.571-7.43A56.5 56.5 0 0041 84.5c0 31.204 25.296 56.5 56.5 56.5"/><path d="M133.877 77.797q.122-1.633.123-3.297C134 50.476 114.524 31 90.5 31S47 50.476 47 74.5 66.476 118 90.5 118q1.665 0 3.297-.123c-19.095-1.55-34.11-17.538-34.11-37.033 0-20.521 16.636-37.156 37.157-37.156 19.495 0 35.483 15.014 37.033 34.11"/><path d="M99 110c16.569 0 30-13.431 30-30 0-16.568-13.431-30-30-30-16.568 0-30 13.432-30 30q0 1.153.085 2.283C70.158 69.125 81.176 58.78 94.61 58.78c14.144 0 25.61 11.466 25.61 25.61 0 13.433-10.342 24.45-23.498 25.524q1.128.084 2.278.085"/><path fill-rule="evenodd" d="M95 104c10.493 0 19-8.507 19-19s-8.507-19-19-19-19 8.507-19 19 8.507 19 19 19m1.348-30.485c2.06-4.118 4.633-4.118 5.662-3.604 2.471 1.235 1.888 4.633 1.03 6.178s-3.192 4.427-5.662 3.603c-2.471-.824-1.878-4.48-1.03-6.177" clip-rule="evenodd"/></g>', width: 186, height: 186 }, bug: { body: '<path fill="currentColor" fill-rule="evenodd" d="M1.6 12.806c0 .463.398.838.889.838.49 0 .889-.375.889-.838v-.77c0-.409.348-.737.782-.737h.313a4 4 0 00-.029.479c0 .653.132 1.276.37 1.85l-1.08 1.095c-.203.204-.356.657-.356.931v1.508c0 .463.398.838.889.838.49 0 .888-.375.888-.838v-1.025a.7.7 0 01.128-.405l.545-.547c.682.727 1.46 1.468 2.613 1.763q.038.015.082.023.091.025.188.024c.391 0 .711-.302.711-.67v-5.697c0-.368.32-.67.711-.67s.712.302.712.67v5.697c0 .368.32.67.71.67q.114.001.221-.034l.089-.023c1.102-.288 1.899-1.032 2.574-1.753l.544.547a.7.7 0 01.128.405v1.025c0 .463.398.838.889.838.49 0 .889-.375.889-.838v-1.508c0-.274-.153-.727-.356-.93l-1.08-1.097c.238-.573.37-1.196.37-1.85q0-.247-.03-.478h.314c.433 0 .782.328.782.737v.77c0 .463.398.838.889.838.49 0 .889-.375.889-.838V11.3c0-.925-.797-1.676-1.778-1.676h-1.675c-.16-.281-.341-.553-.526-.824l1.49-1.522c.203-.204.355-.683.355-1.005V4.764c0-.462-.398-.837-.888-.837-.491 0-.89.375-.89.837V5.87c0 .15-.046.288-.127.405l-.957.966c-.398-.73-.693-1.565-.693-2.644 0-1.25-.907-2.299-2.133-2.597v1.592c0 .368-.32.67-.712.67-.39 0-.71-.302-.71-.67V2c-1.228.298-2.134 1.347-2.134 2.597 0 1.076-.299 1.907-.697 2.637l-.953-.958a.7.7 0 01-.128-.406V4.764c0-.462-.398-.837-.889-.837-.49 0-.889.375-.889.837v1.508c0 .322.153.801.356 1.006L5.57 8.792c-.188.272-.366.546-.526.831H3.378c-.981 0-1.778.75-1.778 1.676z" clip-rule="evenodd"/>', width: 20, height: 20 }, "bug-report": { body: '<path fill="currentColor" d="M8 14.1a4.24 4.24 0 01-2.083-.533 3.2 3.2 0 01-1.417-1.55H3.083a.5.5 0 01-.366-.15.5.5 0 01-.15-.367q0-.232.15-.375a.5.5 0 01.366-.142H4.1a3.3 3.3 0 01-.117-.858V9.25H3.05a.48.48 0 01-.35-.15.5.5 0 01-.15-.367q0-.232.15-.375a.5.5 0 01.367-.141h.916q0-.483.009-.942.007-.458.141-.925H3.067a.48.48 0 01-.35-.15.5.5 0 01-.15-.367q0-.233.15-.375a.5.5 0 01.366-.141h1.5q.217-.483.6-.842a3.5 3.5 0 01.867-.592l-.967-.933a.44.44 0 01-.125-.342.5.5 0 01.142-.341q.15-.15.358-.15a.5.5 0 01.359.15l1.216 1.216A2.73 2.73 0 019 3.466l1.233-1.233q.15-.15.342-.141a.5.5 0 01.342.158q.15.134.15.342a.5.5 0 01-.15.358l-.9.9q.483.25.85.633.366.385.616.85h1.467a.46.46 0 01.358.159.52.52 0 01.142.358.486.486 0 01-.5.5h-1.083q.15.467.141.925-.008.459-.008.942h.95q.2 0 .35.15t.15.366q0 .234-.15.375a.5.5 0 01-.367.142H12q0 .45.008.875t-.108.858h1.05q.2 0 .35.15t.15.367q0 .233-.15.375a.5.5 0 01-.367.142h-1.416a3.2 3.2 0 01-1.417 1.55A4.3 4.3 0 018 14.1m0-1.133q1.2 0 2.033-.842a2.8 2.8 0 00.834-2.042V7.367q0-1.2-.834-2.042A2.75 2.75 0 008 4.483q-1.2 0-2.033.842a2.8 2.8 0 00-.834 2.042v2.716q0 1.2.834 2.042A2.75 2.75 0 008 12.967m-.817-2.284h1.65q.2 0 .35-.141.15-.143.15-.375 0-.233-.15-.375a.5.5 0 00-.366-.142h-1.65a.5.5 0 00-.35.142q-.15.142-.15.375 0 .232.15.375.15.141.366.141m0-2.883h1.65q.2 0 .35-.142.15-.141.15-.375 0-.232-.15-.375a.5.5 0 00-.366-.141h-1.65a.5.5 0 00-.35.141q-.15.143-.15.375 0 .234.15.375.15.142.366.142M8 8.733h.008zh.008zh.008zh.008z"/>' }, "bulk-reorder": { body: '<path fill="currentColor" d="M1.333 5.675q0 1.56 1.05 2.662t2.6 1.18h.474l-.933-.94a.6.6 0 01-.177-.436.6.6 0 01.177-.443.6.6 0 01.439-.181q.258 0 .439.18l1.937 1.945q.223.224.22.525a.75.75 0 01-.223.528l-1.934 1.95a.57.57 0 01-.434.18.604.604 0 01-.617-.614q0-.263.173-.444l.958-.975H5.01q-2.075-.076-3.5-1.555T.082 5.688q0-2.135 1.475-3.62T5.163.585h2.084q.265 0 .445.18t.18.445-.18.445a.6.6 0 01-.445.18H5.163q-1.596 0-2.713 1.116T1.333 5.675m8.99 3.867h4.968q.266 0 .446.18t.18.446-.18.445a.6.6 0 01-.446.18h-4.968a.6.6 0 01-.445-.18.6.6 0 01-.18-.446q0-.266.18-.445.18-.18.445-.18m0-4.479h4.968q.266 0 .446.18t.18.445-.18.446a.6.6 0 01-.446.18h-4.968a.6.6 0 01-.445-.18.6.6 0 01-.18-.446q0-.266.18-.445.18-.18.445-.18m0-4.479h4.968q.266 0 .446.18t.18.445-.18.445a.6.6 0 01-.446.18h-4.968a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18"/>', height: 13 }, "burst-mode": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.209 15.417a.606.606 0 01-.625-.625V5.208a.605.605 0 01.625-.625.605.605 0 01.625.625v9.584a.61.61 0 01-.625.625m-3.438 0a.62.62 0 01-.437-.177.6.6 0 01-.188-.448V5.208q0-.27.188-.447a.62.62 0 01.437-.178.61.61 0 01.625.625v9.584a.6.6 0 01-.177.448.6.6 0 01-.448.177m7.75 0q-.625 0-1.062-.438a1.45 1.45 0 01-.438-1.062V6.083q0-.624.438-1.062a1.45 1.45 0 011.062-.438h7.813q.645 0 1.083.438.437.437.437 1.062v7.834q0 .624-.437 1.062a1.47 1.47 0 01-1.084.438zm0-1.25h7.813a.27.27 0 00.198-.073.24.24 0 00.072-.177V6.083a.24.24 0 00-.072-.176.27.27 0 00-.198-.074H9.52a.24.24 0 00-.177.074.24.24 0 00-.073.176v7.834q0 .103.073.177a.24.24 0 00.177.073m1.542-1.771h4.729q.25 0 .365-.209.114-.207-.053-.395l-1.208-1.646a.35.35 0 00-.302-.146.35.35 0 00-.302.146l-1.271 1.687-.875-1.146a.35.35 0 00-.302-.145.34.34 0 00-.302.166l-.813 1.084q-.146.188-.02.395a.39.39 0 00.354.209"/></g>', width: 20, height: 20 }, "button-alt": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.59 14.583q-.631 0-1.069-.438a1.45 1.45 0 01-.437-1.069V6.922q0-.63.437-1.068a1.45 1.45 0 011.069-.438h12.82q.632 0 1.07.438.437.437.437 1.068v6.154q0 .631-.438 1.07a1.45 1.45 0 01-1.069.437zm0-1.25h12.82a.25.25 0 00.185-.072.25.25 0 00.072-.185V6.922a.25.25 0 00-.072-.184.25.25 0 00-.185-.072H3.59a.25.25 0 00-.184.072.25.25 0 00-.073.184v6.154a.25.25 0 00.073.184.25.25 0 00.184.073m2.58-2.837v1.298a.48.48 0 00.497.497.48.48 0 00.497-.497v-1.298h1.298A.48.48 0 008.958 10a.48.48 0 00-.496-.496H7.164v-1.3a.48.48 0 00-.497-.496.48.48 0 00-.497.496v1.299H4.872a.48.48 0 00-.497.496.48.48 0 00.497.497z"/></g>', width: 20, height: 20 }, "calender-month": { body: '<path fill="currentColor" d="M8 9.35a.67.67 0 01-.492-.192.67.67 0 01-.191-.491q0-.3.191-.492A.67.67 0 018 7.983q.3 0 .492.192a.67.67 0 01.191.492q0 .3-.191.491A.67.67 0 018 9.35m-2.667 0a.67.67 0 01-.491-.192.67.67 0 01-.192-.491q0-.3.192-.492a.67.67 0 01.491-.192q.3 0 .492.192a.67.67 0 01.192.492q0 .3-.192.491a.67.67 0 01-.492.192m5.334 0a.67.67 0 01-.484-.192.65.65 0 01-.2-.491q0-.3.2-.492a.67.67 0 01.484-.192.673.673 0 01.683.684q0 .3-.192.491a.67.67 0 01-.491.192M8 12.017a.673.673 0 01-.683-.683q0-.284.191-.484a.65.65 0 01.492-.2q.3 0 .492.192a.67.67 0 01.191.491.673.673 0 01-.683.684m-2.667 0a.673.673 0 01-.683-.683q0-.284.192-.484a.65.65 0 01.491-.2q.3 0 .492.192a.67.67 0 01.192.491.673.673 0 01-.684.684m5.334 0a.66.66 0 01-.484-.2.66.66 0 01-.2-.484q0-.284.2-.483a.66.66 0 01.484-.2.673.673 0 01.683.683.673.673 0 01-.683.684m-7.634 2.75q-.45 0-.791-.342a1.1 1.1 0 01-.342-.792V3.367q0-.468.342-.8a1.1 1.1 0 01.791-.334h1.05V1.8q0-.234.167-.4a.55.55 0 01.4-.167q.25 0 .417.167a.55.55 0 01.166.4v.433h5.534V1.8q0-.234.166-.4a.55.55 0 01.4-.167q.25 0 .417.167a.55.55 0 01.167.4v.433h1.05q.465 0 .8.334.333.332.333.8v10.266q0 .45-.333.792a1.08 1.08 0 01-.8.342zm0-1.134h9.934V6.5H3.033zm0-8.133h9.934V3.367H3.033zm0 0V3.367z"/>' }, cancel: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.562 13.437a.6.6 0 00.438.188.6.6 0 00.437-.188L10 10.875l2.583 2.583a.55.55 0 00.428.156.6.6 0 00.426-.177.6.6 0 00.188-.437.6.6 0 00-.188-.438L10.875 10l2.583-2.583a.54.54 0 00.156-.428.6.6 0 00-.177-.427.6.6 0 00-.437-.187.6.6 0 00-.438.187L10 9.125 7.416 6.542a.55.55 0 00-.426-.157.62.62 0 00-.428.177.6.6 0 00-.187.438.6.6 0 00.187.437L9.125 10 6.54 12.583a.54.54 0 00-.155.427.6.6 0 00.176.427M10 17.917a7.7 7.7 0 01-3.094-.625 8 8 0 01-2.51-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.645 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.687 2.51q.625 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.687 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625"/></g>', width: 20, height: 20 }, "cancel-circle-outline": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.938 8.063a.36.36 0 00.525 0L6 6.525l1.55 1.55a.33.33 0 00.256.094.37.37 0 00.256-.107.36.36 0 000-.524L6.526 6l1.55-1.55a.33.33 0 00.094-.256.37.37 0 00-.107-.256.36.36 0 00-.524 0L6 5.475l-1.55-1.55a.33.33 0 00-.256-.094.37.37 0 00-.256.107.36.36 0 000 .525L5.475 6l-1.55 1.55a.33.33 0 00-.093.256q.006.157.106.256M6 10.75a4.6 4.6 0 01-1.856-.375 4.8 4.8 0 01-1.506-1.012 4.8 4.8 0 01-1.013-1.507A4.6 4.6 0 011.25 6q0-.987.375-1.856a4.8 4.8 0 011.013-1.506 4.8 4.8 0 011.506-1.013A4.6 4.6 0 016 1.25q.987 0 1.856.375.87.374 1.507 1.013.637.637 1.012 1.506T10.75 6t-.375 1.856a4.8 4.8 0 01-1.012 1.507 4.8 4.8 0 01-1.506 1.012q-.87.375-1.857.375M6 10q1.662 0 2.832-1.168Q10 7.662 10 6T8.832 3.169 6 2Q4.338 2 3.169 3.168 1.999 4.339 2 6t1.169 2.832Q4.338 10 6 10"/></g>', width: 12, height: 12 }, category: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.333 8.854q-.437 0-.656-.396a.72.72 0 01.01-.77l2.667-4.355q.23-.375.646-.375t.646.375l2.666 4.355a.72.72 0 01.011.77q-.22.396-.656.396zm7.25 9.167q-1.437 0-2.437-1t-1-2.438 1-2.437 2.437-1 2.438 1 1 2.437-1 2.438-2.438 1m-11.02-.417a.75.75 0 01-.75-.77v-4.521q0-.313.219-.532a.75.75 0 01.551-.218h4.521q.313 0 .532.218a.75.75 0 01.218.552v4.521a.75.75 0 01-.77.75zm11.02-.833q.917 0 1.553-.635.635-.636.635-1.553 0-.915-.635-1.552a2.1 2.1 0 00-1.553-.635 2.1 2.1 0 00-1.551.635 2.1 2.1 0 00-.636 1.552q0 .917.636 1.553.634.635 1.551.635m-10.52-.417h3.541v-3.541H4.063zm4.145-8.75h3.584L10 4.708z"/></g>', width: 20, height: 20 }, "category-rerun": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><mask id="svgID1" width="14" height="14" x="1" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M1 1h14v14H1z"/></mask><g fill="currentColor" mask="url(#svgID1)"><path d="M4.097 13.5q-.436 0-.746-.31a1.02 1.02 0 01-.309-.745V2.888q0-.437.31-.746.309-.309.745-.309h7.808q.435 0 .745.309.31.31.31.746v3.69a4 4 0 00-.876-.259V2.888a.17.17 0 00-.056-.124.17.17 0 00-.123-.056H4.097a.17.17 0 00-.123.056.17.17 0 00-.057.124v9.557q0 .068.057.123a.17.17 0 00.123.057h4a3 3 0 00.253.875zm-.18-.875V2.708v3.611-.044zm1.313-7.25h5.542V4.5H5.23z"/><path d="M10.224 13.337q.795.663 1.86.663 1.21 0 2.063-.853a2.8 2.8 0 00.854-2.064q0-1.21-.854-2.063a2.8 2.8 0 00-2.063-.853q-.598 0-1.123.226a3 3 0 00-.919.605v-.831h-.875V10.5h2.334v-.875h-.846a2 2 0 011.429-.583q.846 0 1.444.598t.598 1.443-.598 1.444-1.444.598q-.7 0-1.232-.408a2 2 0 01-.722-1.05h-.905q.205 1.005 1 1.67M7.771 8H5.23v-.875h2.54zm0 2.5H5.23v-.875h2.54z"/></g></g>' }, chart: { body: '<path fill="currentColor" d="M4.5 9.35h4.233a.486.486 0 00.483-.5.486.486 0 00-.5-.5H4.484a.486.486 0 00-.483.5.486.486 0 00.5.5m0-2.167h7.017a.486.486 0 00.483-.5.486.486 0 00-.5-.5H4.483a.486.486 0 00-.483.5.486.486 0 00.5.5m0-2.166h7.017a.486.486 0 00.483-.5.486.486 0 00-.5-.5H4.483a.486.486 0 00-.483.5.486.486 0 00.5.5M1.233 13.4V2.367q0-.45.342-.792t.792-.342h11.266q.45 0 .792.342t.342.792v8.6q0 .433-.342.783t-.792.35H3.9l-1.7 1.7a.53.53 0 01-.617.125.52.52 0 01-.35-.525m1.134-1.3 1.15-1.133h10.116v-8.6H2.367zm0-9.733V12.1z"/>' }, "chart-data": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m6.966 8.413.912.911q.165.17.418.17.255 0 .425-.17l2.112-2.105v.798a.46.46 0 00.144.345.5.5 0 00.356.138.5.5 0 00.353-.144.48.48 0 00.147-.356V6.103a.58.58 0 00-.176-.427.58.58 0 00-.427-.176H9.316a.46.46 0 00-.345.147.5.5 0 00-.138.353q0 .212.144.356a.48.48 0 00.356.144h.78L8.3 8.337l-.912-.911a.56.56 0 00-.425-.181.54.54 0 00-.418.18L4.582 9.383a.48.48 0 00-.149.355q0 .21.149.348a.47.47 0 00.354.155q.21 0 .348-.155zm-3.428 5.254q-.506 0-.855-.35a1.16 1.16 0 01-.35-.856V3.54q0-.505.35-.856.35-.35.855-.35h8.923q.505 0 .855.35t.35.856v8.923q0 .504-.35.855-.35.35-.855.35zm0-1h8.923a.2.2 0 00.141-.064.2.2 0 00.064-.142V3.54a.2.2 0 00-.064-.142.2.2 0 00-.14-.064H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.142v8.923q0 .076.064.14t.141.065"/></g>' }, chat: { body: '<path fill="currentColor" fill-rule="evenodd" d="M0 5.125A5.125 5.125 0 015.125 0h10.5a5.125 5.125 0 015.125 5.125v4.5a5.125 5.125 0 01-5.125 5.125h-15A.625.625 0 010 14.125zm3.489 0c0-.483.391-.875.875-.875h11.261a.875.875 0 110 1.75H4.364a.875.875 0 01-.875-.875m0 4.5c0-.483.391-.874.875-.874h6.375a.875.875 0 110 1.75H4.363a.875.875 0 01-.875-.875" clip-rule="evenodd"/>', width: 21, height: 15 }, "chat-fill": { body: '<path fill="currentColor" d="M3.167 8.166h4.016a.46.46 0 00.345-.144.5.5 0 00.139-.356.48.48 0 00-.144-.356.48.48 0 00-.356-.144H3.15a.46.46 0 00-.345.144.5.5 0 00-.138.356q0 .213.143.356a.48.48 0 00.357.144m0-2H9.85a.46.46 0 00.345-.144.5.5 0 00.138-.356.48.48 0 00-.143-.356.48.48 0 00-.357-.144H3.15a.46.46 0 00-.345.144.5.5 0 00-.138.356q0 .213.143.356a.48.48 0 00.357.144m0-2H9.85a.46.46 0 00.345-.144.5.5 0 00.138-.356.48.48 0 00-.143-.356.48.48 0 00-.357-.144H3.15a.46.46 0 00-.345.144.5.5 0 00-.138.356q0 .212.143.356a.48.48 0 00.357.144m-3 7.403V1.87q0-.506.35-.855.35-.35.855-.35h10.256q.506 0 .855.35.35.35.35.855v7.59q0 .505-.35.855t-.855.35H2.526L1.19 12.001a.55.55 0 01-.654.128.56.56 0 01-.37-.56"/>', width: 13, height: 13 }, check: { body: '<path fill="currentColor" d="M4.367 7.717a.7.7 0 01-.25-.042.6.6 0 01-.217-.142L1.033 4.667a.62.62 0 01-.175-.476.67.67 0 01.192-.474.63.63 0 01.467-.184q.283 0 .466.184L4.367 6.1l5.65-5.65a.64.64 0 01.475-.183q.29 0 .475.183.183.183.183.475a.64.64 0 01-.183.475L4.833 7.533a.6.6 0 01-.216.142.7.7 0 01-.25.042"/>', width: 12, height: 8 }, "check-box": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M11.43 13.835 9.652 12.06a.56.56 0 00-.4-.163.54.54 0 00-.406.163.55.55 0 00-.166.403q0 .237.166.403l2.099 2.098q.208.208.483.208.277 0 .484-.208l4.255-4.254a.56.56 0 00.162-.4.54.54 0 00-.162-.406.55.55 0 00-.403-.166.55.55 0 00-.403.166zM7.381 19q-.58 0-.98-.401A1.33 1.33 0 016 17.618V7.382q0-.58.401-.98Q6.803 6 7.382 6h10.236q.58 0 .98.401.402.402.402.981v10.236q0 .58-.401.98a1.33 1.33 0 01-.981.402zm0-1.147h10.236a.23.23 0 00.161-.074.23.23 0 00.074-.161V7.382a.23.23 0 00-.074-.161.23.23 0 00-.161-.074H7.382a.23.23 0 00-.161.074.23.23 0 00-.074.161v10.236q0 .088.074.161a.23.23 0 00.161.074"/></g></g>', width: 24, height: 24 }, "check-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.812 11.792 6.854 9.833a.56.56 0 00-.417-.166.6.6 0 00-.437.187.6.6 0 00-.188.438.6.6 0 00.188.437l2.291 2.292a.7.7 0 00.521.208q.314 0 .542-.208L14 8.354a.56.56 0 00.166-.417.6.6 0 00-.187-.437.6.6 0 00-.438-.188.6.6 0 00-.437.188zM10 17.917a7.7 7.7 0 01-3.094-.625 8 8 0 01-2.51-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.645 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.687 2.51q.625 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.687 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625"/></g>', width: 20, height: 20 }, "check-circle-agent": { body: '<g fill="none"><rect width="22.44" height="22.44" x=".78" y=".78" stroke="currentColor" stroke-width="1.56" rx="11.22"/><path fill="currentColor" fill-rule="evenodd" d="m15.66 7.893-5.77 5.701-1.53-1.675a.82.82 0 00-1.048-.057.77.77 0 00-.21.998l1.813 3.02a.98.98 0 001.652 0c.29-.388 5.826-7.145 5.826-7.145.725-.76-.153-1.428-.733-.85z" clip-rule="evenodd"/></g>', width: 24, height: 24 }, "check-circle-outline": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.3 6.9 4.213 5.812a.45.45 0 00-.344-.13.5.5 0 00-.344.143.47.47 0 00-.137.35q0 .213.137.35L4.95 7.95a.47.47 0 00.35.138.47.47 0 00.35-.138l2.838-2.838a.45.45 0 00.131-.343.5.5 0 00-.144-.344.47.47 0 00-.35-.138.47.47 0 00-.35.138zM6 11a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069q-.675-.675-1.069-1.587A4.9 4.9 0 011 6q0-1.038.394-1.95a5 5 0 011.069-1.587q.675-.675 1.587-1.07A4.9 4.9 0 016 1q1.038 0 1.95.393a5 5 0 011.587 1.07q.675.675 1.069 1.587T11 6t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 016 11m0-1q1.662 0 2.832-1.168Q10 7.662 10 6T8.832 3.169 6 2Q4.338 2 3.169 3.168 1.999 4.339 2 6t1.169 2.832Q4.338 10 6 10"/></g>', width: 12, height: 12 }, "check-fill": { body: '<path fill="currentColor" d="m4.367 6.533 5.35-5.35q.315-.316.75-.316.432 0 .75.316.316.317.316.75 0 .435-.316.75l-6.1 6.1a1.02 1.02 0 01-.75.317q-.435 0-.75-.317L.783 5.95a1.02 1.02 0 01-.316-.75q0-.433.316-.75t.75-.317q.435 0 .75.317z"/>', width: 12, height: 10 }, "check-square": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.367 11.518a.55.55 0 01-.422-.17L3.16 8.563a.47.47 0 01-.14-.356.503.503 0 01.853-.357l2.493 2.493 5.759-5.76a.48.48 0 01.356-.144q.211 0 .356.145a.48.48 0 01.145.356q0 .212-.145.356l-6.05 6.05a.55.55 0 01-.421.17"/></g>' }, checkbox: { body: '<path fill="currentColor" d="M13.563 3.267a1.187 1.187 0 00-1.631.124l-5.423 6-2.67-2.54a1.089 1.089 0 00-1.501 1.577l4.432 4.22 6.924-7.665a1.187 1.187 0 00-.13-1.716"/>' }, "checkbox-list": { body: '<path fill="currentColor" d="M182.5 51.4c-4.1 1.8-3.9 1.6-42.9 50.1-19.1 23.6-35 43-35.4 43s-6.5-6.4-13.5-14.1c-7.1-8-14-14.7-15.7-15.4s-5.2-1-8.1-.8c-8.8.9-14.2 8.3-12.5 17.3.5 2.6 5 8.3 18.2 23.2 9.6 10.9 19.3 21.5 21.5 23.5 7 6.4 15.4 6.1 22.1-1 3.9-4 83-102.1 85.6-106 2.1-3.2 1.9-10.1-.4-14.1-3.5-6.1-12.2-8.7-18.9-5.7m39.1 58.5c-4.5 3-7 7.7-7 13.3 0 5.4 2.1 8.9 7.4 12.5l3.3 2.3h117.1c112.2 0 117.3-.1 120.6-1.9 3.8-2 8-8.9 8-13-.1-4.4-3.7-10.9-7.2-13.1-3.3-2-4.7-2-121.3-2-114.4 0-118.1.1-120.9 1.9M65 214.2c-3.3 1.7-5.1 3.5-6.7 6.8-2.3 4.4-2.3 4.6-2.3 53s0 48.6 2.3 53c1.2 2.4 3.5 5.3 5 6.4 2.8 2.1 3.9 2.1 54.7 2.1s51.9 0 54.6-2.1c1.5-1.1 3.7-3.3 4.8-4.8 2.1-2.7 2.1-3.8 2.1-54.6s0-51.9-2.1-54.7c-1.1-1.5-4-3.8-6.4-5.1-4.4-2.2-4.6-2.2-53-2.2s-48.6 0-53 2.2m84 59.8v31H87v-62h62zm73-12.8c-7.7 5.3-9.7 13.6-5.2 21 4.5 7.3-4.2 6.8 126.4 6.8 115.9 0 117.3 0 120.6-2 3.5-2.2 7.1-8.7 7.2-13.1 0-4.1-4.2-11-8-13-3.3-1.8-8.4-1.9-120.6-1.9H225.3zM63.6 365.9c-1.6 1.1-3.8 3.4-5 5.3-2.1 3.2-2.1 4.1-2.1 54.5 0 50.3 0 51.2 2.1 54 1.1 1.5 3.6 3.8 5.4 5l3.3 2.3h50.6c57.6 0 55.6.3 59.9-8 2.2-4.4 2.2-4.6 2.2-54 0-46.3-.1-49.8-1.9-53-1-1.9-3.3-4.5-5.1-5.8l-3.3-2.2h-51.6c-49.1 0-51.7.1-54.5 1.9m85.4 59.6V457H87v-63h62zm74.4-14.1c-11.6 5.1-11.7 22.4-.1 27.7 4 1.8 8.5 1.9 119.2 1.9h115.1l4.4-2.3c6.2-3.2 8.5-6.7 8.5-13.2 0-5.8-1.8-9.1-6.9-12.9-2.7-2.1-3.3-2.1-119.9-2.3-96.6-.2-117.7 0-120.3 1.1"/>', width: 512, height: 512 }, checklist: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.78 10.892 6.262 8.41q.15-.149.352-.146a.505.505 0 01.49.51q0 .2-.14.35L4.22 11.878a.58.58 0 01-.422.181.58.58 0 01-.422-.18l-1.363-1.363a.46.46 0 01-.135-.348.48.48 0 01.142-.348.47.47 0 01.349-.139q.21 0 .347.139zm0-5.077 2.482-2.482q.15-.149.352-.146a.505.505 0 01.49.51.5.5 0 01-.14.35L4.22 6.802a.58.58 0 01-.422.18.58.58 0 01-.422-.18L2.012 5.44a.46.46 0 01-.135-.348.483.483 0 01.49-.487q.212 0 .348.139zm5.394 5.224a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.212.144-.356a.48.48 0 01.356-.143h4.666q.212 0 .357.143a.48.48 0 01.143.357q0 .213-.143.356a.48.48 0 01-.357.144zm0-5.077a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.212.144-.356a.48.48 0 01.356-.143h4.666q.212 0 .357.143a.48.48 0 01.143.357q0 .213-.143.356a.5.5 0 01-.357.144z"/></g>' }, "chevron-down": { body: '<mask id="svgID0" width="12" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M.888 9.163a.72.72 0 01.525-.226q.3 0 .525.226l4.075 4.075 4.075-4.075a.72.72 0 01.525-.226q.3 0 .525.226a.72.72 0 01.225.524.72.72 0 01-.225.526l-4.5 4.5a.8.8 0 01-.287.188.94.94 0 01-.675 0 .8.8 0 01-.288-.188l-4.5-4.5a.72.72 0 01-.225-.525q0-.3.225-.526"/></g>', width: 12, height: 24 }, "chevron-right": { body: '<mask id="svgID0" width="12" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.225 17.075A.72.72 0 013 16.55q0-.3.225-.525L7.3 11.95 3.225 7.875A.72.72 0 013 7.35q0-.3.225-.525A.72.72 0 013.75 6.6q.3 0 .525.225l4.5 4.5a.8.8 0 01.188.287.94.94 0 010 .675.8.8 0 01-.188.288l-4.5 4.5a.72.72 0 01-.525.225.72.72 0 01-.525-.225"/></g>', width: 12, height: 24 }, chrome: { body: '<g fill="currentColor"><path d="M2.898 4.18C8.476-2.311 18.82-1.03 22.686 6.555h-9.292c-1.675 0-2.756-.038-3.927.579-1.376.724-2.414 2.067-2.777 3.644z"/><path d="M8.008 12c0 2.2 1.789 3.99 3.988 3.99A3.994 3.994 0 0015.984 12c0-2.2-1.789-3.99-3.988-3.99-2.2 0-3.988 1.79-3.988 3.99"/><path d="M13.544 17.223c-2.239.665-4.858-.073-6.293-2.55-1.096-1.89-3.99-6.932-5.305-9.224-4.607 7.06-.636 16.683 7.727 18.325z"/><path d="M15.7 8.01a5.464 5.464 0 011.008 6.718 1860 1860 0 01-5.46 9.248c8.617.531 14.9-7.914 12.062-15.967z"/></g>', width: 24, height: 24 }, class: { body: '<g fill="currentColor"><path d="M121.7 60.6c-3.1 1-6.4 3-9.2 5.9-7.6 7.6-7.5 6.3-7.5 76.2V204h-7.3c-4.3 0-7.8.5-8.5 1.2-.9.9-1.2 15.4-1.2 59 0 66.3-1.1 59.8 10.4 59.8h6.6v53.3c0 60.9 0 60.7 7.5 68.2 7.9 8-1.4 7.5 143.5 7.5 143.6 0 135.6.4 142.8-6.8 8-8 7.7-4.9 8-67l.3-55.2h6.5c11.5 0 10.4 6.5 10.4-59.8 0-43.6-.3-58.1-1.2-59-.7-.7-4.1-1.2-8.5-1.2h-7.2l-.3-30.1-.3-30.1-43-42.3-43-42.4h-97c-82.9 0-97.7.3-101.8 1.5m192.9 42.1c-.7 33.3-.6 36 1.1 39.2 1 1.9 3.1 4.4 4.6 5.5 2.7 2 4.4 2.1 40.5 2.6l37.7.5.2 21c.1 11.5 0 23.6-.3 26.7l-.6 5.8H113v-60.8c0-36.7.4-62.1 1-64.1 1.2-4.1 5.4-8.8 9.5-10.7 2.4-1.1 20.8-1.3 97.4-1.4h94.4zm44.7 39.1-32.8.3-2.4-2.8c-2.3-2.7-2.4-3.1-1.7-15.3.3-6.9.6-21.3.6-32V72.5l34.5 34.5 34.5 34.5zM416 264v52H96V212h320zm-17.5 114.5c-.1 47.7-.3 54.4-1.7 57-2.2 4-5.6 7-9.7 8.4-4.4 1.4-256.9 1.6-262 .1-4-1.1-7.6-4.2-9.9-8.5-1.5-2.7-1.7-9-2-57.3l-.3-54.2 142.8.2 142.8.3z"/><path d="M161 227.9c-12.9 4.2-20.9 16.5-19.8 30.5.9 10.6 6.4 18.9 15.8 23.8 3.6 1.8 6 2.3 12.5 2.3 8.6 0 13.8-1.9 18.2-6.7l2.3-2.4-3.1-2.3c-2.7-2-3.2-2.1-4.2-.8-4.6 5.8-15 7.4-22.7 3.4-6.8-3.4-10.3-9.2-10.8-17.8-.4-6-.1-7.7 2.3-12.5 1.8-3.6 4-6.4 6.5-8 6.8-4.5 16.4-4.4 21.9.2l3 2.5 3.1-2.2c2.9-2.2 2.9-2.3 1.2-4.2-3.3-3.7-9.4-6-16.7-6.3-3.8-.2-8.1 0-9.5.5m142.6.5c-8.5 3.2-12.7 10.7-10.6 18.8 1.6 5.8 5.6 9.1 15.1 12.4 11.8 4.1 14.5 8.4 9.1 14.5-2.3 2.5-3.8 3.2-7.8 3.6-4.1.4-5.5.1-8.7-2.1-4.6-3.2-4.8-3.2-7.7-.1-2 2.1-2.1 2.7-.9 4.1 2.3 2.9 9.8 5.6 15.3 5.6 7.1.1 11.6-1.6 15.6-5.7 2.9-3 3.4-4.3 3.8-9.3.6-8.1-1.4-11.6-8.1-14.8-2.9-1.3-5.8-2.4-6.5-2.4s-3.2-.9-5.6-2.1c-7.4-3.4-8.6-11.1-2.2-15 4-2.4 8.2-2.4 13 .1 4 2 6 1.7 8.4-1.3 1.3-1.5-.2-3.4-4.5-5.6-3.7-1.9-13.4-2.3-17.7-.7m44.2-.4c-10.2 3-15 14.9-9.5 23.1 2.3 3.5 7.1 6.3 17.2 10.1 6.5 2.5 8.4 5.2 7.1 10.2-1.6 6.5-13.1 8.6-19.8 3.6l-3-2.2-2.6 2.5c-2.6 2.6-2.6 2.6-.7 4.7 4.9 5.4 17.8 7 25.2 3.1 6.3-3.2 8.8-7.4 8.8-14.8 0-5.5-.3-6.5-2.9-9.2-1.9-2-5.6-3.9-10.7-5.6-10.3-3.5-12.9-5.6-12.9-10.4 0-5.7 3.6-8.6 10.5-8.6 4.2 0 5.9.5 7.7 2.2l2.4 2.3 3-3.1 2.9-3-2.5-1.9c-4.6-3.5-14-4.9-20.2-3M200 255.9V284h32v-7h-25l-.2-24.3-.3-24.2-3.2-.3-3.3-.3zm57.2-26.2c-2.1 3.9-23.2 52.5-23.2 53.4 0 .5 1.7.9 3.8.9 3.9 0 3.9 0 6.6-7l2.8-7h26.6l2.8 7c2.7 7 2.7 7 6.6 7 2.4 0 3.8-.5 3.8-1.3 0-.6-5.1-13.1-11.3-27.7-11.2-26.1-11.4-26.5-14.5-26.8-2.2-.2-3.4.2-4 1.5m8.6 21c2.8 6.7 4.8 12.4 4.4 12.7-.3.3-5 .6-10.5.6-7.5 0-9.8-.3-9.4-1.3 3.2-8.4 10.1-24.6 10.3-24.5.1.2 2.5 5.8 5.2 12.5"/></g>', width: 512, height: 512 }, clone: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.01 13.216h8.628a.22.22 0 00.161-.066.22.22 0 00.066-.16V4.361a.22.22 0 00-.066-.161.22.22 0 00-.161-.066H7.01a.22.22 0 00-.16.066.22.22 0 00-.067.161v8.627q0 .095.066.16a.22.22 0 00.16.067m0 1.135q-.567 0-.964-.397a1.3 1.3 0 01-.397-.965V4.362q0-.567.397-.965Q6.443 3 7.011 3h8.627q.567 0 .965.397.397.398.397.965v8.627q0 .568-.397.965a1.3 1.3 0 01-.965.397zM4.363 17q-.567 0-.965-.397A1.3 1.3 0 013 15.638V6.443a.56.56 0 01.161-.397.53.53 0 01.407-.17q.246 0 .406.17a.56.56 0 01.161.397v9.195a.22.22 0 00.067.161.22.22 0 00.16.066h9.195q.227 0 .397.16.17.162.17.408t-.17.407a.56.56 0 01-.397.16zM7.011 4.135h-.227 9.08z"/></g>', width: 20, height: 20 }, close: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m10 10.875-4.23 4.23a.6.6 0 01-.426.176.58.58 0 01-.448-.177.6.6 0 01-.188-.437.6.6 0 01.188-.438L9.125 10l-4.23-4.23a.6.6 0 01-.176-.427.57.57 0 01.177-.447.6.6 0 01.437-.188.6.6 0 01.438.188L10 9.125l4.23-4.23a.62.62 0 01.427-.177.58.58 0 01.447.178.6.6 0 01.188.437.6.6 0 01-.188.438L10.875 10l4.23 4.23q.166.165.176.426a.58.58 0 01-.177.448.6.6 0 01-.437.188.6.6 0 01-.438-.188z"/></g>', width: 20, height: 20 }, "close-box": { body: '<path fill="currentColor" d="m9 9.69 2.106 2.105a.43.43 0 00.344.143.53.53 0 00.345-.169.48.48 0 00.156-.344.48.48 0 00-.156-.345L9.69 9l2.106-2.106a.48.48 0 00.156-.344.48.48 0 00-.156-.345.48.48 0 00-.345-.156.48.48 0 00-.344.156L9 8.31 6.894 6.205a.47.47 0 00-.332-.156.47.47 0 00-.331.156.48.48 0 00-.156.345q0 .189.156.344L8.31 9l-2.106 2.106q-.156.155-.143.332a.52.52 0 00.169.331.48.48 0 00.344.156q.189 0 .345-.156zm-4.72 5.235q-.506 0-.855-.35a1.16 1.16 0 01-.35-.856V4.281q0-.507.35-.856.35-.35.856-.35h9.438q.507 0 .856.35.35.35.35.856v9.438q0 .506-.35.857-.35.35-.856.35zm0-.975h9.44a.22.22 0 00.158-.072.22.22 0 00.072-.159V4.281a.22.22 0 00-.072-.159.22.22 0 00-.159-.072H4.281a.22.22 0 00-.159.072.22.22 0 00-.072.159v9.438q0 .087.072.159a.22.22 0 00.159.072"/>', width: 18, height: 18 }, "close-fill": { body: '<path fill="currentColor" d="m5.033 6.5-3 3q-.3.3-.733.3a1 1 0 01-.733-.3q-.3-.3-.3-.733 0-.434.3-.734l3-3-3-3q-.3-.3-.3-.733t.3-.733.733-.3.733.3l3 3 3-3q.3-.3.734-.3.433 0 .733.3t.3.733-.3.733l-3 3 3 3q.3.3.3.734 0 .433-.3.733t-.733.3a1 1 0 01-.734-.3z"/>', width: 10, height: 10 }, "close-fullscreen": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.793 12a.77.77 0 01-.562-.231.77.77 0 01-.231-.562V6.05a.64.64 0 01.661-.662.643.643 0 01.661.662v3.702l5.576-5.576A.63.63 0 0119.361 4q.285 0 .463.176A.63.63 0 0120 4.64a.63.63 0 01-.176.463l-5.576 5.576h3.702q.287 0 .475.187a.64.64 0 01.187.474.64.64 0 01-.662.661zm-8.617 7.824A.63.63 0 014 19.36q0-.286.176-.463l5.576-5.576H6.05a.64.64 0 01-.662-.66A.643.643 0 016.05 12h5.157q.33 0 .562.231a.77.77 0 01.231.562v5.157q0 .287-.187.475a.65.65 0 01-.474.187.64.64 0 01-.661-.662v-3.702l-5.576 5.576a.63.63 0 01-.463.176.63.63 0 01-.463-.176"/></g>', width: 24, height: 24 }, "cloud-done": { body: '<g fill="none"><mask id="svgID0" width="24" height="25" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .949h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6.5 20.45q-2.072 0-3.537-1.441Q1.5 17.569 1.5 15.495q0-1.864 1.2-3.277 1.198-1.415 2.973-1.677.48-2.242 2.255-3.667T12 5.45q2.714 0 4.607 1.893T18.5 11.95v.5h.308q1.58.123 2.636 1.271t1.056 2.73q0 1.672-1.163 2.836T18.5 20.449zm3.85-3.224a.83.83 0 00.633-.256l4.129-4.128a.75.75 0 00.227-.538.73.73 0 00-.228-.547.74.74 0 00-.542-.233.74.74 0 00-.542.233l-3.692 3.692-1.593-1.592a.73.73 0 00-.522-.228.72.72 0 00-.532.228.74.74 0 00-.232.535q0 .3.232.534l2.03 2.044a.83.83 0 00.632.256M6.5 18.95h12q1.05 0 1.775-.725T21 16.45t-.725-1.775-1.775-.725H17v-2q0-2.075-1.463-3.537Q14.075 6.949 12 6.949T8.463 8.412Q7 9.874 7 11.949h-.52q-1.42 0-2.45 1.025A3.36 3.36 0 003 15.45q0 1.45 1.025 2.475A3.37 3.37 0 006.5 18.95"/></g></g>', width: 24, height: 25 }, "cloud-lock": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.417 16.25q-1.728 0-2.947-1.198-1.22-1.2-1.22-2.93 0-1.553 1-2.732.998-1.179 2.478-1.396a5.2 5.2 0 011.879-3.056A5.27 5.27 0 0110 3.75q1.842 0 3.252 1.066a5.34 5.34 0 011.927 2.74.5.5 0 01-.065.465.7.7 0 01-.366.266.63.63 0 01-.455-.039q-.237-.105-.35-.426a4.16 4.16 0 00-1.497-2.028A4 4 0 0010 5Q8.271 5 7.052 6.219 5.834 7.437 5.833 9.167h-.432q-1.184 0-2.043.854a2.8 2.8 0 00-.858 2.062q0 1.208.854 2.063A2.8 2.8 0 005.417 15h5.376q.266 0 .446.18t.18.445-.18.445a.6.6 0 01-.446.18zm8.581 0a.73.73 0 01-.536-.217.73.73 0 01-.217-.536v-2.38q0-.322.232-.534a.8.8 0 01.562-.211v-.833q0-.639.454-1.093a1.5 1.5 0 011.093-.454q.638 0 1.088.454t.45 1.093v.833q.33 0 .561.211a.7.7 0 01.232.534v2.38a.73.73 0 01-.217.536.73.73 0 01-.537.217zm.778-3.878h1.61v-.833a.8.8 0 00-.223-.582.77.77 0 00-.578-.228.8.8 0 00-.582.228.8.8 0 00-.227.582z"/></g>', width: 20, height: 20 }, "cloud-sync": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.25 14.812a2 2 0 01-1.454-.609 2 2 0 01-.61-1.453q0-.825.563-1.415t1.444-.629q.3-.675.9-1.097t1.406-.422q.957 0 1.66.628.703.63.834 1.622h.113q.713 0 1.209.488t.497 1.181q0 .712-.488 1.21a1.62 1.62 0 01-1.2.496zm0-1.125h4.874a.54.54 0 00.394-.168.54.54 0 000-.788.54.54 0 00-.394-.169H15v-.75q0-.618-.44-1.06a1.45 1.45 0 00-1.06-.44q-.618 0-1.05.403a1.36 1.36 0 00-.45.985v.112h-.75a.9.9 0 00-.665.273.9.9 0 00-.272.665q0 .393.272.665a.9.9 0 00.665.272m-7.444 1.07a.547.547 0 01-.563-.563.546.546 0 01.563-.563h1.612q-1.144-.993-1.687-2.147a5.7 5.7 0 01-.544-2.465q0-1.725.91-3.132A5.8 5.8 0 016.468 3.77q.319-.15.581 0 .263.15.263.525 0 .168-.094.29a.7.7 0 01-.244.197 4.63 4.63 0 00-1.921 1.706 4.6 4.6 0 00-.741 2.55q0 1.069.44 1.979.441.909 1.397 1.753v-1.482q0-.244.17-.403a.56.56 0 01.393-.16q.243 0 .403.16a.55.55 0 01.16.403v2.794a.67.67 0 01-.188.479.64.64 0 01-.488.196zm9.806-6.6a4.9 4.9 0 00-.572-1.51q-.404-.685-1.19-1.416v1.481a.53.53 0 01-.17.403.56.56 0 01-.393.16.545.545 0 01-.563-.563V3.92a.67.67 0 01.188-.479.64.64 0 01.487-.196h2.794a.546.546 0 01.563.562.544.544 0 01-.563.563h-1.612q.993.88 1.5 1.81.505.927.675 1.977z"/></g>', width: 18, height: 18 }, "cloud-upload": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.333 13q-1.383 0-2.358-.959Q1 11.084 1 9.7q0-1.233.783-2.183a3.04 3.04 0 012-1.117q.317-1.5 1.5-2.45A4.22 4.22 0 018 3q1.817 0 3.075 1.258 1.258 1.26 1.258 3.075v.334h.2q1.067.083 1.767.85.7.765.7 1.816 0 1.117-.775 1.892a2.57 2.57 0 01-1.892.775H8.5V8.15l.883.867a.48.48 0 00.7 0q.15-.15.142-.359a.5.5 0 00-.142-.341L8.417 6.65A.57.57 0 008 6.467a.57.57 0 00-.417.183L5.917 8.317a.5.5 0 00-.142.341.46.46 0 00.142.359.46.46 0 00.342.133.52.52 0 00.358-.133L7.5 8.15V13z"/></g>' }, code: { body: '<path fill="currentColor" d="M11.77 9.589a.56.56 0 01-.437.176.64.64 0 01-.437-.197.6.6 0 01-.188-.438.6.6 0 01.188-.437l3.375-3.396L10.875 1.9a.55.55 0 01-.157-.427.62.62 0 01.178-.427.6.6 0 01.437-.188.6.6 0 01.438.188l3.75 3.75q.23.23.229.52a.72.72 0 01-.23.522zm-7.54 0L.48 5.839a.72.72 0 01-.23-.521q0-.292.23-.521l3.75-3.75a.6.6 0 01.447-.188.6.6 0 01.448.188.6.6 0 01.188.437.67.67 0 01-.188.459L1.729 5.339l3.396 3.395a.55.55 0 01.157.428.62.62 0 01-.178.427.6.6 0 01-.437.187.6.6 0 01-.438-.187"/>', height: 10 }, "combo-box": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.667 11q-1.249 0-2.125-.876A2.9 2.9 0 011.667 8q0-1.248.875-2.124A2.9 2.9 0 014.667 5h6.666q1.249 0 2.125.876.875.875.875 2.124 0 1.248-.875 2.124a2.9 2.9 0 01-2.125.876zm0-1h6.666q.834 0 1.417-.583.583-.584.583-1.417t-.583-1.417A1.93 1.93 0 0011.333 6H4.667q-.834 0-1.417.583A1.93 1.93 0 002.667 8q0 .834.583 1.417T4.667 10m1.122-1.042L7.3 7.446a.4.4 0 00.121-.276.38.38 0 00-.121-.283.4.4 0 00-.28-.124.4.4 0 00-.279.124L5.367 8.262l-.375-.375a.4.4 0 00-.276-.121.38.38 0 00-.283.121.4.4 0 00-.124.28q0 .154.124.28l.512.51q.18.181.422.181.24 0 .422-.18"/></g>' }, community: { body: '<mask id="svgID0" width="36" height="36" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h36v36H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6 20.288 9.787 16.5 6 12.713 2.213 16.5zm20.25-.788 3.75-6 3.75 6zM18 18q-1.875 0-3.187-1.312Q13.5 15.375 13.5 13.5q0-1.913 1.313-3.206Q16.125 9 18 9q1.913 0 3.206 1.294Q22.5 11.587 22.5 13.5q0 1.875-1.294 3.188Q19.913 18 18 18M0 25.5v-.863q0-1.65 1.669-2.643Q3.337 21 6 21q.488 0 .938.019t.862.094a5.7 5.7 0 00-.787 1.612 6.3 6.3 0 00-.263 1.837V27H1.5q-.637 0-1.069-.431A1.45 1.45 0 010 25.5m9 0v-.937q0-2.438 2.494-3.938 2.493-1.5 6.506-1.5 4.05 0 6.525 1.5T27 24.563v.937q0 .637-.431 1.069A1.45 1.45 0 0125.5 27h-15q-.637 0-1.069-.431A1.45 1.45 0 019 25.5M30 21q2.7 0 4.35.994T36 24.637v.863q0 .637-.431 1.069A1.45 1.45 0 0134.5 27h-5.25v-2.437q0-.975-.244-1.838a5.9 5.9 0 00-.731-1.613q.412-.074.844-.093.43-.02.881-.019"/></g>', width: 36, height: 36 }, compare: { body: '<path fill="currentColor" d="M1.556 14a1.5 1.5 0 01-1.098-.457A1.5 1.5 0 010 12.444V3.111q0-.641.457-1.098a1.5 1.5 0 011.099-.457h2.333q.33 0 .554.224a.75.75 0 01.224.553q0 .331-.224.554a.75.75 0 01-.554.224H1.556v9.333h2.333q.33 0 .554.224a.75.75 0 01.224.554q0 .33-.224.554a.75.75 0 01-.554.224zm4.667.778v-14q0-.331.224-.554A.75.75 0 017 0q.331 0 .554.224a.75.75 0 01.224.554v.778h4.667q.641 0 1.098.457A1.5 1.5 0 0114 3.111v9.333q0 .641-.457 1.098a1.5 1.5 0 01-1.099.458H7.778v.778q0 .33-.224.554a.75.75 0 01-.554.224.75.75 0 01-.554-.224.75.75 0 01-.224-.554m1.556-2.334h4.667V3.111H7.778z"/>', width: 14, height: 15.556 }, config: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M11.667 13.205a1.93 1.93 0 01-1.416-.584 1.93 1.93 0 01-.584-1.416q0-.832.584-1.416.584-.585 1.416-.584.831 0 1.416.584.584.584.584 1.416t-.584 1.416-1.416.584m0-1a.96.96 0 00.708-.292.96.96 0 00.292-.708.96.96 0 00-.292-.708.96.96 0 00-.708-.292.96.96 0 00-.709.292.96.96 0 00-.291.708q0 .417.291.708.292.292.709.292m-4.09-.5H2.833a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.213.144-.356a.48.48 0 01.356-.144h4.744q.213 0 .356.144a.48.48 0 01.144.356q0 .212-.144.357a.48.48 0 01-.356.143m-3.244-4.91a1.93 1.93 0 01-1.416-.584 1.93 1.93 0 01-.584-1.416q0-.832.584-1.416.585-.584 1.416-.584.833 0 1.416.584.585.584.584 1.416 0 .833-.584 1.416-.583.584-1.416.584m0-1a.96.96 0 00.709-.292.96.96 0 00.291-.708.96.96 0 00-.291-.708.96.96 0 00-.709-.292.96.96 0 00-.708.292.96.96 0 00-.292.708q0 .417.292.708.291.292.708.292m8.834-.5H8.423a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.212.144-.357a.48.48 0 01.356-.143h4.744q.212 0 .356.144a.48.48 0 01.144.356q0 .213-.144.356a.48.48 0 01-.356.144"/></g></g>' }, "contact-support": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m10.698 19-.145-2.537h-.821q-3.238 0-5.485-2.247T2 8.732t2.247-5.485T9.732 1q1.619 0 3.02.604a7.8 7.8 0 012.453 1.656q1.05 1.05 1.654 2.451t.604 3.02q0 3.31-1.921 6.004A14 14 0 0110.698 19m-.966-5.17a.8.8 0 00.604-.255.83.83 0 00.241-.591.86.86 0 00-.241-.617.8.8 0 00-.604-.253.8.8 0 00-.604.253.86.86 0 00-.242.617q0 .338.242.591.24.255.604.255m.024-2.948a.57.57 0 00.375-.158.83.83 0 00.253-.422q.047-.339.266-.628.217-.29.773-.846.435-.41.7-.881.267-.472.266-1.052 0-1.135-.784-1.74-.786-.603-1.85-.603-.796 0-1.388.374-.592.375-.955.93a.47.47 0 00-.06.447.54.54 0 00.35.327.56.56 0 00.398 0 .7.7 0 00.351-.29q.193-.29.508-.496.314-.205.797-.205.724 0 1.087.41t.363.895q0 .434-.242.761-.241.326-.628.712-.629.532-.857.919-.231.386-.279.966a.5.5 0 00.134.398.53.53 0 00.422.182m2.392 4.131v1.305a12 12 0 002.79-3.394 8.5 8.5 0 001.076-4.192q0-2.634-1.824-4.459Q12.365 2.45 9.732 2.45T5.274 4.273 3.45 8.732t1.824 4.458 4.458 1.823z"/></g>', width: 20, height: 20 }, "content-copy": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4 10.005a.97.97 0 01-.712-.292A.97.97 0 012.995 9V1.005a.97.97 0 01.293-.713A.97.97 0 014 0h6.195a.97.97 0 01.713.292.97.97 0 01.292.713V9a.97.97 0 01-.292.713.97.97 0 01-.713.292zM4 9h6.195V1.005H4zm-1.995 3a.97.97 0 01-.712-.293A.95.95 0 011 11.01V2.67q0-.21.143-.353a.48.48 0 01.352-.142q.225 0 .368.142a.48.48 0 01.142.353v8.34H8.44q.21 0 .353.143a.48.48 0 01.142.352q0 .21-.142.352A.48.48 0 018.44 12z"/></g>', width: 12, height: 12 }, "content-copy-sm": { body: '<g fill="none"><mask id="svgID0" width="16" height="17" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .949h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3.833 15.154q-.504 0-.855-.35a1.16 1.16 0 01-.35-.856V5.987q0-.213.144-.356a.48.48 0 01.356-.144q.212 0 .357.144a.48.48 0 01.143.356v7.961q0 .078.064.141.064.065.141.065h5.962q.213 0 .356.143a.48.48 0 01.144.357q0 .212-.144.356a.48.48 0 01-.356.144zm2.334-2.334q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855v-7.59q0-.504.35-.855.35-.35.855-.35h5.59q.504 0 .854.35.35.351.35.855v7.59q0 .505-.35.855t-.855.35zm0-1h5.59a.2.2 0 00.14-.064.2.2 0 00.064-.14v-7.59a.2.2 0 00-.064-.142.2.2 0 00-.14-.064h-5.59a.2.2 0 00-.141.064.2.2 0 00-.064.141v7.59q-.001.077.064.141.064.064.14.064"/></g></g>', height: 17 }, "contract-edit": { body: '<path fill="currentColor" d="M6.286 3.994h5.93q.265 0 .444.18.18.18.18.446 0 .265-.18.445a.6.6 0 01-.445.18h-5.93a.6.6 0 01-.445-.18.6.6 0 01-.18-.446q0-.266.18-.445.18-.18.446-.18m0 2.404h5.93q.265 0 .444.18.18.18.18.445 0 .266-.18.446a.6.6 0 01-.445.18h-5.93a.6.6 0 01-.445-.18.6.6 0 01-.18-.446q0-.266.18-.445.18-.18.446-.18M3 15.918a2 2 0 01-1.478-.606 2 2 0 01-.605-1.478v-1.65q0-.321.217-.537a.73.73 0 01.536-.217h1.747V1.59q0-.621.442-1.064A1.45 1.45 0 014.923.084h8.654q.623 0 1.064.442.443.443.443 1.064v4.92q0 .266-.18.446a.6.6 0 01-.445.18.6.6 0 01-.446-.18.6.6 0 01-.18-.446V1.59a.25.25 0 00-.071-.184.25.25 0 00-.185-.072H4.923a.25.25 0 00-.184.072.25.25 0 00-.072.184v9.84h2.644q.266 0 .446.18t.18.445-.18.446a.6.6 0 01-.446.179H2.167v1.154q0 .354.24.594t.593.24h4.311q.266 0 .446.18.18.178.18.444 0 .267-.18.446a.6.6 0 01-.446.18zm6.763-.754v-1.135a.75.75 0 01.226-.54l4.298-4.277a.9.9 0 01.336-.219q.18-.063.36-.063a1 1 0 01.714.295l.771.779q.135.156.209.336t.073.363q0 .18-.067.368a1 1 0 01-.215.343l-4.277 4.277a.75.75 0 01-.54.226h-1.135a.73.73 0 01-.536-.216.73.73 0 01-.217-.537m.994-.24h.792l2.705-2.718-.383-.396-.388-.391-2.726 2.713zm3.114-3.114-.388-.391.77.787z"/>', width: 17 }, "copilot-logo": { body: '<g fill="currentColor"><path d="M14.514 5.939a1 1 0 00-.303-.238.75.75 0 00-.36-.076q-.261-.001-.497-.116a1.3 1.3 0 01-.424-.33 1.5 1.5 0 01-.281-.495 1.8 1.8 0 01-.1-.582q0-.212-.065-.41a1.1 1.1 0 00-.195-.349.9.9 0 00-.294-.237.8.8 0 00-.35-.086h-7.33a.8.8 0 00-.35.086.9.9 0 00-.295.237 1.1 1.1 0 00-.195.35 1.3 1.3 0 00-.065.41c0 .404-.138.793-.38 1.077a1.2 1.2 0 01-.922.445.8.8 0 00-.355.076.9.9 0 00-.303.233 1.1 1.1 0 00-.203.349 1.2 1.2 0 00-.07.415v2.737c0 .141.022.283.07.414q.073.197.203.35a.86.86 0 00.658.303c.346 0 .675.162.922.445.246.284.38.673.385 1.078v2.782a.43.43 0 00.06.218.3.3 0 00.156.136.26.26 0 00.195.005.3.3 0 00.16-.126l1.32-1.932h6.339q.181 0 .35-.087a.9.9 0 00.294-.237 1.1 1.1 0 00.195-.35q.065-.196.065-.41c0-.844.58-1.522 1.303-1.522a.8.8 0 00.354-.076.9.9 0 00.303-.233q.131-.15.204-.349c.047-.131.069-.273.069-.415V6.687c0-.273-.091-.546-.268-.758zm-1.558 3.526c0 .4-.143.784-.385 1.067-.243.284-.576.44-.918.44H4.31a1.21 1.21 0 01-.917-.44 1.68 1.68 0 01-.385-1.067V6.667c0-.4.143-.784.385-1.067a1.21 1.21 0 01.917-.44h7.339c.342 0 .675.156.917.44.243.283.385.668.385 1.067v2.798z"/><path d="m6.58 8.58-.155.474a.104.104 0 01-.197 0l-.155-.473a.31.31 0 00-.199-.199l-.473-.155a.104.104 0 010-.197l.473-.155a.31.31 0 00.199-.2l.155-.472a.104.104 0 01.197 0l.155.473a.31.31 0 00.2.199l.472.155a.104.104 0 010 .197l-.473.155a.31.31 0 00-.199.199m3.254-.001-.155.474a.104.104 0 01-.197 0l-.155-.473a.31.31 0 00-.199-.199l-.473-.155a.104.104 0 010-.197l.473-.155a.31.31 0 00.199-.2l.155-.472a.104.104 0 01.197 0l.155.473a.31.31 0 00.2.199l.472.155a.104.104 0 010 .197l-.473.155a.31.31 0 00-.199.199"/></g>', height: 17 }, copy: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.038 11.667q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855v-7.59q0-.506.35-.855.351-.35.855-.35h5.59q.505 0 .855.35t.35.855v7.59q0 .506-.35.855-.35.35-.855.35zm0-1h5.59a.2.2 0 00.141-.064.2.2 0 00.064-.141v-7.59a.2.2 0 00-.064-.14.2.2 0 00-.14-.065h-5.59a.2.2 0 00-.142.064.2.2 0 00-.064.141v7.59q0 .077.064.14.064.065.141.065M3.705 14q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855v-8.59h1v8.59q0 .077.064.141t.141.064h6.59v1z"/></g>' }, cpu: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.333 9.064V6.936q0-.255.173-.43a.58.58 0 01.43-.173h2.128q.256 0 .43.174a.58.58 0 01.172.429v2.128q0 .255-.173.43a.58.58 0 01-.43.173H6.937a.58.58 0 01-.43-.174.58.58 0 01-.173-.429m1-.397h1.333V7.333H7.333zm-1.167 4.346v-.68H4.872q-.505 0-.856-.35a1.16 1.16 0 01-.35-.855V9.833h-.68a.48.48 0 01-.355-.143.48.48 0 01-.144-.357q0-.213.144-.356a.48.48 0 01.356-.144h.68V7.167h-.68a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.213.144-.357a.48.48 0 01.356-.143h.68V4.872q0-.505.35-.855t.855-.35h1.294v-.68q0-.212.144-.356a.48.48 0 01.357-.144q.212 0 .356.144a.48.48 0 01.143.356v.68h1.667v-.68q0-.212.144-.356a.48.48 0 01.356-.144q.213 0 .356.144a.48.48 0 01.144.356v.68h1.295q.506 0 .855.35.35.35.35.855v1.295h.68q.212 0 .356.144a.48.48 0 01.144.356q0 .213-.144.356a.48.48 0 01-.356.144h-.68v1.666h.68q.212 0 .356.144a.48.48 0 01.144.357q0 .212-.144.356a.48.48 0 01-.356.143h-.68v1.295q0 .506-.35.855-.35.35-.855.35H9.833v.68q0 .212-.144.356a.48.48 0 01-.356.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356v-.68H7.166v.68q0 .212-.143.356a.48.48 0 01-.357.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356m4.962-1.68a.2.2 0 00.14-.064.2.2 0 00.065-.14V4.871a.2.2 0 00-.064-.141.2.2 0 00-.141-.064H4.872a.2.2 0 00-.141.064.2.2 0 00-.065.14v6.257q0 .077.065.141.064.064.14.064z"/></g>' }, "critical-priority": { body: '<g fill="none"><path fill="url(#svgID0)" d="m2.5 4 5-2.9c.3-.2.7-.2 1 0l5 2.9c.3.2.5.5.5.9v8.2c0 .6-.4 1-1 1-.2 0-.4 0-.5-.1L8 11.4 3.5 14c-.5.3-1.1.1-1.4-.4-.1-.1-.1-.3-.1-.5V4.9c0-.4.2-.7.5-.9"/><defs><linearGradient id="svgID0" x1="8" x2="8" y1="1.006" y2="14.118" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient></defs></g>' }, "crop-free": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M4.423 17.083q-.63 0-1.069-.437a1.45 1.45 0 01-.437-1.07v-2.451q0-.267.18-.446.178-.18.445-.18.266 0 .445.18.18.18.18.446v2.452q0 .096.08.176t.176.08h2.452q.266 0 .446.18t.18.445-.18.446a.6.6 0 01-.446.18zm11.154 0h-2.452a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18h2.452a.25.25 0 00.176-.08.25.25 0 00.08-.176v-2.452q0-.267.18-.446.18-.18.445-.18.266 0 .446.18t.18.446v2.452q0 .63-.438 1.069a1.45 1.45 0 01-1.069.437M2.917 6.875V4.423q0-.631.437-1.069a1.45 1.45 0 011.07-.437h2.451q.266 0 .446.179.18.18.18.446 0 .265-.18.445a.6.6 0 01-.446.18H4.423a.25.25 0 00-.176.08.25.25 0 00-.08.176v2.452q0 .266-.18.445a.6.6 0 01-.445.18.6.6 0 01-.446-.18.6.6 0 01-.18-.445m12.916 0V4.423a.25.25 0 00-.08-.176.25.25 0 00-.176-.08h-2.452a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.446t.445-.18h2.452q.63 0 1.069.438.437.438.437 1.069v2.452q0 .266-.18.445a.6.6 0 01-.445.18.6.6 0 01-.445-.18.6.6 0 01-.18-.445M7.784 9.68v3.24a.62.62 0 00.184.457.62.62 0 00.456.184.62.62 0 00.456-.184.62.62 0 00.184-.457V8.17q0-.438-.4-.604a.6.6 0 00-.706.14L6.18 9.484A.62.62 0 006 9.93a.6.6 0 00.18.454.6.6 0 00.45.185.6.6 0 00.45-.185zm4.432.801v-3.24a.62.62 0 00-.184-.457.62.62 0 00-.456-.184.62.62 0 00-.456.184.62.62 0 00-.184.456v4.751q0 .438.4.604a.6.6 0 00.706-.14l1.777-1.777a.62.62 0 00.18-.446.6.6 0 00-.18-.454.6.6 0 00-.45-.185.6.6 0 00-.45.185z"/></g>', width: 20, height: 20 }, crown: { body: '<g fill="none"><g fill="currentColor" clip-path="url(#svgID0)"><path d="M1.91 11.781c0 .176.142.318.317.318h9.546a.32.32 0 00.318-.318v-.955H1.909zm11.136-7.954a.955.955 0 00-.955.954 1 1 0 00.012.116L9.33 6.283 7.507 3.678a.954.954 0 10-1.014 0L4.67 6.283 1.897 4.897a1 1 0 00.012-.116.955.955 0 10-1.07.943l1.07 4.466h10.182l1.071-4.466a.952.952 0 00-.116-1.897"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h14v14H0z"/></clipPath></defs></g>', width: 14, height: 14 }, css: { body: '<g fill="currentColor"><path d="M126.4 60.9c-5.2.9-12.7 5.3-15.5 9.2-4.8 6.8-4.9 8.2-4.9 73.1V204h-6.6c-11.5 0-10.4-6.4-10.4 59.3 0 43.2.3 57.6 1.2 58.5.7.7 4.1 1.2 8.5 1.2h7.2l.3 55.3.3 55.3 2.6 4.9c3.2 6.2 9.3 11 15.9 12.4 7.2 1.5 254.8 1.5 262 0 6.6-1.4 12.7-6.2 15.9-12.4l2.6-4.9.3-55.3.3-55.3h7.2c4.4 0 7.8-.5 8.5-1.2.9-.9 1.2-15.3 1.2-58.5 0-65.7 1.1-59.3-10.4-59.3H406v-29.3l.1-29.2-42.2-41.8c-23.2-23-43.2-42.3-44.6-42.8-2.8-1-186.4-1-192.9 0M314.2 104c-.4 40.7-.4 40.6 7.8 44.7 4.3 2.3 5.1 2.3 40.2 2.3H398v53H114v-60.3c0-36.4.4-61.6 1-63.7 1.2-4.2 6.5-9.7 10.6-11 1.6-.4 44.8-.8 95.9-.7l93 .2zm59.6 20.5c9.4 9.3 17.2 17.3 17.2 17.6 0 .4-14.6.6-32.4.5-30.3-.1-32.5-.2-34.5-2-2-1.9-2.1-2.7-2.1-30.6 0-15.8.3-30.2.6-32l.7-3.2 16.6 16.4c9.1 8.9 24.4 23.9 33.9 33.3M415 264v51.9H97V212h318zm-17.2 112.5.2 53-2.2 4.5c-2.7 5.2-6 7.8-11.4 9-5.2 1.2-251.6 1.2-256.8 0-4.5-1-8.1-3.4-11-7.4-2.1-2.7-2.1-4-2.4-56.4-.1-29.5 0-54.2.2-54.9.4-1.1 25.9-1.3 141.8-1.1l141.3.3z"/><path d="M203.4 238.1c-1.8.5-5.3 2.4-8 4.1-12.9 8.9-15.4 30.3-4.9 42.6 5.3 6.1 12.3 9.2 21.1 9.2 7.8 0 12.4-1.5 17.3-5.6 3.7-3.1 3.8-3.7.6-5.8-2.3-1.5-2.6-1.5-7 1.6-4.1 2.9-5.5 3.3-11 3.3-5.4 0-7-.4-10.7-3-11.8-8.2-12.2-27.6-.6-36.8 6.1-4.9 17-5 22.6-.2l2.8 2.4 3-2.5 2.9-2.4-3-2.5c-5.6-4.7-17.2-6.7-25.1-4.4m46.3.3c-7.1 2.6-10.7 7.6-10.7 14.9 0 8 4.2 12.1 17.4 16.8 9.8 3.5 12 7.9 7.1 13.7-4.3 5.1-11.8 5.4-17.4.6l-2.9-2.4-2.6 2.1c-3.4 2.7-3.3 4.3.7 6.8 12.1 7.5 28.5 3 31.6-8.7 2.5-9.2-1.7-15.5-12.9-19.2-11.3-3.8-13-5.2-13-10.5 0-3.7 1-5.5 4.1-7 3.6-1.9 8.7-1.9 11.9 0 1.4.8 3.1 1.7 3.8 2.1s2.4-.4 3.8-1.7l2.4-2.3-2.1-2.2c-3.8-4.1-14.1-5.5-21.2-3m43.6-.3c-4.6 1.4-10.1 7.1-10.9 11.4-1.8 9.5 3 15.9 14.7 19.7 8.3 2.7 11.9 5.5 11.9 9.5 0 8.6-12.3 12.2-19.8 5.8l-2.8-2.4-3 2.4-2.9 2.3 2 2.2c2.7 3 4.6 3.9 10.5 5 14.5 2.8 26-6.7 23.6-19.5-1-5.2-5.5-9-14.4-11.9-9.5-3.2-12.2-5.4-12.2-10.1 0-7.2 11.1-11.4 17.3-6.5 1.4 1.1 2.9 2 3.4 2 1 0 5.3-4.2 5.3-5.2 0-.4-1.5-1.6-3.4-2.7-4-2.5-14.4-3.6-19.3-2"/></g>', width: 512, height: 512 }, "current-page-url": { body: '<g fill="currentColor"><path d="M44.8 86c-21.5 3.7-38.4 19.4-43.3 40.2-2.1 9-2.1 58.6 0 67.6 4.2 17.8 17.7 32.5 35.4 38.5 6.6 2.2 6.7 2.2 91.4 2.5l84.7.3v5.8c0 25.3 6.7 48.3 20 68.3 28.1 42.4 79.9 62.5 127.1 49.4 15.4-4.3 27.9-10.3 39.4-19l6-4.5 45 44.8c30.8 30.7 45.9 45.1 47.8 45.5C504 426.7 511 421 511 415c0-1.2-.6-3.3-1.4-4.8s-21.1-22.3-45-46.2c-24-23.9-43.6-43.8-43.6-44.2 0-.5 2-3.5 4.4-6.7 13.8-18.9 22.6-45.4 22.6-68.6v-9.2l10.3-.6c5.8-.3 13-1.5 16.8-2.6 12.8-4 24.9-14.3 31-26.3 5.2-10.3 5.9-15.5 5.9-45.8 0-20.8-.4-29-1.5-33.8-4.2-17.8-17.7-32.4-35.4-38.5l-6.6-2.2-209.5-.1c-115.2-.1-211.6.2-214.2.6m426.7 23.9c6.9 3.2 13.6 9.9 16.8 16.9 2.1 4.5 2.2 5.9 2.2 33.2s-.1 28.7-2.2 33.2c-3.2 7-9.9 13.7-16.8 16.9-5.5 2.6-7 2.9-17.1 2.9h-11.1l-1.2-4.3c-6.3-21-26.3-47.1-46.5-60.7-39.8-26.6-90.1-26.5-130.3.2-10.6 7.1-25.5 22.3-32.8 33.5-3.2 5.1-6 9.1-6.1 9s1.8-14.2 4-31.2l4.2-31-4.9-.3c-2.7-.2-5.1-.1-5.3.1s-1.3 8.9-2.5 19.3c-1.1 10.4-2.2 19-2.3 19.2-.2.1-1.8-5.5-3.5-12.5-1.8-7-3.6-14.5-4.2-16.6l-1-3.8-5.2.3-5.2.3-4.1 15.4c-5.8 21.9-6.2 21.7-9-5.7l-1.7-16.2h-6.4c-3.5 0-6.3.4-6.3.8 0 .5 1.8 14.3 4 30.7s4 30.5 4 31.2c0 .9 1.8 1.3 6.5 1.3h6.4l1-3.8c.5-2 2.4-10.4 4.2-18.5s3.6-14.2 4-13.5 2.8 9.1 5.5 18.5l4.7 17.3h6.4c3.4 0 6.3.2 6.3.5s-1.1 2.7-2.4 5.3-3.1 7.1-4 9.9l-1.8 5.3H46.5l-6-2.9c-6.9-3.2-13.6-9.9-16.8-16.9-2.1-4.5-2.2-5.9-2.2-33.2s.1-28.7 2.2-33.2c3.2-7 9.9-13.7 16.8-16.9l6-2.9h419zM355 152.6c33.3 8.4 59.8 35.1 68.6 68.9 2.1 8.2 2.6 12.3 2.6 23 .2 26.8-8.2 48-26.2 66.9-12.4 12.9-25.5 21-42.7 26.3-8 2.4-10.3 2.6-25.8 2.7-14.8.1-18.1-.2-25.4-2.2-33.6-9.2-59.1-34.7-68.3-68.3-2-7.3-2.3-10.6-2.2-25.4.1-15.5.3-17.8 2.7-25.8 5.3-17.2 13.4-30.3 26.3-42.7 15.9-15.2 34.3-23.6 57.4-26.4 7.2-.8 23.8.7 33 3"/><path d="M43 128.7c0 .5 2.3 14.9 5.1 32l5.2 31.3h5.3c6.1 0 4.8 2.4 11.5-21.8 2.5-9 4.5-14.8 5-14 .4.7 2.8 9.1 5.5 18.5l4.7 17.3h5.3c4.6 0 5.2-.3 5.7-2.3.3-1.2 2.7-15.4 5.4-31.5 3.3-20.4 5-28.5 5.5-26.5.3 1.5 2.8 15.7 5.4 31.5l4.7 28.8h12.6l1-3.8c.5-2 2.4-10.4 4.2-18.5s3.6-14.2 4-13.5 2.8 9.1 5.5 18.5l4.7 17.3h6.4c3.4 0 6.3-.1 6.3-.3.1-.1 2-14.4 4.3-31.7l4.3-31.5-4.9-.3c-2.7-.2-5.1-.1-5.3.1s-1.3 8.9-2.5 19.3c-1.1 10.4-2.2 19-2.4 19.2s-.6-.5-.8-1.5c-.3-1-2.7-8.5-5.2-16.6l-4.6-14.8-5.2.3-5.2.3-4 14.7c-2.2 8.1-4.2 14.4-4.6 14-.3-.4-1.4-8.5-2.4-18l-1.8-17.2H96.2l-.6 2.7c-.3 1.6-1.7 10.2-3.1 19.3-1.5 9-2.7 16.6-2.9 16.8-.2.1-1.8-5.5-3.5-12.5-1.8-7-3.6-14.5-4.2-16.6l-1-3.8-5.2.3-5.2.3-4.1 15c-2.3 8.2-4.4 14.3-4.7 13.5s-1.3-9-2.3-18.3L57.7 128h-7.4c-4 0-7.3.3-7.3.7m234.5 63.5c-4.9 4.3-11.9 14.3-15.4 22-4.2 9.3-6.1 19.1-6.1 31.8 0 10.4.1 11.2 2.5 13.5 2 2.1 3.4 2.5 8.2 2.5 3.2 0 6.3-.4 6.9-.8 2.4-1.6 3.4-5.5 3.4-13.4 0-14.7 3.9-25.8 13.4-38.4 6.5-8.7 6.3-15.4-.4-18.9-4.6-2.4-8.5-1.9-12.5 1.7m5.8 87.5c-3.2.6-7.2 5.1-7.9 8.8-1.8 9.9 10.7 16.2 17.9 9 7.2-7.3.3-19.7-10-17.8"/></g>', width: 512, height: 512 }, "custom-fields": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.356 9.075a1 1 0 01-.253-.037.45.45 0 01-.216-.15L9.13 6.13a.59.59 0 01-.188-.468q0-.15.038-.263a.6.6 0 01.15-.225l2.756-2.756a.6.6 0 01.216-.141.7.7 0 01.505 0 .6.6 0 01.216.141l2.757 2.756a.7.7 0 01.16.235.7.7 0 010 .496.7.7 0 01-.16.225l-2.757 2.757a.45.45 0 01-.216.15 1 1 0 01-.252.037M3.524 8.1a.67.67 0 01-.478-.187.64.64 0 01-.197-.488v-3.9q0-.281.197-.478a.65.65 0 01.478-.197h3.9q.3 0 .488.197a.67.67 0 01.187.478v3.9a.66.66 0 01-.187.488.66.66 0 01-.488.187zm7.05 7.05a.64.64 0 01-.487-.196.67.67 0 01-.188-.479v-3.9q0-.3.188-.487a.66.66 0 01.487-.188h3.9a.67.67 0 01.479.188.64.64 0 01.196.487v3.9a.65.65 0 01-.196.479.65.65 0 01-.479.196zm-7.05 0a.65.65 0 01-.478-.196.65.65 0 01-.197-.479v-3.9q0-.3.197-.487a.67.67 0 01.478-.188h3.9q.3 0 .488.188a.66.66 0 01.187.487v3.9a.67.67 0 01-.187.479.64.64 0 01-.488.196zm.45-8.175h3v-3h-3zm8.4.825 2.12-2.119-2.12-2.118-2.118 2.118zm-1.35 6.225h3v-3h-3zm-7.05 0h3v-3h-3z"/></g>', width: 18, height: 18 }, "debug-outline": { body: '<path fill="none" stroke="currentColor" d="m3.074 8.284.065-.558h-.811c-.595 0-1.127.46-1.127 1.09v.616c0 .066-.066.17-.21.17-.145 0-.212-.104-.212-.17V8.226c0-.436.385-.84.922-.84h1.627l.143-.255a8 8 0 01.396-.625l.236-.34-.29-.295L2.629 4.66l-.003-.002q0 .002-.028-.045a.94.94 0 01-.11-.407V2.999c-.001-.066.065-.17.21-.17s.211.103.211.17v.884c0 .227.07.437.193.61l.024.036.031.031.762.767.436.438.338-.517c.273-.42.44-.785.534-1.178.091-.385.104-.77.104-1.205 0-.688.603-1.36 1.405-1.578h.649c.389.105.77.326 1.052.614.289.295.446.632.446.964 0 .44.016.823.108 1.207.093.39.259.754.523 1.174l.336.532.442-.446.766-.773.03-.03.025-.036a1.06 1.06 0 00.192-.61V3c0-.067.066-.17.211-.17s.211.103.211.17v1.206a.94.94 0 01-.11.407l-.03.045-.002.002-1.191 1.217-.287.293.23.339c.148.216.283.419.4.625l.144.253h1.63c.538 0 .923.404.923.84v1.206c0 .066-.067.17-.211.17-.145 0-.212-.104-.212-.17v-.616c0-.631-.53-1.09-1.125-1.09h-.813l.066.558q.019.16.02.325c0 .455-.092.889-.258 1.288l-.128.307.233.236.865.877h.001l.01.013.023.037a1 1 0 01.056.122c.037.103.05.188.05.222v1.206c0 .066-.066.17-.21.17-.145 0-.212-.104-.212-.17v-.82c0-.227-.07-.436-.192-.61l-.025-.036-.03-.031-.436-.437-.366-.367-.353.377c-.532.568-1.086 1.069-1.821 1.26l-.002.001-.071.019-.014.004-.014.004-.02.002a.1.1 0 01-.06-.021l-.008-.013-.001-.002V7.69c0-.599-.509-1.036-1.069-1.036s-1.07.436-1.07 1.036v4.559l-.01.013a.1.1 0 01-.059.021h-.017v-.001l-.01-.002-.01-.003-.005-.001-.014-.006-.036-.01c-.773-.197-1.312-.694-1.85-1.267l-.354-.377-.365.367-.435.437-.03.03-.026.036a1.06 1.06 0 00-.192.61v.821c0 .066-.067.17-.211.17-.145 0-.212-.104-.212-.17v-1.206a.8.8 0 01.051-.222 1 1 0 01.08-.16l.009-.011v-.001l.866-.877.233-.236-.128-.307a3.3 3.3 0 01-.257-1.288q0-.165.02-.325Z"/>', width: 14, height: 14 }, decrypt: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.256 17.917q-.63 0-1.069-.438a1.45 1.45 0 01-.437-1.069V8.59q0-.631.438-1.07a1.45 1.45 0 011.068-.437H12.5V5.417q0-1.042-.73-1.771a2.4 2.4 0 00-1.77-.73q-.895 0-1.57.56-.677.558-.858 1.393a.86.86 0 01-.239.394.56.56 0 01-.394.154.62.62 0 01-.49-.21.5.5 0 01-.127-.467 3.64 3.64 0 011.261-2.194q1.03-.88 2.417-.88 1.56 0 2.655 1.095t1.095 2.656v1.666h.993q.633 0 1.07.438t.437 1.069v7.82q0 .631-.437 1.07a1.46 1.46 0 01-1.07.437zm0-1.25h9.487a.25.25 0 00.185-.072.25.25 0 00.072-.185V8.59a.25.25 0 00-.072-.185.25.25 0 00-.185-.072H5.256a.25.25 0 00-.184.072A.25.25 0 005 8.59v7.82a.25.25 0 00.072.185.25.25 0 00.184.072M10 13.958q.608 0 1.033-.425.426-.426.425-1.033 0-.608-.425-1.033A1.4 1.4 0 0010 11.042q-.608 0-1.033.425a1.4 1.4 0 00-.425 1.033q0 .608.425 1.033.426.425 1.033.425"/></g>', width: 20, height: 20 }, delete: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.083 17.083q-.624 0-1.062-.438a1.45 1.45 0 01-.438-1.062V4.999h-.208a.605.605 0 01-.625-.625.605.605 0 01.625-.625H7.5a.7.7 0 01.218-.52.74.74 0 01.532-.209h3.5q.313 0 .532.208a.7.7 0 01.218.521h3.125a.607.607 0 01.625.625.606.606 0 01-.625.625h-.208v10.584q0 .624-.438 1.062a1.45 1.45 0 01-1.062.438zm-.25-12.084v10.584q0 .104.074.177a.24.24 0 00.176.072h7.834q.104 0 .177-.072a.24.24 0 00.073-.178V5zm2 8.542a.61.61 0 00.625.625.6.6 0 00.449-.177.6.6 0 00.176-.448V7.29a.6.6 0 00-.176-.448.6.6 0 00-.449-.177.606.606 0 00-.625.625zm3.084 0q0 .27.176.448a.6.6 0 00.449.177.6.6 0 00.448-.177.6.6 0 00.177-.448V7.29a.6.6 0 00-.177-.448.6.6 0 00-.448-.177.6.6 0 00-.449.177.6.6 0 00-.176.448zM5.833 4.999v10.584q0 .104.074.177a.24.24 0 00.176.072h-.25z"/></g>', width: 20, height: 20 }, "deployed-code": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M6.417 11.332V7.336l-3.5-2.027v3.995zm1.166 0 3.5-2.028V5.31l-3.5 2.027zM7 6.329l3.456-1.997L7 2.334 3.544 4.332zm-4.667 3.996A1.14 1.14 0 011.75 9.32V4.682a1.14 1.14 0 01.583-1.007l4.084-2.348a1.15 1.15 0 011.166 0l4.084 2.348q.276.16.43.423t.153.584v4.637a1.14 1.14 0 01-.583 1.006l-4.084 2.348a1.15 1.15 0 01-1.166 0z"/><path d="m7 6.33 3.456-1.998L7 2.334 3.544 4.332z"/></g>', width: 14, height: 14 }, "deployed-code-alert": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M7.964 2.625 3.95 4.947l4.117 2.38 4.116-2.38L8.17 2.625a.2.2 0 00-.102-.032.2.2 0 00-.103.032M2.4 10.43V5.373a1.18 1.18 0 01.603-1.041l4.461-2.568q.154-.084.296-.124.143-.04.306-.04.165 0 .315.04t.288.124l4.462 2.568q.286.167.444.44t.158.6V7.35q0 .212-.144.356a.48.48 0 01-.356.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356V5.775L8.653 8.13a1.2 1.2 0 01-1.206 0L3.4 5.775v4.644a.2.2 0 00.026.096.2.2 0 00.076.077l3.853 2.242a.49.49 0 01.25.425.46.46 0 01-.247.428.48.48 0 01-.497.002L3.003 11.47a1.18 1.18 0 01-.603-1.04m9.667 3.914a.3.3 0 00.227-.093.3.3 0 00.093-.227.3.3 0 00-.093-.227.3.3 0 00-.227-.094.3.3 0 00-.227.094.3.3 0 00-.094.227q0 .133.094.227a.3.3 0 00.227.093m0-1.307q.117 0 .206-.089a.28.28 0 00.088-.206v-1.82q0-.12-.088-.209a.285.285 0 00-.413.002.28.28 0 00-.088.206v1.82q0 .12.088.208a.28.28 0 00.207.088m0 2.448q-1.25 0-2.125-.875a2.9 2.9 0 01-.875-2.125q0-1.248.875-2.124a2.9 2.9 0 012.125-.876q1.248 0 2.124.876t.876 2.124-.876 2.125a2.9 2.9 0 01-2.124.875"/><path d="M7.964 2.625 3.95 4.947l4.117 2.38 4.116-2.38L8.17 2.625a.2.2 0 00-.102-.032.2.2 0 00-.103.032"/></g>' }, description: { body: '<path fill="currentColor" d="M3 10.833h4a.5.5 0 00.359-.141.5.5 0 00.141-.359.5.5 0 00-.141-.358A.5.5 0 007 9.833H3a.485.485 0 00-.5.5.486.486 0 00.5.5m0-2.666h4a.486.486 0 00.5-.5.5.5 0 00-.141-.359A.5.5 0 007 7.167H3a.485.485 0 00-.5.5.484.484 0 00.5.5m-1.8 5.166q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V1.867q0-.5.35-.85t.85-.35H6a1.2 1.2 0 01.85.35l2.8 2.8q.166.166.259.383.09.216.091.467v7.466q0 .5-.35.85t-.85.35zM6 4.067v-2.4H1.2q-.066 0-.133.066Q1 1.801 1 1.867v10.266q0 .068.067.134t.133.066h7.6q.067 0 .133-.066.067-.068.067-.134V4.667H6.6a.58.58 0 01-.425-.176A.58.58 0 016 4.067"/>', width: 10, height: 14 }, "desktop-able-chart": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M12.462 13.667H3.537q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855V3.54q0-.506.35-.855.351-.35.855-.35h8.924q.504 0 .855.35.35.35.35.855v8.923q0 .506-.35.855-.35.35-.856.35M3.332 5.501h9.334V3.539a.2.2 0 00-.065-.14.2.2 0 00-.14-.065H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.141zm1.795 1H3.333v5.961q0 .077.064.141.065.064.141.064h1.59zm5.744 0v6.166h1.59a.2.2 0 00.14-.064.2.2 0 00.065-.14V6.5zm-1 0H6.128v6.166h3.744z"/></g></g>' }, "desktop-combobox": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.667 11q-1.249 0-2.125-.876A2.9 2.9 0 011.667 8q0-1.248.875-2.124A2.9 2.9 0 014.667 5h6.666q1.249 0 2.125.876.875.875.875 2.124 0 1.248-.875 2.124a2.9 2.9 0 01-2.125.876zm0-1h6.666q.834 0 1.417-.583.583-.584.583-1.417t-.583-1.417A1.93 1.93 0 0011.333 6H4.667q-.834 0-1.417.583A1.93 1.93 0 002.667 8q0 .834.583 1.417T4.667 10m1.122-1.042L7.3 7.446a.4.4 0 00.121-.276.38.38 0 00-.121-.283.4.4 0 00-.28-.124.4.4 0 00-.279.124L5.367 8.262l-.375-.375a.4.4 0 00-.276-.121.38.38 0 00-.283.121.4.4 0 00-.124.28q0 .154.124.28l.512.51q.18.181.422.181.24 0 .422-.18"/></g></g>' }, "desktop-generic": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3.538 11q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855v-3.59q0-.505.35-.855.351-.35.855-.35h8.924q.504 0 .855.35.35.35.35.855v3.59q0 .505-.35.855t-.856.35zm0-1h8.924a.2.2 0 00.14-.064.2.2 0 00.065-.141v-3.59a.2.2 0 00-.065-.14.2.2 0 00-.14-.065H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.141v3.59q0 .077.064.14.065.066.141.065"/></g></g>' }, "desktop-menubar": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M16 0v16H0V0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3 2.205q0-.506.35-.855Q3.7 1 4.205 1h7.59q.505 0 .855.35t.35.855v1.27q0 .504-.35.855-.35.35-.855.35h-7.59q-.505 0-.855-.35A1.16 1.16 0 013 3.474zm.983 0v1.27q0 .09.058.147a.2.2 0 00.147.058h7.624a.2.2 0 00.147-.058.2.2 0 00.058-.148V2.205a.2.2 0 00-.058-.147.2.2 0 00-.147-.058H4.189a.2.2 0 00-.148.058.2.2 0 00-.058.147M3 7.346q0-.506.35-.855.35-.35.855-.35h7.59q.505 0 .855.35t.35.855v6.449q0 .505-.35.855t-.855.35h-7.59q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855zm.983 0v6.449q0 .09.058.147a.2.2 0 00.147.058h7.624a.2.2 0 00.147-.058.2.2 0 00.058-.147V7.346a.2.2 0 00-.058-.147.2.2 0 00-.147-.058H4.189a.2.2 0 00-.148.058.2.2 0 00-.058.147"/></g></g>' }, "desktop-okcode": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M5.372 11.666q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855v-.667q0-.212.143-.356a.48.48 0 01.357-.144q.213 0 .356.144a.48.48 0 01.144.356v.667q0 .077.064.14.064.066.14.065h7.59a.2.2 0 00.141-.064.2.2 0 00.065-.141V3.999h-8v.872q0 .212-.144.357a.48.48 0 01-.356.143.48.48 0 01-.357-.143.48.48 0 01-.143-.357v-2q0-.505.35-.855t.855-.35h7.59q.504 0 .855.35.35.35.35.855v7.59q0 .505-.35.855t-.856.35zm-2.334 2.333q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855v-8.09q0-.212.144-.356a.48.48 0 01.356-.143q.213 0 .357.143a.48.48 0 01.143.357v8.09q0 .076.064.14.065.064.141.064h8.09q.212 0 .357.144a.5.5 0 01.143.356q0 .213-.143.357a.48.48 0 01-.357.143zm6.079-6.166h-4.45a.48.48 0 01-.357-.144.48.48 0 01-.143-.356q0-.213.143-.357a.48.48 0 01.357-.143h4.45L8.113 5.816a.46.46 0 01-.136-.343.495.495 0 01.5-.492q.21 0 .349.139l1.784 1.79q.18.182.181.423 0 .24-.18.422l-1.792 1.79a.47.47 0 01-.343.14.48.48 0 01-.353-.146.47.47 0 01-.138-.345q0-.206.138-.345z"/></g></g>' }, "desktop-windows": { body: '<mask id="svgID0" width="16" height="17" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .5h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.167 14.5a.485.485 0 01-.5-.5.486.486 0 01.5-.5h.834v-1.333H2.867q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V4.033q0-.5.35-.85t.85-.35h10.267q.5 0 .85.35t.35.85v6.934q0 .5-.35.85t-.85.35H9V13.5h.833q.216 0 .359.141a.5.5 0 01.14.359.5.5 0 01-.14.359.5.5 0 01-.36.14zm-3.3-3.333h10.267q.084 0 .142-.06a.2.2 0 00.058-.14V4.033a.2.2 0 00-.058-.141.2.2 0 00-.142-.059H2.867a.2.2 0 00-.141.059.2.2 0 00-.059.141v6.934q0 .083.059.14.059.06.141.06"/></g>', height: 17 }, devices: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.75 14.27V5.25q0-.646.438-1.083a1.45 1.45 0 011.062-.438h11.417q.25 0 .437.177a.6.6 0 01.188.448q0 .27-.188.448a.62.62 0 01-.437.177H5.25a.24.24 0 00-.177.073A.27.27 0 005 5.25v9.02h3.854q.376 0 .657.282.28.28.28.656a.9.9 0 01-.28.667.92.92 0 01-.657.27H3.021a.9.9 0 01-.667-.27.9.9 0 01-.27-.667q0-.375.27-.656a.9.9 0 01.667-.281zm9.083 1.876a.74.74 0 01-.531-.209.7.7 0 01-.219-.52V7.708a.7.7 0 01.219-.52.74.74 0 01.531-.209h4.355q.313 0 .52.208a.7.7 0 01.209.521v7.709q0 .313-.209.52a.7.7 0 01-.52.209zm.5-1.875h3.334V8.229h-3.334z"/></g>', width: 20, height: 20 }, dnd: { body: '<path fill="currentColor" d="M3 5.5h4.013a.46.46 0 00.35-.144A.5.5 0 007.5 5a.48.48 0 00-.144-.356A.48.48 0 007 4.5H2.988a.46.46 0 00-.35.144A.5.5 0 002.5 5q0 .213.143.356A.48.48 0 003 5.5M5 10a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069Q.786 7.863.393 6.95A4.9 4.9 0 010 5q0-1.038.394-1.95a5 5 0 011.068-1.587Q2.139.787 3.05.392A4.9 4.9 0 015 0q1.038 0 1.95.394a5 5 0 011.587 1.069q.675.675 1.069 1.587T10 5t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 015 10m0-1q1.662 0 2.832-1.168Q9 6.662 9 5T7.832 2.169 5 1Q3.338 1 2.169 2.168.999 3.339 1 5t1.169 2.832Q3.338 9 5 9"/>', width: 10, height: 10 }, "dnd-on": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6 9.562h6q.24 0 .4-.161A.55.55 0 0012.563 9a.54.54 0 00-.161-.401.55.55 0 00-.401-.162H6a.54.54 0 00-.4.162.55.55 0 00-.162.401q0 .24.161.4A.55.55 0 006 9.563m3.001 6.563a6.9 6.9 0 01-2.779-.561 7.2 7.2 0 01-2.262-1.523 7.2 7.2 0 01-1.524-2.261A6.9 6.9 0 011.875 9q0-1.477.561-2.779A7.2 7.2 0 013.959 3.96 7.2 7.2 0 016.22 2.436 6.9 6.9 0 019 1.875q1.478 0 2.779.561a7.2 7.2 0 012.262 1.523 7.2 7.2 0 011.524 2.261q.561 1.3.561 2.779 0 1.477-.561 2.779a7.2 7.2 0 01-1.523 2.262 7.2 7.2 0 01-2.261 1.524A6.9 6.9 0 019 16.125M9 15q2.513 0 4.256-1.744T15 9t-1.744-4.256Q11.513 3 9 3T4.744 4.744 3 9t1.744 4.256Q6.487 15 9 15"/></g>', width: 18, height: 18 }, "do-not-disturb-on": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.667 10.625h6.667q.265 0 .445-.18t.18-.445a.6.6 0 00-.18-.445.6.6 0 00-.445-.18H6.667a.6.6 0 00-.445.18.6.6 0 00-.18.446q0 .265.18.445t.445.18m3.335 7.292a7.7 7.7 0 01-3.088-.623A8 8 0 014.4 15.602a8 8 0 01-1.692-2.513 7.7 7.7 0 01-.624-3.087q0-1.642.623-3.088A8 8 0 014.4 4.4a8 8 0 012.513-1.693A7.7 7.7 0 0110 2.084q1.642 0 3.088.623 1.445.624 2.514 1.692a8 8 0 011.693 2.513q.623 1.444.623 3.087a7.7 7.7 0 01-.623 3.088 8 8 0 01-1.692 2.514 8 8 0 01-2.513 1.692 7.7 7.7 0 01-3.087.624m-.001-1.25q2.79 0 4.729-1.937 1.937-1.938 1.937-4.73 0-2.79-1.937-4.729Q12.793 3.334 10 3.334q-2.79 0-4.729 1.937-1.937 1.937-1.937 4.73 0 2.79 1.937 4.729 1.938 1.937 4.73 1.937"/></g>', width: 20, height: 20 }, "do-not-disturb-on-red": { body: '<g fill="none"><mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6 9.562h6q.24 0 .4-.161A.55.55 0 0012.563 9a.54.54 0 00-.161-.401.55.55 0 00-.401-.162H6a.54.54 0 00-.4.162.55.55 0 00-.162.401q0 .24.161.4A.55.55 0 006 9.563m3.001 6.563a6.9 6.9 0 01-2.779-.561 7.2 7.2 0 01-2.262-1.523 7.2 7.2 0 01-1.524-2.261A6.9 6.9 0 011.875 9q0-1.477.561-2.779A7.2 7.2 0 013.959 3.96 7.2 7.2 0 016.22 2.436 6.9 6.9 0 019 1.875q1.478 0 2.779.561a7.2 7.2 0 012.262 1.523 7.2 7.2 0 011.524 2.261q.561 1.3.561 2.779 0 1.477-.561 2.779a7.2 7.2 0 01-1.523 2.262 7.2 7.2 0 01-2.261 1.524A6.9 6.9 0 019 16.125M9 15q2.513 0 4.256-1.744T15 9t-1.744-4.256Q11.513 3 9 3T4.744 4.744 3 9t1.744 4.256Q6.487 15 9 15"/></g></g>', width: 18, height: 18 }, "dock-to-right": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.98 15.375q-.56 0-.958-.397a1.3 1.3 0 01-.397-.959V3.981q0-.561.397-.959.398-.397.959-.397h10.038q.561 0 .959.397.397.398.397.959v10.038q0 .561-.397.959a1.3 1.3 0 01-.959.397zm3.145-1.125h6.894a.22.22 0 00.159-.072.22.22 0 00.072-.159V3.981a.22.22 0 00-.072-.159.22.22 0 00-.159-.072H7.125z"/></g>', width: 18, height: 18 }, docker: { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M7.531 2.375a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V2.53a.156.156 0 00-.156-.156zM3.781 4.25a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156v-.938a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156v-.938a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156v-.938a.156.156 0 00-.156-.156zm4.681.719-.142.203a2.9 2.9 0 00-.382.89c-.143.604-.056 1.171.252 1.656-.372.207-1.007.278-1.127.282H1.124a.625.625 0 00-.625.625c0 .625.136 1.539.433 2.349.34.888.847 1.543 1.506 1.944.738.45 1.938.707 3.297.707a10 10 0 001.831-.165 7.7 7.7 0 002.39-.865 6.6 6.6 0 001.63-1.329c.784-.883 1.25-1.866 1.597-2.739l.004-.002c.937.038 1.503-.324 1.81-.625.192-.183.343-.405.441-.652l.061-.179-.148-.116c-.04-.032-.42-.318-1.221-.318q-.318.002-.631.055c-.155-1.058-1.033-1.575-1.072-1.598zM1.906 6.125a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V6.28a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V6.28a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V6.28a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V6.28a.156.156 0 00-.156-.156zm1.875 0a.156.156 0 00-.156.156v.938c0 .086.07.156.156.156h.938c.086 0 .156-.07.156-.156V6.28a.156.156 0 00-.156-.156z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M.5.5h15v15H.5z"/></clipPath></defs></g>' }, docs: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.667 13.854h4.166a.6.6 0 00.448-.176.6.6 0 00.177-.449.62.62 0 00-.177-.437.6.6 0 00-.448-.188H6.667q-.271 0-.448.188a.62.62 0 00-.178.437.61.61 0 00.625.625m0-3.229h6.666a.61.61 0 00.625-.625.6.6 0 00-.177-.448.6.6 0 00-.448-.177H6.667a.606.606 0 00-.625.625.605.605 0 00.625.625m0-3.23h6.666q.27 0 .448-.187a.62.62 0 00.177-.437.606.606 0 00-.625-.625H6.667a.605.605 0 00-.625.625q0 .25.177.437a.6.6 0 00.447.188m-2.25 8.438h11.166q.084 0 .167-.083t.083-.167V4.417q0-.083-.083-.167-.084-.083-.167-.083H4.417q-.084 0-.167.083-.084.083-.083.167v11.166q0 .083.083.167.082.084.167.083m0 1.25q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063V4.417q0-.625.437-1.063a1.45 1.45 0 011.063-.437h3.708q.083-.688.615-1.178.53-.489 1.26-.489.75 0 1.27.49.522.489.605 1.177h3.708q.625 0 1.063.437.437.438.437 1.063v11.166q0 .625-.437 1.063a1.45 1.45 0 01-1.063.437zM10 3.625A.61.61 0 0010.625 3a.6.6 0 00-.177-.448.6.6 0 00-.448-.177.606.606 0 00-.625.625.605.605 0 00.625.625"/></g>', width: 20, height: 20 }, "donut-large": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M7.35 14.3q-2.43-.243-4.05-2.048Q1.685 10.45 1.685 8T3.3 3.754Q4.918 1.957 7.35 1.7v1.41q-1.843.253-3.05 1.64T3.094 8 4.3 11.25t3.05 1.64zm1.334 0v-1.41a4.67 4.67 0 002.816-1.387 5.02 5.02 0 001.407-2.836h1.41q-.22 2.249-1.803 3.834-1.581 1.584-3.83 1.799m4.223-6.967a4.93 4.93 0 00-1.4-2.836A4.7 4.7 0 008.684 3.11V1.7q2.255.214 3.837 1.796 1.581 1.583 1.796 3.837z"/></g></g>' }, "double-arrow-left": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M20 20H0V0h20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M15.002 5.728q.18.18.18.439 0 .258-.18.439L11.62 10l3.382 3.394a.62.62 0 01.183.429.58.58 0 01-.184.45.6.6 0 01-.439.18.6.6 0 01-.439-.18l-3.745-3.746a.7.7 0 01-.213-.527.7.7 0 01.213-.527l3.745-3.745a.62.62 0 01.429-.184.58.58 0 01.45.184m-5.292 0q.18.18.18.439 0 .258-.18.439L6.328 10l3.382 3.394a.62.62 0 01.183.429.58.58 0 01-.183.45.6.6 0 01-.44.18.6.6 0 01-.438-.18l-3.746-3.746A.7.7 0 014.874 10q0-.15.048-.28a.7.7 0 01.165-.247l3.746-3.745a.62.62 0 01.428-.184q.255-.01.45.184"/></g>', width: 20, height: 20 }, "double-arrow-right": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.998 14.272a.6.6 0 01-.18-.439q0-.258.18-.439L8.38 10 4.998 6.606a.62.62 0 01-.183-.429.58.58 0 01.183-.45.6.6 0 01.44-.18q.258 0 .439.18l3.745 3.746a.7.7 0 01.213.527q0 .15-.048.28a.7.7 0 01-.165.247l-3.745 3.745a.62.62 0 01-.429.184.58.58 0 01-.45-.184m5.292 0a.6.6 0 01-.181-.439q0-.258.181-.439L13.672 10 10.29 6.606a.62.62 0 01-.183-.429.58.58 0 01.183-.45.6.6 0 01.44-.18q.257 0 .438.18l3.746 3.746a.7.7 0 01.213.527q0 .15-.048.28a.7.7 0 01-.165.247l-3.746 3.745a.62.62 0 01-.428.184.58.58 0 01-.45-.184"/></g>', width: 20, height: 20 }, download: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.04 14.354q-1.923 0-3.34-1.239a4.8 4.8 0 01-1.654-3.11.58.58 0 01.154-.488.63.63 0 01.483-.209.77.77 0 01.49.156.67.67 0 01.249.397 3.52 3.52 0 001.229 2.238 3.57 3.57 0 002.389.879 3.57 3.57 0 002.39-.879 3.52 3.52 0 001.228-2.238.67.67 0 01.249-.397.77.77 0 01.49-.156q.293 0 .483.21a.58.58 0 01.154.487 4.8 4.8 0 01-1.654 3.11q-1.417 1.239-3.34 1.239m-.688-6.778V2.288q0-.294.198-.49a.67.67 0 01.49-.198q.293 0 .49.197a.67.67 0 01.198.49v5.29l1.214-1.214a.65.65 0 01.479-.202.68.68 0 01.487.216.72.72 0 01.207.483.64.64 0 01-.207.483L8.62 9.631a.76.76 0 01-.58.235.76.76 0 01-.58-.235L5.172 7.343a.66.66 0 01-.195-.472.7.7 0 01.195-.494.67.67 0 01.49-.214q.277 0 .49.214z"/></g>' }, "download-for-offline": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M5.333 11.167h5.334q.212 0 .356-.144a.48.48 0 00.144-.357.48.48 0 00-.144-.356.48.48 0 00-.356-.143H5.333a.48.48 0 00-.356.143.48.48 0 00-.144.357q0 .212.144.356a.48.48 0 00.356.144M7.5 7.177l-.882-.872a.48.48 0 00-.343-.142.5.5 0 00-.36.154.48.48 0 00-.144.35q0 .206.144.35l1.663 1.664q.18.18.422.18.24 0 .422-.18l1.663-1.663a.496.496 0 00-.002-.704.5.5 0 00-.344-.149.5.5 0 00-.357.14l-.882.872v-2.51a.48.48 0 00-.144-.357A.48.48 0 008 4.167a.48.48 0 00-.356.143.48.48 0 00-.144.357zm.501 7.156a6.2 6.2 0 01-2.47-.498A6.4 6.4 0 013.52 12.48a6.4 6.4 0 01-1.354-2.01 6.2 6.2 0 01-.5-2.47q0-1.315.5-2.47a6.4 6.4 0 011.352-2.01 6.4 6.4 0 012.01-1.354 6.2 6.2 0 012.47-.5q1.314 0 2.47.5 1.156.498 2.011 1.353t1.354 2.01.5 2.47-.5 2.47a6.4 6.4 0 01-1.353 2.011 6.4 6.4 0 01-2.01 1.354 6.2 6.2 0 01-2.47.5"/></g></g>' }, "download-outline": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.334 13.833a.485.485 0 01-.5-.5.486.486 0 01.5-.5h9.333q.217 0 .359.142a.5.5 0 01.141.358.5.5 0 01-.141.36.5.5 0 01-.359.14zm4.667-2.983a.6.6 0 01-.225-.042.54.54 0 01-.192-.125l-2.35-2.35A.45.45 0 015.101 8q0-.2.15-.35a.48.48 0 01.7 0L7.5 9.2V2.667a.486.486 0 01.5-.5q.216 0 .358.141a.5.5 0 01.142.359V9.2l1.566-1.567A.45.45 0 0110.4 7.5q.2 0 .35.15a.48.48 0 010 .7l-2.334 2.333a.54.54 0 01-.191.125.6.6 0 01-.225.042"/></g>' }, "download-underline": { body: '<mask id="svgID0" width="25" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.978 0h24v24h-24z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.978 15.238a.83.83 0 01-.633-.256l-3.11-3.109a.73.73 0 01-.212-.522.7.7 0 01.212-.532.75.75 0 01.535-.225.7.7 0 01.535.21l1.922 1.923v-7.65q0-.32.216-.535a.73.73 0 01.534-.215q.32 0 .535.215a.73.73 0 01.215.535v7.65l1.924-1.923a.7.7 0 01.53-.205.74.74 0 01.539.22q.217.217.217.527a.72.72 0 01-.217.527l-3.11 3.11a.83.83 0 01-.633.255M7.284 19.5q-.757 0-1.282-.525a1.75 1.75 0 01-.525-1.283V15.75q0-.32.215-.535A.73.73 0 016.228 15q.318 0 .534.215a.73.73 0 01.216.535v1.942q0 .116.096.212a.3.3 0 00.211.096H18.67a.3.3 0 00.211-.096.3.3 0 00.096-.212V15.75q0-.32.216-.535a.73.73 0 01.534-.215q.32 0 .535.215a.73.73 0 01.215.535v1.942q0 .758-.524 1.283-.525.525-1.283.525z"/></g>', width: 25, height: 24 }, draft: { body: '<g fill="none"><mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.73 16.125q-.567 0-.961-.394a1.3 1.3 0 01-.394-.962V3.231q0-.57.394-.962.393-.394.962-.394h5.395q.271 0 .522.105.25.105.435.29l3.147 3.147q.185.184.29.435.105.25.105.522v8.395q0 .569-.394.962a1.3 1.3 0 01-.962.394zm5.395-10.428q0 .29.194.484t.484.194H13.5L10.125 3z"/></g></g>', width: 18, height: 18 }, "draw-highlight": { body: '<g fill="none"><g fill="currentColor" clip-path="url(#svgID0)"><path d="M15.96 6.69 9.778.598a.14.14 0 00-.196 0L5.42 4.701a.14.14 0 00-.002.197l.002.002.697.687-2.044 2.011a.14.14 0 00-.002.198l.002.001.689.679-3.299 3.262h-.95a.14.14 0 00-.14.14v.962c0 .077.062.14.139.14h6.016a.14.14 0 00.098-.04l1.327-1.319.705.694a.14.14 0 00.195 0l2.043-2.016.7.689a.14.14 0 00.195 0l4.164-4.103c.06-.052.06-.14.005-.195m-9.905 5.037H3.261l2.344-2.32 1.398 1.377zm2.7-1.083-2.99-2.946 1.197-1.18 2.99 2.947zm2.94-1.327L7.111 4.8l2.57-2.53 4.583 4.517zm2.446 4.638H.744a.744.744 0 100 1.489h13.397a.744.744 0 100-1.489"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, "drive-file-move": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.376 11.785q-.55 0-.94-.388a1.28 1.28 0 01-.387-.939V3.542q0-.55.388-.94a1.28 1.28 0 01.939-.387h2.858a1.3 1.3 0 01.932.384l.835.835h4.625q.55 0 .939.388.388.389.388.939v5.697q0 .55-.388.94a1.28 1.28 0 01-.94.387zm0-1.327h9.25V4.761H6.453l-1.219-1.22H2.376zm4.64-2.218-.41.41a.58.58 0 00-.171.43q0 .258.181.44a.6.6 0 00.44.174.6.6 0 00.44-.175l1.44-1.44q.2-.201.2-.468a.64.64 0 00-.2-.467l-1.44-1.44a.6.6 0 00-.44-.175.6.6 0 00-.45.185.58.58 0 00-.171.429q0 .258.17.43l.411.41H5.254a.6.6 0 00-.447.181.6.6 0 00-.181.447q0 .265.181.447t.447.182z"/></g>', width: 14, height: 14 }, "dry-run": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M9.292 12.604a.71.71 0 01-.77.042q-.397-.208-.397-.667V8.021q0-.459.396-.667a.71.71 0 01.77.042l3.084 1.958a.7.7 0 01.261.292q.073.167.073.354a.9.9 0 01-.073.354.7.7 0 01-.26.292zm-.854 5.167a9 9 0 01-1.49-.458 7.4 7.4 0 01-1.364-.73.51.51 0 01-.271-.426.6.6 0 01.187-.49.64.64 0 01.407-.188q.24-.02.427.104.52.334 1.094.574.572.239 1.197.364.209.062.365.24a.6.6 0 01.156.406.61.61 0 01-.208.49.55.55 0 01-.5.114m-4.125-3.313q-.23.23-.5.198a.54.54 0 01-.417-.26 7 7 0 01-.76-1.365 7.3 7.3 0 01-.448-1.49.55.55 0 01.115-.49.6.6 0 01.489-.218q.208 0 .396.157a.75.75 0 01.25.385q.146.626.375 1.188.23.563.562 1.083a.65.65 0 01.104.427.6.6 0 01-.166.385m-1.5-5.291a.63.63 0 01-.5-.219.53.53 0 01-.125-.49q.165-.811.448-1.5.28-.687.74-1.354a.61.61 0 01.437-.26q.27-.032.5.198a.6.6 0 01.166.385.65.65 0 01-.104.427 6.4 6.4 0 00-.937 2.271.77.77 0 01-.24.385.57.57 0 01-.385.157m3.479-4.709q-.209.125-.438.084a.7.7 0 01-.375-.188.66.66 0 01-.187-.51.51.51 0 01.27-.427 8 8 0 011.387-.73 9 9 0 011.489-.458.52.52 0 01.479.114.59.59 0 01.208.47.64.64 0 01-.156.416.64.64 0 01-.385.23 6 6 0 00-1.167.384 8 8 0 00-1.125.615m5.27 13.312a9 9 0 001.49-.457q.719-.292 1.364-.73a.51.51 0 00.271-.426.6.6 0 00-.187-.49.64.64 0 00-.407-.188.65.65 0 00-.427.104 7 7 0 01-1.094.574q-.572.239-1.197.364a.8.8 0 00-.365.24.6.6 0 00-.156.406q0 .312.208.49a.55.55 0 00.5.114m4.125-3.312q.23.23.5.198.27-.03.417-.26.459-.646.76-1.365.303-.718.448-1.49a.55.55 0 00-.115-.49.6.6 0 00-.489-.218.6.6 0 00-.396.157.75.75 0 00-.25.385 8 8 0 01-.375 1.188q-.229.563-.562 1.083a.65.65 0 00-.104.427q.021.24.166.385m1.5-5.291a.63.63 0 00.5-.219.53.53 0 00.125-.49 8.4 8.4 0 00-.448-1.5 7.2 7.2 0 00-.74-1.354.61.61 0 00-.437-.26q-.27-.032-.5.198a.6.6 0 00-.166.385q-.021.24.104.427a6.4 6.4 0 01.937 2.271.77.77 0 00.24.385.57.57 0 00.385.157m-3.479-4.709a.6.6 0 00.438.084.7.7 0 00.375-.188.66.66 0 00.187-.51.51.51 0 00-.27-.427 8 8 0 00-1.386-.73 9 9 0 00-1.49-.458.52.52 0 00-.479.114.59.59 0 00-.208.47q0 .228.156.416a.64.64 0 00.385.23q.584.125 1.167.384a8 8 0 011.125.615"/></g>', width: 20, height: 20 }, edge: { body: '<g fill="none"><g clip-path="url(#svgID6)"><path fill="url(#svgID4)" d="M16.245 13.396q-.36.188-.74.331a7.2 7.2 0 01-2.525.454c-3.326 0-6.224-2.288-6.224-5.225a2.21 2.21 0 011.155-1.92c-3.01.127-3.783 3.262-3.783 5.1 0 5.193 4.787 5.72 5.819 5.72.556 0 1.395-.162 1.898-.32l.092-.032a9.02 9.02 0 004.682-3.712.282.282 0 00-.374-.396"/><path fill="url(#svgID0)" d="M16.245 13.396q-.36.188-.74.331a7.2 7.2 0 01-2.525.454c-3.326 0-6.224-2.288-6.224-5.225a2.21 2.21 0 011.155-1.92c-3.01.127-3.783 3.262-3.783 5.1 0 5.193 4.787 5.72 5.819 5.72.556 0 1.395-.162 1.898-.32l.092-.032a9.02 9.02 0 004.682-3.712.282.282 0 00-.374-.396" opacity=".35"/><path fill="url(#svgID5)" d="M7.433 16.973c-.627-.39-1.17-.9-1.598-1.5A5.675 5.675 0 017.91 7.036c.219-.103.594-.29 1.092-.281a2.27 2.27 0 011.806.914c.284.379.44.838.447 1.312 0-.015 1.72-5.596-5.624-5.596-3.086 0-5.624 2.928-5.624 5.498a9.15 9.15 0 00.851 3.937 9 9 0 0010.994 4.718 5.31 5.31 0 01-4.413-.562z"/><path fill="url(#svgID1)" d="M7.433 16.973c-.627-.39-1.17-.9-1.598-1.5A5.675 5.675 0 017.91 7.036c.219-.103.594-.29 1.092-.281a2.27 2.27 0 011.806.914c.284.379.44.838.447 1.312 0-.015 1.72-5.596-5.624-5.596-3.086 0-5.624 2.928-5.624 5.498a9.15 9.15 0 00.851 3.937 9 9 0 0010.994 4.718 5.31 5.31 0 01-4.413-.562z" opacity=".41"/><path fill="url(#svgID2)" d="M10.71 10.466c-.057.073-.233.175-.233.398 0 .183.12.36.332.508 1.011.703 2.917.61 2.922.61a4.2 4.2 0 002.128-.587A4.32 4.32 0 0018 7.677c.018-1.575-.563-2.623-.797-3.087C15.712 1.676 12.496 0 8.999 0A9 9 0 000 8.872C.034 6.304 2.587 4.23 5.624 4.23c.246 0 1.65.024 2.953.708 1.149.603 1.75 1.331 2.17 2.053.434.75.51 1.698.51 2.076 0 .377-.192.937-.547 1.4"/><path fill="url(#svgID3)" d="M10.71 10.466c-.057.073-.233.175-.233.398 0 .183.12.36.332.508 1.011.703 2.917.61 2.922.61a4.2 4.2 0 002.128-.587A4.32 4.32 0 0018 7.677c.018-1.575-.563-2.623-.797-3.087C15.712 1.676 12.496 0 8.999 0A9 9 0 000 8.872C.034 6.304 2.587 4.23 5.624 4.23c.246 0 1.65.024 2.953.708 1.149.603 1.75 1.331 2.17 2.053.434.75.51 1.698.51 2.076 0 .377-.192.937-.547 1.4"/></g><defs><radialGradient id="svgID0" cx="0" cy="0" r="1" gradientTransform="matrix(6.70566 0 0 6.37038 11.053 12.546)" gradientUnits="userSpaceOnUse"><stop offset=".72" stop-opacity="0"/><stop offset=".95" stop-opacity=".53"/><stop offset="1"/></radialGradient><radialGradient id="svgID1" cx="0" cy="0" r="1" gradientTransform="matrix(1.51055 -9.96971 8.05455 1.22038 4.963 13.991)" gradientUnits="userSpaceOnUse"><stop offset=".76" stop-opacity="0"/><stop offset=".95" stop-opacity=".5"/><stop offset="1"/></radialGradient><radialGradient id="svgID2" cx="0" cy="0" r="1" gradientTransform="matrix(-.56937 14.23182 -30.31075 -1.21264 1.818 3.33)" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".11" stop-color="currentColor"/><stop offset=".23" stop-color="currentColor"/><stop offset=".31" stop-color="currentColor"/><stop offset=".67" stop-color="currentColor"/></radialGradient><radialGradient id="svgID3" cx="0" cy="0" r="1" gradientTransform="rotate(73.74 4.811 13.973)scale(6.84346 5.5651)" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor" stop-opacity="0"/></radialGradient><linearGradient id="svgID4" x1="4.128" x2="16.667" y1="12.447" y2="12.447" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><linearGradient id="svgID5" x1="10.738" x2="2.907" y1="7.009" y2="15.539" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset=".16" stop-color="currentColor"/><stop offset=".67" stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><clipPath id="svgID6"><path fill="#fff" d="M0 0h18v18H0z"/></clipPath></defs></g>', width: 18, height: 18 }, edit: { body: '<mask id="svgID0" width="28" height="28" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h28v28H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.013 22.167h1.442l10.803-10.803-1.442-1.443L6.013 20.724zM22 10.098l-3.938-3.901 1.533-1.532a1.68 1.68 0 011.238-.503q.735 0 1.238.503l1.443 1.442q.503.503.52 1.22.017.72-.484 1.221zM5.317 23.918q-.45 0-.752-.302a1.02 1.02 0 01-.302-.753V20.42q0-.21.076-.402.077-.19.24-.354l12.219-12.22 3.937 3.938L8.517 23.6q-.165.165-.355.24a1.1 1.1 0 01-.401.077z"/></g>', width: 28, height: 28 }, "edit-attributes": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M7 16.5q-1.872 0-3.187-1.313Q2.5 13.873 2.5 12t1.313-3.187Q5.127 7.5 7 7.5h10q1.873 0 3.186 1.313Q21.5 10.127 21.5 12t-1.314 3.187Q18.874 16.5 17 16.5zM7 15h10q1.25 0 2.125-.875A2.9 2.9 0 0020 12q0-1.25-.875-2.125A2.9 2.9 0 0017 9H7q-1.25 0-2.125.875A2.9 2.9 0 004 12q0 1.25.875 2.125A2.9 2.9 0 007 15m1.05-1.308q.18 0 .336-.057a.8.8 0 00.297-.198l2.267-2.268a.6.6 0 00.182-.414.57.57 0 00-.182-.424.58.58 0 00-.42-.187.58.58 0 00-.418.187L8.05 12.392l-.562-.561a.6.6 0 00-.414-.182.57.57 0 00-.424.182.58.58 0 00-.187.419.58.58 0 00.187.42l.767.767a.83.83 0 00.633.255"/></g></g>', width: 24, height: 24 }, "edit-calendar": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.423 17.917q-.63 0-1.069-.438a1.45 1.45 0 01-.437-1.069V5.257q0-.632.437-1.07a1.45 1.45 0 011.07-.437h1.153V2.628a.62.62 0 01.184-.457.62.62 0 01.457-.184.62.62 0 01.458.184.62.62 0 01.183.457V3.75h6.314V2.612q0-.266.18-.445.18-.18.445-.18.267 0 .446.18.18.18.18.445V3.75h1.153q.632 0 1.07.438.436.437.437 1.069v4.679h-1.25V8.59H4.167v7.82a.25.25 0 00.072.185.25.25 0 00.184.072h4.84v1.25zM4.167 7.34h11.667V5.257a.25.25 0 00-.072-.185.25.25 0 00-.185-.072H4.423a.25.25 0 00-.184.072.25.25 0 00-.072.185zm13.502 6.322-1.483-1.482.604-.605a.6.6 0 01.44-.18q.257 0 .439.18l.604.605q.18.18.18.439 0 .258-.18.439zm-6.419 4.551v-.783q0-.151.055-.287a.8.8 0 01.171-.253l4.127-4.127 1.482 1.482-4.126 4.127a.8.8 0 01-.254.171.8.8 0 01-.287.055h-.783a.37.37 0 01-.272-.113.37.37 0 01-.113-.272"/></g>', width: 20, height: 20 }, "edit-document": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.205 14.333q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855V2.872q0-.506.35-.855.35-.35.855-.35h4.796q.241 0 .464.093.222.094.386.258l2.798 2.797a1.2 1.2 0 01.351.85V7.7h-1V5.667H9.603a.58.58 0 01-.43-.173.58.58 0 01-.173-.43V2.667H4.205a.2.2 0 00-.14.064.2.2 0 00-.065.14v10.257q0 .077.064.141t.141.064h3.551v1zm7.687-4.637.57.563-2.577 2.567v.7h.7l2.576-2.567.56.559-2.616 2.622a.6.6 0 01-.432.18H9.391q-.12 0-.21-.087a.3.3 0 01-.091-.214V12.75q0-.12.043-.23a.6.6 0 01.137-.202zm1.829 1.822-1.829-1.822.87-.87a.6.6 0 01.426-.164q.255 0 .418.164l.985.984q.164.165.164.419 0 .255-.164.425z"/></g></g>' }, "edit-note": { body: '<g fill="none"><mask id="svgID0" width="41" height="42" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.148.852h40.296v40.296H.148z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M21.814 35.691q-.645 0-1.081-.436a1.47 1.47 0 01-.437-1.081v-.837q0-.296.11-.574a1.5 1.5 0 01.346-.514l8.314-8.314 2.987 2.987-8.315 8.314a1.5 1.5 0 01-1.088.455zm-15.37-8.395q-.536 0-.897-.362a1.22 1.22 0 01-.362-.898q0-.535.362-.897a1.22 1.22 0 01.897-.361h9.235q.535 0 .897.362.362.361.362.898 0 .535-.362.897a1.22 1.22 0 01-.897.361zm26.784-1.55L30.24 22.76l1.217-1.218q.366-.364.885-.364.52 0 .885.364l1.217 1.218q.365.365.365.884 0 .52-.365.885zM6.444 20.58q-.536 0-.897-.362a1.22 1.22 0 01-.362-.898q0-.535.362-.897.361-.36.897-.361h15.951q.535 0 .897.362.362.361.362.898 0 .535-.362.897a1.22 1.22 0 01-.897.361zm0-6.716q-.535 0-.897-.362a1.22 1.22 0 01-.362-.898q0-.535.362-.897.361-.36.897-.361h15.951q.535 0 .897.362.362.361.362.897t-.362.897a1.22 1.22 0 01-.897.362z"/></g></g>', width: 41, height: 42 }, "edit-pencil": { body: '<path fill="currentColor" d="M1.334 14.318a.96.96 0 01-.709-.292.96.96 0 01-.292-.708q0-.415.292-.708a.96.96 0 01.708-.292h11.334q.417 0 .708.292t.292.708a.96.96 0 01-.292.708.96.96 0 01-.708.292zM2.6 10.652a.58.58 0 01-.425-.175.58.58 0 01-.175-.425V8.868q0-.116.042-.233a.46.46 0 01.142-.2L7.95 2.668l2.033 2.034-5.766 5.766a.46.46 0 01-.2.142.7.7 0 01-.234.042zm.4-1h.6l4.984-4.95-.634-.634L3 9.052zm7.65-5.65L8.633 1.985l.984-.983a.62.62 0 01.458-.184q.275 0 .459.184l1.083 1.1a.64.64 0 01.192.45.64.64 0 01-.175.466z"/>', width: 14, height: 15 }, "edit-pencil-new": { body: '<path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M8 13.333h6m-12 0h1.116c.326 0 .49 0 .643-.037q.205-.049.385-.16c.135-.082.25-.197.48-.428L13 4.333a1.414 1.414 0 10-2-2l-8.375 8.375c-.23.231-.346.346-.429.48q-.11.181-.16.386C2 11.728 2 11.891 2 12.217z"/>' }, "edit-square": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.922 15.395q-.495 0-.837-.342a1.14 1.14 0 01-.343-.837V5.48q0-.494.343-.837.342-.342.837-.342h5.573l-.979.978H3.922q-.075 0-.138.063a.2.2 0 00-.063.138v8.735q0 .075.063.138a.2.2 0 00.138.063h8.734q.076 0 .138-.063a.2.2 0 00.063-.138V9.61l.979-.979v5.584q0 .494-.343.837a1.14 1.14 0 01-.837.342zm7.324-10.819.704.688-4.313 4.307v.93h.913l4.336-4.323.692.681-4.292 4.298a1.1 1.1 0 01-.347.236 1 1 0 01-.416.087H7.248a.57.57 0 01-.422-.169.57.57 0 01-.168-.42V9.614a1.08 1.08 0 01.312-.763zm2.332 2.283-2.332-2.283 1.493-1.493q.348-.348.844-.348.497 0 .834.354l.638.642q.337.343.337.829t-.344.828z"/></g>', width: 18, height: 18 }, "element-is-hidden": { body: '<path fill="currentColor" d="M474.609 228.901a453.1 453.1 0 00-103.219-98.287l67.345-67.345c6.78-6.548 6.968-17.352.42-24.132s-17.352-6.968-24.132-.42q-.213.206-.42.42l-73.574 73.506a220.7 220.7 0 00-102.093-27.307C109.229 85.336 7.529 223.03 3.262 228.9a17.07 17.07 0 000 20.07 453.1 453.1 0 00103.219 98.287l-67.345 67.345c-6.78 6.548-6.968 17.352-.42 24.132s17.352 6.968 24.132.42q.213-.206.42-.42l73.574-73.506a220.7 220.7 0 00102.093 27.307c129.707 0 231.407-137.694 235.674-143.565a17.06 17.06 0 000-20.069m-343.313 93.593a425 425 0 01-92.484-83.558c25.122-30.43 106.598-119.467 200.124-119.467a180.7 180.7 0 0176.612 18.773L285.92 167.87c-39.2-26.025-92.076-15.345-118.101 23.855-18.958 28.555-18.958 65.691 0 94.246zm153.72-105.489a50.36 50.36 0 015.12 21.931c0 28.277-22.923 51.2-51.2 51.2a50.36 50.36 0 01-21.931-5.12zm-92.16 43.861a50.36 50.36 0 01-5.12-21.931c0-28.277 22.923-51.2 51.2-51.2a50.36 50.36 0 0121.931 5.12zm46.08 97.536a180.7 180.7 0 01-76.612-18.773l29.628-29.628c39.2 26.025 92.076 15.345 118.101-23.855 18.958-28.555 18.958-65.691 0-94.246l36.523-36.523a425 425 0 0192.484 83.558c-25.123 30.431-106.599 119.467-200.124 119.467"/>', width: 477.871, height: 477.871 }, "element-is-in-diffrent-frame": { body: '<path fill="currentColor" d="M18 32.9c-7.8 2.4-14.8 9-16.8 16C.5 51 0 58.9 0 66.4V80h512V67.2c0-19.3-3.2-27-13.4-32.5l-4.1-2.2-237-.2c-130.4-.1-238.1.2-239.5.6m433.8 14.5c3.4 3.1 3.7 3.9 3.7 8.6s-.3 5.5-3.7 8.6L448 68H296.5c-166.6 0-155.7.4-159-6-1.9-3.7-1.9-8.3 0-12 3.3-6.3-7.7-5.9 158.8-6H448zM36.5 51.5c1.4 1.3 2.5 3.3 2.5 4.5 0 2.7-4.3 7-7 7s-7-4.3-7-7 4.3-7 7-7c1.2 0 3.2 1.1 4.5 2.5M57 51c4.1 4.1 1.2 12-4.5 12-1.4 0-3.4-.9-4.5-2-4.1-4.1-1.2-12 4.5-12 1.4 0 3.4.9 4.5 2m20.5.5c1.4 1.3 2.5 3.3 2.5 4.5 0 2.6-4.3 7-6.8 7-3 0-7.2-3.8-7.2-6.6 0-3 4.1-7.4 7-7.4 1.2 0 3.2 1.1 4.5 2.5M56 164v44h114v-88H56zm139 0v44h122v-88H195zm147 0v44h114v-88H342zM56 276v44h114v-88H56zm139 0v44h122v-88H195zm147 0v44h114v-88H342zM56 388v44h114v-88H56zm139 0v44h122v-88H195zm147 0v44h114v-88H342z"/>', width: 512, height: 512 }, elements: { body: '<path fill="currentColor" d="M24.5.9c-9 2.2-17.2 9-21.5 17.6l-2.5 5v81l3.4 6.3c3.8 7 6.9 10 14.5 14l5.1 2.7h465l5.1-2.7c7.6-4 10.7-7 14.5-14l3.4-6.3v-81l-3.4-6.3c-3.8-7-6.9-10-14.5-14L488.5.5 258 .3C131.2.3 26.2.5 24.5.9m460 21.7c6.3 2.9 6.5 4.4 6.5 41.4s-.2 38.5-6.5 41.4c-3 1.4-25.5 1.6-228.5 1.6-249.7 0-230.1.5-233.4-6.5-2.4-4.9-2.4-68.1 0-73 3.3-7-16.4-6.5 233.2-6.5 203.2 0 225.7.2 228.7 1.6M50.1 193.5c-11 2.4-22.6 8.9-31.1 17.5-25 25-25.2 64.9-.5 89.5 12.2 12.1 25.6 18.3 41.9 19.2 29.2 1.6 56-17 64.9-45.2 3.1-9.9 3.1-27.1 0-37-10.1-31.8-42.8-51-75.2-44m28.5 22.6c18.9 7.1 30.6 26.6 27.5 46-3.8 23.3-25.7 39.6-48.2 36-23.3-3.8-39.6-25.7-36-48.2 3.6-22.4 23.5-38.2 45.6-36.2 3.3.3 8.3 1.4 11.1 2.4m113.6-22.2c-2.9 1-7 3.2-9 4.8-4.7 3.7-9.9 11.3-11.2 16.4-.7 2.5-1 17.8-.8 43.2.3 38.7.3 39.3 2.6 43.5 3.5 6.6 8.8 11.9 15 14.9l5.7 2.8h294l6.3-3.4c7-3.8 10-6.9 14-14.5l2.7-5.1v-81l-2.7-5.1c-4-7.6-7-10.7-14-14.5l-6.3-3.4-145.5-.2c-139-.2-145.7-.2-150.8 1.6m292.3 20.7c6.3 2.9 6.5 4.4 6.5 41.4 0 28.2-.2 33.7-1.6 36.5-3.3 6.9 6.9 6.5-147.8 6.5-152.9 0-144.8.3-148-5.9-2.4-4.5-2.4-69.7 0-74.2 3.1-6.1-5-5.8 147.7-5.9 125.4 0 140.2.2 143.2 1.6m-460 170.3c-9 2.2-17.2 9-21.5 17.6l-2.5 5v81l3.4 6.3c3.8 7 6.9 10 14.5 14l5.1 2.7h294l5.7-2.8c6.2-3 11.5-8.3 15-14.9 2.3-4.3 2.3-4.4 2.3-45.8s0-41.5-2.3-45.8c-3.5-6.6-8.8-11.9-15-14.9l-5.7-2.8-145-.2c-79.7 0-146.3.2-148 .6m289 21.5c6.4 2.7 6.5 3.6 6.5 41.6s-.1 38.9-6.5 41.6c-2.9 1.2-24.7 1.4-143.1 1.4-154.7 0-144.5.4-147.8-6.5-2.4-4.9-2.4-68.1 0-73 3.2-6.9-7.1-6.5 147.7-6.5 118.6 0 140.3.2 143.2 1.4m120.6-20.9c-11 2.4-22.6 8.9-31.1 17.5-25 25-25.2 64.9-.5 89.5 12.2 12.1 25.6 18.3 41.9 19.2 29.2 1.6 56-17 64.9-45.2 3.1-9.9 3.1-27.1 0-37-10.1-31.8-42.8-51-75.2-44m28.5 22.6c11.1 4.2 19 11.5 23.9 22.2 11.8 25.7-4.2 55.2-32.4 59.8-22.5 3.6-44.4-12.7-48.2-36-2.8-17.6 7.3-36.6 23.6-44.2 11-5.2 22.3-5.8 33.1-1.8"/>', width: 512, height: 512 }, ellipse: { body: '<circle cx="4" cy="4" r="4" fill="currentColor"/>', width: 8, height: 8 }, "emergency-home": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M12 21.4q-.352 0-.68-.137a2 2 0 01-.6-.39l-7.593-7.592a2 2 0 01-.39-.6A1.8 1.8 0 012.6 12a1.83 1.83 0 01.527-1.28l7.592-7.593q.272-.275.6-.401.33-.126.681-.126t.688.128.593.399l7.592 7.592q.27.255.4.59a1.92 1.92 0 01.001 1.371q-.127.33-.4.6l-7.593 7.593q-.255.255-.59.391T12 21.4m.221-1.596 7.583-7.583q.077-.077.077-.221t-.077-.221L12.22 4.196q-.076-.076-.22-.076t-.221.077L4.196 11.78q-.077.077-.077.221t.077.221l7.583 7.583q.077.077.221.077t.221-.077m-.22-6.717q.318 0 .534-.216a.73.73 0 00.215-.534V8.22a.73.73 0 00-.216-.534A.73.73 0 0012 7.47a.73.73 0 00-.535.216.73.73 0 00-.215.534v4.116q0 .318.216.534a.73.73 0 00.534.215m0 2.617q.343 0 .575-.232a.78.78 0 00.233-.576.78.78 0 00-.232-.575.78.78 0 00-.576-.233.78.78 0 00-.575.233.78.78 0 00-.233.575q0 .343.233.576a.78.78 0 00.575.232"/></g></g>', width: 24, height: 24 }, emulator: { body: '<mask id="svgID0" width="100" height="101" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .41h100v100H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M30.417 94.16q-3.126 0-5.313-2.187-2.187-2.189-2.187-5.313v-72.5q0-3.125 2.187-5.312 2.189-2.188 5.313-2.188h39.166q3.126 0 5.313 2.188 2.187 2.187 2.187 5.312v72.5q0 3.124-2.187 5.313-2.189 2.187-5.313 2.187zm-1.25-11.458v3.958q0 .417.416.833.417.417.834.417h39.166q.417 0 .834-.417.416-.416.416-.833v-3.958zm0-6.25h41.666V24.368H29.167zm0-58.334h41.666V14.16q0-.417-.416-.833-.417-.417-.834-.417H30.417q-.417 0-.834.417-.416.416-.416.833zm0 64.584v5.208z"/><path d="m47.418 51.673-6.11 16.857q-.057.118-.293.353l-1.292 1.292q-.41.353-.91.176a.91.91 0 01-.617-.704l-.176-1.763q-.06-.058.058-.47l6.285-17.386q.645.646 1.41 1.027a8.6 8.6 0 001.644.618m5.756 0a8.6 8.6 0 001.644-.618q.765-.38 1.41-1.027l6.285 17.386q.06.06.059.47l-.235 1.763q-.06.528-.557.704-.501.177-.912-.176l-1.35-1.292-.294-.353zm-2.878-3.054q-2.703 0-4.582-1.88t-1.88-4.581q0-2.292 1.382-3.967 1.38-1.673 3.317-2.142v-3.877q0-.763.501-1.264.498-.498 1.262-.498.763 0 1.264.498.498.5.498 1.264v3.877q1.938.47 3.32 2.142 1.379 1.676 1.379 3.966 0 2.703-1.88 4.582t-4.581 1.88m0-3.525q1.233 0 2.084-.852.852-.851.852-2.084t-.852-2.087q-.85-.85-2.084-.85t-2.084.85q-.853.853-.853 2.087 0 1.233.853 2.084.85.852 2.084.852"/></g>', width: 100, height: 101 }, "enter-data": { body: '<mask id="svgID0" width="21" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h20v20H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M14.688 17.146a.6.6 0 01-.188-.437.67.67 0 01.188-.459l.645-.625H4.646A.61.61 0 014.042 15a.61.61 0 01.625-.625h10.666l-.666-.646a.58.58 0 01-.167-.427.6.6 0 01.188-.448.6.6 0 01.437-.187.6.6 0 01.438.187l1.604 1.625q.124.105.177.24a.84.84 0 01-.157.844l-1.604 1.604a.58.58 0 01-.448.176.65.65 0 01-.447-.197m-7.313-5.625q-.354 0-.51-.23-.156-.228-.032-.54l2.834-7.522A.87.87 0 0110 2.823a.86.86 0 01.5-.177q.27 0 .51.177a.9.9 0 01.323.406l2.813 7.521q.125.314-.042.542-.167.23-.52.229a.53.53 0 01-.292-.094.42.42 0 01-.188-.26l-.708-2H8.604l-.729 2a.535.535 0 01-.5.354m1.604-3.375h3.042l-1.48-4.104h-.083z"/></g>', width: 21, height: 20 }, environment: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 14.333a6.1 6.1 0 01-2.458-.5 6.4 6.4 0 01-2.017-1.358 6.4 6.4 0 01-1.358-2.016 6.1 6.1 0 01-.5-2.46q0-1.316.5-2.466a6.5 6.5 0 011.358-2.009 6.4 6.4 0 012.017-1.357A6.1 6.1 0 018 1.667q1.316 0 2.466.5a6.4 6.4 0 012.008 1.358 6.4 6.4 0 011.359 2.008q.5 1.151.5 2.467a6.1 6.1 0 01-.5 2.459 6.4 6.4 0 01-1.359 2.016 6.4 6.4 0 01-2.008 1.358q-1.15.5-2.466.5m0-1.017a8 8 0 00.86-1.357q.34-.693.574-1.51H6.567q.234.834.576 1.526.34.69.858 1.342m-1.283-.183a7.4 7.4 0 01-.691-1.25 8 8 0 01-.475-1.433H3.284A5.35 5.35 0 004.7 12.192a4.7 4.7 0 002.016.941m2.567 0a4.7 4.7 0 002.017-.941 5.35 5.35 0 001.416-1.742H10.45q-.2.734-.5 1.441a7 7 0 01-.667 1.242M2.867 9.45h2.484a7.8 7.8 0 01-.1-2.175q.033-.359.1-.725H2.867a4.6 4.6 0 00-.15.7 5.5 5.5 0 000 1.5q.051.367.15.7m3.484 0h3.3q.066-.367.1-.717.033-.35.033-.733a7.7 7.7 0 00-.133-1.45h-3.3A7.7 7.7 0 006.218 8a7.7 7.7 0 00.133 1.45m4.3 0h2.483q.1-.333.15-.7a5.6 5.6 0 000-1.5 4.6 4.6 0 00-.15-.7H10.65q.066.366.1.724a8 8 0 010 1.45q-.034.36-.1.726m-.2-3.9h2.266a5.2 5.2 0 00-1.408-1.742 5.1 5.1 0 00-2.025-.958q.383.583.683 1.275.3.69.484 1.425m-3.884 0h2.867A8 8 0 008 2.683a8 8 0 00-.842 1.325q-.358.708-.592 1.542m-3.283 0H5.55q.183-.734.483-1.425t.683-1.275a5 5 0 00-2.033.958 5.2 5.2 0 00-1.4 1.742"/></g>' }, erase: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M17.898 10.815c.58-.58.58-1.52 0-2.099L12.95 3.768c-.58-.58-1.52-.58-2.099 0l-7.916 7.917c-.58.58-.58 1.52 0 2.099l2.968 2.968c.279.279.656.435 1.05.435h11.009c.205 0 .37-.19.37-.395v-.533s.032-.391-.37-.391h-5.175zM7.984 8.24l5.483 5.484-2.309 2.309h-4.04l-3.464-3.464z"/></g>', width: 20, height: 20 }, error: { body: '<mask id="svgID0" width="48" height="48" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h48v48H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M24 26.15q.65 0 1.076-.426.424-.424.424-1.074V15.6q0-.6-.424-1.026-.426-.424-1.076-.424t-1.074.424Q22.5 15 22.5 15.65v9.05q0 .6.426 1.024.424.426 1.074.426m0 7.3q.7 0 1.15-.45t.45-1.15-.45-1.15-1.15-.45-1.15.45-.45 1.15.45 1.15 1.15.45M24 43q-3.95 0-7.424-1.5Q13.1 40 10.55 37.45T6.5 31.424Q5 27.95 5 24t1.5-7.426Q8 13.1 10.55 10.55t6.026-4.05Q20.05 5 24 5t7.426 1.5Q34.9 8 37.45 10.55t4.05 6.024Q43 20.05 43 24t-1.5 7.424Q40 34.9 37.45 37.45t-6.024 4.05Q27.95 43 24 43m0-3q6.65 0 11.326-4.674Q40 30.65 40 24t-4.674-11.326Q30.65 8 24 8t-11.324 4.674Q8 17.35 8 24t4.676 11.326Q17.349 40 24 40"/></g>', width: 48, height: 48 }, "error-fill": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6 8.365a.4.4 0 00.288-.116.4.4 0 00.116-.287.4.4 0 00-.116-.288A.4.4 0 006 7.558a.4.4 0 00-.288.116.4.4 0 00-.116.288q0 .171.116.287A.4.4 0 006 8.365m0-1.827a.36.36 0 00.267-.107.36.36 0 00.108-.268v-2.25a.36.36 0 00-.108-.267A.36.36 0 006 3.538a.36.36 0 00-.267.108.36.36 0 00-.108.267v2.25q0 .16.108.268A.36.36 0 006 6.538m0 4.212a4.6 4.6 0 01-1.852-.374A4.8 4.8 0 012.64 9.361a4.8 4.8 0 01-1.016-1.508 4.6 4.6 0 01-.374-1.852q0-.986.374-1.853.375-.867 1.015-1.508t1.508-1.016a4.6 4.6 0 011.852-.374q.986 0 1.853.374.867.375 1.508 1.015.642.641 1.016 1.508t.374 1.852-.374 1.853A4.8 4.8 0 019.36 9.36q-.642.642-1.508 1.016A4.6 4.6 0 016 10.75"/></g>', width: 12, height: 12 }, event: { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M13.9 16.023q-.68 0-1.154-.475a1.57 1.57 0 01-.475-1.154q0-.681.475-1.155a1.57 1.57 0 011.154-.474q.681 0 1.155.474t.474 1.155-.474 1.154a1.57 1.57 0 01-1.155.475m-6.624 2.47q-.535 0-.905-.37A1.23 1.23 0 016 17.217V7.77q0-.534.37-.905.372-.37.906-.37h.977v-.951q0-.232.156-.388A.53.53 0 018.796 5q.232 0 .388.155a.53.53 0 01.155.388v.95h5.349V5.53q0-.225.152-.377A.5.5 0 0115.217 5q.225 0 .377.152a.5.5 0 01.153.377v.964h.977q.535 0 .905.37.37.372.371.906v9.448q0 .535-.37.906-.372.37-.906.37zm0-1.059h9.448a.2.2 0 00.15-.068.2.2 0 00.067-.149v-6.624H7.06v6.624q0 .082.068.15a.2.2 0 00.149.067m-.217-7.9h9.882V7.769a.2.2 0 00-.068-.15.2.2 0 00-.149-.067H7.276a.2.2 0 00-.15.068.2.2 0 00-.067.15z"/></g></g>', width: 24, height: 24 }, "event-repeat": { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M3.033 14.767a1.1 1.1 0 01-.8-.334 1.1 1.1 0 01-.333-.8V3.367q0-.467.333-.8.335-.334.8-.334h1.05V1.8q0-.234.167-.4a.56.56 0 01.417-.167q.249 0 .408.167a.56.56 0 01.158.4v.433h5.534V1.8q0-.234.166-.4a.56.56 0 01.417-.167q.25 0 .408.167a.56.56 0 01.159.4v.433h1.05q.465 0 .8.334.333.333.333.8v4.966h-1.133V6.5H3.033v7.133h5.234v1.134zm0-9.267h9.934V3.367H3.033zm9.634 10.633a3.23 3.23 0 01-1.75-.491 3.2 3.2 0 01-1.184-1.275.56.56 0 01-.025-.592q.158-.292.525-.292.184 0 .292.084a.7.7 0 01.175.2q.267.566.783.9.518.333 1.184.333.933 0 1.591-.667.66-.666.659-1.6 0-.933-.659-1.591a2.17 2.17 0 00-1.591-.659 2.22 2.22 0 00-1.534.6h.4q.233.017.375.175a.6.6 0 01.142.409.56.56 0 01-.158.4.54.54 0 01-.409.166H9.767a.55.55 0 01-.4-.166.55.55 0 01-.167-.4V9.95q0-.25.167-.408a.58.58 0 01.416-.159q.234 0 .384.142a.53.53 0 01.166.358v.384a4 4 0 011.059-.675 3.15 3.15 0 011.275-.259q1.416 0 2.408.992t.992 2.408q0 1.418-.992 2.409t-2.408.991M3.033 5.5V3.367z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, "exclamatin-warning": { body: '<defs><path id="svgID0" fill="currentColor" d="M100.028 44.543c24.925 0 45.163 20.238 45.163 45.163 0 24.926-20.238 45.164-45.163 45.164-24.926 0-45.164-20.238-45.164-45.164 0-24.925 20.238-45.163 45.164-45.163"/></defs><mask id="svgID1" width="870" height="965" x="-55" y="-27" maskUnits="userSpaceOnUse" style="mask-type:luminance"><path fill="#fff" d="M-54.273-26.633h869.095v964.071H-54.273z"/></mask><mask id="svgID2" width="54" height="54" x="73" y="63" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M73 63h54v54H73z"/></mask><g fill="none"><g mask="url(#svgID1)"><g opacity=".5"><path fill="currentColor" d="m27.999 89.233 94.01-54.014z"/><path stroke="currentColor" stroke-linecap="round" stroke-width="23.197" d="m27.999 89.233 94.01-54.014"/></g><g opacity=".5"><path fill="currentColor" d="m50.36 124.66 94.01-54.014z"/><path stroke="currentColor" stroke-linecap="round" stroke-width="23.197" d="m50.36 124.66 94.01-54.014"/></g><g opacity=".5"><path fill="currentColor" d="m168.453 57.072 7.327-4.265z"/><path stroke="currentColor" stroke-linecap="round" stroke-width="23.197" d="m168.453 57.072 7.327-4.265"/></g><g opacity=".5"><path fill="currentColor" d="m83.526 153.806 71.397-41.702z"/><path stroke="currentColor" stroke-linecap="round" stroke-width="23.197" d="m83.526 153.806 71.397-41.702"/></g><path stroke="currentColor" stroke-width="1.08" d="M172.386 116.179a2.084 2.084 0 11-.436 4.144 2.084 2.084 0 01.436-4.144Z"/><path stroke="currentColor" stroke-width="1.776" d="M50.851 158.587a3.426 3.426 0 01-.716 6.813 3.427 3.427 0 01.716-6.813ZM98.885 18.178a3.427 3.427 0 013.049 3.765 3.43 3.43 0 01-3.765 3.049 3.427 3.427 0 01-3.049-3.765 3.427 3.427 0 013.765-3.049Z"/><path stroke="currentColor" stroke-width="1.298" d="M19.524 62.79a1.566 1.566 0 11-.002 3.13 1.566 1.566 0 01.002-3.13Zm121.549 102.053a1.566 1.566 0 010 3.13 1.566 1.566 0 010-3.13Z"/></g><use href="#svgID0"/><use href="#svgID0"/><path fill="currentColor" d="M99.946 48c23.15 0 41.947 18.796 41.947 41.946s-18.797 41.947-41.947 41.947S58 113.096 58 89.946 76.796 48 99.946 48"/><g mask="url(#svgID2)"><path fill="currentColor" d="M100 94.7q-1.078 0-1.819-.74t-.74-1.819v-15.75q0-1.077.74-1.818.742-.741 1.819-.741t1.818.741.741 1.818v15.75q0 1.078-.741 1.819T100 94.7m0 11.466q-1.078 0-1.819-.741t-.74-1.818q0-1.078.74-1.819.742-.741 1.819-.741t1.818.741q.741.74.741 1.819 0 1.077-.741 1.818t-1.818.741"/></g></g>', width: 200, height: 180 }, exclamation: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.5 9.359V3.692h1V9.36zm0 2.949v-1h1v1z"/></g>' }, "exclamation-circle-solid": { body: '<path fill="currentColor" d="M504 256c0 136.997-111.043 248-248 248S8 392.997 8 256C8 119.083 119.043 8 256 8s248 111.083 248 248m-248 50c-25.405 0-46 20.595-46 46s20.595 46 46 46 46-20.595 46-46-20.595-46-46-46m-43.673-165.346 7.418 136c.347 6.364 5.609 11.346 11.982 11.346h48.546c6.373 0 11.635-4.982 11.982-11.346l7.418-136c.375-6.874-5.098-12.654-11.982-12.654h-63.383c-6.884 0-12.356 5.78-11.981 12.654"/>', width: 512, height: 512 }, executable: { body: '<g fill="none"><g fill="currentColor" clip-path="url(#svgID0)"><path d="M7.258 11.084H10.3v-7.6c0-.297.241-.538.538-.538h2.324c.297 0 .537.24.537.537v7.6h3.043c.319 0 .498.368.302.619l-4.742 6.083a.383.383 0 01-.604 0l-4.742-6.083a.383.383 0 01.302-.618"/><path d="M20.15 15.256h-4.356l-2.546 3.266a1.57 1.57 0 01-1.248.61 1.57 1.57 0 01-1.248-.61l-2.546-3.266H3.85a1.35 1.35 0 00-1.35 1.35v3.098c0 .746.604 1.35 1.35 1.35h16.3a1.35 1.35 0 001.35-1.35v-3.098a1.35 1.35 0 00-1.35-1.35m-2.916 4.006c0 .196-.16.354-.354.354h-.918a.353.353 0 01-.354-.354v-.366c0-.196.158-.354.354-.354h.918c.194 0 .354.158.354.354zm2.824 0a.353.353 0 01-.354.354h-.916a.353.353 0 01-.354-.354v-.366c0-.196.158-.354.354-.354h.916c.196 0 .354.158.354.354z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M2 2h20v20H2z"/></clipPath></defs></g>', width: 24, height: 24 }, exit: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.417 10.65a.54.54 0 01-.15-.367q0-.2.15-.35l1.266-1.266h-5.1a.484.484 0 01-.5-.5.486.486 0 01.5-.5h5.1l-1.266-1.283a.48.48 0 010-.7q.15-.15.35-.15t.333.133l2.083 2.083a.55.55 0 01.126.191.63.63 0 010 .45.55.55 0 01-.126.193L11.1 10.667q-.15.165-.341.15a.54.54 0 01-.342-.167M3.6 14q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.534q0-.5.35-.85t.85-.35h3.983q.2 0 .35.14.15.143.15.36a.47.47 0 01-.15.357.5.5 0 01-.35.143H3.6q-.067 0-.133.066-.067.068-.067.134V12.8q0 .068.067.133.066.067.133.067h3.983q.2 0 .35.142t.15.358-.15.359a.5.5 0 01-.35.141z"/></g>' }, "expand-more": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 9.767a.8.8 0 01-.224-.033.4.4 0 01-.192-.134l-3.017-3a.5.5 0 01-.133-.35q0-.2.15-.35a.5.5 0 01.35-.133.5.5 0 01.35.133L8 8.617 10.734 5.9q.133-.15.333-.142t.35.142q.15.15.15.358 0 .21-.15.342l-3 3a.4.4 0 01-.191.134.8.8 0 01-.226.033"/></g>' }, "expand-panel": { body: '<path fill="currentColor" d="m7.133 9.48-4.292 4.292q-.138.138-.295.127a.47.47 0 01-.295-.15.43.43 0 01-.138-.308q0-.17.137-.304l4.27-4.27H3.964a.42.42 0 01-.307-.124.42.42 0 01-.124-.306q0-.183.125-.31A.42.42 0 013.966 8h3.493A.527.527 0 018 8.535v3.494a.43.43 0 01-.43.438.427.427 0 01-.437-.431zM9.48 7.133h2.557q.183 0 .307.124a.42.42 0 01.124.306.43.43 0 01-.125.31.42.42 0 01-.308.127H8.541A.527.527 0 018 7.465V3.97a.43.43 0 01.43-.438.426.426 0 01.437.432V6.52l4.292-4.293a.42.42 0 01.305-.138q.17 0 .308.138a.43.43 0 01.138.308.42.42 0 01-.138.305z"/>' }, export: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 10.5a.484.484 0 01-.5-.5V3.15l-.883.882a.5.5 0 01-.35.134.48.48 0 01-.35-.15.48.48 0 010-.7l1.666-1.667a.55.55 0 01.192-.125.62.62 0 01.45 0 .55.55 0 01.192.125l1.666 1.667q.15.15.15.358a.5.5 0 01-.15.358.5.5 0 01-.35.134.5.5 0 01-.35-.134L8.5 3.15V10a.485.485 0 01-.5.5M4.2 15q-.5-.001-.85-.35A1.16 1.16 0 013 13.8V6.865q0-.5.35-.85t.85-.35h1.217q.2 0 .35.141.15.142.15.359a.47.47 0 01-.15.358.5.5 0 01-.35.142H4.2q-.067 0-.133.066Q4 6.8 4 6.866v6.933q0 .067.067.133.066.067.133.067h7.6q.067 0 .133-.067.067-.066.067-.133V6.866q0-.068-.067-.134t-.133-.066h-1.217a.5.5 0 01-.35-.142.47.47 0 01-.15-.358q0-.217.15-.359a.5.5 0 01.35-.141H11.8q.5 0 .85.35t.35.85v6.933q0 .5-.35.85t-.85.35z"/></g>' }, extension: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.916 13.667H3.333a.96.96 0 01-.708-.292.96.96 0 01-.292-.708v-2.584a1.98 1.98 0 001.175-.566Q4 9.034 4 8.333q0-.699-.49-1.183a1.98 1.98 0 00-1.176-.567V4q0-.417.292-.708A.96.96 0 013.333 3h2.666q.085-.633.55-1.05a1.62 1.62 0 011.117-.417q.65 0 1.117.417T9.333 3h2.666q.417 0 .708.292Q13 3.583 13 4v2.667a1.65 1.65 0 011.05.55q.417.466.417 1.116T14.05 9.45A1.65 1.65 0 0113 10v2.667a.96.96 0 01-.292.708.96.96 0 01-.708.292H9.416a1.9 1.9 0 00-.583-1.192A1.64 1.64 0 007.666 12Q7 12 6.5 12.475a1.9 1.9 0 00-.583 1.192m-2.583-1h1.8q.35-.884 1.092-1.276.74-.39 1.441-.39.7 0 1.442.39.741.393 1.091 1.276H12V9.033h.817q.316-.033.483-.24a.72.72 0 000-.918q-.166-.209-.483-.242H12V4H8.366v-.817q-.034-.316-.241-.483a.72.72 0 00-.918 0q-.208.166-.24.483V4H3.332v1.833q.765.3 1.216.984.45.682.45 1.516 0 .817-.45 1.5a2.6 2.6 0 01-1.216 1z"/></g>' }, "extension-off": { body: '<path fill="currentColor" d="M3.167 16.083q-.51 0-.88-.37a1.2 1.2 0 01-.37-.88v-3.23q.855-.105 1.47-.712Q4 10.284 4 9.417t-.613-1.475a2.46 2.46 0 00-1.47-.711V3.92q0-.265.094-.493.093-.226.265-.398l.891.89v2.363A3.3 3.3 0 014.683 7.53q.567.855.567 1.89 0 1.015-.567 1.87a3.37 3.37 0 01-1.516 1.261v2.282h2.274a3.4 3.4 0 011.268-1.516 3.3 3.3 0 011.875-.567q1.02 0 1.874.567t1.268 1.516h2.355l.89.891a1.2 1.2 0 01-.398.266 1.3 1.3 0 01-.492.093H10.77a2.46 2.46 0 00-.712-1.47A2 2 0 008.584 14q-.867 0-1.475.614-.607.614-.711 1.47zm12.083-3.192L14 11.641v-1.343h1.026a.9.9 0 00.572-.29.85.85 0 00.23-.591.85.85 0 00-.23-.592.9.9 0 00-.572-.29H14V4H9.465V2.974a.9.9 0 00-.29-.572.85.85 0 00-.591-.229.85.85 0 00-.592.23.9.9 0 00-.29.571V4H6.36L5.11 2.75H6.5a2.08 2.08 0 01.697-1.31Q7.78.922 8.584.922q.802 0 1.387.516.584.516.696 1.311H14q.516 0 .883.367.367.368.367.883v3.333q.795.112 1.311.697.516.584.516 1.387 0 .802-.516 1.387a2.08 2.08 0 01-1.31.696zm-.185 3.942L1.155 2.936a.6.6 0 01-.184-.442.63.63 0 01.196-.45.6.6 0 01.446-.193q.251 0 .445.194l13.898 13.91a.6.6 0 01.19.435.6.6 0 01-.19.443.6.6 0 01-.446.194.6.6 0 01-.445-.194"/>', width: 18, height: 18 }, eye: { body: '<path fill="currentColor" d="m12.146 8.813-.938-.938q.187-1.041-.593-1.864-.782-.824-1.907-.636l-.937-.937q.292-.125.583-.188.291-.062.646-.062 1.416 0 2.406.99.99.988.99 2.405 0 .354-.063.656a2.6 2.6 0 01-.187.574m2.645 2.583-.916-.854a9 9 0 001.406-1.324q.614-.718 1.052-1.635a8.2 8.2 0 00-2.99-3.344Q11.396 3 9 3q-.604 0-1.188.083a8 8 0 00-1.146.25l-.979-.979a8.4 8.4 0 011.615-.458A9.7 9.7 0 019 1.75q2.77 0 5.052 1.468 2.28 1.47 3.448 3.865a.8.8 0 01.062.219 1.9 1.9 0 010 .562.8.8 0 01-.062.22 9.4 9.4 0 01-1.157 1.812 9 9 0 01-1.552 1.5m.23 4.396-2.917-2.917q-.645.25-1.427.396A9 9 0 019 13.417q-2.792 0-5.063-1.469A9.46 9.46 0 01.5 8.083a.8.8 0 01-.063-.219 1.8 1.8 0 010-.551q.021-.125.063-.23a9.4 9.4 0 011.146-1.77q.666-.813 1.437-1.438L1.208 1.979a.6.6 0 01-.187-.437.67.67 0 01.187-.459.65.65 0 01.449-.166q.26 0 .426.166l13.834 13.834q.166.166.177.416a.63.63 0 01-.178.459.65.65 0 01-.447.166.65.65 0 01-.448-.166M3.958 4.75a8.4 8.4 0 00-1.28 1.26 7.5 7.5 0 00-1.011 1.573 8.2 8.2 0 002.989 3.344q1.949 1.24 4.344 1.24a7 7 0 001.125-.095q.562-.093.958-.197l-1.042-1.083A3.3 3.3 0 019 10.979q-1.417 0-2.406-.99t-.99-2.406q0-.25.053-.531.051-.282.135-.51z"/>', width: 18 }, "eye-icon": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.002 11.683q1.274 0 2.165-.893.89-.892.89-2.167t-.892-2.165a2.95 2.95 0 00-2.167-.89q-1.274 0-2.165.892a2.95 2.95 0 00-.89 2.167q0 1.274.891 2.165.893.89 2.168.89M9 10.65q-.844 0-1.435-.59a1.95 1.95 0 01-.59-1.435q0-.844.59-1.434Q8.155 6.6 9 6.6q.843 0 1.434.59.59.59.59 1.435 0 .843-.59 1.434-.591.591-1.434.591m0 3.225a8.3 8.3 0 01-4.514-1.295 8.43 8.43 0 01-3.129-3.502.6.6 0 01-.068-.206 1.6 1.6 0 010-.494.6.6 0 01.068-.206 8.43 8.43 0 013.13-3.502A8.3 8.3 0 019 3.375q2.462 0 4.514 1.295a8.43 8.43 0 013.129 3.502.6.6 0 01.067.206 1.6 1.6 0 010 .494.6.6 0 01-.067.206 8.43 8.43 0 01-3.13 3.502A8.3 8.3 0 019 13.875"/></g>', width: 18, height: 18 }, "eye-slashed": { body: '<path fill="currentColor" d="M9 9.98q1.418 0 2.406-.99.99-.99.99-2.407 0-1.416-.99-2.405-.99-.99-2.406-.99t-2.406.99q-.99.988-.99 2.405 0 1.418.99 2.406.99.99 2.406.99m0-1.147a2.17 2.17 0 01-1.593-.656 2.17 2.17 0 01-.657-1.594q0-.937.657-1.594A2.17 2.17 0 019 4.333q.938 0 1.595.656.655.657.655 1.594a2.17 2.17 0 01-.655 1.594A2.17 2.17 0 019 8.833m0 3.584q-2.73 0-5.01-1.438Q1.708 9.542.5 7.083a.8.8 0 01-.062-.219 1.8 1.8 0 010-.562.8.8 0 01.062-.219q1.21-2.458 3.49-3.895A9.2 9.2 0 019 .75q2.73 0 5.01 1.438 2.282 1.437 3.49 3.895a.8.8 0 01.063.219 1.9 1.9 0 010 .562.8.8 0 01-.063.22 9.4 9.4 0 01-3.49 3.895A9.2 9.2 0 019 12.417m0-1.25q2.354 0 4.324-1.24a8.14 8.14 0 003.01-3.344 8.15 8.15 0 00-3.01-3.344A7.96 7.96 0 009 2Q6.646 2 4.677 3.24a8.15 8.15 0 00-3.01 3.343 8.14 8.14 0 003.01 3.344A7.95 7.95 0 009 11.167"/>', width: 18, height: 13 }, "eye-with-slash": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m11.83 9.73-.843-.843q.17-.931-.531-1.675-.7-.743-1.719-.575l-.842-.842A2.6 2.6 0 019 5.567q1.275 0 2.167.89.89.892.89 2.168 0 .317-.056.591a2.3 2.3 0 01-.171.514m2.385 2.333-.828-.776q.712-.543 1.266-1.19.553-.647.947-1.472a7.37 7.37 0 00-2.69-3.01Q11.154 4.5 9 4.5q-.544 0-1.069.075T6.9 4.8l-.874-.874a7.6 7.6 0 011.452-.417A8.5 8.5 0 019 3.375q2.5 0 4.552 1.325 2.05 1.326 3.09 3.472a.6.6 0 01.068.206q.02.118.02.247a1.2 1.2 0 01-.087.453 8 8 0 01-1.028 1.629 8.3 8.3 0 01-1.4 1.356m.21 3.944-2.639-2.617q-.576.214-1.278.35-.701.135-1.508.135-2.516 0-4.556-1.326a8.54 8.54 0 01-3.087-3.471.6.6 0 01-.068-.206 1.6 1.6 0 010-.489.6.6 0 01.068-.2 8.2 8.2 0 011.024-1.599A9.4 9.4 0 013.675 5.28L1.982 3.574a.54.54 0 01-.16-.386.54.54 0 01.171-.404.54.54 0 01.395-.163q.233 0 .395.163l12.433 12.432a.558.558 0 11-.79.79m-9.96-9.938A8.3 8.3 0 003.31 7.206a6.2 6.2 0 00-.91 1.419 7.37 7.37 0 002.691 3.01Q6.844 12.75 9 12.75q.511 0 1.02-.087.507-.086.86-.178l-.948-.973a2.7 2.7 0 01-.932.17q-1.277 0-2.167-.89t-.89-2.167q0-.227.045-.477.046-.248.124-.455z"/></g>', width: 18, height: 18 }, "fact-check": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.592 17.083q-.63 0-1.069-.438a1.45 1.45 0 01-.437-1.069V4.422q0-.63.437-1.068a1.45 1.45 0 011.07-.438h12.82q.63 0 1.069.438.437.437.437 1.068v11.154q0 .631-.437 1.07a1.46 1.46 0 01-1.07.437zm0-1.25h12.82a.25.25 0 00.177-.08.25.25 0 00.08-.177V4.422a.25.25 0 00-.08-.176.25.25 0 00-.176-.08H3.593a.25.25 0 00-.177.08.25.25 0 00-.08.176v11.154q0 .096.08.176t.176.08m3.91-1.875q.266 0 .446-.18t.18-.445a.6.6 0 00-.18-.446.6.6 0 00-.445-.18h-2.5a.6.6 0 00-.446.18.6.6 0 00-.18.446q0 .265.18.445t.446.18zm4.626-3.516-.749-.749a.6.6 0 00-.439-.183.6.6 0 00-.44.196.63.63 0 00-.175.44.6.6 0 00.184.438l1.091 1.092q.226.226.528.226.3 0 .527-.226l2.862-2.862a.6.6 0 00.19-.436.6.6 0 00-.19-.443.6.6 0 00-.445-.194.6.6 0 00-.446.194zm-4.625.182q.265 0 .445-.18.18-.178.18-.445a.6.6 0 00-.18-.445.6.6 0 00-.445-.18h-2.5a.6.6 0 00-.446.18.6.6 0 00-.18.445q0 .267.18.446.18.18.446.18zm0-3.333q.265 0 .445-.18t.18-.445a.6.6 0 00-.18-.445.6.6 0 00-.445-.18h-2.5a.6.6 0 00-.446.18.6.6 0 00-.18.445q0 .266.18.445.18.18.446.18z"/></g>', width: 20, height: 20 }, "fact-check-cross": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M5 7.292h2.5a.61.61 0 00.625-.625.606.606 0 00-.625-.625H5a.605.605 0 00-.625.625.605.605 0 00.625.625m0 3.333h2.5A.607.607 0 008.125 10a.6.6 0 00-.176-.448.6.6 0 00-.449-.177H5a.606.606 0 00-.625.625.605.605 0 00.625.625m0 3.333h2.5a.6.6 0 00.449-.176.6.6 0 00.176-.449.6.6 0 00-.176-.448.6.6 0 00-.449-.177H5a.606.606 0 00-.625.625.61.61 0 00.625.625m-1.416 3.125q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063V4.417q0-.625.437-1.063a1.45 1.45 0 011.063-.437h12.833q.624 0 1.062.437.438.438.438 1.063v11.166q0 .625-.438 1.063a1.45 1.45 0 01-1.062.437zm0-1.25h12.833q.082 0 .166-.083t.084-.167V4.417q0-.084-.084-.167-.082-.084-.166-.083H3.584q-.084 0-.167.083t-.083.167v11.166q0 .083.083.167.082.084.167.083"/><path d="m12.77 11.146-1.728 1.729a.6.6 0 01-.438.167.6.6 0 01-.437-.167.6.6 0 01-.167-.437q0-.271.167-.438l1.729-1.73-1.73-1.728A.6.6 0 0110 8.104q0-.27.167-.437a.6.6 0 01.437-.167q.27 0 .438.167l1.729 1.729 1.729-1.73a.6.6 0 01.438-.166q.27 0 .437.167a.6.6 0 01.167.437q0 .27-.167.438l-1.73 1.729L15.376 12a.6.6 0 01.167.438q0 .27-.167.437a.6.6 0 01-.437.167.6.6 0 01-.438-.167z"/></g>', width: 20, height: 20 }, "fact-check-tick": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5 7.292h2.5a.61.61 0 00.625-.625.606.606 0 00-.625-.625H5a.605.605 0 00-.625.625.605.605 0 00.625.625m0 3.333h2.5A.61.61 0 008.125 10a.6.6 0 00-.176-.448.6.6 0 00-.449-.177H5a.606.606 0 00-.625.625.605.605 0 00.625.625m0 3.333h2.5a.6.6 0 00.449-.176.6.6 0 00.176-.449q0-.27-.176-.448a.6.6 0 00-.449-.177H5a.606.606 0 00-.625.625.61.61 0 00.625.625m7.125-2.062a.8.8 0 00.282-.053.6.6 0 00.239-.176l2.875-2.855q.209-.207.198-.448a.63.63 0 00-.198-.427.67.67 0 00-.458-.187.6.6 0 00-.438.187l-2.5 2.5-.75-.75a.56.56 0 00-.437-.177.64.64 0 00-.438.198.7.7 0 00-.177.438.56.56 0 00.177.437l1.104 1.084a.6.6 0 00.24.176q.135.053.281.053m-8.541 5.187q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063V4.417q0-.625.437-1.063a1.45 1.45 0 011.063-.437h12.833q.624 0 1.062.437.438.438.438 1.063v11.166q0 .625-.438 1.063a1.45 1.45 0 01-1.062.437zm0-1.25h12.833q.082 0 .166-.083t.084-.167V4.417q0-.084-.084-.167-.082-.084-.166-.083H3.584q-.084 0-.167.083-.083.084-.083.167v11.166q0 .083.083.167.082.084.167.083"/></g>', width: 20, height: 20 }, "failed-overridden": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path fill-rule="evenodd" d="M3.063 10.373 6 7.436 7.394 8.83A4.7 4.7 0 018.83 7.394L7.436 6l2.937-2.937a.98.98 0 00.294-.718.98.98 0 00-.294-.718.98.98 0 00-.718-.294.98.98 0 00-.718.294L6 4.564 3.063 1.627a.98.98 0 00-.718-.294.98.98 0 00-.718.294.98.98 0 00-.294.718q0 .424.294.718L4.564 6 1.627 8.937a.98.98 0 00-.294.718q0 .424.294.718a.98.98 0 00.718.294.98.98 0 00.718-.294" clip-rule="evenodd"/><path d="M11.333 11.333q.5 0 .85-.35t.35-.85-.35-.85a1.16 1.16 0 00-.85-.35q-.5 0-.85.35t-.35.85.35.85.85.35m0 2.4q.621 0 1.14-.29.52-.29.84-.77a3.84 3.84 0 00-1.98-.54 3.84 3.84 0 00-1.98.54q.321.48.84.77.52.29 1.14.29m0 1.6q-1.66 0-2.83-1.17t-1.17-2.83 1.17-2.83 2.83-1.17 2.83 1.17 1.17 2.83-1.17 2.83-2.83 1.17"/></g>' }, feature: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.333 5.205v7.051a.4.4 0 00.115.295.4.4 0 00.295.115h8.513a.4.4 0 00.295-.115.4.4 0 00.115-.295V5.205H9.999v3.647q0 .307-.252.466a.49.49 0 01-.522.019l-1.226-.606-1.225.606a.49.49 0 01-.522-.018.52.52 0 01-.253-.467V5.205zm.41 8.128q-.447 0-.762-.315a1.04 1.04 0 01-.315-.762V4.991q0-.195.062-.367.063-.171.187-.316L3.953 3.06a.9.9 0 01.362-.294q.217-.1.466-.1h6.41q.25 0 .473.1.224.099.369.294l1.051 1.273a1 1 0 01.187.323q.062.179.062.373v7.227q0 .448-.315.762-.315.315-.762.315zm-.156-8.795h8.812l-.887-1.064a.5.5 0 00-.147-.102.4.4 0 00-.173-.039H4.794a.4.4 0 00-.173.039.5.5 0 00-.147.102zm3.079.667v3.436l1.333-.667 1.334.667V5.205z"/></g>' }, feedback: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m7.788 14.292 2.624-1.584 2.625 1.604-.687-3 2.313-2-3.042-.27-1.209-2.834-1.208 2.813-3.042.27 2.313 2.021zm2.624-.104-3.25 1.937a.62.62 0 01-.687-.02.7.7 0 01-.23-.282.53.53 0 01-.02-.386l.854-3.666-2.854-2.48a.62.62 0 01-.187-.687.7.7 0 01.198-.281.6.6 0 01.343-.136l3.771-.333 1.48-3.479a.6.6 0 01.24-.282.66.66 0 01.342-.093.66.66 0 01.345.093.6.6 0 01.239.282l1.479 3.48 3.77.332a.62.62 0 01.543.417.61.61 0 01-.188.688l-2.854 2.479.854 3.666a.53.53 0 01-.02.386.7.7 0 01-.23.281.62.62 0 01-.687.021z"/></g>', width: 20, height: 20 }, "file-export": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4B5768" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.375 11.625v3.062a.61.61 0 00.625.625.6.6 0 00.448-.176.6.6 0 00.177-.449v-3.062l1.104 1.104q.083.083.209.136a.5.5 0 00.24.042 1 1 0 00.228-.053.45.45 0 00.198-.146.6.6 0 00.188-.437.6.6 0 00-.188-.438L10.521 9.75a.7.7 0 00-.24-.157.8.8 0 00-.562 0 .7.7 0 00-.24.157l-2.083 2.083a.6.6 0 00-.188.438q0 .25.209.437a.63.63 0 00.427.199q.24.01.448-.199zM5.25 17.917q-.625 0-1.062-.438a1.45 1.45 0 01-.438-1.062V3.583q0-.624.438-1.062a1.45 1.45 0 011.062-.438h6a1.5 1.5 0 011.063.438l3.5 3.5a1.5 1.5 0 01.438 1.063v9.333q-.001.624-.439 1.062a1.45 1.45 0 01-1.062.438zm6-11.584v-3h-6q-.083 0-.167.084Q5 3.499 5 3.583v12.834q0 .082.083.166t.167.084h9.5q.083 0 .167-.084.083-.082.083-.166V7.083h-3a.72.72 0 01-.532-.219.72.72 0 01-.218-.53"/></g>', width: 20, height: 20 }, "filled-star": { body: '<mask id="svgID0" width="33" height="32" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h32v32H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m16.5 22.3-5.2 3.1a.94.94 0 01-.567.15 1 1 0 01-.533-.183 1.13 1.13 0 01-.367-.45.84.84 0 01-.033-.617l1.367-5.867L6.6 14.467a.99.99 0 01-.3-1.1q.1-.267.317-.451a1 1 0 01.55-.216l6.033-.533L15.567 6.6q.132-.3.384-.45Q16.2 6 16.5 6t.55.15.383.45l2.367 5.567 6.033.533a1 1 0 01.551.216q.216.184.316.45a.99.99 0 01-.3 1.1l-4.567 3.967L23.2 24.3a.84.84 0 01-.033.617 1.13 1.13 0 01-.367.45 1 1 0 01-.533.182.94.94 0 01-.567-.149z"/></g>', width: 33, height: 32 }, filter: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.334 8.667v4a.65.65 0 01-.192.474.65.65 0 01-.475.192H7.334a.64.64 0 01-.475-.192.64.64 0 01-.192-.474v-4L2.8 3.733a.63.63 0 01-.074-.7q.174-.366.608-.366h9.333q.433 0 .609.366a.64.64 0 01-.076.7zM8 8.2 11.3 4H4.7z"/></g>' }, "filter-list": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 16h16V0H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.333 5a.64.64 0 00-.474.192.64.64 0 00-.192.475q0 .284.192.474a.64.64 0 00.474.192h1.334a.65.65 0 00.475-.192.64.64 0 00.191-.474.65.65 0 00-.191-.475A.65.65 0 008.667 5zm-4.666 6.667a.64.64 0 00-.475.191.65.65 0 00-.192.475q0 .284.192.476a.65.65 0 00.475.191h10.666a.65.65 0 00.475-.191.65.65 0 00.192-.476.65.65 0 00-.192-.475.64.64 0 00-.475-.191zm2-3.334a.65.65 0 00-.476.192A.65.65 0 004 9q0 .283.191.475a.65.65 0 00.476.192h6.666a.65.65 0 00.475-.192A.65.65 0 0012 9a.64.64 0 00-.192-.475.64.64 0 00-.475-.192z"/></g>' }, firefox: { body: '<path fill="currentColor" d="M478.1 235.3c-.7-4.5-1.4-7.1-1.4-7.1s-1.8 2-4.7 5.9c-.9-10.7-2.8-21.2-5.8-31.6-3.7-12.9-8.5-25.4-14.5-37.4-3.8-8-8.2-15.6-13.3-22.8-1.8-2.7-3.7-5.4-5.6-7.9-8.8-14.4-19-23.3-30.7-40-7.6-12.8-12.9-26.9-15.4-41.6-3.2 8.9-5.7 18-7.4 27.3-12.1-12.2-22.5-20.8-28.9-26.7C319.4 24.2 323 9.1 323 9.1S264.7 74.2 289.9 142c8.7 23 23.8 43.1 43.4 57.9 24.4 20.2 50.8 36 64.7 76.6-11.2-21.3-28.1-39.2-48.8-51.5 6.2 14.7 9.4 30.6 9.3 46.5 0 61-49.6 110.5-110.6 110.4-8.3 0-16.5-.9-24.5-2.8-9.5-1.8-18.7-4.9-27.4-9.3-12.9-7.8-24-18.1-32.8-30.3l-.2-.3 2 .7c4.6 1.6 9.2 2.8 14 3.7 18.7 4 38.3 1.7 55.6-6.6 17.5-9.7 28-16.9 36.6-14h.2c8.4 2.7 15-5.5 9-14-10.4-13.4-27.4-20-44.2-17-17.5 2.5-33.5 15-56.4 2.9-1.5-.8-2.9-1.6-4.3-2.5-1.6-.9 4.9 1.3 3.4.3-5-2.5-9.8-5.4-14.4-8.6-.3-.3 3.5 1.1 3.1.8-5.9-4-11-9.2-15-15.2-4.1-7.4-4.5-16.4-1-24.1 2.1-3.8 5.4-6.9 9.3-8.7 3 1.5 4.8 2.6 4.8 2.6s-1.3-2.5-2.1-3.8c.3-.1.5 0 .8-.2 2.6 1.1 8.3 4 11.4 5.8 2.1 1.1 3.8 2.7 5.2 4.7 0 0 1-.5.3-2.7-1.1-2.7-2.9-5-5.4-6.6h.2c2.3 1.2 4.5 2.6 6.6 4.1 1.9-4.4 2.8-9.2 2.6-14 .2-2.6-.2-5.3-1.1-7.8-.8-1.6.5-2.2 1.9-.5-.2-1.3-.7-2.5-1.2-3.7v-.1s.8-1.1 1.2-1.5c1-1 2.1-1.9 3.4-2.7 7.2-4.5 14.8-8.4 22.7-11.6 6.4-2.8 11.7-4.9 12.8-5.6 1.6-1 3.1-2.2 4.5-3.5 5.3-4.5 9-10.8 10.2-17.7.1-.9.2-1.8.3-2.8v-1.5c-.9-3.5-6.9-6.1-38.4-9.1-11.1-1.8-20-10.1-22.5-21.1v-.1c6-15.7 16.8-29.1 30.8-38.3.8-.7-3.2.2-2.4-.5 2.7-1.3 5.4-2.5 8.2-3.5 1.4-.6-6-3.4-12.6-2.7-4 .2-8 1.2-11.7 2.8 1.6-1.3 6.2-3.1 5.1-3.1-8.4 1.6-16.5 4.7-23.9 9 0-.8.1-1.5.5-2.2-5.9 2.5-11 6.5-15 11.5.1-.9.2-1.8.2-2.7-2.7 2-5.2 4.3-7.3 6.9l-.1.1c-17.4-6.7-36.3-8.3-54.6-4.7l-.2-.1h.2c-3.8-3.1-7.1-6.7-9.7-10.9l-.2.1-.4-.2c-1.2-1.8-2.4-3.8-3.7-6-.9-1.6-1.8-3.4-2.7-5.2 0-.1-.1-.2-.2-.2-.4 0-.6 1.7-.9 1.3v-.1c-3.2-8.3-4.7-17.2-4.4-26.2l-.2.1c-5.1 3.5-9 8.6-11.1 14.5-.9 2.1-1.6 3.3-2.2 4.5v-.5c.1-1.1.6-3.3.5-3.1s-.2.3-.3.4c-1.5 1.7-2.9 3.7-3.9 5.8-.9 1.9-1.7 3.9-2.3 5.9-.1.3 0-.3 0-1s.1-2 0-1.7l-.3.7c-6.7 14.9-10.9 30.8-12.4 47.1-.4 2.8-.6 5.6-.5 8.3v.2c-4.8 5.2-9 11-12.7 17.1-12.1 20.4-21.1 42.5-26.8 65.6 4-8.8 8.8-17.2 14.3-25.1C5.5 228.5 0 257.4 0 286.6c1.8-8.6 4.2-17 7-25.3-1.7 34.5 4.9 68.9 19.4 100.3 19.4 43.5 51.6 80 92.3 104.7 16.6 11.2 34.7 19.9 53.8 25.8 2.5.9 5.1 1.8 7.7 2.7-.8-.3-1.6-.7-2.4-1 22.6 6.8 46.2 10.3 69.8 10.3 83.7 0 111.3-31.9 113.8-35 4.1-3.7 7.5-8.2 9.9-13.3 1.6-.7 3.2-1.4 4.9-2.1l1-.5 1.9-.9c12.6-5.9 24.5-13.4 35.3-22.1 16.3-11.7 27.9-28.7 32.9-48.1 3-7.1 3.1-15 .4-22.2.9-1.4 1.7-2.8 2.7-4.3 18-28.9 28.2-61.9 29.6-95.9v-2.8c0-7.3-.6-14.5-1.9-21.6m-299-97.6c-.4 1.1-.9 2.3-1.3 3.5.4-1.2.8-2.3 1.3-3.5"/>', width: 480, height: 512 }, flag: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.167 13.833a.48.48 0 01-.357-.143.48.48 0 01-.143-.357v-9.73q0-.256.173-.43A.58.58 0 014.27 3h4.295q.215 0 .381.134a.58.58 0 01.212.348l.173.851h3.067q.255 0 .429.173a.58.58 0 01.173.427v4.8a.58.58 0 01-.173.428.6.6 0 01-.43.172H9.436a.6.6 0 01-.381-.134.58.58 0 01-.212-.348L8.67 9H4.667v4.333q0 .212-.144.357a.48.48 0 01-.356.143m5.6-4.5H12v-4H8.5L8.233 4H4.667v4H9.5z"/></g>' }, "flash-on": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.487 10.55q-.1.163-.268.106-.17-.056-.17-.23V7h-.974a.43.43 0 01-.325-.13.45.45 0 01-.125-.32V1.738q0-.188.125-.32a.43.43 0 01.325-.13h3.612q.25 0 .382.206a.43.43 0 01.03.431L6.476 5.563h1.112a.44.44 0 01.4.23.41.41 0 010 .457z"/></g>', width: 12, height: 12 }, folder: { body: '<mask id="svgID0" width="21" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.267 0h20v20h-20z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.1 9.792h8.333a.61.61 0 00.625-.625.6.6 0 00-.176-.449.6.6 0 00-.449-.176H6.1a.606.606 0 00-.625.625.605.605 0 00.625.625m0 3.333h5a.61.61 0 00.625-.625q0-.27-.177-.448a.6.6 0 00-.448-.177h-5a.606.606 0 00-.625.625.605.605 0 00.625.625M3.85 16.25q-.625 0-1.062-.437a1.45 1.45 0 01-.438-1.063V5.583q0-.645.438-1.083a1.45 1.45 0 011.062-.437h4.542q.25 0 .479.093.23.095.417.282l.979.979h6.416q.625 0 1.063.437.438.438.437 1.063v7.833q0 .624-.437 1.063a1.45 1.45 0 01-1.063.437zM3.6 5.583v9.167q0 .105.073.178A.24.24 0 003.85 15h12.833q.105 0 .178-.072a.24.24 0 00.072-.178V6.917a.24.24 0 00-.072-.178.24.24 0 00-.178-.072H9.746L8.413 5.313H3.85a.24.24 0 00-.177.073.27.27 0 00-.073.197m0 0v-.27V15z"/></g>', width: 21, height: 20 }, "folder-filled": { body: '<mask id="svgID0" width="36" height="36" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4B5768" d="M0 0h36v36H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.462 29.25q-1.137 0-1.924-.788-.788-.787-.788-1.924V9.462q0-1.137.787-1.924.789-.788 1.925-.788h7.113q.543 0 1.043.21.5.211.87.58l2.209 2.21h11.841q1.137 0 1.924.787.788.788.788 1.925v14.076q0 1.137-.788 1.924-.787.788-1.924.788z"/></g>', width: 36, height: 36 }, "for-loop": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M9.767 3.407a.29.29 0 01.3.293v.733c0 .166-.135.3-.3.309a5.334 5.334 0 104.439 1.961l-.016-.019a.08.08 0 00-.114-.005l-.706.735a.3.3 0 01-.513-.159l-.499-2.996a.3.3 0 01.345-.346l3.005.501a.3.3 0 01.16.51l-.574.565a.31.31 0 00-.02.415 6.667 6.667 0 11-5.508-2.497m1.157 3.104c.05 0 .098.02.133.057a.17.17 0 01.047.135l-.176 1.97a.3.3 0 00.299.327h.957a.27.27 0 01.235.135l.068.117a.17.17 0 01-.004.182l-2.521 4.06a.27.27 0 01-.23.128h-.073a.2.2 0 01-.133-.057.17.17 0 01-.047-.135l.173-1.97a.3.3 0 00-.298-.327h-.959a.28.28 0 01-.234-.135l-.069-.117a.17.17 0 010-.181l2.522-4.06a.28.28 0 01.238-.129z"/></g></g>', width: 20, height: 20 }, "forward-to-inbox": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M13.333 4H2.666v7.795a.2.2 0 00.058.147.2.2 0 00.148.058h5.961v1H2.872q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855v-7.59q0-.506.35-.855.35-.35.855-.35h10.256q.505 0 .855.35t.35.855v4.628h-1zM2.666 4v8-3.167.082zM8 7.333 13.333 4v.962L8.318 8.104A.6.6 0 018 8.197a.6.6 0 01-.318-.093L2.666 5.013V4zM13.052 13h-2.514a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.213.144-.356a.48.48 0 01.356-.144h2.52l-.881-.882a.47.47 0 01-.147-.351.48.48 0 01.157-.352.506.506 0 01.703.007l1.656 1.656q.18.18.18.422 0 .24-.18.422l-1.663 1.663a.47.47 0 01-.343.14.48.48 0 01-.353-.147.47.47 0 01-.138-.345q0-.206.138-.345z"/></g></g>' }, "frame-list": { body: '<g fill="currentColor"><path d="M7 3C4.794 3 3 4.794 3 7s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m9-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m9-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"/><path d="M0 0v60h60V0zm2 2h56v10H2zm56 56H2V14h56z"/><path d="M20 28v-7H4v22h16zM6 23h12v3H6zm0 18V28h12v13zm50-13v-7H40v22h16zm-14-5h12v3H42zm0 18V28h12v13zm-4-17v-7H22v30h16zm-2-4.414L33.586 22h-2.172l3-3H36zM26.414 22l3-3h2.172l-3 3zm.172-3L24 21.586V19zM24 45V24h12v21z"/><path d="M7 40h10v-6H7zm2-4h6v2H9zm16 8h10v-6H25zm2-4h6v2h-6zm16 0h10v-6H43zm2-4h6v2h-6zM5 51h14a1 1 0 100-2H5a1 1 0 100 2m14 1H5a1 1 0 100 2h14a1 1 0 100-2m4-1h14a1 1 0 100-2H23a1 1 0 100 2m0 3h14a1 1 0 100-2H23a1 1 0 100 2m18-3h14a1 1 0 100-2H41a1 1 0 100 2m0 3h14a1 1 0 100-2H41a1 1 0 100 2"/></g>', width: 60, height: 60 }, "github-logo": { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" fill-rule="evenodd" d="M9.5 0c-4.972 0-9 4.028-9 9a8.99 8.99 0 006.154 8.539c.45.078.619-.192.619-.428 0-.213-.012-.922-.012-1.676-2.261.416-2.846-.551-3.026-1.058-.101-.258-.54-1.057-.923-1.27-.314-.17-.764-.586-.01-.597.708-.011 1.214.652 1.383.922.81 1.362 2.104.98 2.621.743.079-.585.315-.979.574-1.204-2.002-.225-4.095-1.001-4.095-4.443 0-.98.349-1.79.922-2.42-.09-.224-.404-1.147.09-2.384 0 0 .754-.237 2.476.922a8.4 8.4 0 012.25-.303c.765 0 1.53.1 2.25.303 1.72-1.17 2.475-.922 2.475-.922.495 1.237.18 2.16.09 2.385.573.63.922 1.428.922 2.419 0 3.453-2.104 4.218-4.106 4.443.326.281.607.822.607 1.665 0 1.204-.011 2.172-.011 2.475 0 .236.169.518.619.428A9.015 9.015 0 0018.5 9c0-4.972-4.027-9-9-9" clip-rule="evenodd"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M.5 0h18v18H.5z"/></clipPath></defs></g>', width: 19, height: 18 }, "grid-logo": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.489 14q-.624 0-1.057-.432A1.44 1.44 0 010 12.51V1.49Q0 .865.432.432.865 0 1.49 0h11.02q.624 0 1.057.432Q14 .865 14 1.49v11.02q0 .624-.432 1.057T12.51 14zM5.4 10.912h3.2q.615 0 1.052-.437.436-.435.436-1.052V7.127a.72.72 0 00-.213-.532.72.72 0 00-.531-.213H7.982a.6.6 0 00-.44.178.6.6 0 00-.178.44q0 .263.178.44a.6.6 0 00.44.178h.87v1.805a.25.25 0 01-.07.182.25.25 0 01-.182.071H5.4a.25.25 0 01-.182-.07.25.25 0 01-.07-.183V4.577q0-.111.07-.182a.25.25 0 01.183-.071h4.687a1.34 1.34 0 00-.472-.883 1.4 1.4 0 00-.953-.353H5.4q-.616 0-1.053.437-.435.435-.436 1.052v4.846q0 .615.436 1.053.437.435 1.053.436"/></g>', width: 14, height: 14 }, "grid-view": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.332 7.333a.96.96 0 01-.708-.292.96.96 0 01-.292-.708v-3q0-.417.292-.708a.96.96 0 01.708-.292h3q.417 0 .708.292.292.291.292.708v3a.96.96 0 01-.292.708.96.96 0 01-.708.292zm0 6.333a.96.96 0 01-.708-.292.96.96 0 01-.292-.708v-3q0-.415.292-.708a.96.96 0 01.708-.292h3q.417 0 .708.292.292.292.292.708v3a.96.96 0 01-.292.708.96.96 0 01-.708.292zm6.333-6.333a.96.96 0 01-.708-.292.96.96 0 01-.292-.708v-3q0-.417.292-.708a.96.96 0 01.708-.292h3q.417 0 .708.292.292.291.292.708v3a.96.96 0 01-.292.708.96.96 0 01-.708.292zm0 6.333a.96.96 0 01-.708-.292.96.96 0 01-.292-.708v-3q0-.415.292-.708a.96.96 0 01.708-.292h3q.417 0 .708.292.292.292.292.708v3a.96.96 0 01-.292.708.96.96 0 01-.708.292zM3.332 6.333h3v-3h-3zm6.333 0h3v-3h-3zm0 6.333h3v-3h-3zm-6.333 0h3v-3h-3z"/></g>' }, handyman: { body: '<path fill="currentColor" d="M19.758 24.054a1 1 0 01-.379-.072 1.4 1.4 0 01-.35-.22l-6.154-6.154v-.933l2.77-2.742h.905l6.154 6.154a.7.7 0 01.233.335q.06.19.059.395 0 .233-.058.408a.9.9 0 01-.234.35l-2.187 2.188q-.176.146-.35.219a1.1 1.1 0 01-.409.072m0-1.983 1.255-1.254-5.309-5.309-1.254 1.255zM4.212 24.083a1 1 0 01-.422-.087 1.2 1.2 0 01-.336-.233l-2.187-2.188a1.05 1.05 0 01-.248-.364 1.1 1.1 0 010-.789q.073-.189.248-.364l6.095-6.095h2.45l.934-.934-4.871-4.87H4.212L.975 4.92l2.887-2.888L7.1 5.271v1.662l4.87 4.871 3.472-3.441-1.721-1.721 1.487-1.459h-2.975l-.641-.641L15.325.808l.613.642v2.975l1.487-1.487 4.404 4.375q.467.465.686 1.05a3.4 3.4 0 01.043 2.274q-.174.525-.583.963l-2.42-2.42-1.663 1.633-1.225-1.225-5.63 5.629v2.479l-6.095 6.066a1.8 1.8 0 01-.35.234.84.84 0 01-.38.087m0-2.041 5.338-5.338-1.225-1.254-5.367 5.367z"/>', width: 25, height: 20 }, "hard-drive": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.334 10.9h9.312a.18.18 0 00.134-.053.18.18 0 00.052-.134V7.338H3.148v3.375q0 .082.052.134.053.052.134.052m7.717-1.025q.315 0 .536-.22a.73.73 0 00.22-.536.73.73 0 00-.22-.536.73.73 0 00-.535-.221.73.73 0 00-.536.22.73.73 0 00-.221.536q0 .315.22.536a.73.73 0 00.535.221m2.69-3.444h-1.28l-1.338-1.362H4.858L3.519 6.43H2.24l1.928-1.951q.148-.155.35-.237.2-.082.421-.082h6.102q.22 0 .422.082.2.083.35.237zM3.334 11.807q-.45 0-.773-.321a1.05 1.05 0 01-.321-.773V6.43h11.5v4.283q0 .452-.321.773a1.05 1.05 0 01-.773.321z"/></g>' }, "headset-mic": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M8.5 14.794a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.212.144-.356a.48.48 0 01.356-.144h3.962a.2.2 0 00.147-.058.2.2 0 00.058-.147v-.59h-1.154a1.16 1.16 0 01-.851-.354 1.16 1.16 0 01-.354-.85V9.486q0-.498.354-.852a1.16 1.16 0 01.851-.354h1.154v-.948q0-1.935-1.367-3.3Q9.934 2.666 8 2.666T4.7 4.033q-1.367 1.365-1.367 3.3v.948h1.154q.498 0 .851.354.354.354.354.852v2.307q0 .498-.354.851a1.16 1.16 0 01-.85.354h-.95q-.504 0-.854-.35a1.16 1.16 0 01-.35-.855V7.333q0-1.166.446-2.199A5.8 5.8 0 013.998 3.33a5.8 5.8 0 011.804-1.218A5.5 5.5 0 018 1.666q1.166 0 2.199.446 1.033.447 1.804 1.218.771.772 1.218 1.804a5.5 5.5 0 01.446 2.199v6.256q0 .505-.35.855t-.855.35z"/></g></g>' }, help: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 11.75a.63.63 0 00.476-.2.67.67 0 00.191-.484.67.67 0 00-.191-.483.63.63 0 00-.476-.2.67.67 0 00-.683.683.67.67 0 00.683.684m.05-6.6q.518 0 .825.274.309.276.309.742 0 .3-.176.592a2.8 2.8 0 01-.524.609q-.484.416-.7.79-.217.377-.234.776a.34.34 0 00.117.292.477.477 0 00.642 0 .53.53 0 00.175-.309q.05-.283.216-.525.167-.24.534-.608.516-.482.716-.867.2-.383.2-.833 0-.8-.583-1.309t-1.5-.508q-.617 0-1.133.258-.517.259-.817.776a.53.53 0 00-.058.325q.024.158.191.258.15.101.359.067a.5.5 0 00.341-.217q.201-.267.459-.425.258-.159.641-.158M8 14.333a6.1 6.1 0 01-2.466-.5 6.5 6.5 0 01-2.009-1.35 6.3 6.3 0 01-1.358-2.008A6.2 6.2 0 011.667 8q0-1.317.5-2.476a6.3 6.3 0 011.358-2.007 6.5 6.5 0 012.009-1.35A6.1 6.1 0 018 1.667a6.2 6.2 0 012.484.5 6.5 6.5 0 012.008 1.35 6.2 6.2 0 011.35 2.007q.492 1.16.492 2.476t-.492 2.475a6.2 6.2 0 01-1.35 2.008 6.5 6.5 0 01-2.008 1.35 6.2 6.2 0 01-2.484.5m0-1q2.234 0 3.784-1.558T13.334 8t-1.55-3.775Q10.234 2.665 8 2.667q-2.2 0-3.766 1.558Q2.667 5.783 2.667 8t1.567 3.775T8 13.333"/></g>' }, "hide-circle-outline": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m9.537 10.95-.787-.775q-.613.4-1.306.612A4.9 4.9 0 016 11a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.588-1.069q-.675-.675-1.068-1.587A4.9 4.9 0 011 6q0-.75.212-1.444.213-.694.613-1.306l-.788-.788a.5.5 0 01-.143-.344.46.46 0 01.143-.355q.15-.15.357-.15.206 0 .356.15l8.5 8.487a.5.5 0 01.144.344.47.47 0 01-.144.356q-.15.15-.356.15a.5.5 0 01-.357-.15M6 10a3.97 3.97 0 002.025-.55L2.55 3.975q-.274.476-.413.981A4 4 0 002 6q0 1.662 1.169 2.832Q4.338 10 6 10m4.175-1.25-.725-.725q.274-.475.412-.982Q10 6.538 10 6q0-1.662-1.169-2.831T6 2a3.96 3.96 0 00-2.025.55l-.725-.725a5.1 5.1 0 011.306-.612A4.9 4.9 0 016 1q1.038 0 1.95.393a5 5 0 011.587 1.07q.675.675 1.069 1.587T11 6q0 .75-.213 1.444a5.1 5.1 0 01-.612 1.306"/></g>', width: 12, height: 12 }, "hide-source": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m12.852 14.267-1.153-1.143a6.4 6.4 0 01-1.732.894A6.1 6.1 0 018 14.333a6.2 6.2 0 01-2.468-.499A6.4 6.4 0 013.52 12.48a6.4 6.4 0 01-1.355-2.011A6.2 6.2 0 011.666 8q0-1.032.316-1.967.315-.934.894-1.732L1.723 3.15a.494.494 0 010-.713.5.5 0 01.357-.155.5.5 0 01.356.155l11.128 11.128q.15.15.152.348a.48.48 0 01-.152.355.5.5 0 01-.356.155.5.5 0 01-.357-.155m.471-2.831-8.759-8.76a6.5 6.5 0 011.63-.748A6.2 6.2 0 018 1.667q1.313 0 2.469.499t2.01 1.355 1.355 2.01.5 2.469q0 .942-.261 1.806a6.5 6.5 0 01-.75 1.63"/></g>' }, "hide-source-outline": { body: '<path fill="currentColor" d="m9.905 11.163-.894-.882q-.652.435-1.39.66a5.3 5.3 0 01-1.534.223 5.1 5.1 0 01-2.058-.412 5.3 5.3 0 01-1.662-1.119 5.3 5.3 0 01-1.119-1.662 5.1 5.1 0 01-.412-2.058q0-.796.224-1.534.224-.737.659-1.39l-.884-.894a.55.55 0 01-.168-.402q0-.231.17-.399a.56.56 0 01.406-.168q.234 0 .403.17l9.07 9.058a.53.53 0 01.164.405.58.58 0 01-.174.405.54.54 0 01-.4.17.55.55 0 01-.4-.171M6.085 9.64q.486 0 .944-.12.459-.121.882-.351l-5.08-5.08q-.241.424-.356.877a4 4 0 00-.115.95q0 1.56 1.082 2.642T6.085 9.64m0-7.45q-.22 0-.43.019-.212.018-.417.078a1.05 1.05 0 01-.61-.036.74.74 0 01-.43-.4.7.7 0 01-.018-.58.64.64 0 01.417-.387A5.2 5.2 0 016.085.667q1.1 0 2.056.412.954.413 1.661 1.119a5.3 5.3 0 011.12 1.662q.411.955.411 2.055a5.2 5.2 0 01-.217 1.488.64.64 0 01-.387.417.7.7 0 01-.58-.018.74.74 0 01-.4-.43 1.05 1.05 0 01-.036-.61 2 2 0 00.078-.423q.02-.218.019-.424 0-1.56-1.083-2.642T6.085 2.191"/>', width: 12, height: 12 }, "highlight-diff": { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" fill-rule="evenodd" d="M13.6 0a2.4 2.4 0 012.396 2.259L16 2.4v11.2a2.4 2.4 0 01-2.259 2.396L13.6 16H2.4a2.4 2.4 0 01-2.396-2.259L0 13.6V2.4A2.4 2.4 0 012.259.004L2.4 0zM7.2 1.6H2.4c-.41 0-.748.397-.794.909l-.006.12V7.2h.8a.8.8 0 110 1.6h-.8v4.8c0 .41.397.749.909.795l.12.005H7.2v-.8a.8.8 0 011.6 0v.8h4.8a.8.8 0 00.795-.706l.005-.094V8.8h-.8a.8.8 0 010-1.6h.8V2.63a1.03 1.03 0 00-.908-1.022l-.12-.007H8.8v.8a.8.8 0 11-1.6 0zm.8 4a.8.8 0 01.795.707L8.8 6.4v.8h.8a.8.8 0 01.094 1.595L9.6 8.8h-.8v.8a.8.8 0 01-1.594.094L7.2 9.6v-.8h-.8a.8.8 0 01-.093-1.594L6.4 7.2h.8v-.8a.8.8 0 01.8-.8" clip-rule="evenodd"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, history: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m10.667 9.75 2.291 2.292a.58.58 0 01.167.427.65.65 0 01-.167.448.6.6 0 01-.447.187.6.6 0 01-.449-.187l-2.437-2.438a.9.9 0 01-.156-.26.8.8 0 01-.052-.281v-3.48a.605.605 0 01.624-.625q.25 0 .438.178a.6.6 0 01.188.447zm-.688 7.333q-2.438 0-4.343-1.468a6.73 6.73 0 01-2.49-3.802.65.65 0 01.052-.521.6.6 0 01.406-.313.54.54 0 01.48.104.9.9 0 01.29.438 5.6 5.6 0 002.063 3.114 5.67 5.67 0 003.542 1.198q2.438 0 4.136-1.698T15.812 10q0-2.438-1.697-4.136T9.979 4.167q-1.354 0-2.552.604a6.2 6.2 0 00-2.052 1.667h1.542q.27 0 .448.176a.6.6 0 01.177.449.606.606 0 01-.625.625H4.062a.72.72 0 01-.531-.22.72.72 0 01-.219-.53V4.083a.61.61 0 01.625-.625q.27 0 .449.177a.6.6 0 01.176.448v1.355A7 7 0 017 3.573a7 7 0 012.979-.656q1.48 0 2.77.562A7.2 7.2 0 0115 5a7.1 7.1 0 011.51 2.24q.554 1.281.553 2.76 0 1.479-.552 2.76A7.1 7.1 0 0115 15a7.2 7.2 0 01-2.25 1.52 6.9 6.9 0 01-2.771.563"/></g>', width: 20, height: 20 }, home: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5 15.833h2.792v-4.958h4.416v4.958H15v-7.5l-5-3.77-5 3.77zm0 1.25q-.52 0-.885-.365a1.2 1.2 0 01-.365-.885v-7.5q0-.291.135-.562.135-.27.365-.438l5-3.77q.167-.126.354-.178.188-.051.396-.052.208 0 .396.052t.354.178l5 3.77q.23.167.364.438.136.27.136.562v7.5q0 .522-.365.885a1.2 1.2 0 01-.885.365h-4.042v-4.958H9.042v4.958z"/></g>', width: 20, height: 20 }, "home-max-dots": { body: '<g fill="none"><mask id="svgID0" width="24" height="25" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .949h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M5.25 17.95h13.5q.93 0 1.59-.66T21 15.7v-5.5q0-.931-.66-1.591t-1.59-.66H5.25q-.93 0-1.59.66T3 10.199v5.5q0 .93.66 1.59t1.59.66m2.25 2.384v-.885H5.25a3.6 3.6 0 01-2.652-1.098A3.6 3.6 0 011.5 15.7v-5.5q0-1.554 1.098-2.652A3.6 3.6 0 015.25 6.45h13.5q1.554 0 2.652 1.098A3.6 3.6 0 0122.5 10.2v5.5q0 1.554-1.098 2.652a3.6 3.6 0 01-2.652 1.098H16.5v.885zm3-6.5a.86.86 0 00.626-.254.85.85 0 00.259-.63.85.85 0 00-.26-.627.85.85 0 00-.625-.258.85.85 0 00-.63.258.86.86 0 00-.255.626q0 .378.254.631.255.254.631.254m-3 0a.86.86 0 00.626-.254.85.85 0 00.259-.63.85.85 0 00-.26-.627.85.85 0 00-.625-.258.85.85 0 00-.63.258.86.86 0 00-.255.626q0 .378.254.631.255.254.631.254m6 0a.86.86 0 00.626-.254.85.85 0 00.259-.63.85.85 0 00-.26-.627.85.85 0 00-.625-.258.85.85 0 00-.63.258.86.86 0 00-.255.626q0 .378.254.631.255.254.631.254m3 0a.86.86 0 00.626-.254.85.85 0 00.259-.63.85.85 0 00-.259-.627.85.85 0 00-.626-.258.85.85 0 00-.63.258.86.86 0 00-.255.626q0 .378.254.631.255.254.631.254"/></g></g>', width: 24, height: 25 }, "hourglass-empty": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.436 13.334h5.128v-2q0-1.113-.738-1.929Q9.089 8.59 8 8.59q-1.086 0-1.825.815a2.78 2.78 0 00-.739 1.929zM8 7.41q1.088 0 1.826-.816a2.78 2.78 0 00.738-1.928v-2H5.436v2q0 1.113.739 1.928.738.816 1.825.816m4.436 6.923H3.564a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.212.144-.356a.48.48 0 01.356-.143h.872v-2q0-1.087.559-1.998A3.3 3.3 0 016.518 8a3.3 3.3 0 01-1.523-1.335 3.75 3.75 0 01-.559-1.998v-2h-.872a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.213.144-.356a.48.48 0 01.356-.144h8.872q.213 0 .356.144a.48.48 0 01.144.356q0 .212-.144.356a.48.48 0 01-.356.144h-.872v2a3.75 3.75 0 01-.558 1.998A3.3 3.3 0 019.482 8a3.3 3.3 0 011.524 1.336 3.75 3.75 0 01.558 1.998v2h.872q.213 0 .356.143a.48.48 0 01.144.357q0 .213-.144.356a.48.48 0 01-.356.144"/></g>' }, "hourglass-top": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.383 13.283h5.234v-1.95q0-1.083-.767-1.85A2.52 2.52 0 008 8.717q-1.083 0-1.85.766a2.52 2.52 0 00-.767 1.85zm7.334 1.517H3.283a.73.73 0 01-.533-.217.73.73 0 01-.217-.533q0-.333.217-.55a.73.73 0 01.533-.217h.584v-1.95q0-1 .45-1.892.45-.89 1.266-1.441a3.74 3.74 0 01-1.266-1.442 4.14 4.14 0 01-.45-1.891v-1.95h-.584A.73.73 0 012.75 2.5a.75.75 0 01-.217-.55q0-.317.217-.533a.73.73 0 01.533-.217h9.434q.315 0 .533.217a.73.73 0 01.217.533.75.75 0 01-.217.55.73.73 0 01-.533.217h-.584v1.95a4.14 4.14 0 01-.45 1.891A3.74 3.74 0 0110.417 8a3.74 3.74 0 011.266 1.441q.45.893.45 1.892v1.95h.584q.315 0 .533.217a.75.75 0 01.217.55.73.73 0 01-.217.533.73.73 0 01-.533.217"/></g>' }, html: { body: '<path fill="currentColor" d="M.417 10.017A.414.414 0 010 9.6V6.4q0-.183.117-.3a.4.4 0 01.3-.117q.183 0 .308.117a.4.4 0 01.125.3v1.067H2.6V6.4q0-.183.117-.3a.4.4 0 01.3-.117q.183 0 .308.117a.4.4 0 01.125.3v3.2a.4.4 0 01-.125.3.44.44 0 01-.308.117A.414.414 0 012.6 9.6V8.3H.85v1.3a.4.4 0 01-.125.3.44.44 0 01-.308.117m5.266 0a.414.414 0 01-.416-.417V6.817h-.75a.4.4 0 01-.3-.117.4.4 0 01-.117-.3q0-.183.117-.3a.4.4 0 01.3-.117H6.85q.183 0 .308.117a.4.4 0 01.125.3.4.4 0 01-.125.3.44.44 0 01-.308.117h-.733V9.6a.4.4 0 01-.125.3.44.44 0 01-.309.117m8.184 0a.5.5 0 01-.375-.142.5.5 0 01-.142-.375V6.4q0-.183.117-.3a.4.4 0 01.3-.117q.183 0 .3.117a.4.4 0 01.116.3v2.783h1.4q.184 0 .3.117a.4.4 0 01.117.3.4.4 0 01-.117.3.4.4 0 01-.3.117zm-5.517 0a.414.414 0 01-.417-.417V6.567q0-.267.167-.425a.58.58 0 01.417-.159h3.333q.267 0 .433.159a.56.56 0 01.167.425V9.6a.4.4 0 01-.125.3.44.44 0 01-.308.117.414.414 0 01-.417-.417V6.817h-1.017v2.1q0 .184-.108.291a.4.4 0 01-.292.109.4.4 0 01-.283-.109.38.38 0 01-.117-.291v-2.1h-1V9.6a.4.4 0 01-.125.3.44.44 0 01-.308.117"/>' }, hub: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.501 17.062q-.859 0-1.461-.602A2 2 0 012.438 15q0-.86.601-1.461a2 2 0 011.462-.602q.24 0 .472.06a2.3 2.3 0 01.439.16l1.487-1.85a2.8 2.8 0 01-.645-1.14A2.9 2.9 0 016.182 8.9l-2.16-.716a2.2 2.2 0 01-.744.729q-.46.274-1.028.274-.86 0-1.46-.602a2 2 0 01-.602-1.46q0-.86.601-1.461.602-.603 1.46-.602.86 0 1.462.601a1.99 1.99 0 01.598 1.572l-.003.09 2.153.748q.31-.573.852-.985.54-.411 1.242-.528V4.258a2.05 2.05 0 01-1.17-.732 2 2 0 01-.445-1.28q0-.855.601-1.457Q8.141.187 9 .187t1.462.601.602 1.461q0 .716-.452 1.277-.45.563-1.164.732V6.56q.701.117 1.24.528.537.411.855.985l2.153-.748a1 1 0 01-.007-.093v-.108q0-.86.601-1.46.602-.602 1.46-.602.86 0 1.462.601.602.602.602 1.46 0 .86-.602 1.462a2 2 0 01-1.46.602q-.565 0-1.033-.274a2.05 2.05 0 01-.739-.729l-2.16.716q.105.637-.073 1.262a2.8 2.8 0 01-.644 1.138l1.487 1.839q.206-.094.438-.148a2 2 0 01.473-.054q.86 0 1.461.601.602.602.602 1.46 0 .86-.602 1.462-.6.602-1.46.602-.859 0-1.461-.602a2 2 0 01-.602-1.46q0-.356.114-.684.115-.328.343-.602l-1.487-1.865q-.639.381-1.41.381a2.74 2.74 0 01-1.417-.38l-1.475 1.864q.22.275.339.602.117.33.118.683 0 .86-.601 1.461-.602.602-1.46.602m-2.25-9q.39 0 .664-.274a.9.9 0 00.273-.664.9.9 0 00-.273-.664.9.9 0 00-.665-.273.9.9 0 00-.664.273.9.9 0 00-.273.664q0 .39.273.664a.9.9 0 00.664.274m2.25 7.875q.39 0 .664-.273a.9.9 0 00.273-.665.9.9 0 00-.273-.664.9.9 0 00-.665-.273.9.9 0 00-.664.273.9.9 0 00-.273.664q0 .39.273.665a.9.9 0 00.664.273M9 3.187q.39 0 .664-.274a.9.9 0 00.273-.664.9.9 0 00-.273-.664A.9.9 0 009 1.312a.9.9 0 00-.664.273.9.9 0 00-.273.664q0 .39.273.664A.9.9 0 009 3.187m0 7.918q.722 0 1.226-.504a1.67 1.67 0 00.504-1.227q0-.722-.504-1.226A1.67 1.67 0 009 7.643q-.722 0-1.226.505a1.67 1.67 0 00-.504 1.226q0 .722.504 1.227A1.67 1.67 0 009 11.105m4.5 4.832q.39 0 .664-.273a.9.9 0 00.273-.665.9.9 0 00-.273-.664.9.9 0 00-.665-.273.9.9 0 00-.664.273.9.9 0 00-.273.664q0 .39.273.665a.9.9 0 00.664.273m2.25-7.875q.39 0 .664-.274a.9.9 0 00.273-.664.9.9 0 00-.273-.664.9.9 0 00-.665-.273.9.9 0 00-.664.273.9.9 0 00-.273.664q0 .39.273.664a.9.9 0 00.664.274"/></g>', width: 18, height: 18 }, hybrid: { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.684 18q-.333 0-.517-.184-.167-.2-.167-.534V6.718q0-.351.167-.534Q7.35 6 7.684 6t.501.184q.183.183.184.534v4.606h7.06V6.718q0-.351.166-.534Q15.78 6 16.113 6t.5.184q.184.183.184.534v10.564q0 .334-.184.534-.166.184-.5.184t-.518-.184q-.167-.2-.167-.534V12.51h-7.06v4.773q0 .334-.166.534-.168.184-.518.184"/></g>', width: 24, height: 24 }, "hybrid-logo": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.581 15.375a.67.67 0 01-.477-.187.62.62 0 01-.198-.47V8.832q0-.281.197-.478a.65.65 0 01.478-.197h2.907q.281 0 .478.197a.65.65 0 01.197.478v5.888a.62.62 0 01-.197.469.67.67 0 01-.478.187zm0-1.406h2.907V9.58H12.58zM6.6 15.375a.55.55 0 01-.403-.159.55.55 0 01-.16-.403q0-.245.16-.404a.55.55 0 01.403-.159h1.05v-1.875H3.206q-.58 0-.975-.394a1.3 1.3 0 01-.393-.956v-7.05q0-.563.393-.956.394-.394.975-.394h10.032q.562 0 .956.394.393.393.393.956v2.119a.546.546 0 01-.562.562.56.56 0 01-.394-.16.53.53 0 01-.168-.402V3.975a.24.24 0 00-.057-.159q-.056-.066-.168-.066H3.206a.24.24 0 00-.178.066.22.22 0 00-.065.159v7.05q0 .094.065.159a.24.24 0 00.178.066h6.638q.244 0 .403.159a.55.55 0 01.16.403.55.55 0 01-.16.404.55.55 0 01-.403.159H8.775v1.875h1.069q.244 0 .403.159a.55.55 0 01.16.403.55.55 0 01-.16.404.55.55 0 01-.403.159z"/></g>', width: 18, height: 18 }, "id-card": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#647488" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M14.888 10.609q.266 0 .445-.18.18-.18.18-.445a.6.6 0 00-.18-.445.6.6 0 00-.445-.18h-2.532a.6.6 0 00-.446.18.6.6 0 00-.18.445q0 .266.18.445.18.18.446.18zm0-2.404q.266 0 .445-.18.18-.178.18-.445a.6.6 0 00-.18-.445.6.6 0 00-.445-.18h-2.532a.6.6 0 00-.446.18.6.6 0 00-.18.445q0 .266.18.446t.446.18zm-7.356 2.756a6 6 0 00-1.258.116 3.1 3.1 0 00-.958.367 1.8 1.8 0 00-.579.498 1 1 0 00-.197.591q0 .22.168.365.167.147.414.147h4.82a.58.58 0 00.415-.157.51.51 0 00.167-.388.92.92 0 00-.193-.547 2.1 2.1 0 00-.583-.509 3.1 3.1 0 00-.958-.367 6 6 0 00-1.258-.116m0-1.09q.608 0 1.033-.425.426-.425.425-1.032 0-.608-.425-1.033a1.4 1.4 0 00-1.033-.426q-.607 0-1.033.426a1.4 1.4 0 00-.425 1.033q0 .607.425 1.032.426.426 1.033.426M3.59 16.25q-.631 0-1.07-.437a1.45 1.45 0 01-.437-1.07V5.256q0-.63.438-1.069A1.45 1.45 0 013.59 3.75h12.82q.631 0 1.07.438.436.437.437 1.068v9.488q0 .63-.438 1.069a1.45 1.45 0 01-1.069.437zm0-1.25h12.82a.24.24 0 00.177-.08.24.24 0 00.08-.177V5.256a.24.24 0 00-.08-.176.25.25 0 00-.177-.08H3.59a.25.25 0 00-.176.08.25.25 0 00-.08.176v9.488q0 .096.08.176t.176.08"/></g>', width: 20, height: 20 }, idea: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M10 16.563q-.459 0-.792-.261a1.04 1.04 0 01-.396-.698h-.479a.8.8 0 01-.583-.25.8.8 0 01-.25-.583v-2.5a5.05 5.05 0 01-2-1.949 5.2 5.2 0 01-.708-2.614q0-2.186 1.51-3.698Q7.812 2.5 10 2.5t3.698 1.51 1.51 3.698a5.2 5.2 0 01-.708 2.614 5.05 5.05 0 01-2 1.949v2.5a.8.8 0 01-.25.583.8.8 0 01-.583.25h-.48a1.04 1.04 0 01-.395.698q-.334.26-.792.26M8.333 14.77h3.334v-.813H8.333zm0-1.438h3.334V12.5H8.333zm-.166-1.666h3.666a4.56 4.56 0 001.834-1.594q.708-1.053.708-2.365 0-1.833-1.27-3.104-1.272-1.27-3.105-1.27t-3.104 1.27-1.271 3.104q0 1.313.708 2.364a4.56 4.56 0 001.834 1.595"/><path d="M9.55 10.8a.18.18 0 01-.147-.07.2.2 0 01-.04-.165l.302-2.26H8.567q-.133 0-.16-.07t.045-.193l1.832-3.538a.14.14 0 01.071-.076.2.2 0 01.098-.028.18.18 0 01.146.07.2.2 0 01.04.165l-.301 2.26h1.098q.123 0 .155.07.03.07-.04.193l-1.833 3.539a.14.14 0 01-.071.075.2.2 0 01-.097.028"/></g>', width: 20, height: 20 }, "if-condition": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M4.889 8.445H8c.654 0 1.238.348 1.645.89a7.2 7.2 0 011.059-1.478C9.99 7.126 9.045 6.667 8 6.667H4.889a.889.889 0 100 1.778m6.831 2.765c.49-1.473 2.005-2.765 3.244-2.765h1.633l-1.149 1.149a.888.888 0 101.257 1.257L20 7.556 16.705 4.26a.888.888 0 10-1.257 1.257l1.15 1.149h-1.634c-2.022 0-4.188 1.748-4.931 3.981l-.42 1.254c-.57 1.712-1.841 2.765-2.502 2.765H4.89a.889.889 0 100 1.778h2.22c1.633 0 3.434-1.711 4.19-3.982z"/><path d="M15.448 12.26a.89.89 0 000 1.258l1.15 1.149h-2.079c-1.127 0-2.071-.792-2.392-1.874a8.3 8.3 0 01-.969 1.942c.788 1.033 1.994 1.71 3.361 1.71h2.078l-1.149 1.149a.888.888 0 101.257 1.257L20 15.556l-3.295-3.295a.89.89 0 00-1.257 0"/></g>', width: 24, height: 24 }, iframe: { body: '<g fill="currentColor"><path d="M14.2 54.6C8.9 57.2 5.9 60.4 2.4 67 .6 70.4.5 77 .2 251.5 0 351 .2 434.8.5 437.6c.9 7.3 5.8 15.1 11.9 18.9l4.9 3 61.2.3c58.8.2 61.3.2 63.6-1.6 3.4-2.8 3.2-8.7-.5-11.8l-2.7-2.4H22.3l-2.7-2.5-2.6-2.4V72.9l2.6-2.4 2.7-2.5H150c125.9 0 127.8 0 130.3-2 1.3-1.1 2.8-3.1 3.1-4.5.7-2.9-1.5-7.9-3.9-8.9-.9-.3-59.8-.6-130.9-.6H19.4zm290.5-1.4c-4.3 3.3-4 10 .5 13.2 3.4 2.4 6.6 1.9 10-1.4 2.5-2.6 2.9-3.6 2.4-6.3-.3-1.8-1.6-4-2.7-5-2.5-2-7.8-2.2-10.2-.5m33.3.8c-3.1 3.1-2.7 9.3.6 11.9 2.6 2.1 3.3 2.1 76.9 2.1h74.2l2.7 2.5 2.6 2.4v366.2l-2.6 2.4-2.7 2.5H168.3l-2.7 2.1c-3.3 2.6-3.7 8.8-.6 11.9 2 2 2.9 2 165.8 1.8l163.9-.3 4.9-3c5.5-3.4 10.7-11.1 11.8-17.2.3-2.1.6-84.6.6-183.3s-.3-181.2-.6-183.3c-1.1-6.1-6.3-13.8-11.8-17.2l-4.9-3-77.4-.3C341 52 340 52 338 54"/><path d="m54.6 122.1-2.6 2v263.8l2.6 2 2.7 2.1h270.4l2.1-2.3c3.2-3.4 3-8.9-.4-11.6-2.7-2.1-2.7-2.1-132-2.1H68V136h268.1l2.4-2.5c1.6-1.5 2.5-3.6 2.5-5.5s-.9-4-2.5-5.5l-2.4-2.5H57.3zm306.6.2-2.2 2.3v263.1l2.3 2.1c2.3 2.2 2.5 2.2 47.9 2.2 44.5 0 45.6 0 48.2-2.1 2-1.6 2.6-2.9 2.6-5.9s-.6-4.3-2.6-5.9c-2.6-2-3.7-2.1-42.5-2.1H375V136h69v107.6c0 79.8.3 108.1 1.2 109.7 2.6 5 7.7 6.1 12.2 2.6l2.6-2V124.1l-2.6-2c-2.6-2.1-3.7-2.1-48.4-2.1h-45.7z"/><path d="M396.3 164.2c-5.8 5.7-10.9 11.3-11.4 12.5-1.1 2.8.7 8 3.1 9.3 4.6 2.5 8 1.2 14.9-5.4l6.6-6.5 6.7 6.5c5.5 5.3 7.2 6.4 10 6.4 1.8 0 4.3-.7 5.5-1.5 2.7-1.9 3.8-6.7 2.3-9.7-1.7-3.2-16.9-18.6-20.2-20.4-5.1-2.6-6.6-1.9-17.5 8.8m-8.6 162c-2.4 1.9-3.8 6.4-2.8 9 .5 1.3 5.6 6.9 11.4 12.5 10.6 10.5 12.5 11.5 17 9.2 3.2-1.6 18.6-16.9 20.3-20.2 3.1-5.8-.7-11.7-7.4-11.7-2.8 0-4.5 1.1-10.1 6.4l-6.6 6.5-6.7-6.5c-5.5-5.3-7.1-6.4-10-6.4-1.9 0-4.2.6-5.1 1.2"/></g>', width: 512, height: 512 }, "ignore-selection": { body: '<g fill="none"><g fill="currentColor" clip-path="url(#svgID0)"><path d="M1.6 0C.712 0 0 .712 0 1.6v12.8c0 .888.712 1.6 1.6 1.6h3.2v-1.6H1.6V1.6h12.8v3.2H16V1.6c0-.888-.712-1.6-1.6-1.6zM8 6.4c-.888 0-1.6.712-1.6 1.6v1.6H8V8h1.6V6.4zm5.6 0V8h.8v1.6H16V6.4zm.8 7.2v.8h-1.6V16h1.6c.888 0 1.6-.712 1.6-1.6v-.8zm-8 0V16h2.4v-1.6H8v-.8z"/><path d="M12.8 10.4H9.6V12h3.2zm0-4h-2.4V8h2.4zm-.8 8H9.6V16H12zm-4-4H6.4v2.4H8zm8 0h-1.6v2.4H16z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, import: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 16h16V0H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 5.5a.484.484 0 00-.5.5v6.85l-.883-.883a.5.5 0 00-.35-.134.48.48 0 00-.35.15.48.48 0 000 .7l1.666 1.667q.084.083.192.125a.62.62 0 00.45 0 .55.55 0 00.192-.125l1.666-1.667q.15-.15.15-.358a.5.5 0 00-.15-.358.5.5 0 00-.35-.134.5.5 0 00-.35.134l-.883.883V6a.485.485 0 00-.5-.5M4.2 1q-.5 0-.85.35T3 2.2v6.933q0 .5.35.85t.85.35h1.217q.2 0 .35-.141.15-.142.15-.359a.47.47 0 00-.15-.358.5.5 0 00-.35-.142H4.2q-.067 0-.133-.066Q4 9.199 4 9.133V2.2q0-.067.067-.133Q4.133 2 4.2 2h7.6q.067 0 .133.067.067.067.067.133v6.933q0 .068-.067.134t-.133.066h-1.217a.5.5 0 00-.35.142.47.47 0 00-.15.358q0 .217.15.359.15.141.35.141H11.8q.5 0 .85-.35t.35-.85V2.2q0-.5-.35-.85A1.16 1.16 0 0011.8 1z"/></g>' }, "import-export": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.5 12.516V8a.486.486 0 01.5-.5q.216 0 .359.141A.5.5 0 0110.5 8v4.516l1.55-1.533q.133-.15.333-.15t.35.15q.167.15.167.35a.48.48 0 01-.15.35l-2.333 2.333a.54.54 0 01-.192.125.62.62 0 01-.45 0 .54.54 0 01-.192-.125L7.25 11.683a.48.48 0 01-.15-.35q0-.2.167-.35.15-.15.342-.15.191 0 .358.15zm-4-9.033L3.95 5.016a.43.43 0 01-.35.158.45.45 0 01-.333-.158.46.46 0 01-.167-.35q0-.2.15-.35l2.333-2.333a.55.55 0 01.192-.125.62.62 0 01.45 0 .55.55 0 01.192.125L8.75 4.316a.48.48 0 010 .7.48.48 0 01-.35.15.54.54 0 01-.367-.15L6.5 3.483V8a.485.485 0 01-.5.5.484.484 0 01-.5-.5z"/></g>' }, incognito: { body: '<g fill="currentColor"><path d="M5.5 17a3.23 3.23 0 110-6.462A3.23 3.23 0 015.5 17m0-5.385a2.154 2.154 0 100 4.308 2.154 2.154 0 000-4.308M13.577 17a3.231 3.231 0 110-6.462 3.231 3.231 0 010 6.462m0-5.385a2.154 2.154 0 100 4.308 2.154 2.154 0 000-4.308"/><path d="M8.192 13.236h2.693v1.077H8.192zm8.347-4.846h-14a.538.538 0 000 1.077h14a.538.538 0 000-1.077"/><path d="M15.58 9.462H3.497l1.077-5.25A1.51 1.51 0 016.022 3h7.027a1.51 1.51 0 011.476 1.212zM4.81 8.385h9.456l-.797-3.963a.43.43 0 00-.42-.345H6.022a.43.43 0 00-.42.345z"/></g>', width: 20, height: 20 }, "indeterminate-check-box": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.334 8.5h5.333a.486.486 0 00.5-.5.5.5 0 00-.141-.359.5.5 0 00-.359-.141H5.334a.485.485 0 00-.5.5.484.484 0 00.5.5m-1.8 5.166q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.533q0-.5.35-.85t.85-.35h8.933q.5 0 .85.35t.35.85v8.933q0 .5-.35.85t-.85.35zm0-1h8.933q.068 0 .134-.066.066-.068.066-.134V3.533q0-.066-.066-.133-.068-.067-.134-.067H3.534q-.066 0-.133.067t-.067.133v8.933q0 .068.067.134t.133.066"/></g>' }, info: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 13.959a.6.6 0 00.448-.177.6.6 0 00.177-.448V9.77a.58.58 0 00-.177-.428.6.6 0 00-.448-.176.606.606 0 00-.625.625v3.562q0 .25.178.428a.6.6 0 00.447.177m0-6.209a.63.63 0 00.48-.198.68.68 0 00.187-.49.66.66 0 00-.667-.666.66.66 0 00-.667.667q0 .291.188.489A.63.63 0 0010 7.75m0 10.167a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.645.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.687A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.624 1.449.625 3.094a7.7 7.7 0 01-.625 3.094 8 8 0 01-1.688 2.51 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625m0-1.25q2.77 0 4.72-1.948 1.946-1.948 1.947-4.719 0-2.77-1.948-4.719Q12.771 3.334 10 3.334q-2.77 0-4.718 1.947-1.95 1.948-1.949 4.72 0 2.77 1.949 4.718Q7.229 16.667 10 16.667"/></g>', width: 20, height: 20 }, "info-fill": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M10 13.958q.265 0 .445-.18t.18-.445V9.791a.6.6 0 00-.18-.445.6.6 0 00-.446-.18.6.6 0 00-.445.18.6.6 0 00-.18.445v3.542q0 .265.18.445t.446.18m0-6.218q.285 0 .48-.193a.65.65 0 00.193-.48q0-.285-.194-.48a.65.65 0 00-.48-.193q-.285 0-.479.193a.65.65 0 00-.193.48q0 .285.193.48a.65.65 0 00.48.193m0 10.176a7.7 7.7 0 01-3.088-.623A8 8 0 014.4 15.601a8 8 0 01-1.692-2.513 7.7 7.7 0 01-.624-3.087q0-1.642.623-3.088A8 8 0 014.398 4.4a8 8 0 012.513-1.692 7.7 7.7 0 013.087-.624q1.642 0 3.088.623 1.444.624 2.514 1.692a8 8 0 011.693 2.513q.623 1.445.623 3.087a7.7 7.7 0 01-.623 3.088 8 8 0 01-1.692 2.514 8 8 0 01-2.513 1.693 7.7 7.7 0 01-3.087.623"/></g></g>', width: 20, height: 20 }, insights: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m12.333 5.73-.705-1.563-1.564-.705 1.564-.706.705-1.564.705 1.564 1.564.706-1.564.705zm0 9.078-.705-1.564-1.564-.705 1.564-.706.705-1.564.705 1.564 1.564.706-1.564.705zm-6.41-2.282L4.513 9.41 1.397 8l3.116-1.41 1.41-3.116 1.41 3.116L10.45 8 7.333 9.41zm0-2.426.667-1.433L8.023 8 6.59 7.333 5.923 5.9l-.667 1.433L3.823 8l1.433.667z"/></g>' }, "install-app": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.756 18.583q-.562 0-.951-.388a1.3 1.3 0 01-.388-.951V2.756q0-.563.388-.95.39-.39.951-.39h5.734a.526.526 0 01.542.538.53.53 0 01-.156.387.52.52 0 01-.386.159H5.756a.25.25 0 00-.176.08.25.25 0 00-.08.176v.952h5.99a.526.526 0 01.542.538.53.53 0 01-.156.387.52.52 0 01-.386.159H5.5v10.416h9V13.75a.526.526 0 01.537-.542q.23 0 .387.156a.52.52 0 01.16.386v3.494q0 .563-.39.95a1.3 1.3 0 01-.95.39zM5.5 16.292v.952q0 .096.08.176t.176.08h8.487a.24.24 0 00.177-.08.24.24 0 00.08-.176v-.952zm9.208-7.657V3.75a.526.526 0 01.537-.542q.23 0 .388.156a.52.52 0 01.159.386v4.843l1.519-1.52a.55.55 0 01.383-.176q.21-.004.39.177.182.18.182.387 0 .205-.181.387l-2.391 2.39a.62.62 0 01-.461.206.65.65 0 01-.469-.205l-2.35-2.35a.5.5 0 01-.166-.383.57.57 0 01.188-.39q.18-.182.387-.182.206 0 .387.181z"/></g>', width: 20, height: 20 }, integrations: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M13.313 11.063V9.938h1.688q.244 0 .403.159a.55.55 0 01.16.403.546.546 0 01-.563.563zm0 3v-1.125h1.688q.244 0 .403.159a.55.55 0 01.16.403.55.55 0 01-.16.404.55.55 0 01-.403.159zm-2.812.75q-.544 0-.929-.44a1.56 1.56 0 01-.384-1.06h-1.5v-2.625h1.5q0-.62.384-1.06.385-.44.929-.44h1.387q.281 0 .479.196a.65.65 0 01.196.479v4.275a.65.65 0 01-.196.478.65.65 0 01-.479.197zm-5.25-2.25a2.7 2.7 0 01-1.988-.825 2.7 2.7 0 01-.825-1.988q0-1.162.825-1.987a2.7 2.7 0 011.988-.825h1.125q.543 0 .928-.384.384-.385.384-.929 0-.543-.384-.928a1.27 1.27 0 00-.928-.384H3.75a.544.544 0 01-.563-.563.547.547 0 01.563-.562h2.625q1.012 0 1.725.712a2.35 2.35 0 01.712 1.725A2.35 2.35 0 018.1 7.35a2.35 2.35 0 01-1.725.713H5.25q-.694 0-1.191.496a1.63 1.63 0 00-.497 1.191q0 .695.497 1.19.497.498 1.19.498h1.688v1.125z"/></g>', width: 18, height: 18 }, intermediate: { body: '<rect width="14" height="3" x="3" y="9" fill="currentColor" rx="1.5"/>', width: 20, height: 20 }, "internet-explorer": { body: '<path fill="currentColor" d="M16.318 5.898c.35-.793.69-1.949.69-2.832 0-2.344-2.568-3.171-6.758-1.244-3.467-.232-6.806 2.374-7.64 6.01.995-1.124 2.523-2.652 3.932-3.26-1.75 1.556-3.242 3.526-4.374 5.58C1.5 11.374.75 13.349.75 14.825c0 3.177 2.993 2.788 5.81 1.353 1.011.496 2.144.503 3.276.503 3.13 0 5.938-1.75 6.987-4.705H12.93c-1.694 2.855-6.343 1.708-6.343-1.53h10.596c.207-1.405-.053-3.085-.865-4.548M2.83 11.928a7.5 7.5 0 003.23 3.975c-2.859 1.577-5.583.937-3.23-3.975M6.568 8.42c.064-1.777 1.62-3.057 3.352-3.057 1.72 0 3.287 1.28 3.351 3.057zm5.947-6.046c.69-.33 1.564-.709 2.337-.709 1.012 0 1.75.7 1.75 1.732 0 .644-.24 1.579-.471 2.187-.845-1.364-2.125-2.63-3.616-3.21"/>', width: 18, height: 18 }, "invalid-selector-selection": { body: '<g fill="currentColor"><path d="M7.8 2.1C5.5 3.3 3.2 5.6 2 8c-1.9 3.7-2 5.8-2 37 0 30.5.1 33.4 1.9 36.8 3.1 6 8.1 8.2 19 8.2H30v332h-9c-11.2 0-15.9 2-19 8-1.9 3.7-2 5.8-2 37 0 37.6.2 38.5 7.8 42.8 3.9 2.2 4.6 2.2 37.1 2.2 31.3 0 33.4-.1 37.1-2 6-3.1 8-7.8 8-19v-9h332v9c0 11 1.8 15.4 7.8 18.8 3.9 2.2 4.6 2.2 37.1 2.2 31.3 0 33.4-.1 37.1-2 2.6-1.3 4.7-3.4 6-6 1.9-3.7 2-5.8 2-37s-.1-33.3-2-37c-3.1-6-7.8-8-19-8h-9V90h9c11.2 0 15.9-2 19-8 1.9-3.7 2-5.8 2-37s-.1-33.3-2-37c-1.3-2.6-3.4-4.7-6-6-3.7-1.9-5.8-2-37-2s-33.3.1-37 2c-6 3.1-8 7.8-8 19v9H90v-9c0-11.2-2-15.9-8-19-3.7-1.9-5.8-2-37.2-2-31.2.1-33.5.2-37 2.1M422 69c0 16.2 4.8 21 20.9 21h9.1v332h-9c-16.3 0-21 4.7-21 21v9H90v-9c0-16.3-4.7-21-21-21h-9V90h9c16.3 0 21-4.7 21-21v-9h332z"/><path d="M248.5 110.9c-1.6 1-11.4 10.4-21.6 20.7-19.7 19.9-20.8 21.6-19.5 28.9 1.3 6.6 7.4 11.6 14.5 11.7 4.9 0 7.5-1.3 13.9-7.5l5.2-5.1V241h-80.3l4.7-5c4.9-5.2 7.6-10.3 7.6-14.2 0-4.6-3.9-10.6-8.4-12.7-5.1-2.5-8.6-2.6-12.9-.5-3.8 1.9-39.2 36.7-41.3 40.6-1.8 3.5-1.8 10.1 0 13.6 2.1 3.9 37.5 38.7 41.3 40.6 4.3 2.1 7.8 2 12.9-.5 4.5-2.1 8.4-8.1 8.4-12.7 0-3.9-2.7-9-7.6-14.2l-4.7-5H241v80.3l-5-4.7c-5.2-4.9-10.3-7.6-14.2-7.6-4.6 0-10.6 3.9-12.7 8.4-2.5 5.1-2.6 8.6-.5 12.9 1.9 3.8 36.7 39.2 40.6 41.3 3.5 1.8 10.1 1.8 13.6 0 3.9-2.1 38.7-37.5 40.6-41.3 2.1-4.3 2-7.8-.5-12.9-2.1-4.5-8.1-8.4-12.7-8.4-3.9 0-9 2.7-14.2 7.6l-5 4.7V271h81.4l-5.8 5.9c-8.3 8.3-9.3 15.3-3.4 22.5 3.4 4.2 8.9 6.2 14.5 5.1 3.2-.6 6.6-3.4 23.1-19.8 10.7-10.6 20-20.4 20.8-21.9 1.8-3.5 1.8-10.1 0-13.6-.8-1.5-10.1-11.3-20.8-21.9-16.5-16.4-19.9-19.2-23.1-19.8-5.6-1.1-11.1.9-14.5 5.1-5.9 7.2-4.9 14.2 3.4 22.5l5.8 5.9H271v-81.4l5.3 5.1c6.3 6.2 8.9 7.5 13.8 7.5 7.1-.1 13.2-5.1 14.5-11.7 1.3-7.3.2-9-20-29.3-10.5-10.7-20.3-20-21.8-20.8-3.8-2-10.7-1.8-14.3.5"/></g>', width: 512, height: 512 }, investigation: { body: '<g fill="currentColor"><path d="M103.3 7.7c-.7.2-1.3 1.3-1.3 2.4 0 1.7.5 1.9 3.8 1.3 4.5-.8 4.6-.9 3.9-2.9-.6-1.4-3.8-1.9-6.4-.8m14.7.7c0 2 6 3.2 7.1 1.5 1.5-2.4 1-2.9-3.1-2.9-2.8 0-4 .4-4 1.4m15 1.6c0 1.3.7 2 1.9 2 1.1 0 2.6.3 3.4.6.9.3 1.6-.2 2-1.5.3-1.4-.1-2.1-1.7-2.5-4-1.1-5.6-.7-5.6 1.4m-43 .3c-4.2 1.1-4.2 1-3.4 3 .4 1.2 1.4 1.5 3.7 1 3.9-.7 4.7-1.4 3.8-3.4-.5-1.3-1.3-1.4-4.1-.6m58.3 2.3c-.7 1.9.4 3.1 3.8 3.9 1.9.5 2.8.2 3.2-.9.7-1.7.3-2-3.7-3.6-2.1-.8-2.8-.7-3.3.6m-73.5 3C72.2 17 70.9 20 72.9 20c1.1 0 7.1-2.1 7.1-2.5 0-1.1-1.3-3.5-1.9-3.5-.3.1-1.8.8-3.3 1.6m87.9 2.1c-1.3 1.2-.7 2.3 2.4 3.9 2.6 1.3 3.3 1.4 4 .2 1.3-2 1.1-2.4-1.6-3.6-3-1.4-3.9-1.5-4.8-.5M60.8 22.6c-3.1 1.6-3.6 3.2-1.3 4 2.2.9 6.6-2.3 5.9-4.1s-1.2-1.8-4.6.1m115.6 2.8c-.4 1 .3 2.4 1.7 3.6 2.9 2.3 3.3 2.4 4.8.6.9-1 .6-1.7-1.1-2.8-4.5-2.9-4.8-2.9-5.4-1.4M47.1 32.3c-2 2.2-2 2.5-.6 3.7 1.4 1.1 2 1 4.2-1.2 2.5-2.5 2.5-4.8-.1-4.8-.7 0-2.2 1.1-3.5 2.3m56.8 7.7-2.3 7-5.1 1.5c-2.8.8-7.8 2.8-11 4.4l-6 3-6.1-3.3-6.1-3.4-9.1 9.1-9 9.2 3.3 5.8 3.3 5.9-3.8 8.1c-2.1 4.5-4.1 9.6-4.4 11.3-.6 2.7-1.4 3.3-7.6 5.3l-7 2.2v24.8l7 2.2 7 2.3 1.5 5.1c.8 2.8 2.8 7.8 4.4 11l3 6-3.3 6.1-3.4 6.1 9.1 9.1 9.2 9 6-3.4 6-3.3 6.9 3.5c3.8 1.9 8.8 3.9 11.1 4.5 4 1 4.2 1.3 6.4 8l2.2 6.9h24.8l2.2-7 2.3-7 5.1-1.5c2.8-.8 7.7-2.8 11-4.4l5.8-3 4.7 2.4 4.7 2.4 9.6-9.7 9.6-9.7-2.4-4.6-2.4-4.7 2.8-5.3c1.6-3 3.7-7.9 4.6-11l1.8-5.6 6.8-2.2 6.9-2.2v-24.8l-7-2.2-7-2.3-1.5-5.1c-.8-2.8-2.8-7.8-4.4-11l-3-6 3.3-6 3.4-6-9-9.2-9.1-9.1-6.2 3.4-6.2 3.4-5.4-2.9c-3-1.6-7.9-3.7-11-4.6l-5.6-1.8-2.2-6.8-2.2-6.9h-24.8zm28 27.5c8.8 2.3 16.2 6.6 23.1 13.5 21.1 20.9 21.3 53.6.4 74.4-20.8 20.9-53.5 20.7-74.4-.4-10.4-10.5-15-21.7-15-37.1 0-15 4.4-25.6 15.4-36.5 11-11 21-15.3 36.1-15.3 5-.1 11.4.6 14.4 1.4"/><path d="M112.4 94c-12.3 1.7-22.6 7.4-32.9 18l-6 6.1 8.1 7.7c12.2 11.6 22.5 16.1 37 16.2 9.1 0 18.1-2.7 26.3-8 7.2-4.7 17.1-14.1 17.1-16.3 0-.9-3.2-4.5-7.1-8.1-8.1-7.5-20.3-14.1-27.6-15.1-2.7-.3-5.9-.7-7.3-.9-1.4-.1-4.8 0-7.6.4m15.3 9.6c2.7 1.6 4.8 3.8 6.2 6.7 7.6 15.7-7.9 31.2-23.6 23.6-8.2-3.9-12.1-15.6-8-23.6 2.1-3.9 7.1-8.1 10.5-8.9 1.5-.3 3.2-.7 3.7-.9 2.1-.6 7.1.8 11.2 3.1"/><path d="M112.2 106c-7.4 3.4-10 12.8-5.5 19.8 3.5 5.6 12.2 7.8 18.4 4.7 6.4-3.4 8.9-12.8 4.9-19.2-3.9-6.5-10.8-8.6-17.8-5.3m77-71.8c-1.7 1.7-1.5 2.2 1.7 4.6 2.3 1.7 3.1 1.9 4 .8 1.6-1.9-4-7.1-5.7-5.4M36.1 42.9c-1.7 2.3-1.8 3.1-.8 4 1.9 1.6 7.2-4 5.5-5.7-1.8-1.8-2.4-1.5-4.7 1.7M200 45.5c-1.1 1.4-1 2 1.2 4.2 1.4 1.4 3.1 2.2 3.7 1.9 1.5-1 1.4-1.7-1.3-4.9-2-2.5-2.4-2.7-3.6-1.2M26.6 55.1c-1.4 2.3-1.5 3.4-.7 4.2.9.9 1.7.6 3.1-1.3 1.1-1.4 1.9-3.1 1.7-3.9-.4-2.6-2.2-2.2-4.1 1m182.7 3c-.8.8-.6 1.9.6 4 1.8 3.2 2 3.3 4 2 1.1-.7 1-1.4-.5-4-2-3.4-2.5-3.6-4.1-2M18.5 68c-1.7 3.2-1.3 5 .9 5 1.6 0 4.1-5.4 3.1-6.9-1.1-1.9-2.4-1.2-4 1.9M217 71c-2.2 1.3-.1 6.4 2.8 6.8 2.6.4 2.7-.3.4-4.5-1.3-2.4-2.1-3-3.2-2.3M12.9 81.7c-1.1 3.1-.6 5.3 1.4 5.3 1.5 0 3.1-5.5 2.1-7.1-1-1.7-2.4-.9-3.5 1.8m209.4 4.1c-2.1 1.3-.1 6.6 2.6 7 1.9.3 2.2 0 1.7-1.7-.3-1.2-.9-3-1.2-4.1-.6-2.2-1.2-2.4-3.1-1.2M9 96.6c-1.5 3.8-1.2 5.4 1 5.4 1.1 0 2-.6 2-1.3 0-.6.3-2.2.6-3.3.9-3.3-2.4-4-3.6-.8m215.5 7.1c1.1 4.9 1.4 5.3 3 4.7 1.1-.5 1.5-1.6 1.3-3.8-.2-2.4-.8-3.2-2.6-3.4-2-.3-2.2 0-1.7 2.5M7 114.1c0 3.3.3 4 1.8 3.7 1.2-.2 1.8-1.4 2-4.1.3-3.2 0-3.7-1.7-3.7-1.8 0-2.1.6-2.1 4.1m219 5.9c0 3.3.3 4 2 4s2-.7 2-4-.3-4-2-4-2 .7-2 4M8.2 125.9c-2.1 1.3-1.1 6.5 1.3 6.9 1.8.2 2-.2 1.7-3.8-.4-4.2-.8-4.5-3-3.1m216.4 8.3c-1 3.8-.7 4.8 1.4 4.8 1.3 0 2-.7 2-1.9 0-1.1.3-2.6.6-3.5.4-1.1 0-1.6-1.4-1.6-1.2 0-2.2.9-2.6 2.2m-215.1 10c.9 4 1.5 4.8 3.6 3.9 2.4-.9.5-7.1-2.2-7.1-1.8 0-2 .4-1.4 3.2m212.1 2.6c-.2.4-.7 2.1-1 3.8-.5 2.4-.3 3.3.9 3.8 1.5.6 3.5-2.7 3.5-5.9 0-1.4-2.7-2.8-3.4-1.7m-206.5 9.1c-1.2.8-1.2 1.4-.1 4 1.2 2.9 2.9 3.9 4.3 2.5.5-.6-1-5-2.2-6.6-.4-.4-1.2-.3-2 .1m200.4 8.1c-1.7 3.2-1.3 5 .9 5 1.6 0 4.1-5.4 3.1-6.9-1.1-1.9-2.4-1.2-4 1.9M178 178.5 165.5 191l27.5 27.5c29.8 29.8 31.9 31.4 40.2 30.1 11.8-1.9 19.1-14.4 14.5-24.9-.7-1.5-9.6-11.2-19.9-21.6-10.4-10.4-18.8-19.2-18.8-19.6s.9-1.9 2-3.5c1.8-2.5 1.8-2.9.4-4.1-1.4-1.1-1.9-.9-3.5 1.1-1 1.4-1.9 2.9-1.9 3.5 0 .5-3.3-2.3-7.3-6.3-4-3.9-7.5-7.2-7.7-7.2-.3 0-6.1 5.6-13 12.5m-156.8-8.6c-1.2.7-1.1 1.4.2 4 1.7 3.3 2.3 3.6 4.4 2.2 1-.6.9-1.4-.5-3.9-2-3.5-2.2-3.6-4.1-2.3m8.3 14.1c-.7 1.2 2.6 5.9 4.2 6 2.1 0 2.4-1.9.7-4.5s-3.8-3.2-4.9-1.5m9.9 11.1c-.3.6.5 2.3 2 3.7 2 2 2.8 2.4 3.8 1.4.9-.9.6-1.7-1.2-3.7-2.6-2.8-3.5-3.1-4.6-1.4M52 205.5c-.7.9-1.1 1.7-.9 1.9 1.9 1.4 5.5 3.6 6 3.6.4 0 .9-.7 1.2-1.5.4-.9-.5-2.2-2.2-3.5-2.5-1.7-3-1.8-4.1-.5m118.8 6.3c-3.1 1.9-3.2 2.1-1.9 4.1.6 1 1.3 1 2.7.2 3.9-2.2 4.5-2.8 3.8-4.4-.7-2-1.1-2-4.6.1m-106.2 1.8c-.8 2.2-.9 2 2.3 3.4 5.2 2.1 7.1-.9 2.1-3.5-3.6-1.9-3.6-1.9-4.4.1m92.2 4.7c-2.6 1-3.5 2.6-2.2 4 .5.4 6-.9 7.2-1.8.5-.4-1-3.5-1.7-3.4-.3.1-1.8.6-3.3 1.2m-78.1 1.4c-1.2 1.2-.7 2 1.8 3.1 3.7 1.7 5.5 1.5 5.5-.7 0-2.3-5.6-4.2-7.3-2.4m63.5 3.1c-1.3.4-2.3 1-2.3 1.4.1.5.1 1.4.1 2.2 0 1.1.8 1.2 3.9.4s3.8-1.4 3.4-2.9c-.6-2-1.3-2.1-5.1-1.1m-48.8 1.6c-.8 2.1-.7 2.3 3.9 3.1 3.3.7 3.7.5 3.7-1.4 0-1.1-.6-2.1-1.2-2.1-.7 0-2.3-.3-3.5-.6-1.6-.4-2.5-.1-2.9 1m15.6 2.7c0 1.8 1.9 2.9 5.1 2.9 1.2 0 1.9-.7 1.9-1.9 0-1.4-.9-2-3.5-2.3-2.8-.3-3.5-.1-3.5 1.3m15-.1c0 1.7.7 2 4 2s4-.3 4-2-.7-2-4-2-4 .3-4 2"/></g>', width: 256, height: 256 }, invite: { body: '<path fill="currentColor" d="M12.75 9.2a.52.52 0 01-.383-.15.5.5 0 01-.15-.367V7.067H10.6a.5.5 0 01-.367-.15.52.52 0 01-.15-.384q0-.216.15-.366t.367-.15h1.617V4.4a.52.52 0 01.15-.383q.15-.15.383-.15.216 0 .367.15.15.15.15.383v1.617h1.616a.52.52 0 01.384.15q.15.15.15.366a.52.52 0 01-.15.384.52.52 0 01-.384.15h-1.616v1.616q0 .217-.15.367t-.367.15M6.017 7.933q-1.15 0-1.875-.725-.725-.724-.725-1.875 0-1.149.725-1.875.724-.725 1.875-.725 1.149 0 1.875.725.725.726.725 1.875t-.725 1.875-1.875.725m-4.867 5.55a.55.55 0 01-.4-.166.55.55 0 01-.167-.4v-1.1q0-.617.317-1.117.316-.5.867-.75 1.266-.55 2.25-.775a9.05 9.05 0 014.008 0q.992.225 2.225.775.55.267.875.758.325.492.325 1.109v1.1a.56.56 0 01-.158.4.54.54 0 01-.409.166zm.567-1.133h8.6v-.517q0-.266-.134-.508a.8.8 0 00-.416-.358q-1.15-.55-1.967-.717a9 9 0 00-1.783-.167q-.968 0-1.784.175t-1.983.709a.87.87 0 00-.392.358 1 1 0 00-.141.508zm4.3-5.55q.633 0 1.05-.417.416-.415.416-1.05 0-.633-.416-1.05-.417-.416-1.05-.416-.635 0-1.05.416-.417.417-.417 1.05 0 .635.417 1.05.415.417 1.05.417"/>' }, ios: { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M7.731 3.585q-.3.085-.84.13.023-1.146.631-1.976Q8.119.914 9.542.6l.02.085q.012.06.021.084 0 .031.005.077l.003.078q0 .469-.235 1.045-.242.577-.75 1.062-.438.414-.875.554m3.623 5.392a2.83 2.83 0 01-.558-1.715q0-.87.525-1.592.284-.394.922-.908a4 4 0 00-.84-.77 3.07 3.07 0 00-1.724-.5q-.573 0-1.397.262-.793.262-1.157.261-.275 0-1.115-.23-.85-.23-1.432-.23-1.39 0-2.297 1.107-.914 1.123-.913 2.876 0 1.862 1.189 3.87Q3.762 13.4 4.99 13.4q.413 0 1.067-.261.655-.255 1.15-.254.524 0 1.22.245.735.247 1.131.247 1.035 0 2.08-1.508.676-.96.994-1.922-.72-.209-1.278-.97"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M.6.6h12.8v12.8H.6z"/></clipPath></defs></g>', width: 14, height: 14 }, "ios-setting": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.86 5.158q-.338.095-.947.147.027-1.29.71-2.224.673-.927 2.273-1.281.01.026.023.095a1 1 0 00.024.095q0 .034.005.087l.003.087q0 .528-.264 1.176-.271.649-.845 1.194-.492.467-.983.624m4.074 6.066a3.2 3.2 0 01-.627-1.93q0-.979.59-1.79.32-.443 1.038-1.023a4.6 4.6 0 00-.946-.865 3.46 3.46 0 00-1.939-.562q-.645 0-1.572.293-.892.296-1.301.295-.309 0-1.255-.26-.955-.26-1.61-.259-1.565 0-2.585 1.246Q2.7 7.633 2.7 9.605q0 2.095 1.338 4.354 1.355 2.24 2.737 2.24.464 0 1.2-.293.738-.286 1.293-.286.591 0 1.373.277.827.276 1.274.277 1.164 0 2.338-1.696.763-1.082 1.119-2.163-.811-.234-1.438-1.091"/></g>', width: 18, height: 18 }, key: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.25 10.219q-.507 0-.862-.356A1.18 1.18 0 014.03 9q0-.506.357-.863.355-.356.862-.356t.862.356q.357.357.357.863t-.357.863a1.18 1.18 0 01-.862.356m0 2.906q-1.725 0-2.925-1.2T1.125 9t1.2-2.925 2.925-1.2q1.2 0 2.175.619.975.618 1.5 1.631h6.469q.131 0 .253.046a.7.7 0 01.234.16l1.181 1.2a.53.53 0 01.16.215.7.7 0 010 .507.5.5 0 01-.16.216l-1.968 1.987q-.094.075-.207.132a.8.8 0 01-.243.075 1 1 0 01-.225-.029.6.6 0 01-.225-.122l-.919-.693-1.05.787a1.3 1.3 0 01-.187.094.6.6 0 01-.207.038.7.7 0 01-.206-.038.7.7 0 01-.187-.094l-1.07-.731H8.926a4.3 4.3 0 01-1.5 1.622 3.93 3.93 0 01-2.175.628m0-1.125q1.087 0 1.875-.656a3.03 3.03 0 001.03-1.594h2.569l1.088.75 1.462-1.069 1.275.975L15.956 9l-.75-.75h-7.05a3.03 3.03 0 00-1.031-1.594Q6.337 6 5.25 6q-1.237 0-2.119.881A2.9 2.9 0 002.25 9q0 1.237.881 2.119A2.9 2.9 0 005.25 12"/></g>', width: 18, height: 18 }, "keyboard-hide": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.583 13.75q-.624 0-1.062-.437a1.45 1.45 0 01-.438-1.063V4.417q0-.625.438-1.063a1.45 1.45 0 011.062-.437h12.834q.624 0 1.062.437.438.438.438 1.063v7.833q0 .624-.438 1.063a1.45 1.45 0 01-1.062.437zm0-1.25h12.834q.082 0 .166-.083t.084-.167V4.417q0-.083-.084-.167-.082-.083-.166-.083H3.583q-.082 0-.166.083t-.084.167v7.833q0 .083.084.167.082.083.166.083m5.688-5.937h1.458V5.104H9.271zm0 2.5h1.458V7.604H9.271zm-2.5-2.5h1.458V5.104H6.771zm0 2.5h1.458V7.604H6.771zm-2.5 0h1.458V7.604H4.271zm0-2.5h1.458V5.104H4.271zm3.229 5h5q.313 0 .52-.209a.7.7 0 00.21-.52.7.7 0 00-.21-.521.7.7 0 00-.52-.209h-5a.7.7 0 00-.52.209.7.7 0 00-.21.52q0 .313.21.521a.7.7 0 00.52.209m4.27-2.5h1.46V7.604h-1.46zm0-2.5h1.46V5.104h-1.46zm2.5 2.5h1.46V7.604h-1.46zm0-2.5h1.46V5.104h-1.46zM10 18.52q-.042 0-.27-.104l-2.022-2.021q-.187-.21-.094-.438.095-.229.365-.229h4.042q.27 0 .365.23.092.228-.094.437l-2.021 2.02q-.042.042-.271.105"/></g>', width: 20, height: 20 }, knowledge: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.625 7.375a.5.5 0 01.093-.27.57.57 0 01.22-.21 7 7 0 011.281-.374 7.3 7.3 0 011.364-.125q.417 0 .792.052.375.053.77.135a.4.4 0 01.25.146q.105.124.105.292 0 .291-.177.416-.177.126-.448.063a5 5 0 00-.635-.083 10 10 0 00-.657-.021q-.603 0-1.187.114a7.6 7.6 0 00-1.104.302q-.292.126-.48 0-.187-.125-.187-.437m0 4.563q0-.147.093-.292a.57.57 0 01.22-.209q.604-.25 1.281-.374a7.5 7.5 0 011.364-.126q.417 0 .792.053.375.052.77.135.147.042.25.167.105.124.105.291 0 .27-.177.406t-.448.073a6.4 6.4 0 00-2.468-.01 6.3 6.3 0 00-1.094.323q-.314.125-.5-.01-.188-.135-.188-.428m0-2.271q0-.147.093-.292a.57.57 0 01.22-.208 7 7 0 011.281-.375 7.3 7.3 0 011.364-.125q.417 0 .792.051.375.052.77.136.147.021.25.156.105.135.105.302 0 .271-.177.406t-.448.053a5 5 0 00-.635-.084 10 10 0 00-.657-.02 6.2 6.2 0 00-2.27.437q-.314.126-.5-.01-.188-.136-.188-.427m-6.208 3.687q1.042 0 2.02.23a8.2 8.2 0 011.938.729V6.124a7 7 0 00-1.896-.854 7.5 7.5 0 00-2.062-.292q-.75 0-1.407.125a9 9 0 00-1.343.375.3.3 0 00-.125.104.22.22 0 00-.042.125v7.875q0 .126.083.177a.16.16 0 00.167.01 7.4 7.4 0 011.26-.312 9 9 0 011.407-.104m5.208.959a8.2 8.2 0 011.938-.73 8.8 8.8 0 012.02-.229q.75 0 1.407.104.655.105 1.26.313a.16.16 0 00.167-.011q.083-.051.083-.177V5.708a.22.22 0 00-.042-.125.3.3 0 00-.125-.104 9 9 0 00-1.343-.375 7.5 7.5 0 00-1.407-.125q-1.042 0-2.062.292-1.02.291-1.896.854zm-.625 1.5q-.25 0-.458-.063a2 2 0 01-.396-.167 7.66 7.66 0 00-3.73-.979q-.77 0-1.5.167a6.6 6.6 0 00-1.416.5.8.8 0 01-.843-.063.87.87 0 01-.407-.77V5.396q0-.27.136-.511a.76.76 0 01.406-.343 7.4 7.4 0 011.76-.615 9 9 0 011.865-.198q1.208 0 2.375.333a8.7 8.7 0 012.208.98 8.7 8.7 0 014.583-1.313 9 9 0 011.865.198 7.4 7.4 0 011.76.615q.27.105.406.343.136.24.136.51v9.043a.84.84 0 01-.417.76.88.88 0 01-.875.052 7.5 7.5 0 00-1.405-.48 6.5 6.5 0 00-1.47-.166q-.979 0-1.926.25a7.7 7.7 0 00-1.803.73q-.187.103-.396.166a1.6 1.6 0 01-.458.063"/></g>', width: 20, height: 20 }, "kobiton-logo": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M5.593 11.671q0-1.069.03-2.062a.823.823 0 00-.912-.843 58 58 0 00-3.023.405.82.82 0 00-.688.81v4.043c0 .4.288.743.683.81.833.14 1.854.29 3.044.42a.822.822 0 00.912-.845q-.045-1.305-.046-2.738m9.665-6.939a57 57 0 00-.411-3.046.82.82 0 00-.81-.686H9.936c-.4 0-.739.287-.806.68a52 52 0 00-.43 3.082c-.054.5.347.932.85.914q1.411-.054 2.975-.055.978 0 1.894.025a.824.824 0 00.84-.914M23 14.019V9.933a.82.82 0 00-.686-.81 53 53 0 00-3.055-.414.824.824 0 00-.91.851q.056 1.432.057 3.022 0 .93-.023 1.804a.824.824 0 00.91.841 58 58 0 003.016-.398.82.82 0 00.69-.81M8.71 19.236c.124 1.187.265 2.21.398 3.054a.82.82 0 00.81.692h4.189a.82.82 0 00.81-.687c.14-.852.286-1.885.412-3.08a.822.822 0 00-.846-.908q-1.366.05-2.871.05-1.067 0-2.059-.03a.823.823 0 00-.842.909m-3.539-1.181a57 57 0 01-3.225-.402.82.82 0 00-.947.81v3.7c0 .453.367.82.82.82h3.668c.5 0 .884-.441.812-.936a64 64 0 01-.385-3.247.83.83 0 00-.743-.745m.725-12.831c.121-1.252.266-2.349.41-3.276A.82.82 0 005.5 1H1.82a.82.82 0 00-.82.82v3.727a.82.82 0 00.943.811c.91-.136 1.985-.273 3.211-.392a.83.83 0 00.743-.742" opacity=".6"/><path d="M22.059 6.307a57 57 0 00-2.747-.348c-1.625 1.208-2.992 3-3.655 3.947l-.032.043q.044 1.256.045 2.633 0 .808-.02 1.573l.007.009c.642.918 1.945 2.628 3.503 3.831a63 63 0 002.903-.355.818.818 0 01.936.812v3.71a.82.82 0 01-.82.821h-3.636a.82.82 0 01-.812-.94 57 57 0 00.35-2.809c-1.472-1.155-2.693-2.648-3.445-3.672q-1.43.059-3.025.06-1.27-.002-2.433-.045a.816.816 0 01-.786-.783 76 76 0 01-.064-3.124q.001-1.282.046-2.454a.816.816 0 01.781-.786 77 77 0 013.368-.073q1.143 0 2.198.037c.747-1.006 1.912-2.408 3.306-3.515a62 62 0 00-.368-2.935A.82.82 0 0118.47 1h3.709a.82.82 0 01.82.82v3.675a.818.818 0 01-.94.812"/></g>', width: 24, height: 24 }, label: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3.09 12.52q-.483 0-.826-.32a1 1 0 01-.344-.765v-6.83q0-.449.344-.767t.826-.318h6.86q.277 0 .526.113.25.113.41.315l2.793 3.415q.24.292.24.657 0 .364-.24.656l-2.793 3.415a1.1 1.1 0 01-.41.315 1.25 1.25 0 01-.526.114zm0-.9h6.86a.2.2 0 00.162-.07l2.793-3.415a.175.175 0 000-.23l-2.793-3.416a.2.2 0 00-.162-.07H3.09a.2.2 0 00-.144.052.17.17 0 00-.056.133v6.83q.001.082.056.134a.2.2 0 00.144.052"/></g></g>' }, "lambdatest-logo": { body: '<path fill="currentColor" d="m5.122 12.989-.009 1.416a.386.386 0 01-.59.324l-.656-.427-.157-.09c-.012-.006-.92-.538-2.891-1.695l-.157-.09a1 1 0 01-.495-.876l.02-3.527.021-3.533a1 1 0 01.155-.527.97.97 0 01.388-.356L3.62 1.97l.158-.09.158-.09L6.687.225l.16-.094a1 1 0 011.044.035l2.842 1.665.158.09 2.889 1.694.157.091a1 1 0 01.495.876l-.019 3.211a.385.385 0 01-.58.33l-1.226-.718a.39.39 0 01-.19-.335l.01-1.93-2.496-1.464a6 6 0 01-.205-.118L7.334 2.155 4.83 3.582l-.038.025-.178.101L2.206 5.08l-.035 5.912 2.498 1.465.21.12.05.047.043.057c.095.074.15.187.15.308m7.28-3.597a.385.385 0 01.58-.33l1.227.715c.119.07.191.198.19.336l-.006 1.173a.4.4 0 01-.112.269l-.583.588c-.22.277-.54.385-.824.22l-4.555-2.68-.03 5.002a.57.57 0 01-.213.489l-.847.676a.566.566 0 01-.95-.421l.043-6.917-.768-.45-.391.222c-.019.013-.012.009-.407.234a.57.57 0 01-.784-.204l-.215-.376-.213-.372a.57.57 0 01.205-.785l.38-.215.941-.534.17-.095a.57.57 0 01.613-.024l.213.125L12.4 9.752z"/>', width: 15 }, "left-arrow-thin": { body: '<path fill="currentColor" d="M3.692 8.007c0-.242.093-.484.268-.681L10.497.33a1.07 1.07 0 011.468-.072.996.996 0 01.074 1.426l-5.9 6.314 5.9 6.314a.99.99 0 01-.074 1.427 1.06 1.06 0 01-1.468-.072L3.96 8.67a.95.95 0 01-.268-.664"/>' }, link: { body: '<path fill="currentColor" d="M6.728 12.62q-1.11 1.11-2.674 1.11-1.565 0-2.674-1.11A3.65 3.65 0 01.27 9.947q0-1.564 1.11-2.674l1.8-1.803a.6.6 0 01.442-.188q.255 0 .442.188a.6.6 0 01.188.442q0 .255-.188.442L2.263 8.156a2.44 2.44 0 00-.742 1.79q0 1.049.742 1.79a2.44 2.44 0 001.79.743 2.44 2.44 0 001.791-.742l1.802-1.802a.6.6 0 01.442-.188q.255 0 .442.188a.6.6 0 01.188.442q0 .255-.188.442zM5.674 9.21a.6.6 0 01-.442.187.6.6 0 01-.442-.188.6.6 0 01-.188-.441q0-.255.188-.442L8.326 4.79a.6.6 0 01.442-.188q.255 0 .442.188a.6.6 0 01.188.442q0 .255-.188.442zm5.145-.68a.6.6 0 01-.442.188.6.6 0 01-.442-.188.6.6 0 01-.188-.442q0-.255.188-.442l1.802-1.802a2.44 2.44 0 00.742-1.79 2.44 2.44 0 00-.742-1.79 2.44 2.44 0 00-1.79-.743 2.44 2.44 0 00-1.791.742L6.354 4.065a.6.6 0 01-.442.188.6.6 0 01-.442-.188.6.6 0 01-.188-.442q0-.255.188-.442L7.272 1.38Q8.382.27 9.946.27t2.674 1.11 1.11 2.674-1.11 2.675z"/>', width: 14, height: 14 }, "link-horizontal": { body: '<mask id="svgID0" width="17" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h16v16H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.167 11.026q-1.255 0-2.14-.885a2.92 2.92 0 01-.886-2.14q0-1.256.885-2.141a2.92 2.92 0 012.14-.885h2.04q.211 0 .355.143a.48.48 0 01.144.357q0 .213-.144.356a.48.48 0 01-.356.144H5.167q-.84 0-1.433.593A1.95 1.95 0 003.141 8q0 .84.593 1.433t1.433.593h2.038q.213 0 .356.144a.48.48 0 01.144.356q0 .213-.144.356a.48.48 0 01-.356.144zM6.5 8.5a.48.48 0 01-.356-.144A.48.48 0 016 8q0-.213.144-.356A.48.48 0 016.5 7.5h4q.212 0 .356.144A.48.48 0 0111 8q0 .212-.144.357a.48.48 0 01-.356.143zm3.295 2.526a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.212.144-.357a.48.48 0 01.356-.143h2.038q.84 0 1.433-.593T13.86 8t-.593-1.432a1.95 1.95 0 00-1.433-.593H9.795a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.212.144-.356a.48.48 0 01.356-.143h2.038q1.256 0 2.141.884.885.885.885 2.14t-.885 2.142-2.14.885z"/></g>', width: 17 }, linux: { body: '<path fill="currentColor" d="M26.873 13.762a.59.59 0 00-.517.352q-.15.318-.283.318-.167.033-.167-.168 0-.401.634-.502zm2.903.469q-.134.033-.384-.218a.55.55 0 00-.584-.15q.801-.369 1.068.067.1.2-.1.301m-11.71 14.296q-.132-.034-.2.1-.066.134-.15.419-.082.285-.183.452a3.3 3.3 0 01-.334.435q-.232.335-.033.402.133.033.417-.235t.417-.602q.033-.1.067-.235a1 1 0 01.066-.2.7.7 0 00.067-.285v-.1l-.033-.084zm28.522 12.019q0-.603-1.835-1.406.135-.503.25-.92.118-.42.167-.871.05-.453.1-.72.051-.269.017-.753a12 12 0 01-.033-.653q0-.168-.117-.737a18 18 0 01-.133-.686 24 24 0 00-.167-.837l-.184-.887q-.333-1.607-1.567-3.449-1.235-1.84-2.402-2.51.8.669 1.901 2.778 2.902 5.424 1.802 9.307-.367 1.34-1.668 1.407-1.035.133-1.285-.62-.249-.753-.267-2.795-.016-2.043-.383-3.583-.3-1.305-.65-2.31t-.651-1.523q-.3-.52-.517-.82a3.4 3.4 0 00-.434-.503l-.25-.234q-.467-2.076-1.034-3.448t-.984-1.875a9 9 0 01-.784-1.105 3.9 3.9 0 01-.5-1.34q-.135-.702.2-1.79.333-1.088.15-1.658t-1.485-.837q-.5-.1-1.484-.602-.984-.503-1.184-.536-.267-.033-.367-.87t.266-1.708 1.201-.904q1.234-.1 1.702 1.005t.133 1.941q-.367.637-.067.888t1.001.016q.434-.133.434-1.205v-1.239q-.166-1.004-.45-1.674t-.701-1.02a3 3 0 00-.784-.503 4.7 4.7 0 00-.9-.251q-3.57.268-2.97 4.486 0 .502-.033.502-.3-.3-.984-.351t-1.1.017q-.418.066-.518-.168.033-1.908-.534-3.013t-1.5-1.138q-.902-.034-1.385.92a5.1 5.1 0 00-.55 1.993q-.034.501.116 1.238t.434 1.256q.283.519.517.452.333-.1.534-.469.133-.3-.234-.268-.234 0-.517-.485a2.44 2.44 0 01-.317-1.122q-.033-.736.3-1.239.334-.501 1.135-.468.567 0 .9.703t.317 1.305-.05.737q-.734.502-1.034.97-.267.403-.917.788-.651.385-.684.418-.435.47-.517.904-.084.435.25.603.467.267.834.653.367.384.534.636.166.25.617.435.45.184 1.184.218 1.568.066 3.403-.503.066-.033.767-.234.7-.201 1.15-.351t.985-.436q.535-.285.7-.586.3-.468.667-.267a.46.46 0 01.217.284q.05.185-.1.402t-.55.318q-.667.201-1.885.72t-1.518.653q-1.468.636-2.335.77-.834.167-2.635-.067-.334-.068-.3.067.032.133.567.636.833.77 2.235.736.567-.033 1.2-.234a10 10 0 001.202-.469q.567-.267 1.117-.586t1-.569.818-.402q.368-.15.584-.083t.283.368a.4.4 0 01-.033.15.44.44 0 01-.133.168 2 2 0 01-.2.15q-.1.068-.284.168a4 4 0 01-.3.15q-.117.051-.334.168-.216.117-.317.15-.933.47-2.252 1.474-1.317 1.005-2.218 1.44-.9.434-1.634.033-.7-.368-2.102-2.444-.734-1.038-.834-.737a1.2 1.2 0 00-.033.335q0 .837-.5 1.892a22 22 0 01-.985 1.858q-.484.804-.7 1.942a2.86 2.86 0 00.383 2.109q-.766.2-2.085 3.013-1.317 2.813-1.584 4.72-.067.605-.05 2.31.017 1.71-.184 1.976-.267.805-.967.1-1.068-1.037-1.2-3.146-.067-.937.132-1.875.134-.636-.033-.603l-.133.167q-1.2 2.177.333 5.558.167.401.834.938.668.535.8.67.668.768 3.47 3.029 2.802 2.26 3.102 2.561.534.503.584 1.272.05.771-.467 1.44-.516.67-1.518.77.267.502.968 1.49.7.987.934 1.808.233.82.233 2.36 1.534-.803.234-3.08a3 3 0 00-.35-.536q-.217-.267-.317-.401-.101-.135-.067-.201.1-.168.434-.318t.667.083q1.535 1.742 5.537 1.206 4.437-.502 5.905-2.913.767-1.272 1.134-1.005.4.202.334 1.741-.034.837-.768 3.08-.3.77-.2 1.256t.8.519q.102-.636.484-2.578.384-1.941.45-3.013.067-.704-.216-2.46-.283-1.759-.25-3.248t.767-2.36q.5-.603 1.701-.603.034-1.24 1.151-1.775t2.419-.351q1.3.184 2.001.753M25.64 12.858q.1-.57-.083-1.004-.184-.436-.384-.502-.3-.068-.3.234.066.168.167.201.333 0 .233.502-.1.67.267.67.1 0 .1-.1m13.977 6.596q-.066-.268-.217-.385a1 1 0 00-.433-.168 1.25 1.25 0 01-.484-.184 1.4 1.4 0 01-.317-.268q-.15-.167-.233-.267l-.184-.218a.7.7 0 00-.133-.134q-.033-.016-.134.05-.466.536.234 1.457.7.92 1.3 1.054.301.034.485-.268a.93.93 0 00.116-.67m-5.938-7.131q0-.369-.166-.653a1.25 1.25 0 00-.367-.419q-.201-.133-.3-.1-.468.033-.234.234l.133.067q.468.134.6 1.038 0 .1.268-.067zm1.802-7.801q0-.067-.084-.167a1.3 1.3 0 00-.3-.235q-.216-.135-.317-.2-.5-.503-.8-.503-.3.033-.384.251a.73.73 0 00-.033.435.76.76 0 01-.017.419q-.033.134-.2.351a1.7 1.7 0 00-.2.302q-.035.083.1.284.133.1.267 0 .133-.1.367-.301t.5-.301q.033-.034.3-.034t.5-.067q.234-.066.3-.234m18.847 44.896q.667.402 1.035.82.367.42.4.804a1.9 1.9 0 01-.084.753q-.116.369-.517.737a10 10 0 01-.784.653q-.383.285-1 .619a38 38 0 01-2.119 1.071q-.633.301-.9.436-1.268.636-2.852 1.874-1.585 1.239-2.519 2.143-.567.536-2.268.653-1.702.117-2.97-.486-.6-.3-.983-.786a4.3 4.3 0 01-.55-.854q-.168-.369-.735-.653-.566-.285-1.568-.318-1.468-.033-4.336-.033-.634 0-1.902.05t-1.934.083q-1.468.034-2.652.503t-1.785 1.004-1.451.954a3.7 3.7 0 01-1.785.385q-.967-.033-3.703-1.038t-4.87-1.44q-.635-.134-1.701-.317a82 82 0 01-1.668-.302q-.6-.117-1.318-.318-.717-.2-1.117-.485a1.64 1.64 0 01-.567-.653q-.334-.77.233-2.226.567-1.457.6-1.825.034-.536-.133-1.34a25 25 0 00-.334-1.422 4.2 4.2 0 01-.15-1.222q.018-.603.35-.904.468-.402 1.902-.469 1.435-.066 2.002-.401 1-.603 1.4-1.172.401-.57.401-1.708.7 2.445-1.068 3.55-1.067.668-2.768.501-1.134-.1-1.435.335-.433.502.167 1.908.067.201.267.603t.284.603a3 3 0 01.15.569q.066.367.033.736 0 .503-.567 1.64-.567 1.14-.467 1.608.1.57 1.234.87.668.2 2.819.62 2.15.419 3.32.686.8.201 2.468.737 1.668.535 2.752.77 1.084.233 1.851.134 1.435-.201 2.152-.938t.767-1.607-.25-1.958-.634-1.741a24 24 0 00-.667-1.222q-4.036-6.362-5.638-8.102-2.268-2.477-3.77-1.34-.366.302-.5-.502-.1-.535-.066-1.272a5.3 5.3 0 01.333-1.741q.3-.77.8-1.574.501-.803.735-1.406.267-.703.884-2.41a77 77 0 01.984-2.612q.366-.903 1-2.042.635-1.138 1.302-1.808 3.67-4.787 4.136-6.528-.4-3.75-.534-10.379-.066-3.014.8-5.072.87-2.06 3.537-3.499 1.3-.702 3.47-.703a12.4 12.4 0 013.535.452q1.768.486 2.97 1.39 1.9 1.406 3.051 4.067t.984 4.939q-.166 3.18 1.001 7.164 1.134 3.783 4.437 7.299 1.835 1.975 3.32 5.457 1.483 3.482 1.984 6.395.267 1.64.167 2.829-.1 1.188-.4 1.858t-.668.736q-.333.067-.784.636-.45.57-.9 1.189t-1.351 1.121-2.035.47q-.6-.035-1.051-.168-.45-.135-.75-.452a6 6 0 01-.451-.52 4.5 4.5 0 01-.384-.685 13 13 0 01-.3-.653q-.734-1.238-1.368-1.005-.633.235-.934 1.64-.3 1.407.234 3.248.668 2.344.033 6.529-.333 2.175.6 3.365.934 1.188 2.436 1.104 1.5-.083 2.835-1.188 1.969-1.64 2.986-2.227 1.018-.585 3.453-1.422 1.767-.603 2.568-1.222.801-.62.617-1.155-.183-.537-.834-.955-.65-.418-1.718-.786-1.1-.37-1.65-1.607-.552-1.239-.501-2.428.05-1.188.517-1.59.033 1.038.267 1.892.233.853.483 1.356.25.501.684.954.435.451.7.636.268.184.718.435.45.25.55.318"/>', width: 60, height: 60 }, list: { body: '<path fill="currentColor" fill-rule="evenodd" d="M8 44a2 2 0 012 2v6a2 2 0 01-2 2H2a2 2 0 01-2-2v-6a2 2 0 012-2zm50 2a2 2 0 012 2v2a2 2 0 01-2 2H18a2 2 0 01-2-2v-2a2 2 0 012-2zM8 25a2 2 0 012 2v6a2 2 0 01-2 2H2a2 2 0 01-2-2v-6a2 2 0 012-2zm50 2a2 2 0 012 2v2a2 2 0 01-2 2H18a2 2 0 01-2-2v-2a2 2 0 012-2zM8 6a2 2 0 012 2v6a2 2 0 01-2 2H2a2 2 0 01-2-2V8a2 2 0 012-2zm50 2a2 2 0 012 2v2a2 2 0 01-2 2H18a2 2 0 01-2-2v-2a2 2 0 012-2z"/>', width: 60, height: 60 }, "list-bullet": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.75 11.042q-.437 0-.74-.303A1 1 0 012.708 10q0-.437.302-.739t.74-.302.74.302.302.74-.302.738a1 1 0 01-.74.303m0-5q-.437 0-.74-.303A1 1 0 012.708 5q0-.437.302-.74.302-.3.74-.301.438 0 .74.301.302.303.302.74 0 .438-.302.74a1 1 0 01-.74.302m0 10q-.437 0-.74-.303A1 1 0 012.708 15q0-.437.302-.739.302-.303.74-.302.438 0 .74.302t.302.74-.302.738a1 1 0 01-.74.303m3.75-.417A.606.606 0 016.875 15a.61.61 0 01.625-.625h9.167q.27 0 .448.177a.6.6 0 01.177.448q0 .27-.177.448a.6.6 0 01-.448.177zm0-5A.605.605 0 016.875 10a.61.61 0 01.625-.625h9.167q.27 0 .448.177a.6.6 0 01.177.448.606.606 0 01-.625.625zm0-5A.605.605 0 016.875 5a.605.605 0 01.625-.625h9.167a.61.61 0 01.625.625.606.606 0 01-.625.625z"/></g>', width: 20, height: 20 }, "list-of-frames": { body: '<path fill="currentColor" d="M14.5 34.4C3.3 39.7.8 45.2.2 65.2L-.2 80h512.4l-.4-15.8c-.3-15.6-.3-15.9-3.3-20.8-1.9-3-4.9-6-7.9-7.9l-4.9-3-238.1-.2L19.5 32zm438.1 13c2.8 2.8 3.4 4.2 3.4 7.5 0 2.3-.7 5.5-1.5 7.1-3.3 6.4 7.5 6-158.2 6-118.6 0-151.3-.3-153.3-1.3-3.2-1.6-7-7.3-7-10.4 0-3.8 2.7-8.6 5.8-10.5 2.5-1.6 13.4-1.7 155-1.8h152.4zM37.1 51.1c4.5 4.5-.4 13-6.6 11.5-2.9-.7-5.6-5.6-4.7-8.8 1.2-4.6 7.8-6.2 11.3-2.7m20.8.5c2.7 3.5 2.6 5.9-.4 8.9s-5.4 3.1-8.9.4c-3.2-2.5-3.4-6.4-.4-9.6 2.9-3.1 7.1-3 9.7.3M78 51c2.9 2.9 2.6 7.4-.6 9.9-3.3 2.6-5.5 2.6-8.5.3-3.1-2.6-3.1-7.8 0-10.4 3-2.4 6.6-2.3 9.1.2M56 164v44h114v-88H56zm139 0v44h117v-88H195zm143 0v44h118v-88H338zM56 276v44h114v-88H56zm139-40v4h261v-8H195zm0 24v4h261v-8H195zm0 24v4h261v-8H195zm0 24v4h261v-8H195zm0 24v4h261v-8H195zM56 388v44h114v-88H56zm139-32v4h261v-8H195zm0 24v4h261v-8H195zm0 24v4h261v-8H195zm0 24v4h261v-8H195z"/>', width: 512, height: 512 }, "list-with-tick": { body: '<path fill="currentColor" d="M4.25 8.212a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.213.144-.356a.5.5 0 01.356-.143h1.943q.212 0 .356.144a.5.5 0 01.144.357q0 .212-.144.356a.5.5 0 01-.356.143zm0-3.384a.48.48 0 01-.356-.144.5.5 0 01-.144-.357q0-.213.144-.356a.5.5 0 01.356-.143h10.558q.212 0 .356.143a.5.5 0 01.144.357q0 .213-.144.356a.5.5 0 01-.356.144zm0-3.385a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.213.144-.356A.5.5 0 014.25.443h10.558q.212 0 .356.144a.5.5 0 01.144.357q0 .212-.144.356a.5.5 0 01-.356.143zm8.41 10.229a.8.8 0 01-.296-.053.8.8 0 01-.267-.183L9.631 8.97a.484.484 0 01.006-.714.5.5 0 01.357-.165.5.5 0 01.356.165l2.312 2.318 4.925-4.925a.5.5 0 01.347-.153.5.5 0 01.37.158q.156.166.159.354a.48.48 0 01-.163.354l-5.069 5.07a.8.8 0 01-.274.187.8.8 0 01-.298.053M.696 1.597A.64.64 0 01.23 1.41.62.62 0 01.039.948.645.645 0 01.688.289q.276 0 .467.187a.62.62 0 01.192.462q0 .276-.187.467a.62.62 0 01-.463.192m0 3.384a.65.65 0 01-.476-.2.65.65 0 01-.201-.477q0-.277.2-.463a.68.68 0 01.477-.187q.276 0 .463.187a.63.63 0 01.187.463.68.68 0 01-.187.476.6.6 0 01-.463.201m0 3.404a.65.65 0 01-.476-.2.65.65 0 01-.201-.478q0-.276.2-.462a.68.68 0 01.477-.187q.276 0 .463.187a.63.63 0 01.187.462.68.68 0 01-.187.477.6.6 0 01-.463.201"/>', width: 19, height: 12 }, "live-help": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 13.708a.8.8 0 00.594-.25.84.84 0 00.24-.604.84.84 0 00-.24-.604A.8.8 0 0010 12a.84.84 0 00-.854.854.84.84 0 00.854.854m.604-3.541q.041-.354.22-.625.176-.27.634-.709.688-.687.948-1.145.26-.459.26-1.042 0-1.02-.718-1.657-.72-.635-1.802-.635-.834 0-1.48.354-.645.354-.979.917a.56.56 0 00-.073.48q.074.249.303.333.207.103.426.01a.76.76 0 00.344-.281q.209-.334.574-.521a1.8 1.8 0 01.822-.188q.688 0 1.053.355.363.354.364.875 0 .395-.24.791t-.677.792q-.562.5-.843.979-.282.48-.282.917 0 .228.167.385a.56.56 0 00.396.156.52.52 0 00.385-.156.7.7 0 00.198-.385m-1.125 7.875L7.667 16.25h-3.25q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063V3.583q0-.624.437-1.062a1.45 1.45 0 011.063-.438h11.166q.625 0 1.063.438t.437 1.062V14.75q0 .624-.437 1.063a1.45 1.45 0 01-1.063.437h-3.25l-1.812 1.792a.7.7 0 01-.521.208.7.7 0 01-.521-.208M4.417 15h3.77L10 16.813 11.812 15h3.771q.105 0 .178-.072a.24.24 0 00.072-.178V3.583a.24.24 0 00-.072-.177.24.24 0 00-.178-.073H4.417a.24.24 0 00-.177.073.24.24 0 00-.074.177V14.75q0 .105.074.178a.24.24 0 00.176.072"/></g>', width: 20, height: 20 }, "live-tv": { body: '<mask id="svgID0" width="17" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h16v16H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m7.93 9.423 2.479-1.58a.6.6 0 00.268-.51.6.6 0 00-.268-.509l-2.478-1.58a.57.57 0 00-.616-.03.56.56 0 00-.315.528v3.183q0 .36.315.528t.616-.03m-1.16 4.244a.58.58 0 01-.43-.173.58.58 0 01-.173-.43v-.73H3.372q-.5 0-.852-.354a1.16 1.16 0 01-.353-.852v-7.59q0-.498.353-.851.353-.354.852-.353h10.256q.5 0 .852.353.354.353.353.852v7.59q0 .498-.353.851-.353.354-.852.354h-2.795v.73a.58.58 0 01-.172.43.58.58 0 01-.43.173zm-3.398-2.333h10.256a.2.2 0 00.148-.058.2.2 0 00.057-.148v-7.59a.2.2 0 00-.057-.147.2.2 0 00-.148-.058H3.372a.2.2 0 00-.148.058.2.2 0 00-.057.148v7.59a.2.2 0 00.057.147.2.2 0 00.148.058"/></g>', width: 17 }, loader: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.729 8c.334 0 .608.271.57.603A5.334 5.334 0 117.397 2.7c.332-.038.603.236.603.57s-.272.6-.602.648a4.125 4.125 0 104.682 4.683c.05-.33.315-.602.649-.602"/></g>' }, "loader-large": { body: '<path fill="currentColor" d="M50.5 22.44c0-.795.645-1.445 1.44-1.397A24 24 0 1135.542 63.77c-.622-.496-.667-1.41-.135-2.001.532-.592 1.44-.635 2.066-.145A21.12 21.12 0 1051.939 23.93c-.794-.054-1.439-.694-1.439-1.489"/>', width: 101, height: 90 }, "local-device": { body: '<path fill="currentColor" d="M12 14.24a.74.74 0 01-.534-.209.7.7 0 01-.22-.523V6.932q0-.315.22-.535A.73.73 0 0112 6.178h3.246a.73.73 0 01.534.22.73.73 0 01.22.534v6.576q0 .315-.22.523a.75.75 0 01-.534.21zm0-1.57h3.246v-4.9H12zm-6.68 1.57a.6.6 0 01-.451-.177.6.6 0 01-.178-.45q0-.273.178-.451a.6.6 0 01.45-.178h1.173V10.89H1.53q-.65 0-1.09-.44A1.45 1.45 0 010 9.382V1.508Q0 .879.44.44T1.529 0h11.204q.628 0 1.068.44t.44 1.068v2.366a.61.61 0 01-.628.629.62.62 0 01-.44-.179.6.6 0 01-.189-.45V1.508q0-.106-.062-.178-.063-.073-.189-.073H1.529a.27.27 0 00-.2.073.24.24 0 00-.072.178v7.874q0 .106.072.178a.27.27 0 00.2.074h7.413q.273 0 .451.177.178.18.178.45 0 .273-.178.452a.6.6 0 01-.45.177H7.748v2.094h1.193q.273 0 .451.178.178.18.178.45 0 .273-.178.451a.6.6 0 01-.45.178z"/>', height: 15 }, lock: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.256 17.917q-.623 0-1.064-.442a1.45 1.45 0 01-.442-1.065V8.59q0-.623.442-1.065.441-.441 1.064-.442h.994V5.417q0-1.56 1.095-2.656Q8.439 1.667 10 1.667t2.655 1.094q1.095 1.095 1.095 2.656v1.666h.993q.624 0 1.065.442.442.442.442 1.065v7.82q0 .623-.442 1.065-.441.441-1.065.442zm0-1.25h9.487a.25.25 0 00.185-.072.25.25 0 00.072-.185V8.59a.25.25 0 00-.072-.185.25.25 0 00-.185-.072H5.256a.25.25 0 00-.184.072A.25.25 0 005 8.59v7.82a.25.25 0 00.072.185.25.25 0 00.184.072M10 13.958q.608 0 1.033-.425.426-.426.425-1.033 0-.608-.425-1.033A1.4 1.4 0 0010 11.042q-.608 0-1.033.425a1.4 1.4 0 00-.425 1.033q0 .608.425 1.033.426.425 1.033.425M7.5 7.083h5V5.417q0-1.042-.73-1.771a2.4 2.4 0 00-1.77-.73 2.4 2.4 0 00-1.77.73 2.4 2.4 0 00-.73 1.77z"/></g>', width: 20, height: 20 }, "lock-open": { body: '<path fill="currentColor" d="M2.256 16.917q-.63 0-1.068-.438A1.45 1.45 0 01.75 15.41V7.59q0-.631.438-1.07a1.45 1.45 0 011.068-.437H9.5V4.417a2.4 2.4 0 00-.73-1.771A2.4 2.4 0 007 1.916q-.895 0-1.57.56-.676.558-.858 1.393a.86.86 0 01-.239.394.56.56 0 01-.394.154.62.62 0 01-.49-.21.5.5 0 01-.127-.467 3.64 3.64 0 011.261-2.194Q5.613.666 7 .666q1.56 0 2.655 1.095t1.095 2.656v1.666h.993q.633 0 1.07.438t.437 1.069v7.82q0 .631-.437 1.07a1.46 1.46 0 01-1.07.437zm0-1.25h9.487a.25.25 0 00.185-.072.25.25 0 00.072-.185V7.59a.25.25 0 00-.072-.185.25.25 0 00-.185-.072H2.256a.25.25 0 00-.184.072A.25.25 0 002 7.59v7.82a.25.25 0 00.072.185.25.25 0 00.184.072M7 12.958q.608 0 1.033-.425.425-.426.425-1.033 0-.608-.425-1.033A1.4 1.4 0 007 10.042q-.608 0-1.033.425a1.4 1.4 0 00-.425 1.033q0 .608.425 1.033.426.425 1.033.425"/>', width: 14, height: 17 }, "logo-icon-dark": { body: '<g fill="currentColor"><path d="M27.425 10.514a1.5 1.5 0 00-1.1-.686c-.218-.027-.445-.064-.66-.098-.275-.042-.558-.086-.837-.117-.743-.075-1.198-.384-1.473-.99-.19-.415-.212-.785-.069-1.15l.106-.275c.184-.478.376-.976.58-1.459a1.56 1.56 0 00-.045-1.371 3.3 3.3 0 00-1.932-1.677 1.56 1.56 0 00-1.418.184 23 23 0 01-.644.396c-.298.181-.607.37-.897.573-.203.143-.46.218-.739.218-.697 0-1.372-.46-1.538-1.043a16 16 0 00-.294-.92c-.09-.252-.177-.516-.257-.772-.162-.546-.52-.924-1.066-1.123a5 5 0 00-.479-.14l-.2-.056L14.43 0h-.901l-.034.012q-.027.007-.052.018l-.072.02c-.92.165-1.47.633-1.674 1.439-.09.354-.218.712-.338 1.055q-.099.278-.189.554c-.181.55-.833.984-1.486.984-.259 0-.505-.071-.704-.211a23 23 0 00-1.115-.705q-.266-.162-.528-.324a1.38 1.38 0 00-1.092-.184c-1.013.247-1.755.865-2.211 1.834-.18.388-.189.814-.015 1.236q.117.288.23.58c.113.298.23.603.361.9.271.611.242 1.15-.102 1.69-.233.369-.538.587-.934.663-.57.11-1.18.203-1.817.279-.539.06-.957.328-1.247.795-.392.633-.558 1.353-.498 2.133.057.731.407 1.255 1.04 1.556.23.11.456.242.68.366.244.14.493.283.757.407.377.173.66.573.75 1.059.094.505-.034 1.018-.34 1.33-.426.444-.844.923-1.24 1.42-.18.223-.31.502-.359.77-.183 1.05.698 2.607 1.686 2.976.245.09.554.117.837.075a20 20 0 001.68-.339c.616-.15 1.09-.023 1.546.426.342.34.497.705.486 1.16-.015.585-.03 1.21-.056 1.844-.023.478.143.893.486 1.228.547.535 1.233.852 2.046.939q.135.017.264.015c.618 0 1.12-.264 1.478-.784.143-.2.298-.388.463-.588.17-.207.343-.418.502-.644.26-.385.738-.614 1.273-.614.525 0 1 .226 1.267.6.219.308.46.606.69.893q.216.26.422.53a1.44 1.44 0 001.025.58c.98.091 1.858-.21 2.604-.892.358-.328.528-.75.501-1.258-.014-.223-.018-.457-.022-.679a17 17 0 00-.038-.893c-.052-.701.167-1.206.683-1.587.342-.249.677-.34 1.043-.28.66.11 1.248.23 1.802.37.572.14 1.1.008 1.56-.4a3.44 3.44 0 001.115-1.91c.136-.637-.015-1.187-.448-1.636-.17-.177-.336-.369-.494-.553-.159-.188-.324-.38-.499-.562-.474-.49-.606-.995-.428-1.635.12-.449.342-.75.69-.946a46 46 0 011.627-.889c.422-.222.693-.565.802-1.02a3.27 3.27 0 00-.468-2.689"/><path d="m13.94 10.666-.004.056-.034.756.656-.34-.005.058 3.208-1.588a.6.6 0 01.479-.023.64.64 0 01.357.33l.433.943a.655.655 0 01-.294.86l-4.953 2.448-.105 2.34-.011.439v.155c0 .356 0 .42.058.719.032.158.076.192.26.287.202.103.452.167.64.167h.065c.133 0 .256 0 .398-.03.404-.08.653-.174 1.098-.409a.24.24 0 01.263.026c.076.06.112.163.09.261-.039.173-.08.528-.122.879l-.004.038c-.033.3-.073.61-.11.86a.26.26 0 01-.187.212q-.69.166-1.102.212a8 8 0 01-.777.042c-.618 0-1.127-.083-1.514-.254a1.95 1.95 0 01-.947-.851c-.214-.382-.322-.897-.322-1.526q0-.126.012-.417c.006-.196.039-.858.1-2.029l.002-.025-1.182.584a.6.6 0 01-.27.063.63.63 0 01-.562-.37l-1.22-2.665a.656.656 0 01.296-.86l.911-.448a.6.6 0 01.48-.024c.155.06.284.177.353.33l.52 1.136.811-.402.103-1.963v-.008l.098-1.246c.013-.17.02-.241.027-.32.012-.123.025-.263.07-.834.01-.118.086-.22.202-.243.61-.12 1.135-.238 1.557-.348a.23.23 0 01.214.05.27.27 0 01.09.212c-.021.483-.039.728-.051.91a7 7 0 00-.025.6l-.004.058c-.005.065-.012.16-.007.192z"/></g>', width: 28, height: 28 }, "logo-testsigma-dark": { body: '<g fill="currentColor"><path fill-rule="evenodd" d="m88.742 9.594.316-1.742v-.06q0-.336-.336-.336h-1.92a.45.45 0 00-.297.119.53.53 0 00-.178.277l-.317 1.742v.06q0 .157.1.247a.37.37 0 00.256.089h1.92q.158 0 .287-.12a.56.56 0 00.169-.276m-41.989 2.275-.198 1.168a.53.53 0 01-.178.277.45.45 0 01-.297.119H44.3l-1.089 6.215q-.099.494-.099.692 0 .277.149.347t.524.069h1.05q.138 0 .247.04.108.039.108.198v.059l-.217 1.247q-.06.296-.436.356t-.702.099q-.327.04-.663.04-1.307 0-2-.495-.692-.494-.692-1.683 0-.218.03-.455t.069-.514l1.088-6.215-1.82-.277q-.317-.04-.317-.337v-.06l.158-.89a.56.56 0 01.169-.277.4.4 0 01.286-.119h1.861L42.3 9.85a.46.46 0 01.168-.257.8.8 0 01.287-.138l1.9-.317h.08q.276 0 .276.237v.06l-.376 2.038h1.782q.336 0 .336.337zm9.89 3.525q0 .277-.029.564t-.07.564l-.157.95q-.1.495-.476.495H49.46q-.04.217-.07.406-.029.188-.029.405 0 .811.456 1.297.454.485 1.563.485 1.089 0 2.059-.08.969-.079 1.603-.138h.079q.118 0 .208.04.089.039.089.177v.08l-.238 1.306a.8.8 0 01-.128.356q-.09.12-.367.159l-.93.148q-.435.069-.89.109a20 20 0 01-.97.06q-.515.019-1.188.02a5 5 0 01-1.346-.199 3.4 3.4 0 01-1.257-.663q-.564-.465-.93-1.227t-.366-1.89q0-.277.02-.574a5 5 0 01.079-.614l.218-1.227q.237-1.385.732-2.355t1.207-1.574a4.4 4.4 0 011.643-.87 7.4 7.4 0 012.058-.268q.99 0 1.722.307.733.307 1.208.851.474.544.712 1.287.238.741.238 1.613m-3.009-1.358q.435.446.436 1.316 0 .198-.02.377a4 4 0 01-.06.376h-4.196q.199-1.09.792-1.802.594-.712 1.782-.712.831 0 1.266.445m12.721-1.829-.198 1.128q-.06.376-.376.376h-.079a7 7 0 00-.554-.079q-.356-.04-.782-.07-.426-.029-.9-.058t-.891-.03q-.237 0-.505.03a2 2 0 00-.495.118.9.9 0 00-.376.268q-.148.177-.148.494 0 .396.594.812l2.315 1.583q.891.614 1.178 1.227.287.615.287 1.267 0 .93-.356 1.593a3.25 3.25 0 01-.95 1.099q-.594.435-1.386.633a7 7 0 01-1.682.198q-.238 0-.663-.01a12 12 0 01-.91-.06q-.486-.048-1.01-.128a10 10 0 01-.98-.198q-.297-.099-.297-.356v-.099l.218-1.187a.4.4 0 01.149-.238.44.44 0 01.267-.08h.06q.355.04.81.08a45 45 0 001.742.119q.396.02.614.02.732 0 1.217-.208.485-.21.485-.9a.84.84 0 00-.148-.466q-.15-.227-.505-.485l-2.415-1.663a3.1 3.1 0 01-.93-1.019 2.65 2.65 0 01-.356-1.336q0-.99.386-1.613.386-.622.99-.99a4 4 0 011.345-.504q.742-.139 1.455-.139.891 0 1.781.1.891.097 1.722.316.277.08.277.356zm8.228.83.198-1.168v-.06q0-.335-.336-.336h-1.781l.376-2.038v-.06q0-.237-.278-.237h-.079l-1.9.317a.8.8 0 00-.287.138.46.46 0 00-.168.257l-.297 1.623h-1.86a.4.4 0 00-.287.12.56.56 0 00-.169.276l-.158.89v.06q0 .297.317.337l1.82.277-1.088 6.215q-.04.277-.07.514-.029.238-.029.455 0 1.188.693 1.683t1.999.495q.336 0 .663-.04t.703-.099T73 22.3l.218-1.247v-.06q0-.158-.11-.197a.7.7 0 00-.247-.04h-1.049q-.375 0-.524-.07-.149-.068-.148-.346 0-.198.098-.692l1.089-6.215h1.781q.159 0 .297-.119a.53.53 0 00.178-.277m8.78-.83-.198 1.128q-.06.376-.376.376h-.08a7 7 0 00-.553-.079 19 19 0 00-.782-.07q-.426-.029-.9-.058-.476-.03-.891-.03-.238 0-.505.03a2 2 0 00-.495.118.9.9 0 00-.376.268q-.148.177-.148.494 0 .396.594.812l2.315 1.583q.89.614 1.178 1.227.287.615.287 1.267 0 .93-.356 1.593a3.25 3.25 0 01-.95 1.099q-.594.435-1.386.633a7 7 0 01-1.682.198q-.239 0-.663-.01a12 12 0 01-.91-.06q-.485-.048-1.01-.128a10 10 0 01-.98-.198q-.297-.099-.297-.356v-.099l.218-1.187a.4.4 0 01.148-.238.44.44 0 01.268-.08h.059q.356.04.811.08a45 45 0 001.742.119q.396.02.614.02.732 0 1.217-.208.485-.21.485-.9a.84.84 0 00-.149-.466q-.148-.227-.504-.485l-2.415-1.663a3.1 3.1 0 01-.93-1.019 2.65 2.65 0 01-.356-1.336q0-.99.386-1.613.385-.622.99-.99a4 4 0 011.345-.504q.743-.139 1.455-.139.89 0 1.781.1.891.097 1.722.316.277.08.277.356zm4.924-.337-1.82 10.351a.6.6 0 01-.179.287.43.43 0 01-.296.129H84.17q-.159 0-.238-.1a.37.37 0 01-.08-.237v-.079l1.822-10.351a.56.56 0 01.168-.277.4.4 0 01.287-.12h1.82q.337 0 .337.337zm11.048.446a.2.2 0 00.01-.07q0-.177-.119-.257a1.2 1.2 0 00-.336-.138 15 15 0 00-1.86-.366 15 15 0 00-2.02-.149q-1.186 0-2.127.258a4.3 4.3 0 00-1.643.84q-.702.585-1.158 1.535-.454.95-.693 2.335l-.257 1.524q-.06.337-.08.634-.019.297-.019.573 0 1.01.317 1.713.316.702.87 1.157.555.456 1.307.663a6 6 0 001.603.208q.435 0 .89-.05a9 9 0 00.911-.148l-.02.159q-.118.99-.583 1.375-.466.386-1.594.386-.336 0-.821-.03t-1-.059-.99-.07a25 25 0 01-.81-.078h-.04q-.376 0-.436.336l-.198 1.05a.2.2 0 01-.01.069.2.2 0 00-.01.049q0 .158.09.227a1 1 0 00.247.13q.356.117 1.267.296.91.178 2.355.178 1.287 0 2.187-.218t1.494-.692q.594-.476.93-1.237t.535-1.85l1.801-10.214a.2.2 0 01.01-.069m-2.84 1.335a9 9 0 00-.802-.119q-.525-.06-1.06-.059-1.226 0-1.81.703-.584.702-.822 2.127l-.257 1.524q-.06.357-.099.663-.04.308-.04.584 0 .792.376 1.188t1.386.396q.356 0 .92-.05t1-.109zm18.739 1.842q.118-.693.118-1.267 0-1.345-.653-2.118-.653-.771-2.078-.772-1.03 0-1.88.238a5.7 5.7 0 00-1.603.732q-.258-.396-.762-.683-.505-.287-1.356-.287-.89 0-1.564.277a12 12 0 00-1.365.673l.079-.415v-.06q0-.336-.337-.336h-1.722a.42.42 0 00-.287.119.56.56 0 00-.168.277l-1.82 10.351v.08q0 .137.078.237.08.099.238.099h1.821a.43.43 0 00.297-.129.6.6 0 00.178-.287l1.405-7.996q1.346-.653 1.94-.653.613 0 .871.198.257.198.257.752 0 .198-.02.435-.02.238-.079.535l-1.188 6.73v.078q0 .14.08.238.078.099.237.099h1.821a.43.43 0 00.297-.129.6.6 0 00.178-.287l1.187-6.73q.06-.375.07-.732.01-.356.029-.692a5 5 0 011.158-.386q.565-.11.841-.11.634 0 .911.219.277.218.277.791 0 .178-.03.406t-.069.505l-1.187 6.73v.078q0 .14.079.238.079.099.237.099h1.821a.43.43 0 00.297-.129.6.6 0 00.178-.287zm11.489-3.108-1.722 9.857a.53.53 0 01-.178.277.45.45 0 01-.297.119h-1.583q-.317 0-.317-.337v-.06l.079-.573q-.831.634-1.583.88a4.7 4.7 0 01-1.485.248q-.672 0-1.266-.227a2.9 2.9 0 01-1.039-.683 3.15 3.15 0 01-.693-1.119q-.248-.663-.248-1.553 0-.278.02-.584.02-.307.079-.604.04-.297.099-.594.04-.257.099-.554t.099-.574q.416-2.335 1.821-3.651 1.406-1.317 3.8-1.317.95 0 1.97.139 1.019.139 1.91.376.217.06.336.128.119.07.119.248a.5.5 0 01-.02.158m-3.63 1.128q.525.04.802.098l-1.089 6.215a7.5 7.5 0 01-1.286.614 3.5 3.5 0 01-1.188.218q-.574 0-.97-.327t-.396-1.178q0-.177.02-.386a5 5 0 01.06-.425l.356-2.039a6 6 0 01.287-1.128q.188-.515.495-.89.306-.377.762-.594.455-.218 1.088-.218.534 0 1.059.04" clip-rule="evenodd"/><path d="M31.343 12.016a1.72 1.72 0 00-1.258-.784c-.249-.03-.508-.073-.754-.112-.314-.048-.637-.099-.956-.133-.849-.086-1.37-.44-1.684-1.133-.216-.474-.241-.896-.078-1.313l.121-.315c.21-.546.43-1.116.663-1.667a1.79 1.79 0 00-.051-1.567 3.78 3.78 0 00-2.21-1.917 1.78 1.78 0 00-1.62.21c-.24.156-.49.307-.735.453-.341.207-.694.422-1.026.655a1.46 1.46 0 01-.844.25c-.797 0-1.569-.526-1.758-1.193-.098-.358-.219-.71-.336-1.05-.103-.29-.202-.59-.293-.884C18.339.892 17.93.461 17.305.233a5 5 0 00-.547-.16c-.073-.02-.155-.042-.228-.064L16.49 0h-1.03l-.039.013q-.029.009-.06.021l-.08.022c-1.052.19-1.68.724-1.914 1.645-.103.406-.249.814-.387 1.206q-.111.318-.215.634c-.207.629-.952 1.124-1.698 1.124-.296 0-.577-.081-.805-.241a27 27 0 00-1.275-.806q-.304-.184-.603-.37a1.57 1.57 0 00-1.248-.21c-1.158.282-2.005.989-2.527 2.096-.206.444-.215.93-.017 1.412q.134.33.263.663c.13.34.262.69.413 1.03.31.698.276 1.314-.117 1.93-.266.422-.615.671-1.068.757-.65.126-1.348.233-2.076.32-.616.069-1.094.374-1.425.908-.448.724-.638 1.546-.57 2.438.066.836.466 1.434 1.19 1.779.263.125.52.276.776.418.279.159.564.323.865.465.432.197.754.654.857 1.21.108.577-.038 1.163-.388 1.52a24 24 0 00-1.417 1.624 2 2 0 00-.41.878c-.21 1.202.798 2.98 1.927 3.402.28.104.633.134.956.086a23 23 0 001.921-.387c.703-.173 1.245-.027 1.766.486.391.388.569.806.555 1.326a120 120 0 01-.064 2.107 1.78 1.78 0 00.556 1.404c.625.612 1.409.974 2.338 1.073q.155.018.302.017c.707 0 1.28-.302 1.69-.896.162-.23.34-.444.529-.672.194-.237.392-.478.573-.736.296-.44.844-.702 1.455-.702.6 0 1.142.259 1.448.685.25.353.525.693.789 1.021.163.198.327.4.482.607.301.392.71.62 1.172.663 1.12.104 2.123-.241 2.975-1.02.409-.375.603-.858.573-1.439-.017-.254-.021-.52-.026-.775-.008-.336-.017-.68-.043-1.02-.06-.802.19-1.38.78-1.814.391-.285.775-.388 1.193-.32.753.125 1.426.263 2.059.423.654.16 1.258.009 1.782-.457a3.93 3.93 0 001.276-2.183c.155-.728-.018-1.357-.513-1.87a15 15 0 01-.565-.632c-.181-.215-.37-.436-.57-.642-.541-.56-.692-1.137-.49-1.869.139-.513.392-.857.789-1.081.65-.37 1.257-.703 1.86-1.016a1.73 1.73 0 00.917-1.167c.27-1.095.09-2.128-.535-3.072"/><path d="m15.931 12.19-.004.064-.039.864.744-.322 3.666-1.815a.68.68 0 01.547-.027.73.73 0 01.408.377l.496 1.078a.75.75 0 01-.336.982l-5.661 2.799-.12 2.673-.013.503v.177c0 .406 0 .48.066.821.038.181.087.22.298.329.23.117.516.19.731.19h.074c.153 0 .293 0 .455-.034.462-.09.747-.199 1.255-.467a.27.27 0 01.301.03.3.3 0 01.103.298c-.044.197-.092.603-.14 1.004l-.004.044c-.038.341-.084.696-.125.982a.3.3 0 01-.215.243q-.788.188-1.26.242c-.31.03-.61.048-.887.048-.707 0-1.289-.094-1.73-.29a2.22 2.22 0 01-1.082-.973c-.245-.437-.368-1.025-.368-1.743q0-.144.013-.477c.007-.224.044-.981.115-2.319l.001-.03-1.35.669a.66.66 0 01-.31.072.72.72 0 01-.643-.422l-1.393-3.047a.75.75 0 01.338-.983l1.042-.512a.68.68 0 01.548-.027.73.73 0 01.404.377l.594 1.298.928-.46.117-2.242v-.01l.112-1.423c.015-.196.023-.277.031-.366.014-.14.029-.302.08-.954a.3.3 0 01.23-.277 33 33 0 001.78-.398.26.26 0 01.244.056.31.31 0 01.103.243c-.024.553-.044.832-.058 1.04a9 9 0 00-.029.687l-.004.066c-.005.073-.014.183-.008.22z"/></g>', width: 127, height: 32 }, logout: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M13.02 13.314a.68.68 0 01-.182-.458.6.6 0 01.181-.433l1.59-1.59H8.221a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.265.18-.445t.445-.18h6.388l-1.598-1.597a.6.6 0 01-.186-.438q0-.252.194-.445a.57.57 0 01.433-.194.6.6 0 01.433.18l2.59 2.592a.7.7 0 01.214.527q0 .15-.048.28a.7.7 0 01-.165.248l-2.6 2.599a.54.54 0 01-.437.18.66.66 0 01-.42-.2M4.502 17.5q-.63 0-1.069-.437a1.45 1.45 0 01-.437-1.07V4.424q0-.63.437-1.069a1.45 1.45 0 011.07-.437H9.47q.267 0 .446.18.18.178.18.445 0 .266-.18.445a.6.6 0 01-.446.18H4.503a.25.25 0 00-.176.08.25.25 0 00-.08.176v11.57q0 .097.08.177t.176.08h4.968q.267 0 .446.18.18.18.18.445 0 .266-.18.446a.6.6 0 01-.446.18z"/></g>', width: 20, height: 20 }, logs: { body: '<path fill="currentColor" d="M13.301 16.25a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18h1.442a.25.25 0 00.185-.072.25.25 0 00.072-.185V5.256a.25.25 0 00-.072-.184.25.25 0 00-.185-.072h-1.442a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18h1.442q.623 0 1.064.442.443.443.443 1.064v9.488q0 .62-.443 1.063a1.45 1.45 0 01-1.064.443zm-8.045 0a1.45 1.45 0 01-1.064-.443 1.45 1.45 0 01-.442-1.064V5.256q0-.621.442-1.064a1.45 1.45 0 011.064-.442H6.7q.265 0 .445.18t.18.445-.18.445A.6.6 0 016.7 5H5.256a.25.25 0 00-.184.072.25.25 0 00-.072.184v9.488a.25.25 0 00.072.184.25.25 0 00.184.072H6.7q.265 0 .445.18t.18.445-.18.445a.6.6 0 01-.445.18z"/>', width: 20, height: 20 }, "mail-box": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4B5768" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.867 13q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V4.2q0-.5.35-.85t.85-.35h10.267q.5 0 .85.35t.35.85v7.6q0 .5-.35.85t-.85.35zm10.467-8.033-5.017 3.2a.5.5 0 01-.15.074.57.57 0 01-.333 0 .5.5 0 01-.15-.074l-5.017-3.2V11.8q0 .084.059.142a.2.2 0 00.141.058h10.267q.084 0 .142-.058a.2.2 0 00.058-.142zM8 7.333 13.234 4H2.767zM2.667 4.967V12z"/></g>' }, "major-priority": { body: '<g fill="currentColor"><path d="m7.984 3.2-4.5 2.7c-.5.3-1.1.1-1.3-.4s-.2-1.1.3-1.3l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4s-.9.6-1.4.3z"/><path d="M3.484 10.2c-.5.3-1.1.1-1.3-.3s-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4s-.9.6-1.4.3l-4.4-2.7z"/><path d="M3.484 14.5c-.5.3-1.1.2-1.3-.3s-.2-1.1.3-1.4l5-3c.3-.2.7-.2 1 0l5 3c.5.3.6.9.3 1.4s-.9.6-1.4.3l-4.4-2.7z"/></g>' }, manufacturing: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.93 6.833a2.6 2.6 0 01-.483-.197 2 2 0 01-.429-.305l-.4.143a.5.5 0 01-.326-.003.48.48 0 01-.251-.203l-.095-.156a.5.5 0 01-.067-.331.45.45 0 01.169-.294l.321-.272a2.1 2.1 0 010-1.097l-.321-.272a.44.44 0 01-.17-.288.5.5 0 01.068-.326l.105-.167a.48.48 0 01.567-.206l.4.144q.203-.185.429-.306.226-.12.484-.197l.068-.393a.5.5 0 01.17-.289.46.46 0 01.31-.113h.176q.175 0 .31.118a.53.53 0 01.17.294l.068.383q.257.077.484.197.225.12.428.306l.4-.144a.5.5 0 01.326.004q.16.057.251.202l.095.157q.09.155.068.33a.45.45 0 01-.17.294l-.321.272a2.1 2.1 0 010 1.097l.322.272a.44.44 0 01.169.289.5.5 0 01-.068.325l-.105.167a.48.48 0 01-.567.206l-.4-.143a2 2 0 01-.428.305q-.227.12-.484.197l-.068.394a.5.5 0 01-.17.288.46.46 0 01-.31.113h-.177a.45.45 0 01-.309-.118.53.53 0 01-.17-.293zm.637-.782q.575 0 .98-.404.405-.405.404-.98 0-.575-.404-.98a1.34 1.34 0 00-.98-.405q-.576 0-.98.405-.405.405-.405.98t.405.98q.404.404.98.404m5.359 7.568a2.2 2.2 0 01-.682-.258 2.4 2.4 0 01-.568-.456l-.493.168a.65.65 0 01-.43.001.6.6 0 01-.335-.28l-.126-.213a.66.66 0 01-.087-.442.6.6 0 01.22-.388l.397-.33a2.63 2.63 0 010-1.508l-.398-.341a.6.6 0 01-.22-.383.65.65 0 01.088-.436l.126-.214a.6.6 0 01.335-.28.65.65 0 01.43.001l.493.168a2.4 2.4 0 01.568-.456q.315-.183.682-.258l.105-.536a.64.64 0 01.633-.518h.272q.237 0 .412.146.174.146.221.372l.105.536q.367.075.682.258t.568.456l.493-.168a.65.65 0 01.43-.001.6.6 0 01.335.28l.126.214a.66.66 0 01.088.441.6.6 0 01-.22.388l-.398.33a2.63 2.63 0 010 1.508l.398.341q.186.153.22.383a.65.65 0 01-.088.437l-.126.214a.6.6 0 01-.335.28.65.65 0 01-.43-.002l-.493-.168a2.4 2.4 0 01-.568.457q-.315.183-.682.257l-.105.536a.64.64 0 01-.633.518h-.272a.64.64 0 01-.633-.518zm.874-.952q.834 0 1.417-.584.583-.583.583-1.416 0-.834-.583-1.417a1.93 1.93 0 00-1.417-.583q-.834 0-1.417.583a1.93 1.93 0 00-.583 1.417q0 .832.583 1.416.585.585 1.417.584"/></g>' }, "manufacturing-sharp": { body: '<mask id="svgID0" width="36" height="36" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4B5768" d="M0 0h36v36H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m8.775 18-.45-2.25a11 11 0 01-.844-.393 6.5 6.5 0 01-.806-.506l-2.175.675-1.5-2.55 1.725-1.5a6.4 6.4 0 010-1.95L3 8.026l1.5-2.55 2.175.675q.413-.3.806-.507.394-.205.844-.393L8.775 3h3l.45 2.25q.45.188.844.393.393.207.806.507l2.175-.675 1.5 2.55-1.725 1.5a6.4 6.4 0 010 1.95l1.725 1.5-1.5 2.55-2.175-.675q-.413.3-.806.506a11 11 0 01-.844.394l-.45 2.25zm1.5-4.5q1.237 0 2.119-.88a2.9 2.9 0 00.881-2.12q0-1.236-.881-2.118a2.9 2.9 0 00-2.119-.881q-1.237 0-2.119.88a2.9 2.9 0 00-.881 2.12q0 1.237.881 2.118a2.9 2.9 0 002.119.882m11.925 21-.675-3.15a7 7 0 01-1.181-.543 9.5 9.5 0 01-1.069-.731l-3 .975-2.1-3.6 2.4-2.1a12.2 12.2 0 010-2.7l-2.4-2.1 2.1-3.6 3 .975q.525-.413 1.069-.732a7 7 0 011.181-.543l.675-3.15h4.2l.675 3.15q.638.224 1.181.543a9.5 9.5 0 011.069.732l3-.975 2.1 3.6-2.4 2.1a12.2 12.2 0 010 2.7l2.4 2.1-2.1 3.6-3-.975q-.525.412-1.069.73a7 7 0 01-1.181.545L26.4 34.5zm2.1-6q1.875 0 3.188-1.312 1.312-1.312 1.312-3.187t-1.312-3.188-3.188-1.312-3.187 1.312-1.313 3.188 1.313 3.187 3.187 1.313"/></g>', width: 36, height: 36 }, "map-link": { body: '<path fill="currentColor" d="M5.867 14.066q-1.134 0-1.917-.791a2.62 2.62 0 01-.783-1.909V5.65a2.24 2.24 0 01-.959-.717 1.75 1.75 0 01-.375-1.1q0-.8.567-1.35t1.35-.55 1.342.558q.558.56.558 1.342 0 .617-.375 1.1-.376.483-.958.717v5.716q0 .65.45 1.109t1.116.458 1.109-.458a1.54 1.54 0 00.441-1.109V4.633q0-1.132.784-1.917.782-.783 1.916-.783t1.917.783q.783.785.783 1.917v5.717q.585.233.959.716.375.485.375 1.1 0 .784-.559 1.342a1.83 1.83 0 01-1.341.558q-.784 0-1.35-.558a1.82 1.82 0 01-.567-1.342q0-.616.375-1.108t.958-.708V4.633q0-.667-.45-1.117t-1.1-.45q-.666 0-1.116.45t-.45 1.117v6.733q0 1.117-.784 1.909-.783.791-1.916.791M3.75 4.65q.333 0 .567-.242a.8.8 0 00.233-.575.8.8 0 00-.233-.583.77.77 0 00-.567-.234.8.8 0 00-.575.234.78.78 0 00-.242.583q0 .333.242.575a.8.8 0 00.575.242m8.517 8.333q.332 0 .566-.242a.8.8 0 00.234-.575.8.8 0 00-.234-.583.77.77 0 00-.566-.233.8.8 0 00-.575.233.78.78 0 00-.242.583q0 .334.242.575a.8.8 0 00.575.242"/>' }, "material-symbols": { body: '<path fill="currentColor" d="M5 18.333V17.18q.476 0 .815.338.34.338.34.815zm3.142 0q0-1.311-.916-2.226T5 15.192v-.834q1.656 0 2.815 1.159 1.16 1.157 1.16 2.816zm2.82 0q0-2.487-1.738-4.225Q7.487 12.372 5 12.372v-.833q1.41 0 2.65.535 1.24.534 2.157 1.453a6.9 6.9 0 011.453 2.157q.535 1.24.535 2.65zm-.929-13.076a.62.62 0 00.456-.185.62.62 0 00.183-.458.627.627 0 00-.642-.64.62.62 0 00-.456.185.62.62 0 00-.183.458q0 .273.185.455a.63.63 0 00.457.184m4.198 13.076a13.4 13.4 0 00-1.08-3.377 10.4 10.4 0 00-1.924-2.8 8.8 8.8 0 00-2.72-1.904Q6.95 9.552 5 9.551V3.013q0-.576.386-.96.386-.386.96-.386h7.372q.576 0 .961.385a1.3 1.3 0 01.385.96v2.68a.9.9 0 01.54.259q.23.225.23.54v1.474q0 .315-.23.54a.9.9 0 01-.54.258V17.5a.8.8 0 01-.249.584.8.8 0 01-.584.25"/>', width: 20, height: 20 }, maximise: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.766 13.833a.58.58 0 01-.425-.175.58.58 0 01-.175-.425v-3.9a.486.486 0 01.5-.5.485.485 0 01.5.5v2.8l8.967-8.967h-2.8a.484.484 0 01-.5-.5.486.486 0 01.5-.5h3.9a.58.58 0 01.425.175.58.58 0 01.175.425v3.9a.485.485 0 01-.5.5.486.486 0 01-.5-.5v-2.8l-8.967 8.967h2.8q.216 0 .359.141a.5.5 0 01.141.359.5.5 0 01-.141.358.5.5 0 01-.359.142z"/></g>', width: 18, height: 18 }, "medium-priority": { body: '<path fill="currentColor" d="M3 4h10c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1m0 6h10c.6 0 1 .4 1 1s-.4 1-1 1H3c-.6 0-1-.4-1-1s.4-1 1-1"/>' }, memory: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.053 9.832q.187 0 .315-.128a.43.43 0 00.127-.315V7.032a.43.43 0 00-.127-.315.43.43 0 00-.315-.128.43.43 0 00-.315.128.43.43 0 00-.127.315v2.357q0 .188.127.315.128.128.315.128m2.947 0q.188 0 .315-.128a.43.43 0 00.127-.315V7.032a.43.43 0 00-.127-.315A.43.43 0 008 6.589a.43.43 0 00-.315.128.43.43 0 00-.127.315v2.357q0 .188.127.315.128.128.315.128m2.948 0q.188 0 .314-.128a.43.43 0 00.127-.315V7.032a.43.43 0 00-.127-.315.43.43 0 00-.315-.128.43.43 0 00-.315.128.43.43 0 00-.127.315v2.357q0 .188.127.315.127.128.316.128m-7.482 1.326h9.068a.17.17 0 00.125-.057.17.17 0 00.057-.125V5.445a.17.17 0 00-.057-.125.17.17 0 00-.125-.057H3.466a.17.17 0 00-.125.057.17.17 0 00-.057.125v5.531q0 .069.057.125.057.057.125.057m0 .884q-.447 0-.757-.31a1.03 1.03 0 01-.309-.756V5.445q0-.447.31-.757.309-.31.756-.31h.555v-.736q0-.187.127-.315a.43.43 0 01.315-.127q.188 0 .315.127t.127.315v.737h2.653v-.737q0-.187.127-.315A.43.43 0 018 3.2q.188 0 .315.127t.127.315v.737h2.653v-.737q0-.187.127-.315a.43.43 0 01.315-.127q.188 0 .315.127t.127.315v.737h.555q.447 0 .757.31.309.309.309.756v5.531q0 .447-.31.757-.309.31-.756.31h-.555v.736q0 .188-.127.315a.43.43 0 01-.315.127.43.43 0 01-.315-.127.43.43 0 01-.127-.315v-.737H8.442v.737q0 .188-.127.315A.43.43 0 018 13.22a.43.43 0 01-.315-.127.43.43 0 01-.127-.315v-.737H4.905v.737q0 .188-.127.315a.43.43 0 01-.315.127.43.43 0 01-.315-.127.43.43 0 01-.127-.315v-.737z"/></g>' }, minimise: { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.394 11.6a.77.77 0 01-.563-.23.77.77 0 01-.23-.563V5.65a.64.64 0 01.66-.661.643.643 0 01.661.661v3.703l5.576-5.576a.63.63 0 01.463-.176q.286 0 .463.176a.63.63 0 01.176.463.63.63 0 01-.176.463l-5.576 5.575h3.702q.287 0 .475.187a.64.64 0 01.187.474.64.64 0 01-.662.662zm-8.618 7.824a.63.63 0 01-.176-.462q0-.288.176-.463l5.576-5.576H5.65a.64.64 0 01-.661-.661.643.643 0 01.66-.661h5.158q.33 0 .562.23.231.233.231.563v5.157q0 .287-.187.474a.64.64 0 01-.474.187.64.64 0 01-.661-.661v-3.702l-5.576 5.575a.63.63 0 01-.463.177.63.63 0 01-.463-.177"/></g>', width: 24, height: 24 }, "minor-priority": { body: '<g fill="currentColor"><path d="m8.045 12.806 4.5-2.7c.5-.3 1.1-.1 1.3.4s.2 1.1-.3 1.3l-5 3c-.3.2-.7.2-1 0l-5-3c-.5-.3-.6-.9-.3-1.4s.9-.6 1.4-.3z"/><path d="M12.545 5.806c.5-.3 1.1-.1 1.3.3s.2 1.1-.3 1.4l-5 3c-.3.2-.7.2-1 0l-5-3c-.5-.3-.6-.9-.3-1.4s.9-.6 1.4-.3l4.4 2.7z"/><path d="M12.545 1.506c.5-.3 1.1-.2 1.3.3s.2 1.1-.3 1.4l-5 3c-.3.2-.7.2-1 0l-5-3c-.5-.3-.6-.9-.3-1.4s.9-.6 1.4-.3l4.4 2.7z"/></g>' }, "mobile-gear": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.09 18.75q-.624 0-1.066-.442a1.45 1.45 0 01-.441-1.064V2.756q0-.63.438-1.068a1.45 1.45 0 011.068-.438h7.853q.622 0 1.065.441.441.443.441 1.065v2.632q.344.09.572.358.23.268.23.624v1.57a.93.93 0 01-.23.625 1.1 1.1 0 01-.572.358v8.32q0 .624-.441 1.066-.442.441-1.065.441zm0-1.25h7.852a.25.25 0 00.184-.072.25.25 0 00.072-.184V2.756a.25.25 0 00-.072-.184.25.25 0 00-.184-.072H6.089a.25.25 0 00-.184.072.25.25 0 00-.072.184v14.488a.25.25 0 00.072.184.25.25 0 00.184.072m3.267-4.862q.02.15.124.247a.36.36 0 00.253.096h.564q.15 0 .253-.096a.4.4 0 00.123-.247l.06-.523q.246-.062.424-.167.177-.105.326-.27l.48.214a.34.34 0 00.264.019.37.37 0 00.21-.174l.281-.5a.37.37 0 00.048-.264.4.4 0 00-.144-.23l-.421-.307q.073-.24.073-.449t-.073-.448l.408-.308a.38.38 0 00.096-.499l-.294-.487a.4.4 0 00-.214-.165.34.34 0 00-.267.015l-.447.201a1.4 1.4 0 00-.326-.25 1.8 1.8 0 00-.424-.161l-.06-.523a.4.4 0 00-.123-.247.36.36 0 00-.253-.096h-.564q-.15 0-.253.096a.4.4 0 00-.124.247l-.06.523a1.8 1.8 0 00-.423.16q-.177.1-.326.251l-.455-.201a.34.34 0 00-.264-.019.4.4 0 00-.21.161l-.294.487a.38.38 0 00-.048.27.4.4 0 00.144.237l.409.308q-.074.238-.074.448t.074.449l-.422.307a.36.36 0 00-.096.486l.282.5q.075.13.213.178a.34.34 0 00.268-.014l.473-.215q.15.165.326.27.178.105.424.167zm.659-1.372q-.542 0-.904-.362A1.23 1.23 0 018.75 10q0-.541.362-.904.362-.362.904-.362.54 0 .903.362.363.363.363.904t-.363.904a1.23 1.23 0 01-.903.362"/></g>', width: 20, height: 20 }, "mobile-number": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6 5.667a.484.484 0 01-.5-.5.484.484 0 01.5-.5h4a.486.486 0 01.5.5.485.485 0 01-.5.5zM4.868 15q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V2.2q0-.5.35-.85t.85-.35h6.267q.5 0 .85.35t.35.85v11.6q0 .5-.35.85t-.85.35zm-.2-2.833h6.667V3.833H4.667zm0 1v.633q0 .084.059.142a.2.2 0 00.141.058h6.267q.084 0 .142-.058a.2.2 0 00.058-.142v-.633zm0-10.334h6.667V2.2a.2.2 0 00-.058-.142.2.2 0 00-.142-.058H4.867a.2.2 0 00-.141.058.2.2 0 00-.059.142z"/></g>' }, "mobile-web": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M4.872 15q-.5 0-.852-.353a1.16 1.16 0 01-.353-.852V2.205q0-.498.353-.852Q4.373 1 4.872 1h6.256q.5 0 .852.353.354.354.353.852v2.436h-1v-.808H4.667v8.334h6.666v-.808h1v2.436q0 .498-.353.852-.353.353-.852.353z"/><path d="M11.833 10.5q-.511 0-.969-.197A2.54 2.54 0 019.53 8.97 2.4 2.4 0 019.333 8q0-.519.197-.972.196-.453.538-.794.34-.34.796-.537a2.4 2.4 0 01.97-.197q.518 0 .971.197a2.55 2.55 0 011.331 1.331q.197.453.197.972 0 .513-.197.969a2.54 2.54 0 01-1.331 1.334 2.4 2.4 0 01-.972.197m0-.512A3 3 0 0012.308 9h-.95a3 3 0 00.475.988m-.65-.1A3.5 3.5 0 0110.846 9h-.738q.181.313.453.544.272.23.622.343m1.3 0q.35-.113.622-.344.271-.232.453-.544h-.737a3.7 3.7 0 01-.338.887M9.896 8.5h.85a3.5 3.5 0 01-.038-.5 3 3 0 01.038-.5h-.85a2 2 0 00-.063.5 2 2 0 00.063.5m1.35 0h1.175a3.5 3.5 0 00.028-.753 4 4 0 00-.028-.247h-1.175a3.5 3.5 0 00-.038.5 3 3 0 00.038.5m1.675 0h.85a2 2 0 00.062-.5 2 2 0 00-.062-.5h-.85a3.5 3.5 0 01.028.753 4 4 0 01-.028.247m-.1-1.5h.737a2.1 2.1 0 00-.453-.544 1.8 1.8 0 00-.622-.344 3.5 3.5 0 01.338.888m-1.463 0h.95a3 3 0 00-.475-.987q-.162.225-.281.468-.12.245-.194.519m-1.25 0h.738a3.7 3.7 0 01.337-.888q-.35.113-.622.344a2.1 2.1 0 00-.453.544"/></g>' }, "more-horizontal": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.188 11.25q-.522 0-.885-.365A1.2 1.2 0 013.938 10q0-.52.365-.885.363-.365.885-.365.52 0 .885.365.364.365.364.885.001.52-.364.885a1.2 1.2 0 01-.886.365m4.812 0q-.52 0-.885-.365A1.2 1.2 0 018.75 10q0-.52.365-.885T10 8.75t.885.365.365.885-.365.885a1.2 1.2 0 01-.885.365m4.813 0q-.522 0-.886-.365a1.2 1.2 0 01-.364-.885q0-.52.364-.885t.886-.365.885.365.364.885-.364.885a1.2 1.2 0 01-.886.365"/></g>', width: 20, height: 20 }, "more-vertical": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 16.063q-.52 0-.885-.365a1.2 1.2 0 01-.365-.886q0-.52.365-.885.365-.364.885-.364.52-.001.885.364.365.364.365.886 0 .52-.365.884a1.2 1.2 0 01-.885.366m0-4.813q-.52 0-.885-.365A1.2 1.2 0 018.75 10q0-.52.365-.885T10 8.75t.885.365.365.885-.365.885a1.2 1.2 0 01-.885.365m0-4.812q-.52 0-.885-.365a1.2 1.2 0 01-.365-.886q0-.52.365-.885.365-.364.885-.364.52-.001.885.364.365.364.365.886 0 .52-.365.885a1.2 1.2 0 01-.885.364"/></g>', width: 20, height: 20 }, "move-down": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M20 0v20H0V0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3.249 5.39a.58.58 0 01.426-.18q.245 0 .439.18l1.112 1.087q.154-2.275 1.736-3.855 1.581-1.58 3.872-1.579 2.349 0 3.987 1.638t1.638 3.987v1.667q0 .265-.18.445a.6.6 0 01-.445.18.6.6 0 01-.446-.18.6.6 0 01-.18-.445V6.668q0-1.818-1.278-3.096-1.28-1.28-3.096-1.28-1.742.001-2.936 1.166-1.192 1.165-1.396 2.984L7.54 5.404a.6.6 0 01.433-.182.634.634 0 01.635.627.6.6 0 01-.19.446L6.361 8.352a.7.7 0 01-.527.213.7.7 0 01-.527-.213l-2.071-2.07a.6.6 0 01-.181-.44.62.62 0 01.194-.451m7.793 6.903q0-.51.37-.88.368-.37.88-.37h2.917q.51 0 .88.37t.37.88v4.583q0 .512-.37.88-.37.37-.88.37h-2.917q-.511 0-.88-.37a1.2 1.2 0 01-.37-.88zm1.25 0v4.583h2.917v-4.583zm-8.75 0q0-.51.37-.88.368-.37.88-.37h2.917q.51 0 .88.37t.37.88v4.583q0 .512-.37.88-.37.37-.88.37H4.792q-.512 0-.88-.37a1.2 1.2 0 01-.37-.88z"/></g></g>', width: 20, height: 20 }, "move-item": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M16.976 10.625H7.773a.6.6 0 01-.446-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.446-.18h9.203L15.9 8.298a.6.6 0 01-.183-.435.64.64 0 01.183-.443.64.64 0 01.446-.2.6.6 0 01.445.187l2.066 2.066q.225.225.226.527 0 .302-.226.528l-2.066 2.065a.6.6 0 01-.441.184.63.63 0 01-.45-.196.65.65 0 01-.187-.44.58.58 0 01.187-.439zm-4.308-3.862v-2.34a.25.25 0 00-.072-.184.25.25 0 00-.184-.072H4.423a.25.25 0 00-.184.072.25.25 0 00-.072.184v11.154a.25.25 0 00.072.185.25.25 0 00.184.072h7.989a.25.25 0 00.184-.072.25.25 0 00.072-.185v-2.34q0-.265.18-.445t.445-.18.446.18.18.445v2.34q0 .623-.442 1.065-.443.442-1.065.442H4.423q-.622 0-1.065-.442a1.45 1.45 0 01-.441-1.065V4.423q0-.622.441-1.065.443-.441 1.065-.441h7.989q.623 0 1.065.441.441.443.441 1.065v2.34q0 .266-.18.446a.6.6 0 01-.445.179.6.6 0 01-.445-.18.6.6 0 01-.18-.445"/></g>', width: 20, height: 20 }, native: { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.65 18q-.316 0-.483-.167Q7 17.65 7 17.316V6.7q0-.334.167-.517A.56.56 0 017.6 6q.267 0 .384.1.133.083.3.317l7.277 9.697h-.4V6.668q0-.318.166-.484.168-.184.484-.184.3 0 .45.184.168.165.168.484v10.664q0 .318-.15.501-.134.167-.401.167a.7.7 0 01-.4-.1 1.4 1.4 0 01-.318-.317L7.9 7.886h.384v9.43q0 .334-.167.517Q7.95 18 7.65 18"/></g>', width: 24, height: 24 }, "nav-bar-menu": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.501 15q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T4.5 15M9 15q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T9 15m4.5 0q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T13.5 15m-9-4.5q-.618 0-1.059-.44A1.44 1.44 0 013.002 9q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059t-1.06.44m4.5 0q-.618 0-1.059-.44A1.44 1.44 0 017.502 9q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T9 10.5m4.5 0q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059t-1.06.44M4.5 6q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T4.5 6M9 6q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T9 6m4.5 0q-.618 0-1.059-.44a1.44 1.44 0 01-.44-1.06q0-.618.44-1.059t1.06-.44 1.059.44.44 1.06q0 .618-.44 1.059T13.5 6"/></g>', width: 18, height: 18 }, navigation: { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#fff" d="M14.143 0v14h-14V0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.497 6.106a1 1 0 010 1.788l-8.764 4.382a1 1 0 01-1.447-.894V7.868l5-.868-5-.868V2.618a1 1 0 011.447-.894z"/></g>', width: 14, height: 14 }, "new-link": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.673 18.745q-1.33 1.33-3.209 1.332-1.876 0-3.209-1.332-1.33-1.331-1.331-3.21 0-1.876 1.331-3.209l2.162-2.162a.73.73 0 01.53-.225q.305 0 .531.226.225.225.225.53t-.225.53l-2.162 2.162a2.93 2.93 0 00-.891 2.149q0 1.257.89 2.148.89.89 2.15.89 1.257 0 2.148-.89l2.162-2.162a.73.73 0 01.53-.225q.306 0 .53.225.226.225.226.53t-.226.53zm-1.264-4.093a.73.73 0 01-.53.225.73.73 0 01-.531-.226.73.73 0 01-.225-.53q0-.305.225-.53l4.243-4.243a.73.73 0 01.53-.225q.306 0 .53.226.226.225.226.53t-.226.53zm6.173-.816a.73.73 0 01-.53.225.73.73 0 01-.53-.226.73.73 0 01-.226-.53q0-.305.226-.53l2.162-2.162q.89-.89.89-2.149 0-1.257-.89-2.148a2.93 2.93 0 00-2.149-.89q-1.257 0-2.148.89l-2.162 2.162a.73.73 0 01-.53.225.73.73 0 01-.531-.225.73.73 0 01-.226-.53q0-.305.226-.53l2.162-2.163q1.332-1.332 3.21-1.332 1.875 0 3.208 1.332 1.332 1.331 1.332 3.21 0 1.875-1.332 3.209z"/></g>', width: 24, height: 24 }, "no-photography": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m17.917 15.542-1.25-1.25V6.083a.24.24 0 00-.073-.176.24.24 0 00-.177-.074H8.208L6.521 4.167l.708-.771q.21-.23.5-.354.292-.126.604-.125h3.334q.313 0 .604.125.29.125.5.354l1.104 1.187h2.542q.624 0 1.062.438t.438 1.062zm-4.5-4.5L9.792 7.417q.75-.042 1.437.218.688.261 1.188.76.52.521.781 1.21.26.686.219 1.437M4.604 4.583l1.25 1.25h-2.27q-.084 0-.167.084-.084.082-.084.166v9.5q0 .105.074.178a.24.24 0 00.176.072h10.48l-2.167-2.166a3 3 0 01-.885.448 3.3 3.3 0 01-1.011.156q-1.437 0-2.437-1t-1-2.438q0-.52.155-1.01.157-.49.449-.886L1.5 3.271a.6.6 0 01-.187-.438.67.67 0 01.187-.458.67.67 0 01.458-.187.6.6 0 01.438.187L17.77 17.771q.187.187.197.437a.54.54 0 01-.197.438.6.6 0 01-.438.187.6.6 0 01-.437-.187l-1.584-1.563H3.584q-.624 0-1.062-.437a1.45 1.45 0 01-.438-1.063v-9.5q0-.624.438-1.062a1.45 1.45 0 011.062-.438z"/></g>', width: 20, height: 20 }, "not-executed-overridden": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path fill-rule="evenodd" d="m10.473 6.746.003-.164q0-1.56-1.082-2.642Q8.31 2.857 6.75 2.857q-.22 0-.43.018-.211.018-.416.079a1.05 1.05 0 01-.611-.036.74.74 0 01-.43-.4.7.7 0 01-.017-.58.64.64 0 01.417-.387 5.2 5.2 0 011.487-.218q1.101 0 2.056.413.955.411 1.662 1.118a5.3 5.3 0 011.119 1.662 5.1 5.1 0 01.41 2.188 4.7 4.7 0 00-1.525.032m-3.78 5.084a4.7 4.7 0 01.087-1.523H6.75q-1.56 0-2.642-1.082-1.083-1.083-1.083-2.643 0-.495.115-.95.115-.453.357-.876l3.967 3.967q.324-.479.753-.864L2.313 1.962a.55.55 0 00-.404-.17.56.56 0 00-.405.169.54.54 0 00-.17.399q0 .231.168.401l.883.894q-.435.655-.659 1.39a5.3 5.3 0 00-.223 1.535q0 1.103.412 2.058.413.955 1.119 1.662a5.3 5.3 0 001.661 1.119q.93.4 1.998.411" clip-rule="evenodd"/><path d="M11.333 11.333q.5 0 .85-.35t.35-.85-.35-.85a1.16 1.16 0 00-.85-.35q-.5 0-.85.35t-.35.85.35.85.85.35m0 2.4a2.3 2.3 0 001.14-.29q.52-.29.84-.77a3.84 3.84 0 00-1.98-.54 3.84 3.84 0 00-1.98.54q.321.48.84.77a2.3 2.3 0 001.14.29m0 1.6q-1.66 0-2.83-1.17t-1.17-2.83 1.17-2.83 2.83-1.17 2.83 1.17 1.17 2.83-1.17 2.83-2.83 1.17"/></g>' }, "offline-bolt": { body: '<path fill="currentColor" d="M6.742 7.921v2.69q0 .258.23.303.23.047.341-.175l1.824-4.163a.35.35 0 00-.027-.34q-.102-.157-.268-.157H7.368V3.334q0-.258-.23-.313-.23-.056-.34.166L4.881 7.424a.37.37 0 00.018.34.3.3 0 00.276.157zM7 14q-1.455 0-2.735-.553a7.1 7.1 0 01-2.22-1.492 7.1 7.1 0 01-1.492-2.22A6.8 6.8 0 010 7q0-1.455.553-2.736a7.1 7.1 0 011.492-2.22 7.1 7.1 0 012.22-1.49A6.8 6.8 0 017 0q1.455 0 2.736.553a7.1 7.1 0 012.22 1.492 7.1 7.1 0 011.491 2.22Q14 5.544 14 7t-.553 2.735a7.1 7.1 0 01-1.492 2.22 7.1 7.1 0 01-2.22 1.492A6.8 6.8 0 017 14m0-1.105q2.45 0 4.173-1.722Q12.895 9.45 12.895 7t-1.722-4.173Q9.45 1.105 7 1.105T2.828 2.827 1.105 7t1.723 4.173Q4.55 12.895 7 12.895"/>', width: 14, height: 14 }, "open-in-full": { body: '<path fill="currentColor" d="M1.15 17.75a.87.87 0 01-.637-.262.87.87 0 01-.263-.638V11a.73.73 0 01.75-.75.73.73 0 01.75.75v4.2L15.2 1.75H11a.726.726 0 01-.75-.75.73.73 0 01.75-.75h5.85a.87.87 0 01.638.262.87.87 0 01.262.638V7a.73.73 0 01-.75.75.73.73 0 01-.75-.75V2.8L2.8 16.25H7q.325 0 .538.212A.73.73 0 017.75 17q0 .325-.212.538A.73.73 0 017 17.75z"/>', width: 18, height: 18 }, "open-in-new": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.533 13.667q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.534q0-.5.35-.85t.85-.35H7.25q.2 0 .35.14.15.143.15.36a.47.47 0 01-.15.357.5.5 0 01-.35.143H3.533q-.067 0-.133.066-.067.068-.067.134v8.933q0 .067.067.133.066.067.133.067h8.934q.066 0 .133-.067t.067-.133V8.75q0-.2.14-.35.143-.15.36-.15.216 0 .358.15t.142.35v3.717q0 .5-.35.85t-.85.35zm2.6-3.8a.44.44 0 01-.15-.342q0-.208.15-.358l5.834-5.833H9.833a.484.484 0 01-.5-.5.486.486 0 01.5-.5h3.234a.58.58 0 01.425.174.58.58 0 01.175.426v3.233a.485.485 0 01-.5.5.486.486 0 01-.5-.5V4.034l-5.85 5.85q-.134.15-.334.15a.46.46 0 01-.35-.167"/></g>' }, "open-in-new-green": { body: '<path fill="currentColor" d="M1.98 13.375q-.568 0-.961-.394a1.3 1.3 0 01-.394-.962V1.981q0-.57.394-.962.393-.394.962-.394h4.168q.24 0 .401.162a.54.54 0 01.161.4q0 .24-.161.401a.54.54 0 01-.401.162H1.981a.22.22 0 00-.159.072.22.22 0 00-.072.159v10.038q0 .086.072.159a.22.22 0 00.159.072h10.038a.22.22 0 00.159-.072.22.22 0 00.072-.159V7.851q0-.24.162-.401a.55.55 0 01.4-.162q.24 0 .401.162a.54.54 0 01.162.401v4.168q0 .57-.394.962a1.3 1.3 0 01-.962.394zm2.914-4.27a.54.54 0 01-.163-.394q0-.232.163-.396L11.46 1.75H9.062a.54.54 0 01-.4-.162.54.54 0 01-.162-.4q0-.24.162-.401a.54.54 0 01.4-.162h3.635q.29 0 .484.194.195.194.194.484v3.635q0 .24-.162.4a.54.54 0 01-.4.162.55.55 0 01-.402-.162.54.54 0 01-.161-.4V2.54L5.666 9.125a.5.5 0 01-.377.155.55.55 0 01-.395-.174"/>', width: 14, height: 14 }, "other-admission": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="m11.555 8.889.114.268a4.32 4.32 0 002.285 2.284l.268.114-.268.114a4.32 4.32 0 00-2.285 2.285l-.114.268-.114-.268a4.32 4.32 0 00-2.284-2.285l-.268-.114.268-.114a4.32 4.32 0 002.284-2.284z"/><path d="M3.539 13.667a1.16 1.16 0 01-.852-.354 1.16 1.16 0 01-.353-.851V3.539q0-.498.353-.851a1.16 1.16 0 01.852-.354h8.923q.497 0 .85.354.355.355.355.85v3.373q0 .212-.144.356a.48.48 0 01-.356.144.48.48 0 01-.357-.144.48.48 0 01-.143-.356V3.539a.2.2 0 00-.064-.141.2.2 0 00-.141-.064H3.539a.2.2 0 00-.141.064.2.2 0 00-.065.14v8.924q0 .077.065.14.064.066.14.065h3.373q.212 0 .356.144a.48.48 0 01.143.356q0 .213-.143.356a.48.48 0 01-.357.144zm-.206-1V3.334 7.46v-.05zm1.5-2.077q0 .212.144.357a.48.48 0 00.356.143h1.679q.212 0 .356-.144a.48.48 0 00.144-.356.48.48 0 00-.144-.356.5.5 0 00-.356-.144H5.334a.48.48 0 00-.357.144.48.48 0 00-.144.356m0-2.59q0 .213.144.357a.48.48 0 00.356.143h3.828q.212 0 .356-.144A.48.48 0 009.66 8a.48.48 0 00-.144-.356.48.48 0 00-.356-.144H5.334a.48.48 0 00-.357.144.48.48 0 00-.144.356m0-2.59q0 .213.144.357a.48.48 0 00.356.143h5.334q.213 0 .356-.143a.48.48 0 00.144-.357.48.48 0 00-.144-.356.48.48 0 00-.356-.143H5.334a.48.48 0 00-.357.143.48.48 0 00-.144.357"/></g>' }, overlap: { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M1.524 0C.678 0 0 .678 0 1.524v8.38c0 .847.678 1.525 1.524 1.525h1.524V9.905H1.524V1.524h8.38v1.524h1.525V1.524A1.52 1.52 0 009.905 0zm4.571 4.571a1.52 1.52 0 00-1.524 1.524V7.62h1.524V6.095H7.62V4.571zm3.048 0v1.524h.762v.762h1.524V4.571zm3.81 0v1.524h1.523v8.381h-8.38v-1.524H4.57v1.524A1.52 1.52 0 006.094 16h8.381c.846 0 1.524-.678 1.524-1.524v-8.38a1.52 1.52 0 00-1.524-1.525zm-3.048 3.81v1.524H8.38v1.524h1.524c.846 0 1.524-.678 1.524-1.524V8.38zm-5.334.762v2.286h2.286V9.905h-.762v-.762z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 0h16v16H0z"/></clipPath></defs></g>' }, pace: { body: '<path fill="currentColor" d="M7 14a6.9 6.9 0 01-2.73-.552 7 7 0 01-2.222-1.497A7 7 0 01.549 9.73 6.9 6.9 0 010 7q0-1.453.552-2.73a7 7 0 011.495-2.222Q2.995 1.102 4.27.549A6.9 6.9 0 017 0q1.47 0 2.738.552a7.1 7.1 0 012.213 1.495q.945.946 1.498 2.215a6.8 6.8 0 01.515 3.403.61.61 0 01-.253.455.66.66 0 01-.517.105.7.7 0 01-.473-.298.76.76 0 01-.14-.542q0-.088.01-.193.01-.102.01-.192 0-1.173-.428-2.187a5.56 5.56 0 00-2.985-2.984A5.6 5.6 0 007 1.4q-2.345 0-3.972 1.628Q1.4 4.655 1.4 7t1.628 3.973T7 12.6a5.6 5.6 0 001.513-.202q.727-.202 1.373-.603a.84.84 0 01.535-.105.59.59 0 01.447.28q.175.245.112.533a.67.67 0 01-.305.447 7 7 0 01-1.742.778Q8.015 14.001 7 14m5.075-2.8a.84.84 0 01-.622-.253.84.84 0 01-.253-.622q0-.368.253-.622a.84.84 0 01.622-.253q.367 0 .622.253.252.253.253.622 0 .368-.253.622a.84.84 0 01-.622.253M7.7 6.72l2.1 2.1a.66.66 0 01.193.49.66.66 0 01-.193.49.66.66 0 01-.49.193.66.66 0 01-.49-.193L6.51 7.49a.7.7 0 01-.21-.507V4.2q0-.297.202-.498A.67.67 0 017 3.5q.298 0 .498.202A.67.67 0 017.7 4.2z"/>', width: 14, height: 14 }, "page-element": { body: '<g fill="currentColor"><path d="M7 3C4.794 3 3 4.794 3 7s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m9-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m9-6c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4m0 6c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2"/><path d="M0 0v60h60V0zm2 2h56v10H2zm56 56H2V14h56z"/><path d="M47 21h5a1 1 0 100-2h-5a1 1 0 100 2m0 3h5a1 1 0 100-2h-5a1 1 0 100 2m0 3h5a1 1 0 100-2h-5a1 1 0 100 2m-35 1c2.757 0 5-2.243 5-5s-2.243-5-5-5-5 2.243-5 5 2.243 5 5 5m0-8c1.654 0 3 1.346 3 3s-1.346 3-3 3-3-1.346-3-3 1.346-3 3-3M8 37h21a1 1 0 100-2H8a1 1 0 100 2m25 0h9a1 1 0 100-2h-9a1 1 0 100 2m13 0h6a1 1 0 100-2h-6a1 1 0 100 2m-15 5h21a1 1 0 100-2H31a1 1 0 100 2m-13-2a1 1 0 100 2h9a1 1 0 100-2zM8 42h6a1 1 0 100-2H8a1 1 0 100 2m0 5h21a1 1 0 100-2H8a1 1 0 100 2m34 0a1 1 0 100-2h-9a1 1 0 100 2zm10-2h-6a1 1 0 100 2h6a1 1 0 100-2m0 5H31a1 1 0 100 2h21a1 1 0 100-2m-25 0h-9a1 1 0 100 2h9a1 1 0 100-2m-13 0H8a1 1 0 100 2h6a1 1 0 100-2"/></g>', width: 60, height: 60 }, "page-loading": { body: '<path fill="currentColor" d="M254 188V2H2v186h111v29H75v22h106v-22h-38v-29zM19 19h217v151H19zm145.204 32.099c0 17.667-6.046 33.865-16.002 43.477 9.955 9.614 16.002 25.813 16.002 43.478v3.545h4.496v10.843H87.3V141.6h4.496v-3.545c0-17.665 6.045-33.865 16.002-43.478-9.957-9.612-16.002-25.813-16.002-43.477v-2.814H87.3V37.443h81.4v10.843h-4.496zm-7.192 3.55H98.987c.825 15.73 7.077 30.033 16.395 37.099l3.731 2.828-3.731 2.828c-9.32 7.067-15.57 21.373-16.395 37.101h58.027c-.826-15.73-7.079-30.035-16.396-37.101l-3.733-2.828 3.733-2.828c9.317-7.066 15.571-21.37 16.394-37.099m-39.088 33.218 3.827 2.146s5.384 7.061 5.384 23.528c0 0 .047.093.126.23-4.371.759-7.488 3.494-7.488 3.494-6.551 4.969-11.719 9.28-12.035 15.303h42.591c-.317-6.025-2.953-7.004-12.036-15.303-2.575-2.352-5.172-3.366-7.577-3.623.006-.771.184-18.253 3.533-23.036 1.619-1.623 2.831-2.146 2.831-2.146 7.08-5.365 11.829-16.228 12.452-28.171h-43.064c.625 11.943 4.379 22.209 11.456 27.578"/>', width: 256, height: 241 }, passed: { body: '<path fill="currentColor" d="M4 6.95 10.075.875a.7.7 0 01.525-.2.7.7 0 01.525.2.7.7 0 01.2.525.7.7 0 01-.2.525L4.625 8.4A.86.86 0 014 8.675a.86.86 0 01-.625-.275l-2.5-2.475a.7.7 0 01-.2-.525.7.7 0 01.2-.525.7.7 0 01.525-.2.7.7 0 01.525.2z"/>', width: 12, height: 9 }, pause: { body: '<g fill="currentColor"><path d="M12.5 25C19.404 25 25 19.404 25 12.5S19.404 0 12.5 0C5.597 0 0 5.596 0 12.5S5.596 25 12.5 25m0-23C18.29 2 23 6.71 23 12.5S18.29 23 12.5 23 2 18.29 2 12.5 6.71 2 12.5 2"/><path d="M10.177 18.396c.69 0 1.25-.56 1.25-1.25v-9.5a1.25 1.25 0 10-2.5 0v9.5c0 .69.56 1.25 1.25 1.25m5 0c.69 0 1.25-.56 1.25-1.25v-9.5a1.25 1.25 0 10-2.5 0v9.5c0 .69.56 1.25 1.25 1.25"/></g>', width: 25, height: 25 }, "pause-bonding-box": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.38 13.045q.266 0 .445-.18.18-.18.18-.446V7.397a.57.57 0 00-.18-.431.62.62 0 00-.445-.173.6.6 0 00-.446.18.6.6 0 00-.18.445v5.022q0 .258.18.431.18.174.446.174m3.078 0q.266 0 .445-.18.18-.18.18-.446V7.397a.57.57 0 00-.18-.431.62.62 0 00-.446-.173.6.6 0 00-.445.18.6.6 0 00-.18.445v5.022q0 .258.18.431.18.174.446.174M9.92 17.837a7.7 7.7 0 01-3.088-.623 8 8 0 01-2.515-1.692 8 8 0 01-1.693-2.514A7.7 7.7 0 012 9.92q0-1.643.624-3.088a8 8 0 011.692-2.515A8 8 0 016.83 2.624 7.7 7.7 0 019.917 2q1.644 0 3.089.624 1.445.623 2.515 1.692a8 8 0 011.693 2.514q.624 1.445.624 3.087a7.7 7.7 0 01-.624 3.089 8 8 0 01-1.692 2.515 8 8 0 01-2.514 1.693 7.7 7.7 0 01-3.088.624m-.001-1.25q2.771 0 4.72-1.948 1.948-1.949 1.948-4.72T14.639 5.2t-4.72-1.949T5.199 5.2Q3.249 7.148 3.25 9.92t1.949 4.72 4.72 1.948"/></g>', width: 20, height: 20 }, "pause-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M9.92 17.838a7.7 7.7 0 01-3.088-.624 8 8 0 01-2.515-1.692 8 8 0 01-1.693-2.514A7.7 7.7 0 012 9.92q0-1.643.624-3.088a8 8 0 011.692-2.515A8 8 0 016.83 2.624 7.7 7.7 0 019.917 2q1.644 0 3.089.624 1.445.623 2.515 1.692a8 8 0 011.693 2.514q.624 1.445.624 3.087a7.7 7.7 0 01-.624 3.089 8 8 0 01-1.692 2.515 8 8 0 01-2.514 1.693 7.7 7.7 0 01-3.088.624m-.001-1.25q2.771 0 4.72-1.95 1.948-1.947 1.948-4.72 0-2.77-1.948-4.72-1.949-1.947-4.72-1.948T5.199 5.2Q3.249 7.148 3.25 9.92t1.949 4.72 4.72 1.948"/><path d="M7 12.576V7.424q0-.18.122-.302A.4.4 0 017.424 7q.18 0 .302.122a.4.4 0 01.122.302v5.152q0 .18-.122.302a.4.4 0 01-.302.122.4.4 0 01-.302-.122.4.4 0 01-.122-.302m2.862-.036a.47.47 0 01-.515 0 .49.49 0 01-.26-.445v-4.19q0-.293.26-.446a.47.47 0 01.515 0l3.501 2.104q.25.154.25.438a.48.48 0 01-.25.436z"/></g>', width: 20, height: 20 }, "pause-plain": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 9.5a.96.96 0 01-.706-.294A.96.96 0 017 8.5v-5q0-.412.294-.706A.96.96 0 018 2.5q.412 0 .706.294A.96.96 0 019 3.5v5q0 .412-.294.706A.96.96 0 018 9.5m-4 0a.96.96 0 01-.706-.294A.96.96 0 013 8.5v-5q0-.412.294-.706A.96.96 0 014 2.5q.412 0 .706.294A.96.96 0 015 3.5v5q0 .412-.294.706A.96.96 0 014 9.5"/></g>', width: 12, height: 12 }, pending: { body: '<path fill="currentColor" d="M3 5.75a.72.72 0 00.531-.219A.72.72 0 003.75 5a.72.72 0 00-.219-.531A.72.72 0 003 4.25a.72.72 0 00-.531.219A.72.72 0 002.25 5q0 .312.219.531A.72.72 0 003 5.75m2.5 0a.72.72 0 00.531-.219A.72.72 0 006.25 5a.72.72 0 00-.219-.531.72.72 0 00-.531-.219.72.72 0 00-.531.219A.72.72 0 004.75 5q0 .312.219.531a.72.72 0 00.531.219m2.5 0a.72.72 0 00.531-.219A.72.72 0 008.75 5a.72.72 0 00-.219-.531A.72.72 0 008 4.25a.72.72 0 00-.531.219A.72.72 0 007.25 5q0 .312.219.531A.72.72 0 008 5.75M5.5 10a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069Q1.287 7.863.894 6.95A4.9 4.9 0 01.5 5q0-1.038.394-1.95a5 5 0 011.068-1.587Q2.639.787 3.55.392A4.9 4.9 0 015.5 0q1.038 0 1.95.394a5 5 0 011.587 1.069q.675.675 1.069 1.587T10.5 5t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 015.5 10m0-1q1.675 0 2.838-1.162Q9.5 6.675 9.5 5T8.338 2.163 5.5 1 2.663 2.163 1.5 5t1.163 2.838T5.5 9"/>', width: 11, height: 10 }, "pending-solid": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.666 8.833q.347 0 .59-.243A.8.8 0 005.5 8a.8.8 0 00-.243-.59.8.8 0 00-.59-.243.8.8 0 00-.59.243.8.8 0 00-.244.59q0 .345.243.59a.8.8 0 00.59.243m3.333 0q.347 0 .59-.243A.8.8 0 008.834 8a.8.8 0 00-.243-.59.8.8 0 00-.59-.243.8.8 0 00-.59.243.8.8 0 00-.244.59q0 .345.243.59a.8.8 0 00.59.243m3.333 0q.348 0 .59-.243a.8.8 0 00.244-.59.8.8 0 00-.242-.59.8.8 0 00-.59-.243.8.8 0 00-.59.243.8.8 0 00-.244.59q0 .345.243.59a.8.8 0 00.59.243m-3.331 5.5a6.2 6.2 0 01-2.47-.498A6.4 6.4 0 013.52 12.48a6.4 6.4 0 01-1.355-2.01A6.2 6.2 0 011.667 8q0-1.315.498-2.47A6.4 6.4 0 013.52 3.52a6.4 6.4 0 012.01-1.354 6.2 6.2 0 012.47-.5q1.314 0 2.47.5 1.155.498 2.011 1.353t1.354 2.01q.5 1.156.5 2.47t-.5 2.47a6.4 6.4 0 01-1.353 2.011 6.4 6.4 0 01-2.01 1.354 6.2 6.2 0 01-2.47.5"/></g>' }, "person-remove": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M14.006 8.958a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18h3.334q.265 0 .445.18t.18.445q0 .267-.18.446a.6.6 0 01-.445.18zM7.5 9.743a2.8 2.8 0 01-2.06-.856 2.8 2.8 0 01-.857-2.06q0-1.203.857-2.06A2.8 2.8 0 017.5 3.91q1.203 0 2.06.857t.857 2.06-.857 2.06a2.8 2.8 0 01-2.06.856M2.003 16.09a.73.73 0 01-.536-.217.73.73 0 01-.217-.537v-1.099q0-.612.333-1.134a2.2 2.2 0 01.888-.802 12 12 0 012.493-.909 10.8 10.8 0 015.072 0q1.258.303 2.493.91.555.28.889.801.332.522.332 1.134v1.1a.73.73 0 01-.217.536.73.73 0 01-.536.217zm.497-1.25h10v-.603a.8.8 0 00-.147-.469 1.1 1.1 0 00-.398-.352 10.7 10.7 0 00-2.196-.803 9.5 9.5 0 00-4.518 0q-1.119.273-2.196.803-.251.137-.398.352a.8.8 0 00-.147.469zm5-6.347q.687 0 1.177-.49.49-.488.49-1.176t-.49-1.177A1.6 1.6 0 007.5 5.16q-.687 0-1.177.49-.49.489-.49 1.177 0 .687.49 1.177t1.177.49"/></g></g>', width: 20, height: 20 }, photo: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3.538 13.667q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855V3.54q0-.506.35-.855.351-.35.855-.35h8.923q.505 0 .856.35.35.35.35.855v8.923q0 .506-.35.855-.35.35-.856.35zm0-1h8.923a.2.2 0 00.141-.064.2.2 0 00.065-.14V3.538a.2.2 0 00-.065-.14.2.2 0 00-.14-.065H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.141v8.923q0 .077.064.141t.141.064m1.565-1.5h5.846q.18 0 .268-.164a.28.28 0 00-.027-.318L9.6 8.555a.3.3 0 00-.241-.12.3.3 0 00-.241.12l-1.63 2.125-1.093-1.4a.3.3 0 00-.238-.114.29.29 0 00-.238.12l-1.051 1.4q-.12.153-.033.317t.268.164"/></g></g>' }, "photo-camera": { body: '<mask id="svgID0" width="15" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.143 0h14v14h-14z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.143 10.208q1.094 0 1.86-.765.765-.765.765-1.86 0-1.094-.766-1.86a2.53 2.53 0 00-1.86-.765q-1.092 0-1.859.766-.765.765-.765 1.86 0 1.093.765 1.859.765.765 1.86.765M2.476 12.25q-.48 0-.824-.342a1.12 1.12 0 01-.343-.825v-7q0-.48.343-.823t.824-.343h1.838l.729-.788q.16-.19.386-.284.226-.095.474-.095h2.48q.247 0 .474.095.225.095.386.284l.729.788h1.837q.482 0 .825.343t.342.823v7q0 .482-.342.825a1.13 1.13 0 01-.825.342zm9.333-1.167v-7H2.476v7z"/></g>', width: 15, height: 14 }, "photo-camera-outline": { body: '<path fill="currentColor" d="M7 9.667q1.25 0 2.125-.875A2.9 2.9 0 0010 6.667q0-1.25-.875-2.125A2.9 2.9 0 007 3.667q-1.25 0-2.125.875A2.9 2.9 0 004 6.667q0 1.25.875 2.125A2.9 2.9 0 007 9.667m0-1.334a1.6 1.6 0 01-1.183-.483 1.6 1.6 0 01-.484-1.183q0-.7.484-1.184A1.6 1.6 0 017 5q.7 0 1.184.483.483.484.483 1.184 0 .699-.483 1.183A1.6 1.6 0 017 8.333M1.667 12q-.55 0-.942-.392a1.28 1.28 0 01-.392-.941v-8q0-.55.392-.942.391-.392.942-.392h2.1L5 0h4l1.233 1.333h2.1q.55 0 .942.392t.392.942v8q0 .55-.392.941a1.28 1.28 0 01-.941.392zm0-1.333h10.667v-8h-2.7L8.417 1.333H5.584L4.367 2.667h-2.7z"/>', width: 14, height: 12 }, "pie-chart": { body: '<path fill="currentColor" d="M8.625 7.375h6.02q-.249-2.416-1.926-4.104-1.677-1.687-4.094-1.917zm-1.25 7.271V1.354q-2.583.23-4.312 2.135Q1.333 5.396 1.333 8t1.73 4.511q1.728 1.905 4.312 2.135m1.25 0q2.417-.23 4.104-1.917t1.917-4.104H8.625zM8 15.916a7.7 7.7 0 01-3.093-.624 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 01.083 8q0-1.645.625-3.094a8 8 0 011.688-2.51A8 8 0 014.906.708 7.7 7.7 0 018 .083q1.646 0 3.083.625a8 8 0 012.51 1.698 8.1 8.1 0 011.699 2.51q.625 1.44.625 3.084a7.7 7.7 0 01-.625 3.073 8.1 8.1 0 01-1.688 2.52 7.9 7.9 0 01-2.51 1.699A7.7 7.7 0 018 15.917"/>' }, "pin-alt": { body: '<g fill="none"><g clip-path="url(#svgID0)"><path fill="currentColor" d="M11.264 5.07 6.296 9.831a.81.81 0 00-.01 1.2c.081.08.18.142.287.185a.9.9 0 00.68-.006.9.9 0 00.285-.189l4.969-4.76a2.47 2.47 0 00.772-1.786c0-.67-.278-1.312-.772-1.785a2.7 2.7 0 00-1.864-.74c-.699 0-1.369.266-1.863.74L3.81 7.45a4.2 4.2 0 00-.975 1.366 4.06 4.06 0 00-.021 3.246c.22.515.546.983.957 1.377.412.394.9.706 1.438.917a4.56 4.56 0 003.388-.02 4.4 4.4 0 001.425-.935l4.97-4.76 1.241 1.19-4.969 4.76a6.2 6.2 0 01-1.995 1.278 6.38 6.38 0 01-4.706 0 6.2 6.2 0 01-1.995-1.277 5.9 5.9 0 01-1.333-1.912 5.68 5.68 0 010-4.51 5.9 5.9 0 011.333-1.91l4.97-4.76a4.5 4.5 0 013.09-1.181 4.5 4.5 0 013.067 1.232 4.12 4.12 0 011.286 2.94 4.12 4.12 0 01-1.233 2.96L8.78 12.212c-.245.235-.536.42-.855.548a2.74 2.74 0 01-2.018 0 2.7 2.7 0 01-.855-.548 2.5 2.5 0 01-.571-.82 2.44 2.44 0 010-1.933 2.5 2.5 0 01.572-.819l4.969-4.761z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M.5.318h16v16H.5z"/></clipPath></defs></g>', width: 17, height: 17 }, "plan-empty-link": { body: '<path fill="currentColor" d="M.71 1.542a1 1 0 111.926-.536zm49.062 16.9a1 1 0 11-1.966.37zm-7.162-1.598a1 1 0 011.08-1.684zm8.78-3.515a1 1 0 111.975-.32zM1.674 1.274l.963-.268.007.024.026.087q.035.119.11.35a25.3 25.3 0 002.44 5.25c1.826 2.953 4.558 5.797 8.38 6.238l-.229 1.986c-4.739-.545-7.913-4.038-9.853-7.174A27.3 27.3 0 01.754 1.694L.71 1.547v-.004zM13.6 12.954c3.924.452 6.513-1.089 9.755-2.783 3.25-1.7 6.974-3.419 12.827-2.667l-.255 1.984c-5.249-.674-8.528.826-11.646 2.455-3.127 1.635-6.272 3.533-10.91 2.999zm22.582-5.45c5.832.75 9.25 3.433 11.198 5.986a14 14 0 011.913 3.391c.177.455.295.833.37 1.103a8 8 0 01.107.443l.002.01v.004l-.982.186-.983.186v.002q.002 0 0 0v-.01l-.013-.053a6 6 0 00-.06-.236 10 10 0 00-.305-.908c-.3-.77-.808-1.816-1.64-2.905-1.644-2.156-4.594-4.538-9.862-5.215zm6.969 8.498.54-.842.003.002.01.006.038.025.149.095a333 333 0 002.234 1.412c1.312.82 2.633 1.625 3.014 1.8l-.84 1.816c-.526-.244-1.99-1.142-3.234-1.92a281 281 0 01-2.25-1.422l-.15-.096-.04-.025-.01-.007-.003-.002zm5.988 2.499c-.437-.203-.728.086-.602-.01a2.3 2.3 0 00.359-.395c.345-.45.754-1.124 1.151-1.87a25 25 0 001.009-2.12 9 9 0 00.278-.752q.042-.14.049-.185c.011-.06-.014.021.009.16l1.974-.32c.036.223.001.43-.018.531-.024.13-.061.267-.102.4-.082.268-.201.587-.341.926-.28.683-.671 1.511-1.093 2.302-.418.783-.887 1.57-1.33 2.146-.216.281-.466.566-.737.771-.203.154-.782.538-1.446.23z"/>', width: 54, height: 21 }, plans: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.363 11.344a.64.64 0 01-.694.037.63.63 0 01-.356-.6V7.22a.63.63 0 01.356-.6.64.64 0 01.694.037l2.775 1.763q.168.112.235.262a.8.8 0 01.065.319.8.8 0 01-.065.319.6.6 0 01-.235.262zm-.769 4.65q-.693-.15-1.34-.413a6.6 6.6 0 01-1.228-.656.46.46 0 01-.244-.384.54.54 0 01.169-.441q.15-.15.366-.169a.58.58 0 01.384.094q.468.3.984.516.516.215 1.078.328.188.056.329.215.14.16.14.366a.55.55 0 01-.188.441.5.5 0 01-.45.103m-3.712-2.982q-.207.207-.45.178a.49.49 0 01-.375-.234 6.4 6.4 0 01-.684-1.228 6.6 6.6 0 01-.404-1.34.5.5 0 01.104-.441.54.54 0 01.44-.197q.188 0 .356.141a.67.67 0 01.225.347q.131.562.338 1.068.206.507.506.975.112.17.094.385a.54.54 0 01-.15.346M2.532 8.25a.56.56 0 01-.45-.196.48.48 0 01-.113-.441q.15-.732.404-1.35.252-.62.665-1.22a.55.55 0 01.394-.234q.243-.027.45.179a.54.54 0 01.15.346.58.58 0 01-.094.385 5.7 5.7 0 00-.844 2.044.7.7 0 01-.216.346.5.5 0 01-.346.141m7.819 7.725a.49.49 0 01-.44-.094.51.51 0 01-.18-.412q0-.207.132-.375a.63.63 0 01.338-.225 6.13 6.13 0 003.403-2.11q1.34-1.621 1.34-3.759a5.84 5.84 0 00-1.34-3.787 5.9 5.9 0 00-3.403-2.1.54.54 0 01-.338-.207.6.6 0 01-.131-.375q0-.262.187-.422a.47.47 0 01.432-.103q2.492.507 4.106 2.457Q16.069 6.413 16.069 9q0 2.57-1.621 4.509a7.12 7.12 0 01-4.097 2.466M5.663 4.013a.55.55 0 01-.394.075.62.62 0 01-.337-.17.6.6 0 01-.169-.459.46.46 0 01.244-.384q.6-.393 1.247-.656a8 8 0 011.34-.413.47.47 0 01.432.103.53.53 0 01.187.422.57.57 0 01-.14.375.58.58 0 01-.347.207q-.525.112-1.05.346-.525.235-1.013.554"/></g>', width: 18, height: 18 }, "plans-billing": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.5 16.128a1.8 1.8 0 01-1.33-.544 1.8 1.8 0 01-.544-1.331v-1.2q0-.282.197-.479a.65.65 0 01.478-.196h1.575V2.553q0-.187.16-.244.158-.056.308.094l.563.562.825-.787a.3.3 0 01.234-.113q.14 0 .235.113l.825.787.806-.787a.34.34 0 01.244-.113.34.34 0 01.243.113l.807.787.806-.787a.35.35 0 01.253-.113q.141 0 .234.113l.807.787.825-.787a.3.3 0 01.235-.113q.14 0 .234.113l.825.787.562-.562q.15-.15.31-.094.159.057.159.244v11.7q0 .788-.544 1.331a1.8 1.8 0 01-1.331.544zm9-1.125q.32 0 .535-.216a.72.72 0 00.216-.534v-10.5H6v8.625h6.075q.281 0 .478.196a.65.65 0 01.197.479v1.2q0 .318.216.534a.72.72 0 00.534.216M7.445 6.565a.52.52 0 01-.393-.16.56.56 0 01-.15-.402.544.544 0 01.562-.563h3.132q.224 0 .393.16a.53.53 0 01.169.403.53.53 0 01-.169.403.56.56 0 01-.393.16zm0 2.25a.52.52 0 01-.393-.16.56.56 0 01-.15-.402.547.547 0 01.562-.563h3.132q.224 0 .393.16a.53.53 0 01.169.403.53.53 0 01-.169.403.56.56 0 01-.393.16zm5.27-2.156a.67.67 0 01-.48-.187.62.62 0 01-.196-.47q0-.28.197-.468a.67.67 0 01.478-.187q.262 0 .46.187a.62.62 0 01.197.469.62.62 0 01-.198.469.64.64 0 01-.459.187m0 2.25a.67.67 0 01-.48-.187.62.62 0 01-.196-.47q0-.28.197-.468a.67.67 0 01.478-.187q.262 0 .46.187a.62.62 0 01.197.469.62.62 0 01-.198.469.64.64 0 01-.459.187M4.5 15.003h7.125v-1.5H3.75v.75q0 .318.215.534a.73.73 0 00.535.216"/></g>', width: 18, height: 18 }, "play-arrow": { body: '<g fill="none"><mask id="svgID0" width="17" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.286 0h16v16h-16z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6.1 12.436a.65.65 0 01-.73.026.69.69 0 01-.37-.642V4.74a.69.69 0 01.37-.641.65.65 0 01.73.026l5.572 3.547A.69.69 0 0112 8.28q0 .393-.328.609z"/></g></g>', width: 17 }, "play-circle": { body: '<path fill="currentColor" d="M6.196 9.244 9.1 7.378a.43.43 0 00.214-.377.43.43 0 00-.214-.38L6.196 4.757a.41.41 0 00-.46-.024.43.43 0 00-.236.403v3.73q0 .274.236.403a.41.41 0 00.46-.024m.805 4.09a6.2 6.2 0 01-2.47-.5 6.4 6.4 0 01-2.011-1.353 6.4 6.4 0 01-1.354-2.01A6.2 6.2 0 01.667 7q0-1.315.499-2.47a6.4 6.4 0 011.353-2.01 6.4 6.4 0 012.01-1.354A6.2 6.2 0 017 .666q1.315 0 2.47.5 1.157.498 2.012 1.353t1.354 2.01q.499 1.156.499 2.47t-.499 2.47a6.4 6.4 0 01-1.354 2.011 6.4 6.4 0 01-2.01 1.354 6.2 6.2 0 01-2.47.5m0-1q2.233 0 3.783-1.55T12.334 7t-1.55-3.783T7 1.667t-3.783 1.55T1.667 7t1.55 3.783T7 12.333"/>', width: 14, height: 14 }, "play-filled": { body: '<mask id="svgID0" width="29" height="28" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.714 0h28v28h-28z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.3 11v6q0 .694.6 1.027.6.33 1.17-.08l4.704-3q.537-.315.537-.947t-.537-.947l-4.705-3q-.568-.41-1.168-.08-.6.332-.6 1.027m2.843 15q-2.495 0-4.689-.947a12.1 12.1 0 01-3.806-2.558 12.1 12.1 0 01-2.558-3.806Q3.143 16.494 3.143 14t.947-4.69a12.1 12.1 0 012.558-3.805 12.1 12.1 0 013.806-2.558Q12.648 2 15.143 2t4.69.947a12.1 12.1 0 013.805 2.558 12.1 12.1 0 012.557 3.805q.948 2.195.948 4.69t-.948 4.689a12.1 12.1 0 01-2.557 3.806 12.1 12.1 0 01-3.805 2.558q-2.196.947-4.69.947"/></g>', width: 29, height: 28 }, "play-plain": { body: '<mask id="svgID0" width="58" height="58" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h58v58H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M19.334 41.505V16.493q0-1.028.724-1.722.726-.695 1.692-.695.303 0 .634.09.332.091.635.273l19.696 12.506q.543.363.815.906.272.544.272 1.148 0 .605-.272 1.148a2.34 2.34 0 01-.815.906L23.019 43.56a2.5 2.5 0 01-1.269.363q-.966 0-1.692-.695-.724-.695-.724-1.722"/></g>', width: 58, height: 58 }, "play-shapes": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.948 8.034a.64.64 0 01-.587-.333.63.63 0 01-.004-.672l2.316-4.11a.63.63 0 01.591-.338q.4 0 .592.339l2.316 4.109a.63.63 0 01-.004.672.64.64 0 01-.587.333zm2.324 7.536a2.72 2.72 0 01-1.997-.824 2.72 2.72 0 01-.823-1.993q0-1.187.823-2.005a2.73 2.73 0 011.997-.817q1.172 0 1.996.823.823.825.823 1.996 0 1.173-.823 1.996a2.72 2.72 0 01-1.996.824m0-1.125q.705 0 1.2-.495.494-.495.494-1.2t-.494-1.2-1.2-.494-1.2.494-.495 1.2.495 1.2q.495.495 1.2.495M3.71 6.91h3.114l-1.56-2.733zm6.912 8.661a.66.66 0 01-.483-.195.66.66 0 01-.195-.483V10.61q0-.29.194-.483.195-.195.484-.195h4.283q.288 0 .483.195.195.194.195.482v4.284a.66.66 0 01-.195.483.66.66 0 01-.483.195zm.447-1.125h3.39v-3.39h-3.39zm.911-9.498-1.648-1.64a.53.53 0 01-.156-.391.533.533 0 01.55-.549q.24 0 .396.156l1.641 1.641 1.642-1.641a.53.53 0 01.394-.156.536.536 0 01.552.549.52.52 0 01-.156.39l-1.649 1.641 1.649 1.649a.52.52 0 01.156.39.533.533 0 01-.55.549.54.54 0 01-.396-.156l-1.642-1.641-1.641 1.641a.53.53 0 01-.395.156.536.536 0 01-.551-.549q0-.237.156-.39z"/></g>', width: 18, height: 18 }, power: { body: '<mask id="svgID0" width="17" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h16v16H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.09 12.667h.82v-1.31L11.167 9.1V6.205a.2.2 0 00-.065-.14.2.2 0 00-.14-.065H6.037a.2.2 0 00-.14.064.2.2 0 00-.065.141V9.1l2.257 2.257zm-1-.885L5.185 9.877a1.2 1.2 0 01-.352-.85v-2.82q0-.498.354-.852A1.16 1.16 0 016.038 5h.744l-.5.5V2.834q0-.212.144-.357a.48.48 0 01.356-.143q.213 0 .356.143a.48.48 0 01.144.357V5h2.436V2.834q0-.212.144-.357a.48.48 0 01.356-.143q.212 0 .356.143a.48.48 0 01.144.357V5.5l-.5-.5h.743q.498 0 .851.355.355.354.355.852v2.82q0 .24-.094.464a1.2 1.2 0 01-.258.386L9.91 11.782v1.282q0 .256-.173.43a.58.58 0 01-.43.173H7.693a.58.58 0 01-.43-.174.58.58 0 01-.172-.429z"/></g>', width: 17 }, preference: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m6 11.36 1.946-1.5 1.946 1.5-.73-2.474 1.825-1.297h-2.27l-.77-2.514-.77 2.514H4.905L6.73 8.886zm1.946.02L5.21 13.466a.5.5 0 01-.365.132.64.64 0 01-.344-.112.6.6 0 01-.244-.293.57.57 0 01-.02-.396l1.054-3.425-2.635-1.885a.53.53 0 01-.233-.314.64.64 0 01.223-.68.58.58 0 01.375-.121h3.284l1.054-3.527a.74.74 0 01.243-.324.56.56 0 01.344-.122q.183 0 .345.122.163.12.243.324l1.054 3.527h3.284q.224 0 .375.121a.64.64 0 01.223.68.53.53 0 01-.233.314l-2.635 1.885 1.054 3.425a.57.57 0 01-.02.396.62.62 0 01-.244.293.64.64 0 01-.344.112.5.5 0 01-.365-.132z"/></g>' }, prescriptions: { body: '<path fill="currentColor" d="m9.44 12.946.883-.888-1.342-1.343-.889.883a.925.925 0 000 1.348.925.925 0 001.349 0m1.58-1.585.888-.882a.9.9 0 00.287-.674.94.94 0 00-.294-.674.94.94 0 00-.67-.288.9.9 0 00-.672.288l-.882.888zm-.873 2.298a1.88 1.88 0 01-1.384.575 1.9 1.9 0 01-1.384-.575 1.9 1.9 0 01-.575-1.384q-.003-.806.575-1.384l2.473-2.473a1.9 1.9 0 011.384-.572q.813 0 1.384.572.579.578.579 1.384t-.579 1.384zm-8.609-.992q-.498 0-.852-.354a1.16 1.16 0 01-.353-.852V2.54q0-.5.353-.852.354-.354.852-.354h2.967Q4.568.778 4.99.39 5.41 0 6 0q.594 0 1.017.39.42.388.478.943h2.966q.5 0 .852.354.354.353.354.851v3.77a2.2 2.2 0 00-.5-.045 4 4 0 00-.5.043V2.54a.2.2 0 00-.058-.148.2.2 0 00-.148-.058H1.538a.2.2 0 00-.147.058.2.2 0 00-.058.147v8.923q0 .09.058.148a.2.2 0 00.147.058h3.736a3.4 3.4 0 00-.05.5q-.006.25.045.5zM6 1.897a.486.486 0 00.5-.5.486.486 0 00-.5-.5.486.486 0 00-.5.5.486.486 0 00.5.5M2.833 4.91v-1h6.334v1zm0 2.59v-1h6.334v.42a2 2 0 00-.217.165q-.102.09-.217.204l-.211.211zm0 2.59v-1h4.099l-.503.502a8 8 0 00-.238.249 4 4 0 00-.208.249z"/>', width: 14, height: 15 }, "progress-activity": { body: '<g fill="none"><mask id="svgID0" width="25" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.667 0h24v24h-24z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M12.664 21.5q-1.95 0-3.683-.747a9.6 9.6 0 01-3.026-2.041 9.6 9.6 0 01-2.04-3.026 9.2 9.2 0 01-.748-3.683q0-1.975.749-3.7a9.7 9.7 0 012.04-3.015A9.6 9.6 0 018.981 3.25a9.2 9.2 0 013.685-.749q.319 0 .534.216a.73.73 0 01.216.534q0 .32-.216.535a.73.73 0 01-.534.215Q9.342 4 7.004 6.337T4.667 12t2.337 5.663T12.667 20t5.663-2.337T20.667 12q0-.319.216-.534a.73.73 0 01.534-.216q.32 0 .534.216a.73.73 0 01.216.534 9.2 9.2 0 01-.75 3.685 9.6 9.6 0 01-2.039 3.027 9.7 9.7 0 01-3.015 2.039q-1.725.75-3.7.749"/></g></g>', width: 25, height: 24 }, "project-case": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#DAF2E8" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.583 17.083q-.625 0-1.062-.437a1.45 1.45 0 01-.438-1.063V6.917q0-.625.438-1.063a1.45 1.45 0 011.062-.437h3.5V4q0-.625.438-1.062A1.45 1.45 0 018.583 2.5h2.833q.625 0 1.063.438.438.436.437 1.062v1.417h3.5q.625 0 1.063.437.437.438.437 1.063v8.666q0 .625-.437 1.063a1.45 1.45 0 01-1.063.437zm0-1.25h12.833q.084 0 .167-.083.084-.083.083-.167V6.917q0-.083-.083-.167t-.167-.083H3.583q-.084 0-.167.083t-.083.167v8.666q0 .083.083.167.084.084.167.083m4.75-10.416h3.333V4q0-.083-.083-.167-.083-.083-.167-.083H8.583q-.083 0-.167.083-.083.083-.083.167z"/></g>', width: 20, height: 20 }, "project-details": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.975 15.375q-.563 0-.956-.394a1.3 1.3 0 01-.394-.956V3.975q0-.563.394-.956.393-.394.956-.394h10.05q.563 0 .956.394.394.393.394.956v10.05q0 .563-.394.956a1.3 1.3 0 01-.956.394zm0-1.125h10.05q.075 0 .15-.075t.075-.15V3.975q0-.075-.075-.15t-.15-.075H3.975q-.075 0-.15.075t-.075.15v10.05q0 .075.075.15t.15.075m2.062-1.669a.65.65 0 00.479-.197.65.65 0 00.197-.478.62.62 0 00-.197-.469.67.67 0 00-.479-.187.64.64 0 00-.468.188.64.64 0 00-.188.468q0 .282.188.478a.62.62 0 00.468.197m0-2.925a.67.67 0 00.479-.187A.62.62 0 006.713 9a.62.62 0 00-.197-.469.67.67 0 00-.479-.187.64.64 0 00-.468.187A.64.64 0 005.38 9q0 .282.188.469a.64.64 0 00.468.187m0-2.906a.67.67 0 00.479-.187.62.62 0 00.197-.47.65.65 0 00-.197-.478.65.65 0 00-.479-.196.62.62 0 00-.468.196.67.67 0 00-.188.479q0 .28.188.468a.64.64 0 00.468.188m2.85 5.719h3.15q.226 0 .394-.16a.53.53 0 00.169-.403.54.54 0 00-.169-.394.54.54 0 00-.393-.168h-3.15a.53.53 0 00-.404.168.56.56 0 00-.159.394q0 .244.159.404.16.159.403.159m0-2.906h3.15q.226 0 .394-.16A.53.53 0 0012.6 9a.53.53 0 00-.169-.403.56.56 0 00-.393-.16h-3.15a.55.55 0 00-.404.16.55.55 0 00-.159.403.546.546 0 00.563.563m0-2.907h3.15a.54.54 0 00.394-.168.54.54 0 00.169-.394.53.53 0 00-.169-.403.56.56 0 00-.393-.16h-3.15a.547.547 0 00-.563.563q0 .225.159.393a.53.53 0 00.403.17"/></g>', width: 18, height: 18 }, "project-members": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.125 9.938A2.35 2.35 0 015.4 9.225 2.35 2.35 0 014.687 7.5q0-1.012.713-1.725a2.35 2.35 0 011.725-.713q1.012 0 1.725.713A2.35 2.35 0 019.563 7.5a2.35 2.35 0 01-.713 1.725 2.35 2.35 0 01-1.725.713m0-1.126q.543 0 .928-.383.384-.386.384-.929t-.383-.928a1.27 1.27 0 00-.929-.385q-.543 0-.928.385a1.27 1.27 0 00-.385.928q0 .543.385.928.385.384.928.384m5.25 2.026q-.768 0-1.303-.535A1.77 1.77 0 0110.538 9q0-.768.534-1.303t1.303-.535 1.303.535q.534.534.534 1.303t-.534 1.303a1.77 1.77 0 01-1.303.534m-4.462 4.05q.843-1.575 2.175-2.138t2.287-.562q.412 0 .787.065.375.066.75.16a6.5 6.5 0 00.778-1.547Q15 9.994 15 9q0-2.513-1.744-4.256T9 3 4.744 4.744Q3 6.487 3 9q0 .9.253 1.715t.703 1.51a7.3 7.3 0 011.538-.572 6.6 6.6 0 011.631-.216 5.4 5.4 0 01.947.085q.479.084.872.197a5 5 0 00-.638.422q-.3.234-.543.478a3 3 0 00-.338-.047q-.15-.01-.3-.01-.619 0-1.275.16a5.6 5.6 0 00-1.181.422q.656.693 1.481 1.134t1.762.61M9 16.124a6.95 6.95 0 01-2.784-.562 7.2 7.2 0 01-2.26-1.52 7.2 7.2 0 01-1.518-2.259A6.95 6.95 0 011.875 9q0-1.482.563-2.785a7.2 7.2 0 011.518-2.259 7.2 7.2 0 012.26-1.518A6.95 6.95 0 019 1.875q1.482 0 2.785.563a7.2 7.2 0 012.259 1.518 7.2 7.2 0 011.518 2.26q.563 1.302.563 2.784t-.562 2.784a7.2 7.2 0 01-1.52 2.26 7.2 7.2 0 01-2.258 1.518A6.95 6.95 0 019 16.125"/></g>', width: 18, height: 18 }, "question-mark": { body: '<g fill="currentColor"><path stroke="currentColor" d="M36.698 10.778c.535 1.795.802 3.488.802 5.09 0 1.614-.242 3.084-.715 4.419a18.5 18.5 0 01-1.824 3.773 23.3 23.3 0 01-2.562 3.311 142 142 0 01-2.864 3.015q-1.05 1.072-2.187 2.279a21 21 0 00-2.097 2.596 16 16 0 00-1.577 2.897 8.2 8.2 0 00-.648 3.174v1.07q0 .393.026.745H12.259l-.889-.6h1.069l-.033-.531q-.012-.194-.02-.39v-.002a45 45 0 01-.042-1.895q0-2.43.588-4.349a17.2 17.2 0 011.567-3.634v-.001a20.6 20.6 0 012.256-3.175zm0 0-.005-.017Q35.9 8.118 33.88 5.878zM4.676 14.004l.842-.682.277-.225-.122-.335-2.815-7.728c2.144-1.346 4.655-2.397 7.542-3.15Q14.962.7 19.344.702c3.677 0 6.67.5 9.002 1.474 2.361.988 4.2 2.225 5.535 3.703zm0 0 1.187.348q3.324-1.724 6.104-2.526 2.862-.82 6.067-.82c2.169 0 3.892.523 5.093 1.649 1.173 1.103 1.77 2.447 1.77 4.016 0 1.84-.595 3.479-1.769 4.903v.001a66 66 0 01-3.692 4.083l-.358-.35.358.35q-1.383 1.411-2.68 2.912z"/><path d="M15.598 10.942q-3.105 0-5.86.774-2.76.778-6.117 2.499L0 4.479q3.36-2.152 7.93-3.318Q12.493 0 16.89 0q5.512 0 9.088 1.464t5.646 3.705Q33.69 7.41 34.51 10.08c.544 1.781.82 3.476.82 5.083q-.002 2.412-.736 4.437a18.2 18.2 0 01-1.85 3.75 23 23 0 01-2.587 3.273 140 140 0 01-2.841 2.928q-1.035 1.034-2.154 2.2a20 20 0 00-2.025 2.453 15 15 0 00-1.51 2.715 7.35 7.35 0 00-.602 2.887v1.035q0 .688.087 1.206H9.738a12 12 0 01-.216-1.938 43 43 0 01-.042-1.854q0-2.412.603-4.35a17 17 0 011.593-3.619 20.4 20.4 0 012.283-3.147 62 62 0 012.67-2.841 64 64 0 003.622-3.921q1.634-1.939 1.635-4.437 0-2.069-1.593-3.534-1.594-1.465-4.695-1.465"/><path stroke="currentColor" d="M22.065 59.242c-1.257 1.059-2.662 1.578-4.236 1.578s-2.98-.52-4.237-1.578c-1.207-1.017-1.835-2.466-1.835-4.423s.628-3.404 1.836-4.423c1.918-1.619 4.762-1.977 7-.845 1.99 1.006 3.308 3.046 3.308 5.268 0 1.957-.627 3.406-1.836 4.423Z"/><path d="M22.15 54.82q0 3.11-2.015 4.804-2.015 1.697-4.557 1.696-2.543.001-4.56-1.696-2.011-1.693-2.012-4.805 0-3.11 2.013-4.805 2.013-1.696 4.559-1.696c1.698 0 3.214.566 4.557 1.696q2.015 1.696 2.015 4.805"/></g>', width: 38, height: 62 }, "question-mark-light": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.724 4.676q0-.722-.483-1.16-.483-.44-1.275-.439-.5 0-.889.205a1.9 1.9 0 00-.669.617.64.64 0 01-.444.277.58.58 0 01-.485-.136.5.5 0 01-.175-.335.58.58 0 01.093-.382 3 3 0 011.1-1.022q.654-.35 1.47-.35 1.301 0 2.12.746.817.746.817 1.943 0 .634-.271 1.162-.272.528-.926 1.136-.612.555-.835.9-.225.347-.26.779a.7.7 0 01-.206.415.57.57 0 01-.41.166.57.57 0 01-.411-.164.54.54 0 01-.17-.405q0-.585.267-1.07t.896-1.044q.67-.589.908-.983t.238-.856m-1.758 7.865a.84.84 0 01-.616-.259.84.84 0 01-.259-.616q0-.358.259-.617a.84.84 0 01.616-.258q.358 0 .617.258a.84.84 0 01.258.617.84.84 0 01-.258.616.84.84 0 01-.617.259"/></g>', width: 14, height: 14 }, "queue-circle-fill": { body: '<mask id="svgID0" width="25" height="25" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.436.844h24v24h-24z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.436 14.344q.624 0 1.063-.437.437-.438.437-1.063t-.437-1.062a1.45 1.45 0 00-1.063-.438q-.625 0-1.062.438a1.45 1.45 0 00-.438 1.062q0 .624.438 1.063.436.437 1.062.437m5 0q.624 0 1.063-.437.437-.438.437-1.063t-.437-1.062a1.45 1.45 0 00-1.063-.438q-.625 0-1.062.438a1.45 1.45 0 00-.438 1.062q0 .624.438 1.063.436.437 1.062.437m5 0q.625 0 1.063-.437.437-.438.437-1.063t-.437-1.062a1.45 1.45 0 00-1.063-.438q-.625 0-1.062.438a1.45 1.45 0 00-.438 1.062q0 .624.438 1.063.436.437 1.062.437m-5 8.5a9.7 9.7 0 01-3.9-.787 10.1 10.1 0 01-3.175-2.138q-1.35-1.35-2.137-3.175a9.7 9.7 0 01-.788-3.9q0-2.075.788-3.9A10.1 10.1 0 015.36 5.77q1.35-1.35 3.175-2.137a9.7 9.7 0 013.9-.788q2.074 0 3.9.788A10.1 10.1 0 0119.51 5.77q1.35 1.35 2.137 3.175a9.7 9.7 0 01.788 3.9 9.7 9.7 0 01-.788 3.9 10.1 10.1 0 01-2.137 3.175q-1.35 1.35-3.175 2.138a9.7 9.7 0 01-3.9.787"/></g>', width: 25, height: 25 }, "queue-circle-outline": { body: '<mask id="svgID0" width="13" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M.5 0h12v12H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4 6.75a.72.72 0 00.531-.219A.72.72 0 004.75 6a.72.72 0 00-.219-.531A.72.72 0 004 5.25a.72.72 0 00-.531.219A.72.72 0 003.25 6q0 .312.219.531A.72.72 0 004 6.75m2.5 0a.72.72 0 00.531-.219A.72.72 0 007.25 6a.72.72 0 00-.219-.531.72.72 0 00-.531-.219.72.72 0 00-.531.219A.72.72 0 005.75 6q0 .312.219.531a.72.72 0 00.531.219m2.5 0a.72.72 0 00.531-.219A.72.72 0 009.75 6a.72.72 0 00-.219-.531A.72.72 0 009 5.25a.72.72 0 00-.531.219A.72.72 0 008.25 6q0 .312.219.531A.72.72 0 009 6.75M6.5 11a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069q-.675-.675-1.069-1.587A4.9 4.9 0 011.5 6q0-1.038.394-1.95a5 5 0 011.069-1.587q.675-.675 1.587-1.07A4.9 4.9 0 016.5 1q1.038 0 1.95.393a5 5 0 011.588 1.07q.675.675 1.068 1.587.394.912.394 1.95t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 016.5 11m0-1q1.675 0 2.838-1.162Q10.5 7.675 10.5 6T9.338 3.163 6.5 2 3.663 3.163 2.5 6t1.163 2.838T6.5 10"/></g>', width: 13, height: 12 }, "radio-button-checked": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M12 15.316q1.38 0 2.348-.968A3.2 3.2 0 0015.316 12q0-1.38-.968-2.348A3.2 3.2 0 0012 8.684q-1.38 0-2.348.968A3.2 3.2 0 008.684 12q0 1.38.968 2.348a3.2 3.2 0 002.348.968M12.001 19a6.8 6.8 0 01-2.73-.551 7.1 7.1 0 01-2.223-1.496 7.1 7.1 0 01-1.497-2.222A6.8 6.8 0 015 12q0-1.452.551-2.73a7.1 7.1 0 011.496-2.223q.944-.945 2.222-1.497A6.8 6.8 0 0112 5q1.452 0 2.73.551a7.1 7.1 0 012.223 1.496q.945.944 1.497 2.222.55 1.278.551 2.73 0 1.452-.551 2.73a7.1 7.1 0 01-1.496 2.223q-.944.945-2.222 1.497A6.8 6.8 0 0112 19m0-1.105q2.469 0 4.182-1.713T17.895 12t-1.713-4.182T12 6.105 7.818 7.818 6.105 12t1.713 4.182T12 17.895"/></g></g>', width: 24, height: 24 }, "radio-checked": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 12.375q1.405 0 2.39-.985T12.375 9t-.985-2.39T9 5.625t-2.39.985T5.625 9t.985 2.39 2.39.985m.001 3.75a6.9 6.9 0 01-2.779-.561 7.2 7.2 0 01-2.262-1.523 7.2 7.2 0 01-1.524-2.261A6.9 6.9 0 011.875 9q0-1.477.561-2.779A7.2 7.2 0 013.959 3.96 7.2 7.2 0 016.22 2.436 6.9 6.9 0 019 1.875a6.9 6.9 0 012.778.561 7.2 7.2 0 012.263 1.523 7.2 7.2 0 011.524 2.261q.561 1.3.561 2.779 0 1.477-.561 2.779a7.2 7.2 0 01-1.523 2.262 7.2 7.2 0 01-2.261 1.524A6.9 6.9 0 019 16.125M9 15q2.513 0 4.256-1.744T15 9t-1.744-4.256Q11.513 3 9 3T4.744 4.744 3 9t1.744 4.256Q6.487 15 9 15"/></g>', width: 18, height: 18 }, "re-fetch-context": { body: '<path fill="currentColor" d="M102.268 36.13q28.24-9.63 55.971-3.88 27.733 5.763 49.855 24.809l-8.208-24.066q-1.088-3.193.28-5.995 1.383-2.796 4.575-3.885t5.995.28q2.796 1.383 3.884 4.575l13.568 39.782q1.257 3.684-.436 7.145-1.706 3.455-5.389 4.71L182.826 93.09q-3.192 1.089-6.038-.408-2.837-1.5-3.842-4.447-1.089-3.192.284-5.985 1.379-2.806 4.571-3.894l22.101-7.538q-18.744-17.183-43.27-22.8-24.536-5.611-49.339 2.847-27.503 9.38-44.294 32.103-16.781 22.72-18.559 50.465-.06 3.036-2.137 4.983-2.08 1.938-4.789 2.039-3.773.19-6.378-2.627-2.602-2.807-2.218-6.503 2.157-32.26 21.662-58.245 19.518-25.977 51.688-36.95m120.059 156.705q2.964 1.457 3.645 5.063.683 3.605-1.512 6.82-6.746 9.154-15.101 16.39-8.366 7.239-18.255 12.805-3.024 1.58-6.141.866-3.13-.72-4.625-3.499-1.827-2.942-1.072-5.941.764-3.001 3.95-4.909a97.5 97.5 0 0015.805-11.147q7.295-6.326 13.31-14.409 1.707-2.227 4.611-2.943 2.911-.72 5.385.904m-119.264 40.949q.967-2.796 3.618-4.249 2.66-1.456 5.702-.573 9.043 2.398 19.183 3.194 10.137.787 19.481-.755 3.443-.352 6.083 1.762 2.64 2.115 2.664 5.398.267 3.197-1.804 5.549-2.08 2.353-5.195 2.868-11.23 1.636-22.186.856a118 118 0 01-21.813-3.669q-3.616-.96-5.236-4.103-1.623-3.152-.497-6.278m-57.628-51.62q2.694-1.742 5.816-1.019 3.125.71 4.95 3.652 4.986 8.99 11.433 16.256a89 89 0 0014.452 13.02q2.557 1.87 3.07 4.984.515 3.115-1.355 5.671-1.784 2.803-5.112 3.114-3.315.309-6.202-1.723-9.153-6.746-16.477-14.94-7.314-8.197-13.208-18.249-1.826-2.94-.944-5.983.881-3.041 3.577-4.783"/>', width: 276, height: 276 }, "re-run": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M16 0v16H0V0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M1.6 8.058q0-1.769.853-3.214a6.5 6.5 0 012.345-2.321H3.291a.45.45 0 01-.33-.13.45.45 0 01-.13-.332.45.45 0 01.13-.33.45.45 0 01.33-.131h2.491q.231 0 .393.161a.54.54 0 01.16.393v2.475a.44.44 0 01-.138.33.46.46 0 01-.323.131.45.45 0 01-.46-.461V3.245a5.6 5.6 0 00-2.107 1.991 5.26 5.26 0 00-.784 2.822q0 1.722.953 3.098a5.53 5.53 0 002.475 2.006.4.4 0 01.239.215.43.43 0 01.023.308.46.46 0 01-.27.308.47.47 0 01-.407 0 6.34 6.34 0 01-2.852-2.33Q1.6 10.073 1.6 8.059m7.104-5.981q.046-.184.207-.292a.45.45 0 01.361-.062q.677.123 1.254.369a7 7 0 011.145.63.54.54 0 01.215.316.42.42 0 01-.077.36.48.48 0 01-.284.178.4.4 0 01-.33-.07 6 6 0 00-1-.545 5.8 5.8 0 00-1.138-.346.433.433 0 01-.354-.538m3.982 2.244a.4.4 0 01.353-.107q.216.03.354.215.384.555.63 1.16.246.609.37 1.27a.52.52 0 01-.07.36.4.4 0 01-.284.193.44.44 0 01-.354-.054.48.48 0 01-.2-.315 6 6 0 00-.323-1.1 5.4 5.4 0 00-.553-1.022.48.48 0 01-.077-.315.4.4 0 01.154-.285m.015 7.473a.44.44 0 01-.169-.284.43.43 0 01.077-.331q.308-.462.546-1.015t.33-1.107a.48.48 0 01.216-.307.4.4 0 01.353-.047q.184.046.277.208a.5.5 0 01.061.346 6 6 0 01-.376 1.26q-.255.6-.623 1.154a.47.47 0 01-.33.215.45.45 0 01-.362-.092M8.703 14.04a.455.455 0 01.354-.553q.599-.11 1.13-.331a5.3 5.3 0 001.006-.562.44.44 0 01.339-.076.43.43 0 01.292.184.38.38 0 01.077.346.54.54 0 01-.216.315 6.4 6.4 0 01-2.429 1.03.42.42 0 01-.354-.061.5.5 0 01-.2-.292M7.21 10.545a.36.36 0 01-.417.01.4.4 0 01-.211-.365V6.122q0-.24.211-.366.212-.126.417.011l3.2 2.035q.194.126.194.354t-.194.354z"/></g>' }, "real-mobile": { body: '<mask id="svgID0" width="100" height="100" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h100v100H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M30.417 93.75q-3.126 0-5.313-2.187-2.187-2.189-2.187-5.313v-72.5q0-3.125 2.187-5.312 2.189-2.188 5.313-2.188h39.166q3.126 0 5.313 2.188 2.187 2.187 2.187 5.312v72.5q0 3.125-2.187 5.313-2.189 2.187-5.313 2.187zm-1.25-17.708h41.666V23.958H29.167z"/></g>', width: 100, height: 100 }, "record-live-editor": { body: '<g fill="none"><g filter="url(#svgID1)"><path fill="currentColor" d="M3 5a5 5 0 015-5h6a5 5 0 015 5v6a5 5 0 01-5 5H8a5 5 0 01-5-5z"/><mask id="svgID0" width="14" height="14" x="4" y="1" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M4 1h14v14H4z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M11 12q-1.672 0-2.836-1.164Q7 9.67 7 8t1.164-2.836Q9.328 4 11 4t2.836 1.164T15 8t-1.164 2.836T11 12"/></g></g><defs><filter id="svgID1" width="22" height="23" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy="1"/><feGaussianBlur stdDeviation=".5"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3554_16213"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feMorphology in="SourceAlpha" radius="1" result="effect2_dropShadow_3554_16213"/><feOffset dy="4"/><feGaussianBlur stdDeviation="2"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"/><feBlend in2="effect1_dropShadow_3554_16213" result="effect2_dropShadow_3554_16213"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_3554_16213" result="shape"/></filter></defs></g>', width: 22, height: 22 }, "recorder-enter": { body: '<path fill="currentColor" d="M2.716 7.713.185 5.182l2.53-2.531zM1.94 5.642v-.92h7.662v.92zm6.767 0V.272h.92v5.37zm-2.48-4.449v-.92h3.375v.92z"/>', width: 10, height: 8 }, redeem: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3 12.6v1.425q0 .094.066.16a.22.22 0 00.159.065h11.55a.22.22 0 00.16-.065.22.22 0 00.065-.16V12.6zm.225 2.775q-.563 0-.956-.394a1.3 1.3 0 01-.394-.956V6.244q0-.563.394-.956.393-.394.956-.394h2.081a1.5 1.5 0 01-.14-.356 1.6 1.6 0 01-.047-.394q0-.788.543-1.331a1.8 1.8 0 011.332-.544q.468 0 .872.244.402.243.703.6l.412.562.431-.562q.282-.376.685-.61t.872-.234q.788 0 1.331.544.544.544.544 1.33 0 .207-.038.395a1 1 0 01-.15.356h2.119q.563 0 .956.394.394.392.394.956v7.781q0 .563-.394.956a1.3 1.3 0 01-.956.394zM3 10.65h12V6.244a.22.22 0 00-.065-.16.22.22 0 00-.16-.065h-4.106l1.218 1.669a.4.4 0 01.075.375.9.9 0 01-.206.375.54.54 0 01-.412.093.52.52 0 01-.356-.225l-2.007-2.7-2.006 2.719a.53.53 0 01-.375.234.43.43 0 01-.375-.121.53.53 0 01-.234-.375.5.5 0 01.103-.394l1.181-1.65h-4.05a.22.22 0 00-.159.065.22.22 0 00-.066.16zm3.994-5.756q.318 0 .535-.216a.73.73 0 00.215-.534.73.73 0 00-.215-.535.73.73 0 00-.535-.215.73.73 0 00-.534.215.73.73 0 00-.216.535q0 .318.216.534a.72.72 0 00.534.216m3.975 0q.318 0 .535-.216a.73.73 0 00.215-.534.73.73 0 00-.215-.535.73.73 0 00-.535-.215.73.73 0 00-.534.215.73.73 0 00-.216.535q0 .318.216.534a.72.72 0 00.534.216"/></g>', width: 18, height: 18 }, redo: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M14.292 14.292v-2.709a.607.607 0 01.625-.625q.27 0 .448.177.177.177.177.428v3.229a.72.72 0 01-.219.53.72.72 0 01-.531.22H5.27l1.062 1.062a.64.64 0 01.209.459.67.67 0 01-.188.458.6.6 0 01-.447.187.58.58 0 01-.428-.166l-2.083-2.105a.7.7 0 01-.208-.52q0-.313.208-.521l2.062-2.063a.583.583 0 01.896 0 .6.6 0 01.188.438.6.6 0 01-.188.437L5.27 14.292zM5.708 5.708v2.709a.606.606 0 01-.625.625.61.61 0 01-.625-.604v-3.23q0-.312.22-.531a.72.72 0 01.53-.219h9.521l-1.062-1.062a.64.64 0 01-.209-.458.67.67 0 01.188-.459.6.6 0 01.448-.187q.26 0 .427.166l2.083 2.105a.7.7 0 01.209.52q0 .313-.209.521l-2.062 2.063a.582.582 0 01-.896 0 .6.6 0 01-.188-.438.6.6 0 01.188-.437l1.083-1.084z"/></g>', width: 20, height: 20 }, refresh: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.917 12.188a6.3 6.3 0 01-.375-2.146q0-2.708 1.886-4.604Q7.312 3.542 10 3.542h.646L9.542 2.438A.64.64 0 019.375 2q0-.25.167-.437a.6.6 0 01.448-.188q.26 0 .427.188L12.5 3.646q.126.104.167.239a.95.95 0 010 .563.5.5 0 01-.167.24L10.417 6.77a.55.55 0 01-.427.187.6.6 0 01-.448-.187.64.64 0 01-.167-.438q0-.25.167-.437l1.104-1.104H10q-2.166 0-3.687 1.53-1.521 1.532-1.521 3.72 0 .416.073.843t.219.844q.083.167.041.344a.6.6 0 01-.166.302q-.27.27-.594.218t-.448-.405m5.667 6.25L7.5 16.354a.5.5 0 01-.166-.24.95.95 0 010-.562.5.5 0 01.166-.24l2.084-2.083a.55.55 0 01.427-.187.6.6 0 01.448.187q.165.188.166.438a.64.64 0 01-.166.437l-1.105 1.104H10q2.167 0 3.688-1.53 1.52-1.532 1.52-3.72a5 5 0 00-.291-1.687.5.5 0 01-.042-.344.6.6 0 01.167-.302q.27-.27.594-.22.322.053.448.407a6.3 6.3 0 01.375 2.146q0 2.708-1.885 4.605-1.886 1.895-4.574 1.895h-.646l1.105 1.105q.165.187.166.437a.64.64 0 01-.166.438.6.6 0 01-.448.187.55.55 0 01-.427-.187"/></g>', width: 20, height: 20 }, "rejected-tc": { body: '<g fill="none" stroke="currentColor" stroke-linecap="round" stroke-width="1.33"><path d="M17 10V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h3M7 7h6m-6 3h3"/><path stroke-linejoin="round" d="m17 13-5 5m0-5 5 5"/></g>', width: 20, height: 20 }, reload: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M8.033 13q-2.1 0-3.55-1.45T3.033 8t1.45-3.55T8.033 3q1.167 0 2.209.517a4.6 4.6 0 011.725 1.466V3.5a.47.47 0 01.15-.358.5.5 0 01.35-.142.486.486 0 01.5.5v2.967a.62.62 0 01-.167.442.57.57 0 01-.433.174H9.4a.47.47 0 01-.359-.15.5.5 0 01-.141-.35q0-.216.141-.358a.5.5 0 01.359-.142h2.133a4 4 0 00-1.466-1.524A3.9 3.9 0 008.033 4Q6.368 4 5.2 5.167 4.033 6.333 4.033 8T5.2 10.833 8.033 12a3.96 3.96 0 002.175-.633 3.76 3.76 0 001.459-1.717.46.46 0 01.192-.225.53.53 0 01.291-.092q.283 0 .433.2.15.201.034.45a4.9 4.9 0 01-1.825 2.192A4.9 4.9 0 018.033 13"/></g></g>' }, remove: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4 8.5a.484.484 0 01-.5-.5.486.486 0 01.5-.5h8q.216 0 .359.141A.5.5 0 0112.5 8a.485.485 0 01-.5.5z"/></g>' }, "remove-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.667 10.626h6.667q.265 0 .445-.18t.18-.446a.6.6 0 00-.18-.445.6.6 0 00-.445-.18H6.667a.6.6 0 00-.445.18.6.6 0 00-.18.446q0 .265.18.445t.445.18m3.335 7.291a7.7 7.7 0 01-3.088-.623A8 8 0 014.4 15.602a8 8 0 01-1.692-2.513 7.7 7.7 0 01-.624-3.087q0-1.642.623-3.088A8 8 0 014.4 4.4a8 8 0 012.513-1.692A7.7 7.7 0 0110 2.084q1.642 0 3.088.623 1.445.624 2.514 1.692a8 8 0 011.693 2.513q.623 1.444.623 3.087a7.7 7.7 0 01-.623 3.088 8 8 0 01-1.692 2.514 8 8 0 01-2.513 1.693 7.7 7.7 0 01-3.087.623m-.001-1.25q2.79 0 4.729-1.937 1.937-1.937 1.937-4.73 0-2.79-1.937-4.729Q12.793 3.334 10 3.334q-2.79 0-4.729 1.937-1.937 1.938-1.937 4.73 0 2.79 1.937 4.729 1.938 1.937 4.73 1.937"/></g>', width: 20, height: 20 }, "reopen-window": { body: '<path fill="currentColor" d="M3.95 17.875a1.6 1.6 0 01-1.177-.481 1.6 1.6 0 01-.481-1.176V5.782q0-.694.481-1.176a1.6 1.6 0 011.176-.481h14.103a1.6 1.6 0 011.175.481q.482.481.482 1.176v5.5h-1.375V7.333H3.667v8.885q0 .105.088.194a.27.27 0 00.194.088h6.664v1.375zm13.114 3.385q-1.567 0-2.758-.964a4.38 4.38 0 01-1.548-2.421h1.139q.332 1.018 1.187 1.654.855.638 1.98.638 1.392 0 2.37-.98.98-.979.98-2.37 0-1.39-.98-2.37a3.23 3.23 0 00-2.37-.98q-.752 0-1.422.325a3.8 3.8 0 00-1.167.875h1.532v1.093h-3.385v-3.385h1.093v1.5q.636-.674 1.505-1.088a4.25 4.25 0 011.844-.412q1.84 0 3.142 1.301 1.3 1.3 1.3 3.141t-1.3 3.142-3.142 1.3"/>', width: 22, height: 22 }, reorder: { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 19.225a1.18 1.18 0 01-.863-.362A1.18 1.18 0 017.775 18q0-.5.362-.863A1.18 1.18 0 019 16.775q.499 0 .863.362.362.363.362.863t-.362.863a1.18 1.18 0 01-.863.362m6 0a1.18 1.18 0 01-.863-.362 1.18 1.18 0 01-.362-.863q0-.5.362-.863a1.18 1.18 0 01.863-.362q.499 0 .863.362.362.363.362.863t-.362.863a1.18 1.18 0 01-.863.362m-6-6a1.18 1.18 0 01-.863-.362A1.18 1.18 0 017.775 12q0-.5.362-.863A1.18 1.18 0 019 10.775q.499 0 .863.362.362.363.362.863t-.362.863a1.18 1.18 0 01-.863.362m6 0a1.18 1.18 0 01-.863-.362 1.18 1.18 0 01-.362-.863q0-.5.362-.863a1.18 1.18 0 01.863-.362q.499 0 .863.362.362.363.362.863t-.362.863a1.18 1.18 0 01-.863.362m-6-6q-.5 0-.863-.363A1.18 1.18 0 017.775 6q0-.5.362-.863A1.18 1.18 0 019 4.775q.499 0 .863.362.362.363.362.863t-.362.862T9 7.225m6 0q-.5 0-.863-.363A1.18 1.18 0 0113.775 6q0-.5.362-.863A1.18 1.18 0 0115 4.775q.499 0 .863.362.362.363.362.863t-.362.862-.863.363"/></g>', width: 24, height: 24 }, replay: { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.06 20.495a7.3 7.3 0 01-2.927-.594 7.6 7.6 0 01-2.375-1.604 7.6 7.6 0 01-1.604-2.375 7.3 7.3 0 01-.594-2.927q0-.354.24-.593.24-.24.593-.24.355 0 .594.24.24.24.24.593 0 2.438 1.698 4.136t4.135 1.697 4.135-1.697 1.698-4.136-1.698-4.135-4.135-1.698h-.125l.708.708a.76.76 0 01.24.584.85.85 0 01-.833.844.78.78 0 01-.594-.24L9.31 6.912a.8.8 0 01-.25-.583.8.8 0 01.25-.584L11.456 3.6a.78.78 0 01.594-.24.85.85 0 01.833.845.76.76 0 01-.24.583l-.708.708h.125q1.563 0 2.927.594 1.365.593 2.375 1.604a7.6 7.6 0 011.604 2.375q.594 1.365.594 2.927a7.3 7.3 0 01-.594 2.927 7.6 7.6 0 01-1.604 2.375 7.6 7.6 0 01-2.375 1.604 7.3 7.3 0 01-2.927.594"/></g>', width: 24, height: 24 }, report: { body: '<path fill="currentColor" d="M6.2 17.818a1.82 1.82 0 01-1.275-.525l-3.9-3.9a1.8 1.8 0 01-.387-.587 1.8 1.8 0 01-.138-.688v-5.6q0-.35.138-.688.136-.336.387-.587l3.9-3.9q.25-.25.587-.388Q5.85.818 6.2.818h5.6a1.82 1.82 0 011.275.525l3.9 3.9q.25.25.388.587.137.339.137.688v5.6a1.82 1.82 0 01-.525 1.275l-3.9 3.9a1.82 1.82 0 01-1.275.525zm2.8-3.8a.78.78 0 00.575-.225.78.78 0 00.225-.575.78.78 0 00-.225-.575.78.78 0 00-.575-.225.78.78 0 00-.575.225.78.78 0 00-.225.575q0 .35.225.575t.575.225m0-3.475a.73.73 0 00.75-.75V5.268a.73.73 0 00-.212-.538A.73.73 0 009 4.518a.73.73 0 00-.75.75v4.525a.726.726 0 00.75.75m-2.9 5.775h5.8l4.1-4.1v-5.8l-4.1-4.1H6.1L2 6.418v5.8z"/>', width: 18, height: 18 }, requirement: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.333 11.083h3.333a.5.5 0 00.359-.141.5.5 0 00.141-.359.5.5 0 00-.141-.35.47.47 0 00-.359-.15H5.333a.47.47 0 00-.358.15.5.5 0 00-.142.35.486.486 0 00.5.5m0-2.583h5.333a.486.486 0 00.5-.5.5.5 0 00-.141-.359.5.5 0 00-.359-.141H5.333a.485.485 0 00-.5.5.484.484 0 00.5.5m0-2.583h5.333q.216 0 .359-.15a.5.5 0 00.141-.35.485.485 0 00-.5-.5H5.333a.484.484 0 00-.5.5q0 .2.142.35.14.15.358.15m-1.8 6.75h8.933q.067 0 .133-.067.067-.066.067-.133V3.533q0-.066-.067-.133-.066-.067-.133-.067H3.533q-.068 0-.134.067t-.066.133v8.934q0 .067.066.133.068.066.134.067m0 1q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.533q0-.5.35-.85t.85-.35h2.966q.067-.549.492-.942Q7.417 1.001 8 1q.6 0 1.017.391.417.393.483.942h2.967q.5 0 .85.35t.35.85v8.934q0 .5-.35.85t-.85.35zM7.999 2.9a.486.486 0 00.5-.5.5.5 0 00-.14-.359.5.5 0 00-.36-.141.485.485 0 00-.5.5.484.484 0 00.5.5"/></g>' }, "requirement-types": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.25 9.563h5.25A.547.547 0 0011.063 9a.55.55 0 00-.16-.403.55.55 0 00-.403-.16H5.25A.546.546 0 004.688 9a.544.544 0 00.562.563m0-2.25h5.25a.547.547 0 00.563-.563.55.55 0 00-.16-.404.55.55 0 00-.403-.159H5.25a.546.546 0 00-.562.563.544.544 0 00.562.563m-2.025 7.312q-.563 0-.956-.394a1.3 1.3 0 01-.394-.956v-8.55q0-.563.394-.956.393-.394.956-.394h11.55q.563 0 .956.394.394.393.394.956v8.55q0 .563-.394.956a1.3 1.3 0 01-.956.394zm0-1.125h11.55a.22.22 0 00.16-.065.22.22 0 00.065-.16v-8.55a.22.22 0 00-.065-.159.22.22 0 00-.16-.066H3.225a.22.22 0 00-.159.066.22.22 0 00-.066.159v8.55q0 .094.066.16a.22.22 0 00.159.065"/></g>', width: 18, height: 18 }, "rest-api": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 13.038a.48.48 0 01-.357-.143.48.48 0 01-.143-.357q0-.212.143-.356a.48.48 0 01.357-.144h1.205a.8.8 0 00.59-.243.8.8 0 00.243-.59V9.82q0-.594.35-1.073t.92-.663v-.169a1.8 1.8 0 01-.92-.663 1.77 1.77 0 01-.35-1.073V4.795a.8.8 0 00-.243-.59.8.8 0 00-.59-.244H10a.48.48 0 01-.357-.143.48.48 0 01-.143-.357q0-.212.143-.356A.48.48 0 0110 2.961h1.205q.761 0 1.298.536.535.536.535 1.298v1.384q0 .335.22.572.221.236.55.268.212.012.356.157a.48.48 0 01.143.35v.948a.48.48 0 01-.143.35.53.53 0 01-.357.157.84.84 0 00-.549.268.8.8 0 00-.22.571v1.385q0 .762-.535 1.298-.536.535-1.298.535zm-5.206 0q-.761 0-1.298-.535a1.77 1.77 0 01-.535-1.298V9.82a.8.8 0 00-.22-.57.84.84 0 00-.55-.27.53.53 0 01-.356-.156.48.48 0 01-.143-.35v-.948q0-.207.143-.35a.53.53 0 01.357-.157.84.84 0 00.549-.268.8.8 0 00.22-.572V4.795q0-.763.535-1.298.536-.536 1.298-.536H6q.212 0 .356.144a.48.48 0 01.144.356q0 .213-.144.357A.48.48 0 016 3.96H4.794a.8.8 0 00-.59.243.8.8 0 00-.243.59V6.18q0 .596-.35 1.073-.35.48-.92.663v.17q.57.184.92.662.35.48.35 1.073v1.385q0 .348.243.59a.8.8 0 00.59.243H6q.212 0 .356.144a.48.48 0 01.144.356q0 .213-.144.357a.48.48 0 01-.356.143z"/></g>' }, "restart-alt": { body: '<path fill="currentColor" d="M6.096 12.163a4.5 4.5 0 01-2.69-1.59 4.5 4.5 0 01-1.073-2.975q0-1.036.438-1.954a4.4 4.4 0 011.24-1.56.42.42 0 01.276-.08q.161.006.277.123a.41.41 0 01.132.336.48.48 0 01-.19.335q-.613.51-.955 1.247a3.6 3.6 0 00-.343 1.553q0 1.371.846 2.384a3.8 3.8 0 002.144 1.306q.16.028.27.16.11.131.109.292a.41.41 0 01-.146.328.4.4 0 01-.335.095m1.837 0a.4.4 0 01-.335-.095.41.41 0 01-.146-.328q0-.161.11-.292a.45.45 0 01.27-.16 3.74 3.74 0 002.143-1.306q.831-1.013.831-2.384 0-1.59-1.1-2.69-1.102-1.102-2.691-1.102h-.292l.569.569q.116.117.116.306a.4.4 0 01-.116.307.44.44 0 01-.321.13.39.39 0 01-.306-.13L5.337 3.675a.4.4 0 01-.102-.146.4.4 0 01-.029-.16q0-.088.03-.16a.4.4 0 01.101-.146l1.328-1.328a.4.4 0 01.306-.116q.19 0 .32.116a.47.47 0 01.117.321.4.4 0 01-.116.307l-.57.568h.292q1.955 0 3.31 1.364 1.357 1.364 1.357 3.303 0 1.692-1.064 2.975a4.47 4.47 0 01-2.684 1.59"/>', width: 14, height: 14 }, "restart-execution": { body: '<path fill="currentColor" d="M12.195 3.958V2.524q0-.186.126-.312a.42.42 0 01.311-.126q.187 0 .312.126a.42.42 0 01.126.312v2.355a.5.5 0 01-.151.377.5.5 0 01-.376.15h-2.35a.42.42 0 01-.312-.125.42.42 0 01-.126-.312q0-.186.126-.312a.42.42 0 01.312-.126h1.317a5.33 5.33 0 00-1.92-2.004 5 5 0 00-2.644-.732 5.06 5.06 0 00-2.869.86 5.2 5.2 0 00-1.916 2.283.8.8 0 01-.25.315.44.44 0 01-.373.07.33.33 0 01-.259-.231.57.57 0 01.034-.4 6.06 6.06 0 012.23-2.737A5.9 5.9 0 016.946.92q1.636 0 3.011.797 1.376.799 2.238 2.241m.4 3.67q.184 0 .297.142a.41.41 0 01.078.335 7 7 0 01-.373 1.28q-.24.585-.644 1.174a.42.42 0 01-.29.197.36.36 0 01-.322-.115.46.46 0 01-.15-.336.7.7 0 01.123-.367q.3-.441.47-.882a7 7 0 00.293-.966.66.66 0 01.182-.332.46.46 0 01.335-.13M7.528 12.69q0-.21.129-.34A.64.64 0 018 12.18q.522-.103.953-.288.43-.186.871-.484a.58.58 0 01.359-.112q.182.009.335.162a.36.36 0 01.109.306.44.44 0 01-.176.291 6.6 6.6 0 01-1.155.64q-.576.243-1.278.368a.43.43 0 01-.345-.076.35.35 0 01-.145-.296M3.36 11.452a.48.48 0 01.34-.156.6.6 0 01.363.126q.43.297.87.472.442.173.966.284.207.042.335.177t.129.335a.36.36 0 01-.138.296.4.4 0 01-.329.076 6.2 6.2 0 01-1.288-.364 6.4 6.4 0 01-1.166-.644.43.43 0 01-.188-.29.34.34 0 01.106-.312M1.3 7.627q.21 0 .337.131a.7.7 0 01.174.347q.117.53.292.967.176.435.491.875a.57.57 0 01.115.353.5.5 0 01-.16.335.34.34 0 01-.305.11.45.45 0 01-.291-.18 6 6 0 01-.658-1.166 6.2 6.2 0 01-.368-1.294.42.42 0 01.075-.338.35.35 0 01.298-.14"/>', width: 14, height: 14 }, "restart-live-editor": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M13.195 4.958V3.524q0-.186.126-.312a.42.42 0 01.311-.126q.187 0 .312.126a.42.42 0 01.126.312v2.355a.5.5 0 01-.151.377.5.5 0 01-.376.15h-2.35a.42.42 0 01-.312-.125.42.42 0 01-.126-.312q0-.186.126-.312a.42.42 0 01.312-.126h1.317a5.33 5.33 0 00-1.92-2.004 5 5 0 00-2.644-.732 5.06 5.06 0 00-2.869.86 5.2 5.2 0 00-1.916 2.283.8.8 0 01-.25.315.44.44 0 01-.373.07.33.33 0 01-.259-.231.57.57 0 01.034-.4 6.06 6.06 0 012.23-2.737A5.9 5.9 0 017.946 1.92q1.636 0 3.011.797 1.375.799 2.238 2.241m.4 3.67q.184 0 .297.142a.41.41 0 01.078.335 7 7 0 01-.373 1.28q-.24.585-.644 1.174a.42.42 0 01-.29.197.36.36 0 01-.322-.115.46.46 0 01-.15-.336.7.7 0 01.123-.367q.3-.441.47-.882.171-.441.293-.966a.66.66 0 01.182-.332.46.46 0 01.335-.13M8.528 13.69q0-.21.129-.34A.64.64 0 019 13.18q.522-.103.953-.288.43-.186.871-.484a.58.58 0 01.359-.112q.182.009.335.162a.36.36 0 01.109.306.44.44 0 01-.176.291 6.7 6.7 0 01-1.155.64q-.576.243-1.278.368a.43.43 0 01-.345-.076.35.35 0 01-.145-.296M4.36 12.452a.48.48 0 01.34-.156.6.6 0 01.363.126q.43.297.87.472.442.173.966.284.207.042.335.177t.129.335a.36.36 0 01-.138.296.4.4 0 01-.329.076 6.2 6.2 0 01-1.288-.364 6.4 6.4 0 01-1.166-.644.43.43 0 01-.188-.29.34.34 0 01.106-.312M2.3 8.627q.21 0 .337.131a.7.7 0 01.174.347q.117.53.292.967.176.435.491.875a.57.57 0 01.115.353.5.5 0 01-.16.335.34.34 0 01-.305.11.45.45 0 01-.291-.18 6 6 0 01-.658-1.166 6.2 6.2 0 01-.368-1.294.42.42 0 01.075-.338.35.35 0 01.298-.14"/><path d="M6.555 5.85v4.28q0 .18.156.267a.28.28 0 00.31-.016l3.331-2.134a.3.3 0 00.138-.257.3.3 0 00-.138-.258l-3.33-2.133a.28.28 0 00-.31-.017.29.29 0 00-.156.268"/></g>' }, "restore-from-trash": { body: '<path fill="currentColor" d="M3.308 17.5q-.749 0-1.278-.53a1.74 1.74 0 01-.53-1.278V3h-.25a.73.73 0 01-.534-.216A.73.73 0 01.5 2.25q0-.32.216-.535A.73.73 0 011.25 1.5H5q0-.368.259-.626a.85.85 0 01.625-.259h4.232q.366 0 .625.259A.85.85 0 0111 1.5h3.75q.32 0 .534.215a.73.73 0 01.216.535.73.73 0 01-.216.534.73.73 0 01-.534.216h-.25v12.692q0 .749-.53 1.278-.53.53-1.278.53zM13 3H3v12.692a.3.3 0 00.087.221.3.3 0 00.22.087h9.385a.3.3 0 00.222-.087.3.3 0 00.086-.221zM7.25 8.234v3.67q0 .318.215.534a.73.73 0 00.535.215.73.73 0 00.534-.215.73.73 0 00.216-.535V8.234l1.323 1.308q.207.208.515.212a.72.72 0 00.539-.227.72.72 0 00.217-.527.72.72 0 00-.217-.527L8.633 5.978A.87.87 0 008 5.708a.87.87 0 00-.633.27L4.873 8.473a.75.75 0 00-.22.514.7.7 0 00.22.54q.217.218.52.225a.73.73 0 00.534-.21z"/>', height: 18 }, "result-aborted": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.592 12.183A.573.573 0 017 11.592.575.575 0 017.592 11h9.466q.257 0 .425.167a.58.58 0 01.167.425.574.574 0 01-.592.591z"/></g>', width: 24, height: 24 }, "result-failed": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m12 12.827-3.996 3.996a.58.58 0 01-.403.167.54.54 0 01-.424-.167.57.57 0 01-.177-.414q0-.236.177-.413L11.173 12 7.177 8.004A.58.58 0 017.01 7.6a.54.54 0 01.167-.423A.57.57 0 017.591 7q.236 0 .413.177L12 11.173l3.996-3.996a.58.58 0 01.404-.168.55.55 0 01.423.168.57.57 0 01.177.414q0 .236-.177.413L12.827 12l3.996 3.996a.58.58 0 01.167.403.54.54 0 01-.167.424.57.57 0 01-.414.177.57.57 0 01-.413-.177z"/></g>', width: 24, height: 24 }, "result-not-executed": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D2D5D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m16.721 17.863-.991-.992q-.69.503-1.495.776a5.2 5.2 0 01-1.695.273 5.3 5.3 0 01-2.134-.43 5.5 5.5 0 01-1.731-1.165 5.5 5.5 0 01-1.164-1.731 5.3 5.3 0 01-.431-2.134q0-.891.273-1.695.273-.805.776-1.495l-1.006-.99A.47.47 0 017 7.977a.4.4 0 01.123-.302.44.44 0 01.316-.143q.172 0 .302.143l9.598 9.584a.414.414 0 010 .604.42.42 0 01-.31.13.42.42 0 01-.308-.13m-4.181-.805q.705 0 1.35-.208a4.8 4.8 0 001.222-.597L8.746 9.888q-.387.574-.596 1.222-.208.645-.208 1.35 0 1.912 1.344 3.255 1.343 1.343 3.254 1.343m4.584-1.638-.618-.632a4.46 4.46 0 00.632-2.328q0-1.911-1.343-3.255-1.344-1.343-3.255-1.343-.632 0-1.215.158a4.5 4.5 0 00-1.113.474l-.632-.617q.66-.432 1.401-.655A5.4 5.4 0 0112.54 7q1.135 0 2.134.431a5.5 5.5 0 011.731 1.164 5.5 5.5 0 011.164 1.731q.43.999.431 2.134 0 .82-.222 1.559-.224.74-.654 1.401"/></g>', width: 24, height: 24 }, "result-passed": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m10 13.95 6.076-6.075a.7.7 0 01.525-.2.7.7 0 01.525.2.7.7 0 01.2.525.7.7 0 01-.2.525l-6.5 6.475a.86.86 0 01-.625.275.86.86 0 01-.625-.275l-2.5-2.475a.7.7 0 01-.2-.525.7.7 0 01.2-.525.7.7 0 01.525-.2.7.7 0 01.525.2z"/></g>', width: 24, height: 24 }, "result-queued": { body: '<path fill="currentColor" d="M4.136 9.176q.49 0 .833-.343T5.312 8t-.343-.833a1.13 1.13 0 00-.833-.343q-.49 0-.833.343A1.13 1.13 0 002.96 8q0 .49.343.833t.833.343m3.864 0q.49 0 .833-.343T9.176 8t-.343-.833A1.13 1.13 0 008 6.824q-.49 0-.833.343A1.13 1.13 0 006.824 8q0 .49.343.833T8 9.176m3.864 0q.49 0 .833-.343T13.04 8t-.343-.833a1.13 1.13 0 00-.833-.343q-.49 0-.833.343a1.13 1.13 0 00-.343.833q0 .49.343.833t.833.343M8 16q-1.664 0-3.123-.63a8.1 8.1 0 01-2.539-1.708A8.1 8.1 0 01.63 11.123 7.8 7.8 0 010 8q0-1.664.63-3.123t1.708-2.539A8.1 8.1 0 014.877.63 7.8 7.8 0 018 0q1.664 0 3.123.63t2.539 1.708a8.1 8.1 0 011.708 2.539Q16 6.335 16 8q0 1.664-.63 3.123a8.1 8.1 0 01-1.708 2.539 8.1 8.1 0 01-2.539 1.708Q9.665 16 8 16m0-1.784q2.609 0 4.412-1.804Q14.216 10.608 14.216 8q0-2.609-1.804-4.412Q10.608 1.784 8 1.784q-2.609 0-4.412 1.804Q1.784 5.392 1.784 8q0 2.609 1.804 4.412Q5.392 14.216 8 14.216"/>' }, "result-stopped": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.02 18.52q-1.352 0-2.54-.513a6.6 6.6 0 01-2.062-1.386 6.6 6.6 0 01-1.385-2.061 6.3 6.3 0 01-.513-2.54q0-1.351.513-2.54a6.6 6.6 0 011.385-2.061A6.6 6.6 0 019.48 6.033a6.3 6.3 0 012.54-.513q1.35 0 2.54.513t2.06 1.386a6.6 6.6 0 011.386 2.06q.514 1.19.514 2.541t-.514 2.54a6.6 6.6 0 01-1.385 2.061 6.6 6.6 0 01-2.061 1.386 6.3 6.3 0 01-2.54.513m0-1.026q2.274 0 3.874-1.6 1.6-1.599 1.6-3.874t-1.6-3.875-3.874-1.599-3.874 1.6-1.6 3.874 1.6 3.875q1.599 1.599 3.874 1.599m-1.95-2.908h3.9q.256 0 .436-.18t.18-.436v-3.9a.6.6 0 00-.18-.437.6.6 0 00-.437-.179h-3.9a.6.6 0 00-.436.18.6.6 0 00-.18.436v3.9q0 .257.18.436.18.18.437.18"/></g>', width: 24, height: 24 }, results: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.093 12.563q.225 0 .394-.16A.53.53 0 006.656 12V8.25a.53.53 0 00-.17-.403.56.56 0 00-.393-.16.546.546 0 00-.562.563V12a.547.547 0 00.562.563m2.906 0a.55.55 0 00.404-.16.55.55 0 00.159-.403V6a.546.546 0 00-.563-.562.544.544 0 00-.562.562v6a.547.547 0 00.562.563m2.907 0a.55.55 0 00.403-.16.55.55 0 00.16-.403v-1.5a.55.55 0 00-.16-.403.55.55 0 00-.403-.16.56.56 0 00-.394.16.53.53 0 00-.169.403V12q0 .244.169.404a.56.56 0 00.394.159m-7.932 2.812q-.562 0-.956-.394a1.3 1.3 0 01-.394-.956V3.975q0-.563.394-.956.394-.394.956-.394h10.05q.562 0 .957.394.393.393.393.956v10.05q0 .563-.393.956a1.3 1.3 0 01-.957.394zm0-1.125h10.05a.22.22 0 00.16-.065.22.22 0 00.065-.16V3.975a.22.22 0 00-.065-.159.22.22 0 00-.16-.066H3.974a.22.22 0 00-.159.066.22.22 0 00-.066.16v10.05q0 .093.066.159a.22.22 0 00.16.065"/></g>', width: 18, height: 18 }, "resume-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M8.458 13.125a.607.607 0 00.625-.625V7.48a.58.58 0 00-.176-.428.6.6 0 00-.449-.177.606.606 0 00-.625.625v5.02q0 .251.178.427a.6.6 0 00.447.178m3.084 0a.61.61 0 00.625-.625V7.48a.58.58 0 00-.177-.428.6.6 0 00-.448-.177.6.6 0 00-.449.177.6.6 0 00-.176.448v5.02q0 .251.176.427a.6.6 0 00.449.178M10 17.917a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.624 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.688 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625m0-1.25q2.77 0 4.72-1.948 1.946-1.948 1.947-4.72 0-2.77-1.948-4.718T10 3.333 5.282 5.281Q3.332 7.23 3.333 10t1.949 4.72Q7.229 16.665 10 16.666"/><path d="M15 10a5 5 0 11-10 0 5 5 0 0110 0"/></g>', width: 20, height: 20 }, "resume-plain": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3 8.5v-5q0-.212.144-.356A.48.48 0 013.5 3q.212 0 .356.144A.48.48 0 014 3.5v5q0 .212-.144.356A.48.48 0 013.5 9a.48.48 0 01-.356-.144A.48.48 0 013 8.5m2.763.05q-.25.15-.507 0A.48.48 0 015 8.113V3.888q0-.288.256-.438.257-.15.506 0l3.526 2.125q.25.15.25.425a.47.47 0 01-.25.425z"/></g>', width: 12, height: 12 }, retry: { body: '<g fill="currentColor"><path fill-opacity=".01" d="M0 0h14v14H0z"/><path fill-rule="evenodd" d="M1.777 6.81c0 2.841 2.06 4.777 4.373 5.177a.486.486 0 11-.166.959c-2.718-.47-5.18-2.761-5.18-6.136 0-1.434.652-2.561 1.414-3.419.546-.614 1.17-1.113 1.673-1.495H2.364a.467.467 0 110-.933h2.8c.257 0 .466.209.466.467v2.8a.467.467 0 11-.933 0V2.507l-.002.001c-.533.402-1.185.894-1.75 1.53-.666.75-1.168 1.656-1.168 2.772m10.367.38c0-2.812-2.017-4.736-4.3-5.165a.486.486 0 01.18-.956c2.682.504 5.093 2.782 5.093 6.12 0 1.435-.653 2.562-1.415 3.42-.546.613-1.17 1.112-1.672 1.494h1.527a.467.467 0 010 .934h-2.8a.467.467 0 01-.467-.467v-2.8a.467.467 0 11.934 0v1.722h.001c.533-.403 1.185-.895 1.75-1.53.667-.75 1.169-1.657 1.169-2.773" clip-rule="evenodd"/></g>', width: 14, height: 14 }, "reusable-step-group": { body: '<g fill="currentColor"><path d="M7.985 15.117q-2.384 0-4.092-1.584-1.708-1.582-1.891-3.916a.44.44 0 01.125-.35q.141-.15.358-.15.2 0 .342.141a.63.63 0 01.175.359q.183 1.916 1.6 3.208 1.416 1.292 3.383 1.292 2.084 0 3.542-1.459 1.458-1.458 1.458-3.541 0-2.085-1.417-3.542-1.415-1.458-3.5-1.458h-.366l.866.866a.48.48 0 010 .7.48.48 0 01-.7 0l-1.75-1.75a.5.5 0 01-.116-.166.5.5 0 01-.034-.184.5.5 0 01.034-.183.5.5 0 01.116-.167l1.767-1.766a.45.45 0 01.333-.134.5.5 0 01.35.134.5.5 0 01.134.35.45.45 0 01-.134.333l-.966.967h.383q1.25 0 2.342.466a6 6 0 011.908 1.284q.817.816 1.283 1.908.467 1.092.467 2.342t-.467 2.341a6 6 0 01-1.283 1.909 6 6 0 01-1.908 1.283 5.9 5.9 0 01-2.342.467"/><path d="M9.9 8.078a.28.28 0 01-.216.093H8.15a.28.28 0 01-.215-.096.34.34 0 01-.087-.233q0-.139.087-.231a.28.28 0 01.215-.093h1.534q.129 0 .215.095a.34.34 0 01.087.234.33.33 0 01-.087.231m.001 2.763a.28.28 0 01-.216.093H8.15a.28.28 0 01-.215-.095.34.34 0 01-.087-.234q0-.138.087-.231a.28.28 0 01.215-.093h1.534q.129 0 .215.096a.34.34 0 01.087.233.33.33 0 01-.087.231M6.923 8.347a.6.6 0 01-.464.208.62.62 0 01-.466-.205.7.7 0 01-.193-.503q0-.297.19-.505a.6.6 0 01.464-.209q.275 0 .467.206a.7.7 0 01.192.503.72.72 0 01-.19.505m0 2.763a.6.6 0 01-.464.209.62.62 0 01-.466-.206.7.7 0 01-.193-.503q0-.297.19-.505a.6.6 0 01.464-.208q.275 0 .467.205a.7.7 0 01.192.503.72.72 0 01-.19.505"/></g>' }, "review-tc": { body: '<g fill="none" stroke="currentColor" stroke-linecap="round"><path stroke-width="1.33" d="M17 8V5a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2h3M7 7h6m-6 3h3"/><path stroke-linejoin="round" stroke-width="1.2" d="M11 15a4 4 0 108 0 4 4 0 00-8 0"/><path stroke-linejoin="round" stroke-width="1.2" d="M15 13v1.875L16 16"/></g>', width: 20, height: 20 }, "right-arrow-thin": { body: '<path fill="currentColor" d="M12.308 7.993c0 .242-.093.484-.268.681L5.503 15.67a1.07 1.07 0 01-1.468.072.996.996 0 01-.073-1.426l5.9-6.314-5.9-6.314A.99.99 0 014.035.26a1.06 1.06 0 011.468.072L12.04 7.33c.175.18.268.422.268.664"/>' }, rocket: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m5.208 15.917 1.854-.771a25 25 0 01-.416-1.437 13 13 0 01-.292-1.48l-1.021.709a.3.3 0 00-.094.093.2.2 0 00-.031.115zM8.333 15h3.333q.376-.916.604-2.115.23-1.196.23-2.468 0-1.98-.635-3.698A8.1 8.1 0 0010 3.77a8.1 8.1 0 00-1.865 2.948q-.636 1.718-.635 3.698 0 1.27.229 2.468.23 1.2.604 2.115M10 10.625q-.604 0-1.032-.427a1.4 1.4 0 01-.427-1.031q0-.604.427-1.032A1.4 1.4 0 0110 7.71q.603 0 1.031.426.427.428.427 1.032t-.427 1.031a1.4 1.4 0 01-1.031.427m4.791 5.292v-2.771q0-.063-.031-.115a.3.3 0 00-.094-.093l-1.02-.709q-.105.75-.313 1.563t-.396 1.375zM10 2.146q1.896 1.521 2.822 3.635.928 2.115.928 4.823v.209l1.604 1.083q.312.188.5.53.187.345.187.72v4.604l-3.729-1.5H7.687l-3.729 1.5v-4.604q0-.375.178-.72.175-.343.51-.55l1.604-1.063v-.209q0-2.708.927-4.823Q8.104 3.667 10 2.146"/></g>', width: 20, height: 20 }, "rotate-left": { body: '<path fill="currentColor" d="M2.617 7.9a.57.57 0 01-.467-.2.5.5 0 01-.1-.467q.1-.482.292-.95.191-.465.441-.9a.5.5 0 01.409-.266.57.57 0 01.458.183q.15.134.175.342a.57.57 0 01-.075.375 5.2 5.2 0 00-.583 1.433.6.6 0 01-.2.325.53.53 0 01-.35.125M6.6 14.684a7 7 0 01-.925-.3 6 6 0 01-.875-.434.53.53 0 01-.275-.416.59.59 0 01.192-.484.55.55 0 01.325-.158.54.54 0 01.358.075q.35.216.692.358t.708.242a.62.62 0 01.317.208.54.54 0 01.133.358.57.57 0 01-.192.45.48.48 0 01-.458.1m-3.817-2.75a6 6 0 01-.433-.884 7 7 0 01-.3-.983.5.5 0 01.1-.467.57.57 0 01.467-.2.54.54 0 01.341.125.58.58 0 01.209.325q.083.384.216.742.134.359.35.675a.7.7 0 01.084.392.56.56 0 01-.167.358q-.216.216-.467.192-.25-.026-.4-.275M9.4 14.667a.5.5 0 01-.458-.092.54.54 0 01-.192-.441q0-.185.133-.35a.6.6 0 01.317-.217 5.2 5.2 0 002.708-1.792q1.059-1.325 1.059-3.125 0-2.067-1.4-3.492T8.083 3.7h-.316l.866.867q.134.15.134.383a.55.55 0 01-.167.4.56.56 0 01-.417.167.56.56 0 01-.416-.167L5.933 3.517a1 1 0 01-.125-.192.5.5 0 01-.041-.208q0-.116.041-.209a1 1 0 01.125-.191L7.767.883a.56.56 0 01.408-.166q.242 0 .425.166a.55.55 0 01.167.4q0 .234-.15.4l-.867.867h.333q2.534.033 4.275 1.792Q14.1 6.1 14.1 8.65q0 2.2-1.317 3.85A6.1 6.1 0 019.4 14.667"/>' }, rule: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.85 5.682 13.333 3.2q.15-.15.35-.142t.35.159a.5.5 0 01.134.35.5.5 0 01-.134.35l-2.75 2.75a.57.57 0 01-.416.183.57.57 0 01-.417-.183l-1.367-1.35a.47.47 0 01-.133-.35q0-.217.133-.35a.47.47 0 01.35-.134q.217 0 .35.134zm-9.017.15a.484.484 0 01-.5-.5.484.484 0 01.5-.5H6.5a.486.486 0 01.5.5.485.485 0 01-.5.5zm9.334 5.534-1.384 1.383a.47.47 0 01-.35.133.47.47 0 01-.35-.133.47.47 0 01-.133-.35q0-.216.133-.35l1.384-1.383-1.384-1.384a.47.47 0 01-.133-.35q0-.216.133-.35a.47.47 0 01.35-.133q.217 0 .35.133l1.384 1.384 1.383-1.384a.47.47 0 01.35-.133q.216 0 .35.133a.47.47 0 01.133.35.47.47 0 01-.133.35l-1.383 1.384 1.383 1.383a.47.47 0 01.133.35.47.47 0 01-.133.35.47.47 0 01-.35.133.47.47 0 01-.35-.133zm-9.334-.2a.485.485 0 01-.5-.5.486.486 0 01.5-.5H6.5q.216 0 .359.141a.5.5 0 01.14.359.5.5 0 01-.14.358.5.5 0 01-.36.142z"/></g>' }, run: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.125 8.02v3.96q0 .457.396.666.395.208.77-.042l3.105-1.958A.73.73 0 0012.75 10a.73.73 0 00-.354-.646L9.292 7.396a.71.71 0 00-.771-.042q-.396.208-.396.667M10 17.918a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.624 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.688 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625m0-1.25q2.77 0 4.72-1.948 1.946-1.948 1.947-4.719 0-2.77-1.948-4.72Q12.771 3.334 10 3.334q-2.77 0-4.718 1.948Q3.332 7.229 3.333 10t1.949 4.72Q7.229 16.665 10 16.666"/></g>', width: 20, height: 20 }, "run-step": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m8.517 10.033 2.666-1.783q.084-.034.109-.1a.4.4 0 00.024-.15.4.4 0 00-.024-.15q-.025-.066-.109-.1L8.517 5.967A.3.3 0 008.2 5.95a.28.28 0 00-.167.267v3.566q0 .184.167.267.166.083.317-.017m-2.384.317q.2 0 .35-.142a.47.47 0 00.15-.358V6.133a.45.45 0 00-.15-.341.5.5 0 00-.35-.142.484.484 0 00-.5.5v3.717q0 .2.142.341a.48.48 0 00.358.142M8 14.333a6.2 6.2 0 01-2.475-.5 6.4 6.4 0 01-2.009-1.35 6.4 6.4 0 01-1.35-2.008A6.2 6.2 0 011.667 8q0-1.317.5-2.475a6.4 6.4 0 011.35-2.008 6.4 6.4 0 012.01-1.35A6.2 6.2 0 018 1.667a6.2 6.2 0 012.475.5 6.4 6.4 0 012.008 1.35 6.4 6.4 0 011.35 2.008q.5 1.158.5 2.475t-.5 2.475a6.4 6.4 0 01-1.35 2.008 6.4 6.4 0 01-2.008 1.35 6.2 6.2 0 01-2.475.5m0-1q2.217 0 3.775-1.558T13.333 8t-1.558-3.775T8 2.667 4.225 4.225 2.667 8t1.558 3.775T8 13.333"/></g>' }, safari: { body: '<path fill="currentColor" d="M236.9 256.8c0-9.1 6.6-17.7 16.3-17.7 8.9 0 17.4 6.4 17.4 16.1 0 9.1-6.4 17.7-16.1 17.7-9 0-17.6-6.7-17.6-16.1M504 256c0 137-111 248-248 248S8 393 8 256 119 8 256 8s248 111 248 248m-26.6 0c0-122.3-99.1-221.4-221.4-221.4S34.6 133.7 34.6 256 133.7 477.4 256 477.4 477.4 378.3 477.4 256m-72.5 96.6c0 3.6 13 10.2 16.3 12.2-27.4 41.5-69.8 71.4-117.9 83.3l-4.4-18.5c-.3-2.5-1.9-2.8-4.2-2.8-1.9 0-3 2.8-2.8 4.2l4.4 18.8c-13.3 2.8-26.8 4.2-40.4 4.2-36.3 0-72-10.2-103-29.1 1.7-2.8 12.2-18 12.2-20.2 0-1.9-1.7-3.6-3.6-3.6-3.9 0-12.2 16.6-14.7 19.9-41.8-27.7-72-70.6-83.6-119.6l19.1-4.2c2.2-.6 2.8-2.2 2.8-4.2 0-1.9-2.8-3-4.4-2.8L62 294.5c-2.5-12.7-3.9-25.5-3.9-38.5 0-37.1 10.5-73.6 30.2-104.9 2.8 1.7 16.1 10.8 18.3 10.8 1.9 0 3.6-1.4 3.6-3.3 0-3.9-14.7-11.3-18-13.6 28.2-41.2 71.1-70.9 119.8-81.9l4.2 18.5c.6 2.2 2.2 2.8 4.2 2.8s3-2.8 2.8-4.4L219 61.7c12.2-2.2 24.6-3.6 37.1-3.6 37.1 0 73.3 10.5 104.9 30.2-1.9 2.8-10.8 15.8-10.8 18 0 1.9 1.4 3.6 3.3 3.6 3.9 0 11.3-14.4 13.3-17.7 41 27.7 70.3 70 81.7 118.2l-15.5 3.3c-2.5.6-2.8 2.2-2.8 4.4 0 1.9 2.8 3 4.2 2.8l15.8-3.6c2.5 12.7 3.9 25.7 3.9 38.7 0 36.3-10 72-28.8 102.7-2.8-1.4-14.4-9.7-16.6-9.7-2.1 0-3.8 1.7-3.8 3.6m-33.2-242.2c-13 12.2-134.2 123.7-137.6 129.5l-96.6 160.5c12.7-11.9 134.2-124 137.3-129.3z"/>', width: 512, height: 512 }, salesforce: { body: '<g fill="none"><g clip-path="url(#svgID0)"><path stroke="currentColor" stroke-width="1.3" d="m6.974 4.47.46.602.525-.547a2.5 2.5 0 011.814-.78c.939 0 1.766.522 2.21 1.314l.29.517.542-.242a3.2 3.2 0 011.305-.277c1.778 0 3.23 1.457 3.23 3.265s-1.452 3.264-3.23 3.264q-.322 0-.636-.063l-.464-.094-.232.413a2.186 2.186 0 01-2.865.901l-.615-.3-.268.63a2.587 2.587 0 01-4.808-.117l-.195-.527-.55.116q-.232.05-.483.05C1.71 12.596.65 11.535.65 10.21a2.39 2.39 0 011.18-2.068l.498-.292-.23-.529a2.844 2.844 0 012.612-3.97c.923 0 1.743.438 2.264 1.119Z"/></g><defs><clipPath id="svgID0"><path fill="#fff" d="M0 2.7h18v12.6H0z"/></clipPath></defs></g>', width: 18, height: 18 }, "sap-logo": { body: '<path fill="currentColor" stroke="currentColor" stroke-width=".144" d="M0 6.064v11.872h12.13L24 6.064zm3.264 2.208h.005c.863.001 1.915.245 2.676.633l-.82 1.43c-.835-.404-1.255-.442-1.73-.467-.708-.038-1.064.215-1.069.488-.007.332.669.633 1.305.838.964.306 2.19.715 2.377 1.9L7.77 8.437h2.046l2.064 5.576-.007-5.575h2.37c2.257 0 3.318.764 3.318 2.519 0 1.575-1.09 2.514-2.936 2.514h-.763l-.01 2.094-3.588-.003-.25-.908c-.37.122-.787.189-1.23.189-.456 0-.885-.071-1.263-.2l-.358.919-2 .006.09-.462q-.043.038-.087.074c-.535.43-1.208.629-2.037.644l-.213.002a5.1 5.1 0 01-2.581-.675l.73-1.448c.79.467 1.286.572 1.956.558.347-.007.598-.07.761-.239a.56.56 0 00.156-.369c.007-.376-.53-.553-1.185-.756-.531-.164-1.135-.389-1.606-.735-.559-.41-.825-.924-.812-1.65a2 2 0 01.566-1.377c.519-.537 1.357-.863 2.363-.863zm10.597 1.67v1.904h.521c.694 0 1.247-.23 1.248-.964 0-.709-.554-.94-1.248-.94zm-5.087.767-.748 2.362c.223.085.481.133.757.133.268 0 .52-.047.742-.126l-.736-2.37z"/>', left: -2.4, top: -2.4, width: 28.8, height: 28.8 }, "saucelabs-logo": { body: '<path fill="currentColor" d="M7.8 41.237a25.5 25.5 0 01-1.718-9.289A25.99 25.99 0 0132.21 6.084a28 28 0 013.658.255L32.94 9.3h-.795A22.746 22.746 0 0010.26 38.246h19.915l-8.462 15.556 20.042-20.296h-27.36L45.22 2.903A31.6 31.6 0 0032.019.04a32.04 32.04 0 00-16.702 59.362l9.544-18.038zM48.72 4.62l-9.543 18.04H56.26a25.93 25.93 0 01-24.209 35.217 30 30 0 01-3.786-.255l2.895-2.927h.9a22.745 22.745 0 0022.746-22.746 25 25 0 00-.859-6.172H34.023l8.303-15.684L21.903 30.42h27.423L18.85 61.15A32.04 32.04 0 0048.721 4.621z"/>', width: 64, height: 64 }, save: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.423 17.083q-.63 0-1.069-.437a1.45 1.45 0 01-.437-1.069V4.423q0-.63.437-1.069a1.45 1.45 0 011.07-.437h8.943q.301 0 .58.117.277.117.483.322l2.215 2.215q.204.204.322.483.117.277.117.58v8.943q0 .63-.438 1.069a1.45 1.45 0 01-1.069.437zm11.41-10.541L13.46 4.167H4.423a.25.25 0 00-.184.072.25.25 0 00-.072.184v11.154a.25.25 0 00.072.184.25.25 0 00.184.072h11.154a.25.25 0 00.184-.072.25.25 0 00.073-.184zM10 14.39q.866 0 1.475-.609t.609-1.474-.61-1.475A2 2 0 0010 10.224q-.865 0-1.474.61a2 2 0 00-.609 1.474q0 .865.609 1.474t1.474.609M6.074 8.237h5.337a.73.73 0 00.537-.215.73.73 0 00.216-.538v-1.41a.73.73 0 00-.216-.538.73.73 0 00-.537-.215H6.074a.73.73 0 00-.538.215.73.73 0 00-.215.538v1.41a.73.73 0 00.215.538.73.73 0 00.538.215"/></g>', width: 20, height: 20 }, scenario: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.492 7.597 8.428 5.533a.5.5 0 01-.123-.18.55.55 0 010-.395.5.5 0 01.123-.179l2.064-2.064a.5.5 0 01.18-.122.55.55 0 01.395 0q.091.035.178.122L13.31 4.78a.5.5 0 01.122.18.55.55 0 010 .396.5.5 0 01-.122.178l-2.065 2.064a.52.52 0 01-.378.158.5.5 0 01-.197-.035.5.5 0 01-.178-.123m-7.416-1.06V3.615q0-.228.155-.383a.52.52 0 01.384-.155h2.923q.228 0 .383.155a.52.52 0 01.155.383v2.923q0 .229-.154.384a.52.52 0 01-.384.155H3.615a.52.52 0 01-.384-.155.52.52 0 01-.155-.384m5.846 5.847V9.46q0-.228.155-.383a.52.52 0 01.384-.155h2.923q.229 0 .384.155a.52.52 0 01.154.383v2.924q0 .228-.154.383a.52.52 0 01-.384.155H9.461a.52.52 0 01-.384-.155.52.52 0 01-.155-.383m-5.846 0V9.46q0-.228.155-.383a.52.52 0 01.384-.155h2.923q.228 0 .383.155a.52.52 0 01.155.383v2.924q0 .228-.154.383a.52.52 0 01-.384.155H3.615a.52.52 0 01-.384-.155.52.52 0 01-.155-.383m.667-5.975H6.41V3.744H3.743zm7.142.646 1.883-1.883-1.883-1.883-1.883 1.883zm-1.296 5.2h2.667V9.59H9.589zm-5.846 0H6.41V9.59H3.743z"/></g>' }, scenarios: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M11.555 8.889a5.04 5.04 0 002.667 2.666 5.04 5.04 0 00-2.667 2.667 5.04 5.04 0 00-2.666-2.667 5.04 5.04 0 002.666-2.666"/><path d="M3.538 13.667a1.16 1.16 0 01-.851-.354 1.16 1.16 0 01-.354-.85V3.538q0-.497.354-.851a1.16 1.16 0 01.851-.354h8.923q.498 0 .851.354.354.354.354.851V6.91q0 .213-.143.356a.48.48 0 01-.357.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356V3.539a.2.2 0 00-.064-.14.2.2 0 00-.14-.065H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.141v8.923q0 .077.064.141.065.064.141.064H6.91q.213 0 .356.144a.48.48 0 01.144.357q0 .212-.144.356a.48.48 0 01-.356.143zm-.205-1V3.334v4.127-.05zm1.5-2.076q0 .212.144.356a.48.48 0 00.356.143h1.678q.212 0 .357-.143a.48.48 0 00.143-.357.48.48 0 00-.143-.356.48.48 0 00-.357-.143H5.333a.48.48 0 00-.356.143.48.48 0 00-.144.357m0-2.59q0 .213.144.356a.48.48 0 00.356.144H9.16q.212 0 .356-.144A.48.48 0 009.66 8a.48.48 0 00-.144-.356.48.48 0 00-.356-.143H5.333a.48.48 0 00-.356.143.48.48 0 00-.144.357m0-2.59q0 .212.144.356a.48.48 0 00.356.144h5.333q.212 0 .357-.144a.48.48 0 00.143-.356.48.48 0 00-.143-.357.48.48 0 00-.357-.143H5.333a.48.48 0 00-.356.144.48.48 0 00-.144.356"/></g>' }, schedule: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.65 10.667q.2.2.492.2a.7.7 0 00.508-.217.7.7 0 00.2-.509.7.7 0 00-.2-.508L8.733 7.7V5.4a.7.7 0 00-.208-.517.73.73 0 00-.525-.2.71.71 0 00-.733.734v2.55q0 .15.058.291.058.142.175.259zM8 14.8q-1.416 0-2.659-.533a6.8 6.8 0 01-2.158-1.45 6.8 6.8 0 01-1.45-2.158A6.7 6.7 0 011.2 8q0-1.416.533-2.659a6.8 6.8 0 011.45-2.158 6.8 6.8 0 012.158-1.45A6.7 6.7 0 018 1.2q1.416 0 2.659.533a6.8 6.8 0 012.158 1.45 6.8 6.8 0 011.45 2.158Q14.8 6.583 14.8 8t-.533 2.659a6.8 6.8 0 01-1.45 2.158 6.8 6.8 0 01-2.158 1.45A6.7 6.7 0 018 14.8m0-1.517q2.2 0 3.742-1.541Q13.283 10.2 13.283 8t-1.541-3.742Q10.2 2.717 8 2.717T4.259 4.258 2.717 8t1.542 3.742Q5.799 13.283 8 13.283"/></g>' }, "schedule-fill": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.748 8.693V6.338a.72.72 0 00-.215-.533A.72.72 0 009 5.59a.72.72 0 00-.533.215.72.72 0 00-.215.533V8.97a.76.76 0 00.23.559l2.2 2.198q.208.21.52.209a.72.72 0 00.74-.734.72.72 0 00-.214-.53zM9 16q-1.456 0-2.733-.55a7.1 7.1 0 01-2.22-1.496 7.1 7.1 0 01-1.496-2.221A6.8 6.8 0 012 9q0-1.456.55-2.733a7.1 7.1 0 011.496-2.22A7.1 7.1 0 016.267 2.55 6.8 6.8 0 019 2q1.456 0 2.733.55a7.1 7.1 0 012.22 1.496q.945.945 1.496 2.221T16 9q0 1.456-.55 2.733a7.1 7.1 0 01-1.496 2.22 7.1 7.1 0 01-2.221 1.496A6.8 6.8 0 019 16"/></g>', width: 18, height: 18 }, "schedule-light": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.5 7.798V5.167a.48.48 0 00-.144-.356A.48.48 0 008 4.667a.48.48 0 00-.357.144.48.48 0 00-.143.356v2.785q0 .117.043.228a.6.6 0 00.138.204l2.283 2.283q.138.139.348.142a.47.47 0 00.354-.142.48.48 0 00.145-.351.48.48 0 00-.145-.352zM8 14.334a6.2 6.2 0 01-2.47-.499 6.4 6.4 0 01-2.01-1.354 6.4 6.4 0 01-1.355-2.01 6.2 6.2 0 01-.498-2.47q0-1.314.498-2.47A6.4 6.4 0 013.52 3.52a6.4 6.4 0 012.01-1.354A6.2 6.2 0 018 1.667q1.314 0 2.47.499 1.155.498 2.011 1.353t1.354 2.01q.5 1.156.5 2.47t-.5 2.47a6.4 6.4 0 01-1.353 2.012 6.4 6.4 0 01-2.01 1.354 6.2 6.2 0 01-2.47.499m0-1q2.217 0 3.775-1.559T13.333 8t-1.558-3.775T8 2.667 4.225 4.225Q2.665 5.785 2.666 8q0 2.217 1.559 3.775Q5.783 13.335 8 13.334"/></g>' }, school: { body: '<mask id="svgID0" width="37" height="36" x="-1" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M-.003 0h36v36h-36z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M31.498 24v-8.85l-12.076 6.562a2.89 2.89 0 01-2.85 0l-12.675-6.9q-.412-.225-.58-.562a1.65 1.65 0 01-.17-.75q0-.413.17-.75.168-.337.58-.562l12.676-6.9q.337-.189.693-.282a2.86 2.86 0 011.463 0q.356.094.694.281l14.287 7.8q.375.189.581.544.207.357.207.769V24q0 .637-.432 1.069a1.45 1.45 0 01-1.069.431q-.637 0-1.068-.431A1.45 1.45 0 0131.498 24m-14.925 6.712-7.5-4.05q-.75-.412-1.163-1.124A3 3 0 017.497 24v-5.7l9.076 4.912a2.89 2.89 0 002.85 0l9.075-4.912V24a3.02 3.02 0 01-1.576 2.663l-7.5 4.05a2.86 2.86 0 01-2.156.281 3 3 0 01-.693-.282"/></g>', width: 36, height: 36 }, "screen-rotation": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.5 15.708 4.27 9.48A1.35 1.35 0 013.949 9a1.6 1.6 0 01-.094-.563q0-.312.094-.562t.323-.48l3.125-3.124q.229-.229.479-.324a1.6 1.6 0 01.563-.093A1.6 1.6 0 019 3.947q.25.095.48.324l6.228 6.229q.229.23.324.48a1.6 1.6 0 01.093.562q0 .333-.093.572-.094.24-.324.47l-3.125 3.124q-.229.229-.468.324-.24.093-.573.093a1.6 1.6 0 01-.563-.093 1.4 1.4 0 01-.479-.324m.854-.896a.32.32 0 00.199.063q.114 0 .176-.062l3.084-3.084a.24.24 0 00.062-.176.32.32 0 00-.062-.199L8.625 5.167a.3.3 0 00-.187-.063q-.104 0-.188.063L5.167 8.25a.3.3 0 00-.063.187q0 .104.063.188zM10 19.584a9.2 9.2 0 01-3.572-.697 9.75 9.75 0 01-5.062-4.74 9.2 9.2 0 01-.928-3.48.59.59 0 01.166-.468.63.63 0 01.48-.198q.229 0 .406.167.177.166.198.416.208 2.98 2.281 5.146t5.01 2.521l-2.083-2.104a.62.62 0 01-.178-.427.58.58 0 01.178-.448.6.6 0 01.437-.188.6.6 0 01.438.188l3.167 3.166q.395.396.281.74-.114.345-.656.386-.147.02-.281.02zM18.917 10a.58.58 0 01-.407-.167.62.62 0 01-.198-.416q-.208-2.98-2.28-5.146-2.074-2.167-5.011-2.521l2.083 2.104q.166.166.178.427a.58.58 0 01-.178.448.6.6 0 01-.437.188.6.6 0 01-.438-.188L9.063 1.562q-.396-.395-.281-.74.114-.342.656-.385.145-.02.281-.02H10q1.896 0 3.573.697a9.9 9.9 0 012.969 1.907 9.8 9.8 0 012.094 2.822 9.1 9.1 0 01.927 3.49.59.59 0 01-.167.469.63.63 0 01-.48.198"/></g>', width: 20, height: 20 }, screenshot: { body: '<path fill="currentColor" d="m4.35 11.817 2.317-2.334 1.216 1.2 1.45-1.833 2.367 2.967zm1-5.267q-.483 0-.833-.35a1.16 1.16 0 01-.35-.85q0-.483.35-.833t.85-.35q.483 0 .833.35t.35.85q0 .483-.35.833t-.85.35M3.3 14.767q-.867 0-1.467-.6t-.6-1.467V3.3q0-.867.6-1.467t1.467-.6h9.4q.867 0 1.467.6t.6 1.467v9.4q0 .867-.6 1.467t-1.467.6zm0-1.134h9.4a.9.9 0 00.667-.266.9.9 0 00.266-.667V3.3a.9.9 0 00-.266-.667.9.9 0 00-.667-.266H3.3a.9.9 0 00-.667.266.9.9 0 00-.266.667v9.4q0 .4.266.667.267.266.667.266"/>' }, scroll: { body: '<g fill="currentColor"><path d="M92.8 19.4c-9.9 3.6-16.6 9.5-21.6 18.9l-2.7 5.2v125l3.4 6.3c6 11 16.3 18 27.8 19l6.3.5v-4.2c0-4.1 0-4.1-3.8-4.1-9 0-18-5.4-23-13.8l-2.7-4.7-.3-59.3c-.2-39.4.1-60.6.8-63.2 1.5-5.4 6.7-11.9 12.5-15.5l4.8-3h67.4l4.8 3c5.8 3.6 11 10.1 12.5 15.5.7 2.6 1 23.8.8 63.2l-.3 59.3-2.7 4.7c-5 8.4-14 13.8-23 13.8-3.8 0-3.8 0-3.8 4.1v4.1l5.8-.4c11.6-.8 22.3-8 28.3-19l3.4-6.3v-125l-2.8-5.3c-3.9-7.5-8.7-12.4-15.9-16.3l-6.3-3.4-33-.2c-25.5-.2-33.8 0-36.7 1.1"/><path d="M124 71v17h8V54h-8zm-9 78.5v2.5h13.1c13 0 13 0 12.7-2.3-.3-2.1-.7-2.2-13-2.5l-12.8-.3zm0 11.5v3h26v-6h-26zm0 14v4h26v-8h-26zm0 26v15h-9.5l11.3 11.2 11.3 11.3 10.4-11 10.4-11-4-.3-3.9-.3V186h-26z"/></g>', width: 256, height: 256 }, "scroll-action": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#093B4D" d="M0 0h18v18H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path fill-rule="evenodd" d="M9.047 15.677q1.203-1.203 1.203-2.922v-7.5q0-1.719-1.204-2.922T6.123 1.13t-2.92 1.203T2 5.255v7.5q0 1.719 1.204 2.922t2.923 1.203 2.92-1.203m.078-10.422v7.5q0 1.237-.881 2.119a2.9 2.9 0 01-2.119.881 2.9 2.9 0 01-2.119-.881 2.9 2.9 0 01-.881-2.119v-7.5q0-1.237.881-2.119a2.9 2.9 0 012.119-.881q1.237 0 2.119.881.88.882.881 2.119m-4.5 1.25a.5.5 0 000 1h3a.5.5 0 100-1zm0 2a.5.5 0 000 1h3a.5.5 0 100-1zm-.5 2.5a.5.5 0 01.5-.5h3a.5.5 0 010 1h-3a.5.5 0 01-.5-.5" clip-rule="evenodd"/><path d="m13.878 12.129 1.238-1.238a.37.37 0 01.262-.111.36.36 0 01.266.11.36.36 0 010 .528l-1.458 1.458a.4.4 0 01-.308.124.4.4 0 01-.308-.124l-1.457-1.458a.37.37 0 01-.11-.261.36.36 0 01.11-.266.36.36 0 01.527 0zm0-6.258L12.64 7.11a.37.37 0 01-.26.111.36.36 0 01-.267-.11.36.36 0 010-.528l1.458-1.458A.4.4 0 0113.878 5q.089 0 .164.028t.144.096l1.458 1.458q.108.109.11.261a.36.36 0 01-.11.266.36.36 0 01-.528 0z"/></g>', width: 18, height: 18 }, search: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M13.301 14.138 9.203 10.04q-.524.435-1.22.689a4.3 4.3 0 01-1.466.253q-1.9 0-3.209-1.308Q2 8.366 2 6.499q0-1.865 1.308-3.182T6.5 2q1.865 0 3.174 1.317t1.308 3.182q0 .75-.244 1.44-.245.689-.715 1.281l4.133 4.099a.56.56 0 01.174.41.54.54 0 01-.192.41.58.58 0 01-.427.174.53.53 0 01-.41-.175M6.5 9.813q1.377 0 2.345-.968A3.2 3.2 0 009.813 6.5q0-1.377-.968-2.354A3.18 3.18 0 006.5 3.17q-1.395 0-2.364.976A3.22 3.22 0 003.17 6.5q0 1.38.967 2.346.968.969 2.364.968"/></g>' }, "secure-shield": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.283 14.75h1.434a.46.46 0 00.353-.17.4.4 0 00.1-.372l-.476-2.616q.471-.201.759-.635.287-.432.287-.957 0-.717-.511-1.23a1.68 1.68 0 00-1.23-.51q-.718 0-1.229.51-.51.513-.51 1.23 0 .525.287.957.288.434.759.635l-.475 2.616q-.05.203.099.373t.353.17m.717 6.62a1.9 1.9 0 01-.596-.1q-3.164-1.125-5.034-3.99-1.87-2.864-1.87-6.18V6.595q0-.57.328-1.025.327-.456.847-.661l5.692-2.125q.321-.116.633-.116t.633.116l5.692 2.125q.52.205.847.66.328.458.328 1.026V11.1q0 3.318-1.87 6.182t-5.034 3.99a1.7 1.7 0 01-.596.1m0-1.47q2.6-.825 4.3-3.3 1.7-2.476 1.7-5.5V6.586a.3.3 0 00-.053-.173.3.3 0 00-.149-.116l-5.692-2.125a.3.3 0 00-.106-.02.3.3 0 00-.106.02L6.202 6.298a.3.3 0 00-.149.116.3.3 0 00-.053.173V11.1q0 3.025 1.7 5.5t4.3 3.3"/></g>', width: 24, height: 24 }, security: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9 16.013q-.187 0-.347-.029a1 1 0 01-.272-.084q-2.193-.843-3.6-2.934a8.14 8.14 0 01-1.406-4.64V4.95q0-.431.244-.769.243-.337.637-.506l4.275-1.594q.244-.075.469-.075t.469.075l4.275 1.594q.393.169.637.506.244.338.244.77v3.374q0 2.55-1.406 4.641-1.407 2.091-3.6 2.934a1 1 0 01-.272.084 2 2 0 01-.347.029m0-1.088q1.82-.562 3.037-2.221A7.4 7.4 0 0013.463 9H9V3.094L4.65 4.725a.17.17 0 00-.113.084.25.25 0 00-.037.122v3.722q0 .141.037.347H9z"/></g>', width: 18, height: 18 }, "select-check-box": { body: '<mask id="svgID0" width="16" height="17" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 .5h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m7.683 11.6-3.4-3.4.7-.7 2.7 2.7 6-5.983.7.683zm-4.15 2.567q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V4.033q0-.5.35-.85t.85-.35h8.934q.15 0 .283.042.134.042.267.108l-.9.9a.2.2 0 00-.117-.05H3.533a.2.2 0 00-.141.059.2.2 0 00-.059.141v8.934q0 .082.059.142a.2.2 0 00.141.058h8.934q.083 0 .142-.058a.2.2 0 00.058-.142V8.5l1-1v5.467q0 .5-.35.85t-.85.35z"/></g>', height: 17 }, "select-window": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M2.872 14.269q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855v-5.59q0-.505.35-.855t.855-.35h1.461V2.936q0-.505.35-.856.35-.35.856-.35h7.59q.504 0 .854.35t.35.856v5.59q0 .504-.35.854t-.855.35h-1.461v3.334q0 .504-.35.855-.35.35-.856.35zm0-1h7.59a.2.2 0 00.14-.064.2.2 0 00.065-.141V8.602h-8v4.462q0 .077.064.14.065.065.14.065m8.795-4.539h1.461a.2.2 0 00.141-.064.2.2 0 00.064-.14V4.063h-8v2.205h5.128q.505 0 .856.35.35.35.35.855z"/></g></g>' }, selection: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#42526E" d="M.5 0h16v16H.5z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.333 12v4.667q0 .354-.24.593a.8.8 0 01-.593.24.8.8 0 01-.594-.24.8.8 0 01-.24-.593V10q0-.354.24-.594t.594-.24h6.667q.354 0 .593.24.24.24.24.594t-.24.594a.8.8 0 01-.593.24H12.5l5.25 5.25a.8.8 0 01.23.583.8.8 0 01-.23.583.8.8 0 01-.583.23.8.8 0 01-.584-.23zm-7.5-7.833a.8.8 0 01-.593-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.593-.24.354 0 .594.24t.24.593-.24.594a.8.8 0 01-.594.24m3.334 0a.8.8 0 01-.594-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.594-.24t.593.24.24.593-.24.594a.8.8 0 01-.593.24m3.333 0a.8.8 0 01-.594-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.594-.24t.594.24.24.593-.24.594a.8.8 0 01-.594.24m3.333 0a.8.8 0 01-.593-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.593-.24.354 0 .594.24t.24.593-.24.594a.8.8 0 01-.594.24m3.334 0a.8.8 0 01-.594-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.594-.24t.593.24.24.593-.24.594a.8.8 0 01-.593.24m-10 13.333a.8.8 0 01-.594-.24.8.8 0 01-.24-.593q0-.354.24-.594t.594-.24.593.24.24.594-.24.593a.8.8 0 01-.593.24m-3.334-10a.8.8 0 01-.593-.24.8.8 0 01-.24-.593q0-.354.24-.594t.593-.24.594.24.24.594-.24.593a.8.8 0 01-.594.24m0 3.333a.8.8 0 01-.593-.24A.8.8 0 013 10q0-.354.24-.594t.593-.24.594.24.24.594-.24.594a.8.8 0 01-.594.24m0 3.334a.8.8 0 01-.593-.24.8.8 0 01-.24-.594q0-.354.24-.593.24-.24.593-.24.354 0 .594.24t.24.593-.24.594a.8.8 0 01-.594.24m0 3.333a.8.8 0 01-.593-.24.8.8 0 01-.24-.593q0-.354.24-.594t.593-.24.594.24.24.594-.24.593a.8.8 0 01-.594.24m13.334-10a.8.8 0 01-.594-.24.8.8 0 01-.24-.593q0-.354.24-.594t.594-.24.593.24.24.594-.24.593a.8.8 0 01-.593.24"/></g>' }, seperator: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M2.167 8.5a.48.48 0 01-.356-.143A.48.48 0 011.667 8q0-.212.144-.356a.48.48 0 01.356-.143h11.666q.212 0 .357.143a.48.48 0 01.143.357q0 .213-.143.356a.48.48 0 01-.357.144zm3.269-2a.58.58 0 01-.43-.173.58.58 0 01-.173-.429v-.462q0-.255.174-.429a.58.58 0 01.429-.173h5.128q.255 0 .43.173a.58.58 0 01.173.43v.461q0 .255-.173.43a.58.58 0 01-.43.173zm0 4.667a.58.58 0 01-.43-.173.58.58 0 01-.173-.43v-.46q0-.258.174-.43a.58.58 0 01.429-.173h5.128q.255 0 .43.173a.58.58 0 01.173.43v.46q0 .258-.173.43a.58.58 0 01-.43.173z"/></g></g>' }, settings: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.125 16.125H7.857a.63.63 0 01-.432-.169.7.7 0 01-.225-.431l-.225-1.688a2.8 2.8 0 01-.609-.28 6 6 0 01-.572-.395l-1.556.675a.7.7 0 01-.863-.28l-1.125-1.97a.64.64 0 01-.075-.478.7.7 0 01.244-.403l1.369-1.031a2 2 0 01-.047-.338 6 6 0 010-.656 2.5 2.5 0 01.047-.356L2.419 7.294a.7.7 0 01-.244-.403.64.64 0 01.075-.479l1.125-1.95a.64.64 0 01.375-.3.67.67 0 01.47.02l1.574.655a4.8 4.8 0 011.181-.675L7.2 2.475a.7.7 0 01.225-.431.63.63 0 01.432-.17h2.268a.65.65 0 01.45.17q.187.168.225.43l.225 1.688q.337.132.61.29.27.16.553.385l1.594-.656a.65.65 0 01.46-.019.72.72 0 01.383.3l1.125 1.95q.132.225.075.479a.7.7 0 01-.243.403l-1.388 1.05q.038.187.038.337V9q0 .15-.01.309a3 3 0 01-.047.366l1.37 1.031q.205.15.262.403a.6.6 0 01-.094.478l-1.125 1.95a.64.64 0 01-.375.3.73.73 0 01-.488-.018l-1.537-.657q-.281.226-.572.394a4 4 0 01-.59.281l-.226 1.688a.7.7 0 01-.225.431.65.65 0 01-.45.169M9 11.25a2.17 2.17 0 001.594-.656A2.17 2.17 0 0011.25 9a2.17 2.17 0 00-.656-1.594A2.17 2.17 0 009 6.75a2.17 2.17 0 00-1.593.656A2.17 2.17 0 006.75 9q0 .937.657 1.594A2.17 2.17 0 009 11.25m0-1.125q-.468 0-.796-.329A1.08 1.08 0 017.875 9q0-.469.329-.797.328-.328.796-.328t.797.328.328.797-.328.796a1.08 1.08 0 01-.797.329M8.25 15h1.482l.262-2.006q.582-.15 1.05-.432.47-.281.919-.712l1.856.787.75-1.275-1.631-1.218q.093-.3.122-.582a5.7 5.7 0 000-1.134 2.6 2.6 0 00-.122-.553l1.631-1.238-.731-1.275-1.894.788a4.1 4.1 0 00-.9-.704 4 4 0 00-1.05-.44L9.75 3H8.27l-.263 2.006a3.8 3.8 0 00-1.05.413 5 5 0 00-.938.712l-1.856-.769-.731 1.275 1.612 1.2a3 3 0 00-.131.563 4.6 4.6 0 000 1.181q.038.281.131.563l-1.612 1.218.73 1.275 1.857-.787q.432.431.919.712.487.282 1.069.432z"/></g>', width: 18, height: 18 }, "settings-filled": { body: '<mask id="svgID0" width="36" height="36" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#4B5768" d="M0 0h36v36H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M16.338 32.25a1.9 1.9 0 01-1.325-.51 2.1 2.1 0 01-.68-1.252l-.366-2.807a7 7 0 01-1.236-.566 8 8 0 01-1.132-.778L9 27.44a1.87 1.87 0 01-1.42.06 2.05 2.05 0 01-1.11-.91l-1.69-2.93a1.84 1.84 0 01-.228-1.398q.168-.737.767-1.216l2.247-1.687a8 8 0 01-.073-.672 11 11 0 010-1.323q.021-.33.073-.723L5.32 14.954q-.6-.48-.76-1.223a1.88 1.88 0 01.235-1.405L6.47 9.438q.396-.646 1.11-.904.713-.258 1.42.053l2.585 1.091a10 10 0 011.158-.786 7.7 7.7 0 011.21-.573l.38-2.807q.122-.743.68-1.253a1.9 1.9 0 011.325-.509h3.324a1.9 1.9 0 011.325.51q.558.507.68 1.253l.366 2.82q.675.246 1.221.573.547.328 1.104.772l2.657-1.09a1.84 1.84 0 011.42-.054 2.1 2.1 0 011.109.904l1.676 2.903q.396.66.228 1.397a2.1 2.1 0 01-.767 1.216l-2.305 1.73q.08.365.088.68t.007.636q0 .306-.015.622-.013.315-.103.722l2.261 1.702q.6.48.775 1.216.174.737-.22 1.398l-1.7 2.916q-.395.66-1.116.912-.72.25-1.428-.061l-2.567-1.105q-.557.444-1.137.786a7 7 0 01-1.188.558l-.367 2.822q-.12.744-.68 1.253a1.9 1.9 0 01-1.324.509zm1.68-9.75q1.872 0 3.185-1.314 1.314-1.314 1.314-3.186t-1.314-3.186-3.186-1.314q-1.895 0-3.197 1.314T13.517 18t1.303 3.186 3.197 1.314"/></g>', width: 36, height: 36 }, "settings-input-antenna": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M10 5.833q-1.584 0-2.75 1.032a4.07 4.07 0 00-1.375 2.593.52.52 0 01-.218.396.74.74 0 01-.449.146.57.57 0 01-.447-.198.54.54 0 01-.136-.469q.23-2.062 1.76-3.406T10 4.583q2.084 0 3.614 1.344 1.532 1.344 1.76 3.406a.55.55 0 01-.134.469.58.58 0 01-.448.198.74.74 0 01-.449-.146.52.52 0 01-.218-.396 4.07 4.07 0 00-1.375-2.593Q11.584 5.833 10 5.833M10 2.5q-2.958 0-5.093 2-2.136 2-2.386 4.958a.54.54 0 01-.209.396.7.7 0 01-.437.146.58.58 0 01-.448-.198.6.6 0 01-.156-.469 8.5 8.5 0 01.854-3.177 8.8 8.8 0 011.907-2.563A8.8 8.8 0 016.75 1.875 8.6 8.6 0 0110 1.25q1.73 0 3.26.625a9 9 0 012.71 1.708 8.64 8.64 0 012.76 5.75.6.6 0 01-.157.469.58.58 0 01-.448.198.7.7 0 01-.438-.146.54.54 0 01-.208-.396Q17.23 6.5 15.094 4.5T10 2.5"/><path d="M9.292 20q-.255 0-.482-.098a1.3 1.3 0 01-.39-.263l-2.243-2.242q-.3-.3-.338-.752a1.35 1.35 0 01.173-.813q.195-.33.534-.466.339-.135.64-.06l1.173.27v-4.905q0-.632.436-1.068.436-.435 1.069-.436.631 0 1.068.436.435.436.436 1.068v2.588h.392q.075 0 .135.03t.135.06l2.227 1.084q.362.165.535.534.172.37.097.76l-.541 3.28q-.075.436-.422.715-.345.278-.782.278zm0-1.204h3.852l.572-3.28-2.498-1.234h-1.053v-3.61a.3.3 0 00-.083-.22.3.3 0 00-.218-.082.3.3 0 00-.218.083.3.3 0 00-.083.218v6.38l-2.558-.542z"/></g>', width: 20, height: 20 }, "setup-agent": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M2.917 6.84v6.32a1.47 1.47 0 00.753 1.301l4.824 2.774a.6.6 0 00.62-.002.58.58 0 00.309-.535.61.61 0 00-.312-.532l-4.816-2.803a.3.3 0 01-.096-.096.24.24 0 01-.032-.12V7.343l5.059 2.944a1.48 1.48 0 001.506 0l5.101-2.944V9.31q0 .265.18.445t.445.18.446-.18.18-.445V6.839a1.47 1.47 0 00-.754-1.3l-5.577-3.21a1.4 1.4 0 00-.36-.155 1.5 1.5 0 00-.776 0 2 2 0 00-.37.154L3.67 5.538a1.47 1.47 0 00-.753 1.301"/><path d="M18.75 15.729q0 1.56-1.095 2.655T15 19.48t-2.655-1.095-1.095-2.655 1.095-2.656Q13.439 11.98 15 11.98t2.655 1.094 1.095 2.656m-2.825.368-1.16 1.16a.37.37 0 00-.114.256.35.35 0 00.113.264.36.36 0 00.26.117.36.36 0 00.26-.117l1.52-1.521a.7.7 0 00.214-.528.7.7 0 00-.213-.526l-1.521-1.521a.37.37 0 00-.256-.113.35.35 0 00-.264.113.36.36 0 00-.117.26q0 .141.12.262l1.158 1.157h-2.888a.35.35 0 00-.258.11.354.354 0 000 .517q.11.11.258.11z"/></g>', width: 20, height: 20 }, "shield-info": { body: '<path fill="currentColor" fill-opacity=".773" d="M4.567 9.943h.866V6.06h-.866zM4.997 5a.465.465 0 00.475-.468.465.465 0 00-.469-.476.465.465 0 00-.475.469.465.465 0 00.468.475M5 13.054q-2.096-.557-3.481-2.435A6.9 6.9 0 01.133 6.417V2.83L5 .959l4.867 1.872v3.586a6.9 6.9 0 01-1.386 4.202Q7.096 12.497 5 13.054m0-.904q1.733-.537 2.867-2.15A6.1 6.1 0 009 6.417v-3L5 1.89 1 3.417v3A6.1 6.1 0 002.133 10Q3.267 11.613 5 12.15"/>', width: 10, height: 14 }, "short-text": { body: '<g fill="none"><mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M6.629 11.258a.6.6 0 01-.448-.18.6.6 0 01-.181-.45q0-.267.18-.447.181-.18.449-.181h11.742q.267 0 .448.18.18.182.181.45 0 .267-.18.447a.6.6 0 01-.449.181zm0 3.355a.6.6 0 01-.448-.181.6.6 0 01-.181-.448q0-.268.18-.448a.6.6 0 01.449-.181h6.71q.267 0 .448.18.18.18.18.45 0 .266-.18.447-.18.18-.448.18z"/></g></g>', width: 24, height: 24 }, simulator: { body: '<mask id="svgID0" width="100" height="100" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h100v100H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M30.417 93.75q-3.126 0-5.313-2.187-2.187-2.189-2.187-5.313v-72.5q0-3.125 2.187-5.312 2.189-2.188 5.313-2.188h39.166q3.126 0 5.313 2.188 2.187 2.187 2.187 5.312v72.5q0 3.125-2.187 5.313-2.189 2.187-5.313 2.187zm-1.25-19.687V86.25q0 .417.416.833.417.417.834.417h39.166q.417 0 .834-.417.416-.417.416-.833V74.063zM50 84.479q1.563 0 2.604-1.096 1.042-1.09 1.042-2.654 0-1.458-1.042-2.554-1.041-1.092-2.604-1.092t-2.604 1.092q-1.042 1.096-1.042 2.554 0 1.563 1.042 2.654Q48.437 84.48 50 84.48M29.167 67.813h41.666V23.958H29.167zm0-50.105h41.666V13.75q0-.417-.416-.833-.417-.417-.834-.417H30.417q-.417 0-.834.417-.416.416-.416.833zm0 56.355V87.5z"/><path d="M34 49.23c0-1.091.885-1.976 1.977-1.976h27.236a1.977 1.977 0 110 3.953H35.977A1.977 1.977 0 0134 49.231"/><path d="M62.41 59a1.977 1.977 0 00.724-2.7L49.516 32.711a1.977 1.977 0 10-3.424 1.977L59.71 58.276a1.977 1.977 0 002.7.723"/><path d="M37.59 59a1.977 1.977 0 01-.723-2.7l13.618-23.588a1.977 1.977 0 013.424 1.977L40.29 58.276a1.977 1.977 0 01-2.7.723"/></g>', width: 100, height: 100 }, skip: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.923 11.038V4.961q0-.212.144-.356a.48.48 0 01.357-.144q.212 0 .356.144a.48.48 0 01.143.356v6.077q0 .212-.144.357a.48.48 0 01-.356.143.48.48 0 01-.356-.143.48.48 0 01-.144-.357m-6.846-.628V5.59q0-.272.18-.437a.6.6 0 01.423-.166q.083 0 .17.017a.4.4 0 01.164.077l3.62 2.42a.6.6 0 01.203.22.6.6 0 01.066.279.6.6 0 01-.066.28.6.6 0 01-.202.219l-3.62 2.42a.4.4 0 01-.165.077 1 1 0 01-.17.017.6.6 0 01-.422-.166.56.56 0 01-.18-.437m1-.743L7.587 8l-2.51-1.667z"/></g>' }, "skip-next": { body: '<path fill="currentColor" d="M6.923 7.038V.961q0-.212.144-.356a.48.48 0 01.356-.144q.212 0 .357.144a.48.48 0 01.143.356v6.077q0 .212-.144.357a.48.48 0 01-.356.143.48.48 0 01-.356-.143.48.48 0 01-.144-.357M.077 6.41V1.59q0-.272.18-.437A.6.6 0 01.68.987q.083 0 .17.017a.4.4 0 01.164.077l3.62 2.42a.6.6 0 01.203.22.6.6 0 01.066.279.6.6 0 01-.066.28.6.6 0 01-.202.219l-3.62 2.42a.4.4 0 01-.165.077 1 1 0 01-.17.017.6.6 0 01-.422-.166.56.56 0 01-.18-.437m1-.743L3.587 4l-2.51-1.667z"/>', width: 8, height: 8 }, sliders: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.333 9.667q-.698 0-1.182-.484a1.6 1.6 0 01-.484-1.182q0-.699.484-1.183a1.6 1.6 0 011.182-.484h9.334q.699 0 1.182.484.484.484.484 1.183.001.698-.484 1.182a1.6 1.6 0 01-1.182.484zm6-1h3.334a.65.65 0 00.475-.191.65.65 0 00.191-.475.65.65 0 00-.191-.475.65.65 0 00-.475-.192H9.333z"/></g>' }, "smart-display": { body: '<path fill="currentColor" d="m11.008 12.646 4.346-2.742q.496-.32.496-.904 0-.583-.496-.904l-4.346-2.742q-.525-.35-1.079-.058-.554.291-.554.933v5.542q0 .642.554.933.555.292 1.08-.058M3.017 17.75q-.876 0-1.488-.613a2.03 2.03 0 01-.612-1.487V2.35q0-.875.612-1.487A2.03 2.03 0 013.017.25h17.966q.876 0 1.488.613.612.612.612 1.487v13.3q0 .876-.612 1.487a2.03 2.03 0 01-1.488.613zm0-1.75h17.966a.34.34 0 00.249-.101.34.34 0 00.101-.249V2.35a.34.34 0 00-.101-.247.34.34 0 00-.249-.103H3.017a.34.34 0 00-.248.103.34.34 0 00-.102.247v13.3q0 .146.102.248t.248.102"/>', width: 25, height: 20 }, soql: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 7.452q1.8 0 3.659-.52 1.857-.518 2.15-1.11-.285-.605-2.118-1.13A13.3 13.3 0 0010 4.167q-1.848 0-3.675.519-1.827.52-2.15 1.136.328.604 2.165 1.117a13.6 13.6 0 003.66.513m-7.083 6.634V5.833q0-.584.577-1.111.578-.528 1.555-.93.977-.403 2.261-.639A15 15 0 0110 2.917q1.398 0 2.682.236 1.284.237 2.261.643.976.405 1.559.93.58.524.581 1.107 0 .56-.597 1.076-.599.516-1.587.918-.99.401-2.265.638-1.277.237-2.634.237-1.755 0-3.275-.333-1.52-.332-2.558-.952v2.713q.772.613 1.927.964 1.155.35 2.454.464a.64.64 0 01.433.211.65.65 0 01.166.452.6.6 0 01-.173.433.5.5 0 01-.426.154 15 15 0 01-2.305-.362q-1.206-.28-2.076-.798v2.519q.33.575 1.64 1.006t3.467.583a.62.62 0 01.433.225.7.7 0 01.166.464.64.64 0 01-.173.453.54.54 0 01-.439.172 13.5 13.5 0 01-2.465-.264 9.3 9.3 0 01-2.017-.639q-.864-.399-1.363-.93-.5-.532-.5-1.15m10.865 2.997a3.18 3.18 0 01-2.336-.965 3.18 3.18 0 01-.965-2.336q0-1.37.965-2.336a3.18 3.18 0 012.336-.965q1.37 0 2.336.965.965.966.965 2.336 0 .502-.144.974a3.3 3.3 0 01-.423.882l1.795 1.795q.172.172.177.435a.6.6 0 01-.177.443.58.58 0 01-.44.177.63.63 0 01-.438-.177l-1.795-1.787q-.419.255-.886.407a3.1 3.1 0 01-.97.152m0-1.25q.86 0 1.455-.596t.596-1.455a1.98 1.98 0 00-.596-1.455 1.98 1.98 0 00-1.455-.596 1.98 1.98 0 00-1.455.596 1.98 1.98 0 00-.596 1.455q0 .86.596 1.455a1.98 1.98 0 001.455.596"/></g>', width: 20, height: 20 }, sort: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 16h16V0H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.333 4H2.667a.64.64 0 00-.475.192.64.64 0 00-.192.475q0 .284.192.474a.64.64 0 00.475.192h2.666a.65.65 0 00.476-.192A.65.65 0 006 4.667a.65.65 0 00-.191-.475A.65.65 0 005.333 4m8 6.667H2.667a.64.64 0 00-.475.191.65.65 0 00-.192.475q0 .284.192.476a.65.65 0 00.475.191h10.666a.65.65 0 00.475-.191.65.65 0 00.192-.476.65.65 0 00-.192-.475.64.64 0 00-.475-.191m-4-3.334H2.667a.64.64 0 00-.475.192A.64.64 0 002 8q0 .283.192.475a.65.65 0 00.475.192h6.666a.65.65 0 00.476-.192A.65.65 0 0010 8a.65.65 0 00-.191-.475.65.65 0 00-.476-.192"/></g>' }, "sort-asc": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 24h24V0H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M3.894 4.149 1.9 6.143a.74.74 0 00.015 1.07q.209.207.507.212.3.004.532-.203l.823-.779V19.17q0 .32.215.535a.73.73 0 00.535.215.73.73 0 00.534-.215.73.73 0 00.216-.535V6.443l.823.779a.76.76 0 00.54.2.7.7 0 00.514-.225.7.7 0 00.217-.522.72.72 0 00-.217-.532L5.16 4.15a.87.87 0 00-.633-.271.87.87 0 00-.633.27m7.861 15.271H8.389a.6.6 0 01-.45-.182.6.6 0 01-.181-.45.6.6 0 01.181-.449.6.6 0 01.45-.181h3.366a.6.6 0 01.45.181q.18.182.18.45a.6.6 0 01-.18.45.6.6 0 01-.45.181m10.097-8.738H8.389a.6.6 0 01-.45-.181.6.6 0 01-.181-.45.6.6 0 01.181-.45.6.6 0 01.45-.181h13.463a.6.6 0 01.45.182q.18.18.18.45a.6.6 0 01-.18.449.6.6 0 01-.45.181m-5.049 4.37H8.39a.6.6 0 01-.45-.182.6.6 0 01-.181-.45.6.6 0 01.181-.45.6.6 0 01.45-.181h8.414a.6.6 0 01.45.181.6.6 0 01.181.45.6.6 0 01-.181.45.6.6 0 01-.45.181"/></g>', width: 24, height: 24 }, "sort-desc": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M3.895 19.851 1.9 17.857a.74.74 0 01.016-1.07.7.7 0 01.507-.212q.298-.004.531.203l.823.779V4.83q0-.32.216-.535a.73.73 0 01.534-.215q.32 0 .535.215a.73.73 0 01.215.535v12.727l.823-.779a.76.76 0 01.54-.2q.306.007.514.225a.7.7 0 01.218.522q0 .315-.218.532L5.16 19.85a.87.87 0 01-.633.271.87.87 0 01-.632-.27m7.86-15.271H8.389a.6.6 0 00-.45.181.6.6 0 00-.18.45q0 .27.18.45.183.18.45.181h3.366a.6.6 0 00.45-.181.6.6 0 00.181-.45.6.6 0 00-.181-.45.6.6 0 00-.45-.181m10.097 8.738H8.39a.6.6 0 00-.45.181.6.6 0 00-.18.45q0 .27.18.45.183.18.45.181h13.463a.6.6 0 00.45-.182.6.6 0 00.181-.45.6.6 0 00-.181-.449.6.6 0 00-.45-.181m-5.048-4.37H8.389a.6.6 0 00-.45.182.6.6 0 00-.18.45q0 .27.18.45.183.18.45.181h8.415a.6.6 0 00.45-.181.6.6 0 00.18-.45.6.6 0 00-.18-.45.6.6 0 00-.45-.181"/></g>', width: 24, height: 24 }, "source-notes": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.997 15.23a3.1 3.1 0 01-1.699-.488 3.3 3.3 0 01-1.165-1.269.35.35 0 01-.021-.305.4.4 0 01.204-.227.4.4 0 01.298-.012q.153.051.234.197a2.4 2.4 0 00.865.947q.568.363 1.285.363 1.014 0 1.726-.713A2.35 2.35 0 0014.436 12q0-1.01-.713-1.723A2.35 2.35 0 0012 9.565q-.548 0-1.034.236-.487.236-.85.636h.718a.386.386 0 01.397.397.386.386 0 01-.397.398H9.372a.58.58 0 01-.43-.173.58.58 0 01-.173-.43V9.167a.386.386 0 01.398-.398.387.387 0 01.397.398v.693a3.6 3.6 0 011.095-.79q.632-.3 1.341-.3 1.341 0 2.286.944.945.945.945 2.286t-.946 2.286-2.288.945m-1.33-9.32q.213 0 .356-.144a.48.48 0 00.144-.356.48.48 0 00-.144-.356.48.48 0 00-.356-.144H5.333a.48.48 0 00-.356.144.48.48 0 00-.144.357q0 .212.144.356a.48.48 0 00.356.143zM9.34 7.5H5.333a.48.48 0 00-.356.144.48.48 0 00-.144.356q0 .213.144.356a.48.48 0 00.356.144h2.802a5 5 0 01.554-.553q.3-.255.65-.447m-2.213 2.59H5.333a.48.48 0 00-.356.144.48.48 0 00-.144.356q0 .212.144.356a.48.48 0 00.356.144h1.521a3 3 0 01.106-.514q.072-.246.167-.486M3.54 13.667a1.16 1.16 0 01-.851-.354 1.16 1.16 0 01-.355-.852V3.54q0-.498.355-.852a1.16 1.16 0 01.85-.354h8.924q.497 0 .85.354.355.354.355.852v3.517a4 4 0 00-.49-.156 4 4 0 00-.51-.091V3.54a.2.2 0 00-.064-.142.2.2 0 00-.141-.064H3.539a.2.2 0 00-.141.064.2.2 0 00-.065.142v8.923q0 .076.065.14.064.065.14.065H6.81q.027.26.09.51.065.251.158.49z"/></g>' }, "space-dashboard": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.975 15.375q-.563 0-.956-.394a1.3 1.3 0 01-.394-.956V3.975q0-.563.394-.956.393-.394.956-.394h10.05q.563 0 .956.394.394.393.394.956v10.05q0 .563-.394.956a1.3 1.3 0 01-.956.394zm0-1.125h4.463V3.75H3.975q-.075 0-.15.075t-.075.15v10.05q0 .075.075.15t.15.075m5.588 0h4.462q.075 0 .15-.075t.075-.15V9H9.563zm0-6.375h4.687v-3.9q0-.075-.075-.15t-.15-.075H9.563z"/></g>', width: 18, height: 18 }, speed: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.95 11.513q.394.393 1.032.374.637-.018.919-.45l3-4.35q.169-.243-.038-.44-.206-.197-.45-.047l-4.35 3q-.431.282-.469.9t.357 1.012m-4.124 3.112q-.3 0-.563-.141a1.1 1.1 0 01-.431-.421 7.6 7.6 0 01-.694-1.632 6.7 6.7 0 01-.262-1.931q0-1.463.562-2.756a7.5 7.5 0 011.519-2.269 7 7 0 012.26-1.537A6.95 6.95 0 019 3.375q.862 0 1.622.178.759.178 1.471.535.32.168.366.44.047.272-.178.516a.5.5 0 01-.31.131.8.8 0 01-.346-.037 5.8 5.8 0 00-1.266-.478A5.7 5.7 0 009 4.5q-2.493 0-4.246 1.753Q3.001 8.007 3.001 10.5q0 .788.215 1.556.216.77.61 1.444h10.35q.431-.713.628-1.481a6.4 6.4 0 00.197-1.594q0-.656-.16-1.312a5.7 5.7 0 00-.478-1.275.6.6 0 01-.066-.367.56.56 0 01.197-.327.52.52 0 01.498-.113q.27.075.402.357.357.75.535 1.48.178.732.197 1.538a7.7 7.7 0 01-.234 1.922 7.3 7.3 0 01-.723 1.772q-.15.243-.421.384a1.2 1.2 0 01-.572.141z"/></g>', width: 18, height: 18 }, splitscreen: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M9.333 10.539h1.936a.58.58 0 00.43-.173.58.58 0 00.173-.43V6.064a.58.58 0 00-.173-.43.58.58 0 00-.43-.173H9.333a.58.58 0 00-.43.173.58.58 0 00-.172.43v3.872q0 .258.172.43a.58.58 0 00.43.173m-4.602 0h1.936a.58.58 0 00.43-.173.58.58 0 00.172-.43V6.064a.58.58 0 00-.172-.43.58.58 0 00-.43-.173H4.73a.58.58 0 00-.43.173.58.58 0 00-.173.43v3.872q0 .258.173.43a.58.58 0 00.43.173M2.87 13q-.504 0-.854-.35a1.16 1.16 0 01-.35-.855v-7.59q0-.505.35-.855T2.872 3h10.256q.506 0 .855.35.35.35.35.855v7.59q0 .505-.35.855t-.855.35zm10.257-9H2.872a.2.2 0 00-.141.064.2.2 0 00-.064.141v7.59q0 .077.064.14.065.066.14.065h10.257a.2.2 0 00.141-.064.2.2 0 00.064-.141v-7.59a.2.2 0 00-.064-.14.2.2 0 00-.14-.065"/></g></g>' }, square: { body: '<path fill="currentColor" d="M.706 8a.68.68 0 01-.5-.206.68.68 0 01-.206-.5V.706a.68.68 0 01.206-.5.68.68 0 01.5-.206h6.588a.68.68 0 01.5.206.68.68 0 01.206.5v6.588a.68.68 0 01-.206.5.68.68 0 01-.5.206z"/>', width: 8, height: 8 }, "star-half": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.45 5.025v6.842l2.763 1.688-.723-3.158 2.434-2.105-3.202-.285zm0 8.399-3.42 2.04a.65.65 0 01-.724-.022.75.75 0 01-.242-.296.55.55 0 01-.022-.407l.9-3.86L2.936 8.27a.65.65 0 01-.197-.724.7.7 0 01.208-.296.64.64 0 01.362-.142l3.97-.351 1.556-3.662a.63.63 0 01.253-.297.7.7 0 01.361-.098q.198 0 .362.098.165.099.252.297l1.557 3.662 3.97.35a.65.65 0 01.57.44.64.64 0 01-.198.723l-3.004 2.61.9 3.86a.55.55 0 01-.023.406.75.75 0 01-.241.295.65.65 0 01-.724.022z"/></g>', width: 18, height: 18 }, "star-rate": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m6.75 12.78 2.19-1.688 2.189 1.687-.821-2.782 2.052-1.46H9.806L8.94 5.71l-.867 2.828H5.52l2.052 1.46zm2.19.022-3.08 2.349a.56.56 0 01-.41.149.7.7 0 01-.388-.126.7.7 0 01-.274-.33.64.64 0 01-.022-.446l1.185-3.854-2.964-2.12a.6.6 0 01-.262-.353.72.72 0 01.251-.765.65.65 0 01.421-.136h3.695l1.185-3.968a.83.83 0 01.274-.365.64.64 0 01.388-.137q.205 0 .387.137a.83.83 0 01.274.365l1.186 3.968h3.694q.25 0 .422.136a.72.72 0 01.25.765.6.6 0 01-.262.353l-2.964 2.12 1.186 3.854a.64.64 0 01-.023.445.7.7 0 01-.274.33.7.7 0 01-.388.127.56.56 0 01-.41-.15z"/></g>', width: 18, height: 18 }, "step-group": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.5 6.667h2.2a.484.484 0 00.5-.5.486.486 0 00-.5-.5H8.5a.485.485 0 00-.5.5.484.484 0 00.5.5m0 3.667h2.2a.484.484 0 00.5-.5.486.486 0 00-.5-.5H8.5a.485.485 0 00-.5.5.484.484 0 00.5.5M5.532 7.25h.933a.6.6 0 00.442-.175.6.6 0 00.175-.442V5.7a.6.6 0 00-.175-.442.6.6 0 00-.442-.175h-.933a.6.6 0 00-.617.617v.933a.6.6 0 00.617.617m0 3.667h.933a.6.6 0 00.442-.175.6.6 0 00.175-.442v-.933a.6.6 0 00-.175-.442.6.6 0 00-.442-.175h-.933a.6.6 0 00-.617.617v.933a.6.6 0 00.617.617m-2 2.75q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.534q0-.5.35-.85t.85-.35h8.933q.5 0 .85.35t.35.85v8.933q0 .5-.35.85t-.85.35zm0-1h8.933q.067 0 .133-.067.067-.067.067-.133V3.534q0-.068-.067-.134-.066-.066-.133-.066H3.533q-.068 0-.134.066-.066.068-.066.134v8.933q0 .067.066.133.068.067.134.067"/></g>' }, "step-over": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.764 6.821q.64 0 1.288.362a3.1 3.1 0 011.07.985h-.808a.5.5 0 00-.354.143.48.48 0 00-.151.363q0 .219.151.362a.5.5 0 00.354.143h1.92q.27 0 .438-.176a.6.6 0 00.168-.43v-1.92a.5.5 0 00-.143-.363.5.5 0 00-.362-.143.5.5 0 00-.354.143.48.48 0 00-.151.363v.791a3.8 3.8 0 00-1.39-1.22 3.7 3.7 0 00-1.676-.413q-1.33 0-2.298.791a3.58 3.58 0 00-1.255 1.97.49.49 0 00.093.422q.143.185.345.185.185 0 .345-.118a.55.55 0 00.21-.286 2.47 2.47 0 01.91-1.398 2.6 2.6 0 011.65-.556M8 14.401q-1.33-.001-2.5-.506a6.5 6.5 0 01-2.03-1.364 6.5 6.5 0 01-1.365-2.03A6.2 6.2 0 011.6 8q0-1.332.505-2.502a6.5 6.5 0 011.365-2.03A6.5 6.5 0 015.5 2.106 6.2 6.2 0 018 1.6q1.33 0 2.502.505 1.17.506 2.029 1.365a6.5 6.5 0 011.364 2.029Q14.4 6.669 14.4 8a6.2 6.2 0 01-.505 2.5 6.5 6.5 0 01-1.364 2.03 6.5 6.5 0 01-2.03 1.365 6.25 6.25 0 01-2.5.505m0-1.011q2.24 0 3.815-1.575T13.39 8t-1.575-3.815Q10.24 2.611 8 2.611T4.186 4.185 2.61 8t1.575 3.815Q5.76 13.39 8 13.39"/></g>' }, "step-over-live-editor": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.001 12.5a1.77 1.77 0 01-1.299-.535 1.77 1.77 0 01-.535-1.298q0-.763.534-1.299A1.77 1.77 0 018 8.833q.764 0 1.3.535.534.534.535 1.298 0 .764-.535 1.298a1.77 1.77 0 01-1.298.536m3.55-5.667a4.1 4.1 0 00-1.446-1.569A3.83 3.83 0 008 4.666a3.83 3.83 0 00-2.296.732 4 4 0 00-1.447 1.879q-.075.22-.232.388a.5.5 0 01-.375.168.43.43 0 01-.366-.184.43.43 0 01-.071-.397 4.9 4.9 0 011.76-2.575q1.306-1.01 3.01-1.01 1.23 0 2.257.542a5 5 0 011.703 1.451V4.128q0-.212.143-.356a.48.48 0 01.357-.144q.213 0 .356.144a.48.48 0 01.144.356V7.23q0 .255-.174.429a.58.58 0 01-.43.173H9.238a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.213.144-.356a.48.48 0 01.356-.144z"/></g>' }, "step-over-next": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 12.5a1.77 1.77 0 01-1.298-.534 1.77 1.77 0 01-.535-1.298q0-.765.534-1.3A1.77 1.77 0 018 8.834q.764 0 1.299.535.535.534.535 1.298T9.3 11.965A1.77 1.77 0 018 12.5m3.55-5.667a4.1 4.1 0 00-1.445-1.568A3.83 3.83 0 008 4.667a3.83 3.83 0 00-2.296.731 4 4 0 00-1.448 1.879q-.075.22-.231.388a.5.5 0 01-.375.168.43.43 0 01-.366-.184.43.43 0 01-.071-.396 4.9 4.9 0 011.76-2.576q1.305-1.01 3.01-1.01 1.23 0 2.257.543a5 5 0 011.702 1.45V4.128q0-.212.144-.356a.48.48 0 01.356-.144q.212 0 .357.144a.48.48 0 01.143.356v3.103q0 .255-.173.43a.58.58 0 01-.43.172H9.238a.48.48 0 01-.356-.143.48.48 0 01-.144-.357q0-.213.144-.356a.48.48 0 01.356-.144z"/></g>' }, "step-result": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.683 7.5q.184-2.45 1.992-4.142T8 1.667q1.317 0 2.467.5a6.4 6.4 0 012.008 1.358 6.4 6.4 0 011.358 2.008q.5 1.151.5 2.467a6.1 6.1 0 01-.5 2.459 6.4 6.4 0 01-1.358 2.016 6.4 6.4 0 01-2.008 1.358q-1.151.5-2.467.5a6.3 6.3 0 01-1.667-.224 6.3 6.3 0 01-1.566-.676q-.234-.133-.25-.366a.52.52 0 01.166-.417.5.5 0 01.292-.141.44.44 0 01.308.058q.65.366 1.326.566.675.2 1.391.2 2.217 0 3.775-1.558Q13.334 10.217 13.333 8t-1.558-3.775T8 2.667q-2.1 0-3.617 1.391Q2.868 5.45 2.683 7.5a.55.55 0 01-.158.358.5.5 0 01-.358.142.47.47 0 01-.358-.15.44.44 0 01-.126-.35m.567 3.917a.46.46 0 01-.133-.342q0-.208.133-.342l2.667-2.666a.6.6 0 01.4-.184.54.54 0 01.416.15L7.317 9.35l2.783-2.8H8.6a.46.46 0 01-.341-.142.46.46 0 01-.142-.341q0-.217.142-.35a.48.48 0 01.341-.134h2.55q.267 0 .433.167a.6.6 0 01.167.433v2.55a.48.48 0 01-.133.342.46.46 0 01-.35.142.46.46 0 01-.342-.142.46.46 0 01-.142-.342v-1.5L7.75 10.267a.6.6 0 01-.4.183.54.54 0 01-.417-.15L5.35 8.983l-2.417 2.434a.46.46 0 01-.34.133.46.46 0 01-.343-.133"/></g>' }, "step-type-switch": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M4.402 16.074a1.28 1.28 0 01-.94-.388 1.28 1.28 0 01-.388-.94V6.334q0-.553.387-.94a1.28 1.28 0 01.94-.388h11.364q.553 0 .94.388.388.387.388.94v8.412q0 .553-.387.94a1.28 1.28 0 01-.941.388h-1.716a.54.54 0 01-.397-.157.54.54 0 01-.156-.396.54.54 0 01.156-.398.54.54 0 01.397-.156h1.716a.22.22 0 00.157-.064.22.22 0 00.064-.157V6.334a.2.2 0 00-.064-.156.2.2 0 00-.157-.065H4.402a.2.2 0 00-.157.065.2.2 0 00-.064.156v8.412q0 .092.064.157a.2.2 0 00.157.064h1.715a.537.537 0 01.554.553.54.54 0 01-.554.554z"/><path d="M8 13.86q-.462 0-.627.406-.167.405.147.72l2.103 2.102a.5.5 0 00.213.158.7.7 0 00.498 0 .5.5 0 00.211-.158l2.103-2.102q.314-.315.148-.72t-.627-.406zm-.868-2.583a.7.7 0 01-.522-.216.7.7 0 01-.216-.522.7.7 0 01.216-.522.7.7 0 01.522-.216q.308 0 .523.216a.7.7 0 01.215.522q0 .307-.215.522a.7.7 0 01-.523.216m2.84 0a.7.7 0 01-.522-.216.7.7 0 01-.215-.522.7.7 0 01.215-.522.7.7 0 01.523-.216.7.7 0 01.522.216.7.7 0 01.216.522.7.7 0 01-.216.522.7.7 0 01-.522.216m2.841 0a.7.7 0 01-.522-.216.7.7 0 01-.216-.522.7.7 0 01.216-.522.7.7 0 01.522-.216q.308 0 .523.216a.7.7 0 01.215.522q0 .307-.215.522a.7.7 0 01-.523.216M3.607 3.663a.63.63 0 01-.434-.15A.48.48 0 013 3.131q0-.23.173-.381.171-.15.434-.15H16.56q.262 0 .435.15.172.15.172.381 0 .23-.172.38t-.435.151z"/></g></g>', width: 20, height: 20 }, stop: { body: '<mask id="svgID0" width="15" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#fff" d="M.143 0h14v14h-14z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.643 9.333V4.667q0-.482.342-.824.343-.343.824-.343h4.667q.48 0 .824.343.343.342.343.824v4.666q0 .482-.343.824a1.12 1.12 0 01-.824.343H4.809q-.48 0-.824-.343a1.12 1.12 0 01-.342-.824"/></g>', width: 15, height: 14 }, "stop-circle": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.903 10.763h4.194a.65.65 0 00.475-.191.65.65 0 00.191-.475V5.903a.65.65 0 00-.191-.475.64.64 0 00-.475-.191H5.903a.64.64 0 00-.475.191.64.64 0 00-.191.475v4.194q0 .283.191.475a.65.65 0 00.475.191M8 15a6.8 6.8 0 01-2.73-.551 7.1 7.1 0 01-2.223-1.496 7.1 7.1 0 01-1.497-2.222A6.8 6.8 0 011 8q0-1.452.551-2.73a7.1 7.1 0 011.496-2.223q.944-.945 2.222-1.497A6.8 6.8 0 018 1q1.452 0 2.73.551a7.1 7.1 0 012.223 1.496q.945.944 1.497 2.222.55 1.278.551 2.73 0 1.452-.551 2.73a7.1 7.1 0 01-1.496 2.223q-.944.945-2.222 1.497A6.8 6.8 0 018 15"/></g>' }, "stop-circle-outline": { body: '<mask id="svgID0" width="12" height="12" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h12v12H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6 11a4.9 4.9 0 01-1.95-.394 5 5 0 01-1.587-1.069q-.675-.675-1.069-1.587A4.9 4.9 0 011 6q0-1.038.394-1.95a5 5 0 011.069-1.587q.675-.675 1.587-1.07A4.9 4.9 0 016 1q1.038 0 1.95.393a5 5 0 011.587 1.07q.675.675 1.069 1.587T11 6t-.394 1.95a5 5 0 01-1.069 1.587q-.675.675-1.587 1.069A4.9 4.9 0 016 11m0-1q1.662 0 2.832-1.168Q10 7.662 10 6T8.832 3.169 6 2Q4.338 2 3.169 3.168 1.999 4.339 2 6t1.169 2.832Q4.338 10 6 10M4.5 8h3q.213 0 .356-.144A.48.48 0 008 7.5v-3a.5.5 0 00-.144-.356A.5.5 0 007.5 4h-3a.48.48 0 00-.356.144A.48.48 0 004 4.5v3q0 .213.144.356A.48.48 0 004.5 8"/></g>', width: 12, height: 12 }, "stop-record": { body: '<g fill="none"><g filter="url(#svgID1)"><path fill="currentColor" d="M2 5a5 5 0 015-5h6a5 5 0 015 5v6a5 5 0 01-5 5H7a5 5 0 01-5-5z"/><mask id="svgID0" width="10" height="10" x="5" y="3" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M5.333 3.333h9.333v9.333H5.333z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M8.8 9.6h2.4a.4.4 0 00.285-.115.4.4 0 00.115-.285V6.8a.4.4 0 00-.115-.285.4.4 0 00-.285-.115H8.8a.4.4 0 00-.285.115.4.4 0 00-.115.285v2.4q0 .17.115.285A.4.4 0 008.8 9.6M10 12a3.9 3.9 0 01-1.56-.315 4 4 0 01-1.27-.855 4 4 0 01-.855-1.27A3.9 3.9 0 016 8q0-.83.315-1.56t.855-1.27a4 4 0 011.27-.855A3.9 3.9 0 0110 4q.83 0 1.56.315t1.27.855.855 1.27T14 8t-.315 1.56-.855 1.27-1.27.855A3.9 3.9 0 0110 12"/></g></g><defs><filter id="svgID1" width="20" height="20.667" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset dy=".667"/><feGaussianBlur stdDeviation=".333"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_3554_16278"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feMorphology in="SourceAlpha" radius=".667" result="effect2_dropShadow_3554_16278"/><feOffset dy="2.667"/><feGaussianBlur stdDeviation="1.333"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.02 0"/><feBlend in2="effect1_dropShadow_3554_16278" result="effect2_dropShadow_3554_16278"/><feBlend in="SourceGraphic" in2="effect2_dropShadow_3554_16278" result="shape"/></filter></defs></g>', width: 20, height: 21 }, store: { body: '<path fill="currentColor" d="M7 14q-1.455 0-2.726-.553a7.1 7.1 0 01-2.22-1.501 7.1 7.1 0 01-1.501-2.22A6.8 6.8 0 010 7q0-2.394 1.391-4.21A7.04 7.04 0 014.974.295v1.197a5.8 5.8 0 00-2.8 2.119Q1.104 5.102 1.105 7q0 2.45 1.723 4.173Q4.55 12.895 7 12.895t4.173-1.722Q12.895 9.45 12.895 7q0-1.897-1.069-3.39a5.8 5.8 0 00-2.8-2.118V.295A7.05 7.05 0 0112.61 2.79Q14 4.605 14 7q0 1.455-.553 2.726a7.1 7.1 0 01-1.501 2.22 7.1 7.1 0 01-2.22 1.501A6.8 6.8 0 017 14m0-4.31L3.574 6.262l.773-.792 2.1 2.1V0h1.106v7.571l2.1-2.1.773.792z"/>', width: 14, height: 14 }, "submit-review": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M14 0H0v14h14z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M11.185 6.417 8.91 8.692a.53.53 0 00-.167.408.6.6 0 00.182.408.62.62 0 00.408.168.53.53 0 00.409-.168l2.683-2.683a.5.5 0 00.124-.19.7.7 0 00.036-.218.7.7 0 00-.036-.22.5.5 0 00-.124-.189L9.742 3.325a.54.54 0 00-.401-.16.6.6 0 00-.416.16.57.57 0 00-.175.415q0 .241.175.416zM7.685 7 5.994 8.692a.53.53 0 00-.168.408.6.6 0 00.182.408.62.62 0 00.409.168.53.53 0 00.408-.168l2.683-2.683a.5.5 0 00.124-.19.7.7 0 00.037-.218.7.7 0 00-.037-.22.5.5 0 00-.124-.189L6.825 3.325a.54.54 0 00-.401-.16.6.6 0 00-.416.16.57.57 0 00-.175.415q0 .241.175.416l1.677 1.677H4.083q-1.21 0-2.063.853a2.8 2.8 0 00-.853 2.064v1.75q0 .248.167.415.168.168.416.168a.56.56 0 00.416-.168.56.56 0 00.167-.415V8.75q0-.73.51-1.24Q3.355 7 4.084 7z"/></g>', width: 14, height: 14 }, subtitles: { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M2.872 13q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855v-7.59q0-.505.35-.855T2.872 3h10.256q.506 0 .855.35.35.35.35.855v7.59q0 .505-.35.855t-.855.35zm0-1h10.256a.2.2 0 00.141-.064.2.2 0 00.064-.141v-7.59a.2.2 0 00-.064-.14.2.2 0 00-.14-.065H2.871a.2.2 0 00-.141.064.2.2 0 00-.064.141v7.59q0 .077.064.14.065.066.14.065m1.82-1.526h4.282q.212 0 .357-.143a.48.48 0 00.143-.357.48.48 0 00-.143-.356.48.48 0 00-.357-.144h-4.28a.48.48 0 00-.356.144.48.48 0 00-.144.357q0 .212.144.356a.48.48 0 00.356.143M7.026 7.95h4.282q.212 0 .356-.144a.48.48 0 00.144-.356.48.48 0 00-.144-.357.48.48 0 00-.356-.143H7.026a.48.48 0 00-.357.144.48.48 0 00-.143.356q0 .213.143.356a.5.5 0 00.357.144m-2.333 0q.212 0 .356-.144a.48.48 0 00.143-.356.48.48 0 00-.143-.357.48.48 0 00-.357-.143.48.48 0 00-.356.144.5.5 0 00-.144.356q0 .213.144.356a.5.5 0 00.356.144m6.615 2.525q.213 0 .356-.143a.5.5 0 00.144-.357.48.48 0 00-.144-.356.48.48 0 00-.357-.144.48.48 0 00-.356.144.48.48 0 00-.143.357q0 .212.143.356a.48.48 0 00.357.143"/></g></g>' }, "success-overridden": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M4.896 6.632 10.696 1q.344-.333.814-.333t.813.333q.345.333.344.79 0 .456-.344.789L5.71 9q-.344.333-.813.333-.47 0-.814-.333L1.01 6.018a1.06 1.06 0 01-.343-.79q0-.456.343-.79.344-.333.813-.333.47 0 .814.334zm6.437 4.701q.5 0 .85-.35t.35-.85-.35-.85a1.16 1.16 0 00-.85-.35q-.5 0-.85.35t-.35.85.35.85.85.35m0 2.4a2.3 2.3 0 001.14-.29q.52-.29.84-.77a3.84 3.84 0 00-1.98-.54 3.84 3.84 0 00-1.98.54q.321.48.84.77a2.3 2.3 0 001.14.29m0 1.6q-1.66 0-2.83-1.17t-1.17-2.83 1.17-2.83 2.83-1.17 2.83 1.17 1.17 2.83-1.17 2.83-2.83 1.17"/></g>' }, suites: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.75 8.25q-.47 0-.797-.328a1.08 1.08 0 01-.329-.797V3.75q0-.468.329-.796.327-.33.796-.329h3.375q.469 0 .797.329.328.327.328.796v3.375q0 .469-.328.797a1.08 1.08 0 01-.797.328zm0 7.125q-.47 0-.797-.328a1.08 1.08 0 01-.329-.797v-3.375q0-.468.329-.796.327-.33.796-.329h3.375q.469 0 .797.329.328.328.328.796v3.375q0 .469-.328.797a1.08 1.08 0 01-.797.328zm7.124-7.125q-.468 0-.796-.328a1.08 1.08 0 01-.329-.797V3.75q0-.468.329-.796.328-.33.796-.329h3.375q.469 0 .797.329.328.327.328.796v3.375q0 .469-.328.797a1.08 1.08 0 01-.797.328zm0 7.125q-.468 0-.796-.328a1.08 1.08 0 01-.329-.797v-3.375q0-.468.329-.796.328-.33.796-.329h3.375q.469 0 .797.329.328.328.328.796v3.375q0 .469-.328.797a1.08 1.08 0 01-.797.328zM3.75 7.125h3.375V3.75H3.75zm7.125 0h3.375V3.75h-3.375zm0 7.125h3.375v-3.375h-3.375zm-7.125 0h3.375v-3.375H3.75z"/></g>', width: 18, height: 18 }, "supervised-user-circle": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.917 11.042A2.6 2.6 0 016 10.25a2.6 2.6 0 01-.792-1.917q0-1.125.792-1.916a2.6 2.6 0 011.917-.792q1.125 0 1.916.792a2.6 2.6 0 01.792 1.916 2.6 2.6 0 01-.792 1.917 2.6 2.6 0 01-1.916.792m0-1.25q.603 0 1.031-.427.427-.428.427-1.032t-.427-1.031a1.4 1.4 0 00-1.031-.427q-.604 0-1.032.427a1.4 1.4 0 00-.427 1.031q0 .605.427 1.032.428.427 1.032.427m5.833 2.25q-.855 0-1.447-.595A1.97 1.97 0 0111.708 10q0-.854.595-1.448a1.97 1.97 0 011.447-.594q.854 0 1.448.594T15.792 10a1.97 1.97 0 01-.594 1.447 1.97 1.97 0 01-1.448.595m-4.958 4.5q.937-1.75 2.416-2.375 1.48-.625 2.542-.625.458 0 .875.072.417.073.833.178.522-.75.865-1.719.344-.969.344-2.073 0-2.792-1.938-4.73Q12.792 3.335 10 3.334T5.27 5.272Q3.335 7.208 3.334 10q0 1 .282 1.906.28.906.78 1.677a8 8 0 011.71-.636q.936-.239 1.812-.239.52 0 1.051.094.532.094.97.219-.375.208-.709.469-.333.26-.604.53a3 3 0 00-.375-.052 6 6 0 00-1.75.167 6.2 6.2 0 00-1.313.47 6.4 6.4 0 001.646 1.26 6.6 6.6 0 001.959.677M10 17.917a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.688-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.624 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.688 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625"/></g>', width: 20, height: 20 }, support: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 17.917a7.7 7.7 0 01-3.093-.625 8 8 0 01-2.511-1.688 8 8 0 01-1.687-2.51A7.7 7.7 0 012.083 10q0-1.646.625-3.094a8 8 0 011.688-2.51 8 8 0 012.51-1.688A7.7 7.7 0 0110 2.083q1.646 0 3.094.625 1.448.626 2.51 1.688a8 8 0 011.688 2.51q.625 1.448.625 3.094a7.7 7.7 0 01-.625 3.093 8 8 0 01-1.688 2.511 8 8 0 01-2.51 1.688 7.7 7.7 0 01-3.094.625m-2.416-1.709 1.229-2.791a3.36 3.36 0 01-1.355-.854 3.9 3.9 0 01-.854-1.355l-2.833 1.167a6.5 6.5 0 001.5 2.333 6.5 6.5 0 002.313 1.5m-.98-7.416q.27-.771.845-1.344.572-.573 1.343-.844L7.625 3.771a6.7 6.7 0 00-2.333 1.52A6.7 6.7 0 003.77 7.626zM10 12.375q.98 0 1.678-.698A2.3 2.3 0 0012.375 10q0-.98-.697-1.677A2.3 2.3 0 0010 7.625q-.979 0-1.677.698A2.3 2.3 0 007.625 10q0 .98.698 1.677a2.3 2.3 0 001.677.698m2.417 3.833a6.5 6.5 0 002.302-1.489 6.5 6.5 0 001.49-2.302l-2.792-1.23a3.5 3.5 0 01-.844 1.344q-.573.573-1.323.865zm.979-7.458 2.813-1.167a6.5 6.5 0 00-1.49-2.302 6.5 6.5 0 00-2.302-1.49L11.25 6.626q.75.292 1.302.843.553.553.844 1.282"/></g>', width: 20, height: 20 }, "support-agent": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.09 13.667a.48.48 0 01-.357-.144.48.48 0 01-.143-.356q0-.213.143-.357a.48.48 0 01.357-.143h4.371a.22.22 0 00.145-.052.17.17 0 00.06-.134V7.818q0-1.911-1.367-3.219Q9.93 3.292 8 3.292T4.701 4.6Q3.333 5.907 3.333 7.818v3.425q0 .213-.143.357a.48.48 0 01-.357.143q-.48 0-.823-.333a1.1 1.1 0 01-.343-.814V9.301q0-.324.184-.594.185-.27.482-.434l.031-.851a5.2 5.2 0 01.566-2.017A5.8 5.8 0 014.17 3.79a5.6 5.6 0 011.745-1.072A5.7 5.7 0 018 2.333q1.095 0 2.08.384a5.7 5.7 0 011.746 1.067q.76.683 1.24 1.61.477.93.57 2.017l.03.835q.292.137.48.392.187.255.187.57v1.488q0 .315-.187.57-.188.255-.48.392v.823q0 .492-.353.839-.352.347-.852.347zM6.128 9.179a.58.58 0 110-1.16q.246 0 .418.17.172.168.172.413t-.172.411a.58.58 0 01-.418.166m3.744 0a.58.58 0 110-1.16q.245 0 .417.17.172.168.172.413t-.172.411a.58.58 0 01-.417.166M4.248 8.133Q4.144 6.501 5.263 5.34q1.12-1.16 2.77-1.16 1.388 0 2.448.858A3.5 3.5 0 0111.77 7.26a5.1 5.1 0 01-2.625-.746 4.87 4.87 0 01-1.85-2 4.84 4.84 0 01-1.063 2.199 4.96 4.96 0 01-1.983 1.42"/></g>' }, "support-mic": { body: '<mask id="svgID0" width="36" height="36" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h36v36H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.962 29.25q-1.137 0-1.924-.788-.788-.787-.788-1.924V16.5q0-2.624 1.004-4.947a12.9 12.9 0 012.74-4.059 12.9 12.9 0 014.06-2.74A12.3 12.3 0 0118 3.75q2.624 0 4.947 1.004a12.9 12.9 0 014.059 2.74 12.9 12.9 0 012.74 4.06A12.3 12.3 0 0130.75 16.5v14.077q0 1.136-.788 1.924-.787.787-1.924.787h-8.913a1.1 1.1 0 01-.802-.323 1.1 1.1 0 01-.323-.802q0-.478.323-.801a1.1 1.1 0 01.802-.324h8.913a.45.45 0 00.332-.13.45.45 0 00.13-.331V29.25h-2.596a2.6 2.6 0 01-1.915-.797 2.6 2.6 0 01-.797-1.915v-5.192q0-1.119.797-1.915a2.6 2.6 0 011.915-.797H28.5V16.5q0-4.35-3.075-7.425T18 6t-7.425 3.075T7.5 16.5v2.134h2.596q1.119 0 1.915.797.797.797.797 1.915v5.192q0 1.119-.797 1.915a2.6 2.6 0 01-1.915.797z"/></g>', width: 36, height: 36 }, "swap-horiz": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.983 8.733a.44.44 0 01-.15-.342q0-.207.15-.358L12.516 6.5H8a.484.484 0 01-.5-.5.486.486 0 01.5-.5h4.516l-1.533-1.533a.5.5 0 01-.15-.359q0-.208.15-.358a.48.48 0 01.7 0l2.333 2.333a.55.55 0 01.126.192.63.63 0 010 .45.55.55 0 01-.126.192L11.683 8.75a.45.45 0 01-.35.141.5.5 0 01-.35-.158M4.316 12.75l-2.333-2.333a.54.54 0 01-.125-.192.61.61 0 01.125-.642L4.316 7.25a.48.48 0 01.7 0q.15.15.15.358a.5.5 0 01-.15.359L3.483 9.5H8q.216 0 .358.141A.5.5 0 018.5 10a.485.485 0 01-.5.5H3.483l1.533 1.533q.15.15.15.358 0 .21-.15.342a.5.5 0 01-.35.158.45.45 0 01-.35-.141"/></g>' }, swipe: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.667 5.583a.73.73 0 01-.532-.218.73.73 0 01-.218-.532V2.167q0-.21.146-.354a.48.48 0 01.354-.146q.208 0 .354.145a.48.48 0 01.146.355v1.458A10.98 10.98 0 0110 1.063a11 11 0 017.083 2.562V2.167q0-.21.146-.354a.48.48 0 01.354-.146q.209 0 .355.145a.48.48 0 01.145.355v2.666a.73.73 0 01-.218.532.73.73 0 01-.532.218h-2.666a.48.48 0 01-.354-.146.48.48 0 01-.146-.354q0-.208.146-.354a.48.48 0 01.354-.146h2a11.4 11.4 0 00-3.114-1.865A9.5 9.5 0 0010 2.042q-1.854 0-3.552.676a11.4 11.4 0 00-3.115 1.865h2q.209 0 .355.146a.48.48 0 01.145.354.48.48 0 01-.145.354.48.48 0 01-.355.146zM8.792 18.75q-.27 0-.5-.104a1.4 1.4 0 01-.417-.292l-3.104-3.083a1.2 1.2 0 01-.354-.771 1.4 1.4 0 01.166-.833q.21-.354.563-.5a1.08 1.08 0 01.687-.063l2.084.459V6.25q0-.708.479-1.187.48-.48 1.187-.48.709 0 1.188.48.48.479.48 1.187v3.896h.666a.54.54 0 01.354.125l2.875 1.396q.542.27.782.833.239.563.135 1.146l-.688 4.083a1.22 1.22 0 01-.437.73 1.24 1.24 0 01-.813.291zm0-1.25h5.333l.708-4.083a.65.65 0 00-.01-.344.47.47 0 00-.24-.281l-3.125-1.542H10v-5a.4.4 0 00-.114-.303.4.4 0 00-.303-.114.4.4 0 00-.302.114.4.4 0 00-.114.303v8.833l-3.542-.729z"/></g>', width: 20, height: 20 }, "sync-alt": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M13.728 10.106a.6.6 0 01-.194-.446.6.6 0 01.18-.432l1.937-1.936H3.333a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.446t.445-.18h12.318l-1.944-1.943a.58.58 0 01-.173-.425q0-.252.194-.445a.6.6 0 01.439-.181q.258 0 .439.18l2.912 2.912a.7.7 0 01.213.528.7.7 0 01-.213.527l-2.92 2.92a.58.58 0 01-.438.18.6.6 0 01-.432-.188m-8.334 6.666-2.912-2.911a.7.7 0 01-.213-.528q0-.15.048-.28a.7.7 0 01.165-.247l2.92-2.92a.6.6 0 01.425-.18.6.6 0 01.445.188.594.594 0 01.013.878L4.35 12.708h12.318q.265 0 .445.18t.18.445q0 .267-.18.446a.6.6 0 01-.445.18H4.349l1.944 1.943q.173.174.18.431a.56.56 0 01-.188.44.58.58 0 01-.439.193.62.62 0 01-.452-.194"/></g>', width: 20, height: 20 }, "table-chart": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.462 13.667H3.537q-.504 0-.855-.35a1.16 1.16 0 01-.35-.855V3.54q0-.506.35-.855.351-.35.855-.35h8.924q.504 0 .855.35.35.35.35.855v8.923q0 .506-.35.855-.35.35-.856.35M3.332 5.501h9.334V3.539a.2.2 0 00-.065-.14.2.2 0 00-.14-.065H3.537a.2.2 0 00-.14.064.2.2 0 00-.065.141zm1.795 1H3.333v5.961q0 .077.064.141.065.064.141.064h1.59zm5.744 0v6.166h1.59a.2.2 0 00.14-.064.2.2 0 00.065-.14V6.5zm-1 0H6.128v6.166h3.744z"/></g>' }, tag: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M9.27 14.036a.97.97 0 01-.714.287.97.97 0 01-.712-.287L1.977 8.169a1.1 1.1 0 01-.228-.333 1 1 0 01-.082-.403V2.667q0-.41.295-.705a.96.96 0 01.705-.295h4.766q.207 0 .396.08t.327.217l5.867 5.877a1 1 0 01.297.717.96.96 0 01-.284.711zm-.716-.703 4.77-4.766-5.888-5.9h-4.77v4.766zM4.333 5.167q.346 0 .59-.243a.8.8 0 00.244-.59.8.8 0 00-.243-.59.8.8 0 00-.59-.244.8.8 0 00-.59.243.8.8 0 00-.244.59q0 .346.243.59a.8.8 0 00.59.244"/></g>' }, "task-alt": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M17.75 8.354q.084.396.125.813.042.416.042.833a7.65 7.65 0 01-.625 3.083 8 8 0 01-1.699 2.51 8 8 0 01-2.51 1.699 7.65 7.65 0 01-3.083.625 7.65 7.65 0 01-3.083-.625 8.1 8.1 0 01-2.511-1.699 8 8 0 01-1.697-2.51A7.65 7.65 0 012.083 10q0-1.646.625-3.083a8.1 8.1 0 011.698-2.511 8.1 8.1 0 012.51-1.698A7.65 7.65 0 0110 2.083q1.105 0 2.125.292 1.02.291 1.896.812.23.147.282.396t-.136.48a.7.7 0 01-.417.26.63.63 0 01-.479-.094 5.9 5.9 0 00-1.542-.667A6.5 6.5 0 0010 3.333q-2.77 0-4.718 1.948Q3.332 7.23 3.333 10t1.949 4.72Q7.229 16.665 10 16.666t4.72-1.948q1.947-1.948 1.947-4.72a5.8 5.8 0 00-.167-1.395.7.7 0 01.063-.386.65.65 0 01.25-.28q.291-.21.573-.063a.7.7 0 01.364.48m-9.458 4.667-2.313-2.313a.55.55 0 01-.155-.427A.6.6 0 016 9.854a.6.6 0 01.449-.187q.26 0 .426.187l1.938 1.938 7.812-7.813a.52.52 0 01.428-.177.58.58 0 01.426.198.55.55 0 01.188.427.6.6 0 01-.188.448L9.354 13.02a.78.78 0 01-.541.208.7.7 0 01-.521-.208"/></g>', width: 20, height: 20 }, terminal: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10.833 13.958a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.265.18-.445t.445-.18h3.334q.265 0 .445.18t.18.445q0 .267-.18.446a.6.6 0 01-.445.18zm-5.022-.519A.6.6 0 015.638 13q0-.266.173-.44l1.715-1.727-1.728-1.727a.6.6 0 01-.183-.44.6.6 0 01.196-.438.65.65 0 01.439-.18.58.58 0 01.44.18l2.07 2.078a.7.7 0 01.213.527q0 .15-.048.28a.7.7 0 01-.165.248l-2.07 2.078a.6.6 0 01-.434.18.6.6 0 01-.445-.18M3.59 16.25q-.631 0-1.07-.437a1.45 1.45 0 01-.437-1.07V5.256q0-.63.438-1.069A1.45 1.45 0 013.59 3.75h12.82q.631 0 1.07.438.436.437.437 1.068v9.487q0 .633-.438 1.07a1.45 1.45 0 01-1.069.437zm0-1.25h12.82a.25.25 0 00.177-.08.25.25 0 00.08-.177V6.667H3.333v8.076q0 .097.08.177.081.08.177.08"/></g>', width: 20, height: 20 }, "terminal-info": { body: '<path fill="currentColor" d="M8.05 11.383a.53.53 0 00.392-.158.53.53 0 00.158-.392V7.867a.5.5 0 00-.167-.375.54.54 0 00-.383-.159.53.53 0 00-.392.159.53.53 0 00-.158.391v2.967a.5.5 0 00.167.375.54.54 0 00.383.158M8 6.167A.62.62 0 008.442 6a.57.57 0 00.175-.433.63.63 0 00-.175-.45A.6.6 0 008 4.933a.6.6 0 00-.442.184.63.63 0 00-.175.45q0 .266.175.433A.62.62 0 008 6.167m0 8.6a6.9 6.9 0 01-2.675-.517 6.6 6.6 0 01-2.15-1.425 6.6 6.6 0 01-1.425-2.15A6.9 6.9 0 011.233 8q0-1.416.517-2.658a6.6 6.6 0 011.425-2.15 6.7 6.7 0 012.15-1.434A6.8 6.8 0 018 1.233q1.417 0 2.658.525 1.242.525 2.15 1.434A6.74 6.74 0 0114.766 8q0 1.434-.524 2.675a6.7 6.7 0 01-1.434 2.15 6.6 6.6 0 01-2.15 1.425A6.9 6.9 0 018 14.767m0-1.134q2.318 0 3.975-1.65 1.659-1.65 1.658-3.983 0-2.317-1.658-3.975T8 2.367 4.025 4.025 2.367 8q0 2.334 1.658 3.983T8 13.633"/>' }, "terminal-logs": { body: '<path fill="currentColor" d="M3.033 12.967h9.934v-6.25L9.283 3.033h-6.25zm0 1.133q-.466 0-.8-.333a1.1 1.1 0 01-.333-.8V3.033q0-.465.333-.8.334-.333.8-.333h6.25q.234 0 .45.092.217.09.367.241L13.767 5.9q.15.15.241.367.092.216.092.45v6.25q0 .465-.333.8a1.1 1.1 0 01-.8.333zm2.1-2.967h5.734q.216 0 .366-.15t.15-.366a.5.5 0 00-.15-.367.5.5 0 00-.366-.15H5.133a.5.5 0 00-.366.15q-.15.15-.15.367 0 .216.15.366t.366.15m0-2.616h5.734a.5.5 0 00.366-.142q.15-.142.15-.358a.5.5 0 00-.15-.367.5.5 0 00-.366-.15H5.133a.5.5 0 00-.366.15q-.15.15-.15.367 0 .216.15.358.15.141.366.142m0-2.6h3.584q.216 0 .366-.15t.15-.367a.47.47 0 00-.15-.358.5.5 0 00-.366-.142H5.133a.5.5 0 00-.366.15q-.15.15-.15.367 0 .2.15.35t.366.15m-2.1 7.05V3.033z"/>' }, "terminal-report": { body: '<path fill="currentColor" d="M8 14.1a4.24 4.24 0 01-2.083-.533 3.2 3.2 0 01-1.417-1.55H3.083a.5.5 0 01-.366-.15.5.5 0 01-.15-.367q0-.233.15-.375a.5.5 0 01.366-.142H4.1a3.3 3.3 0 01-.117-.858V9.25H3.05a.48.48 0 01-.35-.15.5.5 0 01-.15-.367q0-.232.15-.375a.5.5 0 01.367-.141h.916q0-.484.009-.942.007-.459.141-.925H3.067a.48.48 0 01-.35-.15.5.5 0 01-.15-.367q0-.233.15-.375a.5.5 0 01.366-.141h1.5q.217-.484.6-.842a3.5 3.5 0 01.867-.592l-.967-.933a.44.44 0 01-.125-.342.5.5 0 01.142-.341q.15-.15.358-.15a.5.5 0 01.359.15l1.216 1.216A2.73 2.73 0 019 3.466l1.233-1.233q.15-.15.342-.141a.5.5 0 01.342.158q.15.134.15.342a.5.5 0 01-.15.358l-.9.9q.483.25.85.633.366.385.616.85h1.467a.46.46 0 01.358.159.52.52 0 01.142.358.486.486 0 01-.5.5h-1.083q.15.467.141.925-.008.459-.008.942h.95q.2 0 .35.15t.15.366q0 .233-.15.375a.5.5 0 01-.367.142H12q0 .45.008.875t-.108.858h1.05q.2 0 .35.15t.15.367q0 .232-.15.375a.5.5 0 01-.367.142h-1.416a3.2 3.2 0 01-1.417 1.55A4.3 4.3 0 018 14.1m0-1.133q1.2 0 2.033-.842a2.8 2.8 0 00.834-2.042V7.367q0-1.2-.834-2.042A2.75 2.75 0 008 4.483q-1.2 0-2.033.842a2.8 2.8 0 00-.834 2.042v2.716q0 1.2.834 2.042A2.75 2.75 0 008 12.967m-.817-2.284h1.65q.2 0 .35-.141.15-.143.15-.375 0-.233-.15-.375a.5.5 0 00-.366-.142h-1.65a.5.5 0 00-.35.142q-.15.142-.15.375 0 .232.15.375.15.141.366.141m0-2.883h1.65q.2 0 .35-.142t.15-.375-.15-.375a.5.5 0 00-.366-.141h-1.65a.5.5 0 00-.35.141q-.15.142-.15.375t.15.375.366.142M8 8.733h.008zh.008zh.008zh.008z"/>' }, "test-case": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.167 5.967a.47.47 0 01-.358-.15.5.5 0 01-.142-.35.486.486 0 01.5-.5h4.667q.216 0 .359.141a.5.5 0 01.14.359q0 .2-.14.35a.47.47 0 01-.36.15zm0 5.066a.484.484 0 01-.5-.5q0-.2.142-.35a.47.47 0 01.358-.15h4.667q.216 0 .359.15.14.15.14.35a.485.485 0 01-.5.5zM10.401 6.8 9.05 5.433a.41.41 0 01-.142-.342.5.5 0 01.142-.341q.132-.15.35-.15.216 0 .35.15l1.066 1.067L13.3 3.333q.133-.15.342-.15.208 0 .358.167a.5.5 0 01.133.35.5.5 0 01-.133.35L11.25 6.8a.583.583 0 01-.85 0m0 5.083-1.35-1.366a.41.41 0 01-.142-.342.55.55 0 01.142-.358.47.47 0 01.35-.134q.216 0 .35.134l1.066 1.083L13.3 8.417q.133-.15.342-.15.208 0 .358.15a.5.5 0 01.133.35.5.5 0 01-.133.35l-2.75 2.766a.583.583 0 01-.85 0"/></g>' }, "test-data": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.667 7.833h6.667a.486.486 0 00.5-.5.5.5 0 00-.141-.358.5.5 0 00-.36-.142H4.668a.485.485 0 00-.5.5.484.484 0 00.5.5m0 2.667h4a.486.486 0 00.5-.5.5.5 0 00-.141-.359.5.5 0 00-.359-.141h-4a.485.485 0 00-.5.5.484.484 0 00.5.5m-1.8 2.5q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V4.467q0-.518.35-.867.35-.35.85-.35h3.634a1 1 0 01.716.3l.784.783h5.133q.5 0 .85.35t.35.85V11.8q0 .5-.35.85t-.85.35zm-.2-8.533V11.8q0 .084.059.142a.2.2 0 00.141.058h10.267q.084 0 .142-.058a.2.2 0 00.058-.142V5.533a.2.2 0 00-.058-.142.2.2 0 00-.142-.058h-5.55L6.517 4.25h-3.65a.2.2 0 00-.141.059.2.2 0 00-.059.158m0 0V4.25 12z"/></g>' }, "test-data-profile": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.333 13.667a.96.96 0 01-.708-.292.96.96 0 01-.292-.708V3.333q0-.417.292-.708a.96.96 0 01.708-.292h7.2l3.134 3.134v7.2a.96.96 0 01-.292.708.96.96 0 01-.708.292zm0-1h9.334V6H10.6a.58.58 0 01-.425-.175A.58.58 0 0110 5.4V3.333H3.333zm2-1.667h5.334a.5.5 0 00.358-.141.5.5 0 00.142-.36.5.5 0 00-.142-.358.5.5 0 00-.358-.141H5.333a.485.485 0 00-.5.5.486.486 0 00.5.5m0-5H7.5a.486.486 0 00.5-.5.485.485 0 00-.5-.5H5.333a.484.484 0 00-.5.5.484.484 0 00.5.5m0 2.5h5.334a.486.486 0 00.5-.5.5.5 0 00-.142-.359.5.5 0 00-.358-.141H5.333a.485.485 0 00-.5.5.484.484 0 00.5.5"/></g>' }, "test-development": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.234 13.66a.8.8 0 01-.59-.244.8.8 0 01-.244-.59q0-.348.244-.59a.8.8 0 01.59-.244h9.453q.348 0 .59.243a.8.8 0 01.244.59.8.8 0 01-.244.591.8.8 0 01-.59.244zm1.057-3.058a.48.48 0 01-.355-.146.48.48 0 01-.146-.355v-.987a.6.6 0 01.035-.194.4.4 0 01.118-.167l4.81-4.81 1.696 1.696-4.81 4.81a.4.4 0 01-.167.118.6.6 0 01-.194.035zm.333-.834h.5l4.157-4.13-.528-.527-4.129 4.156zm6.38-4.713-1.68-1.682.82-.82a.52.52 0 01.383-.153q.229 0 .382.153l.903.917a.54.54 0 01.16.376.53.53 0 01-.146.389z"/></g>' }, testcase: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.743 13.333q-.46 0-.769-.308a1.04 1.04 0 01-.308-.769V3.744q0-.46.308-.77.309-.308.769-.308h8.513q.46 0 .768.309.309.308.309.769v8.512q0 .46-.309.769a1.04 1.04 0 01-.768.308zm0-.667h8.513a.4.4 0 00.282-.128.4.4 0 00.128-.282V3.744a.4.4 0 00-.128-.283.4.4 0 00-.282-.128H3.743a.4.4 0 00-.282.128.4.4 0 00-.128.283v8.512q0 .154.128.282.128.129.282.128M5.333 11h3.333a.32.32 0 00.238-.096.32.32 0 00.095-.238.32.32 0 00-.095-.237.32.32 0 00-.238-.096H5.333a.32.32 0 00-.238.096.32.32 0 00-.096.237q0 .143.096.238a.32.32 0 00.238.096m0-2.667h5.333a.32.32 0 00.238-.095.32.32 0 00.095-.238.32.32 0 00-.095-.238.32.32 0 00-.238-.095H5.333a.32.32 0 00-.238.095.32.32 0 00-.096.238q0 .142.096.238a.32.32 0 00.238.095m0-2.666h5.333a.32.32 0 00.238-.096.32.32 0 00.095-.238.32.32 0 00-.095-.238.32.32 0 00-.238-.095H5.333a.32.32 0 00-.238.095.32.32 0 00-.096.238q0 .142.096.238a.32.32 0 00.238.096"/></g>' }, "testcase-parallel-run": { body: '<mask id="svgID0" width="30" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h30v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M2.556 13.361a.7.7 0 01-.355-.407.65.65 0 01.035-.533l4.741-9.473a.7.7 0 01.403-.35.66.66 0 01.529.04q.258.131.355.407a.65.65 0 01-.036.533l-4.74 9.473a.7.7 0 01-.403.35.66.66 0 01-.53-.04m5.856 0a.7.7 0 01-.355-.407.65.65 0 01.035-.533l4.741-9.473a.68.68 0 01.402-.35.66.66 0 01.53.04q.258.131.354.407a.65.65 0 01-.035.533l-4.74 9.473a.7.7 0 01-.403.35.66.66 0 01-.53-.04m6.146 0a.7.7 0 01-.355-.407.65.65 0 01.036-.533l4.74-9.473a.68.68 0 01.403-.35.66.66 0 01.529.04q.258.131.355.407a.65.65 0 01-.036.533l-4.74 9.473a.7.7 0 01-.403.35.66.66 0 01-.53-.04m5.856 0a.7.7 0 01-.355-.407.65.65 0 01.035-.533l4.741-9.473a.68.68 0 01.402-.35.66.66 0 01.53.04q.258.131.355.407a.65.65 0 01-.036.533l-4.74 9.473a.7.7 0 01-.403.35.66.66 0 01-.53-.04"/></g>', width: 30 }, "testsigma-logo": { body: '<g fill="none"><circle cx="6" cy="6" r="3.429"/><path fill="currentColor" fill-rule="evenodd" d="M5.99 4.128c0-.019.002-.047.004-.068z" clip-rule="evenodd"/><path fill="currentColor" fill-rule="evenodd" d="M11.754 4.506a.65.65 0 00-.472-.294q-.142-.018-.283-.042-.178-.029-.358-.05c-.319-.032-.514-.165-.632-.425a.6.6 0 01-.03-.492l.046-.118c.08-.205.161-.419.249-.625a.67.67 0 00-.02-.588 1.42 1.42 0 00-.828-.719.67.67 0 00-.607.08q-.136.086-.276.169a7 7 0 00-.385.245.55.55 0 01-.316.094c-.3 0-.589-.197-.66-.447A7 7 0 007.057.9a9 9 0 01-.11-.331.7.7 0 00-.457-.482 2 2 0 00-.205-.06L6.2.004 6.184 0h-.386l-.015.005-.022.008-.03.008c-.395.071-.63.272-.718.617a5 5 0 01-.145.452l-.004.012-.015.042-.062.184c-.077.236-.357.421-.637.421a.52.52 0 01-.301-.09 10 10 0 00-.478-.302l-.227-.139a.6.6 0 00-.468-.079 1.37 1.37 0 00-.947.786.64.64 0 00-.007.53q.051.123.099.248.07.194.155.387c.116.261.103.492-.044.723a.6.6 0 01-.4.284 11 11 0 01-.779.12.7.7 0 00-.534.34c-.168.272-.24.58-.214.915.024.313.175.538.446.667.099.047.195.104.291.157l.011.006c.101.058.205.117.314.168.161.074.282.246.321.454.04.216-.014.436-.146.57-.182.19-.361.396-.53.609a.75.75 0 00-.155.33c-.078.45.3 1.117.723 1.275a.75.75 0 00.358.032c.228-.035.464-.082.72-.145a.64.64 0 01.663.183.64.64 0 01.208.497v.02c-.006.245-.013.506-.024.77a.67.67 0 00.209.526 1.44 1.44 0 00.99.409c.265 0 .48-.113.633-.336.061-.086.128-.166.199-.252q.111-.133.215-.276a.65.65 0 01.545-.263c.225 0 .428.097.543.257.09.126.188.248.283.366l.013.016q.093.112.18.228a.62.62 0 00.44.249c.42.039.797-.09 1.116-.383a.65.65 0 00.215-.54 6 6 0 01-.01-.284v-.006a7 7 0 00-.016-.383c-.022-.3.071-.517.293-.68a.57.57 0 01.447-.12c.282.047.535.099.772.159.245.06.472.003.668-.171a1.47 1.47 0 00.479-.82.73.73 0 00-.193-.7 6 6 0 01-.212-.238 5 5 0 00-.213-.24c-.203-.21-.26-.427-.184-.701a.62.62 0 01.296-.405c.244-.14.471-.264.698-.381a.65.65 0 00.343-.438c.102-.41.034-.798-.2-1.152m-5.78.065-.002.024v.351l.265-.148 1.375-.68a.26.26 0 01.205-.01.27.27 0 01.153.141l.186.404a.28.28 0 01-.126.369l-2.123 1.05-.045 1.002-.005.188v.067c0 .152 0 .18.025.308.014.068.033.082.112.123a.7.7 0 00.274.071h.028c.057 0 .11 0 .17-.013a1.5 1.5 0 00.47-.175.1.1 0 01.114.011c.032.026.048.07.038.112a5 5 0 00-.052.377l-.002.016a11 11 0 01-.047.368.11.11 0 01-.08.091 4 4 0 01-.473.091 3 3 0 01-.332.018q-.4 0-.65-.108a.83.83 0 01-.405-.365c-.092-.164-.138-.385-.138-.654q0-.054.005-.179c.003-.084.017-.368.043-.87v-.01l-.506.25a.25.25 0 01-.116.027.27.27 0 01-.241-.158l-.523-1.142a.28.28 0 01.127-.37l.391-.191a.26.26 0 01.205-.01.27.27 0 01.152.141l.223.487.348-.172.052-.845.033-.534.012-.137c.005-.053.011-.113.03-.358a.11.11 0 01.087-.104q.393-.078.667-.149a.1.1 0 01.092.021c.026.023.04.057.038.091-.009.207-.016.312-.022.39-.006.085-.01.138-.01.258l-.002.024-.003.083z" clip-rule="evenodd"/></g>', width: 12, height: 12 }, "testsuite-parallel-run": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.476 13.361a.7.7 0 01-.355-.407.65.65 0 01.035-.533l4.741-9.473a.7.7 0 01.402-.35.66.66 0 01.53.04q.258.132.355.407a.65.65 0 01-.036.533l-4.74 9.473a.68.68 0 01-.403.35.66.66 0 01-.53-.04m5.856 0a.7.7 0 01-.355-.407.65.65 0 01.035-.533l4.741-9.473a.7.7 0 01.402-.35.66.66 0 01.53.04q.258.132.354.407a.65.65 0 01-.035.533l-4.741 9.473a.68.68 0 01-.402.35.66.66 0 01-.53-.04"/></g>' }, "text-snippet": { body: '<path fill="currentColor" d="M1.133 11.067h9.934v-6.25L7.383 1.133h-6.25zm0 1.133q-.465 0-.8-.333a1.1 1.1 0 01-.333-.8V1.133q0-.465.333-.8Q.668 0 1.133 0h6.25q.234 0 .45.092.217.09.367.241L11.867 4q.15.15.241.367.092.216.092.45v6.25q0 .465-.333.8a1.1 1.1 0 01-.8.333zm2.1-2.967h5.734q.216 0 .366-.15t.15-.366a.5.5 0 00-.15-.367.5.5 0 00-.366-.15H3.233a.5.5 0 00-.366.15q-.15.15-.15.367 0 .216.15.366t.366.15m0-2.616h5.734a.5.5 0 00.366-.142q.15-.142.15-.358a.5.5 0 00-.15-.367.5.5 0 00-.366-.15H3.233a.5.5 0 00-.366.15q-.15.15-.15.367 0 .216.15.358t.366.142m0-2.6h3.584q.216 0 .366-.15t.15-.367a.47.47 0 00-.15-.358A.5.5 0 006.817 3H3.233a.5.5 0 00-.366.15q-.15.15-.15.367 0 .2.15.35t.366.15m-2.1 7.05V1.133z"/>', width: 13, height: 13 }, "textbox-placeholder": { body: '<g fill="currentColor"><path d="M43.3 86.5c-19.9 4.3-38.2 22.7-42.2 42.3-1.5 7.3-1.5 119.1 0 126.4 3 14.7 14.7 29.8 28.6 37.1 13 6.8 11 6.7 108.1 6.7 96.9 0 92.4.3 95.6-6.5 2-4.1 2-4.9 0-9-3.2-6.8 1.5-6.5-97.8-6.5-86.8 0-89.7-.1-94.8-2-7.6-2.8-12.2-7.1-16-14.8l-3.3-6.7v-123l3.3-6.7c3.8-7.7 8.4-12 16-14.8 5.2-2 8.4-2 215.2-2s210 0 215.2 2c7.6 2.8 12.2 7.1 16 14.8l3.3 6.7v123l-2.6 5.5c-3.6 7.7-7.1 11.5-13.7 14.7l-5.7 2.8-49.8.5-49.9.5-2.9 3.3c-4 4.5-4 9.9 0 14.4l2.9 3.3 45.4.3c30.7.2 47.5-.1 52.1-.9 20.9-3.5 40.4-22.1 44.6-42.7 1.5-7.3 1.5-119.1 0-126.4-4.1-19.9-22.4-38-42.6-42.3-9.8-2.1-415.5-2.1-425 0"/><path d="M122 177.8c-8.2 4.5-11.9 13.5-8.2 20.2 4.5 8.2 13.5 11.9 20.2 8.2 8.2-4.5 11.9-13.5 8.2-20.2-4.5-8.2-13.5-11.9-20.2-8.2m9.2 10.9c2.2 2 2.3 4.1.1 6.5-2 2.2-4.1 2.3-6.5.1-2.2-2-2.3-4.1-.1-6.5 2-2.2 4.1-2.3 6.5-.1M250 177.8c-8.2 4.5-11.9 13.5-8.2 20.2 4.5 8.2 13.5 11.9 20.2 8.2 8.2-4.5 11.9-13.5 8.2-20.2-4.5-8.2-13.5-11.9-20.2-8.2m9.2 10.9c2.2 2 2.3 4.1.1 6.5-2 2.2-4.1 2.3-6.5.1-2.2-2-2.3-4.1-.1-6.5 2-2.2 4.1-2.3 6.5-.1M378 177.8c-8.2 4.5-11.9 13.5-8.2 20.2 4.5 8.2 13.5 11.9 20.2 8.2 8.2-4.5 11.9-13.5 8.2-20.2-4.5-8.2-13.5-11.9-20.2-8.2m9.2 10.9c2.2 2 2.3 4.1.1 6.5-2 2.2-4.1 2.3-6.5.1-2.2-2-2.3-4.1-.1-6.5 2-2.2 4.1-2.3 6.5-.1M292 303.6c-7.6 3.3-11.3 9.6-11.4 19.4v6.5L322 412c38.4 76.3 41.8 82.7 45.7 85.6 2.3 1.8 6.5 3.7 9.3 4.4 4.4 1.1 5.7 1 9.7-.5 5.2-2 10.8-6.6 12.8-10.5.8-1.5 4.1-13.7 7.5-27.1 3.3-13.4 6.4-25.3 6.9-26.5.8-1.8 4.9-3.1 28-8.9 24.9-6.2 27.3-7 31.1-10.2 10-8.6 10.8-20.7 1.9-30.7-2.7-3.2-16.9-10.6-85.1-44.7L308 302h-6.2c-3.5.1-7.9.8-9.8 1.6m166.2 98.5c-.4.3-13.1 3.7-28.2 7.4s-28.7 7.4-30.1 8.1c-3.6 1.8-4.5 4.6-12.4 36.3l-6.8 27.4-39.3-78.4c-21.6-43.1-39.3-78.7-39.3-79.1-.1-.5 35.2 16.9 78.4 38.4 43.1 21.6 78.1 39.5 77.7 39.9"/></g>', width: 512, height: 512 }, "thumb-down": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.93 9.042a1 1 0 01-.736-.32 1 1 0 01-.319-.735v-.942a1 1 0 01.024-.197q.023-.105.052-.196l1.672-3.945q.126-.28.42-.472.295-.193.616-.193h6.134v7L6.4 12.406a.704.704 0 01-.841.129.7.7 0 01-.308-.319.62.62 0 01-.041-.427l.628-2.747zm6.988-.373V2.917h-5.26a.3.3 0 00-.127.033.22.22 0 00-.098.113L1.75 7v.987q0 .08.05.13t.13.05h5.014l-.731 3.197zm2.57-6.627q.434 0 .744.31.31.309.31.744v4.891q0 .435-.31.745t-.745.31H9.793v-.875h1.694a.18.18 0 00.13-.05.18.18 0 00.05-.13v-4.89a.18.18 0 00-.05-.13.18.18 0 00-.13-.05H9.793v-.875z"/></g>', width: 14, height: 14 }, "thumb-up": { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.07 4.958q.417 0 .736.32.32.318.32.735v.942a1 1 0 01-.024.197 2 2 0 01-.053.196l-1.672 3.945a1.1 1.1 0 01-.42.472 1.1 1.1 0 01-.616.193H4.207v-7L7.6 1.594a.704.704 0 01.842-.129q.21.112.307.319.097.206.042.427l-.629 2.747zm-6.988.373v5.752h5.261a.3.3 0 00.126-.033.22.22 0 00.099-.113L12.25 7v-.987a.18.18 0 00-.05-.13.18.18 0 00-.13-.05H7.057l.732-3.197zm-2.569 6.627q-.435 0-.745-.31a1.02 1.02 0 01-.31-.744V6.013q0-.435.31-.745t.745-.31h1.694v.875H2.513a.18.18 0 00-.129.05.18.18 0 00-.05.13v4.89q0 .08.05.13t.129.05h1.694v.875z"/></g>', width: 14, height: 14 }, "thumbs-down": { body: '<path fill="currentColor" d="M1.93 8.808q-.345 0-.64-.297-.299-.298-.298-.64v-.607q0-.107.016-.197.015-.09.06-.167l1.657-3.901q.125-.295.472-.458.346-.164.666-.164l6.164.015v6.416L6.72 12.114a1.16 1.16 0 01-.52.31.64.64 0 01-.504-.05q-.217-.126-.264-.428-.045-.3.025-.668l.467-2.47zm7.338-.314V3.15h-5.61a.3.3 0 00-.127.034.22.22 0 00-.098.112L1.75 7.219v.651q0 .08.05.13t.13.05h4.897l-.658 3.518zm2.802-6.102q.407 0 .672.275a.92.92 0 01.266.662V7.87a.92.92 0 01-.266.663.9.9 0 01-.672.275h-2.043V8.05h2.043A.18.18 0 0012.2 8a.18.18 0 00.05-.13V3.33a.18.18 0 00-.05-.13.18.18 0 00-.13-.05h-2.043v-.758z"/>', width: 14, height: 14 }, "thumbs-down-filled": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3 16q-.8 0-1.4-.6T1 14v-2a2 2 0 01.15-.75l3-7.05q.225-.5.75-.85T6 3h8q.825 0 1.412.587Q16 4.176 16 5v10.175q0 .4-.162.762a2.1 2.1 0 01-.438.638l-5.425 5.4q-.375.35-.887.425a1.58 1.58 0 01-.988-.175 1.5 1.5 0 01-.687-.7q-.213-.45-.088-.925L8.45 16zM20 3q.824 0 1.413.587Q22 4.176 22 5v9q0 .825-.587 1.412A1.93 1.93 0 0120 16q-.824 0-1.413-.588A1.93 1.93 0 0118 14V5q0-.824.587-1.412A1.93 1.93 0 0120 3"/></g>', width: 24, height: 24 }, "thumbs-up": { body: '<path fill="currentColor" d="M12.07 5.177q.345 0 .641.297.297.298.297.641v.607q0 .105-.016.197a.5.5 0 01-.06.166l-1.657 3.901q-.125.296-.472.459-.345.163-.666.163l-6.164-.014V5.177L7.28 1.871q.232-.232.52-.31a.64.64 0 01.504.05q.218.126.264.428.046.3-.024.668l-.468 2.47zm-7.338.314v5.344h5.611a.3.3 0 00.126-.033.22.22 0 00.098-.112l1.683-3.923v-.652a.18.18 0 00-.05-.13.18.18 0 00-.13-.05H7.173l.658-3.518zM1.93 11.594a.9.9 0 01-.672-.276.92.92 0 01-.266-.662V6.115a.92.92 0 01.266-.662.9.9 0 01.672-.276h2.043v.758H1.93a.18.18 0 00-.13.05.18.18 0 00-.05.13v4.54q0 .08.05.13t.13.05h2.043v.759z"/>', width: 14, height: 14 }, "thumbs-up-filled": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M21 8q.8 0 1.4.6T23 10v2a2 2 0 01-.15.75l-3 7.05q-.225.5-.75.85T18 21h-8q-.825 0-1.412-.587A1.93 1.93 0 018 19V8.825q0-.4.162-.762.164-.363.438-.638l5.425-5.4q.375-.35.887-.425.513-.075.988.175.476.25.687.7.213.45.088.925L15.55 8zM4 21q-.824 0-1.412-.587A1.93 1.93 0 012 19v-9q0-.825.587-1.412A1.93 1.93 0 014 8q.824 0 1.412.588Q6 9.175 6 10v9q0 .824-.588 1.413A1.93 1.93 0 014 21"/></g>', width: 24, height: 24 }, thunder: { body: '<g fill="none"><g filter="url(#svgID1)"><path fill="url(#svgID0)" d="M3.512 2.224a.3.3 0 01.108-.162A.3.3 0 013.8 2h2.4a.29.29 0 01.243.13.32.32 0 01.041.281L5.416 5.75H7.7q.086 0 .159.047.072.047.11.128a.32.32 0 01-.032.33l-4.2 5.624a.29.29 0 01-.376.086.3.3 0 01-.138-.157.33.33 0 01-.01-.213l1.08-3.658H2.3a.29.29 0 01-.24-.125.32.32 0 01-.048-.275z"/></g><defs><linearGradient id="svgID0" x1="3.5" x2="9.841" y1="0" y2=".867" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor"/><stop offset="1" stop-color="currentColor"/></linearGradient><filter id="svgID1" width="10" height="14" x="0" y="0" color-interpolation-filters="sRGB" filterUnits="userSpaceOnUse"><feFlood flood-opacity="0" result="BackgroundImageFix"/><feColorMatrix in="SourceAlpha" result="hardAlpha" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"/><feOffset/><feGaussianBlur stdDeviation="1"/><feComposite in2="hardAlpha" operator="out"/><feColorMatrix values="0 0 0 0 1 0 0 0 0 0.730056 0 0 0 0 0.746092 0 0 0 0.25 0"/><feBlend in2="BackgroundImageFix" result="effect1_dropShadow_7674_13921"/><feBlend in="SourceGraphic" in2="effect1_dropShadow_7674_13921" result="shape"/></filter></defs></g>', width: 10, height: 14 }, timer: { body: '<mask id="svgID0" width="14" height="14" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h14v14H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.8 1.604a.42.42 0 01-.312-.126.42.42 0 01-.126-.311q0-.187.126-.312A.42.42 0 015.8.729h2.4q.186 0 .312.126a.42.42 0 01.126.312.42.42 0 01-.126.311.42.42 0 01-.312.126zM7 8.054a.42.42 0 00.312-.125.42.42 0 00.126-.312v-2.4a.42.42 0 00-.126-.312A.42.42 0 007 4.779a.42.42 0 00-.312.126.42.42 0 00-.125.311v2.401q0 .186.125.312A.42.42 0 007 8.055m0 4.488q-1.02 0-1.924-.39a5 5 0 01-1.578-1.066 5 5 0 01-1.066-1.579 4.8 4.8 0 01-.39-1.924q0-1.02.39-1.923A5 5 0 013.498 4.08a5 5 0 011.578-1.066A4.8 4.8 0 017 2.625q.876 0 1.688.297a5.4 5.4 0 011.507.852l.42-.42a.42.42 0 01.304-.124.4.4 0 01.31.124.42.42 0 01.127.308q0 .18-.127.307l-.42.42q.555.695.852 1.507.297.81.297 1.687 0 1.02-.39 1.924a5 5 0 01-1.066 1.579q-.675.675-1.578 1.065T7 12.541m0-.875q1.692 0 2.888-1.196t1.195-2.888-1.195-2.887T7 3.5 4.113 4.696 2.917 7.583t1.196 2.888T7 11.667"/></g>', width: 14, height: 14 }, "toggle-off": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#093B4D" d="M0 0h16v16H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M5.443 1.333q1.527 0 2.598 1.019t1.07 2.473v6.349q0 1.455-1.069 2.474-1.069 1.018-2.596 1.018t-2.598-1.018q-1.07-1.02-1.07-2.474V4.825q0-1.455 1.07-2.473 1.068-1.02 2.595-1.019m.002.952q-1.101 0-1.884.746-.783.747-.783 1.794v6.349q0 1.047.783 1.794.783.746 1.884.746 1.099 0 1.883-.746.783-.747.783-1.794V4.825q0-1.047-.783-1.794a2.63 2.63 0 00-1.883-.746m1.61 7.321a.5.5 0 110 1h-3a.5.5 0 010-1zm0-2a.5.5 0 110 1h-3a.5.5 0 010-1zm0-2a.5.5 0 110 1h-3a.5.5 0 010-1zm5.281 5.174 1.1-1.1a.32.32 0 01.233-.098q.136-.002.236.098a.32.32 0 010 .47l-1.295 1.295a.36.36 0 01-.274.11.36.36 0 01-.273-.11l-1.296-1.296a.32.32 0 01-.098-.232.32.32 0 01.098-.237.32.32 0 01.469 0zm0-5.561-1.1 1.1a.32.32 0 01-.232.099.32.32 0 01-.237-.099.32.32 0 010-.468l1.296-1.296a.36.36 0 01.273-.11q.078 0 .146.024a.4.4 0 01.128.086l1.295 1.296a.32.32 0 01.099.232.32.32 0 01-.099.236.32.32 0 01-.468 0z"/></g>' }, "total-tc": { body: '<g fill="none" stroke="currentColor" stroke-width="1.33"><rect width="12.67" height="12.67" x="3.665" y="3.665" rx="1.335"/><path stroke-linecap="round" d="M7 7h6m-6 3h6m-6 3h3"/></g>', width: 20, height: 20 }, touch: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8.116 16.125q-.569 0-1.075-.239a2.26 2.26 0 01-.846-.688L2.62 10.575a.45.45 0 01-.103-.32.45.45 0 01.133-.301q.281-.3.673-.36.39-.062.733.148l1.828.98V4.79q0-.24.161-.4a.55.55 0 01.401-.162.563.563 0 01.574.562v6.75a.63.63 0 01-.337.582.65.65 0 01-.677.005l-1.237-.643 2.339 3.049q.184.232.45.35.266.12.557.119h3.69q.705 0 1.2-.492.494-.49.494-1.196v-2.827a.88.88 0 00-.261-.647.88.88 0 00-.648-.262H9.372a.54.54 0 01-.4-.161.55.55 0 01-.162-.401q0-.24.161-.401a.55.55 0 01.401-.162h3.22q.846 0 1.44.594.593.593.593 1.44v2.826q0 1.166-.828 1.99a2.72 2.72 0 01-1.992.823zm.771-9.367a.54.54 0 01-.4-.162.55.55 0 01-.162-.4q0-.045.072-.282.15-.262.225-.534t.075-.591a2.17 2.17 0 00-.656-1.594 2.17 2.17 0 00-1.594-.656 2.17 2.17 0 00-1.594.656 2.17 2.17 0 00-.656 1.594q0 .32.075.59.075.273.225.535a.4.4 0 01.058.14q.014.072.014.141 0 .24-.155.401a.53.53 0 01-.396.162.58.58 0 01-.49-.293 3.3 3.3 0 01-.456-1.678q0-1.403.985-2.388.986-.985 2.39-.985t2.39.985q.985.985.985 2.388a3.3 3.3 0 01-.456 1.678.6.6 0 01-.197.21.5.5 0 01-.282.083"/></g>', width: 18, height: 18 }, "touch-app": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.514 13.736q-.438 0-.828-.184-.39-.185-.652-.53L3.28 9.46a.34.34 0 01-.079-.247.35.35 0 01.102-.232.88.88 0 01.519-.278.8.8 0 01.565.114l1.408.756V5.001a.42.42 0 01.125-.309.42.42 0 01.309-.124A.434.434 0 016.67 5v5.201q0 .3-.26.449a.5.5 0 01-.522.004l-.953-.496 1.802 2.35q.142.178.347.27.205.09.43.09h2.842q.543 0 .925-.378a1.25 1.25 0 00.381-.922V9.391a.68.68 0 00-.201-.499.68.68 0 00-.5-.201h-2.48a.42.42 0 01-.309-.125.42.42 0 01-.124-.309q0-.184.124-.309a.42.42 0 01.31-.124h2.48q.653 0 1.11.457t.457 1.11v2.178q0 .899-.638 1.533a2.1 2.1 0 01-1.535.634zm.595-7.218a.42.42 0 01-.31-.125.42.42 0 01-.124-.308q0-.035.056-.217.116-.202.173-.412.058-.21.058-.455 0-.722-.505-1.228a1.67 1.67 0 00-1.229-.506q-.721 0-1.228.506A1.67 1.67 0 004.495 5q0 .245.057.455.058.21.174.412a.3.3 0 01.044.108.5.5 0 01.011.109q0 .184-.12.309a.4.4 0 01-.304.124.45.45 0 01-.378-.226A2.54 2.54 0 013.628 5q0-1.08.759-1.84a2.5 2.5 0 011.841-.76q1.083 0 1.842.76.759.758.759 1.84a2.53 2.53 0 01-.351 1.292.5.5 0 01-.152.161.4.4 0 01-.217.065"/></g>' }, "tree-folder": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M3.98 15.375q-.567 0-.961-.394a1.3 1.3 0 01-.394-.962V3.981q0-.57.394-.962.393-.394.962-.394h10.038q.57 0 .962.394.394.393.394.962v10.038q0 .57-.394.962a1.3 1.3 0 01-.962.394zm0-1.125h10.04a.22.22 0 00.158-.072.22.22 0 00.072-.159V6.058H3.75v7.961q0 .086.072.159a.22.22 0 00.159.072"/></g>', width: 18, height: 18 }, "tree-list": { body: '<path fill="currentColor" d="M1.872 7.667q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855V1.539q0-.505.35-.856.35-.35.855-.35H12.13q.504 0 .855.35.35.35.35.856v4.923q0 .504-.35.855-.351.35-.855.35zm0-1H12.13a.2.2 0 00.147-.058.2.2 0 00.058-.147V1.539a.2.2 0 00-.058-.148.2.2 0 00-.147-.058H1.872a.2.2 0 00-.147.058.2.2 0 00-.058.148v4.923q0 .09.058.147a.2.2 0 00.147.058m2.064-2.27v1.039a.386.386 0 00.398.397.386.386 0 00.397-.397V4.398H5.77A.386.386 0 006.167 4a.386.386 0 00-.398-.397H4.731V2.564a.386.386 0 00-.397-.397.386.386 0 00-.398.397v1.039H2.898A.386.386 0 002.5 4a.386.386 0 00.398.398z"/>', width: 14, height: 8 }, troubleshoot: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.238 14.65a.5.5 0 01-.206-.039.8.8 0 01-.19-.119l-3.35-3.35v-.507L10 9.143h.492l3.35 3.35a.4.4 0 01.126.181.7.7 0 01.032.215q0 .128-.032.222a.5.5 0 01-.127.19l-1.19 1.191a.58.58 0 01-.413.159m0-1.079.683-.682L10.03 10l-.682.682zm-8.46 1.096a.54.54 0 01-.23-.048.6.6 0 01-.183-.127l-1.19-1.19a.573.573 0 010-.826L5.492 9.16h1.333l.508-.508L4.683 6h-.905L2.016 4.238l1.571-1.571L5.35 4.429v.904L8 7.984l1.889-1.873-.937-.936.81-.794h-1.62l-.348-.35L9.825 2l.334.35v1.618l.81-.81 2.396 2.382q.255.254.373.571a1.84 1.84 0 01.024 1.238q-.096.285-.318.524l-1.317-1.317-.905.888-.666-.666L7.492 9.84v1.35l-3.317 3.301a1 1 0 01-.19.127.45.45 0 01-.207.048m0-1.111 2.905-2.905-.667-.683-2.92 2.92z"/></g>' }, "ts-logo": { body: '<g fill="currentColor"><path d="M23.507 9.012a1.3 1.3 0 00-.943-.588c-.187-.023-.381-.055-.566-.084-.235-.036-.478-.074-.716-.1-.637-.065-1.028-.33-1.264-.85-.162-.355-.18-.672-.059-.985l.092-.235c.157-.41.322-.837.497-1.25a1.34 1.34 0 00-.039-1.176 2.84 2.84 0 00-1.656-1.438 1.34 1.34 0 00-1.216.158c-.18.117-.368.23-.551.34-.256.155-.52.316-.77.49a1.1 1.1 0 01-.633.188c-.597 0-1.176-.394-1.318-.895a14 14 0 00-.252-.788 17 17 0 01-.22-.662 1.41 1.41 0 00-.914-.962 4 4 0 00-.41-.12c-.055-.016-.116-.032-.172-.049L12.368 0h-.772l-.03.01q-.021.006-.044.016a.4.4 0 01-.061.016c-.788.143-1.26.543-1.435 1.234-.077.304-.186.61-.29.904q-.083.239-.162.476c-.155.471-.714.843-1.273.843-.222 0-.433-.061-.603-.181-.314-.214-.64-.414-.957-.604q-.228-.139-.452-.278a1.18 1.18 0 00-.936-.158c-.868.212-1.504.742-1.895 1.572a1.3 1.3 0 00-.013 1.06q.1.246.197.497c.097.255.197.517.31.772.232.523.207.986-.088 1.447-.2.317-.462.504-.8.569a23 23 0 01-1.558.24 1.39 1.39 0 00-1.069.68 2.97 2.97 0 00-.427 1.829c.049.627.35 1.075.892 1.334.197.094.39.207.582.314.21.119.423.242.65.348.323.149.564.491.642.908.08.433-.029.872-.291 1.14-.365.38-.723.791-1.063 1.218-.155.19-.265.43-.307.659-.158.9.598 2.235 1.445 2.551.209.078.474.1.717.064.455-.07.927-.164 1.44-.29.527-.13.934-.02 1.325.365.293.29.426.604.416.994a85 85 0 01-.048 1.58c-.02.41.123.766.417 1.054.469.458 1.057.73 1.754.804q.116.014.226.013c.53 0 .96-.226 1.267-.672.123-.172.255-.333.397-.504.146-.178.294-.358.43-.552.222-.33.633-.526 1.092-.526.449 0 .856.194 1.085.513.188.265.394.52.592.766q.185.223.362.455c.226.294.533.465.878.498.84.077 1.593-.181 2.232-.766.307-.281.453-.643.43-1.078-.013-.19-.016-.392-.02-.582-.006-.252-.013-.51-.032-.766-.045-.6.143-1.033.585-1.36.293-.213.581-.29.895-.24.565.094 1.07.198 1.544.318.49.12.943.006 1.337-.343a2.95 2.95 0 00.956-1.638c.117-.545-.013-1.017-.384-1.401a11 11 0 01-.424-.475 10 10 0 00-.427-.482c-.406-.419-.52-.852-.367-1.4.103-.386.293-.644.59-.812a40 40 0 011.396-.762c.362-.19.594-.484.688-.875a2.8 2.8 0 00-.402-2.304"/><path d="m11.948 9.142-.003.049-.029.647.558-.241 2.75-1.361a.5.5 0 01.41-.02.54.54 0 01.306.282l.372.809a.56.56 0 01-.252.736l-4.246 2.1-.09 2.004-.01.377v.133c0 .305 0 .36.05.616.028.136.065.165.223.247.173.088.387.143.549.143h.055c.115 0 .22 0 .341-.026.347-.068.56-.15.942-.35a.21.21 0 01.225.022c.065.051.096.14.078.224a9 9 0 00-.105.752l-.004.033a22 22 0 01-.093.737.22.22 0 01-.162.182q-.59.142-.944.182a7 7 0 01-.666.036c-.53 0-.966-.071-1.298-.218a1.67 1.67 0 01-.811-.73c-.183-.327-.276-.768-.276-1.307q0-.108.01-.357c.005-.169.033-.736.086-1.74l.001-.022-1.013.501a.5.5 0 01-.41.02.54.54 0 01-.304-.282l-1.045-2.285a.56.56 0 01.254-.738l.781-.383a.5.5 0 01.41-.021c.134.05.244.152.304.283l.446.974.695-.345.088-1.682v-.007l.084-1.068c.012-.146.017-.207.024-.274.01-.106.021-.226.059-.715.009-.101.074-.189.173-.208.524-.104.973-.205 1.335-.299a.2.2 0 01.183.042c.053.046.08.114.078.182-.018.415-.033.625-.045.78-.012.17-.02.276-.02.515l-.004.05c-.004.055-.01.137-.006.165z"/></g>', width: 24, height: 24 }, "tutorial-video": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m9.292 12.604 3.104-1.958A.73.73 0 0012.75 10a.73.73 0 00-.354-.646L9.292 7.396a.71.71 0 00-.771-.042q-.396.209-.396.667v3.958a.7.7 0 00.396.667q.395.208.77-.042M3.584 16.25q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063v-9.5q0-.625.437-1.062a1.45 1.45 0 011.063-.438h12.833q.624 0 1.062.438.438.436.438 1.062v9.5q0 .624-.438 1.063a1.45 1.45 0 01-1.062.437zm0-1.25h12.833q.104 0 .177-.072a.24.24 0 00.073-.178v-9.5a.24.24 0 00-.073-.177.24.24 0 00-.177-.073H3.584a.24.24 0 00-.177.073.24.24 0 00-.074.177v9.5q0 .105.074.178a.24.24 0 00.176.072"/></g>', width: 20, height: 20 }, undo: { body: '<path fill="currentColor" d="M2.301 9.333a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.212.144-.356a.48.48 0 01.356-.144h4.285q1.043 0 1.796-.69.752-.689.752-1.701t-.752-1.699a2.58 2.58 0 00-1.796-.686H1.905l1.504 1.504a.48.48 0 01.145.351.48.48 0 01-.145.352.47.47 0 01-.355.141.48.48 0 01-.348-.141L.421 3.479a.55.55 0 01-.17-.422q0-.12.038-.224a.55.55 0 01.132-.197L2.706.35a.48.48 0 01.351-.145q.207 0 .352.145a.47.47 0 01.141.354.48.48 0 01-.141.348L1.905 2.557h4.68q1.464 0 2.506.977 1.043.975 1.043 2.408T9.091 8.353q-1.043.98-2.505.98z"/>', width: 11, height: 10 }, "unfold-less": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 11.036 6.285 12.75a.48.48 0 01-.349.142.47.47 0 01-.354-.142.48.48 0 01-.145-.351q0-.207.145-.351l1.996-1.997A.56.56 0 018 9.882a.56.56 0 01.422.17l1.996 1.997q.139.138.142.348a.47.47 0 01-.142.354.48.48 0 01-.351.145.48.48 0 01-.352-.145zm0-6.072L9.715 3.25a.48.48 0 01.348-.142.47.47 0 01.355.142.48.48 0 01.145.35.48.48 0 01-.145.352L8.422 5.947a.56.56 0 01-.422.17.56.56 0 01-.422-.17L5.582 3.951a.48.48 0 01-.142-.348.47.47 0 01.142-.354.48.48 0 01.351-.145q.207 0 .352.145z"/></g>' }, "unmark-deletion": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.867 13.666q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V3.999H3.5a.484.484 0 01-.5-.5.484.484 0 01.5-.5H6q0-.25.175-.416a.6.6 0 01.425-.167h2.8q.25 0 .425.167.175.166.175.416h2.5a.486.486 0 01.5.5.485.485 0 01-.5.5h-.167v8.467q0 .5-.35.85t-.85.35zm-.2-9.667v8.467q0 .084.058.142a.2.2 0 00.142.058h6.266q.084 0 .142-.058a.2.2 0 00.058-.142V3.999zm1.6 6.834a.486.486 0 00.5.5.5.5 0 00.358-.142.5.5 0 00.142-.358v-5a.5.5 0 00-.142-.359.5.5 0 00-.358-.141.485.485 0 00-.5.5zm2.466 0q0 .216.142.358a.5.5 0 00.358.142.5.5 0 00.359-.142.5.5 0 00.141-.358v-5a.5.5 0 00-.141-.359.5.5 0 00-.359-.141.5.5 0 00-.358.141.5.5 0 00-.142.359zM4.667 3.999v8.467q0 .084.058.142a.2.2 0 00.142.058h-.2z"/><path stroke="currentColor" stroke-linecap="round" d="m13.354 2.646-11 11"/></g>' }, unplugged: { body: '<g fill="none"><path fill="currentColor" d="M124.675 137.473c-33.137 0-60-26.861-60-60 0-33.136 26.863-60 60-60s60 26.864 60 60c0 33.139-26.863 60-60 60"/><path fill="url(#svgID0)" d="M98.798 80H54.53c-7.665 0-13.879-5.245-13.879-11.715v-56.57c0-4.81-4.617-8.71-10.315-8.71H1.78C.798 3.005 0 2.333 0 1.503S.798 0 1.78 0h28.556C38 0 44.212 5.245 44.212 11.714v56.572c0 4.81 4.619 8.707 10.317 8.707h44.269z"/><path fill="url(#svgID1)" d="M250 155.938h-28.173c-7.665 0-13.878-5.245-13.878-11.714V87.652c0-4.81-4.618-8.708-10.316-8.708h-28.555c-.983 0-1.781-.673-1.781-1.503s.798-1.503 1.781-1.503h28.555c7.664 0 13.877 5.245 13.877 11.714v56.573c0 4.808 4.618 8.706 10.316 8.706H250z"/><path fill="currentColor" d="M89.244 83.775h-7.096a3.07 3.07 0 01-3.066-3.066V75.27a3.06 3.06 0 011.078-2.334 3.06 3.06 0 011.988-.732h7.096z"/><path fill="currentColor" d="M105.781 89.821H91.61a3.963 3.963 0 01-3.962-3.963V70.123a3.963 3.963 0 013.962-3.964h14.171z"/><path fill="currentColor" d="M108.9 64.75v26.48a.52.52 0 01-.521.52H106.3a.52.52 0 01-.52-.52V64.75a.52.52 0 01.52-.521h2.079c.287 0 .521.233.521.52"/><path fill="currentColor" d="M108.9 74.438v-4.032h9.645a2.016 2.016 0 010 4.032zm0 11.133V81.54h9.645a2.015 2.015 0 010 4.031zm-3.119 4.25H91.61a3.963 3.963 0 01-3.962-3.963V70.123a3.963 3.963 0 013.962-3.964c1.18 16.99 14.171 18.553 14.171 18.553z"/><path fill="currentColor" d="M104.639 89.821V66.16h1.142v23.662zm-4.847 0H91.61a3.963 3.963 0 01-3.962-3.963V74.81c0 11.154 12.144 15.01 12.144 15.01m-12.885-6.045V72.204h.74v11.571zm21.994-9.336v-4.033h1.412v4.033zm-.001 11.133v-4.033h1.412v4.033z"/><path fill="currentColor" d="M87.647 83.776H82.15a3.07 3.07 0 01-3.067-3.067V75.27a3.06 3.06 0 011.078-2.333c-1.04 8.477 7.487 9.772 7.487 9.772zm83.653-.001h7.094a3.067 3.067 0 003.068-3.067v-5.439c0-.933-.419-1.77-1.077-2.333h-.002a3.05 3.05 0 00-1.989-.732H171.3z"/><path fill="currentColor" d="M154.763 89.82h14.171a3.964 3.964 0 003.964-3.964V70.122a3.964 3.964 0 00-3.964-3.964h-14.171z"/><path fill="currentColor" d="M151.643 64.75v26.48c0 .286.233.52.522.52h2.078a.52.52 0 00.52-.52V64.75a.52.52 0 00-.52-.522h-2.078a.52.52 0 00-.522.522"/><path fill="currentColor" d="M154.763 89.82h14.171a3.964 3.964 0 003.964-3.964V70.122a3.964 3.964 0 00-3.964-3.964c-1.18 16.99-14.171 18.552-14.171 18.552z"/><path fill="currentColor" d="M155.906 89.82V66.16h-1.143v23.66zm4.848 0h8.18a3.964 3.964 0 003.964-3.964V74.81c0 11.153-12.144 15.01-12.144 15.01m12.884-6.044v-11.57h-.739v11.57z"/><path fill="currentColor" d="M172.897 83.775h5.497a3.067 3.067 0 003.068-3.067V75.27c0-.934-.419-1.77-1.077-2.334h-.002c1.041 8.476-7.486 9.771-7.486 9.771zm-29.834-36.709v-7.328a1.008 1.008 0 012.016 0v7.328a1.009 1.009 0 01-2.016 0m9.297 9.297c0-.557.451-1.008 1.009-1.008h7.326a1.008 1.008 0 110 2.016h-7.326c-.558 0-1.009-.45-1.009-1.008m-2.575-6.723c0-.257.099-.515.295-.712l5.034-5.033a1.008 1.008 0 111.425 1.427l-5.032 5.032a1.008 1.008 0 01-1.722-.714m-33.206 59.383v7.327a1.007 1.007 0 11-2.016 0v-7.327a1.008 1.008 0 012.016 0m-9.296-9.297c0 .557-.452 1.008-1.01 1.008h-7.325a1.008 1.008 0 110-2.016h7.325c.558 0 1.01.45 1.01 1.008m2.574 6.723c0 .257-.098.516-.295.712l-5.033 5.034a1.009 1.009 0 01-1.425-1.427l5.032-5.032a1.006 1.006 0 011.721.713"/><defs><linearGradient id="svgID0" x1="0" x2="52.102" y1="0" y2="6.172" gradientUnits="userSpaceOnUse"><stop stop-color="currentColor" stop-opacity="0"/><stop offset=".737" stop-color="currentColor"/></linearGradient><linearGradient id="svgID1" x1="197.167" x2="253.056" y1="146.929" y2="149.787" gradientUnits="userSpaceOnUse"><stop offset=".455" stop-color="currentColor"/><stop offset="1" stop-color="currentColor" stop-opacity="0"/></linearGradient></defs></g>', width: 250, height: 156 }, upload: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.333 13q-1.383 0-2.358-.959Q1 11.084 1 9.7q0-1.25.8-2.192T3.783 6.4q.317-1.5 1.5-2.45A4.22 4.22 0 018 3q1.817 0 3.075 1.258 1.258 1.26 1.258 3.075v.334h.2q1.067.083 1.767.85.7.765.7 1.816 0 1.117-.767 1.892-.766.775-1.883.775H8.7q-.5 0-.85-.35a1.16 1.16 0 01-.35-.85V8.117l-.883.9a.47.47 0 01-.35.133.473.473 0 01-.492-.492.5.5 0 01.142-.341L7.583 6.65a.4.4 0 01.192-.133.76.76 0 01.45 0 .4.4 0 01.192.133l1.666 1.667a.5.5 0 01.142.341.473.473 0 01-.492.492.45.45 0 01-.35-.15L8.5 8.117V11.8q0 .067.067.133.066.067.133.067h3.633a1.6 1.6 0 001.184-.483A1.6 1.6 0 0014 10.333a1.6 1.6 0 00-.483-1.183 1.6 1.6 0 00-1.184-.483h-1V7.333q0-1.383-.974-2.358A3.2 3.2 0 008 4q-1.383 0-2.358.975a3.2 3.2 0 00-.975 2.358h-.35q-.95 0-1.634.684A2.25 2.25 0 002 9.667q0 .966.683 1.65a2.25 2.25 0 001.65.683H5.5q.216 0 .359.141A.5.5 0 016 12.5a.5.5 0 01-.141.359A.5.5 0 015.5 13z"/></g>' }, "upload-up": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.205 13q-.506 0-.855-.35a1.16 1.16 0 01-.35-.855v-1.308q0-.213.144-.356a.48.48 0 01.356-.144q.212 0 .356.144a.48.48 0 01.144.356v1.308q0 .077.064.14.064.066.141.065h7.59a.2.2 0 00.14-.064.2.2 0 00.065-.141v-1.308q0-.213.144-.356a.48.48 0 01.356-.144q.213 0 .356.144a.48.48 0 01.144.356v1.308q0 .505-.35.855t-.855.35zM7.5 4.926 6.218 6.208q-.15.149-.353.146a.5.5 0 01-.36-.157.52.52 0 01-.15-.35.47.47 0 01.15-.352l2.073-2.073A.55.55 0 018 3.252a.55.55 0 01.422.17l2.073 2.073q.149.149.147.348a.5.5 0 01-.147.354.5.5 0 01-.357.16.47.47 0 01-.356-.15L8.5 4.927v5.1q0 .212-.144.356a.48.48 0 01-.356.144.48.48 0 01-.356-.144.48.48 0 01-.144-.356z"/></g></g>' }, usage: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M10 17.917a7.65 7.65 0 01-3.083-.625 8.1 8.1 0 01-2.511-1.699 8 8 0 01-1.697-2.51A7.65 7.65 0 012.083 10q0-3.062 2.021-5.312t5.063-2.563v1.77q-2.313.292-3.813 2.032T3.854 10q0 2.583 1.782 4.365 1.78 1.78 4.364 1.78a6.2 6.2 0 002.709-.603 6.1 6.1 0 002.166-1.73l1.521.896a8 8 0 01-2.812 2.365 7.8 7.8 0 01-3.584.844m7.25-4.75-1.52-.875q.228-.563.323-1.136.093-.573.093-1.156 0-2.334-1.5-4.073t-3.812-2.031V2.125q3.041.291 5.062 2.552 2.02 2.26 2.02 5.323 0 .813-.145 1.615a5.8 5.8 0 01-.52 1.552"/></g>', width: 20, height: 20 }, "usage-details": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 14.667a6.5 6.5 0 01-2.6-.525 6.7 6.7 0 01-2.117-1.425A6.7 6.7 0 011.86 10.6 6.5 6.5 0 011.333 8q0-1.383.526-2.6a6.7 6.7 0 011.425-2.117q.9-.9 2.116-1.425A6.5 6.5 0 018 1.333q1.383 0 2.6.525t2.117 1.425T14.142 5.4t.525 2.6-.525 2.6a6.7 6.7 0 01-1.425 2.117q-.9.9-2.117 1.425a6.5 6.5 0 01-2.6.525m0-1.334q2.234 0 3.784-1.55T13.334 8t-1.55-3.783T8 2.667t-3.783 1.55T2.667 8t1.55 3.783T8 13.333M7.6 9v2.283q0 .267.25.325.25.059.383-.175l2.017-3.95a.31.31 0 00-.017-.325A.32.32 0 009.95 7H8.5V4.683q0-.266-.25-.333-.25-.066-.383.167l-2.1 4q-.084.183.008.333T6.05 9z"/></g>' }, "user-check": { body: '<path fill="currentColor" d="M1.783 13.484a.55.55 0 01-.4-.167.55.55 0 01-.166-.4v-1.1q0-.6.308-1.1t.892-.767a12.3 12.3 0 012.216-.767A9 9 0 016.65 8.95q.483 0 1.075.067.591.066 1.158.216l-.95.934a24 24 0 00-.633-.059 8 8 0 00-.65-.024q-.95 0-1.742.175-.792.174-2.008.708a.84.84 0 00-.425.375 1.06 1.06 0 00-.125.492v.516H7.6l1.133 1.133zm8.717-.017a.48.48 0 01-.4-.183l-1.617-1.617a.47.47 0 01-.166-.358q0-.21.166-.375.15-.15.359-.15.207 0 .375.15l1.283 1.283 3.183-3.184q.15-.15.359-.15.207 0 .375.15.15.168.15.375a.5.5 0 01-.15.359L10.9 13.284a.6.6 0 01-.2.141.5.5 0 01-.2.042m-3.85-5.55q-1.134 0-1.867-.725-.733-.726-.733-1.875t.733-1.875 1.867-.725q1.15 0 1.883.725.734.724.734 1.875 0 1.149-.734 1.875-.733.725-1.883.725m0-1.134q.633 0 1.05-.416.417-.417.417-1.05T7.7 4.267 6.65 3.85t-1.05.417-.417 1.05.417 1.05 1.05.416"/>' }, "user-failure": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M12 12q-1.65 0-2.825-1.175T8 8t1.175-2.825T12 4t2.825 1.175T16 8t-1.175 2.825T12 12m-7 8a.97.97 0 01-.712-.288A.97.97 0 014 19v-1.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T12 13h.35q.15 0 .3.05-.2.45-.338.938A8 8 0 0012.1 15q-.124.9-.075 1.512.05.614.275 1.488.15.525.4 1.038.25.512.55.962zm9.7-.7a.95.95 0 01-.275-.7q0-.425.275-.7l1.4-1.4-1.4-1.4a.95.95 0 01-.275-.7q0-.425.275-.7a.95.95 0 01.7-.275q.424 0 .7.275l1.4 1.4 1.4-1.4a.95.95 0 01.7-.275q.424 0 .7.275a.95.95 0 01.275.7.95.95 0 01-.275.7l-1.4 1.4 1.4 1.4a.95.95 0 01.275.7.95.95 0 01-.275.7.95.95 0 01-.7.275.95.95 0 01-.7-.275l-1.4-1.4-1.4 1.4a.95.95 0 01-.7.275.95.95 0 01-.7-.275"/></g>', width: 24, height: 24 }, "user-not-executed": { body: '<mask id="svgID0" width="24" height="24" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h24v24H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M11.5 12q-1.65 0-2.825-1.175T7.5 8t1.175-2.825T11.5 4t2.825 1.175T15.5 8t-1.175 2.825T11.5 12m-7 8a.97.97 0 01-.712-.288A.97.97 0 013.5 19v-1.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T11.5 13h.35q.15 0 .3.05-.2.45-.338.938A8 8 0 0011.6 15q-.124.9-.075 1.512.05.614.275 1.488.15.525.4 1.038.25.512.55.962z"/><path fill-rule="evenodd" d="m14.197 14.404-.255-.255a.625.625 0 01.884-.884l5.48 5.48a.625.625 0 11-.884.884l-.326-.326a3.5 3.5 0 01-4.9-4.9m4 4a2.25 2.25 0 01-3.103-3.103zM19.25 16.5q0 .16-.022.314l1.012 1.012a3.5 3.5 0 00-4.566-4.566l1.012 1.012q.155-.022.314-.022a2.25 2.25 0 012.25 2.25" clip-rule="evenodd"/></g>', width: 24, height: 24 }, "user-passed": { body: '<path fill="currentColor" d="M13.55 15.975q-.2 0-.375-.062a.9.9 0 01-.325-.213l-2.05-2.05a.95.95 0 01-.275-.7q0-.425.275-.7a.95.95 0 01.7-.275q.425 0 .7.275l1.35 1.35 4.35-4.35a.95.95 0 01.7-.275q.425 0 .7.275a.95.95 0 01.275.7.95.95 0 01-.275.7l-5.05 5.05q-.15.15-.325.213a1.1 1.1 0 01-.375.062M8 8Q6.35 8 5.175 6.825T4 4t1.175-2.825T8 0t2.825 1.175T12 4t-1.175 2.825T8 8m-7 8a.97.97 0 01-.712-.288A.97.97 0 010 15v-1.8q0-.825.425-1.55t1.175-1.1q1.275-.65 2.875-1.1T8 9q.75 0 1.463.075.712.075 1.387.225L8.6 11.55q-.574.575-.562 1.412.012.838.587 1.413L10.25 16z"/>', width: 20 }, "user-role": { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M7.5 8.775q-1.086 0-1.856-.779-.768-.777-.768-1.846 0-1.088.768-1.856a2.53 2.53 0 011.857-.77 2.53 2.53 0 011.856.77 2.53 2.53 0 01.769 1.856q0 1.069-.77 1.846a2.5 2.5 0 01-1.855.779m-4.95 5.7a.67.67 0 01-.477-.188.64.64 0 01-.197-.487v-.994q0-.563.29-1.022.291-.46.816-.722a12.6 12.6 0 012.006-.768q1.088-.32 2.513-.32h.225q.093 0 .187.038a4.2 4.2 0 00-.3 1.088h-.112q-1.294 0-2.297.3t-1.716.675a1 1 0 00-.366.319.74.74 0 00-.121.412v.544h4.725q.075.3.216.59.14.29.29.535zM7.5 7.65q.62 0 1.06-.441.44-.44.44-1.06 0-.618-.44-1.059a1.45 1.45 0 00-1.06-.44q-.618 0-1.058.44A1.45 1.45 0 006 6.15q0 .618.44 1.059t1.06.44m5.1 5.512q.6 0 1.013-.421.413-.422.413-1.022 0-.582-.413-1.004a1.36 1.36 0 00-1.012-.421q-.582 0-1.003.421a1.37 1.37 0 00-.422 1.004q0 .6.422 1.022a1.37 1.37 0 001.003.421m-.693.882a2.3 2.3 0 01-.497-.207 3 3 0 01-.46-.318l-.712.243a.26.26 0 01-.206-.01.36.36 0 01-.15-.14l-.281-.45q-.056-.092-.038-.206a.3.3 0 01.113-.187l.58-.47a1.77 1.77 0 010-1.144l-.58-.486a.3.3 0 01-.113-.188.3.3 0 01.038-.206l.28-.469q.075-.075.17-.122a.22.22 0 01.187-.01l.713.263q.206-.206.45-.328.242-.122.506-.197l.131-.75a.4.4 0 01.113-.178.28.28 0 01.187-.065h.544q.13 0 .206.065.075.066.094.178l.131.75q.263.076.506.207.245.131.45.337l.694-.281a.3.3 0 01.216.009.35.35 0 01.16.14l.28.488q.056.094.038.197a.3.3 0 01-.113.178l-.58.488q.093.262.093.562t-.094.563l.581.469q.094.075.113.187a.3.3 0 01-.038.206l-.28.47a.3.3 0 01-.15.13.3.3 0 01-.207 0l-.713-.243q-.225.187-.459.318a2.3 2.3 0 01-.497.207l-.131.75a.33.33 0 01-.094.168.28.28 0 01-.206.075h-.544a.25.25 0 01-.187-.075.5.5 0 01-.113-.168z"/></g>', width: 18, height: 18 }, users: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M1.03 13.35a.64.64 0 01-.468-.187.64.64 0 01-.188-.47v-.262q0-.768.779-1.237.777-.47 2.034-.469.225 0 .431.019.207.018.394.056a2.5 2.5 0 00-.31.694 3 3 0 00-.103.806v1.05zm4.52 0a.674.674 0 01-.675-.694v-.318q0-1.088 1.133-1.744Q7.143 9.937 9 9.938q1.857 0 2.991.656t1.134 1.744v.318a.676.676 0 01-.675.694zm8.85 0V12.3q0-.43-.113-.806a3 3 0 00-.3-.694q.187-.038.394-.056.205-.02.43-.019 1.257 0 2.035.469t.778 1.237v.263a.64.64 0 01-.187.469.64.64 0 01-.469.187zM9 11.063q-1.182 0-2.017.318-.834.32-.927.77v.074h5.887v-.075q-.112-.468-.937-.778t-2.007-.31m-5.813-1.07q-.525 0-.9-.374-.375-.375-.375-.9 0-.544.375-.919t.9-.375.9.375.375.919q0 .525-.375.9t-.9.375m11.625 0q-.525 0-.9-.374-.375-.375-.375-.9 0-.544.375-.919t.9-.375.9.375.375.919q0 .525-.375.9t-.9.375m-5.813-.618q-.806 0-1.377-.571a1.88 1.88 0 01-.573-1.379q0-.806.573-1.378.57-.572 1.377-.572t1.379.572.571 1.378-.571 1.379a1.88 1.88 0 01-1.379.571M9 6.6a.8.8 0 00-.825.825A.8.8 0 009 8.25a.8.8 0 00.591-.234.8.8 0 00.234-.59.8.8 0 00-.234-.582A.8.8 0 009 6.6"/></g>', width: 18, height: 18 }, versions: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M18 0H0v18h18z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M5.213 14.85V3.15a1.34 1.34 0 00-.91.422 1.3 1.3 0 00-.365.928v9q0 .525.365.919.366.393.91.431m9.131 1.369q.563 0 .965-.404.404-.402.404-.965V3.15q0-.562-.404-.966a1.32 1.32 0 00-.965-.403H7.688q-.563 0-.956.403a1.33 1.33 0 00-.394.966v11.7q0 .563.394.965.392.404.956.404zM2.813 13.5v-9a.98.98 0 00-.638.319.93.93 0 00-.262.656v7.031q0 .395.262.675a.98.98 0 00.638.319m11.531 1.594H7.688a.2.2 0 01-.16-.075.25.25 0 01-.065-.169V3.15a.25.25 0 01.065-.169.2.2 0 01.16-.075h6.656q.094 0 .169.075t.075.169v11.7a.23.23 0 01-.075.169.23.23 0 01-.169.075"/></g>', width: 18, height: 18 }, "view-agenda": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.417 9q-.624 0-1.062-.438A1.45 1.45 0 012.917 7.5V4.687q0-.645.438-1.083a1.45 1.45 0 011.062-.437h11.167q.625 0 1.063.437.437.438.437 1.083V7.5q0 .625-.437 1.062A1.45 1.45 0 0115.584 9zm0-1.25h11.167a.25.25 0 00.167-.074.23.23 0 00.083-.176V4.687a.26.26 0 00-.083-.187q-.083-.084-.167-.083H4.417q-.082 0-.166.083a.26.26 0 00-.084.187V7.5q0 .105.084.176a.25.25 0 00.166.074m0 9.083q-.624 0-1.062-.437a1.47 1.47 0 01-.438-1.084V12.5q0-.625.438-1.063A1.45 1.45 0 014.417 11h11.167q.625 0 1.063.437.437.438.437 1.063v2.812q0 .646-.437 1.084a1.45 1.45 0 01-1.063.437zm0-1.25h11.167q.084 0 .167-.083a.26.26 0 00.083-.188V12.5a.23.23 0 00-.083-.178.26.26 0 00-.167-.072H4.417a.26.26 0 00-.166.072.23.23 0 00-.084.178v2.812q0 .104.084.188.082.083.166.083"/></g></g>', width: 20, height: 20 }, visibility: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 10.383q1.133 0 1.925-.792.792-.791.792-1.924t-.792-1.925A2.62 2.62 0 008 4.95q-1.134 0-1.925.792a2.62 2.62 0 00-.792 1.925q0 1.133.792 1.924.792.792 1.925.792m0-.916q-.75 0-1.275-.526A1.73 1.73 0 016.2 7.667q0-.75.525-1.276Q7.25 5.867 8 5.867t1.275.524.525 1.276-.525 1.274Q8.75 9.466 8 9.467m0 2.866a7.37 7.37 0 01-4.009-1.15A7.54 7.54 0 011.2 8.067a.6.6 0 01-.05-.176 1.5 1.5 0 010-.45.6.6 0 01.05-.174A7.54 7.54 0 013.991 4.15 7.37 7.37 0 018 3a7.37 7.37 0 014.008 1.15A7.54 7.54 0 0114.8 7.267a.6.6 0 01.05.174 1.5 1.5 0 010 .45.6.6 0 01-.05.176 7.54 7.54 0 01-2.792 3.116A7.37 7.37 0 018 12.333"/></g>' }, "visibility-off-outline": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m13.144 10.81-.935-.935q.188-1.035-.591-1.861t-1.91-.639l-.935-.936A2.9 2.9 0 0110 6.186q1.418 0 2.408.99t.99 2.407q0 .352-.064.657a2.5 2.5 0 01-.19.57m2.651 2.594-.92-.862a9 9 0 001.407-1.323q.614-.72 1.052-1.636a8.2 8.2 0 00-2.99-3.343Q12.395 5 10 5q-.604 0-1.187.083-.584.085-1.146.25l-.971-.97a8.4 8.4 0 011.614-.464q.823-.15 1.69-.149 2.78 0 5.058 1.473 2.28 1.473 3.434 3.857.055.096.075.228.021.133.021.275a1.4 1.4 0 01-.096.503 9 9 0 01-1.142 1.81 9.2 9.2 0 01-1.555 1.508m.234 4.381-2.933-2.907a9 9 0 01-1.42.388q-.78.15-1.676.15-2.794 0-5.061-1.472-2.268-1.473-3.43-3.858a.7.7 0 01-.076-.228 1.8 1.8 0 010-.543.7.7 0 01.075-.222 9 9 0 011.138-1.777q.669-.817 1.438-1.45L2.202 3.97a.6.6 0 01-.177-.429.6.6 0 01.19-.449.6.6 0 01.44-.181q.256 0 .438.181l13.814 13.814a.62.62 0 01.184.429.58.58 0 01-.184.45.6.6 0 01-.439.18.6.6 0 01-.439-.18M4.962 6.744a9 9 0 00-1.285 1.263 7 7 0 00-1.01 1.576 8.2 8.2 0 002.99 3.344q1.947 1.24 4.343 1.24.57 0 1.133-.097.564-.096.957-.198l-1.054-1.08a3 3 0 01-1.035.19q-1.419-.001-2.409-.99-.99-.99-.99-2.409 0-.252.052-.53a3 3 0 01.138-.505z"/></g>', width: 20, height: 20 }, "visibility-outline": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M8 10.383q1.133 0 1.925-.792.792-.791.792-1.924t-.792-1.925A2.62 2.62 0 008 4.95q-1.134 0-1.925.792a2.62 2.62 0 00-.792 1.925q0 1.133.792 1.924.792.792 1.925.792m0-.916q-.75 0-1.275-.526A1.73 1.73 0 016.2 7.667q0-.75.525-1.276Q7.25 5.867 8 5.867t1.275.524.525 1.276-.525 1.274Q8.75 9.466 8 9.467m0 2.866a7.37 7.37 0 01-4.009-1.15A7.54 7.54 0 011.2 8.067a.6.6 0 01-.05-.176 1.5 1.5 0 010-.45.6.6 0 01.05-.174A7.54 7.54 0 013.991 4.15 7.37 7.37 0 018 3a7.37 7.37 0 014.008 1.15A7.54 7.54 0 0114.8 7.267a.6.6 0 01.05.174 1.5 1.5 0 010 .45.6.6 0 01-.05.176 7.54 7.54 0 01-2.792 3.116A7.37 7.37 0 018 12.333m0-1q1.883 0 3.459-.992a6.5 6.5 0 002.408-2.674 6.5 6.5 0 00-2.408-2.676A6.37 6.37 0 008 4q-1.883 0-3.459.991a6.5 6.5 0 00-2.408 2.676 6.5 6.5 0 002.408 2.674A6.36 6.36 0 008 11.333"/></g>' }, "visual-difference": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M3.584 17.083q-.625 0-1.063-.437a1.45 1.45 0 01-.437-1.063v-9.5q0-.624.437-1.062a1.45 1.45 0 011.063-.438h2.541L7.23 3.396q.21-.23.5-.354.292-.125.605-.125h3.333q.313 0 .604.125t.5.354l1.104 1.187h2.542q.624 0 1.062.438.438.437.438 1.062v9.5q0 .625-.438 1.063a1.45 1.45 0 01-1.062.437zm12.833-1.25q.104 0 .177-.072a.24.24 0 00.073-.178v-9.5a.24.24 0 00-.073-.176.24.24 0 00-.177-.074H3.584a.24.24 0 00-.177.074.24.24 0 00-.074.176v9.5q0 .105.074.178a.24.24 0 00.176.072z"/><path d="M10 14.167q-1.394 0-2.364-.97-.97-.969-.97-2.364 0-1.394.97-2.363T10 7.5q1.378 0 2.356.97.977.97.977 2.363t-.977 2.364a3.23 3.23 0 01-2.356.97m0-.91q1 0 1.712-.711a2.34 2.34 0 00.712-1.713q0-1-.712-1.712A2.34 2.34 0 0010 8.41q-1 0-1.712.712a2.33 2.33 0 00-.712 1.712q0 1 .712 1.713a2.34 2.34 0 001.712.712"/></g>', width: 20, height: 20 }, "visual-difference-loading": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M13.004 10.862a3.45 3.45 0 01-.946 2.133 2.72 2.72 0 01-2.057.883q-.175 0-.35-.025a4 4 0 01-.35-.066.7.7 0 00-.313.008.46.46 0 00-.257.159.45.45 0 00-.098.42q.059.239.278.318.268.105.54.142.274.038.55.038 1.646 0 2.78-1.179 1.137-1.179 1.216-2.856l.404.367a.51.51 0 00.686-.008.5.5 0 00.162-.356.47.47 0 00-.149-.356l-1.03-1.03a.72.72 0 00-.528-.214.72.72 0 00-.527.214l-1.03 1.03a.48.48 0 00-.156.35q0 .193.156.349.155.155.349.155.195 0 .35-.155zm-7-.032-.404-.367a.51.51 0 00-.686.008.5.5 0 00-.162.356.47.47 0 00.15.356l1.03 1.03a.72.72 0 00.527.213q.314 0 .527-.213l1.03-1.03a.48.48 0 00.156-.35.48.48 0 00-.155-.349.48.48 0 00-.35-.155.48.48 0 00-.35.155l-.32.32a3.45 3.45 0 01.946-2.132A2.72 2.72 0 0110 7.79q.174 0 .349.024.174.026.341.067.15.042.318 0a.45.45 0 00.26-.167.45.45 0 00.103-.42.42.42 0 00-.274-.319 4 4 0 00-.545-.133A3.3 3.3 0 0010 6.796q-1.647 0-2.782 1.179-1.136 1.178-1.215 2.856M3.59 17.083q-.63 0-1.069-.437a1.45 1.45 0 01-.437-1.069V6.09q0-.631.437-1.07a1.45 1.45 0 011.07-.437h2.544l1.09-1.18q.205-.227.496-.356.29-.13.613-.13h3.333q.323 0 .613.13.292.13.496.355l1.09 1.181h2.545q.63 0 1.069.438.437.438.437 1.069v9.487q0 .63-.437 1.069a1.45 1.45 0 01-1.07.437zm0-1.25h12.82a.25.25 0 00.185-.072.25.25 0 00.072-.184V6.09a.25.25 0 00-.072-.184.25.25 0 00-.184-.073h-3.103L11.78 4.167H8.222l-1.53 1.666H3.59a.25.25 0 00-.184.073.25.25 0 00-.072.184v9.487a.25.25 0 00.072.184.25.25 0 00.184.072"/></g></g>', width: 20, height: 20 }, warning: { body: '<mask id="svgID0" width="18" height="18" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h18v18H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.569 15.375a.66.66 0 01-.579-.339.7.7 0 01-.096-.328.6.6 0 01.095-.35l6.42-11.09a.67.67 0 01.59-.34q.174 0 .33.083.158.082.261.256l6.42 11.09q.105.175.096.35a.72.72 0 01-.333.575.64.64 0 01-.342.093zm.768-1.125h11.325L9 4.5zM9 13.356a.6.6 0 00.431-.174.6.6 0 00.175-.432.6.6 0 00-.175-.432.6.6 0 00-.431-.174.6.6 0 00-.432.174.6.6 0 00-.174.432q0 .258.174.432t.432.174m0-1.962q.24 0 .4-.162a.55.55 0 00.162-.4V8.207a.54.54 0 00-.161-.401A.55.55 0 009 7.644a.54.54 0 00-.401.162.55.55 0 00-.162.4v2.626q0 .24.162.4a.55.55 0 00.401.162"/></g>', width: 18, height: 18 }, "warning-fill": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M2.854 17.083a.69.69 0 01-.646-.375.73.73 0 010-.75L9.333 3.625A.74.74 0 0110 3.25q.438 0 .667.375l7.125 12.333q.207.375 0 .75a.69.69 0 01-.646.375zM10 8.5a.606.606 0 00-.625.625v2.917q0 .25.177.437a.6.6 0 00.448.188q.27 0 .448-.188a.62.62 0 00.177-.437V9.125a.6.6 0 00-.177-.448A.6.6 0 0010 8.5m0 6.333a.65.65 0 00.48-.187.65.65 0 00.187-.48.65.65 0 00-.188-.479A.65.65 0 0010 13.5a.65.65 0 00-.48.188.65.65 0 00-.187.479q0 .291.188.479a.65.65 0 00.479.187"/></g>', width: 20, height: 20 }, web: { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M6.706 13.146a8.6 8.6 0 01-.682-1.28q-.3-.69-.48-1.42H3.282a5.3 5.3 0 001.404 1.742q.87.697 2.02.958m-3.843-3.7H5.34a8.3 8.3 0 01-.12-1.449q0-.362.029-.72.029-.357.091-.728H2.863a5.3 5.3 0 00-.199 1.448 5.4 5.4 0 00.199 1.45m.419-3.897h2.262q.168-.736.474-1.437a7.7 7.7 0 01.688-1.263 4.9 4.9 0 00-2.007.955A5.2 5.2 0 003.282 5.55m3.288 0h2.854a7.8 7.8 0 00-.568-1.505 9 9 0 00-.859-1.366q-.51.65-.852 1.34t-.575 1.53m3.881 0h2.262A5.3 5.3 0 0011.296 3.8a4.8 4.8 0 00-2.008-.952q.352.556.657 1.257t.506 1.443M7.997 14.33a6.1 6.1 0 01-2.458-.5 6.4 6.4 0 01-2.016-1.36 6.4 6.4 0 01-1.36-2.015Q1.665 9.3 1.664 7.997q0-1.312.5-2.463a6.4 6.4 0 011.359-2.011 6.4 6.4 0 012.016-1.36q1.156-.498 2.458-.499a6.1 6.1 0 012.464.5 6.4 6.4 0 012.01 1.359 6.4 6.4 0 011.36 2.01q.5 1.152.5 2.464 0 .174-.009.353a4 4 0 01-.031.353h-1.017q.035-.174.045-.348a5.4 5.4 0 00-.187-1.806h-2.478a8.3 8.3 0 01.119 1.448q0 .183-.003.355a5 5 0 01-.02.35h-1a5 5 0 00.02-.347q.003-.174.003-.358 0-.375-.028-.726a8 8 0 00-.091-.722H6.34a8.4 8.4 0 00-.12 1.448q0 .375.029.727.029.35.091.722h2.362v1H6.57q.233.835.584 1.54.353.705.843 1.33.196-.26.37-.531.173-.273.336-.556v2.062a4 4 0 01-.348.031 8 8 0 01-.358.009m3.167-2.454v1.22q0 .213-.144.357a.48.48 0 01-.356.143.48.48 0 01-.356-.143.48.48 0 01-.144-.357v-2.33q0-.259.172-.43a.58.58 0 01.43-.173h2.331q.213 0 .357.144a.48.48 0 01.143.356q0 .213-.143.356a.48.48 0 01-.357.144H11.86l1.789 1.782a.47.47 0 01.138.346.5.5 0 01-.138.357.47.47 0 01-.357.152.5.5 0 01-.356-.152z"/></g>' }, "while-loop": { body: '<g fill="none"><mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="M13.871 6.245c1.142 0 2.076.934 2.076 2.076v3.46c0 .987-.698 1.819-1.625 2.026-.245.055-.45.253-.45.504v.476c0 .25.204.457.452.424a3.47 3.47 0 003.007-3.43V8.32a3.47 3.47 0 00-3.46-3.46h-3.42a.454.454 0 00-.455.454v.476c0 .25.204.454.454.454z"/><path d="M10.757 4.255a.454.454 0 00-.729-.361L8.325 5.19a.454.454 0 000 .723l1.703 1.297c.3.228.73.015.73-.361zm-4.497 9.6a2.08 2.08 0 01-2.076-2.076V8.32c0-.987.698-1.819 1.625-2.026.245-.055.45-.253.45-.504v-.475c0-.251-.204-.458-.452-.425A3.47 3.47 0 002.8 8.32v3.46a3.47 3.47 0 003.46 3.46h3.697a.455.455 0 00.455-.454v-.476a.454.454 0 00-.455-.454z"/><path d="M9.374 13.25c0-.376.43-.589.73-.36l1.702 1.297a.454.454 0 010 .722l-1.702 1.297a.454.454 0 01-.73-.36zM7.686 9.314q.357 0 .551.205.195.199.195.504 0 .3-.195.499-.194.194-.551.194-.342 0-.541-.194a.67.67 0 01-.2-.499q0-.305.195-.504.194-.205.546-.205m2.574 0q.357 0 .551.205.195.199.194.504 0 .3-.194.499-.195.194-.551.194-.342 0-.541-.194a.67.67 0 01-.2-.499q0-.305.194-.504.195-.205.547-.205m2.573 0q.357 0 .552.205.195.199.194.504 0 .3-.194.499-.195.194-.552.194-.341 0-.54-.194a.67.67 0 01-.2-.499q0-.305.194-.504.195-.205.546-.205"/></g></g>', width: 20, height: 20 }, "widget-exit": { body: '<mask id="svgID0" width="22" height="22" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h22v22H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M18.674 11.687H8.55a.67.67 0 01-.49-.197.67.67 0 01-.198-.49q0-.293.198-.49a.67.67 0 01.49-.198h10.124l-1.185-1.184a.65.65 0 01-.202-.48.7.7 0 01.202-.487.7.7 0 01.49-.22.65.65 0 01.49.206l2.272 2.273q.249.248.249.58 0 .33-.249.58l-2.272 2.272a.65.65 0 01-.485.202.7.7 0 01-.495-.216.72.72 0 01-.206-.483.64.64 0 01.206-.483zM13.935 7.44V4.865a.27.27 0 00-.079-.203.28.28 0 00-.203-.079H4.866a.28.28 0 00-.203.08.28.28 0 00-.08.202v12.27q0 .123.08.202.079.08.203.08h8.787q.123 0 .203-.08a.27.27 0 00.08-.203V14.56q0-.292.197-.49a.67.67 0 01.49-.197q.292 0 .49.197a.67.67 0 01.197.49v2.574q0 .686-.486 1.172a1.6 1.6 0 01-1.17.485H4.865q-.687 0-1.172-.485a1.6 1.6 0 01-.486-1.172V4.865q0-.686.486-1.171a1.6 1.6 0 011.172-.486h8.787q.686 0 1.172.486t.485 1.171V7.44a.67.67 0 01-.197.49.67.67 0 01-.49.197.67.67 0 01-.49-.197.67.67 0 01-.198-.49"/></g>', width: 22, height: 22 }, "wifi-off": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="m15.875 18.25-7.25-7.292q-.646.147-1.24.396a6.4 6.4 0 00-1.114.604 1.77 1.77 0 01-.969.302 1.13 1.13 0 01-.885-.364 1.13 1.13 0 01-.344-.906q.03-.532.448-.844Q5 9.792 5.53 9.5q.531-.291 1.094-.542L4.75 7.083q-.542.293-1.052.615-.51.323-.99.698a1.48 1.48 0 01-.948.333q-.531 0-.885-.375a1.15 1.15 0 01-.354-.896q.021-.52.437-.854.458-.375.938-.719t1.02-.635L1.75 4.083a.8.8 0 01-.23-.583.8.8 0 01.23-.583.8.8 0 01.583-.23.8.8 0 01.584.23l14.145 14.146q.25.25.25.593 0 .344-.25.594a.9.9 0 01-.593.24.78.78 0 01-.594-.24M10 17.5a2 2 0 01-1.48-.615q-.603-.615-.603-1.468 0-.876.604-1.48A2 2 0 0110 13.334q.874 0 1.48.604.603.604.603 1.48 0 .855-.604 1.468-.604.615-1.479.615m5.688-5.73q-.334.334-.782.324a1.1 1.1 0 01-.781-.344l-3.417-3.417a9.4 9.4 0 012.594.604q1.22.48 2.24 1.271.375.292.427.76a.94.94 0 01-.281.803m3.437-3.416a1.2 1.2 0 01-.875.386q-.521.01-.937-.323a11.4 11.4 0 00-3.365-1.907A11.5 11.5 0 0010 5.833a11 11 0 00-1.667.125L6.208 3.833a14 14 0 011.865-.375A15 15 0 0110 3.333q2.604 0 4.906.865a14.3 14.3 0 014.136 2.385q.416.354.437.875.021.522-.354.896"/></g>', width: 20, height: 20 }, windows: { body: '<path fill="currentColor" d="m0 93.7 183.6-25.3v177.4H0zm0 324.6 183.6 25.3V268.4H0zm203.8 28L448 480V268.4H203.8zm0-380.6v180.1H448V32z"/>', width: 448, height: 512 }, "windows-link": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h16v16H0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M4.692 11.026q-1.255 0-2.14-.885A2.92 2.92 0 011.667 8q0-1.255.885-2.141a2.92 2.92 0 012.14-.885h2.013q.212 0 .356.143a.48.48 0 01.144.357q0 .213-.144.356a.48.48 0 01-.356.144H4.692a1.95 1.95 0 00-1.432.593A1.95 1.95 0 002.667 8q0 .84.593 1.433a1.95 1.95 0 001.432.593h2.013q.212 0 .356.144a.48.48 0 01.144.356q0 .213-.144.356a.48.48 0 01-.356.144zM6 8.5a.48.48 0 01-.356-.144A.48.48 0 015.5 8q0-.213.144-.356A.48.48 0 016 7.5h4q.212 0 .356.144A.48.48 0 0110.5 8q0 .212-.144.357A.48.48 0 0110 8.5zm3.295 2.526a.48.48 0 01-.356-.144.48.48 0 01-.144-.356q0-.212.144-.357a.48.48 0 01.356-.143h2.014a1.95 1.95 0 001.431-.593q.594-.593.593-1.433 0-.84-.593-1.432a1.95 1.95 0 00-1.431-.593H9.295a.48.48 0 01-.356-.144.48.48 0 01-.144-.357q0-.212.144-.356a.48.48 0 01.356-.143h2.013q1.255 0 2.14.885T14.333 8t-.885 2.14-2.14.886z"/></g></g>' }, "windows-lite": { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="currentColor" mask="url(#svgID0)"><path d="m6.5 6.274 2.8-.385v2.705H6.5zm0 4.952 2.8.385V8.94H6.5zm3.109.427 3.724.514V8.939H9.61zm0-5.806v2.747h3.724v-3.26z"/><path d="M7.708 17.5a.607.607 0 01-.625-.625.61.61 0 01.625-.625H8.75v-1.667H3.583q-.624 0-1.062-.437a1.45 1.45 0 01-.438-1.063V4.417q0-.625.438-1.063a1.45 1.45 0 011.062-.437h12.834q.624 0 1.062.437.438.438.438 1.063v8.666q0 .625-.438 1.063a1.45 1.45 0 01-1.062.437H11.25v1.667h1.042q.27 0 .448.177a.6.6 0 01.177.448.6.6 0 01-.177.448.6.6 0 01-.448.177zm-4.125-4.167h12.834q.104 0 .177-.073a.24.24 0 00.073-.177V4.417a.24.24 0 00-.073-.177.24.24 0 00-.177-.073H3.583a.24.24 0 00-.176.073.24.24 0 00-.074.177v8.666q0 .105.074.177a.24.24 0 00.176.073"/></g>', width: 20, height: 20 }, "windows-menu": { body: '<g fill="none"><mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M16 0v16H0V0z"/></mask><g mask="url(#svgID0)"><path fill="currentColor" d="M3 2.205q0-.506.35-.855Q3.7 1 4.205 1h7.59q.505 0 .855.35t.35.855v1.27q0 .504-.35.855-.35.35-.855.35h-7.59q-.505 0-.855-.35A1.16 1.16 0 013 3.474zm.983 0v1.27q0 .09.058.147a.2.2 0 00.147.058h7.624a.2.2 0 00.147-.058.2.2 0 00.058-.148V2.205a.2.2 0 00-.058-.147.2.2 0 00-.147-.058H4.189a.2.2 0 00-.148.058.2.2 0 00-.058.147M3 7.346q0-.506.35-.855.35-.35.855-.35h7.59q.505 0 .855.35t.35.855v6.449q0 .505-.35.855t-.855.35h-7.59q-.505 0-.855-.35a1.16 1.16 0 01-.35-.855zm.983 0v6.449q0 .09.058.147a.2.2 0 00.147.058h7.624a.2.2 0 00.147-.058.2.2 0 00.058-.147V7.346a.2.2 0 00-.058-.147.2.2 0 00-.147-.058H4.189a.2.2 0 00-.148.058.2.2 0 00-.058.147"/></g></g>' }, "wrap-text": { body: '<mask id="svgID0" width="16" height="16" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M16 0H0v16h16z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M12.667 8.167q.212 0 .356-.144a.48.48 0 00.143-.357.48.48 0 00-.143-.356.48.48 0 00-.357-.143H4.5q-.973 0-1.653.68a2.25 2.25 0 00-.68 1.653q0 .974.68 1.653a2.25 2.25 0 001.653.68h2.01l-.668.668a.47.47 0 00-.149.35.5.5 0 00.156.357.5.5 0 00.356.155.5.5 0 00.356-.155l1.45-1.45a.56.56 0 00.173-.425.56.56 0 00-.173-.423L6.546 9.441a.45.45 0 00-.338-.138.5.5 0 00-.358.155.48.48 0 00-.15.361.52.52 0 00.16.362l.651.651H4.5q-.553 0-.943-.39-.39-.392-.39-.944 0-.553.39-.943t.943-.39zm0-3.667q.212 0 .356-.144A.48.48 0 0013.166 4a.48.48 0 00-.143-.356.48.48 0 00-.357-.144H3.333a.48.48 0 00-.356.144.48.48 0 00-.144.356q0 .212.144.356a.48.48 0 00.356.144zm0 7.333q.212 0 .356-.143a.48.48 0 00.143-.357.48.48 0 00-.143-.356.48.48 0 00-.357-.144H10.65a.46.46 0 00-.345.144.5.5 0 00-.139.357q0 .212.144.356a.48.48 0 00.356.143z"/></g>' }, wrench: { body: '<path fill="currentColor" d="m7.729 8.812-1.75-1.729a2.4 2.4 0 00-.312.688q-.105.375-.105.77 0 1.188.844 2.021.844.834 2.031.834.293 0 .573-.052.282-.052.573-.157l2.938 3a.77.77 0 00.5.198.76.76 0 00.52-.177l.605-.562a.66.66 0 00.229-.51.7.7 0 00-.209-.511l-3-2.98q.084-.27.146-.551.063-.282.063-.553 0-1.228-.854-2.083-.854-.854-2.084-.854-.354 0-.729.115-.375.114-.708.302L8.79 7.79zm2.27 9.646a8.6 8.6 0 01-3.343-.646 8.2 8.2 0 01-2.687-1.78 8.2 8.2 0 01-1.782-2.688A8.6 8.6 0 011.542 10q0-1.77.645-3.323A8.2 8.2 0 013.97 3.989a8.4 8.4 0 012.687-1.791A8.5 8.5 0 0110 1.542q1.77 0 3.323.656a8.4 8.4 0 012.687 1.791 8.4 8.4 0 011.792 2.678q.656 1.54.656 3.333 0 1.791-.656 3.344a8.4 8.4 0 01-1.792 2.687 8.2 8.2 0 01-2.687 1.781 8.6 8.6 0 01-3.323.646m0-1.416q3 0 5.022-2.021 2.02-2.022 2.02-5.021t-2.02-5.021Q12.999 2.959 10 2.959t-5.021 2.02q-2.02 2.02-2.02 5.02t2.02 5.022q2.02 2.02 5.02 2.02"/>', width: 20, height: 20 }, wysiwyg: { body: '<mask id="svgID0" width="20" height="20" x="0" y="0" maskUnits="userSpaceOnUse" style="mask-type:alpha"><path fill="#D9D9D9" d="M0 0h20v20H0z"/></mask><g fill="none" mask="url(#svgID0)"><path fill="currentColor" d="M4.423 17.083a1.45 1.45 0 01-1.064-.442 1.45 1.45 0 01-.442-1.064V4.423q0-.621.442-1.064a1.45 1.45 0 011.064-.442h11.154q.621 0 1.064.442.442.443.442 1.064v11.154q0 .621-.442 1.064a1.45 1.45 0 01-1.064.442zm0-1.25h11.154a.25.25 0 00.184-.072.25.25 0 00.072-.184V5.833H4.167v9.744a.25.25 0 00.072.184.25.25 0 00.184.072m2.035-6.041a.6.6 0 01-.445-.18.6.6 0 01-.18-.446q0-.265.18-.445t.445-.18h7.084q.265 0 .445.18t.18.446-.18.445a.6.6 0 01-.445.18zm0 3.333a.6.6 0 01-.445-.18.6.6 0 01-.18-.445q0-.266.18-.445.18-.18.445-.18h3.75q.266 0 .446.18t.18.445-.18.445a.6.6 0 01-.446.18z"/></g>', width: 20, height: 20 }, xray: { body: '<g fill="currentColor"><path d="m14.419 10-4.71 1.182L7.345 20c.02 0 7.074-10 7.074-10" opacity=".5"/><path d="M14.419 10 5 12.365V6.473h7.054z" opacity=".8"/><path d="M5 6.473v5.892L12.054 0z"/></g>', width: 20, height: 20 }, zip: { body: '<g fill="currentColor"><path d="M3.172 6.707h17.656c.465 0 .887.207 1.172.531v-.867A1.17 1.17 0 0020.828 5.2h-8.324a2.37 2.37 0 01-1.399-.46L9.391 3.46C8.984 3.16 8.496 3 7.992 3h-4.82A1.17 1.17 0 002 4.172v3.07a1.55 1.55 0 011.172-.535"/><path d="M20.828 7.098h-8.047v.39h.39c.216 0 .392.176.392.39v.782c0 .215-.176.39-.391.39.215 0 .39.177.39.391v.782c0 .214-.175.39-.39.39.215 0 .39.176.39.39v.782a.39.39 0 01-.39.39c.215 0 .39.177.39.391v.782c0 .214-.175.39-.39.39.215 0 .39.176.39.39v.782a.39.39 0 01-.39.39c.215 0 .39.177.39.391v.782a.39.39 0 01-.261.37l.613 2.055q.04.136.04.278v.031h6.874A1.17 1.17 0 0022 18.035V8.27a1.17 1.17 0 00-1.172-1.172M10.047 19.176q0-.142.043-.278l.633-2.117a1 1 0 01.5-.593v-.106h-.391a.39.39 0 01-.39-.39v-.782a.39.39 0 01.39-.39.39.39 0 01-.39-.391v-.781c0-.215.175-.391.39-.391a.39.39 0 01-.39-.39v-.782a.39.39 0 01.39-.39.39.39 0 01-.39-.391v-.781c0-.215.175-.391.39-.391a.39.39 0 01-.39-.39V8.66a.39.39 0 01.39-.39.39.39 0 01-.39-.391v-.781h-7.27A1.17 1.17 0 002 8.27v9.765a1.17 1.17 0 001.172 1.172h6.875z"/><path d="m13.54 19.008-.634-2.117a.58.58 0 00-.562-.418h.828v-.782h-.781v-.78h.78v-.782h-.78v-.781h.78v-.782h-.78v-.78h.78v-.782h-.78v-.781h.78V9.44h-.78v-.78h.78v-.782h-.78v-.781h-1.563v.78h.781v.782h-.78v.781h.78v.782h-.78v.78h.78v.782h-.78v.781h.78v.782h-.78v.78h.78v.782h-.78v.781h.78v.782h.047a.59.59 0 00-.562.418l-.633 2.117a.6.6 0 00-.024.168v1.867c0 .324.262.586.586.586h1.954a.585.585 0 00.585-.586v-1.867a.6.6 0 00-.023-.168m-.563 1.449a.585.585 0 01-.586.586h-.782a.585.585 0 01-.586-.586v-.195c0-.325.262-.586.586-.586h.782c.324 0 .586.262.586.586z"/></g>', width: 24, height: 24 } } };
addCollection(iconify_bundle_default);
var Icon3 = ({
  className: className2 = "",
  name,
  setRef,
  toolTip = "",
  tootTipClassName = "",
  toolTipPlacement = "bottom",
  tooltipAlignment = "start",
  ...extra
}) => /* @__PURE__ */ jsx(Fragment, { children: toolTip ? /* @__PURE__ */ jsx(
  ToolTip,
  {
    content: toolTip,
    className: tootTipClassName,
    placement: toolTipPlacement,
    tooltipClassName: tootTipClassName,
    align: tooltipAlignment,
    children: /* @__PURE__ */ jsx("div", { className: classNames67(className2), ref: setRef, ...extra, children: /* @__PURE__ */ jsx(Icon, { icon: name }) })
  }
) : /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames67("inline-flex items-center", className2),
    ref: setRef,
    "data-icon-name": name,
    "data-testid": name,
    ...extra,
    children: /* @__PURE__ */ jsx(Icon, { icon: name })
  }
) });
var MultiSelectItem = ({
  children,
  isSelected = false,
  className: className2 = "",
  wrapperClassName = "",
  role,
  ...extra
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      role,
      className: classNames67(
        "cursor-pointer hover:bg-secondary-50 py-2 px-4 text-xs leading-3.5 flex items-center break-all gap-x-2 rounded",
        className2
      ),
      ...extra,
      children: [
        /* @__PURE__ */ jsx("span", { className: classNames67("w-full", wrapperClassName), children }),
        isSelected && /* @__PURE__ */ jsx(
          Icon3,
          {
            name: "check-circle",
            className: " text-base text-primary-600 shrink-0"
          }
        )
      ]
    }
  );
};
var multi_select_item_default = MultiSelectItem;
var MultiSelectGroupLabel = ({
  children,
  className: className2 = "",
  ...extra
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "py-2 px-4 text-secondary-400 text-2xs leading-3 break-all font-semibold uppercase",
        className2
      ),
      ...extra,
      children
    }
  );
};
var multi_select_group_label_default = MultiSelectGroupLabel;
var useAnimatedClass = (className2) => {
  const [isAnimated, setIsAnimated] = useState(false);
  useEffect(() => {
    const timeout = setTimeout(() => {
      setIsAnimated(true);
    }, 1e3);
    return () => {
      clearTimeout(timeout);
    };
  }, []);
  return isAnimated ? "" : className2;
};
var use_animated_class_default = useAnimatedClass;
var useBeforeUnloadWarning = (handleBeforeUnload) => {
  const onBeforeUnloadHandler = (event) => {
    handleBeforeUnload(event);
  };
  useEffect(() => {
    window.addEventListener("beforeunload", onBeforeUnloadHandler);
    return () => {
      window.removeEventListener("beforeunload", onBeforeUnloadHandler);
    };
  }, [onBeforeUnloadHandler, handleBeforeUnload]);
};
var use_before_unload_warning_default = useBeforeUnloadWarning;
function useBindActions({
  actionHandlers,
  initialState: initialState3,
  extraActions = {}
}) {
  const [state, _setState] = useState(initialState3);
  const setState = (newValues) => {
    _setState((prev) => ({ ...prev, ...newValues }));
  };
  const { t } = useTranslation();
  const actions = useMemo(() => {
    return bindActions(
      { ...actionHandlers },
      { state, setState, t, ...extraActions }
    );
  }, [actionHandlers, state, extraActions, t]);
  return { actions, setState, state };
}
var useClickOutside = (ref, handler, enabled = true, buttonRef = null) => {
  if (buttonRef) {
    buttonRef.current = buttonRef?.current || buttonRef;
  }
  useEffect(() => {
    const listener = (event) => {
      if (!ref.current || ref.current.contains(event.composedPath()?.[0]) || !enabled || buttonRef?.current?.contains(event.composedPath()?.[0])) {
        return;
      }
      handler(event);
    };
    document.addEventListener("mousedown", listener);
    return () => document.removeEventListener("mousedown", listener);
  }, [ref, handler, enabled, buttonRef]);
};
var use_click_outside_default = useClickOutside;
var useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);
  useEffect(
    () => {
      const handler = setTimeout(() => {
        setDebouncedValue(value);
      }, delay);
      return () => {
        clearTimeout(handler);
      };
    },
    [value, delay]
    // Only re-call effect if value or delay changes
  );
  return debouncedValue;
};
var use_debounce_default = useDebounce;
var useExternalEvents = (moduleName = "", events = [], handler = (eventName, data, publish) => {
}) => {
  const GROOT_TO_ANGULAR = "ts-react-external-events";
  const ANGULAR_TO_GROOT = "ts-angular-to-groot-event";
  const publish = useCallback((eventName, data, debounce5 = false) => {
    const event = new CustomEvent(GROOT_TO_ANGULAR, {
      detail: { moduleName, eventName, data }
    });
    debounce5 ? window.setTimeout(() => window.dispatchEvent(event), 50) : window.dispatchEvent(event);
  }, []);
  const customHandler = useCallback(
    ({ detail: { moduleName: _moduleName, data, eventName } }) => {
      if (events.includes(eventName) && _moduleName == moduleName)
        handler(eventName, data, publish);
    },
    [handler, publish, events, moduleName]
  );
  useEffect(() => {
    window.addEventListener(ANGULAR_TO_GROOT, customHandler);
    return () => window.removeEventListener(ANGULAR_TO_GROOT, customHandler);
  }, [customHandler]);
  return publish;
};
var use_external_events_default = useExternalEvents;
var useFocus = (ref) => {
  const getFirstFocusableElement = () => {
    const focusableElements = 'input:not(:disabled), select, textarea, [tabindex]:not([tabindex="-1"])';
    return ref?.current.querySelectorAll(focusableElements)[0];
  };
  useEffect(() => {
    const firstFocusableElement = getFirstFocusableElement();
    firstFocusableElement?.focus();
  }, []);
  return /* @__PURE__ */ jsx(Fragment, {});
};
var use_focus_default = useFocus;
var createMarker = (textToMark) => `<span class="bg-orange-300">${textToMark}</span>`;
var escapeRegExp = (string2) => {
  return string2.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
};
var markSearchableText = (element, regex2) => {
  const walker = document.createTreeWalker(element, NodeFilter.SHOW_TEXT, null);
  const textNodes = [];
  let currentNode = walker.nextNode();
  while (currentNode) {
    textNodes.push(currentNode);
    currentNode = walker.nextNode();
  }
  textNodes.forEach((textNode) => {
    const { textContent } = textNode;
    const markedText = textContent.replace(
      regex2,
      (match) => createMarker(match)
    );
    if (markedText !== textContent) {
      const span = document.createElement("span");
      span.innerHTML = markedText;
      textNode.parentNode.replaceChild(span, textNode);
    }
  });
};
var useHighlight = (ref, searchTerm, containerSelector) => {
  const containerElement = document.querySelector(containerSelector);
  const searchAndMark = useCallback(() => {
    const searchableElementList = containerElement?.querySelectorAll(".tree-node");
    searchableElementList?.forEach((element) => {
      const escapedSearchTerm = escapeRegExp(searchTerm || "");
      let regex2;
      if (escapedSearchTerm?.trim() !== "") {
        regex2 = new RegExp(`(${escapedSearchTerm})`, "gi");
      } else {
        regex2 = new RegExp(`[^\\w\\s]`, "g");
      }
      if (searchTerm?.trim() !== "") {
        markSearchableText(element, regex2);
      }
    });
  }, [searchTerm]);
  useEffect(() => {
    if (ref?.current && searchTerm) {
      searchAndMark();
    }
  }, [ref?.current, searchTerm]);
  const handleScroll = () => {
    searchAndMark();
  };
  return { handleScroll };
};
var use_highlight_default = useHighlight;
function useHorizontalResize({
  defaultWidth,
  minWidth,
  maxWidth
}) {
  const [width, setWidth] = useState(defaultWidth);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartX = useRef(0);
  const targetRef = useRef(null);
  const onMouseMove = (event) => {
    const deltaY = dragStartX.current - event.clientX;
    const convertedHeight = typeof width === "string" ? Number(width?.replace("px", "")) : width;
    const newHeight = Math.min(
      Math.max(convertedHeight - deltaY, minWidth),
      maxWidth
    );
    setWidth(`${newHeight}px`);
  };
  const onMouseUp = () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
    setIsDragging(false);
  };
  const onMouseDown = (event) => {
    dragStartX.current = event.clientX;
    setIsDragging(true);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };
  useEffect(() => {
    setWidth(defaultWidth);
  }, [targetRef?.current]);
  return { width, onMouseDown, isDragging, targetRef };
}
var useInternalEvents = (events = [], handler = (_eventName, _data, _publish) => {
}) => {
  const id = "ts-internal-events-hook";
  const publish = useCallback((eventName, data = null, debounce5 = false) => {
    const event = new CustomEvent(id, { detail: { eventName, data } });
    debounce5 ? window.setTimeout(() => window.dispatchEvent(event), 50) : window.dispatchEvent(event);
  }, []);
  const eventsRef = useRef(events);
  const handlerRef = useRef(handler);
  useEffect(() => {
    eventsRef.current = events;
    handlerRef.current = handler;
  });
  const customHandler = useCallback(
    ({ detail: { data, eventName } }) => {
      if (eventsRef.current.includes(eventName))
        handlerRef.current(eventName, data, publish);
    },
    [publish]
  );
  useEffect(() => {
    window.addEventListener(id, customHandler);
    return () => window.removeEventListener(id, customHandler);
  }, [customHandler]);
  return publish;
};
var use_internal_events_default = useInternalEvents;
var useKeyPress = (targetKey, handler, element) => {
  const target = element ? element?.current : window;
  const upHandler = (e) => {
    e.key === targetKey && handler?.();
  };
  useEffect(() => {
    target?.addEventListener("keyup", upHandler);
    return () => target?.removeEventListener("keyup", upHandler);
  }, [handler, element]);
};
var use_key_press_default = useKeyPress;

// src/custom-hooks/use-on-action/index.ts
var useOnAction = (actionHandlers, data) => {
  const onAction = (action) => {
    const { type, payload } = action || {};
    const handler = actionHandlers[type];
    let result;
    if (handler) {
      result = handler(payload, data);
    }
    return result;
  };
  return { onAction };
};
var use_on_action_default = useOnAction;
var usePopstateListener = (onBrowserNavigate) => {
  const namedOnBrowserNavigate = () => {
    onBrowserNavigate();
  };
  useEffect(() => {
    window.addEventListener("popstate", namedOnBrowserNavigate);
    return () => window.removeEventListener("popstate", namedOnBrowserNavigate);
  }, [onBrowserNavigate]);
};
var use_popstate_listener_default = usePopstateListener;
function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  }, [value]);
  return ref.current;
}
var useToggle = (initialState3 = false) => {
  const [state, setState] = useState(initialState3);
  const toggle = useCallback(() => {
    setState((prevState) => !prevState);
  }, []);
  return [state, toggle];
};
var use_toggle_default = useToggle;
var useTransitionEnd = (target, handler) => {
  useEffect(() => {
    target?.current?.addEventListener("transitionend", handler);
  }, [target, handler]);
};
var use_transition_end_default = useTransitionEnd;
function useVerticalResize({
  defaultHeight,
  minHeight,
  maxHeight
}) {
  const [height, setHeight] = useState(defaultHeight);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartY = useRef(0);
  const targetRef = useRef(null);
  const onMouseMove = (event) => {
    const deltaY = event.clientY - dragStartY.current;
    const convertedHeight = typeof height === "string" ? height?.replace("px", "") : height;
    const newHeight = Math.min(
      Math.max(convertedHeight - deltaY, minHeight),
      maxHeight
    );
    setHeight(`${newHeight}px`);
  };
  const onMouseUp = () => {
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
    setIsDragging(false);
  };
  const onMouseDown = (event) => {
    dragStartY.current = event.clientY;
    setIsDragging(true);
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };
  useEffect(() => {
    setHeight(defaultHeight);
  }, [targetRef?.current]);
  return { height, onMouseDown, isDragging, targetRef };
}
var Dropdown = ({
  children,
  setRef,
  onToggleHandler,
  toggleDropdown,
  className: className2,
  style = {},
  attributes = {},
  isAnimationEnabled = false,
  closeOnClickOutside = true,
  buttonRef = null,
  role,
  ariaLabel,
  ...extra
}) => {
  const ref = useRef(null);
  const updateRef = (el) => {
    ref.current = el;
    setRef?.(el);
  };
  use_click_outside_default(
    ref,
    (event) => {
      onToggleHandler ? onToggleHandler(event) : closeOnClickOutside && toggleDropdown?.(false);
    },
    true,
    buttonRef
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      ref: updateRef,
      className: classNames67(
        "bg-white rounded overflow-hidden shadow-md gap-0.5 z-[1000] max-h-[320px] overflow-y-auto",
        className2,
        {
          "absolute top-full left-0 transition-all duration-300 ease-out": isAnimationEnabled
        }
      ),
      style,
      role,
      "aria-label": ariaLabel,
      ...attributes,
      ...extra,
      children
    }
  );
};
var DropdownItem = ({
  children,
  isSelected = false,
  isDisabled = false,
  className: className2 = "",
  ...extra
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames67(
      "cursor-pointer text-unique-600 hover:bg-secondary-50 py-2 px-3 text-xs",
      { "!text-primary-600 cursor-default": isSelected },
      { "!cursor-not-allowed !opacity-50 pointer-events-none": isDisabled },
      className2
    ),
    ...extra,
    children
  }
);
var DropdownButton = ({
  children,
  className: className2,
  wrapperClassName,
  name,
  placement = "bottom-end",
  variant = "select-fill",
  fillWidth = true,
  label,
  labelClassName = "",
  disabled = false,
  dropdownIconClassName = "h-6",
  dropdownClassName = "",
  onFocusClassName = "",
  showDropdownOnHover = false,
  onClick,
  hideOnChildClick = true,
  isOpen,
  setIsOpen,
  showDropdownOnMoreClick = false,
  livePlacement = true,
  showDropdownIcon = true,
  isRequired = false,
  hideErrorMessage,
  hasError = false,
  errorText = "",
  errorClassName = "",
  nameClassName = "",
  closeOnOutsideClick = true,
  offset = [0, 4],
  ...extra
}) => {
  const [btnRef, setBtnRef] = useState(null);
  const [showDropdown, _toggleDropdown] = useState(false);
  const [dropdownRef, setDropdownRef] = useState(null);
  const [timer, setTimer] = useState(null);
  const offsetModifier7 = [
    {
      name: "offset",
      options: {
        offset
      }
    },
    {
      name: "computeStyles",
      options: {
        adaptive: livePlacement
      }
    }
  ];
  const { styles: styles2, attributes } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: "fixed",
    modifiers: offsetModifier7
  });
  const preventEventBubbling = (event) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
  };
  const handleChildClick = (handler, event) => {
    preventEventBubbling(event);
    if (hideOnChildClick) {
      _toggleDropdown(false);
    }
    handler?.();
  };
  const onToggleDropdown = (event) => {
    preventEventBubbling(event);
    toggleDropdown(!showDropdown);
    onClick && onClick();
  };
  const toggleDropdown = useCallback(
    (toggle) => {
      _toggleDropdown(toggle);
      setIsOpen?.(toggle);
    },
    [_toggleDropdown]
  );
  const onToggleHandler = (event) => {
    if (!btnRef?.contains(event?.composedPath()?.[0]) && closeOnOutsideClick) {
      toggleDropdown(!showDropdown);
    }
  };
  useEffect(() => {
    if (hideOnChildClick) return;
    toggleDropdown(isOpen);
  }, [isOpen]);
  const padding = {
    "select-fill": "px-3 h-9",
    "select-fill-plain": "px-3 h9",
    "no-bg": ""
  };
  const bgShowDropDown = {
    "select-fill": "border border-primary-300 bg-white",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50",
    "no-bg": "text-primary-500",
    light: "border border-primary-300 bg-white"
  };
  const bgDropDown = {
    "select-fill": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "no-bg": "text-primary-500",
    light: "border border-secondary-200 bg-white text-unique-800"
  };
  const style = {
    ...styles2.popper || {},
    ...btnRef ? { width: btnRef.offsetWidth } : {}
  };
  const showOptions = useCallback(() => {
    timer && clearInterval(timer);
    toggleDropdown(true);
  }, [timer, toggleDropdown]);
  const hideOptions = useCallback(() => {
    setTimer(
      setTimeout(() => {
        toggleDropdown(false);
      }, 100)
    );
  }, [toggleDropdown, setTimer]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-block relative select-none",
        { "w-full": fillWidth },
        wrapperClassName
      ),
      onMouseEnter: showDropdownOnHover ? () => showOptions() : null,
      onMouseLeave: showDropdownOnHover ? () => hideOptions() : null,
      children: [
        label && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames67(
              "text-secondary-500 text-xs font-medium p-1",
              labelClassName
            ),
            children: [
              label,
              isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: setBtnRef,
            className: classNames67(
              "rounded text-xs leading-3.5 flex items-center",
              { "cursor-pointer": !disabled },
              { [bgShowDropDown[variant]]: showDropdown },
              { [bgDropDown[variant]]: !showDropdown },
              padding[variant],
              className2,
              { [onFocusClassName]: showDropdown }
            ),
            onClick: (e) => {
              if (!disabled && !showDropdownOnMoreClick) onToggleDropdown(e);
              else preventEventBubbling(e);
            },
            ...extra,
            "data-isopen": showDropdown,
            children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  className: classNames67(
                    "truncate w-full",
                    {
                      "border-r-[0.5px] border-r-secondary-200 pr-2": showDropdownOnMoreClick && !disabled
                    },
                    nameClassName
                  ),
                  children: name
                }
              ),
              !disabled && showDropdownIcon && /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "expand-more",
                  className: classNames67(
                    `ml-2 text-base flex items-center transform duration-300 ${dropdownIconClassName}`,
                    {
                      "rotate-180": showDropdown
                    }
                  ),
                  onClick: (e) => {
                    if (!disabled && showDropdownOnMoreClick) onToggleDropdown(e);
                  }
                }
              )
            ]
          }
        ),
        (hideOnChildClick ? showDropdown : isOpen) && /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: classNames67(
              "w-full min-w-[90px] z-[1000]",
              dropdownClassName
            ),
            toggleDropdown,
            setRef: setDropdownRef,
            style,
            attributes: attributes.popper,
            onToggleHandler,
            buttonRef: btnRef,
            children: React__default.Children.map(
              children,
              (child) => React__default.isValidElement(child) ? React__default.cloneElement(child, {
                ...child.props,
                onClick: (event) => handleChildClick(child.props?.["onClick"], event)
              }) : child
            )
          }
        ),
        !hideErrorMessage && hasError && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67(
              "pl-0.5 text-xs h-4 text-error-600",
              errorClassName
            ),
            children: errorText
          }
        )
      ]
    }
  );
};

// src/utils/common.ts
var generateUniqueId = () => Math.random().toString(36).substr(2);
var NOOP = () => {
};
var handleDownload = (src, name) => {
  fetch(src, {
    cache: "no-store"
  }).then(async (response) => {
    if (response.ok) {
      const downloadedFile = await response.blob();
      if (downloadedFile) {
        const a = document.createElement("a");
        const downloadUrl = window.URL.createObjectURL(downloadedFile);
        a.href = downloadUrl;
        a.download = name;
        a.click();
        a.remove();
        return;
      }
    } else {
      return void 0;
    }
  });
};
var cloneString = (search, itemList = []) => {
  const pattern = new RegExp(`(${search})(-clone)?(-([0-9]))?`);
  let rank = 0;
  const rankMap = {};
  itemList.forEach((item) => {
    const match = (item || "").match(pattern);
    const localRank = match?.[4] ? 4 : match?.[2] ? 2 : 0;
    if (localRank > rank) {
      rankMap[localRank] = match;
      rank = localRank;
    }
  });
  if (rank == 0) {
    return `${search}-clone`;
  } else if (rank == 2) {
    return `${search}-clone-2`;
  } else {
    return `${search}-clone-${Number(rankMap[rank][4]) + 1}`;
  }
};
var tsLog = (message, type = "INFO", module = "COMMON") => {
  const logColors = {
    INFO: "#3498db",
    // blue
    WARNING: "#f39c12",
    // yellow
    ERROR: "#e74c3c"
    // red
  };
  const objects = [];
  const timestamp = (/* @__PURE__ */ new Date()).toLocaleString();
  let formattedMessage = `%c[${timestamp}] ${module} - ${type}: `;
  let messageStyle = "";
  if (typeof message === "object") {
    formattedMessage += "%o";
    messageStyle = `color: ${logColors[type] || "#8e44ad"}; font-weight: bold`;
    objects.push(message);
  } else if (typeof message === "string") {
    formattedMessage += `%c${message}`;
    messageStyle = "color: #95a5a6";
  } else {
    formattedMessage += `%c${JSON.stringify(message)}`;
    messageStyle = "color: #95a5a6";
  }
  if (window["tslog"]) {
    console.log(formattedMessage, messageStyle, ...objects);
  }
};
var isFireFox = () => {
  return navigator.userAgent.toLowerCase().indexOf("firefox") > -1;
};
var isChrome = () => {
  return navigator.userAgent.toLowerCase().indexOf("chrome");
};
var isEdge = () => {
  return navigator.userAgent.toLowerCase().indexOf("edge");
};
var Input = ({
  id,
  type = "text",
  value,
  placeholder,
  onFocus = NOOP,
  onChange = NOOP,
  onInput,
  isReadOnly = false,
  isDisabled = false,
  isRequired = false,
  prefix,
  suffix,
  hasError = false,
  errorText = "",
  className: className2,
  inputClassName,
  wrapperClassName,
  label = "",
  labelClassName = "",
  hideErrorMessage,
  preventDecimal = false,
  preventDefaultValue = false,
  setRef = () => {
  },
  minValue,
  errorClassName = "",
  onBlur,
  customInputRef,
  onkeydown,
  preventFloatingValue = false,
  showOutline = false,
  infoIcon,
  maxValue,
  preventLeadingSpace = true,
  autofocus = false,
  ariaLabel
}) => {
  const ref = useRef(null);
  const variantClasses = useMemo(() => {
    return {
      normal: [
        "bg-secondary-50 border-transparent",
        { "focus-within:bg-white": !(isDisabled || isReadOnly) }
      ],
      error: "bg-white border-error-300",
      disabled: "bg-neutral-50 border-neutral-100"
    };
  }, []);
  const variant = hasError ? "error" : isDisabled ? "disabled" : "normal";
  const hasOutline = !(prefix || suffix);
  const handleKeyDown = useCallback(
    (event) => {
      const { code, key, currentTarget } = event;
      const preventConditions = [
        preventDecimal && code === "Period",
        preventFloatingValue && (key === "e" || key === "E" || key === "-" || key === "."),
        preventLeadingSpace && Number(currentTarget.selectionStart) === 0 && key === " "
      ];
      if (preventConditions.some(Boolean)) {
        event.preventDefault();
      }
      onkeydown?.(event);
    },
    [preventDecimal, onkeydown, preventFloatingValue, preventLeadingSpace]
  );
  const handleScroll = useCallback(
    (event) => {
      if (type == "number") {
        event.currentTarget.blur();
      }
    },
    [type]
  );
  const valueAttributes = useMemo(() => {
    return preventDefaultValue ? { value } : { defaultValue: value };
  }, [preventDefaultValue, value]);
  const updateRef = useCallback(
    (el) => {
      ref.current = el;
      setRef?.(el);
    },
    [setRef]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67("inline-flex flex-col", wrapperClassName),
      ref: updateRef,
      children: [
        label && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames67(
              "text-secondary-500 text-xs font-medium p-1 flex items-center",
              labelClassName
            ),
            children: [
              label,
              isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" }),
              infoIcon
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            id: id || void 0,
            className: classNames67(
              "inline-flex rounded border items-center",
              variantClasses[variant],
              className2,
              {
                "focus-within:border-primary-300": (hasOutline || showOutline) && !(isReadOnly || isDisabled)
              },
              {
                "focus-within:border-neutral-100": !hasOutline && !showOutline && !(isReadOnly || isDisabled)
              }
            ),
            children: [
              prefix,
              /* @__PURE__ */ jsx(
                "input",
                {
                  className: classNames67(
                    "flex-grow outline-none text-unique-600 text-small leading-5 px-3 py-2 bg-transparent",
                    { "!cursor-not-allowed": isDisabled || isReadOnly },
                    inputClassName
                  ),
                  type,
                  readOnly: isReadOnly,
                  disabled: isDisabled,
                  required: isRequired,
                  placeholder,
                  onChange: (e) => onChange(e.target.value),
                  onFocus,
                  onInput: (e) => onInput?.(e.target.value),
                  onKeyDown: handleKeyDown,
                  ref: customInputRef || ref,
                  ...valueAttributes,
                  onScroll: handleScroll,
                  onWheel: handleScroll,
                  min: minValue,
                  onBlur,
                  max: maxValue,
                  autoFocus: autofocus,
                  "aria-label": ariaLabel || label || placeholder || void 0
                }
              ),
              suffix
            ]
          }
        ),
        !hideErrorMessage && hasError && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67(
              "pl-0.5 text-xs h-4 text-error-600",
              errorClassName
            ),
            children: errorText
          }
        )
      ]
    }
  );
};
var PasswordInput = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  return /* @__PURE__ */ jsx(
    Input,
    {
      ...props,
      type: showPassword ? "text" : "password",
      suffix: props?.hasMask ? !showPassword ? /* @__PURE__ */ jsx(
        Icon3,
        {
          name: "eye-with-slash",
          onClick: () => setShowPassword((prev) => !prev),
          className: "mr-2 cursor-pointer text-secondary-500 w-5 h-5"
        }
      ) : /* @__PURE__ */ jsx(
        Icon3,
        {
          name: "eye-icon",
          onClick: () => setShowPassword((prev) => !prev),
          className: "mr-2 cursor-pointer text-secondary-500 w-5 h-5"
        }
      ) : null
    }
  );
};
var InputWithRef = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsx(Input, { ...props, ref });
  }
);
InputWithRef.displayName = "InputWithRef";
var PasswordInputWithRef = forwardRef(
  (props, ref) => {
    return /* @__PURE__ */ jsx(PasswordInput, { ...props, ref });
  }
);
PasswordInputWithRef.displayName = "PasswordInputWithRef";
var Prefix = ({ iconName, iconClassName }) => {
  if (iconName) {
    return /* @__PURE__ */ jsx(
      Icon3,
      {
        name: iconName,
        className: classNames67("pl-3 text-base", iconClassName)
      }
    );
  }
  return null;
};
var Suffix = ({
  showClearIcon,
  input,
  onClear,
  suffixIconName,
  suffixIconClassName,
  clearIconClassName
}) => {
  if (showClearIcon && input?.length) {
    return /* @__PURE__ */ jsx(
      Icon3,
      {
        name: "close",
        className: classNames67("pr-3 text-base", clearIconClassName),
        onClick: onClear
      }
    );
  } else if (suffixIconName) {
    return /* @__PURE__ */ jsx(
      Icon3,
      {
        name: suffixIconName,
        className: classNames67("pr-3 text-base", suffixIconClassName)
      }
    );
  }
  return null;
};
var DebouncedSearchInput = ({
  value,
  onChange,
  prefixIconName,
  prefixIconClassName,
  suffixIconName,
  suffixIconClassName,
  showClearIcon = false,
  clearIconClassName,
  inputClassName,
  characterLimit = 250,
  ...rest
}) => {
  const [input, setInput] = useState(value || "");
  const debouncedInputValue = use_debounce_default(input, 500);
  const inputRef = useRef(null);
  const { t } = useTranslation();
  const handleInputChange = (_value) => {
    setInput(_value);
  };
  const onClear = useCallback(() => {
    setInput("");
    if (inputRef.current) {
      const inputElement = inputRef.current.querySelector("input");
      inputElement?.focus();
    }
  }, [inputRef, onChange]);
  useEffect(() => {
    if (input !== value) setInput(value);
  }, [value]);
  useEffect(() => {
    if (debouncedInputValue.length <= characterLimit)
      onChange(debouncedInputValue);
  }, [debouncedInputValue]);
  return /* @__PURE__ */ jsx(
    Input,
    {
      ...rest,
      type: "text",
      onChange: handleInputChange,
      prefix: /* @__PURE__ */ jsx(Prefix, { iconName: prefixIconName, iconClassName: prefixIconClassName }),
      suffix: /* @__PURE__ */ jsx(
        Suffix,
        {
          input,
          onClear,
          suffixIconName,
          suffixIconClassName,
          showClearIcon,
          clearIconClassName
        }
      ),
      value: input,
      customInputRef: inputRef,
      inputClassName: classNames67(
        "text-2xs leading-4 transition-all px-3",
        inputClassName
      ),
      preventDefaultValue: true,
      hasError: input?.length > characterLimit,
      errorText: t("search.input.character.limit")
    }
  );
};
var TruncatedText = ({
  value,
  className: className2 = "",
  toolTipPlacement = "bottom",
  tooltipClassName,
  children,
  tootlipContainerClassName,
  onClick,
  lineClamp = 1,
  id,
  role,
  ...rest
}) => {
  const [spanRef, setSpanRef] = useState(null);
  const tooltipContent = spanRef?.scrollWidth && spanRef?.offsetWidth < spanRef?.scrollWidth || lineClamp > 1 && spanRef?.scrollHeight > spanRef?.clientHeight ? value : "";
  return /* @__PURE__ */ jsxs(
    "span",
    {
      className: classNames67(
        "w-full text-small text-unique-600 font-normal",
        {
          truncate: lineClamp === 1,
          [`line-clamp-${lineClamp}`]: lineClamp > 1
        },
        className2
      ),
      ref: setSpanRef,
      onClick: onClick || NOOP,
      id: id || void 0,
      role: role || void 0,
      ...rest,
      children: [
        /* @__PURE__ */ jsx(
          ToolTip,
          {
            placement: toolTipPlacement,
            tooltipClassName: classNames67(
              "max-w-xs whitespace-normal break-all",
              tooltipClassName
            ),
            className: tootlipContainerClassName,
            content: tooltipContent,
            children: value
          }
        ),
        children
      ]
    }
  );
};
var extractText = (node) => {
  if (typeof node === "string") {
    return node;
  } else if (React__default.isValidElement(node)) {
    return extractText(
      node?.props?.children
    );
  } else if (Array.isArray(node)) {
    return node.map(extractText).join("");
  } else {
    return "";
  }
};
var offsetModifier = [
  {
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }
];
var MultiSelect = ({
  children,
  className: className2,
  wrapperClassName,
  name,
  placement = "bottom-end",
  variant = "select-fill",
  fillWidth = true,
  label = "",
  labelClassName = "",
  disabled = false,
  dropdownIconClassName = "h-6",
  dropdownClassName = "",
  onSearch,
  errorText,
  searchPlaceholder,
  onFocusClassName = "",
  hideSearch = false,
  preventDefaultSearch = false,
  show = false,
  onCloseField,
  onFocus,
  hideOnItemClick = false,
  searchInputClassName = "",
  updatePositionOnLeftMove = false,
  isRequired = false,
  ...extra
}) => {
  const [btnRef, setBtnRef] = useState(null);
  const [showDropdown, toggleDropdown] = useState(show);
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const { styles: styles2, attributes, forceUpdate } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: "fixed",
    modifiers: offsetModifier
  });
  const { left } = btnRef?.getBoundingClientRect?.() || {};
  const handleChildClick = (handler, skipHideOnClick) => {
    if (hideOnItemClick && !skipHideOnClick) {
      onToggleDropdown(false);
    }
    handler?.();
  };
  const onToggleDropdown = (value) => {
    toggleDropdown(value);
    if (!value) {
      onCloseField && onCloseField();
    } else {
      onSearchOptions("");
      onFocus && onFocus();
    }
  };
  const padding = {
    "select-fill": "px-3 py-1.5",
    "select-fill-plain": "px-3 py-1.5",
    "no-bg": ""
  };
  const bgShowDropDown = {
    "select-fill": "border border-primary-300 bg-white",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50",
    "no-bg": "text-primary-500"
  };
  const bgDropDown = {
    "select-fill": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "no-bg": "text-primary-500"
  };
  const style = {
    ...styles2.popper || {},
    ...btnRef ? { width: btnRef.offsetWidth } : {}
  };
  const onSearchOptions = (searchKeyWord2) => {
    onSearch && onSearch(searchKeyWord2);
    setSearchKeyWord(searchKeyWord2);
  };
  const filteredChildren = React__default.Children.toArray(children).filter((child) => {
    if (!child) {
      return false;
    }
    if (React__default.isValidElement(child) && (child.type === multi_select_group_label_default || child.type === multi_select_item_default)) {
      return true;
    }
    const childText = extractText(child) || "";
    return preventDefaultSearch ? true : childText.toLowerCase().includes(searchKeyWord.toLowerCase());
  });
  const { t } = useTranslation();
  const MultiSelectNotFoundItem = ({ displayText }) => {
    return /* @__PURE__ */ jsx("div", { className: "text-unique-600 text-small leading-5 px-3 py-2", children: t(displayText) });
  };
  useEffect(() => {
    if (updatePositionOnLeftMove) {
      forceUpdate?.();
    }
  }, [left, name]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-block relative select-none",
        { "w-full": fillWidth },
        wrapperClassName
      ),
      children: [
        label && /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames67(
              "text-secondary-500 text-xs font-medium p-1",
              labelClassName
            ),
            children: [
              label,
              isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" })
            ]
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: setBtnRef,
            className: classNames67(
              "rounded text-xs leading-3.5 flex items-center cursor-pointer",
              { [bgShowDropDown[variant]]: showDropdown },
              { [bgDropDown[variant]]: !showDropdown },
              { "bg-white border-error-300": !showDropdown && !!errorText },
              padding[variant],
              className2,
              { [onFocusClassName]: showDropdown }
            ),
            onClick: () => onToggleDropdown(!showDropdown),
            ...extra,
            "data-isopen": showDropdown,
            children: [
              /* @__PURE__ */ jsx(TruncatedText, { value: name }),
              !disabled && /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "expand-more",
                  className: classNames67(
                    "ml-2 text-base flex items-center transform duration-300",
                    dropdownIconClassName,
                    {
                      "rotate-180": showDropdown
                    }
                  )
                }
              )
            ]
          }
        ),
        errorText && /* @__PURE__ */ jsx("div", { className: "pl-0.5 text-xs h-4 text-error-600", children: errorText }),
        showDropdown && /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: classNames67(
              "w-full min-w-52 z-[1000] py-1",
              dropdownClassName
            ),
            toggleDropdown: onToggleDropdown,
            setRef: setDropdownRef,
            style,
            attributes: attributes.popper,
            buttonRef: btnRef,
            children: /* @__PURE__ */ jsxs(Fragment, { children: [
              !hideSearch && /* @__PURE__ */ jsx("div", { className: "w-full flex border-b border-secondary-100", children: /* @__PURE__ */ jsx(
                DebouncedSearchInput,
                {
                  value: searchKeyWord,
                  onChange: onSearchOptions,
                  placeholder: searchPlaceholder,
                  wrapperClassName: "w-full",
                  className: classNames67(
                    "bg-transparent !border-white",
                    searchInputClassName
                  ),
                  suffixIconName: "search",
                  suffixIconClassName: "text-secondary-600"
                }
              ) }),
              /* @__PURE__ */ jsx("div", { className: "max-h-52 overflow-y-auto w-full", children: filteredChildren.length === 0 && searchKeyWord ? /* @__PURE__ */ jsx(
                MultiSelectNotFoundItem,
                {
                  displayText: "multiselect.no-result.found"
                }
              ) : filteredChildren.map((child) => {
                if (React__default.isValidElement(child) && "onClick" in child.props) {
                  const { onClick, skipHideOnClick, ...restProps } = child.props;
                  return React__default.cloneElement(child, {
                    ...restProps,
                    onClick: () => handleChildClick(onClick, skipHideOnClick)
                  });
                } else {
                  return child;
                }
              }) })
            ] })
          }
        )
      ]
    }
  );
};
var multi_select_default = MultiSelect;
var offsetModifier2 = [
  {
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }
];
var CustomMultiSelect = ({
  children,
  className: className2,
  openedClassName,
  closedClassName,
  wrapperClassName,
  name,
  placement = "bottom-end",
  fillWidth = false,
  disabled = false,
  dropdownIconClassName = "h-6",
  dropdownClassName = "",
  onSearch,
  errorText,
  searchPlaceholder,
  hideSearch = false,
  show = false,
  onCloseField,
  onFocus,
  closeOnClickOutside = true,
  ...extra
}) => {
  const [btnRef, setBtnRef] = useState(null);
  const [showDropdown, toggleDropdown] = useState(show);
  const [dropdownRef, setDropdownRef] = useState(null);
  const [searchKeyWord, setSearchKeyWord] = useState("");
  const { styles: styles2, attributes } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: "fixed",
    modifiers: offsetModifier2
  });
  const onToggleDropdown = (value) => {
    toggleDropdown(value);
    if (!value) {
      onSearchOptions("");
      onCloseField && onCloseField();
    } else {
      onFocus && onFocus();
    }
  };
  const style = {
    ...styles2.popper || {},
    ...btnRef ? { width: btnRef.offsetWidth } : {}
  };
  const onSearchOptions = (searchKeyWord2) => {
    onSearch && onSearch(searchKeyWord2);
    setSearchKeyWord(searchKeyWord2);
  };
  useEffect(() => {
    toggleDropdown(show);
  }, [show]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-block relative select-none",
        { "w-full": fillWidth },
        wrapperClassName
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: setBtnRef,
            className: classNames67(
              "flex items-center",
              className2,
              { [openedClassName]: showDropdown },
              { [closedClassName]: !showDropdown }
            ),
            onClick: () => onToggleDropdown(!disabled),
            ...extra,
            "data-isopen": showDropdown,
            children: [
              /* @__PURE__ */ jsx("span", { className: "truncate w-full", children: name }),
              !disabled && /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "expand-more",
                  className: classNames67(
                    "ml-2 text-base flex items-center transform duration-300",
                    dropdownIconClassName,
                    {
                      "rotate-180": showDropdown
                    }
                  )
                }
              )
            ]
          }
        ),
        errorText && /* @__PURE__ */ jsx("div", { className: "pl-0.5 text-xs h-4 text-error-600", children: errorText }),
        showDropdown && /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: classNames67("w-full min-w-52 z-[1000]", dropdownClassName),
            toggleDropdown: onToggleDropdown,
            setRef: setDropdownRef,
            style,
            attributes: attributes.popper,
            closeOnClickOutside,
            children: /* @__PURE__ */ jsxs(Fragment, { children: [
              !hideSearch && /* @__PURE__ */ jsx("div", { className: "w-full flex border-b border-secondary-100", children: /* @__PURE__ */ jsx(
                DebouncedSearchInput,
                {
                  value: searchKeyWord,
                  onChange: onSearchOptions,
                  placeholder: searchPlaceholder,
                  type: "text",
                  hideErrorMessage: true,
                  wrapperClassName: "w-full",
                  className: " bg-transparent !border-white",
                  suffixIconName: "search",
                  suffixIconClassName: "text-base text-secondary-600 flex items-center"
                }
              ) }),
              /* @__PURE__ */ jsx("div", { className: "max-h-[260px] overflow-y-auto", children })
            ] })
          }
        )
      ]
    }
  );
};
var custom_multi_select_default = CustomMultiSelect;
var IconGroup = ({
  children,
  direction = "horizontal",
  className: className2 = "",
  ...extra
}) => {
  const isHorizontal = direction == "horizontal";
  const isVertical = direction == "vertical";
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "bg-white rounded relative flex text-xl gap-2 p-0.5 min-w-[34px]",
        { "flex-row": isHorizontal },
        { "flex-col": isVertical },
        className2
      ),
      ...extra,
      children
    }
  );
};
var IconGroupItem = ({
  isSelected,
  children,
  className: className2 = "",
  ...extra
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames67(
      "inline-flex min-h-[30px] min-w-[30px] items-center justify-center cursor-pointer hover:bg-secondary-50 text-black rounded",
      { "!bg-primary-50 text-primary-600": isSelected },
      className2
    ),
    ...extra,
    children
  }
);
function Spinner({
  secondaryColor,
  speed,
  still = false,
  thickness,
  ...svgProps
}) {
  const strokeWidth = 4 * (thickness / 100);
  const circleStyle = !still ? { animation: `spinners-react-circular ${140 / speed}s linear infinite` } : {};
  return /* @__PURE__ */ jsxs("svg", { fill: "none", ...svgProps, viewBox: "0 0 66 66", children: [
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: "33",
        cy: "33",
        fill: "none",
        r: "28",
        stroke: secondaryColor,
        strokeWidth
      }
    ),
    /* @__PURE__ */ jsx(
      "circle",
      {
        cx: "33",
        cy: "33",
        fill: "none",
        r: "28",
        stroke: "currentColor",
        strokeDasharray: "1, 174",
        strokeDashoffset: "306",
        strokeLinecap: "round",
        strokeWidth,
        style: circleStyle
      }
    )
  ] });
}
var toastify = (content, {
  type = "default",
  position = "top-center",
  hideProgressBar = true,
  autoClose = 5e3
}) => {
  return toast(content, {
    type,
    closeButton: /* @__PURE__ */ jsx(Icon3, { name: "close", className: "text-unique-800 text-base" }),
    position,
    hideProgressBar,
    autoClose
  });
};
var Label = ({ children, className: className2 }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "inline-flex rounded bg-secondary-100 text-[10px] h-[18px] min-w-[18px] justify-center items-center p-0.5",
        className2
      ),
      children
    }
  );
};
var SpotEdit = ({
  text: text2,
  decoratedText,
  decoratedTextClassName,
  placeholder,
  defaultEditState = false,
  className: className2,
  inputClassName,
  textClassName,
  placeholderClassName,
  changeHandler,
  tabHandler,
  inputComponent,
  editable = true,
  clickoutEnabled = true,
  onFocus = () => {
  },
  onBlur = () => {
  },
  focustrap = false,
  preventDefaultValue = false,
  tooltipText
}) => {
  const [isEditMode, changeViewMode] = useState(false);
  const inputRef = useRef(null);
  const [inputValue, updateInputValue] = useState(text2);
  const [isFocused, updateFocused] = useState(false);
  const focusInput = useCallback(
    () => inputRef.current?.focus(),
    [inputRef, inputValue]
  );
  const notifyChange = useCallback(() => {
    const value = !!inputComponent ? inputRef.current?.textContent : inputRef.current?.value;
    changeHandler?.(value || "");
    changeViewMode(false);
    onBlur();
  }, [inputRef, changeHandler, inputComponent]);
  const handleEdit = useCallback(() => {
    if (!editable) return;
    changeViewMode(true);
    updateInputValue(text2);
    setTimeout(focusInput);
  }, [isEditMode, inputRef, editable]);
  useEffect(() => {
    changeViewMode(defaultEditState);
    setTimeout(focusInput);
  }, [defaultEditState]);
  use_click_outside_default(inputRef, notifyChange, clickoutEnabled);
  use_key_press_default("Enter", () => notifyChange(), inputRef);
  use_key_press_default("Escape", () => changeViewMode(false), inputRef);
  use_key_press_default("Tab", () => tabHandler(), inputRef);
  const handleFocusEvent = useCallback(() => {
    updateFocused(true);
    onFocus();
  }, [onFocus]);
  const handleBlurEvent = () => {
    updateFocused(false);
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67("inline-block overflow-hidden", className2),
      "data-focus-trap": focustrap && isEditMode && isFocused,
      children: [
        !isEditMode && !text2?.length && /* @__PURE__ */ jsx(
          "span",
          {
            onClick: handleEdit,
            className: classNames67(
              "text-secondary-400 cursor-text block",
              placeholderClassName
            ),
            children: placeholder
          }
        ),
        !isEditMode && !!text2?.length && (decoratedText ? /* @__PURE__ */ jsx(
          "span",
          {
            onClick: handleEdit,
            className: classNames67(
              "text-secondary-400 cursor-text block",
              decoratedTextClassName
            ),
            children: decoratedText
          }
        ) : /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames67(
              "cursor-text block whitespace-nowrap text-ellipsis",
              textClassName
            ),
            onClick: handleEdit,
            children: /* @__PURE__ */ jsx(ToolTip, { content: /* @__PURE__ */ jsxs("div", { children: [
              "Value: ",
              tooltipText
            ] }), children: text2 })
          }
        )),
        isEditMode && !inputComponent && /* @__PURE__ */ jsx(
          "input",
          {
            ref: (el) => inputRef.current = el,
            value: preventDefaultValue ? text2 : inputValue,
            onChange: (e) => {
              preventDefaultValue ? changeHandler(e.target.value) : updateInputValue(e.target.value);
            },
            className: classNames67("outline-none w-full", inputClassName)
          }
        ),
        isEditMode && inputComponent != null && /* @__PURE__ */ jsx(
          "div",
          {
            ref: (el) => inputRef.current = el,
            contentEditable: true,
            onInput: (e) => updateInputValue(e.target?.textContent),
            className: classNames67("outline-none w-full", inputClassName),
            onFocus: handleFocusEvent,
            onBlur: handleBlurEvent,
            children: inputComponent
          }
        )
      ]
    }
  );
};
var UcTabHeader = ({
  children,
  className: className2,
  selected,
  onClick,
  dontHighlightOnSelect
}) => {
  return /* @__PURE__ */ jsx(
    "li",
    {
      className: classNames67(
        {
          "text-primary-700 border-primary-700": selected && !dontHighlightOnSelect
        },
        { "border-transparent": dontHighlightOnSelect || !selected },
        "border-b text-small leading-5 font-semibold text-secondary-800 py-3.5 cursor-pointer",
        className2
      ),
      onClick,
      children
    }
  );
};
var UcTabContent = ({
  children,
  className: className2,
  selected
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67("w-full h-full", { hidden: !selected }, className2),
      children
    }
  );
};
var UcTab = ({ children, className: className2 }) => {
  return /* @__PURE__ */ jsx("li", { className: classNames67(className2), children });
};
UcTab.name;
UcTabHeader.name;
UcTabContent.name;
var uc_tab_default = UcTab;
var UcTabList = ({ children, className: className2 }) => {
  return /* @__PURE__ */ jsx(
    "ul",
    {
      className: classNames67(
        "flex flex-col md:flex-row flex-wrap list-none",
        className2
      ),
      children
    }
  );
};
var uc_tablist_default = UcTabList;
var useTabs = ({ selectedTabIndex = 0, tabs, onSelect }) => {
  const [selectedIndex, setSelectedIndex] = useState(selectedTabIndex);
  useEffect(() => {
    setSelectedIndex(selectedTabIndex || 0);
  }, [selectedTabIndex]);
  const onSelectTab = (index) => {
    setSelectedIndex(index);
    onSelect && onSelect(index);
  };
  return {
    selectedIndex,
    onSelectTab,
    tabs
  };
};
var useTabs_default = useTabs;
var UcTabs = (props) => {
  const { selectedIndex, onSelectTab, tabs } = useTabs_default(props);
  const { hiddenTabIndex = [], suffixElement } = props;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full w-full", children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          { "justify-between flex": suffixElement },
          props.className
        ),
        children: [
          /* @__PURE__ */ jsx(uc_tablist_default, { className: props.className, children: tabs.map((tab, ind) => {
            return !tab?.hidden && hiddenTabIndex.indexOf(ind) == -1 && /* @__PURE__ */ jsx(
              UcTabHeader,
              {
                dontHighlightOnSelect: tab?.dontHighlightOnSelect,
                className: props.headingClassName,
                selected: ind === selectedIndex,
                onClick: () => onSelectTab(ind),
                children: tab.heading
              },
              ind
            );
          }) }),
          suffixElement && suffixElement
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "w-full h-full overflow-hidden", children: tabs.map((tab, ind) => {
      return !tab?.hidden && hiddenTabIndex.indexOf(ind) == -1 && /* @__PURE__ */ jsx(
        UcTabContent,
        {
          className: props.contentClassName,
          selected: ind === selectedIndex,
          children: typeof tab.content === "function" ? tab.content() : tab.content
        },
        ind
      );
    }) })
  ] }) });
};
var uc_tabs_default = UcTabs;

// src/note/note.constant.ts
var ICON_NAME_MAP = {
  danger: "info",
  info: "info",
  warning: "info",
  success: "check-circle"
};
var getBgColorClassByType = (type) => {
  let bgClass;
  switch (type) {
    case "warning":
      bgClass = "bg-warning-50 border border-warning-300";
      break;
    case "info":
      bgClass = "bg-secondary-100";
      break;
    case "success":
      bgClass = "bg-primary-100";
      break;
    case "danger":
      bgClass = "bg-error-100";
      break;
  }
  return bgClass;
};
var getIconColorClassByType = (type) => {
  let iconClass;
  switch (type) {
    case "warning":
      iconClass = "text-warning-700";
      break;
    case "info":
      iconClass = "text-secondary-600";
      break;
    case "success":
      iconClass = "text-secondary-600";
      break;
    case "danger":
      iconClass = "text-secondary-600";
      break;
  }
  return iconClass;
};
var getTextColorClassByType = (type) => {
  let iconClass;
  switch (type) {
    case "warning":
      iconClass = "text-unique-600";
      break;
    case "info":
      iconClass = "text-secondary-800";
      break;
    case "success":
      iconClass = "text-secondary-800";
      break;
    case "danger":
      iconClass = "text-secondary-800";
      break;
  }
  return iconClass;
};
var Note = ({
  type,
  heading,
  content,
  hideIcon,
  className: className2,
  iconClassName
}) => /* @__PURE__ */ jsxs(
  "div",
  {
    className: classNames67(
      "flex p-3 text-xs leading-4.5 rounded space-x-2",
      getBgColorClassByType(type),
      getTextColorClassByType(type),
      className2
    ),
    role: "note",
    children: [
      !hideIcon && /* @__PURE__ */ jsx("div", { className: "shrink-0 inline-flex items-center", children: /* @__PURE__ */ jsx(
        Icon3,
        {
          className: classNames67(
            "text-xl flex",
            getIconColorClassByType(type),
            iconClassName
          ),
          name: ICON_NAME_MAP[type]
        }
      ) }),
      /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
        heading && /* @__PURE__ */ jsx("span", { children: heading }),
        content && /* @__PURE__ */ jsx("span", { children: content })
      ] })
    ]
  }
);
var TabTypeContext = createContext("primary");
var Tab = ({
  children,
  direction = "horizontal",
  type = "primary",
  className: className2 = "",
  ...extra
}) => {
  const isHorizontal = direction === "horizontal";
  const isVertical = direction === "vertical";
  const isPrimary = type === "primary";
  const isSecondary = type === "secondary";
  return /* @__PURE__ */ jsx(TabTypeContext.Provider, { value: type, children: /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        {
          "gap-2 border-b-[0.5px] border-b-secondary-200 flex h-11": isPrimary
        },
        { "flex gap-2": isSecondary },
        { "flex-row": isHorizontal },
        { "flex-col": isVertical },
        className2
      ),
      ...extra,
      children
    }
  ) });
};
var TabItemPrimary = ({
  isSelected,
  count = 0,
  children,
  className: className2 = "",
  onClick,
  countClassName,
  customLabel,
  ...extra
}) => /* @__PURE__ */ jsxs(
  "div",
  {
    onClick,
    className: classNames67(
      "inline-flex flex-row items-center justify-center text-small leading-5 text-center text-primary-900 cursor-pointer min-w-[60px] border-b border-b-transparent px-2",
      { "!text-primary-1000 border-b-2 !border-b-primary-1000": isSelected },
      { "!text-secondary-500": !isSelected },
      className2
    ),
    ...extra,
    children: [
      children,
      customLabel || !!count && /* @__PURE__ */ jsx(Label, { className: classNames67("ml-2", countClassName), children: count })
    ]
  }
);
var TabItemSecondary = ({
  isSelected,
  count = void 0,
  variant = "primary",
  children,
  className: className2 = "",
  countClassName,
  onClick,
  ...extra
}) => {
  const bgSeledcted = {
    primary: "bg-primary-100",
    secondary: "bg-secondary-100"
  };
  const colorSeledcted = {
    primary: "text-secondary-600",
    secondary: "text-secondary-600"
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      onClick,
      className: classNames67(
        "inline-flex items-center justify-center",
        "text-small leading-5 text-center cursor-pointer px-3 rounded min-w-[60px] h-6 flex-row",
        {
          "text-small leading-5 cursor-pointer": isSelected,
          [bgSeledcted[variant]]: isSelected,
          [colorSeledcted[variant]]: isSelected
        },
        className2
      ),
      ...extra,
      children: [
        children,
        !!count && /* @__PURE__ */ jsxs("span", { className: classNames67("pl-1", countClassName), children: [
          "(",
          count,
          ")"
        ] })
      ]
    }
  );
};
var TabItem = ({
  isSelected,
  count = 0,
  variant = "primary",
  onClick,
  children,
  className: className2 = "",
  countClassName,
  customLabel,
  ...extra
}) => {
  const type = useContext(TabTypeContext);
  const isPrimary = type === "primary";
  const isSecondary = type === "secondary";
  if (isPrimary) {
    return /* @__PURE__ */ jsx(
      TabItemPrimary,
      {
        isSelected,
        count,
        className: className2,
        onClick,
        countClassName,
        customLabel,
        ...extra,
        children
      }
    );
  } else if (isSecondary) {
    return /* @__PURE__ */ jsx(
      TabItemSecondary,
      {
        variant,
        isSelected,
        count,
        className: className2,
        onClick,
        countClassName,
        ...extra,
        children
      }
    );
  }
};
var Button = ({
  type = "primary",
  className: className2,
  children,
  isDisabled = false,
  size = "md",
  onClick = NOOP,
  isLoading = false,
  ...extra
}) => {
  const isMedium = size == "md";
  const isSmall = size == "sm";
  const isLarge = size == "lg";
  const isDisableNeeded = useMemo(() => {
    return isDisabled || isLoading;
  }, [isDisabled, isLoading]);
  const bg = {
    danger: "bg-error-500 hover:bg-error-600",
    "danger-light": "bg-error-50 hover:bg-error-100",
    primary: "bg-primary-1000 hover:shadow hover:shadow-secondary-200",
    "primary-outline": "border border-neutral-300 hover:border-primary-400",
    "primary-transparent": "bg-transparent hover:bg-primary-100",
    "primary-light": "bg-primary-50 hover:bg-primary-100",
    secondary: "bg-secondary-100 hover:bg-secondary-unique-100",
    "secondary-light": "bg-secondary-50 hover:bg-secondary-100",
    tertiary: "bg-primary-100",
    light: "bg-white border-secondary-200 border",
    "primary-default": "bg-primary-1000 hover:shadow hover:shadow-secondary-200"
  };
  const textClr = {
    danger: "text-white",
    "danger-light": "text-error-600",
    primary: "text-white",
    "primary-outline": "text-primary-600",
    "primary-transparent": "text-secondary-600",
    "primary-light": "text-error-600",
    secondary: "text-secondary-700",
    "secondary-light": "text-unique-600",
    tertiary: "text-primary-600 hover:text-primary-700",
    light: "text-secondary-700",
    "primary-default": "text-white"
  };
  const styles2 = classNames67(
    "text-small leading-5 rounded inline-flex items-center",
    { "active:scale-[0.99] active:translate-y-[1px]": !isDisableNeeded },
    bg[type],
    textClr[type] || "text-white",
    { "px-8 h-10": isLarge },
    { "px-4 h-8": isMedium },
    { "h-6 px-2": isSmall },
    {
      "cursor-pointer": !isDisableNeeded,
      "cursor-not-allowed": isDisableNeeded
    },
    { "opacity-30": isDisableNeeded },
    className2
  );
  return /* @__PURE__ */ jsxs(
    "button",
    {
      className: styles2,
      onClick: isDisableNeeded ? NOOP : onClick,
      ...extra,
      disabled: isDisableNeeded,
      children: [
        isLoading && /* @__PURE__ */ jsx(
          Icon3,
          {
            className: "text-base animate-spin mr-2",
            name: "loader"
          }
        ),
        children
      ]
    }
  );
};
var PrimaryButton = (props) => {
  return /* @__PURE__ */ jsx(Button, { ...props, type: "primary" });
};
var PrimaryOutlineButton = (props) => {
  return /* @__PURE__ */ jsx(Button, { ...props, type: "primary-outline" });
};
var SecondaryButton = (props) => {
  return /* @__PURE__ */ jsx(Button, { ...props, type: "secondary" });
};
var DangerButton = (props) => {
  return /* @__PURE__ */ jsx(Button, { ...props, type: "danger" });
};
var TabelContext = createContext("body");
var Table = ({
  className: className2 = "",
  wrapperClassName = "",
  children
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames67(
      "overflow-auto border border-neutral-100 rounded",
      wrapperClassName
    ),
    children: /* @__PURE__ */ jsx(
      "table",
      {
        className: classNames67(
          "atom-table",
          "border-collapse border border-neutral-100 rounded",
          className2
        ),
        children
      }
    )
  }
);
var TableBody = ({
  className: className2,
  children
}) => {
  return /* @__PURE__ */ jsx(TabelContext.Provider, { value: "body", children: /* @__PURE__ */ jsx("tbody", { className: classNames67(className2), children }) });
};
var TableHeader = ({
  className: className2,
  children
}) => {
  return /* @__PURE__ */ jsx(TabelContext.Provider, { value: "header", children: /* @__PURE__ */ jsx("thead", { className: classNames67(className2), children }) });
};
var TableRow = ({
  className: className2,
  children,
  onMouseEnter,
  onMouseLeave,
  onClick,
  isHeader,
  ...extra
}) => (
  // const isHeader = useContext(TabelContext) == "header";
  /* @__PURE__ */ jsx(
    "tr",
    {
      onMouseEnter,
      onMouseLeave,
      onClick,
      className: classNames67(className2, { "hover:bg-secondary-50": !isHeader }),
      ...extra,
      children
    }
  )
);
var TableCell = ({
  className: className2,
  children,
  colspan = 1,
  onClick = null,
  isHeader
}) => {
  className2 = classNames67(
    "px-2 h-8 border border-neutral-100 text-xs text-neutral-800",
    className2
  );
  if (isHeader)
    return /* @__PURE__ */ jsx(
      "th",
      {
        className: classNames67("text-left font-semibold", className2),
        onClick,
        colSpan: colspan,
        children
      }
    );
  return /* @__PURE__ */ jsx("td", { className: className2, colSpan: colspan, onClick, children });
};
var StatusLabel = ({
  type,
  className: className2,
  children
}) => {
  const borderColors = {
    error: "border-error-100",
    success: "border-primary-100"
  };
  const textColors = {
    error: "text-error-700",
    success: "text-primary-700"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "rounded-full px-2 h-5 inline-flex items-center text-xs border",
        borderColors[type],
        textColors[type],
        className2
      ),
      children
    }
  );
};

// src/dynamic-type-input/constants.ts
var dynamicValues = [
  {
    i18n: "datatype.name.plain-text",
    type: "plain",
    id: "null",
    symbol: "",
    valuePattern: /[^\s]+/,
    template: "{value}",
    templateOffset: 1,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.plain-text",
    type: "dynamic",
    id: "raw",
    symbol: "",
    valuePattern: /[^\s]+/,
    template: "{value}",
    templateOffset: 1,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.parameter",
    type: "dynamic",
    id: "parameter",
    symbol: "@",
    valuePattern: /\@\|[^\|]+\|/,
    template: "@|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_PARAMETER" /* PARAMETER */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.runtime",
    type: "dynamic",
    id: "runtime",
    symbol: "$",
    valuePattern: /\$\|[^\|]+\|/,
    template: "$|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_RUNTIME_VARIABLE" /* RUNTIME_VARIABLE */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.environment",
    type: "dynamic",
    id: "global",
    symbol: "*",
    valuePattern: /\*\|[^\|]+\|/,
    template: "*|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_ENVIRONMENT" /* ENVIRONMENT */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.random",
    type: "dynamic",
    id: "random",
    symbol: "~",
    valuePattern: /\~\|[^\|]+\|/,
    template: "~|{value}|",
    templateOffset: 1,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.data-generator",
    type: "dynamic",
    id: "function",
    symbol: "!",
    valuePattern: /\!\|[^\|]+\|/,
    template: "!|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_DATA_GENERATOR" /* DATA_GENERATOR */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.phone-number",
    type: "dynamic",
    id: "phone_number",
    symbol: "%",
    valuePattern: /\%\|[^\|]+\|/,
    template: "%|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_PHONE_NUMBER" /* PHONE_NUMBER */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.mail-box",
    type: "dynamic",
    id: "mail_box",
    symbol: "&",
    valuePattern: /\&\|[^\|]+\|/,
    template: "&|{value}|",
    templateOffset: 1,
    modalOpen: "OPEN_MAILBOX" /* MAILBOX */,
    showInSuggestion: true
  },
  {
    i18n: "datatype.name.mail-box",
    type: "dynamic",
    id: "attribute",
    symbol: "",
    template: "{value}",
    templateOffset: 1,
    showInSuggestion: false
  },
  {
    i18n: "datatype.name.mail-box",
    type: "dynamic",
    id: "ui_identifier",
    symbol: "",
    template: "{value}",
    templateOffset: 1,
    showInSuggestion: false
  },
  {
    i18n: "datatype.name.mail-box",
    type: "dynamic",
    id: "selectable",
    symbol: "",
    template: "{value}",
    templateOffset: 1,
    showInSuggestion: false
  }
];
var initTranslations = (path) => {
  return new Promise((resolve, reject) => {
    i18n.use(Backend).use(initReactI18next).init({
      debug: false,
      fallbackLng: "en-US",
      preload: ["en-US"],
      interpolation: {
        escapeValue: false
        // not needed for react as it escapes by default
        // format: (value, format, lng) => { // legacy usage
        //   if (value instanceof Date) {
        //     return DateTime.fromJSDate(value).setLocale(lng).toLocaleString(DateTime[format])
        //   }
        //   return value;
        // }
      },
      backend: {
        loadPath: path,
        addPath: "/{{ns}}/locales/add/{{lng}}"
      }
    }).then(() => {
      resolve();
    }).catch((error) => {
      reject(error);
    });
  });
};
var __ = i18n.t.bind(i18n);

// src/dynamic-type-input/utils.ts
var convertValueToBlock = (value) => {
  if (typeof value != "string") return value;
  const chunks = [];
  let chunk = "";
  let locked = false;
  let special_char_locked = false;
  const special_chars = [
    "!" /* DATA_GENERATOR */,
    "&" /* EMAIL */,
    "%" /* PHONE_NUMBER */,
    "*" /* ENVIRONMENT */,
    "$" /* RUNTIME_VARIABLE */,
    "@" /* PARAMETER */,
    "~" /* RANDOM */
  ];
  for (const char of String(value)) {
    if (special_chars.includes(char)) {
      special_char_locked = true;
      chunk += char;
    } else if (special_char_locked && char == "|") {
      const special_char = chunk.slice(-1);
      chunks.push(chunk.slice(0, chunk.length - 1));
      chunk = special_char + char;
      special_char_locked = false;
      locked = true;
    } else {
      chunk += char;
      if (locked && char == "|") {
        locked = false;
        chunks.push(chunk);
        chunk = "";
      }
    }
  }
  if (chunk) chunks.push(chunk);
  return chunks.filter((i) => i.length).map(textToBlock).filter((item) => !!item);
};
var textToBlock = (text2) => {
  const checks = [...dynamicValues].filter((item) => item.id != "raw").reverse();
  for (const check of checks) {
    if (check.valuePattern && text2.match(check.valuePattern)) {
      return { value: text2, type: check.id };
    }
  }
};
var blocksToText = (blocks) => blocks.reduce((prev, block) => prev + block.value.trim(), "");
var setCaret = (el, position) => {
  const range = document.createRange();
  const sel = window.getSelection();
  if (!el.innerHTML) el.innerHTML = "&hairsp;";
  range.setStart(el.nodeType == el.TEXT_NODE ? el.parentElement : el, position);
  range.collapse(true);
  sel.removeAllRanges();
  sel.addRange(range);
};
var getSelectionOffset = (containerEl) => {
  const range = containerEl.getRootNode().getSelection().getRangeAt(0);
  const preSelectionRange = range.cloneRange();
  preSelectionRange.selectNodeContents(containerEl);
  preSelectionRange.setEnd(range.startContainer, range.startOffset);
  const start = preSelectionRange.toString().length;
  return {
    start,
    end: start + range.toString().length
  };
};
var unwrapTemplate = (value) => {
  if (typeof value == "number") value = String(value);
  return value?.trim().replace?.(/^.\|(.*)\|$/, "$1").trim() || value;
};
var wrapWithTemplate = (value, type) => {
  return type ? value && dynamicValues.find((item) => item.id == type).template.replace("{value}", unwrapTemplate(value).trim()) : value;
};

// src/dynamic-type-input/hooks.ts
var useFormatedPaste = (element) => {
  const handlePaste = useCallback((e) => {
    e.preventDefault();
    const text2 = e.clipboardData.getData("text/plain");
    document.execCommand("insertText", false, text2);
  }, []);
  useEffect(() => {
    element.current?.addEventListener("paste", handlePaste);
    return () => element.current?.removeEventListener("paste", handlePaste);
  }, [element]);
};
var useKeyMovement = (element, refs, blocks, createNextnode, deleteNode2, hasCreateBlock) => {
  const handler = useCallback(
    (e) => {
      blocks.length;
      const isForward = e.key == "ArrowRight";
      const isBackspace = e.key == "Backspace";
      const currentBlock = e.target.getAttribute("data-uuid");
      const nextBlock = blocks.find(
        (block, idx) => idx > 0 && blocks[idx - 1]?.uuid == currentBlock
      )?.uuid;
      const previousBlock = blocks.find(
        (block, idx) => blocks[idx + 1]?.uuid == currentBlock
      )?.uuid;
      const cursorPosition = e.target.getRootNode().getSelection().focusOffset;
      if (e.target.textContent.length == cursorPosition && isForward) {
        if (nextBlock) {
          setCaret(refs.current[nextBlock], 0);
          refs.current[nextBlock].focus();
        } else if (refs.current[currentBlock].textContent.trim().length && hasCreateBlock) {
          createNextnode();
        }
      } else if (cursorPosition == 0 && previousBlock && !isForward) {
        if (isBackspace) {
          deleteNode2(currentBlock);
        }
        setCaret(refs.current[previousBlock], 1);
        refs.current[previousBlock].focus();
      }
    },
    [refs, createNextnode, hasCreateBlock]
  );
  useEffect(() => {
    element.current?.addEventListener("keydown", handler);
    return () => element.current?.removeEventListener("keydown", handler);
  }, [element, handler]);
};
var useEmptySpace = (element, isSingleBlock) => {
  const handler = useCallback((e) => {
    if (!e.target.textContent.length && !isSingleBlock) {
      e.target.innerHTML = "&hairsp;";
    }
  }, []);
  useEffect(() => {
    element.current?.addEventListener("focus", handler);
    return () => element.current?.removeEventListener("focus", handler);
  }, [element, handler]);
};
var useDomToBlock = (refs, updateContentBlock, blocks, updateBlock, includeTemplate) => {
  const templateMap = dynamicValues.reduce((previousValue, currentValue) => {
    previousValue[currentValue.id] = currentValue;
    return previousValue;
  }, {});
  return useCallback(() => {
    const domNodes = Object.values(refs.current || {}).sort(
      (a, b) => a?.initialsedTime - b?.initialsedTime
    );
    const getType = (block) => block.getAttribute("data-id");
    const _blocks = domNodes.map((block) => ({
      value: includeTemplate ? templateMap[block.getAttribute("data-id")].template.replace(
        "{value}",
        block.textContent.trim()
      ) : block.textContent.trim(),
      type: getType(block) == "null" ? null : getType(block),
      uuid: block.getAttribute("data-uuid")?.trim(),
      more_details: JSON.parse(block.getAttribute("data-more-details"))
    }));
    const filterdBlocks = blocks?.map(
      (obj) => _blocks.find((item) => item.uuid === obj.uuid)
    );
    updateContentBlock(filterdBlocks || _blocks);
  }, [updateContentBlock, refs, blocks, updateBlock]);
};
var usePreventEnter = (element) => {
  const handler = useCallback((e) => {
    if (e.key == "Enter") e.preventDefault();
  }, []);
  useEffect(() => {
    element.current?.addEventListener("keydown", handler);
    return () => element.current?.removeEventListener("keydown", handler);
  }, [element, handler]);
};
var useBlockChange = (element, blocks, handler) => {
  const customHandler = useCallback(() => {
    window.setTimeout(handler, 50);
  }, [handler]);
  useEffect(() => {
    element.current?.addEventListener("keydown", customHandler);
    element.current?.addEventListener("paste", customHandler);
    return () => {
      element.current?.removeEventListener("keydown", customHandler);
      element.current?.removeEventListener("paste", customHandler);
    };
  }, [element, customHandler]);
  useEffect(() => handler(), [blocks]);
};
var useTemplateClick = (blocks, updateBlock, updateSuggestion, refs, getTestData, dynamicValues2) => {
  const handleValueInjection = useCallback(
    (item, idx, text2 = "", more_details = null) => {
      const _blocks = [...blocks];
      _blocks[idx].text = text2;
      _blocks[idx].type = item.type;
      _blocks[idx].id = item.id;
      _blocks[idx].uuid = generateUniqueId();
      _blocks[idx].more_details = more_details;
      updateBlock(_blocks);
      updateSuggestion(null);
    },
    [updateBlock, updateSuggestion, blocks]
  );
  return useCallback(
    async (item, idx, uuid) => {
      if (!uuid || idx == null) return;
      const template = dynamicValues2.find((value) => value.id == item.id);
      updateSuggestion(null);
      if (template.modalOpen) {
        await getTestData({ modal: template.modalOpen, uuid }).then(
          (response) => {
            if (response?.selected?.text)
              handleValueInjection(
                item,
                idx,
                response?.selected?.text,
                response?.selected?.more_details
              );
          }
        );
      } else {
        handleValueInjection(item, idx, "");
      }
      window.setTimeout(() => {
        setCaret(
          refs.current[uuid]?.childNodes?.[0] || refs.current[uuid],
          item.templateOffset
        );
      }, 50);
    },
    [handleValueInjection, refs, updateSuggestion]
  );
};
var useSuggestion = (value, suggestion, updateSuggestion, item, dynamicValues2, ref, itemKey, isFocused, handleTemplateClick, editable) => {
  const timer = useRef(null);
  const valueEmptySuggestionToggled = useRef(false);
  const customHandler = useCallback(
    (e) => {
      if (e.key == "ArrowDown" || e.key == "ArrowUp") {
        e.preventDefault();
        suggestion.position = e.key == "ArrowUp" ? Math.max(0, suggestion?.position - 1) : Math.min(
          suggestion?.position + 1,
          dynamicValues2.filter(
            (item2) => item2.type == "dynamic" && item2.showInSuggestion
          ).length - 1
        );
        updateSuggestion(Object.assign({}, suggestion));
      } else if (e.key == "Enter") {
        handleTemplateClick(
          dynamicValues2[suggestion.position],
          suggestion.itemKey,
          suggestion.uuid
        );
        updateSuggestion(null);
      } else if (e.key == "Backspace" && value.trim().length == 1) {
        updateSuggestion({
          ref: ref.current,
          itemKey,
          uuid: item.uuid,
          position: 0,
          itemID: item.id
        });
        valueEmptySuggestionToggled.current = true;
      } else if (valueEmptySuggestionToggled.current && e.currentTarget?.innerText?.trim().length > 0) {
        updateSuggestion(null);
        valueEmptySuggestionToggled.current = false;
      }
    },
    [suggestion, updateSuggestion, value, valueEmptySuggestionToggled]
  );
  const clickHandler = useCallback(() => {
    if (suggestion?.ref == ref.current || item.type != "dynamic" || !editable)
      return;
    window.getSelection().selectAllChildren(ref.current);
    updateSuggestion({
      ref: ref.current,
      itemKey,
      uuid: item.uuid,
      position: 0,
      itemID: item.id
    });
  }, [ref, suggestion, item, editable]);
  const focusoutHandler = useCallback(() => {
    timer.current = window.setTimeout(() => {
      updateSuggestion(null);
    }, 250);
  }, [timer, updateSuggestion]);
  const focusinHandler = useCallback(() => {
    if (value.trim() && !window.getSelection().toString()) {
      updateSuggestion(null);
    } else if (!value.trim()) {
      updateSuggestion({
        ref: ref.current,
        itemKey,
        uuid: item.uuid,
        position: 0,
        itemID: item.id
      });
      valueEmptySuggestionToggled.current = true;
    }
  }, [timer, updateSuggestion, value]);
  useEffect(() => {
    ref.current?.addEventListener("keydown", customHandler);
    ref.current?.addEventListener("click", clickHandler);
    ref.current?.addEventListener("focusout", focusoutHandler);
    ref.current?.addEventListener("focusin", focusinHandler);
    return () => {
      ref.current?.removeEventListener("keydown", customHandler);
      ref.current?.removeEventListener("click", clickHandler);
      ref.current?.removeEventListener("focusout", focusoutHandler);
      ref.current?.removeEventListener("focusin", focusinHandler);
    };
  }, [customHandler, ref]);
  useEffect(() => {
    if (suggestion && timer.current) {
      window.clearTimeout(timer.current);
      timer.current = null;
    }
  }, [timer, suggestion]);
};
var useSelectionAction = (ref, updateCreateBlockOption, uuid, itemKey, outerRef, refs, dataInputId) => {
  const customHandler = useCallback((e) => {
    const selection = window.getSelection();
    const ref2 = refs.current[uuid];
    const offsets = getSelectionOffset(ref2);
    if (e.target.getAttribute("data-type") != "plain" || !selection?.toString()?.length)
      return;
    const parentRef = findParentByDataId(e?.currentTarget, dataInputId);
    updateCreateBlockOption({
      style: {
        marginTop: -(parentRef?.offsetHeight + 50),
        left: Math.min(ref2?.offsetLeft + offsets.start * 7, ref2?.offsetWidth)
      },
      offsets,
      uuid,
      itemKey
    });
  }, []);
  const findParentByDataId = (element, dataInputId2) => {
    return element?.closest(`div[data-input-id="${dataInputId2}"]`);
  };
  useEffect(() => {
    ref.current?.addEventListener("mouseup", customHandler);
    return () => {
      ref.current?.removeEventListener("mouseup", customHandler);
    };
  }, [ref, customHandler]);
};
var useCreateBlockFromSelectionHandlers = (refs, blocks, updateSuggestion, updateBlock) => {
  const [createBlockOption, updateCreateBlockOption] = useState(null);
  const handleCreateBlockClickout = useCallback(() => {
    updateCreateBlockOption(null);
    updateSuggestion(null);
  }, [updateCreateBlockOption, updateSuggestion]);
  const [handlePostConvertToBlockLock, handlePostConvertToBlockLockUpdate] = useState(null);
  const handlePostConvertToBlock = useCallback(
    ([uuid, itemKey]) => {
      const ref = refs.current[uuid];
      if (!ref) {
        return;
      }
      window.getSelection().selectAllChildren(ref);
      window.setTimeout(
        () => updateSuggestion({ ref, itemKey, uuid, position: 0 }),
        100
      );
    },
    [refs, updateSuggestion]
  );
  const handleConvertToBlock = useCallback(() => {
    const newBlocks = [];
    const newUUID = generateUniqueId();
    const ref = refs.current[createBlockOption.uuid];
    const textContent = ref.textContent;
    const preSelectedText = textContent.slice(
      0,
      createBlockOption.offsets.start
    );
    const selectedText = textContent.slice(
      createBlockOption.offsets.start,
      createBlockOption.offsets.end
    );
    const postSelectedText = textContent.slice(createBlockOption.offsets.end);
    if (!textContent?.trim().length) return;
    if (preSelectedText)
      newBlocks.push({
        text: preSelectedText,
        type: "plain",
        id: "null",
        uuid: createBlockOption.uuid
      });
    if (selectedText)
      newBlocks.push({
        text: selectedText,
        type: "plain",
        id: "null",
        uuid: newUUID
      });
    if (postSelectedText)
      newBlocks.push({
        text: postSelectedText,
        type: "plain",
        id: "null",
        uuid: generateUniqueId()
      });
    blocks.splice(createBlockOption.itemKey, 1, ...newBlocks);
    updateCreateBlockOption(null);
    window.setTimeout(
      () => handlePostConvertToBlockLockUpdate([
        newUUID,
        createBlockOption.itemKey + (preSelectedText ? 1 : 0)
      ]),
      100
    );
  }, [
    createBlockOption,
    updateSuggestion,
    updateCreateBlockOption,
    refs,
    handlePostConvertToBlockLockUpdate,
    blocks,
    updateBlock
  ]);
  useEffect(() => {
    if (handlePostConvertToBlockLock?.length)
      handlePostConvertToBlock(handlePostConvertToBlockLock);
  }, [handlePostConvertToBlockLock, refs]);
  return {
    handleCreateBlockClickout,
    handleConvertToBlock,
    createBlockOption,
    updateCreateBlockOption
  };
};
var useInitializeBlock = (blocks, createNextnode) => {
  useEffect(() => {
    if (!blocks?.length) createNextnode();
  }, [blocks, createNextnode]);
};
var useFocused = (element) => {
  const [isFocused, updateFocused] = useState(false);
  useEffect(() => {
    const handleFocusIn = () => updateFocused(true);
    const handleFocusOut = () => updateFocused(false);
    element.current?.addEventListener("focusin", handleFocusIn);
    element.current?.addEventListener("focusout", handleFocusOut);
    return () => {
      element.current?.removeEventListener("focusin", handleFocusIn);
      element.current?.removeEventListener("focusout", handleFocusOut);
    };
  }, [element, updateFocused]);
  return isFocused;
};
var useNodeOperations = (blocks, updateBlock, refs, isSingleBlock) => {
  const createNextnode = useCallback(() => {
    if (!isSingleBlock || !blocks?.length)
      updateBlock([
        ...blocks || [],
        { text: "", type: "plain", id: "null", uuid: generateUniqueId() }
      ]);
  }, [blocks, updateBlock, isSingleBlock]);
  const deleteNode2 = useCallback(
    (uuid) => {
      const idx = blocks.findIndex((block) => block.uuid == uuid);
      blocks.splice(idx, 1);
      refs.current = blocks.reduce((prev, cur) => {
        if (cur.uuid != uuid) prev[cur.uuid] = refs.current[cur.uuid];
        return prev;
      }, {});
      updateBlock(blocks);
    },
    [blocks, updateBlock, refs]
  );
  return { createNextnode, deleteNode: deleteNode2 };
};
function textColor(blockStyle, id, type) {
  let colorValue = "text-secondary-700";
  if (id == "attribute") {
    colorValue = "text-warning-700";
  } else if (id == "selectable") {
    colorValue = "text-neutral-700";
  } else if (id == "ui_identifier") {
    colorValue = "text-primary-700";
  } else if (blockStyle == "full" ? type != "plain" && id != "raw" : type != "plain") {
    colorValue = "text-unique-500";
  }
  return colorValue;
}
var DynamicRenderer = ({
  itemKey,
  item,
  refs,
  setRef,
  blocks,
  createNextnode,
  deleteNode: deleteNode2,
  dynamicValues: dynamicValues2,
  updateSuggestion,
  suggestion,
  handleTemplateClick,
  updateCreateBlockOption,
  isSingleBlock,
  placeholder,
  isPassword,
  editable,
  blockStyle,
  hasCreateBlock,
  outerRef,
  isOnlyDynamicValueEditable,
  customStyle,
  dataInputId,
  updateIsPasteEvent
}) => {
  const { text: text2, type, id, uuid, more_details } = item;
  const ref = useRef(null);
  const [value, updateValue] = useState(text2);
  const isFocused = useFocused(ref);
  const [showOptions, updateShowOption] = useState(false);
  const handleInput = useCallback(
    (e) => {
      updateValue(e.nativeEvent.target?.textContent);
    },
    [updateValue]
  );
  const handlePaste = useCallback(
    (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key === "v" && updateIsPasteEvent)
        updateIsPasteEvent(true);
    },
    [updateIsPasteEvent]
  );
  const handleKeyUp = (e) => {
    updateIsPasteEvent(false);
  };
  const template = dynamicValues2.find((item2) => item2.id == id);
  const hasContentEditable = useMemo(() => {
    return editable && (!isOnlyDynamicValueEditable || item.type == "dynamic");
  }, [item]);
  useFormatedPaste(ref);
  useKeyMovement(ref, refs, blocks, createNextnode, deleteNode2, hasCreateBlock);
  useEmptySpace(ref, isSingleBlock);
  usePreventEnter(ref);
  useSuggestion(
    value,
    suggestion,
    updateSuggestion,
    item,
    dynamicValues2.filter((item2) => item2.type == "dynamic"),
    ref,
    itemKey,
    isFocused,
    handleTemplateClick,
    editable
  );
  useSelectionAction(
    ref,
    updateCreateBlockOption,
    uuid,
    itemKey,
    outerRef,
    refs,
    dataInputId
  );
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "span",
    {
      className: classNames67(
        "min-h-[20px] flex items-center justify-center",
        {
          "bg-neutral-100": blockStyle == "full" && type != "plain" && id != "raw",
          "text-secondary-700 rounded flex items-center justify-center": type != "plain",
          "min-w-[150px]": isSingleBlock
        },
        customStyle
      ),
      children: [
        template?.symbol && /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames67({
              "bg-neutral-100 rounded w-5 h-5 mr-1 inline-flex item-center justify-center flex-shrink-0": blockStyle == "symbol",
              "mx-1": blockStyle == "full"
            }),
            children: template.symbol
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            contentEditable: hasContentEditable ? "true" : void 0,
            suppressContentEditableWarning: true,
            onInput: handleInput,
            onKeyDown: handlePaste,
            onKeyUp: handleKeyUp,
            ref: (el) => {
              setRef(itemKey, uuid, el, Date.now());
              ref.current = el;
            },
            "data-id": id,
            "data-type": type,
            "data-item-key": itemKey,
            "data-uuid": uuid,
            "data-more-details": JSON.stringify(more_details || {}),
            className: classNames67(
              "outline-none dynamic-ipt w-full inline-block " + textColor(blockStyle, id, type),
              {
                "password-text": isPassword && isSingleBlock && (type == "plain" || type == "dynamic" && id == "raw"),
                "bg-warning-200 rounded": showOptions
              }
            ),
            placeholder: isSingleBlock ? placeholder : "",
            children: text2
          }
        )
      ]
    }
  ) });
};
var modifier = [
  {
    name: "offset",
    options: {
      offset: [0, 12]
    }
  }
];
var RenderEngineSuggestion = ({
  dynamicValues: dynamicValues2,
  handleTemplateClick,
  suggestion,
  updateSuggestion,
  createBlockOption,
  hasCreateBlock,
  createBlockOptionRef,
  handleConvertToBlock
}) => {
  const { t } = useTranslation();
  const [dropdownRef, setDropdownRef] = useState(null);
  const toggleDropdown = useCallback(() => {
  }, [suggestion, updateSuggestion]);
  const { styles: styles2, attributes } = usePopper(suggestion?.ref, dropdownRef, {
    placement: "bottom-end",
    strategy: "fixed",
    modifiers: modifier
  });
  const canShowTestDataSuggestion = useMemo(() => {
    return suggestion && !["ui_identifier", "attribute", "selectable"].includes(suggestion.itemID);
  }, [suggestion]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    canShowTestDataSuggestion && /* @__PURE__ */ jsx(
      Dropdown,
      {
        className: "w-[160px] min-w-[90px] z-[1000]",
        toggleDropdown,
        setRef: setDropdownRef,
        style: styles2.popper,
        attributes: attributes.popper,
        children: dynamicValues2.filter((item) => item.type == "dynamic" && item.showInSuggestion).map((item, dIdx) => /* @__PURE__ */ jsxs(
          DropdownItem,
          {
            isSelected: suggestion?.itemID === item?.id,
            onClick: () => handleTemplateClick(item, suggestion.itemKey, suggestion.uuid),
            className: classNames67({
              "!bg-secondary-50 !text-primary-600": suggestion?.itemID === item?.id
            }),
            children: [
              item.symbol && /* @__PURE__ */ jsx("span", { className: "rounded p-1 bg-neutral-100 w-5 inline-flex h-5 items-center justify-center mr-2", children: item.symbol }),
              t(item.i18n)
            ]
          },
          dIdx
        ))
      },
      "drop-down"
    ),
    createBlockOption && hasCreateBlock && /* @__PURE__ */ jsx(
      "div",
      {
        ref: createBlockOptionRef,
        onClick: handleConvertToBlock,
        className: "bg-white absolute mt-[-80px] shadow-md rounded px-2 py-1 cursor-pointer hover:text-primary-400",
        style: createBlockOption.style,
        children: t("insert.testdata")
      }
    )
  ] });
};
var RenderEngine = ({
  data,
  dynamicValues: dynamicValues2,
  isSingleBlock,
  className: className2,
  placeholder,
  onChange,
  isPassword,
  editable,
  blockStyle,
  getTestData,
  hasCreateBlock,
  includeTemplate,
  onFocusChange,
  isOnlyDynamicValueEditable,
  customStyle,
  dataInputId,
  updateIsPasteEvent
}) => {
  const refs = useRef({});
  const outerRef = useRef(null);
  const createBlockOptionRef = useRef(null);
  const hasFocus = useFocused(outerRef);
  const [blocks, updateBlock] = useState(
    isSingleBlock && data?.length ? [data[0]] : data
  );
  const [suggestion, _updateSuggestion] = useState(null);
  const updateSuggestion = (data2) => {
    _updateSuggestion(data2);
  };
  const setRef = useCallback(
    (key, uuid, value, time) => {
      if (value) {
        refs.current[uuid] = value;
        if (!refs.current[uuid].initialsedTime) {
          refs.current[uuid].initialsedTime = time;
        }
      }
    },
    [refs]
  );
  const onChangeHandler = useDomToBlock(
    refs,
    onChange,
    blocks,
    updateBlock,
    includeTemplate
  );
  const { createNextnode, deleteNode: deleteNode2 } = useNodeOperations(
    blocks,
    updateBlock,
    refs,
    isSingleBlock
  );
  const handleTemplateClick = useTemplateClick(
    blocks,
    updateBlock,
    updateSuggestion,
    refs,
    getTestData,
    dynamicValues2
  );
  const {
    handleCreateBlockClickout,
    handleConvertToBlock,
    createBlockOption,
    updateCreateBlockOption
  } = useCreateBlockFromSelectionHandlers(
    refs,
    blocks,
    updateSuggestion,
    updateBlock
  );
  useBlockChange(outerRef, blocks, onChangeHandler);
  useInitializeBlock(blocks, createNextnode);
  use_click_outside_default(createBlockOptionRef, handleCreateBlockClickout);
  useEffect(() => onFocusChange(hasFocus), [hasFocus, onFocusChange]);
  const handleClick = useCallback(
    (event) => {
      if (isFireFox && event.currentTarget == event.target && refs?.current) {
        const keyList = Object.keys(refs?.current);
        const index = keyList[keyList.length - 1];
        refs?.current[index].focus();
      }
    },
    [refs]
  );
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: (el) => outerRef.current = el,
      className: classNames67(
        "outline-none whitespace-nowrap overflow-hidden w-full flex items-center px-1",
        className2
      ),
      contentEditable: false,
      suppressContentEditableWarning: true,
      onClick: handleClick,
      "data-input-id": dataInputId,
      children: [
        blocks?.map((item, idx) => /* @__PURE__ */ jsx(
          DynamicRenderer,
          {
            updateSuggestion,
            suggestion,
            handleTemplateClick,
            createBlockOption,
            updateCreateBlockOption,
            outerRef,
            dynamicValues: dynamicValues2,
            createNextnode,
            deleteNode: deleteNode2,
            itemKey: idx,
            setRef,
            refs,
            item,
            blocks,
            isSingleBlock,
            placeholder,
            editable,
            isPassword,
            blockStyle,
            hasCreateBlock,
            isOnlyDynamicValueEditable,
            customStyle,
            dataInputId,
            updateIsPasteEvent
          },
          item.uuid
        )),
        /* @__PURE__ */ jsx(
          RenderEngineSuggestion,
          {
            dynamicValues: dynamicValues2,
            handleTemplateClick,
            suggestion,
            updateSuggestion,
            createBlockOption,
            hasCreateBlock,
            createBlockOptionRef,
            handleConvertToBlock
          }
        )
      ]
    }
  );
};
var DynamicValueInput = ({
  value,
  onChange,
  placeholder = "",
  allowedDynamics = [],
  className: className2 = "",
  isSingleBlock = true,
  isPassword = false,
  modifyDefaultDynamicValue = (item) => item,
  editable = true,
  blockStyle = "full",
  getTestData = NOOP,
  hasCreateBlock = false,
  includeTemplate = false,
  onFocusChange = NOOP,
  isOnlyDynamicValueEditable = false,
  customStyle = "",
  dataInputId = "dynamic-input",
  updateIsPasteEvent = NOOP
}) => {
  let DYNAMIC_VALUES = modifyDefaultDynamicValue(dynamicValues);
  if (allowedDynamics.length) {
    DYNAMIC_VALUES = DYNAMIC_VALUES.filter(
      (item) => allowedDynamics.includes(item.id)
    );
  }
  const internalBlock = value?.map((block) => ({
    uuid: block.uuid || generateUniqueId(),
    text: block.value.replace(/.\|(.*)\|/, "$1").trim(),
    id: String(block.type),
    type: String(block.type) == "null" ? "plain" : "dynamic",
    ...block.more_details == void 0 ? {} : { more_details: block.more_details },
    ...block.hasValue == void 0 ? {} : { hasValue: block.hasValue }
  }));
  return /* @__PURE__ */ jsx(
    RenderEngine,
    {
      placeholder,
      data: internalBlock,
      className: className2,
      isSingleBlock,
      dynamicValues: DYNAMIC_VALUES,
      onChange,
      editable,
      isPassword,
      blockStyle,
      getTestData,
      hasCreateBlock,
      includeTemplate,
      onFocusChange,
      isOnlyDynamicValueEditable,
      customStyle,
      dataInputId,
      updateIsPasteEvent
    }
  );
};
var Avatar = ({
  size = "sm",
  alt,
  shape = "circle",
  src,
  onError = () => true,
  initialsToDisplay = 1,
  className: className2
}) => {
  const [hasLoaded, setHasLoaded] = React__default.useState(false);
  const [fallbackToInitial, setFallbackToInitial] = React__default.useState(false);
  const handleImageLoad = () => {
    setHasLoaded(true);
  };
  const handleImageError = () => {
    setHasLoaded(false);
    if (onError) {
      const value = onError();
      setFallbackToInitial(value);
    }
  };
  const initials = alt?.slice(0, initialsToDisplay).toLocaleUpperCase();
  const sizeClassName = {
    xs: "w-4 h-4 text-xs font-medium",
    sm: "w-8 h-8 text-base font-semibold",
    md: "w-18 h-18 text-xl font-semibold",
    lg: "w-32 h-32 text-4xl font-bold"
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "inline-flex items-center text-black bg-yellow-500 justify-center overflow-hidden border-white border",
        sizeClassName[size],
        shape === "circle" ? "rounded-[128px]" : "rounded-lg",
        className2
      ),
      children: src && typeof src === "string" && !fallbackToInitial ? /* @__PURE__ */ jsx(
        "img",
        {
          alt,
          className: "bg-cover bg-center",
          src,
          style: {
            backgroundImage: `url(${src})`,
            backgroundSize: "cover",
            width: "100%",
            height: "100%",
            display: hasLoaded ? "block" : "none"
          },
          onLoad: handleImageLoad,
          onError: handleImageError
        }
      ) : initials
    }
  );
};
var AvatarGroup = ({
  children,
  size = "sm",
  maxCount,
  direction = "horizontally",
  leftSpace = 0,
  avatarSize
}) => {
  const avatars = Array.isArray(children) ? children : [children];
  const slicedCount = avatars.length - (maxCount || avatars.length);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        display: "flex",
        position: "relative",
        flexDirection: direction == "horizontally" ? "row" : "column",
        height: "100%"
      },
      children: [
        avatars?.length && avatars?.slice(0, maxCount || avatars.length).map((avatar, index) => /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              zIndex: avatars.length - index,
              left: `${index * 12}%`,
              top: 0
            },
            children: /* @__PURE__ */ jsx(Avatar, { ...avatar.props, size: avatarSize || size })
          },
          `key-${index}`
        )),
        slicedCount > 0 && /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              position: "absolute",
              zIndex: avatars.length - (maxCount || avatars.length),
              left: `${(maxCount || avatars.length) * 12}%`,
              top: 0
            },
            children: /* @__PURE__ */ jsx(
              Avatar,
              {
                initialsToDisplay: 4,
                alt: `+${slicedCount}`,
                size: avatarSize || size,
                className: "!bg-secondary-100 !text-secondary-unique-800 !text-xs !font-normal ml-1"
              }
            )
          }
        )
      ]
    }
  );
};
var UploadAvatar = ({
  accepts,
  iconName,
  iconClassName,
  onChange,
  ...rest
}) => {
  const fileInputRef = useRef(null);
  const clickHandler = () => {
    fileInputRef?.current.click();
  };
  const handleFileChange = (event) => {
    onChange?.(event);
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsx(Avatar, { ...rest }),
    /* @__PURE__ */ jsx(
      Icon3,
      {
        name: iconName,
        onClick: clickHandler,
        className: classNames67(
          "absolute bg-secondary-50 border-2 rounded-full border-shades-50 bottom-0.5 -right-1 p-1 text-[#4B5563] cursor-pointer",
          iconClassName
        )
      }
    ),
    /* @__PURE__ */ jsx(
      "input",
      {
        type: "file",
        className: "hidden",
        name: "file",
        ref: fileInputRef,
        onChange: handleFileChange,
        accept: accepts
      }
    )
  ] });
};
var FormatOption = /* @__PURE__ */ ((FormatOption2) => {
  FormatOption2["YYYY_MM_DD"] = "yyyy-MM-dd";
  FormatOption2["MMM_D_HH_MM_SS_A"] = "MMM d, h:mm:ss a";
  FormatOption2["HH_MM_A_MMM_D_YYYY"] = "h:mm a MMM d, yyyy";
  FormatOption2["MMM_D_YYYY_HH_MM_A"] = "MMM d, yyyy, hh:mm a";
  FormatOption2["MMM_D_YYYY"] = "MMM d, yyyy";
  FormatOption2["HH_MM_A"] = "hh:mm a";
  FormatOption2["HH_MM_SS_SSS"] = "hh:mm:ss.sss";
  FormatOption2["HH_MM_SS"] = "hh:mm:ss";
  FormatOption2["EEE_D_MMM"] = "EEE d MMM";
  FormatOption2["HH_MM_A_D_MMM_YYYY"] = "hh:mm a, d MMM, yyyy";
  FormatOption2["MMM_D_HH_MM_A"] = "MMM d, hh:mm a";
  FormatOption2["D_MMM_HH_MM_SS_A"] = "d MMM, hh:mm:ss a";
  FormatOption2["MMM_D_HH_MM_SS"] = "MMM d, HH:mm:ss";
  FormatOption2["EEE_MMM_D_YYYY_HH_MM"] = "EEE | MMM d yyyy | HH:mm";
  return FormatOption2;
})(FormatOption || {});
var DateTimeFormat = ({
  date,
  format: formatString = "MMM d, yyyy, hh:mm a",
  relative = false,
  className: className2 = "",
  tooltipContent = "",
  showTooltip = false
}) => {
  const dateTimeFormat = date instanceof Date && !isNaN(date?.getTime()) || typeof date === "number" ? relative ? formatDistanceToNow(date, {
    includeSeconds: true,
    addSuffix: true
  }) : format(date, formatString) : "-";
  return showTooltip ? /* @__PURE__ */ jsx(ToolTip, { content: tooltipContent || dateTimeFormat, align: "center", children: /* @__PURE__ */ jsx("span", { className: className2, children: dateTimeFormat }) }) : /* @__PURE__ */ jsx("span", { className: className2, children: dateTimeFormat });
};
var FixedField = ({
  label,
  text: text2,
  date,
  wrapperClassName = "",
  labelClassName = "",
  textClassName = "",
  showPrefixAvatar,
  prefixAvatarClassName,
  src = ""
}) => {
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs("div", { className: classNames67("flex-col", wrapperClassName), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "flex flex-row mb-1.5 text-secondary-500 text-2xs mx-0.5 font-medium",
          labelClassName
        ),
        children: [
          /* @__PURE__ */ jsx("span", { className: "flex-grow", children: t(label) }),
          date && /* @__PURE__ */ jsx(
            DateTimeFormat,
            {
              date,
              format: "h:mm a MMM d, yyyy" /* HH_MM_A_MMM_D_YYYY */,
              relative: false
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx("div", { className: "flex flex-wrap w-full", children: /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "flex flex-grow bg-secondary-50 text-secondary-700 py-2.5 px-3 rounded text-xs font-medium gap-3 items-center w-full overflow-hidden",
          textClassName
        ),
        children: [
          showPrefixAvatar && text2 && /* @__PURE__ */ jsx(
            Avatar,
            {
              alt: text2,
              shape: "circle",
              size: "xs",
              className: classNames67("mr-0.5 shrink-0", prefixAvatarClassName),
              src
            }
          ),
          /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx(TruncatedText, { value: text2 }) })
        ]
      }
    ) })
  ] });
};
var ToggleSwitch = ({
  label,
  id,
  checked = false,
  onChange,
  outline = false,
  size = "small",
  labelPosition = "right",
  isDisabled,
  labelClassName,
  enableCustomToggle = false,
  wrapperClassName = "",
  ariaLabel
}) => {
  const [isChecked, setIsChecked] = React__default.useState(checked);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const onCheckStateChange = (event) => {
    !enableCustomToggle && setIsChecked(event.target.checked);
    onChange(event.target.checked);
  };
  const toggleOffBackgroundColor = !outline ? "bg-secondary-400 border-secondary-400 border" : "border-secondary-400 border";
  const toggleOnBackgroundColor = !outline ? "bg-primary-500 border-primary-500 border" : "border-primary-600 border";
  const toggleOffCircleBackgroundColor = !outline ? `after:bg-white ${isDisabled ? "opacity-10" : ""}` : `after:bg-secondary-500 ${isDisabled ? "opacity-10" : ""}`;
  const toggleOnCircleBackgroundColor = !outline ? "after:bg-white" : "after:bg-primary-600";
  const sizeClassName = size === "medium" ? "w-8 h-4 after:h-4 after:w-4" : size === "small" ? "w-6 h-3 after:h-3 after:w-3" : "w-10 h-5 after:h-5 after:w-5";
  const labelPositionClassName = labelPosition === "left" ? "flex-row-reverse" : "flex-row";
  const toggleOnLabel = "text-neutral-800 text-xs truncate";
  return /* @__PURE__ */ jsxs(
    "label",
    {
      htmlFor: id || void 0,
      className: classNames67(
        {
          "opacity-75 cursor-not-allowed": isDisabled,
          "cursor-pointer": !isDisabled
        },
        "inline-flex relative items-center max-w-full",
        labelPositionClassName,
        wrapperClassName
      ),
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            onChange: onCheckStateChange,
            type: "checkbox",
            checked: isChecked,
            id: id || void 0,
            className: "sr-only peer",
            disabled: isDisabled,
            "aria-label": ariaLabel || label || void 0
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            "data-testid": "toggle-switch",
            className: classNames67(
              {
                [toggleOffBackgroundColor]: !isChecked,
                [toggleOnBackgroundColor]: isChecked
              },
              {
                [toggleOffCircleBackgroundColor]: !isChecked
              },
              {
                [toggleOnCircleBackgroundColor]: isChecked
              },
              sizeClassName,
              "rounded-full peer peer-checked:after:translate-x-full after:content-[''] after:absolute after:scale-90 after:-translate-y-2/4 after:top-1/2 box-content after:rounded-full after:transition-all"
            )
          }
        ),
        label && /* @__PURE__ */ jsx(
          "span",
          {
            "data-testid": "toggle-label",
            className: classNames67("ml-3", toggleOnLabel, labelClassName),
            children: label
          }
        )
      ]
    }
  );
};
var DefaultCheckIcon = ({ className: className2 }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: className2,
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "inherit",
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M13.5633 3.26743C13.0731 2.86756 12.3557 2.92201 11.9316 3.39126L6.50872 9.3913L3.83913 6.85067C3.41866 6.4505 2.75818 6.45062 2.33785 6.85094C1.88738 7.27996 1.88738 7.99856 2.33785 8.42758L6.77012 12.6488L13.6937 4.9834C14.149 4.47935 14.0895 3.69683 13.5633 3.26743Z",
          fill: "inherit"
        }
      )
    }
  );
};
var Checkbox = ({
  checked = false,
  label,
  name,
  onChange,
  checkIcon,
  size = "medium",
  type = "primary",
  fillColor,
  borderColor,
  isDisabled,
  labelClassName,
  isReadOnly = false,
  className: className2,
  checkIconClassName = "",
  inputClassName = "",
  reflect = false,
  isRequired = false,
  ariaLabel
}) => {
  const [isChecked, setIsChecked] = useState(checked);
  useEffect(() => {
    setIsChecked(checked);
  }, [checked]);
  const onCheckStateChange = useCallback(
    (event) => {
      event.preventDefault();
      if (!isReadOnly) {
        setIsChecked(event.target.checked);
        onChange?.(event.target.checked);
      }
    },
    [onChange, isReadOnly]
  );
  const sizeClass = size === "medium" ? "h-5 w-5" : size === "small" ? "h-4 w-4" : "h-6 w-6";
  const themeClass = !fillColor && !borderColor ? type === "primary" ? "border-neutral-600 checked:bg-primary-500" : type === "secondary" ? "border-neutral-600 checked:bg-neutral-600" : null : null;
  const iconClass = classNames67(
    sizeClass,
    "fill-white absolute -translate-x-2/4 -translate-y-2/4 top-1/2 left-1/2 scale-75"
  );
  return /* @__PURE__ */ jsxs(
    "label",
    {
      className: classNames67(
        "flex items-center space-x-3",
        !isDisabled ? "cursor-pointer" : "cursor-not-allowed",
        className2
      ),
      children: [
        /* @__PURE__ */ jsxs("span", { className: "relative flex", children: [
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "checkbox",
              name,
              className: classNames67(
                sizeClass,
                themeClass,
                "disabled:opacity-75 disabled:!cursor-not-allowed disabled:bg-neutral-700 appearance-none bg-white border border-gray-300 rounded focus:outline-none  checked:border-transparent",
                { "cursor-pointer": !isDisabled },
                inputClassName
              ),
              checked: reflect ? checked : isChecked,
              onChange: reflect ? null : onCheckStateChange,
              onClickCapture: reflect ? null : onCheckStateChange,
              onChangeCapture: reflect ? null : onCheckStateChange,
              style: {
                backgroundColor: isChecked && fillColor,
                borderColor: !isChecked && borderColor
              },
              "aria-label": ariaLabel || (typeof label === "string" ? label : void 0),
              disabled: isDisabled,
              readOnly: isReadOnly
            },
            isChecked ? "checked" : "unchecked"
          ),
          isChecked ? !checkIcon ? /* @__PURE__ */ jsx(DefaultCheckIcon, { className: iconClass }) : React__default.cloneElement(checkIcon, {
            className: classNames67(iconClass, checkIconClassName)
          }) : null
        ] }),
        label && /* @__PURE__ */ jsxs(Fragment, { children: [
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              "data-testid": "checkbox-label",
              value: label,
              className: classNames67(
                "text-neutral-800 text-small inline-block overflow-hidden",
                labelClassName
              )
            }
          ),
          isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" })
        ] })
      ]
    }
  );
};
var InputWithCheckbox = ({
  label = "",
  value,
  updateValue,
  onCheckBoxChange,
  hasError = false,
  inputClassName = "",
  checkboxSize = "small",
  labelClassNameForCheckbox = "",
  wrapperClassName = "",
  checkBoxClassName = "",
  placeholder = "",
  isCheckBoxDisabled = false,
  defaultValue = "0",
  isChecked = false,
  isDisabled = false,
  suffix,
  errorLabel
}) => {
  const [isSelected, setIsSelected] = useState(isChecked);
  const onChange = (checked) => {
    onCheckBoxChange?.(checked);
    if (!checked) updateValue(defaultValue);
    setIsSelected(checked);
  };
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs("div", { className: classNames67("flex items-center", wrapperClassName), children: [
      /* @__PURE__ */ jsx(
        Checkbox,
        {
          type: "primary",
          size: checkboxSize,
          label: t(label),
          checked: isSelected,
          onChange,
          inputClassName: checkBoxClassName,
          isDisabled: isCheckBoxDisabled,
          labelClassName: labelClassNameForCheckbox
        }
      ),
      /* @__PURE__ */ jsx(
        Input,
        {
          isRequired: isSelected,
          value: value === null ? "" : value?.toString(),
          onChange: updateValue,
          wrapperClassName: "h-11 pl-3 gap-2 rounded-md !w-16 !items-center !justify-center",
          inputClassName: classNames67(
            "w-11 h-7 !px-1 text-center",
            inputClassName
          ),
          hasError: !!(hasError && isSelected),
          preventDecimal: true,
          preventDefaultValue: true,
          isDisabled: isDisabled || !isSelected,
          placeholder,
          hideErrorMessage: true,
          className: "!w-11",
          errorClassName: "!w-[420px] !pl-40 -mt-2"
        }
      ),
      !!suffix && suffix
    ] }),
    !!(hasError && errorLabel) && /* @__PURE__ */ jsxs("div", { className: "flex items-center ", children: [
      /* @__PURE__ */ jsx(Icon3, { className: "text-lg text-error-600", name: "error" }),
      /* @__PURE__ */ jsx("div", { className: "ml-2 text-sm text-error-600", children: t(errorLabel) })
    ] })
  ] });
};
var SearchInput = ({
  value,
  onChange,
  placeholder,
  isExpanded
}) => {
  const [searchExpanded, setSearchExpanded] = useState(isExpanded);
  useEffect(() => {
    setSearchExpanded(isExpanded);
  }, [isExpanded]);
  return /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
    /* @__PURE__ */ jsx(
      "span",
      {
        style: {
          transition: "all 1s ease-in-out",
          width: searchExpanded ? "100%" : "0"
        },
        children: /* @__PURE__ */ jsx(
          Input,
          {
            value,
            onChange,
            suffix: value && /* @__PURE__ */ jsx(Icon3, { name: "clear" }),
            placeholder,
            inputClassName: classNames67(
              {
                "!px-2.5": searchExpanded,
                "!px-0": !searchExpanded
              },
              "!py-0"
            ),
            hideErrorMessage: true
          }
        )
      }
    ),
    /* @__PURE__ */ jsx(
      Icon3,
      {
        name: "search",
        className: "text-base leading-4 cursor-pointer px-2",
        onClick: () => setSearchExpanded(!searchExpanded)
      }
    )
  ] });
};
var TextArea = ({
  id,
  value,
  placeholder,
  onChange,
  isReadOnly = false,
  isDisabled = false,
  prefix,
  suffix,
  hasError = false,
  errorText = "",
  className: className2,
  inputClassName,
  wrapperClassName,
  label = "",
  labelClassName = "",
  setRef = () => {
  },
  isAutoSize = false,
  rows = 2,
  maxHeight,
  minHeight,
  maxLength,
  onBlur,
  isRequired = false,
  errorClassName,
  preventLeadingSpace = true,
  onkeydown,
  preventDefaultValue = false,
  onFocus
}) => {
  const ref = useRef(null);
  const updateRef = (el) => {
    ref.current = el;
    setRef?.(el);
  };
  const variantClasses = {
    normal: "bg-secondary-50 focus-within:bg-white border-transparent",
    error: "bg-white border-error-300 ",
    disabled: "bg-neutral-50 border-neutral-100"
  };
  const variant = hasError ? "error" : isDisabled ? "disabled" : "normal";
  const hasOutline = !(prefix || suffix);
  useEffect(() => {
    if (isAutoSize && ref.current) {
      if (minHeight && !value) {
        ref.current.style.height = `${minHeight}px`;
      } else if (maxHeight && ref.current.scrollHeight > maxHeight) {
        ref.current.style.height = `${maxHeight}px`;
      } else {
        ref.current.style.height = `${ref.current.scrollHeight}px`;
      }
    }
  }, [value, isAutoSize, minHeight, maxHeight]);
  const valueAttributes = useMemo(() => {
    return preventDefaultValue ? { value } : { defaultValue: value };
  }, [preventDefaultValue, value]);
  const handleKeyDown = useCallback(
    (event) => {
      if (preventLeadingSpace && event.currentTarget.selectionStart === 0 && event.key === " ") {
        event.preventDefault();
      }
      onkeydown?.(event);
    },
    [onkeydown, preventLeadingSpace]
  );
  return /* @__PURE__ */ jsxs("div", { className: classNames67("inline-flex flex-col", wrapperClassName), children: [
    label && /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "text-secondary-500 text-xs font-medium p-1",
          labelClassName
        ),
        children: [
          label,
          isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        id: id || void 0,
        className: classNames67(
          "inline-flex rounded border",
          variantClasses[variant],
          { "focus-within:border-primary-300": hasOutline },
          { "focus-within:border-neutral-100": !hasOutline },
          className2
        ),
        "data-testid": "text-area-container",
        children: [
          prefix,
          /* @__PURE__ */ jsx(
            "textarea",
            {
              required: isRequired,
              ref: updateRef,
              rows,
              className: classNames67(
                "flex-grow outline-none text-secondary-700 text-small leading-5 px-3 py-2 bg-transparent resize",
                inputClassName
              ),
              readOnly: isReadOnly,
              disabled: isDisabled,
              ...valueAttributes,
              onKeyDown: handleKeyDown,
              placeholder,
              onChange: (e) => onChange(e.target.value),
              "data-testid": "text-area-input",
              maxLength,
              onBlur,
              onFocus
            }
          ),
          suffix
        ]
      }
    ),
    hasError && errorText && /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames67(
          "pl-0.5 text-xs h-4 text-error-600",
          errorClassName
        ),
        "data-testid": "text-area-error",
        children: errorText
      }
    )
  ] });
};

// src/auto-resizing-debounced-input/constants.ts
var DEFAULT_DIMENSIONS = {
  minHeight: 31,
  maxHeight: 150
};
var DEBOUNCE_DELAY = 500;
var DEFAULT_CHARACTER_LIMIT = 250;
var AutoResizingDebouncedInput = ({
  value,
  minHeight = DEFAULT_DIMENSIONS.minHeight,
  onChange,
  showClearIcon = false,
  clearIconClassName,
  inputClassName,
  characterLimit = DEFAULT_CHARACTER_LIMIT,
  searchInputClassName,
  onClear: onTextAreaClear,
  ...rest
}) => {
  const [input, setInput] = useState(value || "");
  const debouncedInputValue = use_debounce_default(input, DEBOUNCE_DELAY);
  const textAreaRef = useRef(null);
  const [isExpanded, setIsExpanded] = useState(false);
  const { t } = useTranslation();
  const onClear = useCallback(() => {
    setInput("");
    onChange("");
    setIsExpanded(false);
    if (onTextAreaClear) {
      onTextAreaClear();
    }
  }, [onChange, onTextAreaClear]);
  useEffect(() => {
    if (input !== value) {
      setInput(value);
    }
  }, [value]);
  useEffect(() => {
    if (value !== debouncedInputValue && debouncedInputValue.length <= characterLimit) {
      onChange(debouncedInputValue);
    }
  }, [debouncedInputValue]);
  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
    }
    if (e.key === "Escape" && input.length > 0) {
      e.preventDefault();
      onClear();
    }
  };
  useEffect(() => {
    const textarea = textAreaRef.current;
    if (textarea) {
      textarea.style.transition = "height 0.3s ease-in";
      if (isExpanded) {
        textarea.style.height = "auto";
        textarea.style.height = `${Math.max(
          textarea.scrollHeight,
          minHeight
        )}px`;
      } else {
        textarea.style.height = `${minHeight}px`;
        textarea.style.overflow = "hidden";
      }
    }
  }, [isExpanded, input]);
  const clearSuffix = showClearIcon && input.length > 0 && /* @__PURE__ */ jsx(
    "div",
    {
      className: "flex items-start py-2 pr-2 cursor-pointer",
      onClick: onClear,
      children: /* @__PURE__ */ jsx(
        Icon3,
        {
          name: "close",
          className: classNames67(
            "text-white bg-secondary-500 p-[1px] text-[10px] cursor-pointer rounded-full mt-0.5",
            clearIconClassName
          ),
          title: t("common.clear")
        }
      )
    }
  );
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "transition-all duration-300 rounded-lg bg-primary-100",
        searchInputClassName,
        isExpanded && "shadow-xl ring-2 ring-neutral-300"
      ),
      children: /* @__PURE__ */ jsx(
        TextArea,
        {
          ...rest,
          value: input,
          onChange: setInput,
          onkeydown: handleKeyDown,
          setRef: (el) => {
            if ("setRef" in rest) {
              rest.setRef(el);
            }
            textAreaRef.current = el;
          },
          suffix: clearSuffix,
          isAutoSize: true,
          minHeight,
          maxHeight: DEFAULT_DIMENSIONS.maxHeight,
          maxLength: characterLimit,
          rows: 1,
          preventLeadingSpace: false,
          inputClassName: classNames67(
            "text-sm leading-6",
            "bg-transparent !resize-none ",
            inputClassName
          ),
          preventDefaultValue: true,
          onBlur: () => setIsExpanded(false),
          onFocus: () => setIsExpanded(true)
        }
      )
    }
  );
};
var ExpandableInput = ({
  value,
  onChange,
  prefixIconName,
  placeholder,
  inputClassName,
  inputContainerClassName,
  iconClassName,
  onClick,
  onBlur,
  expandableWrapperClassName,
  inputWrapperClassName,
  showClearIcon = false
}) => {
  const [inputExpanded, setInputExpanded] = useState(false);
  const [inputRef, setInputRef] = useState(null);
  const [input, setInput] = useState(value);
  const debouncedInputValue = use_debounce_default(input, 500);
  useEffect(() => {
    onChange(debouncedInputValue);
  }, [debouncedInputValue]);
  const handleInputChange = (value2) => {
    setInput(value2);
  };
  const onSearchIconClick = useCallback(() => {
    setInputExpanded(true);
    onClick && onClick?.();
    inputRef?.querySelector("input").focus();
  }, [inputRef]);
  const onSearchInputBlur = useCallback(() => {
    if (!value && !input) {
      setInputExpanded(false);
      inputRef?.querySelector("input").blur();
      onBlur && onBlur?.();
    }
  }, [value, input]);
  const onClear = () => {
    setInput("");
    onChange("");
  };
  const canShowClearButton = useMemo(() => {
    return showClearIcon && inputExpanded && !!input?.length;
  }, [inputExpanded, showClearIcon, input]);
  return /* @__PURE__ */ jsx(
    "div",
    {
      onClick: onSearchIconClick,
      onBlur: onSearchInputBlur,
      className: classNames67("cursor-pointer", expandableWrapperClassName),
      children: /* @__PURE__ */ jsx(
        Input,
        {
          type: "text",
          onChange: handleInputChange,
          placeholder,
          prefix: prefixIconName ? /* @__PURE__ */ jsx(
            Icon3,
            {
              name: prefixIconName,
              className: classNames67("px-3 text-base", iconClassName)
            }
          ) : "",
          suffix: canShowClearButton && /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "close",
              className: "pr-3 text-base",
              onClick: onClear
            }
          ),
          value: input,
          setRef: setInputRef,
          inputClassName: classNames67(
            "text-2xs leading-4 transition-all",
            {
              "w-0 !px-0": !inputExpanded,
              "!pl-0 !pr-3": inputExpanded
            },
            inputClassName
          ),
          className: classNames67(inputContainerClassName, {
            "!border-0": !inputExpanded
          }),
          wrapperClassName: inputWrapperClassName,
          preventDefaultValue: true
        }
      )
    }
  );
};

// src/utils/event.ts
var preventBubble = (event) => {
  event?.preventDefault();
  event?.stopPropagation();
  event?.stopImmediatePropagation && event.stopImmediatePropagation();
};

// src/utils/validation.ts
var validateEmail = (value) => {
  const emailRegex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,13}$/g;
  return emailRegex.test(value);
};
var isValidDate = (value) => {
  return isNaN(parseInt(value));
};
var validateFileName = (fileName) => {
  const windowsIllegalChars = /[\\/:*?"<>|]/g;
  const unixIllegalChars = /[\x00/]/g;
  const windowsMatches = fileName?.match(windowsIllegalChars) || [];
  const unixMatches = fileName?.match(unixIllegalChars) || [];
  const allMatches = [.../* @__PURE__ */ new Set([...windowsMatches, ...unixMatches])];
  const formattedMatches = allMatches.map((char) => char === ":" ? "/" : char).join(" ");
  return allMatches.length > 0 ? formattedMatches : null;
};
var isValidFileType = (fileName, allowedFileTypes) => {
  const fileType = fileName?.split(".")?.slice(-1)[0];
  return allowedFileTypes.includes(fileType);
};
var areValidFileTypes = (files2, allowedTypes) => {
  for (const file of files2) {
    if (!isValidFileType(file.name, allowedTypes)) {
      return false;
    }
  }
  return true;
};
var isValidJson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
var commonClassProperties = "px-3 box-border flex items-center space-x-2.5 w-fit rounded cursor-pointer";
var types = {
  outline: "border border-solid border-slate-350",
  filled: "bg-gray-100",
  transparant: "bg-transparent"
};
var UploadButton = ({
  label,
  type = "outline",
  onFileRemove,
  onFileSelect,
  uploadedFileName,
  isFileUploading,
  size = "md",
  className: className2,
  accept,
  displayWithIconFileSize,
  fileSize,
  disabled
}) => {
  const fileInputRef = useRef(null);
  const [isFileError, setIsFileError] = useState(null);
  const { t } = useTranslation();
  const onFileChange = (event) => {
    const fileName = event.target.files[0]?.name;
    const illegalChar = validateFileName(fileName);
    if (illegalChar) {
      setIsFileError(
        t("user.filename.invalidchars", {
          illegalChar
        })
      );
      return;
    }
    setIsFileError("");
    onFileSelect?.(event);
  };
  const removeFile = (event) => {
    preventBubble(event);
    onFileRemove?.(event);
  };
  const selectFile = () => {
    fileInputRef?.current?.click();
  };
  const sizeVarients = {
    sm: "py-1",
    md: "py-2"
  };
  return /* @__PURE__ */ jsxs("span", { children: [
    !uploadedFileName && /* @__PURE__ */ jsx(
      "input",
      {
        type: "file",
        style: { display: "none" },
        onChange: onFileChange,
        ref: fileInputRef,
        accept,
        disabled
      }
    ),
    !displayWithIconFileSize ? /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: selectFile,
        className: classNames67(
          commonClassProperties,
          sizeVarients[size],
          types[type],
          className2
        ),
        children: [
          /* @__PURE__ */ jsx(
            "span",
            {
              className: classNames67(
                "text-small",
                uploadedFileName ? "text-secondary-600" : ""
              ),
              children: uploadedFileName || label
            }
          ),
          uploadedFileName && /* @__PURE__ */ jsx(
            "span",
            {
              className: "text-[18px] text-secondary-900 hover:bg-gray-150 flex",
              onClick: removeFile,
              children: /* @__PURE__ */ jsx(Icon3, { name: "close", className: "flex" })
            }
          ),
          isFileUploading && /* @__PURE__ */ jsx("span", { className: "w-4 text-green-600", children: /* @__PURE__ */ jsx(
            Spinner,
            {
              secondaryColor: "bg-green-600",
              speed: 100,
              still: void 0,
              thickness: 150
            }
          ) })
        ]
      }
    ) : /* @__PURE__ */ jsxs(
      "div",
      {
        onClick: selectFile,
        className: classNames67(
          commonClassProperties,
          sizeVarients[size],
          types[type],
          className2,
          uploadedFileName ? "bg-[#F7F8F9]" : ""
        ),
        children: [
          !uploadedFileName && /* @__PURE__ */ jsx("span", { className: classNames67("text-small"), children: label }),
          uploadedFileName && /* @__PURE__ */ jsxs("div", { className: "flex", children: [
            /* @__PURE__ */ jsxs(
              "span",
              {
                className: classNames67(
                  "text-small",
                  "flex",
                  uploadedFileName ? "text-secondary-600" : ""
                ),
                children: [
                  uploadedFileName && /* @__PURE__ */ jsx("div", { className: "w-8 h-8 bg-white rounded-full text-secondary-900 flex items-center justify-center text-center", children: /* @__PURE__ */ jsx(Icon3, { name: "draft", className: " text-[18px]" }) }),
                  /* @__PURE__ */ jsxs("div", { className: "pl-3 pr-4", children: [
                    /* @__PURE__ */ jsx(
                      "span",
                      {
                        className: `${uploadedFileName ? "text-sm font-semibold" : ""}`,
                        children: uploadedFileName
                      }
                    ),
                    uploadedFileName && fileSize && /* @__PURE__ */ jsx("p", { className: "text-xs", children: fileSize })
                  ] })
                ]
              }
            ),
            uploadedFileName && /* @__PURE__ */ jsx(
              "span",
              {
                className: "text-[18px] text-secondary-900 hover:bg-gray-150 pt-3",
                onClick: removeFile,
                children: /* @__PURE__ */ jsx(Icon3, { name: "close", className: "flex" })
              }
            )
          ] }),
          isFileUploading && /* @__PURE__ */ jsx("span", { className: "w-4 text-green-600", children: /* @__PURE__ */ jsx(
            Spinner,
            {
              secondaryColor: "bg-green-600",
              speed: 100,
              still: void 0,
              thickness: 150
            }
          ) })
        ]
      }
    ),
    isFileError && /* @__PURE__ */ jsx("div", { className: "text-red-600 text-xs mt-2", children: isFileError })
  ] });
};
var Expandable = ({
  isExpanded,
  expandLabel,
  collapseLabel,
  onChange,
  children,
  wrapperClassName = "",
  className: className2 = "",
  iconClassName = "",
  labelClassName = "",
  suffix,
  showIcon = true
}) => /* @__PURE__ */ jsxs("div", { className: classNames67("flex flex-col", wrapperClassName), children: [
  /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-flex items-center cursor-pointer",
        className2
      ),
      onClick: () => onChange(!isExpanded),
      children: [
        showIcon && /* @__PURE__ */ jsx(
          Icon3,
          {
            name: isExpanded ? "angle-bottom" : "angle-right",
            className: classNames67("inline-flex items-center", iconClassName)
          }
        ),
        /* @__PURE__ */ jsx("div", { className: classNames67("pl-1 text-small leading-5", labelClassName), children: isExpanded ? expandLabel : collapseLabel }),
        suffix && suffix
      ]
    }
  ),
  isExpanded && children
] });
var Accordion = ({
  headerChildren,
  bodyChildren,
  iconChildren,
  headerClassName = "",
  bodyClassName = "",
  iconClassName = "",
  iconName,
  wrapperClassName = "",
  onToggle,
  disabled = false,
  open
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const toggleAccordion = useCallback(
    (toggle) => {
      if (disabled) return;
      setIsOpen(toggle);
      onToggle(toggle);
    },
    [disabled, onToggle]
  );
  useEffect(() => {
    if (typeof open === "boolean") {
      toggleAccordion(open);
    }
  }, [open]);
  return /* @__PURE__ */ jsxs("div", { className: wrapperClassName, children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "py-1 flex flex-row",
          { "cursor-pointer": !disabled },
          headerClassName
        ),
        onClick: () => toggleAccordion(!isOpen),
        children: [
          /* @__PURE__ */ jsx("div", { className: "flex flex-grow", children: headerChildren }),
          iconChildren || /* @__PURE__ */ jsx(
            Icon3,
            {
              name: iconName || (isOpen ? "angle-top" : "angle-bottom"),
              className: classNames67("text-xl", iconClassName)
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames67(bodyClassName, {
          hidden: !isOpen
        }),
        children: bodyChildren
      }
    )
  ] });
};
var Overlay = ({
  className: className2,
  isOpen = true,
  children,
  zIndex = 2e3,
  showOverlay = true
}) => {
  const classname = classNames67(
    {
      "flex justify-center items-center top-0 left-0 absolute inset-0 bg-black/30 backdrop-blur-sm overflow-y-auto h-full w-full overscroll-contain": showOverlay
    },
    className2
  );
  return isOpen ? /* @__PURE__ */ jsx("div", { "data-overlay": "true", className: classname, style: { zIndex }, children }) : /* @__PURE__ */ jsx(Fragment, {});
};
var Modal = ({
  overlayClassName,
  className: className2,
  zIndex = 2e3,
  isOpen = true,
  children,
  closeOnOutsideClick = false,
  closeOnEscape = false,
  showCloseButton = false,
  portalTarget = document.body,
  onClose,
  showOverlay = true,
  style
}) => {
  const dialogNode = useRef(null);
  const handleClose = useCallback(() => {
    onClose && onClose();
  }, [onClose]);
  const handleEscape = useCallback(
    (event) => {
      if (event.key === "Escape" && closeOnEscape) {
        handleClose();
      }
    },
    [closeOnEscape, handleClose]
  );
  const handleClickOutside = (event) => {
    event?.stopPropagation?.();
    if (event.target === dialogNode.current?.firstChild && closeOnOutsideClick) {
      handleClose();
    }
  };
  useEffect(() => {
    if (isOpen) {
      dialogNode.current?.focus();
      document.addEventListener("keydown", handleEscape);
    } else {
      document.removeEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen]);
  const animationClass = use_animated_class_default(
    "animate__animated animate__faster animate__zoomIn"
  );
  if (!isOpen) {
    return null;
  }
  return createPortal(
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "dialog",
        ref: dialogNode,
        role: "dialog",
        tabIndex: -1,
        onClick: handleClickOutside,
        children: /* @__PURE__ */ jsx(
          Overlay,
          {
            isOpen,
            className: overlayClassName,
            zIndex,
            showOverlay,
            children: /* @__PURE__ */ jsxs(
              "div",
              {
                className: classNames67(
                  "rounded p-6 bg-white shadow-modal",
                  {
                    "min-w-[430px]": !className2?.includes("min-w")
                  },
                  animationClass,
                  className2
                ),
                style,
                children: [
                  children,
                  showCloseButton && /* @__PURE__ */ jsx("div", { style: { top: "18px", right: "18px" }, className: "absolute", children: /* @__PURE__ */ jsx(
                    Icon3,
                    {
                      name: "close",
                      onClick: onClose,
                      className: "cursor-pointer text-[20px] text-secondary-500"
                    }
                  ) })
                ]
              }
            )
          }
        )
      }
    ),
    portalTarget
  );
};
var ConfirmationModal = ({
  className: className2,
  zIndex = 2e3,
  isOpen = true,
  children,
  title,
  actions = [],
  wrapperClassName,
  bodyClassName,
  IconContent,
  headerClassName,
  buttonContainerClassName,
  portalTarget = document.body,
  onClose,
  showCloseButton = false
}) => /* @__PURE__ */ jsx(
  Modal,
  {
    isOpen,
    className: className2,
    zIndex,
    portalTarget,
    closeOnEscape: true,
    closeOnOutsideClick: true,
    onClose,
    showCloseButton,
    children: /* @__PURE__ */ jsxs("div", { className: classNames67("flex items-center", wrapperClassName), children: [
      IconContent && IconContent,
      /* @__PURE__ */ jsxs("div", { className: classNames67("w-full", bodyClassName), children: [
        title && /* @__PURE__ */ jsx(
          "h3",
          {
            role: "heading",
            className: classNames67(
              "text-xl pb-4 font-semibold",
              headerClassName
            ),
            children: title
          }
        ),
        children,
        !!actions.length && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67(
              "pt-4 flex flex-row-reverse gap-2",
              buttonContainerClassName
            ),
            children: actions.map((item, idx) => /* @__PURE__ */ jsx(
              Button,
              {
                type: item.type,
                onClick: item.handler,
                className: item.classNames,
                isDisabled: item?.isDisabled || false,
                children: item.name
              },
              idx
            ))
          }
        )
      ] })
    ] })
  }
);
var DrawerItem = ({
  className: className2,
  width = 490,
  children,
  direction = "right"
}) => {
  const theme = {
    right: "animate__fadeInRight right-0",
    left: "animate__fadeInLeft left-0"
  };
  const stopDrawerItemsEventBubbling = (event) => {
    event.stopPropagation();
  };
  return /* @__PURE__ */ jsx(
    "div",
    {
      onClick: stopDrawerItemsEventBubbling,
      className: classNames67(
        "h-full fixed bg-white shadow-modal animate__animated animate__faster",
        theme[direction],
        className2
      ),
      style: isNaN(width) ? {} : { width: `${width}px` },
      children
    }
  );
};
var DrawerHeader = ({
  icon,
  title,
  className: className2,
  onClose,
  wrapperClassName = ""
}) => {
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "bg-secondary-50 grid items-center h-14 pl-8 pr-4 gap-x-2",
        wrapperClassName
      ),
      style: { gridTemplateColumns: "auto 1fr auto" },
      children: [
        /* @__PURE__ */ jsx(
          Icon3,
          {
            name: icon,
            className: classNames67("text-secondary-600 text-xl", className2)
          }
        ),
        title,
        /* @__PURE__ */ jsx("span", { onClick: onClose, children: /* @__PURE__ */ jsx(
          Icon3,
          {
            name: "close",
            className: "text-secondary-700 text-2xl font-semibold cursor-pointer"
          }
        ) })
      ]
    }
  );
};
var Drawer = ({
  overlayClassName,
  zIndex = 2e3,
  isOpen = true,
  children,
  closeOnEscape,
  closeOnOutsideClick,
  portalTarget = document.body,
  onClose,
  onOutSideClick
}) => {
  const dialogNode = useRef(document.createElement("div"));
  const [isMounted, setIsMounted] = useState(isOpen);
  const handleClose = useCallback(() => {
    setIsMounted(false);
    onClose && onClose();
  }, [onClose]);
  const handleEscape = useCallback(
    (event) => {
      if (event.key === "Escape" && closeOnEscape) {
        handleClose();
      }
    },
    [closeOnEscape, handleClose]
  );
  const stopDrawerItemsEventBubbling = (event) => {
    event?.stopPropagation();
  };
  const handleClickOutside = useCallback(
    (event) => {
      stopDrawerItemsEventBubbling(event);
      if (event.target === dialogNode.current.childNodes[0] && closeOnOutsideClick) {
        if (onOutSideClick) {
          onOutSideClick();
        } else {
          handleClose();
        }
      }
    },
    [closeOnOutsideClick, handleClose]
  );
  useEffect(() => {
    setIsMounted(isOpen);
  }, [isOpen]);
  return isMounted && createPortal(
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "dialog",
        ref: dialogNode,
        role: "dialog",
        tabIndex: -1,
        onKeyDown: handleEscape,
        onClick: handleClickOutside,
        children: /* @__PURE__ */ jsx(Overlay, { isOpen, className: overlayClassName, zIndex, children })
      }
    ),
    portalTarget
  );
};

// src/constants/aria-labels.ts
var ARIA_LABELS = {
  // Actions
  DELETE: "Delete",
  EDIT: "Edit",
  SAVE: "Save",
  CANCEL: "Cancel",
  CLOSE: "Close",
  CONFIRM: "Confirm",
  SUBMIT: "Submit",
  // Navigation
  GO_BACK: "Go back",
  GO_FORWARD: "Go forward",
  NEXT: "Next",
  PREVIOUS: "Previous",
  MOVE_UP: "Move step up",
  MOVE_DOWN: "Move step down",
  // Common UI
  SEARCH: "Search",
  FILTER: "Filter",
  SETTINGS: "Settings",
  MENU: "Menu",
  MORE_OPTIONS: "More options",
  // Export/Import
  EXPORT: "Export",
  IMPORT: "Import",
  DOWNLOAD: "Download",
  UPLOAD: "Upload",
  // Communication
  SEND: "Send",
  REPLY: "Reply",
  // Agent/Reporting
  REPORT_AGENT: "Report Agent",
  // Logs
  VIEW_LOGS: "View logs",
  // Stop actions
  STOP: "Stop"
  // Add more common labels as needed
};

// src/constants/index.ts
var EMPTY_OBJECT = Object.freeze({});

// src/utils/conversion.ts
function formatBytes(bytes, decimals = 2) {
  if (!+bytes) return "0 Bytes";
  const k = 1024;
  const dm = decimals < 0 ? 0 : decimals;
  const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return `${parseFloat((bytes / Math.pow(k, i)).toFixed(dm))} ${sizes[i]}`;
}
function formatMillisecond(millisecond) {
  return millisecond < 1e3 ? `${millisecond} MS` : `${millisecond / 1e3} S`;
}

// src/utils/misc.ts
var getOrigin = () => window.parent == window ? window.location.origin : document.referrer?.slice(0, -1);
var isStepAddon = (stepDetails) => {
  const { kibbutzPluginNlpId } = stepDetails || EMPTY_OBJECT;
  return !!kibbutzPluginNlpId;
};
var hasStepValidXpath = (stepDetails) => !!stepDetails?.testStepElements && stepDetails.testStepElements.every((element) => element?.elementType);
var isAllowedAppTypeForHighlight = (appType) => [
  "WebApplication" /* WebApplication */,
  "MobileWeb" /* MobileWeb */,
  "AndroidNative" /* AndroidNative */,
  "IOSNative" /* IOSNative */
].includes(appType);
function bindActions(actions, ...rest) {
  if (typeof actions === "object" && actions !== null) {
    const boundActions = {};
    for (const key in actions) {
      const action = actions[key];
      if (typeof action === "function") {
        boundActions[key] = function(...args) {
          return action.apply(this, args)(...rest);
        };
      }
    }
    return boundActions;
  }
  throw new Error("bindActions expects an object.");
}
var getFormattedTime = (givenDate) => {
  return givenDate.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false
  });
};
var getFormattedDate = (givenDate) => {
  return givenDate.toLocaleDateString("en-GB");
};

// src/readers/test-case-result.reader.ts
var test_case_result_reader_exports = {};
__export(test_case_result_reader_exports, {
  application: () => application,
  consolidatedVisualResult: () => consolidatedVisualResult,
  testCaseApplicationType: () => testCaseApplicationType,
  testCaseEnvResolution: () => testCaseEnvResolution
});
var application = property(
  "environmentResult.executionResult.execution.applicationVersion.application"
);
var testCaseApplicationType = property(
  "testCase.requirement.version.application.applicationType"
);
var testCaseEnvResolution = property(
  "environmentResult.environmentSettings.resolution"
);
var consolidatedVisualResult = property("consolidatedVisualResult");

// src/readers/test-case.reader.ts
var test_case_reader_exports = {};
__export(test_case_reader_exports, {
  isDataDriven: () => isDataDriven,
  testDataProfileId: () => testDataProfileId
});
var testDataProfileId = property(
  "testCaseDataDrivenCondition.testDataProfileId"
);
var isDataDriven = property("isDataDriven");

// src/readers/user-preference.reader.ts
var user_preference_reader_exports = {};
__export(user_preference_reader_exports, {
  applicationType: () => applicationType
});
var applicationType = property(
  "preference.projectPreference.selectedVersion.application.applicationType"
);
var Badge = ({
  message,
  children,
  type = "danger",
  dot = false,
  size = "lg",
  placement = "top-right",
  offsetDelta = [0, 0]
}) => {
  const ref = useRef(null);
  const badgeRef = useRef(null);
  const [parentOffset, setParentOffset] = React__default.useState([0, 0]);
  const [badgeOffset, setBadgeOffset] = React__default.useState([0, 0]);
  useEffect(() => {
    if (ref.current) {
      setParentOffset([ref.current.offsetWidth, ref.current.offsetHeight]);
    }
  }, [ref]);
  useEffect(() => {
    if (badgeRef.current) {
      setBadgeOffset([
        badgeRef.current.offsetWidth,
        badgeRef.current.offsetHeight
      ]);
    }
  }, [badgeRef]);
  const sizeClassName = {
    sm: "w-4 h-4 text-xs",
    md: "w-6 h-6 text-base",
    lg: "w-11 h-11 text-xl"
  };
  const bagClasses = {
    success: "bg-primary-500 text-white",
    warning: "bg-yellow-500 text-back",
    danger: "bg-error-500 text-white",
    info: "bg-gray-500 text-white",
    light: "bg-white text-black",
    dark: "bg-gray-900 text-white"
  };
  return /* @__PURE__ */ jsxs("div", { className: classNames67("relative inline-block"), ref, children: [
    children,
    React__default.Children.map(children, (child) => /* @__PURE__ */ jsx(
      "sup",
      {
        ref: badgeRef,
        "data-offset": badgeOffset,
        "data-parent-offset-top": parentOffset,
        style: {
          top: placement === "top-right" || placement === "top-left" ? -badgeOffset[1] / 2 + offsetDelta[0] : placement === "bottom-right" ? parentOffset[1] - badgeOffset[1] / 2 - offsetDelta[0] : parentOffset[1] - badgeOffset[1] / 2 - offsetDelta[0],
          left: placement === "top-right" ? parentOffset[0] - badgeOffset[0] / 2 - offsetDelta[1] : placement === "top-left" ? -badgeOffset[0] / 2 + offsetDelta[1] : placement === "bottom-right" ? parentOffset[0] - badgeOffset[0] / 2 - offsetDelta[1] : -badgeOffset[0] / 2 + offsetDelta[1]
        },
        className: classNames67(
          "absolute flex justify-center items-center rounded-full border ",
          sizeClassName[size],
          bagClasses[type]
        ),
        children: !dot && /* @__PURE__ */ jsx("div", { children: message })
      }
    ))
  ] });
};
var Divider = ({
  textMargin = 0,
  textPosition = "center",
  orientation = "horizontal",
  children,
  type = "solid",
  className: className2
}) => {
  const styles2 = {
    height: orientation === "horizontal" ? "1px" : "100%",
    width: orientation === "vertical" ? "1px" : "100%",
    margin: "2px 0px"
  };
  const textStyles = {
    margin: `0 ${textMargin}px`
  };
  const textClassNames = classNames67("bg-white px-1 z-10");
  if (children) {
    return /* @__PURE__ */ jsxs(
      "div",
      {
        style: styles2,
        className: classNames67(
          type === "dashed" ? "border-dashed" : type === "dotted" ? "border-dotted" : "border-solid",
          "flex",
          "items-center",
          "border-t",
          className2
        ),
        children: [
          textPosition === "left" && /* @__PURE__ */ jsx("span", { style: textStyles, className: textClassNames, children }),
          /* @__PURE__ */ jsx("div", { className: "flex-1" }),
          textPosition === "center" && /* @__PURE__ */ jsx("span", { style: textStyles, className: textClassNames, children }),
          /* @__PURE__ */ jsx("div", { className: "flex-1" }),
          textPosition === "right" && /* @__PURE__ */ jsx("span", { style: textStyles, className: textClassNames, children })
        ]
      }
    );
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: styles2,
      className: classNames67(
        type === "dashed" ? "border-dashed" : type === "dotted" ? "border-dotted" : "border-solid",
        "flex",
        "items-center",
        "border-t",
        className2
      )
    }
  );
};
var Radio = ({
  value,
  checked = false,
  disabled = false,
  children,
  className: className2 = "",
  labelTextClassName = "",
  inputClassName = "",
  onChange = (event) => {
  },
  name,
  size = "small",
  onClick,
  id
}) => {
  const sizeClass = size === "medium" ? "h-5 w-5" : size === "small" ? "h-4 w-4" : "h-6 w-6";
  const inputId = id || value;
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "label",
    {
      htmlFor: inputId,
      className: classNames67(
        "text-md flex items-center gap-x-2",
        disabled ? "cursor-not-allowed" : "cursor-pointer",
        className2
      ),
      onClick: () => {
        if (!disabled && onClick) onClick();
      },
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            id: inputId,
            type: "radio",
            value,
            disabled,
            name,
            onChange,
            checked,
            className: classNames67(
              "focus:outline-none  checked:border-transparent items-baseline form-radio checked:accent-primary-500 hover:accent-primary-500 transition duration-200 ease-in-out",
              disabled ? "cursor-not-allowed" : "cursor-pointer",
              sizeClass,
              inputClassName
            )
          }
        ),
        /* @__PURE__ */ jsx(
          "span",
          {
            className: classNames67(
              "items-baseline text-small text-unique-600",
              labelTextClassName
            ),
            children
          }
        )
      ]
    },
    inputId
  ) });
};
var RadioGroup = ({
  onChange = (e) => {
  },
  children,
  disabled = false,
  direction = "horizontal",
  name,
  className: className2 = ""
}) => {
  const radios = Children.toArray(children);
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "flex relative",
        direction === "horizontal" ? "flex-row" : "flex-col",
        disabled ? "cursor-not-allowed" : "",
        className2
      ),
      children: radios.map((radio, index) => {
        if (isValidElement(radio)) {
          return /* @__PURE__ */ createElement(
            Radio,
            {
              ...radio.props,
              name,
              disabled: disabled ? true : radio.props?.disabled,
              key: index,
              onChange
            }
          );
        } else {
          return radio;
        }
      })
    }
  );
};
var RadioGroupSearch = ({
  value,
  onSelect,
  optionsHook,
  placeholder,
  debounceTime = 500,
  prefixIcon,
  wrapperClassName = "",
  searchInputClassName = "",
  prefixIconClassName = "",
  radioGroupClassName = "",
  radioButtonClassName = "",
  searchInputContainerClassName = "",
  displayTextWrapperClassName = ""
}) => {
  const [options, setOptions] = useState([]);
  const [optionsFetching, setOptionsFetching] = useState(false);
  const [searchInputValue, setSearchInputValue] = useState(null);
  const debouncedFn = useCallback(
    debounce((inputValue) => {
      if (optionsHook) {
        setOptionsFetching(true);
        (async () => {
          const options2 = await optionsHook(inputValue);
          setOptions(options2);
          setOptionsFetching(false);
        })();
      }
    }, debounceTime),
    [optionsHook]
  );
  const handleInput = useCallback(
    (event) => {
      setSearchInputValue(event.target.value);
      debouncedFn(event.target.value);
    },
    [debouncedFn, searchInputValue]
  );
  const handleSelection = useCallback(
    (event) => {
      const selectedOption = options.find(
        (item) => item.id == event.target.value
      );
      onSelect(selectedOption);
    },
    [options]
  );
  useEffect(() => {
    debouncedFn("");
  }, []);
  return /* @__PURE__ */ jsxs("div", { className: classNames67(wrapperClassName), children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "relative flex items-center justify-center w-full",
          searchInputContainerClassName
        ),
        children: [
          prefixIcon && /* @__PURE__ */ jsx(
            Icon3,
            {
              name: prefixIcon,
              className: classNames67(
                "ml-3 text-lg text-secondary-600 absolute left-0 top-1/2 transform -translate-y-1/2 icon",
                prefixIconClassName
              )
            }
          ),
          /* @__PURE__ */ jsx(
            "input",
            {
              type: "text",
              value: searchInputValue,
              onChange: handleInput,
              placeholder,
              "aria-label": placeholder || "Search",
              className: classNames67(
                "pr-3 pl-10  py-2 flex-grow outline-none font-medium text-xs bg-secondary-50 text-secondary-700",
                searchInputClassName
              )
            }
          )
        ]
      }
    ),
    optionsHook && !optionsFetching && /* @__PURE__ */ jsx(
      RadioGroup,
      {
        className: classNames67("pl-2", radioGroupClassName),
        direction: "vertical",
        onChange: (event) => handleSelection(event),
        name: value.label,
        children: options && options.map((item, ind) => /* @__PURE__ */ jsx(
          Radio,
          {
            className: classNames67(
              "text-secondary-600 hover:text-secondary-800 mt-6",
              radioButtonClassName
            ),
            name: item.label,
            value: item.id,
            checked: value.id == item.id,
            children: /* @__PURE__ */ jsx(
              "div",
              {
                className: classNames67(
                  "flex pl-1 items-center",
                  displayTextWrapperClassName
                ),
                children: /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    className: "pl-2 inline-block",
                    value: item.label
                  }
                )
              }
            )
          },
          ind
        ))
      }
    )
  ] });
};
var Empty = ({
  description,
  className: className2,
  image,
  imageClassName,
  shouldShowImage = true,
  imageSource,
  descriptionClassName = ""
}) => /* @__PURE__ */ jsx(
  "div",
  {
    className: classNames67(
      `flex items-center justify-center h-full`,
      className2
    ),
    children: /* @__PURE__ */ jsxs("div", { className: "text-gray-500 text-center flex flex-col items-center", children: [
      shouldShowImage && (image ? image : /* @__PURE__ */ jsx(
        "img",
        {
          src: imageSource,
          className: classNames67("empty-illustration", imageClassName),
          alt: "Empty state illustration"
        }
      )),
      description && /* @__PURE__ */ jsx("div", { className: classNames67("text-lg mt-2", descriptionClassName), children: description })
    ] })
  }
);
var ShimmerLoader = ({
  type = "line",
  className: className2 = "",
  size = "lg"
}) => {
  const circleSizeClassName = {
    xs: "w-4 h-4",
    sm: "w-8 h-8",
    md: "w-16 h-16",
    lg: "w-32 h-32"
  };
  if (type === "circle") {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames67(
          "flex items-center justify-center h-full",
          className2
        ),
        children: /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67(
              `relative shimmer-circle animate-shimmer rounded-full bg-gray-300`,
              circleSizeClassName[size]
            )
          }
        )
      }
    );
  } else {
    return /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames67(
          "shimmer-line h-6 bg-gray-300 rounded-sm animate-shimmer",
          className2
        )
      }
    );
  }
};
var ShimmerCardTileLoader = ({ count = 1, cardClassName }) => {
  const items2 = [];
  for (let i = 0; i < count; i++) {
    items2.push(
      /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames67(
            "border border-secondary-100 flex h-full items-center justify-center p-2 rounded-md mb-4",
            cardClassName
          ),
          children: /* @__PURE__ */ jsxs("div", { className: "relative w-full", children: [
            /* @__PURE__ */ jsx(ShimmerLoader, { className: "mt-1.5 w-2/3 h-2" }),
            /* @__PURE__ */ jsx(ShimmerLoader, { className: "mt-1.5 w-1/3 h-2" }),
            /* @__PURE__ */ jsx(ShimmerLoader, { className: "mt-1.5 w-1/4 h-2" })
          ] })
        },
        i
      )
    );
  }
  return /* @__PURE__ */ jsx(Fragment, { children: items2 });
};
var Video = ({
  preview,
  src,
  muted = false,
  closeOnEscape = true,
  alt = "Video preview",
  className: className2 = ""
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  useEffect(() => {
    if (closeOnEscape) {
      const handleKeyDown = (event) => {
        if (event.key === "Escape") {
          setIsModalOpen(false);
        }
      };
      window.addEventListener("keydown", handleKeyDown);
      return () => {
        window.removeEventListener("keydown", handleKeyDown);
      };
    }
  }, [closeOnEscape]);
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: `relative overflow-hidden border-secondary-100 rounded-md h-full shadow-md ${className2}`,
        children: [
          /* @__PURE__ */ jsx("img", { src: preview, alt, className: "w-full h-full opacity-50" }),
          /* @__PURE__ */ jsx("div", { className: "absolute inset-0 flex items-center justify-center", children: /* @__PURE__ */ jsx("button", { onClick: () => setIsModalOpen(true), children: /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "play-filled",
              className: "text-primary-700 text-7xl"
            }
          ) }) })
        ]
      }
    ),
    isModalOpen && /* @__PURE__ */ jsx(Modal, { isOpen: isModalOpen, children: /* @__PURE__ */ jsxs("div", { children: [
      /* @__PURE__ */ jsx(
        "button",
        {
          className: "absolute bg-gray-150 focus:outline-none focus:text-white hover:bg-black hover:text-white px-2 right-0 text-gray-500 top-0 z-[1000]",
          onClick: () => setIsModalOpen(false),
          children: "\xD7"
        }
      ),
      /* @__PURE__ */ jsx("video", { src: src.toString(), controls: true, autoPlay: true, muted })
    ] }) })
  ] });
};
var DurationFormat = ({
  milliseconds,
  format: format6 = "hh:mm:ss.SSS",
  showTooltip = true,
  className: className2,
  showEmpty = false
}) => {
  const formatMilliseconds = useCallback(
    (ms) => {
      const hours = Math.floor(ms / 36e5);
      const minutes = Math.floor(ms % 36e5 / 6e4);
      const seconds = Math.floor(ms % 6e4 / 1e3);
      const remainingMilliseconds = ms % 1e3;
      switch (format6) {
        case "hh:mm:ss.SSS":
          return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${remainingMilliseconds.toString().padStart(3, "0")}`;
        case "hh:mm:ss":
          return `${hours.toString().padStart(2, "0")}:${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        case "mm:ss.SSS":
          return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}.${remainingMilliseconds.toString().padStart(3, "0")}`;
        case "mm:ss":
          return `${minutes.toString().padStart(2, "0")}:${seconds.toString().padStart(2, "0")}`;
        default:
          return "Invalid format";
      }
    },
    [format6]
  );
  const convertMillisecondsToWords = useCallback(
    (timeInMilliseconds) => {
      const millisecondsInHour = 36e5;
      const millisecondsInMinute = 6e4;
      const millisecondsInSecond = 1e3;
      const hours = Math.floor(timeInMilliseconds / millisecondsInHour);
      timeInMilliseconds = timeInMilliseconds % millisecondsInHour;
      const minutes = Math.floor(timeInMilliseconds / millisecondsInMinute);
      timeInMilliseconds = timeInMilliseconds % millisecondsInMinute;
      const seconds = Math.floor(timeInMilliseconds / millisecondsInSecond);
      timeInMilliseconds = timeInMilliseconds % millisecondsInSecond;
      let result = "";
      if (hours > 0) {
        result += `${hours} hour${hours > 1 ? "s" : ""} `;
      }
      if (minutes > 0) {
        result += `${minutes} minute${minutes > 1 ? "s" : ""} `;
      }
      if (seconds > 0) {
        result += `${seconds} second${seconds > 1 ? "s" : ""} `;
      }
      if (timeInMilliseconds > 0) {
        result += `${timeInMilliseconds} millisecond${timeInMilliseconds > 1 ? "s" : ""} `;
      }
      return result.trim();
    },
    []
  );
  const formattedString = useMemo(() => {
    return formatMilliseconds(milliseconds);
  }, [formatMilliseconds, milliseconds]);
  const tooltipContent = useMemo(() => {
    return convertMillisecondsToWords(milliseconds);
  }, [convertMillisecondsToWords, milliseconds]);
  if (showEmpty && !milliseconds) {
    return null;
  }
  if (showTooltip && tooltipContent?.trim())
    return /* @__PURE__ */ jsx("span", { className: classNames67("inline-block", className2), children: /* @__PURE__ */ jsx(ToolTip, { content: tooltipContent, align: "center", children: formattedString }) });
  else return /* @__PURE__ */ jsx("span", { className: "inline-block", children: formattedString });
};

// src/utils/timer.ts
var calculateTime = (startTime, endTime) => {
  if (endTime) {
    return endTime.getTime() - (/* @__PURE__ */ new Date()).getTime();
  }
  return (/* @__PURE__ */ new Date()).getTime() - startTime.getTime();
};
var Timer = ({
  startTime = /* @__PURE__ */ new Date(),
  endTime,
  showTooltip = true,
  onTimerEnd,
  format: format6 = endTime ? "mm:ss" : "hh:mm:ss"
}) => {
  const [elapsedTime, setElapsedTime] = useState(() => calculateTime(startTime, endTime));
  useEffect(() => {
    const interval = setInterval(() => {
      const updatedTime = calculateTime(startTime, endTime);
      if (endTime && updatedTime <= 0) {
        clearInterval(interval);
        setElapsedTime(0);
        if (onTimerEnd) {
          onTimerEnd();
        }
      } else {
        setElapsedTime(updatedTime);
      }
    }, 500);
    return () => clearInterval(interval);
  }, [startTime, endTime, onTimerEnd]);
  return /* @__PURE__ */ jsx(
    DurationFormat,
    {
      milliseconds: elapsedTime,
      format: format6,
      showTooltip
    }
  );
};
var ChipOption = ({
  value,
  onSelect,
  addButton
}) => /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, onClick: () => onSelect(value), children: /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
  value.displayText,
  " ",
  addButton
] }) });
var offsetModifier3 = [
  {
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }
];
var ChipInput = ({
  debounceTime = 500,
  optionsHook,
  value = [],
  onAdd,
  onRemove = NOOP,
  triggerKey = "Enter",
  placeholder = "",
  className: className2 = "",
  LoadingContent = "",
  chipsBoxWrapperClassName = "",
  addNewPlacement = "End",
  placement = "bottom-end",
  emptyMessage = "",
  addNewOnBlur = false,
  showAddNew = true,
  addNewButton = /* @__PURE__ */ jsxs(Button, { type: "primary", size: "sm", children: [
    " ",
    "+ Add"
  ] }),
  variant = "select-fill",
  isReadOnly,
  label,
  labelClassName,
  inputClassName,
  showNoMatchItem = true,
  validationType,
  disableOnRemove = false,
  schemaRules,
  isOptionsFetching = false,
  loadedOptions = [],
  onSearch
}) => {
  const [inputValue, setInputValue] = useState("");
  const [focused, setFocused] = useState(false);
  const [chips, setChips] = useState(value);
  const inputRef = useRef(null);
  const [options, setOptions] = useState(loadedOptions);
  const [showOptionsDropdown, setShowOptionsDropdown] = useState(false);
  const [optionsFetching, setOptionsFetching] = useState(
    Boolean(isOptionsFetching)
  );
  const [showAllChips, setShowAllChips] = useState(
    isReadOnly ? false : true
  );
  const [dropdownRef, setDropdownRef] = useState(null);
  const [btnRef, setBtnRef] = useState(null);
  const [errorText, setErrorText] = useState(null);
  const [maxHeight, setMaxHeight] = useState("auto");
  const { styles: styles2, attributes } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: "fixed",
    modifiers: offsetModifier3
  });
  const style = {
    ...styles2.popper || {},
    ...btnRef ? { width: btnRef.offsetWidth } : {},
    ...maxHeight ? { maxHeight } : {}
  };
  function getScrollableParent(element) {
    let parent = element.parentElement;
    while (parent) {
      const overflowY = window.getComputedStyle(parent).overflowY;
      if (overflowY === "auto" || overflowY === "scroll") {
        return parent;
      }
      parent = parent.parentElement;
    }
    return window;
  }
  useEffect(() => {
    if (showOptionsDropdown && inputRef?.current) {
      const inputElement = inputRef.current;
      const dropdownRect = inputElement.getBoundingClientRect();
      const scrollParent = getScrollableParent(inputElement);
      let visibleSpaceBelow;
      if (scrollParent === window) {
        visibleSpaceBelow = window.innerHeight - dropdownRect.bottom;
      } else {
        const parentRect = scrollParent.getBoundingClientRect();
        visibleSpaceBelow = parentRect.bottom - dropdownRect.bottom;
      }
      const maxHeight2 = Math.max(0, visibleSpaceBelow);
      setMaxHeight(`${maxHeight2}px`);
    }
  }, [showOptionsDropdown, inputRef?.current]);
  useEffect(() => {
    const updateStates = () => {
      if (isOptionsFetching !== optionsFetching) {
        setOptionsFetching(isOptionsFetching);
      }
      if (loadedOptions !== options) {
        setOptions(loadedOptions);
      }
    };
    updateStates();
  }, [isOptionsFetching, JSON.stringify(loadedOptions)]);
  useEffect(() => {
    const trimmedChips = value.map((item) => ({
      ...item,
      displayText: item.displayText.trim()
    }));
    setChips(trimmedChips);
  }, [value]);
  const fetchOptions = async (inputValue2) => {
    if (onSearch) {
      const result = await onSearch(inputValue2);
      if (result) {
        setOptions(result);
      }
      setShowOptionsDropdown(true);
    }
    if (optionsHook) {
      setOptionsFetching(true);
      (async () => {
        const options2 = await optionsHook(inputValue2);
        setOptionsFetching(false);
        if (!(typeof options2 === "boolean")) {
          setOptions(options2);
          setShowOptionsDropdown(true);
        }
      })();
    }
  };
  const schemaKey = "chipInput";
  const schema = useMemo(
    () => schemaRules ? yup.object().shape({
      [schemaKey]: schemaRules
    }) : void 0,
    [schemaRules]
  );
  const debouncedSearch = useCallback(debounce(fetchOptions, debounceTime), [
    onAdd,
    optionsHook,
    onSearch
  ]);
  const debouncedRemove = useCallback(debounce(onRemove, debounceTime), [
    onRemove
  ]);
  const isDuplicate = useMemo(() => {
    return options?.some(
      (item) => item.displayText.toLowerCase() === inputValue?.trim()?.toLowerCase()
    );
  }, [inputValue, options]);
  const validateSchema = (input) => {
    if (!schema) {
      return true;
    }
    const schemaInput = { [schemaKey]: input };
    try {
      schema.validateSync(schemaInput);
      setErrorText(null);
      return true;
    } catch (err) {
      setErrorText(err?.message);
      return false;
    }
  };
  const isInputValid = (chipToAdd) => {
    if (errorText || !chipToAdd.displayText || !validateSchema(chipToAdd.displayText)) {
      return false;
    }
    switch (validationType) {
      case "email":
        return validateEmail(chipToAdd.displayText);
      case "testDataIdentifierFilter":
        if (["*|", "$|", "$||", "*||"].includes(chipToAdd?.displayText?.trim())) {
          setInputValue("");
          return false;
        }
      default:
        return true;
    }
  };
  const handleAdd = useCallback(
    (chipToAdd) => {
      if (chipToAdd && isInputValid(chipToAdd)) {
        if (!chips.find(
          (chip) => chip.id === chipToAdd.id || chip.displayText.toLowerCase() === chipToAdd.displayText.toLowerCase()
        )) {
          chips.push(chipToAdd);
          onAdd && onAdd(chipToAdd);
        }
        setInputValue("");
        setChips(chips);
        setOptions([]);
      }
    },
    [chips, setChips, onAdd]
  );
  const handleDelete = useCallback(
    (chipToDelete) => {
      onRemove && debouncedRemove(chipToDelete);
      setChips(chips.filter((chip) => chip !== chipToDelete));
      inputRef.current.focus();
    },
    [chips, setChips, inputValue, onRemove]
  );
  const handleKeyPress = useCallback(
    (event) => {
      if (showAddNew && event.key === triggerKey) {
        handleAdd({ id: inputValue, displayText: inputValue.trim() });
        event.preventDefault();
      } else if ((event.key === "Backspace" || event.key === "Delete") && inputValue === "" && value.length) {
        handleDelete(chips[chips.length - 1]);
      }
    },
    [chips, handleAdd, inputValue, setChips, handleDelete, showAddNew]
  );
  const handleInput = (event) => {
    const val = event.target.value;
    setInputValue(val);
    debouncedSearch(val);
    validateSchema(val);
  };
  const handleSelection = useCallback(
    (selectedOption) => {
      handleAdd(selectedOption);
      inputRef.current.focus();
    },
    [showOptionsDropdown, handleAdd, setShowOptionsDropdown]
  );
  const handleInputBlur = useCallback(
    (event) => {
      setFocused(false);
      if (addNewOnBlur) {
        const value2 = event.target?.value?.trim?.();
        if (value2) {
          handleAdd({ id: value2, displayText: value2.trim() });
        }
      }
    },
    [addNewOnBlur, setFocused, handleAdd]
  );
  const handleInputFocus = useCallback(() => {
    setFocused(true);
    debouncedSearch(inputValue);
  }, [inputValue, debouncedSearch, setFocused]);
  const handleOutsideClick = (event) => {
    if (!btnRef?.contains(event?.composedPath()?.[0])) {
      setShowOptionsDropdown(false);
    }
  };
  const handlePaste = (event) => {
    event.preventDefault();
    const pastedValue = inputValue + event.clipboardData.getData("text");
    setInputValue(pastedValue);
    const newChip = { id: pastedValue, displayText: pastedValue };
    handleAdd(newChip);
  };
  const padding = {
    "select-fill": "px-3 py-1.5",
    "select-fill-plain": "px-3 py-1.5",
    "no-bg": ""
  };
  const bgShowDropDown = {
    "select-fill": "border border-primary-300 bg-white",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50",
    "no-bg": "text-primary-500"
  };
  const bgDropDown = {
    "select-fill": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "no-bg": "text-primary-500"
  };
  const chipIds = useMemo(() => chips.map((chip) => chip.id), [chips]);
  const remainingOptions = useMemo(
    () => options.filter((option) => !chipIds.includes(option.id)),
    [options, chipIds]
  );
  const isChipsContainsValue = useMemo(() => {
    const inputValueChips = chips.some(
      (item) => item.displayText.toLowerCase().trim() === inputValue.toLowerCase().trim()
    );
    return !!inputValueChips;
  }, [chips, inputValue]);
  return /* @__PURE__ */ jsxs("div", { className: classNames67("relative w-full", className2), children: [
    label && /* @__PURE__ */ jsx(
      "div",
      {
        className: classNames67(
          "text-secondary-500 text-xs font-medium p-1",
          labelClassName
        ),
        children: label
      }
    ),
    /* @__PURE__ */ jsxs("div", { className: classNames67("flex flex-wrap w-full"), children: [
      /* @__PURE__ */ jsxs(
        "div",
        {
          ref: setBtnRef,
          className: classNames67(
            "animate flex flex-wrap items-center px-2 relative w-full text-base overflow-hidden rounded gap-2",
            { [bgShowDropDown[variant]]: focused },
            { [bgDropDown[variant]]: !focused },
            padding[variant],
            chipsBoxWrapperClassName
          ),
          children: [
            chips.map((chip, index) => {
              if (!showAllChips && index > 1) return null;
              return /* @__PURE__ */ jsxs(
                Label,
                {
                  className: "relative rounded bg-white border border-secondary-200  overflow-hidden break-all h-fit",
                  children: [
                    /* @__PURE__ */ jsx("span", { className: " px-1.5 text-xs leading-3 font-semibold text-secondary-700", children: chip.displayText }),
                    !isReadOnly && /* @__PURE__ */ jsx(
                      Icon3,
                      {
                        name: "close",
                        "data-testid": `remove-button-${index}`,
                        className: classNames67(
                          "cursor-pointer text-base leading-4 text-secondary-600 hover:bg-error-100 hover:text-error-600 h-full w-6 flex items-center justify-center",
                          { "!opacity-50 !cursor-not-allowed": disableOnRemove }
                        ),
                        onClick: () => !isReadOnly && !disableOnRemove && handleDelete(chip)
                      }
                    )
                  ]
                },
                index
              );
            }),
            !showAllChips && !!chips?.length && /* @__PURE__ */ jsx(Label, { className: "relative cursor-pointer rounded py-1 pl-1.5 bg-white border border-secondary-200 text-xs leading-3 text-unique-600 !h-6", children: /* @__PURE__ */ jsx(
              "span",
              {
                className: " px-1.5 text-xs leading-3 font-semibold text-secondary-700",
                onClick: () => setShowAllChips(true),
                children: "..."
              }
            ) }),
            !isReadOnly ? /* @__PURE__ */ jsx(
              "input",
              {
                onPaste: handlePaste,
                ref: inputRef,
                onFocus: handleInputFocus,
                onBlur: handleInputBlur,
                type: "text",
                value: inputValue,
                onChange: handleInput,
                onKeyDown: handleKeyPress,
                placeholder,
                className: classNames67(
                  "flex-grow outline-none px-1 bg-transparent font-medium text-xs text-secondary-700",
                  inputClassName
                )
              }
            ) : !!emptyMessage && !chips?.length && /* @__PURE__ */ jsx("span", { className: "text-xs leading-6 font-semibold text-secondary-400", children: emptyMessage })
          ]
        }
      ),
      errorText && /* @__PURE__ */ jsx("div", { className: "pl-0.5 text-xs h-4 text-error-600", children: errorText }),
      !errorText && (optionsHook || onSearch) && (showOptionsDropdown || optionsFetching) && !isChipsContainsValue && /* @__PURE__ */ jsx(
        Dropdown,
        {
          className: "w-full z-[1000] py-1 max-h-64 !overflow-auto",
          setRef: setDropdownRef,
          style,
          attributes: attributes.popper,
          onToggleHandler: handleOutsideClick,
          children: /* @__PURE__ */ jsxs(Fragment, { children: [
            optionsFetching && LoadingContent,
            addNewPlacement === "Start" && showAddNew && !isDuplicate && !optionsFetching && inputValue.trim() !== "" && /* @__PURE__ */ jsx(
              ChipOption,
              {
                onSelect: handleSelection,
                value: { id: inputValue, displayText: inputValue.trim() },
                addButton: addNewButton
              }
            ),
            !optionsFetching && remainingOptions?.length ? remainingOptions.map((option, index) => /* @__PURE__ */ jsx(
              ChipOption,
              {
                onSelect: handleSelection,
                value: option,
                addButton: ""
              },
              index
            )) : inputValue.trim() && showNoMatchItem && /* @__PURE__ */ jsx(DropdownItem, { children: "No tags" }),
            addNewPlacement === "End" && showAddNew && !isDuplicate && !optionsFetching && inputValue.trim() !== "" && /* @__PURE__ */ jsx(
              ChipOption,
              {
                onSelect: handleSelection,
                value: { id: inputValue, displayText: inputValue.trim() },
                addButton: addNewButton
              }
            )
          ] })
        }
      )
    ] })
  ] });
};
var Calendar = ({
  className: className2 = "",
  onChange,
  value,
  allowPartialRange = false,
  defaultView = "year",
  formatDay,
  formatLongDate,
  formatMonth,
  formatShortWeekday,
  formatWeekday,
  formatYear,
  inputRef,
  maxDate,
  minDate,
  selectRange
}) => {
  const handleDateChange = (date, event) => {
    onChange(date, event);
  };
  return /* @__PURE__ */ jsx(
    Calendar$1,
    {
      prevLabel: /* @__PURE__ */ jsx(Icon3, { name: "angle-left" }),
      nextLabel: /* @__PURE__ */ jsx(Icon3, { name: "angle-right" }),
      allowPartialRange,
      defaultView,
      formatDay,
      formatLongDate,
      formatMonth,
      formatShortWeekday,
      formatWeekday,
      formatYear,
      inputRef,
      maxDate,
      minDate,
      selectRange,
      onChange: handleDateChange,
      value,
      className: className2
    }
  );
};
var DatePicker = (props) => {
  const [selectedDate, setSelectedDate] = useState(props.value);
  const [showCalendar, setShowCalendar] = useState(false);
  const inputRef = useRef(null);
  const calendarRef = useRef(null);
  useEffect(() => {
    inputRef.current?.addEventListener("click", () => {
      setShowCalendar(!showCalendar);
    });
    inputRef.current?.addEventListener("focus", () => {
      setShowCalendar(true);
    });
    calendarRef.current?.addEventListener("click", (e) => {
      e.stopPropagation();
    });
    return () => {
      inputRef.current?.removeEventListener("click", () => {
        setShowCalendar(!showCalendar);
      });
      inputRef.current?.removeEventListener("focus", () => {
        setShowCalendar(true);
      });
      calendarRef.current?.removeEventListener("click", (e) => {
        e.stopPropagation();
      });
    };
  }, [showCalendar, inputRef]);
  const handleDateChange = useCallback(
    (date, event) => {
      setSelectedDate(date);
      setShowCalendar(false);
      if (props.onChange) props.onChange(date, event);
    },
    [showCalendar]
  );
  return /* @__PURE__ */ jsxs("div", { className: props.containerClassName, children: [
    /* @__PURE__ */ jsx(
      "input",
      {
        onFocus: () => setShowCalendar(true),
        onClick: () => setShowCalendar(!showCalendar),
        placeholder: props.placeholder,
        value: format(selectedDate, props.dateFormat || "MMM d, yyyy"),
        onChange: NOOP,
        type: "text",
        ref: inputRef,
        className: classNames67("", props.inputRefClassName)
      }
    ),
    showCalendar && /* @__PURE__ */ jsx(
      Calendar,
      {
        ...props,
        onChange: handleDateChange,
        value: selectedDate,
        defaultView: "month",
        selectRange: false
      }
    )
  ] });
};
var offsetModifier4 = [
  {
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }
];
var DateRangePicker = (props) => {
  const {
    value,
    placement = "bottom-end",
    onChange,
    fillWidth,
    wrapperClassName,
    labelClassName,
    label,
    variant,
    disabled = false,
    className: className2,
    inputRefClassName,
    isStaticPlaceHolder,
    onFocusClassName,
    dropdownClassName,
    dropdownIconClassName = "",
    show = false,
    onCloseField,
    ...extra
  } = props;
  const [selectedDates, setSelectedDates] = useState(value);
  const [showCalendar, setShowCalendar] = useState(show);
  const [dropdownRef, setDropdownRef] = useState(null);
  const [btnRef, setBtnRef] = useState(null);
  useEffect(() => {
    setSelectedDates(value);
  }, [value, setSelectedDates]);
  const {
    styles: styles2,
    attributes,
    update: popperPositionUpdate
  } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: "fixed",
    modifiers: offsetModifier4
  });
  const onToggleDropdown = (value2) => {
    setShowCalendar(value2);
    if (!value2) {
      onCloseField && onCloseField();
    }
  };
  const handleDateChange = useCallback(
    (date, event) => {
      setSelectedDates(date);
      onToggleDropdown(false);
      if (onChange) onChange(date, event);
    },
    [setSelectedDates]
  );
  const padding = {
    "select-fill": "px-3 py-1.5",
    "select-fill-plain": "px-3 py-1.5",
    "no-bg": ""
  };
  const bgShowDropDown = {
    "select-fill": "border border-primary-300 bg-white",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50",
    "no-bg": "text-primary-500"
  };
  const bgDropDown = {
    "select-fill": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "select-fill-plain": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    "no-bg": "text-primary-500"
  };
  const style = {
    ...styles2.popper || {},
    ...btnRef ? { width: btnRef.offsetWidth } : {}
  };
  const { className: _className, ...restCalendarProps } = props;
  useEffect(() => {
    popperPositionUpdate?.();
  }, [popperPositionUpdate]);
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-block relative select-none",
        { "w-full": fillWidth },
        wrapperClassName
      ),
      children: [
        label && /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67(
              "text-secondary-500 text-xs font-medium p-1",
              labelClassName
            ),
            children: label
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: setBtnRef,
            className: classNames67(
              "rounded text-xs leading-3.5 flex items-center cursor-pointer gap-x-3",
              { [bgShowDropDown[variant]]: showCalendar },
              { [bgDropDown[variant]]: !showCalendar },
              padding[variant],
              className2,
              { [onFocusClassName]: showCalendar }
            ),
            onClick: () => onToggleDropdown(!showCalendar),
            ...extra,
            "data-isopen": showCalendar,
            children: [
              /* @__PURE__ */ jsx(
                "span",
                {
                  "data-testid": "range-picker-result-placeholder",
                  className: classNames67("truncate w-full", inputRefClassName),
                  children: Array.isArray(selectedDates) && selectedDates?.length && !isStaticPlaceHolder ? `${format(
                    selectedDates[0],
                    props.dateFormat || "MMM d, yyyy"
                  )} - ${format(
                    selectedDates[1],
                    props.dateFormat || "MMM d, yyyy"
                  )}` : props.placeholder
                }
              ),
              /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "edit-calendar",
                  className: classNames67(
                    " text-xl leading-5 text-unique-800",
                    dropdownIconClassName
                  )
                }
              )
            ]
          }
        ),
        showCalendar && /* @__PURE__ */ jsx(
          Dropdown,
          {
            className: classNames67(
              "w-full min-w-fit z-[1000]",
              dropdownClassName
            ),
            toggleDropdown: onToggleDropdown,
            setRef: setDropdownRef,
            style,
            attributes: attributes.popper,
            buttonRef: btnRef,
            children: /* @__PURE__ */ jsx(
              Calendar,
              {
                ...restCalendarProps,
                selectRange: true,
                onChange: handleDateChange,
                value: selectedDates,
                defaultView: "month"
              }
            )
          }
        )
      ]
    }
  ) });
};
var ImageViewer = ({
  src,
  lazyLoad = true,
  className: className2 = "",
  onMaximize = NOOP,
  canMaximize = true,
  enablePageFullScreen = false,
  onError = NOOP,
  onLoad = NOOP,
  imageClass = ""
}) => {
  const [isMaximized, setIsMaximized] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [imageSrc, setImageSrc] = useState(
    lazyLoad ? null : src
  );
  const imageRef = useRef(null);
  useEffect(() => {
    if (!canMaximize) return;
    const handleEscape = (event) => {
      if (event.key === "Escape") {
        setIsMaximized(false);
      }
    };
    if (isMaximized) {
      document.addEventListener("keydown", handleEscape);
    } else {
      document.removeEventListener("keydown", handleEscape);
    }
    return () => {
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isMaximized, canMaximize]);
  useEffect(() => {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting || entry.intersectionRatio >= 0) {
          setImageSrc(src);
          observer.unobserve(entry.target);
        }
      });
    });
    if (imageRef.current) {
      observer.observe(imageRef.current);
      imageRef.current.onload = () => {
        setIsLoading(false);
      };
    }
  }, [imageRef, setImageSrc, src]);
  const toggleMaximize = () => {
    if (!canMaximize) return;
    setIsMaximized(!isMaximized);
    if (!isMaximized) onMaximize();
  };
  const renderContent = () => /* @__PURE__ */ jsxs(
    "div",
    {
      "data-test-id": "image-viewer",
      className: classNames67(
        `${isMaximized && enablePageFullScreen ? "fixed inset-0 z-50" : "relative"}`,
        className2
      ),
      onClick: toggleMaximize,
      style: isMaximized && enablePageFullScreen ? { top: 0, left: 0, width: "100vw", height: "100vh", zIndex: 9999 } : {},
      children: [
        canMaximize && /* @__PURE__ */ jsx(
          "button",
          {
            className: "absolute p-2 rounded-md text-gray-500 hover:text-white focus:outline-none focus:text-white",
            onClick: toggleMaximize,
            "aria-label": isMaximized ? "Minimize image" : "Maximize image",
            children: /* @__PURE__ */ jsx(
              "svg",
              {
                className: "h-6 w-6",
                fill: "none",
                viewBox: "0 0 24 24",
                stroke: "currentColor",
                children: isMaximized ? /* @__PURE__ */ jsx(
                  "path",
                  {
                    fill: "none",
                    stroke: "currentColor",
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: "2",
                    d: "M15 19v-2a2 2 0 0 1 2-2h2M15 5v2a2 2 0 0 0 2 2h2M5 15h2a2 2 0 0 1 2 2v2M5 9h2a2 2 0 0 0 2-2V5"
                  }
                ) : /* @__PURE__ */ jsx(
                  "path",
                  {
                    strokeLinecap: "round",
                    strokeLinejoin: "round",
                    strokeWidth: 2,
                    d: "M8 3H5a2 2 0 00-2 2v3m18 0V5a2 2 0 00-2-2h-3m0 18h3a2 2 0 002-2v-3M3 16v3a2 2 0 002 2h3"
                  }
                )
              }
            )
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            className: classNames67(
              "bg-cover h-full bg-center bg-no-repeat flex justify-center items-center",
              isMaximized ? "p-10 bg-gray-800" : "bg-gray-100"
            ),
            children: [
              isLoading && /* @__PURE__ */ jsx("div", { className: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2", children: /* @__PURE__ */ jsx("div", { className: "empty-page-loader" }) }),
              /* @__PURE__ */ jsx(
                "img",
                {
                  ref: imageRef,
                  className: classNames67(
                    imageClass,
                    `${isMaximized ? "rounded-sm object-cover h-full w-full transition-all" : "transition-all"}`,
                    canMaximize ? isMaximized ? "cursor-zoom-out" : "cursor-zoom-in" : ""
                  ),
                  src: imageSrc,
                  alt: "Image viewer content",
                  style: { display: imageSrc ? "block" : "none" },
                  onError,
                  onLoad
                }
              )
            ]
          }
        )
      ]
    }
  );
  return enablePageFullScreen && isMaximized ? createPortal(renderContent(), document.body) : renderContent();
};
var InfiniteScroll = ({
  rowHeight = 20,
  className: className2,
  items: items2,
  loadMore,
  hasMore,
  LoadingComponent = /* @__PURE__ */ jsx("h1", { children: "Loading..." }),
  onLoadMoreError,
  itemRender = ({ item }) => item ? /* @__PURE__ */ jsx(Fragment, { children: item.name }) : null,
  minHeight = 64,
  isDynamicHeight = false,
  listHeight,
  overscanRowCount = 20,
  listRef,
  isDynamicHeightList = false,
  resetPage = false,
  isLoading: showLoader = false,
  rowRendererRole = "presentation",
  getItemKey
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const search = "";
  const [isLoading, setIsLoading] = useState(false);
  const [stateItems, setStateItems] = useState(items2);
  const [queryKey, setQueryKey] = useState("");
  const resolveItemKey = useCallback(
    (item, rowIndex, columnIndex = 0) => {
      if (getItemKey) {
        const customKey = getItemKey(item, rowIndex);
        if (customKey !== void 0 && customKey !== null && customKey !== "") {
          return customKey;
        }
      }
      if (item?.id !== void 0 && item?.id !== null && item?.id !== "") {
        return item.id;
      }
      return `${rowIndex}-${columnIndex}`;
    },
    [getItemKey]
  );
  const _handleScroll = useCallback(
    async ({
      clientHeight,
      scrollHeight,
      scrollTop
    }) => {
      const key = `loadmore-${items2?.length}`;
      if (hasMore && queryKey !== key && !isLoading && clientHeight && scrollHeight && scrollTop + clientHeight >= scrollHeight - 10) {
        setQueryKey(key);
        setIsLoading(true);
        try {
          loadMore(currentPage, search);
          setCurrentPage(currentPage + 1);
        } catch (err) {
          if (onLoadMoreError) {
            onLoadMoreError(err);
          }
        } finally {
          setIsLoading(false);
        }
      }
    },
    [hasMore, isLoading, items2, currentPage]
  );
  const _renderRow = ({
    index,
    key,
    style
  }) => {
    if (isDynamicHeightList) {
      List?.recomputeHeights();
      List?.forceUpdate();
    }
    const props = { item: stateItems[index], page: currentPage, search, index };
    return /* @__PURE__ */ jsxs("div", { style, role: rowRendererRole, children: [
      itemRender(props),
      isLoading ? LoadingComponent : null
    ] }, key);
  };
  const cache = useMemo(
    () => new CellMeasurerCache({
      minHeight,
      fixedWidth: true,
      keyMapper: (rowIndex, columnIndex) => {
        return resolveItemKey(stateItems[rowIndex], rowIndex, columnIndex);
      }
    }),
    [minHeight, stateItems?.length, getItemKey]
  );
  useEffect(() => {
    if (isDynamicHeight) cache?.clearAll();
  }, [stateItems, isDynamicHeight]);
  useEffect(() => {
    setStateItems(items2);
  }, [items2]);
  useEffect(() => {
    setCurrentPage(resetPage ? 1 : currentPage);
    setQueryKey("");
  }, [resetPage]);
  const dynamicRowRenderer = ({
    index,
    parent,
    style
  }) => {
    const props = {
      item: stateItems[index],
      page: currentPage,
      search,
      index
    };
    const item = stateItems[index];
    const stableKey = resolveItemKey(item, index);
    return /* @__PURE__ */ jsx(
      CellMeasurer,
      {
        cache,
        columnIndex: 0,
        parent,
        rowIndex: index,
        children: ({ measure, registerChild }) => /* @__PURE__ */ jsx(
          "div",
          {
            ref: registerChild,
            style,
            role: rowRendererRole,
            children: itemRender({ ...props, measure })
          },
          stableKey
        )
      },
      stableKey
    );
  };
  if (isDynamicHeightList)
    return /* @__PURE__ */ jsx(
      AutoSizer,
      {
        className: className2 == "step-group-list-items" ? className2 : "",
        children: ({ width, height }) => /* @__PURE__ */ jsx(
          List,
          {
            width,
            height: height || 600,
            rowCount: stateItems.length,
            rowHeight: cache.rowHeight,
            rowRenderer: dynamicRowRenderer,
            onScroll: _handleScroll,
            ref: listRef,
            overscanRowCount,
            scrollToAlignment: "center",
            deferredMeasurementCache: cache
          }
        )
      }
    );
  return /* @__PURE__ */ jsx(AutoSizer, { className: className2, children: ({ height, width }) => /* @__PURE__ */ jsxs(Fragment, { children: [
    !isDynamicHeight && /* @__PURE__ */ jsx(
      List,
      {
        width: width || 600,
        height: listHeight || height || 600,
        rowCount: stateItems.length,
        rowHeight,
        rowRenderer: _renderRow,
        onScroll: _handleScroll
      }
    ),
    isDynamicHeight && /* @__PURE__ */ jsx(
      List,
      {
        width: width || 600,
        height: listHeight || height || 600,
        rowCount: stateItems.length,
        rowHeight: cache.rowHeight,
        deferredMeasurementCache: cache,
        rowRenderer: dynamicRowRenderer,
        onScroll: _handleScroll
      }
    ),
    (isLoading || showLoader) && /* @__PURE__ */ jsx(
      "div",
      {
        style: {
          width: width || 600
        },
        children: LoadingComponent
      }
    )
  ] }) });
};

// src/infinite-scroll-v2/index.tsx
var infinite_scroll_v2_exports = {};
__export(infinite_scroll_v2_exports, {
  InfiniteLoaderBasic: () => InfiniteLoaderBasic_default,
  VirtualizedInfiniteLoader: () => VirtualizedInfiniteLoader_default
});
var DEFAULT_SCROLL_DEBOUNCE_DELAY = 50;
var DEFAULT_VERTICAL_SCROLL_THRESHOLD = 1e3;
var InfiniteLoaderBasic = ({
  verticalScrollThreshold = DEFAULT_VERTICAL_SCROLL_THRESHOLD,
  scrollDebounceDelay = DEFAULT_SCROLL_DEBOUNCE_DELAY,
  isLoading = false,
  hasMore = false,
  containerClassName = "",
  handleScroll = noop,
  loadMore = noop,
  children
}) => {
  const containerRef = useRef(null);
  const onScroll = debounce(() => {
    if (handleScroll) handleScroll();
    const scrollPosY = containerRef.current.scrollHeight - containerRef.current.scrollTop;
    if (isLoading || scrollPosY > verticalScrollThreshold || !hasMore) return;
    loadMore();
  }, scrollDebounceDelay);
  return /* @__PURE__ */ jsx("div", { className: containerClassName, ref: containerRef, onScroll, children });
};
var InfiniteLoaderBasic_default = InfiniteLoaderBasic;
var VirtualizedInfiniteLoader = ({
  LoadingComponent = /* @__PURE__ */ jsx("div", { children: "Loading..." }),
  className: className2 = "",
  rowHeight = 20,
  minHeight = 64,
  listHeight,
  overscanRowCount = 20,
  listRef,
  isDynamicHeightList,
  toggleToCalculateHeight,
  loadMore,
  hasMore,
  isLoading,
  rowCount,
  rowRenderer,
  items: items2,
  resetPage = false,
  totalPages,
  scrollToIndex,
  noResultsComponent,
  disableHeight = false,
  rowRendererRole = "presentation"
}) => {
  const _rowCount = hasMore ? rowCount + 1 : rowCount;
  const [stateItems, setStateItems] = useState(items2);
  const [currentPage, setCurrentPage] = useState(0);
  const [queryKey, setQueryKey] = useState("");
  const _loadMoreRows = isLoading ? noop : (page) => {
    loadMore(currentPage + 1);
    setCurrentPage(currentPage + 1);
  };
  const _isRowLoaded = ({ index }) => !hasMore || index < rowCount;
  const cache = useMemo(
    () => new CellMeasurerCache({
      minHeight,
      fixedWidth: true
    }),
    [minHeight]
  );
  useEffect(() => {
    if (isDynamicHeightList) cache?.clearAll();
  }, [cache, isDynamicHeightList, toggleToCalculateHeight]);
  useEffect(() => {
    setStateItems(items2);
  }, [items2]);
  useEffect(() => {
    if (resetPage) {
      setCurrentPage(0);
      setQueryKey("");
    }
  }, [resetPage]);
  const _handleScroll = useCallback(
    async ({ clientHeight, scrollHeight, scrollTop }) => {
      const key = `loadmore-${items2?.length}`;
      if (hasMore && queryKey !== key && !isLoading && clientHeight && scrollHeight && scrollTop && scrollTop + clientHeight >= scrollHeight - 10 && currentPage < totalPages - 1) {
        setQueryKey(key);
        try {
          await _loadMoreRows(currentPage + 1);
          setCurrentPage(currentPage + 1);
        } catch (err) {
          console.error(err);
        }
      }
    },
    [hasMore, isLoading, stateItems, items2, currentPage, queryKey]
  );
  const _rowRenderer = ({ index, key, style, parent }) => {
    let content;
    if (!_isRowLoaded({ index })) {
      content = isLoading ? LoadingComponent : /* @__PURE__ */ jsx(Fragment, {});
    } else if (isDynamicHeightList) {
      content = /* @__PURE__ */ jsx(
        CellMeasurer,
        {
          cache,
          columnIndex: 0,
          parent,
          rowIndex: index,
          children: ({ measure, registerChild }) => /* @__PURE__ */ jsx("div", { ref: registerChild, role: rowRendererRole, children: rowRenderer(index, { measure }) }, key)
        },
        key
      );
    } else {
      content = rowRenderer(index);
    }
    return /* @__PURE__ */ jsx("div", { style, role: rowRendererRole, children: content }, key);
  };
  if (!isLoading && rowCount === 0 && noResultsComponent) {
    return noResultsComponent;
  }
  return /* @__PURE__ */ jsx(
    InfiniteLoader,
    {
      isRowLoaded: _isRowLoaded,
      loadMoreRows: _loadMoreRows,
      rowCount: _rowCount,
      children: ({ onRowsRendered, registerChild }) => /* @__PURE__ */ jsx(AutoSizer, { className: className2, disableHeight, children: ({ height, width }) => {
        const props = {
          overscanRowCount,
          ref: listRef || registerChild,
          onRowsRendered,
          width: width || 600,
          height: listHeight || height || 600,
          rowCount: _rowCount,
          rowRenderer: _rowRenderer,
          rowHeight,
          ...scrollToIndex !== null && { scrollToIndex },
          ...isDynamicHeightList && {
            rowHeight: cache.rowHeight,
            overscanRowCount,
            scrollToAlignment: "center",
            deferredMeasurementCache: cache
          }
        };
        return /* @__PURE__ */ jsx(List, { ...props, onScroll: _handleScroll });
      } })
    }
  );
};
var VirtualizedInfiniteLoader_default = VirtualizedInfiniteLoader;
var PaginationButton = ({
  children,
  type,
  onClick,
  className: className2,
  disabled = false,
  isActive = false
}) => {
  const btnClassNames = {
    circle: "rounded-full px-4",
    square: "rounded px-4"
  };
  const activeStateClassNames = {
    active: "bg-primary-500 text-white hover:bg-primary-500",
    "in-active": "bg-gray-100 text-gray-900 hover:bg-gray-200"
  };
  return /* @__PURE__ */ jsx(
    "button",
    {
      className: classNames67(
        isActive ? activeStateClassNames["active"] : activeStateClassNames["in-active"],
        "py-2 flex items-center",
        disabled && "cursor-not-allowed",
        btnClassNames[type],
        className2
      ),
      onClick,
      disabled,
      children
    }
  );
};
var SimplePagination = ({
  totalPages,
  onPage,
  type = "square"
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
    onPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
    onPage(currentPage - 1);
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-center", children: [
    /* @__PURE__ */ jsx(
      PaginationButton,
      {
        type,
        className: `${currentPage !== 1 && "hover:bg-gray-200"} ${type === "square" ? "rounded-r-none" : "px-2"}`,
        onClick: handlePrevious,
        disabled: currentPage === 1,
        children: /* @__PURE__ */ jsx(Icon3, { name: "arrow-backward" })
      }
    ),
    /* @__PURE__ */ jsx(
      PaginationButton,
      {
        type,
        className: `${currentPage === totalPages && "hover:bg-gray-200"} ${type === "square" ? "rounded-l-none" : "px-2"}`,
        onClick: handleNext,
        disabled: currentPage === totalPages,
        children: /* @__PURE__ */ jsx(Icon3, { name: "arrow-forward" })
      }
    )
  ] });
};
var FullPagination = ({
  totalPages,
  onPage,
  type = "circle"
}) => {
  const [currentPage, setCurrentPage] = useState(1);
  const handleNext = () => {
    setCurrentPage(currentPage + 1);
    onPage(currentPage + 1);
  };
  const handlePrevious = () => {
    setCurrentPage(currentPage - 1);
    onPage(currentPage - 1);
  };
  const handlePage = (page) => {
    setCurrentPage(page);
    onPage(page);
  };
  const pages = [];
  for (let i = 1; i <= totalPages; i++) {
    pages.push(i);
  }
  let visiblePages;
  if (currentPage > 4 && currentPage < totalPages - 2) {
    visiblePages = [
      1,
      "...",
      currentPage - 1,
      currentPage,
      currentPage + 1,
      "...",
      totalPages
    ];
  } else if (currentPage <= 4) {
    visiblePages = [...pages.slice(0, 5), "...", totalPages];
  } else if (currentPage >= totalPages - 2) {
    visiblePages = [1, "...", ...pages.slice(-5)];
  }
  const numberButtonClassNames = {
    circle: "py-2 px-4 rounded-full ml-2",
    squared: "py-2 px-4"
  };
  return /* @__PURE__ */ jsxs("div", { className: "flex justify-center", children: [
    /* @__PURE__ */ jsx(
      PaginationButton,
      {
        type,
        className: `${currentPage !== 1 && "hover:bg-gray-200"} ${type === "square" && "rounded-r-none"} px-3`,
        onClick: handlePrevious,
        disabled: currentPage === 1,
        children: /* @__PURE__ */ jsx(Icon3, { name: "arrow-backward" })
      }
    ),
    visiblePages.map((number, index) => /* @__PURE__ */ jsx(
      PaginationButton,
      {
        type,
        isActive: currentPage === number,
        className: classNames67(
          type === "square" && "rounded-none",
          numberButtonClassNames[type],
          typeof number !== "string" && currentPage === number ? "hover:bg-primary-500" : "hover:bg-gray-200"
        ),
        onClick: () => handlePage(number),
        disabled: typeof number === "string",
        children: number
      },
      index
    )),
    /* @__PURE__ */ jsx(
      PaginationButton,
      {
        type,
        className: `${currentPage === totalPages && "hover:bg-gray-200"} ${type === "square" ? "rounded-l-none" : "ml-2"} px-3`,
        onClick: handleNext,
        disabled: currentPage === totalPages,
        children: /* @__PURE__ */ jsx(Icon3, { name: "arrow-forward" })
      }
    )
  ] });
};
var AutoCompleteOption = ({
  value,
  onSelect,
  CustomItemWrapper = null
}) => /* @__PURE__ */ jsx(
  DropdownItem,
  {
    isSelected: false,
    className: `${value.disabled && "cursor-not-allowed"}`,
    onClick: () => onSelect(value),
    children: /* @__PURE__ */ jsx("div", { className: "w-full", children: CustomItemWrapper ? /* @__PURE__ */ jsx(CustomItemWrapper, { value }) : value.label })
  }
);
var AutoComplete = ({
  debounceTime = 300,
  optionsHook,
  value,
  onSelect,
  placeholder = "",
  className: className2 = "",
  LoadingContent = "",
  emptyContent = "",
  variant = "none",
  CustomItemWrapper = null,
  label = "",
  labelClassName = "",
  isRequired = false,
  dropdownClass,
  showClearButton = true,
  inputContainerClassName = "",
  inputClassName = "",
  prefixIcon = "",
  prefixIconClassName = "",
  showPrefixAvatar = false,
  prefixAvatarClassName = "",
  optionLimit = void 0,
  onShowFullList,
  onClear = NOOP,
  errorText,
  selectOnClickOutside = false,
  showSearchOnDropdown = false,
  disabled = false,
  src = "",
  optionsFooter
}) => {
  const { t } = useTranslation();
  const ref = useRef(null);
  const [inputValue, setInputValue] = useState(
    !showSearchOnDropdown ? value?.label : ""
  );
  const [focused, setFocused] = useState(false);
  const inputRef = useRef(null);
  const [options, setOptions] = useState([]);
  const [showOptionsDropdown, setShowOptionsDropdown] = useState(false);
  const [optionsFetching, setOptionsFetching] = useState(false);
  const debouncedFn = useCallback(
    debounce((inputValue2 = "") => {
      if (optionsHook) {
        setOptionsFetching(true);
        (async () => {
          const options2 = await optionsHook(inputValue2);
          setOptions(options2);
          setShowOptionsDropdown(true);
          setOptionsFetching(false);
        })();
      }
    }, debounceTime),
    [inputValue, showOptionsDropdown, optionsHook]
  );
  const onArrowIconClick = () => {
    if (!showOptionsDropdown) {
      debouncedFn();
    } else {
      setShowOptionsDropdown(!showOptionsDropdown);
    }
  };
  const handleInput = useCallback(
    (event) => {
      setInputValue(event.target.value);
      debouncedFn(event.target.value);
    },
    [debouncedFn]
  );
  const handleKeyDown = useCallback(
    (event) => {
      if (event?.keyCode === 13) {
        event?.preventDefault();
        event?.preventDefault();
        if (options?.length === 1) {
          handleSelection(options[0]);
        }
      }
    },
    [options]
  );
  const handleSelection = useCallback(
    (selectedOption) => {
      onSelect?.(selectedOption);
      setShowOptionsDropdown(false);
      setInputValue(!showSearchOnDropdown ? selectedOption?.label : "");
    },
    [showOptionsDropdown, inputValue, showSearchOnDropdown]
  );
  const handleInputBlur = (event) => {
    setFocused(false);
  };
  useEffect(() => {
    if (!showOptionsDropdown && showSearchOnDropdown) {
      setInputValue("");
    }
  }, [showOptionsDropdown]);
  const handleClear = useCallback(() => {
    setInputValue("");
    inputRef.current.focus();
    debouncedFn();
    onClear();
  }, [inputValue, inputRef, onClear, debouncedFn]);
  const bgShowOptions = {
    "select-fill": "border border-primary-300 bg-white text-secondary-800",
    none: "bg-white"
  };
  const bgHideOptions = {
    "select-fill": "border border-secondary-50 bg-secondary-50 text-secondary-800",
    none: "bg-white"
  };
  use_click_outside_default(ref, () => {
    if (showOptionsDropdown && selectOnClickOutside && Boolean(options?.length)) {
      if (!inputValue) {
        handleSelection(null);
      } else {
        handleSelection(options[0]);
      }
    }
    setShowOptionsDropdown(false);
  });
  useEffect(() => {
    setInputValue(!showSearchOnDropdown ? value?.label : "");
  }, [value]);
  const handleDropDownClick = () => {
    if (showSearchOnDropdown && !disabled) {
      if (showOptionsDropdown) {
        setShowOptionsDropdown(false);
      } else {
        debouncedFn();
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: classNames67("relative w-full", className2), children: [
    label && /* @__PURE__ */ jsxs(
      "div",
      {
        className: classNames67(
          "text-secondary-500 text-xs font-medium p-1",
          labelClassName
        ),
        children: [
          label,
          isRequired && /* @__PURE__ */ jsx("span", { className: "text-error-500 ml-1", children: "*" })
        ]
      }
    ),
    /* @__PURE__ */ jsxs(
      "div",
      {
        className: "flex flex-wrap w-full",
        ref: (el) => {
          ref.current = el;
        },
        children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: classNames67(
                "animate flex flex-wrap items-center relative w-full rounded overflow-hidden px-3 py-1 h-9",
                { [bgShowOptions[variant]]: showOptionsDropdown },
                { [bgHideOptions[variant]]: !showOptionsDropdown },
                { "cursor-pointer": showSearchOnDropdown },
                inputContainerClassName
              ),
              onClick: handleDropDownClick,
              children: /* @__PURE__ */ jsxs("div", { className: "flex items-center justify-center w-full", children: [
                prefixIcon && /* @__PURE__ */ jsx(
                  Icon3,
                  {
                    name: prefixIcon,
                    className: classNames67(
                      "ml-3 text-xl text-secondary-600 absolute left-0 top-1/2 transform -translate-y-1/2 icon",
                      prefixIconClassName
                    )
                  }
                ),
                showPrefixAvatar && value?.label && /* @__PURE__ */ jsx(
                  Avatar,
                  {
                    alt: value.label,
                    shape: "circle",
                    size: "xs",
                    className: classNames67(
                      "ml-3 absolute left-0 top-1/2 transform -translate-y-1/2",
                      prefixAvatarClassName
                    ),
                    src
                  }
                ),
                !showSearchOnDropdown && !disabled ? /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
                  "input",
                  {
                    ref: inputRef,
                    onFocus: () => {
                      setFocused(true);
                      debouncedFn();
                    },
                    onBlur: handleInputBlur,
                    type: "text",
                    value: inputValue,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    placeholder,
                    className: classNames67(
                      "flex-grow outline-none bg-transparent font-medium text-xs text-secondary-700",
                      inputClassName
                    ),
                    onClick: () => setShowOptionsDropdown(!showOptionsDropdown)
                  }
                ) }) : /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    "data-testid": "static-value-placeholder",
                    className: classNames67(
                      "font-medium text-xs",
                      { "text-secondary-700": value?.label },
                      { "text-secondary-500": !value?.label },
                      inputClassName
                    ),
                    value: value?.label || placeholder
                  }
                ),
                /* @__PURE__ */ jsxs("div", { className: "right-6 inline-flex items-center", children: [
                  !showSearchOnDropdown && !disabled && showClearButton && inputValue && /* @__PURE__ */ jsx(
                    Icon3,
                    {
                      onClick: handleClear,
                      name: "close",
                      className: "hover:text-secondary-800 cursor-pointer text-lg mr-2 icon",
                      "data-testid": "dropdown-clear"
                    }
                  ),
                  /* @__PURE__ */ jsx(
                    Icon3,
                    {
                      onClick: !disabled ? onArrowIconClick : NOOP,
                      name: "angle-bottom",
                      className: classNames67(
                        "hover:text-secondary-800 cursor-pointer text-lg icon",
                        { "rotate-180": showOptionsDropdown }
                      ),
                      "data-testid": "dropdown-arrow"
                    }
                  )
                ] })
              ] })
            }
          ),
          errorText && /* @__PURE__ */ jsx("div", { className: "pl-0.5 text-xs h-4 text-error-600", children: errorText }),
          optionsHook && (showOptionsDropdown || optionsFetching) && /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsx(
            Dropdown,
            {
              className: classNames67("absolute mt-9 w-full", dropdownClass, {
                "bg-white border-error-300": !!errorText
              }),
              children: /* @__PURE__ */ jsxs(Fragment, { children: [
                showSearchOnDropdown && /* @__PURE__ */ jsx("div", { className: "w-full flex border-b border-secondary-100 sticky top-0", children: /* @__PURE__ */ jsx(
                  "input",
                  {
                    ref: inputRef,
                    onFocus: () => {
                      setFocused(true);
                    },
                    onBlur: handleInputBlur,
                    type: "text",
                    value: inputValue,
                    onChange: handleInput,
                    onKeyDown: handleKeyDown,
                    placeholder,
                    className: "flex-grow outline-none font-medium text-xs text-secondary-700 px-3 py-2"
                  }
                ) }),
                optionsFetching && (LoadingContent || /* @__PURE__ */ jsx(DropdownItem, { isSelected: false, children: t("common.loading") })),
                !optionsFetching && /* @__PURE__ */ jsxs(Fragment, { children: [
                  options.slice(0, optionLimit).map((option, index) => /* @__PURE__ */ jsx(
                    AutoCompleteOption,
                    {
                      onSelect: handleSelection,
                      value: option,
                      CustomItemWrapper
                    },
                    index
                  )),
                  options.length > optionLimit && /* @__PURE__ */ jsx(
                    "div",
                    {
                      className: "px-4 py-3 text-primary-600 font-semibold text-small leading-5 border-secondary-200 border border-x-0 border-b-0 absolute bottom-0 w-full cursor-pointer",
                      onClick: onShowFullList,
                      children: "See full list"
                    }
                  ),
                  !options.length && emptyContent
                ] }),
                !!optionsFooter && /* @__PURE__ */ jsxs("div", { className: "w-full overflow-hidden sticky bottom-0 py-2 bg-white", children: [
                  /* @__PURE__ */ jsx(Divider, { type: "solid", className: "pb-2" }),
                  optionsFooter
                ] })
              ] })
            }
          ) })
        ]
      }
    )
  ] });
};
var Column = ({ children, className: className2, width, role }) => {
  const styles2 = {
    flex: `0 0 ${width}%`,
    maxWidth: `${width}%`
  };
  return /* @__PURE__ */ jsx("div", { style: styles2, className: className2, "data-testid": "layout-column", role, children });
};
var column_default = Column;
var SortLabel = ({
  label,
  direction,
  isSortSelected,
  onClick,
  ascendingTooltip = "",
  descendingTooltip = ""
}) => {
  const onToggle = (event) => {
    onClick?.(event.target);
  };
  return /* @__PURE__ */ jsxs(
    "span",
    {
      onClick: onToggle,
      className: "cursor-pointer flex items-center",
      "data-testid": "sort-label",
      children: [
        /* @__PURE__ */ jsx("span", { className: "truncate mr-1", "data-testid": "sort-label-text", children: label }),
        isSortSelected && /* @__PURE__ */ jsx("span", { "data-testid": "sort-label-icon", className: "flex", children: /* @__PURE__ */ jsx(
          Icon3,
          {
            "data-testid": "sort-icon",
            name: "filter-list",
            className: `fas fa-sort-down transition duration-200 ${direction === "asc" ? "rotate-0" : "rotate-180 transform origin-center"}`,
            toolTip: direction === "asc" ? ascendingTooltip : descendingTooltip,
            toolTipPlacement: "top",
            tooltipAlignment: "center"
          }
        ) })
      ]
    }
  );
};
var sort_label_default = SortLabel;
var Card = ({ children, className: className2, role, ariaLabel }) => {
  return /* @__PURE__ */ jsx("div", { className: classNames67("rounded-lg card-box-shadow", className2), role, "aria-label": ariaLabel, children });
};
var PieChartToolTipDropDown = ({
  data,
  toolTipDropdownClassName,
  toolTipCountLabel,
  toolTipContentClassName,
  toolTipPlacement = "left-start",
  chartRef
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const offsetModifier7 = [
    {
      name: "offset",
      options: {
        offset: [0, 4]
      }
    }
  ];
  const { styles: styles2, attributes } = usePopper(chartRef, dropdownRef, {
    placement: toolTipPlacement,
    strategy: "fixed",
    modifiers: offsetModifier7
  });
  const style = {
    ...styles2.popper || {},
    ...chartRef ? { width: chartRef.offsetWidth } : {}
  };
  return /* @__PURE__ */ jsx(
    Dropdown,
    {
      className: classNames67(
        "hidden group-hover:block !z-[1000] !w-[220px]",
        toolTipDropdownClassName
      ),
      setRef: setDropdownRef,
      style,
      attributes: attributes.popper,
      children: /* @__PURE__ */ jsx(
        PieChartToolTip,
        {
          data,
          toolTipCountLabel,
          toolTipContentClassName
        }
      )
    }
  );
};
var PieChartToolTip = ({
  data,
  toolTipCountLabel,
  toolTipContentClassName
}) => /* @__PURE__ */ jsxs("div", { className: classNames67("py-4 px-5 z-[1000]", toolTipContentClassName), children: [
  /* @__PURE__ */ jsx("div", { className: "text-unique-600 text-small leading-5 font-normal", children: toolTipCountLabel }),
  /* @__PURE__ */ jsx("div", { className: "pt-3", children: /* @__PURE__ */ jsx(Divider, { type: "solid" }) }),
  /* @__PURE__ */ jsx("div", { children: data.labels.map(
    (option, index) => data.datasets?.[0]?.data?.[index] > 0 && /* @__PURE__ */ jsxs("div", { className: "pt-3 flex", children: [
      /* @__PURE__ */ jsx(
        "span",
        {
          style: {
            background: data.datasets?.[0]?.backgroundColor?.[index],
            borderColor: data.datasets?.[0]?.backgroundColor?.[index]
          },
          className: classNames67(
            "inline-flex h-1.5 w-1.5 border-[3px] rounded-full self-center"
          )
        }
      ),
      /* @__PURE__ */ jsx("div", { className: "text-unique-600 text-small leading-5 font-normal pl-3", children: option }),
      /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3 ml-auto", children: [
        /* @__PURE__ */ jsx("div", { className: "text-unique-600 text-small leading-5 font-normal", children: "-" }),
        /* @__PURE__ */ jsx("div", { className: "text-unique-600 text-small leading-5 font-normal", children: data.datasets?.[0]?.data?.[index] })
      ] })
    ] })
  ) })
] });
Chart.register(ArcElement, Tooltip, Legend, Title, SubTitle);
var PieChart = ({
  data,
  showOverViewToolTip = false,
  toolTipDropdownClassName = "",
  toolTipContentClassName = "",
  toolTipCountLabel = "",
  ariaLabel
}) => {
  const [chartRef, setChartRef] = useState(null);
  const [showTooltip, setShowTooltip] = useState(false);
  const options = {
    plugins: {
      tooltip: {
        enabled: false
      },
      legend: {
        display: false
      }
    },
    responsive: true
  };
  return /* @__PURE__ */ jsxs("div", { className: "w-full h-full group", ref: setChartRef, children: [
    /* @__PURE__ */ jsx(
      Pie,
      {
        data,
        options,
        onMouseOver: () => setShowTooltip(true),
        onMouseOut: () => setShowTooltip(false),
        "aria-label": ariaLabel
      }
    ),
    showOverViewToolTip && showTooltip && /* @__PURE__ */ jsx(
      PieChartToolTipDropDown,
      {
        data,
        toolTipDropdownClassName: classNames67(
          "hidden group-hover:block",
          toolTipDropdownClassName
        ),
        toolTipContentClassName,
        toolTipCountLabel,
        chartRef
      }
    )
  ] });
};
Chart.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend
);
var LineChart = ({
  data,
  showAlterantiveXLabel = false,
  url = "",
  wrapperClassName = "",
  ariaLabel
}) => {
  const options = {
    responsive: true,
    maintainAspectRatio: false,
    animation: {
      duration: 500
    },
    transitions: {
      show: {
        animations: {
          x: {
            from: 0
          },
          y: {
            from: 0
          }
        }
      },
      hide: {
        animations: {
          x: {
            to: 0
          },
          y: {
            to: 0
          }
        }
      }
    },
    plugins: {
      tooltip: {
        mode: "index",
        intersect: false,
        backgroundColor: "black",
        bodySpacing: 10,
        xPadding: 20,
        yPadding: 10,
        callbacks: {
          title: function(tooltipItems) {
            if (tooltipItems.length) {
              const xLabel = tooltipItems[0].chart.data.labels[tooltipItems[0].dataIndex];
              return xLabel;
            }
            return "";
          },
          label: function(tooltipItem) {
            return ` ${tooltipItem.dataset.label} ${tooltipItem.raw}`;
          },
          labelPointStyle: function(tooltipItem) {
            return {
              pointStyle: "circle",
              rotation: 0,
              borderWidth: 0,
              radius: 4
            };
          },
          afterBody: function(tooltipItems) {
            const tooltip = tooltipItems[0];
            const chart = tooltip.chart;
            const ctx = chart.ctx;
            const x = tooltip.element.x;
            const yAxis = chart.scales.y;
            const topY = yAxis.top - 10;
            const bottomY = yAxis.bottom;
            const radius = 10;
            ctx.save();
            ctx.fillStyle = "rgba(243, 246, 246, 0.5)";
            ctx.beginPath();
            ctx.moveTo(x - 16 + radius, topY);
            ctx.lineTo(x + 16 - radius, topY);
            ctx.quadraticCurveTo(x + 16, topY, x + 16, topY + radius);
            ctx.lineTo(x + 16, bottomY - radius);
            ctx.quadraticCurveTo(x + 16, bottomY, x + 16 - radius, bottomY);
            ctx.lineTo(x - 16 + radius, bottomY);
            ctx.quadraticCurveTo(x - 16, bottomY, x - 16, bottomY - radius);
            ctx.lineTo(x - 16, topY + radius);
            ctx.quadraticCurveTo(x - 16, topY, x - 16 + radius, topY);
            ctx.closePath();
            ctx.fill();
            ctx.restore();
            return "";
          }
        },
        usePointStyle: true,
        caretPadding: 20,
        font: {
          size: 12,
          family: "sans-serif",
          weight: "normal"
        }
      },
      legend: {
        position: "bottom",
        align: "start",
        labels: {
          usePointStyle: true,
          pointStyle: "circle",
          font: {
            size: 14,
            color: "#3E4D65"
          },
          padding: 20,
          boxWidth: 8,
          boxHeight: 8
        }
      }
    },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          callback: function(value, index) {
            return showAlterantiveXLabel ? index % 2 === 0 ? this.getLabelForValue(value) : "" : this.getLabelForValue(value);
          },
          maxRotation: 78,
          minRotation: 78,
          font: {
            size: 15,
            family: "sans-serif",
            color: "#3E4D65"
          },
          padding: 5
        },
        offset: false
      },
      y: {
        grid: {
          display: true,
          drawBorder: false,
          color: "#E2E4E9"
        },
        ticks: {
          display: true,
          padding: 15,
          font: {
            size: 12
          },
          stepSize: 1,
          callback: function(value) {
            return Math.floor(value);
          }
        },
        title: {
          display: true,
          text: "Test Case",
          font: {
            size: 14,
            weight: "normal",
            color: "#3E4D65"
          }
        }
      }
    },
    elements: {
      line: {
        borderWidth: 1
      }
    },
    onClick: (event, elements) => {
      const chart = event.chart;
      if (chart.tooltip?._active && chart.tooltip._active.length && !!url?.length) {
        const activePoint = chart.tooltip._active[0];
        const x = activePoint.element.x;
        const topY = chart.scales.y.top;
        const bottomY = chart.scales.y.bottom;
        const { offsetX, offsetY } = event.native;
        if (offsetX >= x - 16 && offsetX <= x + 16 && offsetY >= topY && offsetY <= bottomY) {
          window.location.href = url;
        }
      }
    }
  };
  const highlightPointsPlugin = {
    id: "highlightPointsPlugin",
    afterDraw: function(chart) {
      if (chart.tooltip?._active && chart.tooltip._active.length) {
        const activePointIndex = chart.tooltip._active[0].index;
        chart.data.datasets.forEach((dataset) => {
          dataset.pointRadius = dataset.data.map((_, index) => {
            return index === activePointIndex ? 3 : 0;
          });
        });
      } else {
        chart.data.datasets.forEach((dataset) => {
          dataset.pointRadius = dataset.data.map(() => 0);
        });
      }
      chart.update();
    }
  };
  return /* @__PURE__ */ jsx("div", { className: `w-full h-[334px] ${wrapperClassName}`, children: /* @__PURE__ */ jsx(Line, { data, options, plugins: [highlightPointsPlugin], "aria-label": ariaLabel }) });
};
var offsetModifier5 = [
  {
    name: "offset",
    options: {
      offset: [0, 4]
    }
  }
];
var PopoverContent = ({
  children,
  show,
  setDropdownRef,
  style,
  attributes,
  dropdownClassName
}) => {
  if (!show) return null;
  return createPortal(
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: setDropdownRef,
        style,
        ...attributes,
        className: classNames67(
          "w-full min-w-52 z-[9999] py-1 bg-white rounded-md shadow-mi",
          dropdownClassName
        ),
        children
      }
    ),
    document.body
  );
};
var Popover = ({
  children,
  wrapperClassName,
  placement = "bottom-end",
  fillWidth = true,
  disabled = false,
  dropdownClassName = "",
  onFocusClassName = "",
  trigger,
  variant = "select-fill",
  className: className2 = "",
  show = false,
  stopBubble = false,
  onToggle,
  onCloseField,
  onFocus,
  dropdownIconClassName = "",
  canShowDropdownIcon = false,
  dropdownStrategy = "fixed",
  refreshPosition = false,
  args = {},
  ...extra
}) => {
  const [btnRef, setBtnRef] = useState(null);
  const [showDropdown, toggleDropdown] = useState(show);
  const [dropdownRef, setDropdownRef] = useState(null);
  const popperRef = useRef(null);
  const { styles: styles2, attributes, forceUpdate } = usePopper(btnRef, dropdownRef, {
    placement,
    strategy: dropdownStrategy,
    modifiers: [
      ...offsetModifier5,
      {
        name: "preventOverflow",
        options: {
          padding: 8
        }
      }
    ]
  });
  const bgShowDropDown = {
    "select-fill": "border border-primary-300 bg-white",
    "select-fill-plain": "border border-secondary-100 bg-secondary-100",
    "no-bg": "text-primary-500"
  };
  const bgDropDown = {
    "select-fill": "border border-secondary-100 bg-secondary-100 text-secondary-800",
    "select-fill-plain": "border border-secondary-100 bg-secondary-100 text-secondary-800",
    "no-bg": "text-primary-500"
  };
  const padding = {
    "select-fill": "px-3 py-1.5",
    "select-fill-plain": "px-3 py-1.5",
    "no-bg": ""
  };
  const style = {
    ...styles2.popper,
    ...btnRef ? { width: btnRef.offsetWidth } : {}
  };
  const onToggleDropdown = useCallback(
    (value) => {
      toggleDropdown(value);
      onToggle?.(value, { key: args ?? {} });
      if (!value) {
        onCloseField?.();
      } else {
        onFocus?.();
      }
    },
    [onToggle, onCloseField, onFocus, args]
  );
  useEffect(() => {
    toggleDropdown(show);
  }, [show]);
  useEffect(() => {
    if (show && refreshPosition) {
      forceUpdate?.();
    }
  }, [refreshPosition]);
  use_click_outside_default(popperRef, () => {
    onToggleDropdown(false);
  });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "inline-block relative select-none",
        { "w-full": fillWidth },
        wrapperClassName
      ),
      children: [
        /* @__PURE__ */ jsxs(
          "div",
          {
            ref: setBtnRef,
            onClick: (event) => {
              stopBubble && preventBubble(event);
              !disabled && onToggleDropdown(!showDropdown);
            },
            ...extra,
            "data-isopen": showDropdown,
            className: classNames67(
              { [onFocusClassName]: showDropdown },
              { [bgShowDropDown[variant]]: showDropdown },
              { [bgDropDown[variant]]: !showDropdown },
              padding[variant],
              { "cursor-pointer": !disabled },
              { "opacity-50 cursor-not-allowed": disabled },
              className2
            ),
            children: [
              trigger,
              canShowDropdownIcon && !disabled && /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "expand-more",
                  className: classNames67(
                    "ml-2 text-base flex items-center transform duration-300",
                    dropdownIconClassName,
                    {
                      "rotate-180": showDropdown
                    }
                  )
                }
              )
            ]
          }
        ),
        /* @__PURE__ */ jsx(
          PopoverContent,
          {
            show: showDropdown,
            setDropdownRef,
            style,
            attributes: attributes.popper,
            dropdownClassName,
            children: /* @__PURE__ */ jsx(
              "span",
              {
                ref: (el) => {
                  popperRef.current = el;
                },
                children
              }
            )
          }
        )
      ]
    }
  );
};
var popover_default = Popover;

// src/drag-and-drop-file-uploader/uploader-utils.ts
var getFileSizeMB = (size) => size / 1024 / 1024;
var restrictedFileTypes = [
  "js",
  "php",
  "ts",
  "asp",
  "exe",
  "bat",
  "sh",
  "rar",
  "cmd",
  "msi",
  "vbs",
  "jar",
  "scr",
  "com",
  "pif",
  "reg",
  "hta",
  "swf",
  "aspx",
  "wsf",
  "ade",
  "chm",
  "msc",
  "cpl",
  "lnk",
  "cgi"
];
var checkType = (file) => {
  const extension = file.name.split(".").pop();
  const restrictedLoweredTypes = restrictedFileTypes.map(
    (type) => type.toLowerCase()
  );
  for (const type of restrictedLoweredTypes) {
    if (type.endsWith("/*")) {
      const prefix = type.slice(0, -1);
      if (file.type.startsWith(prefix)) {
        return false;
      }
    } else if (type.includes("/")) {
      if (file.type == type) {
        return false;
      }
    }
  }
  return !restrictedLoweredTypes.includes(extension.toLowerCase());
};
var acceptedExt = (types2) => {
  if (types2 === void 0) return "";
  return types2.map(
    (type) => type?.includes("/") ? `${type.toLowerCase()}` : `.${type.toLowerCase()}`
  ).join(",");
};
var DragAndDropFileUploader = ({
  children,
  accept,
  multiple = false,
  maxSize,
  minSize,
  removeLabel,
  actionLabel,
  onSizeError,
  onTypeError,
  handleChange,
  onSelect,
  onFileRemove,
  className: className2,
  acceptedExtensions
}) => {
  const [dragging, setDragging] = useState(false);
  const [error, setError] = useState(false);
  const [uploaded, setUploaded] = useState(false);
  const [currFiles, setFile] = useState(null);
  const [errorMessage, setErrorMessage] = useState("");
  const fileInputRef = useRef(null);
  const { t } = useTranslation();
  const validateFile = useCallback(
    (file) => {
      const illegalChar = validateFileName(file.name);
      const errorText = t("user.filename.invalidchars", {
        illegalChar
      });
      if (illegalChar) {
        setError(true);
        setErrorMessage(errorText);
        return false;
      }
      if (!checkType(file) || acceptedExtensions && !acceptedExtensions.includes(file?.name?.split(".").pop())) {
        setError(true);
        if (onTypeError) onTypeError("File type is not supported");
        return false;
      }
      if (maxSize && getFileSizeMB(file.size) > maxSize) {
        setError(true);
        if (onSizeError) onSizeError("File size is too big");
        return false;
      }
      if (minSize && getFileSizeMB(file.size) < minSize) {
        setError(true);
        if (onSizeError) onSizeError("File size is too small");
        return false;
      }
      setError(false);
      setErrorMessage("");
      onTypeError && onTypeError("");
      onSizeError && onSizeError("");
      return true;
    },
    [onSizeError, onTypeError, setError, accept]
  );
  const handleChanges = (files2) => {
    let checkError = false;
    if (files2) {
      if (files2 instanceof File) {
        checkError = !validateFile(files2);
      } else {
        for (let i = 0; i < files2.length; i++) {
          const file = files2[i];
          checkError = !validateFile(file) || checkError;
        }
      }
      if (checkError) return false;
      if (handleChange) handleChange(files2);
      setFile(files2);
      setUploaded(true);
      setError(false);
      return true;
    }
    return false;
  };
  const handleInputChange = (ev) => {
    const allFiles = ev.target.files;
    const files2 = multiple ? allFiles : allFiles[0];
    const success = handleChanges(files2);
    if (onSelect && success) onSelect(files2);
  };
  const handleClick = useCallback(() => {
    fileInputRef.current.click();
  }, [fileInputRef]);
  const handleDragIn = useCallback((ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    if (ev.dataTransfer.items && ev.dataTransfer.items.length !== 0) {
      setDragging(true);
    }
  }, []);
  const handleDragOut = useCallback((ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    setDragging(false);
  }, []);
  const handleDrag = useCallback((ev) => {
    ev.preventDefault();
    ev.stopPropagation();
  }, []);
  const handleDrop = useCallback(
    (ev) => {
      ev.preventDefault();
      ev.stopPropagation();
      setDragging(false);
      const eventFiles = ev.dataTransfer.files;
      if (eventFiles && eventFiles.length > 0) {
        const files2 = multiple ? eventFiles : eventFiles[0];
        handleChanges(files2);
      }
    },
    [handleChanges]
  );
  const handleRemoveFile = (event, file) => {
    event?.preventDefault?.();
    event?.stopPropagation?.();
    event?.stopImmediatePropagation?.();
    if (multiple) {
      setFile((prevFiles) => {
        const filteredFiles = prevFiles.filter((f) => f !== file);
        handleChange && handleChange(filteredFiles);
        return filteredFiles;
      });
    } else {
      fileInputRef.current.value = null;
      setFile(null);
      handleChange && handleChange(null);
    }
    if (onFileRemove) {
      onFileRemove(file);
    }
  };
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "w-full border border-dashed border-secondary-200 rounded py-4 px-3 cursor-pointer",
        {
          "bg-secondary-50/50": dragging
        },
        className2
      ),
      onClick: handleClick,
      onDragEnter: handleDragIn,
      onDragLeave: handleDragOut,
      onDragOver: handleDrag,
      onDrop: handleDrop,
      "data-testid": "dnd-file-uploader-wrapper",
      children: [
        /* @__PURE__ */ jsx(
          "input",
          {
            ref: fileInputRef,
            type: "file",
            accept: acceptedExt(accept),
            multiple,
            className: "hidden",
            onChange: handleInputChange,
            "data-testid": "dnd-file-uploader-input"
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "flex flex-col items-center justify-center gap-y-2", children: [
          /* @__PURE__ */ jsx("span", { className: "flex items-center justify-center w-8 h-8 rounded-full bg-secondary-50", children: /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "cloud-upload",
              className: "text-primary-500 text-base"
            }
          ) }),
          currFiles ? Array.isArray(currFiles) && currFiles?.length ? currFiles.map((file, ind) => {
            return /* @__PURE__ */ jsx(
              "div",
              {
                className: "flex gap-x-2 items-center px-4 w-full justify-center",
                children: /* @__PURE__ */ jsx(
                  TruncatedText,
                  {
                    value: file.name,
                    className: "font-semibold text-small leading-5 text-unique-600 flex items-center justify-center",
                    tootlipContainerClassName: "inline-block max-w-[90%] truncate",
                    children: /* @__PURE__ */ jsx(
                      Icon3,
                      {
                        name: "delete",
                        toolTip: "Remove",
                        toolTipPlacement: "bottom",
                        className: "text-error-600 text-lg ml-2",
                        "data-testid": `remove-${file?.name?.toLowerCase()?.replace(" ", "_")}`,
                        onClick: (event) => handleRemoveFile(event)
                      }
                    )
                  }
                )
              },
              ind
            );
          }) : /* @__PURE__ */ jsx("div", { className: "flex gap-x-2 items-center px-4 w-full justify-center", children: /* @__PURE__ */ jsx(
            TruncatedText,
            {
              value: currFiles.name,
              className: "font-semibold text-small leading-5 text-unique-600 flex items-center justify-center",
              tootlipContainerClassName: "inline-block max-w-[90%] truncate",
              children: /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "delete",
                  toolTip: "Remove",
                  toolTipPlacement: "bottom",
                  className: "text-error-600 text-lg ml-2",
                  "data-testid": `remove-${currFiles?.name?.toLowerCase()?.replace(" ", "_")}`,
                  onClick: (event) => handleRemoveFile(event)
                }
              )
            }
          ) }) : null,
          (multiple || !multiple && !currFiles?.name) && /* @__PURE__ */ jsx("div", { children: /* @__PURE__ */ jsx("span", { className: " text-small leading-5 font-normal text-primary-500 hover:text-primary-600 underline", children: actionLabel || "Browse file" }) }),
          errorMessage && /* @__PURE__ */ jsx("div", { className: "text-small leading-4 font-normal text-error-700 mt-1", children: errorMessage }),
          children && /* @__PURE__ */ jsx("div", { children })
        ] })
      ]
    }
  );
};
var drag_and_drop_file_uploader_default = DragAndDropFileUploader;

// src/v2/index.tsx
var v2_exports = {};
__export(v2_exports, {
  BUTTON_SIZE: () => BUTTON_SIZE,
  BUTTON_VARIANTS: () => BUTTON_VARIANTS,
  Button: () => Button2,
  INPUT_STATUS: () => INPUT_STATUS,
  INPUT_VARIANT: () => INPUT_VARIANT,
  Input: () => Input2,
  MultilineInputLikeText: () => MultilineInputLikeText,
  PASSWORD_VALIDATIONS: () => PASSWORD_VALIDATIONS,
  PageLoader: () => PageLoader,
  PasswordInput: () => PasswordInput2,
  PasswordStrength: () => PasswordStrength,
  Slider: () => Slider,
  Tabs: () => Tabs,
  buttonVariants: () => buttonVariants
});
var cn = (...inputs) => {
  return clsx(inputs);
};

// src/v2/button/enums/index.ts
var BUTTON_VARIANTS = /* @__PURE__ */ ((BUTTON_VARIANTS2) => {
  BUTTON_VARIANTS2["PRIMARY"] = "primary";
  BUTTON_VARIANTS2["SECONDARY"] = "secondary";
  BUTTON_VARIANTS2["TERTIARY"] = "tertiary";
  BUTTON_VARIANTS2["DANGER_PRIMARY"] = "danger-primary";
  BUTTON_VARIANTS2["DANGER_SECONDARY"] = "danger-secondary";
  BUTTON_VARIANTS2["DANGER_TERTIARY"] = "danger-tertiary";
  BUTTON_VARIANTS2["LINK"] = "link";
  return BUTTON_VARIANTS2;
})(BUTTON_VARIANTS || {});
var BUTTON_SIZE = /* @__PURE__ */ ((BUTTON_SIZE2) => {
  BUTTON_SIZE2["NORMAL"] = "normal";
  BUTTON_SIZE2["SMALL"] = "small";
  BUTTON_SIZE2["SMALLEST"] = "smallest";
  return BUTTON_SIZE2;
})(BUTTON_SIZE || {});
var buttonVariants = cva(
  // eslint-disable-next-line max-len
  "inline-flex items-center justify-center whitespace-nowrap rounded-border-radius-button text-small leading-5 disabled:pointer-events-none",
  {
    variants: {
      variant: {
        ["primary" /* PRIMARY */]: [
          "bg-button-primary-background-default",
          "hover:bg-button-primary-background-hover",
          "active:bg-button-primary-background-pressed",
          "disabled:bg-button-primary-background-disabled",
          "text-button-primary-text-default",
          "disabled:text-button-primary-text-disabled"
        ],
        ["secondary" /* SECONDARY */]: [
          "bg-button-secondary-background-default",
          "hover:bg-button-secondary-background-hover",
          "active:bg-button-secondary-background-pressed",
          "disabled:bg-button-secondary-background-disabled",
          "text-button-secondary-text-default",
          "disabled:text-button-secondary-text-disabled",
          "border-border-width-button",
          "border-button-secondary-stroke-default"
        ],
        ["tertiary" /* TERTIARY */]: [
          "bg-button-tertiary-background-default",
          "hover:bg-button-tertiary-background-hover",
          "active:bg-button-tertiary-background-pressed",
          "disabled:bg-button-tertiary-background-disabled",
          "text-button-tertiary-text-default",
          "disabled:text-button-tertiary-text-disabled"
        ],
        ["danger-primary" /* DANGER_PRIMARY */]: [
          "bg-button-danger-primary-background-default",
          "hover:bg-button-danger-primary-background-hover",
          "active:bg-button-danger-primary-background-pressed",
          "disabled:bg-button-danger-primary-background-disabled",
          "text-button-danger-primary-text-default",
          "disabled:text-button-danger-primary-text-disabled"
        ],
        ["danger-secondary" /* DANGER_SECONDARY */]: [
          "bg-button-danger-secondary-background-default",
          "hover:bg-button-danger-secondary-background-hover",
          "active:bg-button-danger-secondary-background-pressed",
          "disabled:bg-button-danger-secondary-background-disabled",
          "text-button-danger-secondary-text-default",
          "disabled:text-button-danger-secondary-text-disabled",
          "border-border-width-button",
          "border-button-danger-secondary-stroke-default"
        ],
        ["danger-tertiary" /* DANGER_TERTIARY */]: [
          "bg-button-danger-tertiary-background-default",
          "hover:bg-button-danger-tertiary-background-hover",
          "active:bg-button-danger-tertiary-background-pressed",
          "disabled:bg-button-danger-tertiary-background-disabled",
          "text-button-danger-tertiary-text-default",
          "disabled:text-button-danger-tertiary-text-disabled"
        ],
        ["link" /* LINK */]: [
          "text-button-link-text-default",
          "disabled:text-button-link-text-disabled"
        ]
      },
      size: {
        ["normal" /* NORMAL */]: [
          "px-padding-button-default-x",
          "py-padding-button-default-y",
          "gap-gap-button-default"
        ],
        ["small" /* SMALL */]: [
          "px-padding-button-small-x",
          "py-padding-button-small-y",
          "gap-gap-button-small"
        ],
        ["smallest" /* SMALLEST */]: [
          "px-padding-button-smallest-x",
          "py-padding-button-smallest-y",
          "gap-gap-button-smallest"
        ]
      }
    },
    defaultVariants: {
      variant: "primary" /* PRIMARY */,
      size: "normal" /* NORMAL */
    }
  }
);
var Button2 = forwardRef(
  ({
    className: className2,
    variant = "primary" /* PRIMARY */,
    size = "normal" /* NORMAL */,
    asChild = false,
    iconLeft,
    iconRight,
    iconStyles,
    isLoading = false,
    buttonVariants: buttonVariantsProp,
    disabled = false,
    ...rest
  }, ref) => {
    const { children } = rest;
    const Comp = asChild ? Slot : "button";
    const renderIcon = useCallback(
      (name) => {
        return /* @__PURE__ */ jsx(
          Icon3,
          {
            name,
            "data-testid": name,
            className: cn(
              "flex justify-center items-center stroke-none",
              iconStyles
            )
          }
        );
      },
      [iconStyles]
    );
    const componentClassName = cn(
      (buttonVariantsProp || buttonVariants)({ variant, size, className: className2 })
    );
    return /* @__PURE__ */ jsxs(
      Comp,
      {
        className: componentClassName,
        ref,
        disabled: disabled || isLoading,
        ...rest,
        children: [
          iconLeft && renderIcon(iconLeft),
          /* @__PURE__ */ jsx(Slottable, { children }),
          isLoading ? /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "loader",
              "data-testid": "loader",
              className: "text-base animate-spin ml-1"
            }
          ) : iconRight && renderIcon(iconRight)
        ]
      }
    );
  }
);
Button2.displayName = "Button";
var labelVariants = cva(
  "peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
);
var Label2 = React__default.forwardRef(({ className: className2, ...props }, ref) => /* @__PURE__ */ jsx(
  LabelPrimitive.Root,
  {
    ref,
    className: cn(labelVariants(), className2),
    ...props
  }
));
Label2.displayName = LabelPrimitive.Root.displayName;

// src/v2/input/enums/index.ts
var INPUT_VARIANT = /* @__PURE__ */ ((INPUT_VARIANT2) => {
  INPUT_VARIANT2["DEFAULT"] = "default";
  INPUT_VARIANT2["SMALL"] = "small";
  return INPUT_VARIANT2;
})(INPUT_VARIANT || {});
var INPUT_STATUS = /* @__PURE__ */ ((INPUT_STATUS2) => {
  INPUT_STATUS2["DEFAULT"] = "default";
  INPUT_STATUS2["ERROR"] = "error";
  return INPUT_STATUS2;
})(INPUT_STATUS || {});

// src/v2/input/constants/index.ts
var INPUT_STATUS_VS_STYLES = {
  ["default" /* DEFAULT */]: cn(
    "border-input-stroke-default hover:border-input-stroke-hovered",
    "focus-within:border-input-stroke-focused",
    "focus-within:shadow-input-default",
    "disabled:border-input-stroke-disabled disabled:bg-input-background-disabled"
  ),
  ["error" /* ERROR */]: cn(
    "border-input-stroke-error",
    "focus-within:shadow-input-stroke-error focus-within:!shadow-input-error"
  )
};
var INPUT_SIZE_VS_STYLES = {
  ["default" /* DEFAULT */]: [
    "max-h-9",
    "py-padding-input-default-y px-padding-input-default-x"
  ],
  ["small" /* SMALL */]: [
    "max-h-7",
    "py-padding-input-small-y px-padding-input-small-x"
  ]
};
var Input2 = forwardRef(
  ({
    errorText,
    wrapperClassName,
    labelClassName,
    variant = "default" /* DEFAULT */,
    addonBefore,
    addonAfter,
    hasError,
    inputClassName,
    ...rest
  }, ref) => {
    const inputRef = useRef(null);
    const { className: className2, label, required, disabled } = rest;
    const status = useMemo(
      () => !disabled && hasError && errorText ? "error" /* ERROR */ : "default" /* DEFAULT */,
      [disabled, hasError, errorText]
    );
    const commonStyles = useMemo(
      () => cn(
        "bg-input-background-default",
        "text-input-text-typed",
        "placeholder:text-input-text-placeholder",
        {
          "border-input-stroke-disabled bg-input-background-disabled": disabled
        }
      ),
      [disabled]
    );
    const wrapperStyles = useMemo(
      () => cn(
        "inline-flex flex-col items-start shrink-0 w-15rem gap-gap-input-label",
        "text-font-12px leading-4 font-normal",
        wrapperClassName
      ),
      [wrapperClassName]
    );
    const containerStyles = useMemo(
      () => cn(
        "w-full",
        "file:border-0 file:bg-transparent disabled:pointer-events-none",
        "flex-grow outline-none inline-flex items-center",
        "border border-solid rounded-border-radius-input",
        "text-font-13px leading-5",
        { [INPUT_STATUS_VS_STYLES[status]]: !disabled },
        INPUT_SIZE_VS_STYLES[variant],
        commonStyles,
        className2
      ),
      [variant, disabled, status, className2, commonStyles]
    );
    const inputStyles = cn(
      "outline-none w-[inherit] focus-visible:outline-none",
      commonStyles,
      inputClassName
    );
    const onClick = useCallback(
      (e) => {
        e.stopPropagation();
        inputRef?.current?.focus();
      },
      [inputRef]
    );
    const setRef = useCallback(
      (e) => {
        if (ref && typeof ref == "function") ref(e);
        inputRef.current = e;
      },
      [ref, inputRef]
    );
    return /* @__PURE__ */ jsxs("div", { className: wrapperStyles, children: [
      label && /* @__PURE__ */ jsxs("div", { children: [
        /* @__PURE__ */ jsx(
          Label2,
          {
            className: cn(
              "text-input-text-label font-medium",
              labelClassName
            ),
            children: label
          }
        ),
        required && /* @__PURE__ */ jsx("span", { className: "ml-1 text-input-text-error", children: "*" })
      ] }),
      /* @__PURE__ */ jsxs("div", { className: containerStyles, onClick, children: [
        addonBefore && /* @__PURE__ */ jsx("div", { className: "mr-2", children: addonBefore }),
        /* @__PURE__ */ jsx("input", { ...rest, ref: setRef, className: inputStyles }),
        addonAfter && /* @__PURE__ */ jsx("div", { className: "ml-2", children: addonAfter })
      ] }),
      status == "error" /* ERROR */ && /* @__PURE__ */ jsx("div", { className: "text-input-text-error", children: errorText })
    ] });
  }
);
Input2.displayName = "Input";
var PasswordInput2 = (props) => {
  const [showPassword, setShowPassword] = useState(false);
  const { isLogin, ...restProps } = props;
  const handleClick = useCallback(
    () => setShowPassword((prev) => !prev),
    [setShowPassword]
  );
  const preventInvalidInput = (e) => {
    if (isLogin) return;
    const isEmoji = /[\u{1F300}-\u{1F9FF}]/gu.test(e.key);
    const isSpace = e.code === "Space" || e.keyCode === 32 || e.key === " ";
    const isPaste = (e.metaKey || e.ctrlKey) && e.key === "v";
    if (isEmoji || isSpace || isPaste) {
      e.preventDefault();
    }
  };
  const handlePaste = (e) => {
    if (isLogin) return;
    e.preventDefault();
    const pastedText = e.clipboardData.getData("text");
    const cleanText = pastedText.replace(/[\u{1F300}-\u{1F9FF}]/gu, "").replace(/\s+/g, " ");
    const cursorPosition = e.target.selectionStart;
    const currentValue = e.target.value;
    const newValue = currentValue.slice(0, cursorPosition) + cleanText + currentValue.slice(e.target.selectionEnd);
    e.target.value = newValue;
  };
  const inputType = useMemo(
    () => showPassword ? "text" : "password",
    [showPassword]
  );
  const iconName = useMemo(
    () => showPassword ? "visibility" : "visibility-off-outline",
    [showPassword]
  );
  const iconButton = useMemo(
    () => /* @__PURE__ */ jsx(
      Icon3,
      {
        name: iconName,
        className: "!flex text-input-icon-default cursor-pointer w-5 h-5 text-lg",
        onClick: handleClick
      }
    ),
    [iconName, handleClick]
  );
  const enhancedProps = {
    ...restProps,
    onKeyDown: preventInvalidInput,
    onPaste: handlePaste
  };
  return /* @__PURE__ */ jsx(Input2, { ...enhancedProps, addonAfter: iconButton, type: inputType });
};
var PASSWORD_VALIDATIONS = [
  {
    key: "upperLower",
    label: "password_strongness.upper_lower",
    test: (password) => /(?=.*[a-z])(?=.*[A-Z])/.test(password)
  },
  {
    key: "digits",
    label: "password_strongness.digits",
    test: (password) => /\d/.test(password)
  },
  {
    key: "special",
    label: "password_strongness.special",
    test: (password) => /[!@#$%^&*(),.?":{}|<>]/.test(password)
  },
  {
    key: "length",
    label: "password_strongness.length",
    test: (password) => password.length >= 10
  }
];
var STRENGTH_LEVELS = {
  0: { label: "password_strongness.title", style: { text: "", bg: "" } },
  1: {
    label: "password_strongness.weak",
    style: { text: "text-red-500", bg: "bg-red-500" }
  },
  2: {
    label: "password_strongness.average",
    style: { text: "text-yellow-600", bg: "bg-yellow-600" }
  },
  3: {
    label: "password_strongness.good",
    style: { text: "text-blue-600", bg: "bg-blue-600" }
  },
  4: {
    label: "password_strongness.strong",
    style: { text: "text-primary-800", bg: "bg-primary-800" }
  }
};
var PasswordStrength = ({
  name,
  label,
  placeholder,
  value,
  errorText,
  onChange,
  onBlur,
  onFocus,
  wrapperClassName,
  labelClassName
}) => {
  const { t } = useTranslation();
  const [focused, setFocused] = useState(false);
  const validatePassword = () => {
    const results = PASSWORD_VALIDATIONS.map((validation) => ({
      ...validation,
      isValid: validation.test(value)
    }));
    return {
      results,
      passedCount: results.filter((v) => v.isValid).length,
      isValid: results.every((v) => v.isValid)
    };
  };
  const {
    results: validationResults,
    passedCount,
    isValid
  } = validatePassword();
  const strength = STRENGTH_LEVELS[passedCount];
  const StrengthBar = () => /* @__PURE__ */ jsx("div", { className: "flex gap-3 h-[3px] w-full", children: [1, 2, 3, 4].map((level) => /* @__PURE__ */ jsx(
    "div",
    {
      className: `flex-1 rounded transition-all duration-300 ${passedCount >= level ? strength.style.bg : "bg-secondary-400"}`
    },
    level
  )) });
  const ValidationRules = () => /* @__PURE__ */ jsx("ul", { className: "text-sm space-y-1 flex flex-col gap-2 pt-4", children: validationResults.map((rule) => /* @__PURE__ */ jsxs("li", { className: "flex items-center flex-row gap-2.5", children: [
    /* @__PURE__ */ jsx("span", { className: "flex items-center justify-center w-[10px]", children: rule.isValid ? /* @__PURE__ */ jsx(Icon3, { name: "check", className: "text-primary-800 text-[10px]" }) : /* @__PURE__ */ jsx("span", { className: "text-secondary-500 rounded-full bg-secondary-500 p-[3px]" }) }),
    /* @__PURE__ */ jsx(
      "span",
      {
        className: classNames67({
          "line-through": rule.isValid,
          "text-gray-700": !rule.isValid
        }),
        children: t(rule.label)
      }
    )
  ] }, rule.key)) });
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "relative mx-auto text-font-12px leading-4 font-normal flex flex-1"
      ),
      children: [
        /* @__PURE__ */ jsx(
          PasswordInput2,
          {
            id: "password-input",
            name,
            label,
            placeholder,
            type: "password",
            required: true,
            hasError: !!errorText || !isValid,
            errorText,
            value,
            onChange: (e) => onChange(e.target.value),
            onFocus: () => {
              setFocused(true);
              onFocus?.();
            },
            onBlur: () => {
              setFocused(false);
              onBlur?.();
            },
            wrapperClassName,
            labelClassName
          }
        ),
        focused && /* @__PURE__ */ jsxs("div", { className: "absolute top-full left-0 right-0 mt-1 p-4 border border-gray-200 shadow-lg rounded bg-white w-[80%] mx-auto z-10 transition-all duration-200 ease-in-out opacity-100 transform translate-y-0", children: [
          /* @__PURE__ */ jsxs("div", { className: "pb-4 gap-3 flex flex-col mx-[-16px] px-4 border-b border-gray-200 rounded-b-lg", children: [
            /* @__PURE__ */ jsx("div", { className: "flex justify-between text-xs", children: /* @__PURE__ */ jsx("span", { className: `font-medium`, children: t(strength.label) }) }),
            /* @__PURE__ */ jsx(StrengthBar, {})
          ] }),
          /* @__PURE__ */ jsx(ValidationRules, {})
        ] })
      ]
    }
  );
};
var MultilineInputLikeText = ({
  value,
  onChange,
  type = "text",
  readOnly = false,
  placeholder = "",
  className: className2 = ""
}) => {
  const divRef = useRef(null);
  const lastValueRef = useRef("");
  const isUpdatingRef = useRef(false);
  const getMaskedValue = useCallback((val) => {
    if (!val) return "";
    return "\u2022".repeat(val.length);
  }, []);
  const handleInput = useCallback(() => {
    if (!divRef.current || isUpdatingRef.current) return;
    const currentText = divRef.current.innerText ?? "";
    if (type === "password") {
      const previousValue = lastValueRef.current;
      const maskedLength = getMaskedValue(previousValue).length;
      if (currentText.length > maskedLength) {
        const newChars = currentText.slice(maskedLength);
        const newValue = (previousValue ?? "") + newChars;
        lastValueRef.current = newValue;
        onChange(newValue);
      } else if (currentText.length < maskedLength) {
        const deletedCount = maskedLength - currentText.trim().replace(/\n/g, "").length;
        const newValue = (previousValue ?? "").slice(0, -deletedCount);
        lastValueRef.current = newValue;
        onChange(newValue);
      }
    } else {
      if (currentText !== lastValueRef.current) {
        lastValueRef.current = currentText;
        onChange(currentText);
      }
    }
  }, [type, onChange, getMaskedValue]);
  useEffect(() => {
    if (!divRef.current || isUpdatingRef.current) return;
    const displayText = type === "password" ? getMaskedValue(value) : value;
    if (lastValueRef.current === value && divRef.current.innerText === displayText) {
      return;
    }
    isUpdatingRef.current = true;
    const el = divRef.current;
    const sel = window.getSelection();
    const isFocused = document.activeElement === el;
    let cursorOffset = 0;
    if (isFocused && sel && sel.rangeCount > 0) {
      try {
        const range = sel.getRangeAt(0);
        const preCaretRange = range.cloneRange();
        preCaretRange.selectNodeContents(el);
        preCaretRange.setEnd(range.endContainer, range.endOffset);
        cursorOffset = preCaretRange.toString().length;
      } catch (error) {
      }
    }
    el.innerText = displayText ?? "";
    lastValueRef.current = value;
    if (isFocused && sel) {
      try {
        sel.removeAllRanges();
        const range = document.createRange();
        const node = el.firstChild || el;
        const position = Math.min(cursorOffset, el.innerText.length);
        if (node.nodeType === Node.TEXT_NODE) {
          range.setStart(node, position);
          range.setEnd(node, position);
        } else {
          range.setStart(el, 0);
          range.setEnd(el, 0);
        }
        sel.addRange(range);
      } catch (error) {
      }
    }
    isUpdatingRef.current = false;
  }, [value, type, getMaskedValue]);
  const handlePaste = useCallback(
    (e) => {
      e.preventDefault();
      const plainText = e.clipboardData.getData("text/plain");
      if (!divRef.current) return;
      try {
        if (document.execCommand) {
          document.execCommand("insertText", false, plainText);
        } else {
          const selection = window.getSelection();
          if (selection && selection.rangeCount > 0) {
            const range = selection.getRangeAt(0);
            range.deleteContents();
            range.insertNode(document.createTextNode(plainText));
          } else {
            divRef.current.innerText += plainText;
          }
        }
        setTimeout(() => handleInput(), 0);
      } catch (error) {
        if (type === "password") {
          onChange(value + plainText);
        } else {
          onChange((divRef.current?.innerText ?? "") + plainText);
        }
      }
    },
    [value, type, onChange, handleInput]
  );
  const handleKeyDown = useCallback(
    (e) => {
      if (e.key === "Enter") {
        e.stopPropagation();
      }
    },
    []
  );
  if (readOnly) {
    return /* @__PURE__ */ jsx("div", { className: `p-2 whitespace-pre-wrap break-words ${className2}`, children: type === "password" ? getMaskedValue(value) : value });
  }
  return /* @__PURE__ */ jsxs("div", { className: "w-full", children: [
    /* @__PURE__ */ jsx("input", { type: "hidden", value }),
    /* @__PURE__ */ jsx(
      "div",
      {
        ref: divRef,
        className: `p-2 min-h-[40px] text-sm whitespace-pre-wrap break-words focus:outline-none w-full h-full border rounded-md focus-within:border-primary-300 border-transparent ${className2}`,
        contentEditable: true,
        "data-placeholder": placeholder,
        onInput: handleInput,
        onPaste: handlePaste,
        onKeyDown: handleKeyDown,
        style: {
          whiteSpace: "pre-wrap"
        },
        suppressContentEditableWarning: true
      }
    )
  ] });
};
var Slider = React.forwardRef(
  ({
    label,
    infoIcon,
    value,
    addonAfter,
    min,
    max,
    step,
    disabled,
    name,
    onValueChange,
    onValueCommit,
    wrapperClassName,
    labelClassName,
    className: className2,
    ...props
  }, ref) => {
    const wrapperStyles = useMemo(
      () => cn(
        "inline-flex flex-col items-start shrink-0 w-15rem gap-gap-input-label",
        "text-font-12px leading-4 font-normal w-full",
        wrapperClassName
      ),
      [wrapperClassName]
    );
    return /* @__PURE__ */ jsxs("div", { className: wrapperStyles, children: [
      label && /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-1", children: [
        /* @__PURE__ */ jsx(
          Label2,
          {
            className: cn(
              "text-input-text-label font-medium",
              labelClassName
            ),
            children: label
          }
        ),
        infoIcon
      ] }),
      /* @__PURE__ */ jsxs("div", { className: "flex items-center gap-4", children: [
        /* @__PURE__ */ jsxs(
          RadixSlider.Root,
          {
            ref,
            name,
            disabled,
            min,
            max,
            step,
            value,
            onValueChange,
            onValueCommit,
            className: cn(
              "relative flex h-5 touch-none select-none items-center h-5 w-64",
              className2
            ),
            ...props,
            children: [
              /* @__PURE__ */ jsx(RadixSlider.Track, { className: "relative h-[5px] grow rounded-full bg-neutral-100", children: /* @__PURE__ */ jsx(RadixSlider.Range, { className: "absolute h-full rounded-full bg-secondary-500" }) }),
              /* @__PURE__ */ jsx(RadixSlider.Thumb, { className: "block size-5 rounded-full bg-white border-2 focus:outline-none border-secondary-500 ring-secondary-500" })
            ]
          }
        ),
        addonAfter
      ] })
    ] });
  }
);
var Tabs = ({
  activeTab,
  tabs,
  className: className2,
  onChangeTab,
  tabClassName
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "border-[0.5px] border-divider-100 rounded-md p-0.5",
        "inline text-2xs text-secondary-unique-600 leading-4",
        "font-medium bg-secondary-50 cursor-pointer",
        className2
      ),
      children: tabs.map((tab) => /* @__PURE__ */ jsx(
        "button",
        {
          type: "button",
          disabled: tab.disabled,
          className: classNames67(
            "inline-flex items-center justify-center  rounded-l-md py-1.5 px-3 h-6",
            tabClassName,
            {
              "!bg-white rounded-r-md shadow-ai-button-reverse": activeTab === tab.value,
              "text-secondary-unique-50 cursor-not-allowed": tab.disabled
            }
          ),
          onClick: () => {
            onChangeTab(tab.value);
          },
          children: tab.label
        },
        tab.value
      ))
    }
  );
};
var PageLoader = (props) => {
  const { top = "25%", additionalClassNames } = props;
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        `empty-page-loader mt-[${top}] mx-auto`,
        additionalClassNames
      )
    }
  );
};
var DownloadImageBtn = ({
  src,
  name,
  type = "link" /* LINK */,
  className: className2,
  children
}) => {
  const screenshotDownloadLinkRef = useRef(null);
  const handleDownlodScreenshot = () => {
    screenshotDownloadLinkRef.current?.click();
  };
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "a",
      {
        style: { display: "none" },
        onClick: () => handleDownload(src, name),
        download: name,
        id: "screenshot-download",
        ref: screenshotDownloadLinkRef
      }
    ),
    /* @__PURE__ */ jsx(
      Button2,
      {
        className: classNames67(className2),
        variant: type,
        onClick: handleDownlodScreenshot,
        children
      }
    )
  ] });
};

// src/draw-rectangles-over-image/utils.ts
function drawRectangles(ctx, obj, scaleFactor) {
  const rectX = obj.x * scaleFactor;
  const rectY = obj.y * scaleFactor;
  const rectWidth = obj.width * scaleFactor;
  const rectHeight = obj.height * scaleFactor;
  const radius = 4;
  ctx.beginPath();
  ctx.moveTo(rectX + radius, rectY);
  ctx.lineTo(rectX + rectWidth - radius, rectY);
  ctx.arcTo(
    rectX + rectWidth,
    rectY,
    rectX + rectWidth,
    rectY + radius,
    radius
  );
  ctx.lineTo(rectX + rectWidth, rectY + rectHeight - radius);
  ctx.arcTo(
    rectX + rectWidth,
    rectY + rectHeight,
    rectX + rectWidth - radius,
    rectY + rectHeight,
    radius
  );
  ctx.lineTo(rectX + radius, rectY + rectHeight);
  ctx.arcTo(
    rectX,
    rectY + rectHeight,
    rectX,
    rectY + rectHeight - radius,
    radius
  );
  ctx.lineTo(rectX, rectY + radius);
  ctx.arcTo(rectX, rectY, rectX + radius, rectY, radius);
  ctx.closePath();
  ctx.strokeStyle = "#3A6271";
  ctx.lineWidth = 2;
  ctx.stroke();
}
var DrawRectanglesOverImage = ({ src, className: className2 = "", coordinates }) => {
  const canvasRef = useRef(null);
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext("2d");
    const img = new Image();
    img.onload = () => {
      const updateCanvasSize = () => {
        const containerWidth = canvas.parentElement.offsetWidth;
        const containerHeight = canvas.parentElement.offsetHeight;
        const aspectRatio = img.width / img.height;
        if (containerWidth / aspectRatio < containerHeight) {
          canvas.style.width = "100%";
          canvas.style.height = "100%";
        } else {
          canvas.style.width = "100%";
          canvas.style.height = "100%";
        }
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0, img.width, img.height);
        const scaleFactor = canvas.width / img.width;
        coordinates.forEach((obj) => drawRectangles(ctx, obj, scaleFactor));
      };
      updateCanvasSize();
      window.addEventListener("resize", updateCanvasSize);
      return () => window.removeEventListener("resize", updateCanvasSize);
    };
    img.src = src;
  }, [src, coordinates]);
  return /* @__PURE__ */ jsx(
    "canvas",
    {
      ref: canvasRef,
      className: classNames67(
        "relative top-0 left-0 w-full h-full object-contain",
        className2
      )
    }
  );
};
var draw_rectangles_over_image_default = DrawRectanglesOverImage;
var className = "!absolute w-full h-full object-contain border border-[#DFE3E5] rounded";
var ActiveItem = ({
  src,
  name,
  emptyMessage,
  emptyImageSrc,
  coordinates,
  shouldDrawRectangle,
  showCloseButton,
  handleCloseModal
}) => {
  const containerRef = useRef(null);
  useEffect(() => {
    const container = containerRef.current;
    const image = container.querySelector("img");
    const resizeImage = () => {
      if (image == null) {
        return;
      }
      if (image.naturalWidth > image.naturalHeight) {
        image.style.width = "100%";
        image.style.height = "auto";
      } else {
        image.style.width = "auto";
        image.style.height = "100%";
      }
    };
    resizeImage();
    window.addEventListener("resize", resizeImage);
    return () => {
      window.removeEventListener("resize", resizeImage);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: "h-full relative overflow-hidden flex justify-center rounded-[5px]",
      children: [
        showCloseButton && /* @__PURE__ */ jsx(
          Button,
          {
            type: "primary",
            className: "px-2 bg-secondary-200 absolute right-1 top-1",
            style: { zIndex: 50 },
            onClick: handleCloseModal,
            "aria-label": "Close image viewer",
            children: /* @__PURE__ */ jsx(
              Icon3,
              {
                name: "close",
                className: "text-2xl text-secondary-600 flex items-center"
              }
            )
          }
        ),
        shouldDrawRectangle && /* @__PURE__ */ jsx(
          draw_rectangles_over_image_default,
          {
            src,
            coordinates,
            className
          }
        ),
        !shouldDrawRectangle && src && /* @__PURE__ */ jsx(
          "img",
          {
            className,
            src,
            alt: name,
            style: { ...shouldDrawRectangle && { display: "none" } }
          }
        ),
        !src && /* @__PURE__ */ jsx(
          Empty,
          {
            className: "absolute w-full h-full border border-[#DFE3E5] rounded",
            description: emptyMessage,
            imageSource: emptyImageSrc
          }
        )
      ]
    }
  );
};
var NavIcon = ({
  icon,
  onNav,
  isDisabled,
  className: className2,
  direction
}) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "w-[72px] h-[72px] rounded-full shadow-[0_0_4px_rgba(0, 0, 0, 0.15)] flex items-center justify-center cursor-pointer z-10 bg-white",
        {
          "cursor-not-allowed pointer-events-none": isDisabled
        },
        className2
      ),
      onClick: onNav,
      style: { boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)" },
      "data-testid": "carousel-nav-icon-" + direction,
      children: /* @__PURE__ */ jsx(
        Icon3,
        {
          name: icon,
          className: classNames67("text-secondary-700 text-lg", {
            "opacity-50 cursor-not-allowed": isDisabled
          })
        }
      )
    }
  );
};
var PreviewItem = ({ src, side = "left" }) => {
  const prevStyle = {
    backgroundImage: `url(${src})`,
    width: "200px"
  };
  if (side === "right") {
    prevStyle["backgroundPosition"] = "100% 0";
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      style: prevStyle,
      className: "opacity-50 border border-[#DFE3E5] bg-cover bg-no-repeat mt-7 rounded-[5px]"
    }
  );
};
var Carousel = ({
  onMoveCarousel,
  imgSrcList,
  activeSeq,
  emptyMessage,
  emptyImageSrc
}) => {
  const handleNav = (direction) => {
    if (onMoveCarousel) onMoveCarousel(direction);
  };
  const isLastActive = activeSeq === imgSrcList.length - 1;
  const isFirstActive = activeSeq === 0;
  const { t } = useTranslation();
  return /* @__PURE__ */ jsx("div", { className: "h-full", children: /* @__PURE__ */ jsxs(
    "div",
    {
      className: "h-full grid gap-x-6",
      style: { gridTemplateColumns: "auto 1fr auto" },
      children: [
        /* @__PURE__ */ jsx(
          PreviewItem,
          {
            src: isFirstActive ? "" : imgSrcList[activeSeq - 1].src,
            side: "right"
          }
        ),
        /* @__PURE__ */ jsxs("div", { className: "h-full w-full relative", children: [
          /* @__PURE__ */ jsx(
            NavIcon,
            {
              icon: "arrow-backward",
              onNav: () => handleNav(-1),
              isDisabled: isFirstActive,
              className: "absolute left-[-100px] top-[45%]",
              direction: "backward"
            }
          ),
          /* @__PURE__ */ jsxs("div", { className: "flex flex-col h-full", children: [
            /* @__PURE__ */ jsx("div", { className: "flex justify-end py-1", children: imgSrcList[activeSeq]?.src && /* @__PURE__ */ jsx(
              DownloadImageBtn,
              {
                src: imgSrcList[activeSeq]?.src,
                name: imgSrcList[activeSeq]?.name,
                className: "text-primary-600 hover:underline text-2xs !p-0",
                children: t("common.download")
              }
            ) }),
            /* @__PURE__ */ jsx(
              ActiveItem,
              {
                emptyMessage,
                emptyImageSrc,
                ...imgSrcList[activeSeq],
                handleCloseModal: () => {
                }
              }
            )
          ] }),
          /* @__PURE__ */ jsx(
            NavIcon,
            {
              icon: "arrow-forward",
              onNav: () => handleNav(1),
              isDisabled: isLastActive,
              className: "absolute right-[-100px] top-[45%]",
              direction: "forward"
            }
          )
        ] }),
        /* @__PURE__ */ jsx(PreviewItem, { src: isLastActive ? "" : imgSrcList[activeSeq + 1].src })
      ]
    }
  ) });
};
Chart.register(ArcElement, Tooltip, Legend, Title, SubTitle);
var DonutChart = ({
  dataSets,
  title,
  options,
  data,
  ariaLabel
}) => {
  const defaultOptions = {
    cutout: 60,
    plugins: {
      tooltip: {
        enabled: false
      }
    }
  };
  const mergedOptions = {
    ...options || defaultOptions,
    plugins: {
      ...options?.plugins || defaultOptions.plugins
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", children: [
    /* @__PURE__ */ jsx(
      Doughnut,
      {
        data: data || { datasets: dataSets },
        options: mergedOptions,
        "aria-label": ariaLabel
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "absolute-center z-[1] text-center",
        dangerouslySetInnerHTML: { __html: title }
      }
    )
  ] });
};
Chart.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);
var BarChart = ({
  data,
  title,
  externalTooltip = null,
  onClickOnBar = NOOP,
  wrapperClassName = null,
  chartOptions,
  ariaLabel
}) => {
  Math.max(
    ...data.datasets.flatMap((dataset) => dataset.data)
  );
  const options = chartOptions || {
    plugins: {
      title: {
        display: true
      },
      legend: {
        display: false
      },
      tooltip: {
        // Disable the on-canvas tooltip
        enabled: !externalTooltip,
        external: externalTooltip
      }
    },
    responsive: true,
    scales: {
      x: {
        stacked: true,
        grid: {
          display: false
        },
        ticks: {
          display: false,
          showLabelBackdrop: false
        }
      },
      y: {
        stacked: true,
        grid: {
          display: false,
          drawBorder: false
        },
        ticks: {
          display: false,
          showLabelBackdrop: false
        }
        // max: maxDataValue * maxPercentage,
      }
    },
    animation: {
      duration: 1,
      onComplete: function({ chart }) {
        const ctx = chart.ctx;
        ctx.canvas.classList.add(
          "!font-medium",
          "!text-small",
          "leading-5",
          "!text-unique-800"
        );
        chart.config.data.datasets.forEach(function(dataset, i) {
          const meta = chart.getDatasetMeta(i);
          meta.data.forEach(function(bar, index) {
            const data2 = dataset.data[index];
            ctx.fillText(
              data2,
              bar.x - (`${data2}`.length * 5 / 2 + 1.5),
              bar.y - 10
            );
          });
        });
      }
    },
    onClick: function(evt, element) {
      if (element?.length > 0) {
        onClickOnBar(data?.labels[element[0]?.index]);
      }
    }
  };
  return /* @__PURE__ */ jsxs("div", { className: classNames67("relative", wrapperClassName), children: [
    /* @__PURE__ */ jsx(
      Bar,
      {
        data,
        options,
        className: classNames67({ "cursor-pointer": onClickOnBar !== NOOP }),
        "aria-label": ariaLabel
      }
    ),
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "absolute-center text-center",
        dangerouslySetInnerHTML: { __html: title }
      }
    )
  ] });
};
var OTPInput = ({
  value,
  inputNumber,
  separator: separator2,
  onChange,
  renderInput,
  inputStyle,
  inputType = "text",
  containerStyle,
  shouldAutoFocus,
  ...rest
}) => /* @__PURE__ */ jsx(
  OtpInput,
  {
    value,
    numInputs: inputNumber,
    renderSeparator: separator2,
    onChange,
    renderInput,
    inputStyle,
    inputType,
    shouldAutoFocus,
    containerStyle,
    ...rest
  }
);
var otp_input_default = OTPInput;
var FreshChat = ({ className: className2, ...rest }) => {
  const fcSettings = {
    token: rest.token,
    host: rest.host || "https://wchat.freshchat.com",
    siteId: "app.testsigma.com",
    restoreId: rest.restoreId || null,
    firstName: rest.firstName,
    lastName: rest.lastName,
    email: rest.email,
    externalId: rest.email,
    faqTags: {
      tags: rest.tags,
      filterType: "category"
    },
    config: {
      headerProperty: {
        hideChatButton: true
      },
      ...rest.config
    }
  };
  const toggleWidget = (show) => {
    const widget = document.querySelector("#fc_frame");
    if (show) {
      widget.setAttribute("style", "z-index: 6000 !important");
    } else {
      widget.setAttribute("style", "z-index: 1000 !important");
    }
  };
  const loadScript = () => {
    const id = "freshchat-lib";
    if (document.getElementById(id) || window.fcWidget) return;
    const script = document.createElement("script");
    script.async = true;
    script.type = "text/javascript";
    script.src = "https://wchat.freshchat.com/js/widget.js";
    script.id = id;
    document.head.appendChild(script);
  };
  const init = () => {
    const properties = {
      firstName: fcSettings.firstName,
      lastName: fcSettings.lastName,
      email: fcSettings.email,
      ...rest.userProps
    };
    window.fcWidget.init({
      ...fcSettings
    });
    window.fcWidget.on("widget:opened", () => toggleWidget(true));
    window.fcWidget.on("widget:closed", () => toggleWidget(false));
    window.fcWidget.user.get((res) => {
      if (res?.status !== 200) {
        window.fcWidget.user.setProperties(properties);
      }
      window.fcWidget.on(
        "user:created",
        rest?.onUserCreated ? rest.onUserCreated : () => {
        }
      );
    });
  };
  useEffect(() => {
    loadScript();
    const interval = setInterval(() => {
      if (window.fcWidget) {
        clearInterval(interval);
        try {
          init();
        } catch (error) {
          throw new Error(error);
        }
      }
    }, 1e3);
    return () => {
      if (window?.fcWidget) {
        window.fcWidget.user.clear();
      }
    };
  }, []);
  function open() {
    window?.fcWidget?.open();
  }
  return /* @__PURE__ */ jsx(
    "div",
    {
      onClick: open,
      className: classNames67(
        "bg-status-ready cdk-drag p-2.5 font-bold text-3xl text-white",
        "flex items-center justify-center",
        className2
      ),
      style: {
        position: "absolute",
        width: "50px",
        height: "50px",
        borderRadius: "50% 5px 50% 50%"
      },
      children: /* @__PURE__ */ jsx(Icon3, { name: "chat", className: "text-[18px]" })
    }
  );
};
var freshchat_default = FreshChat;
var UpgradeModal = ({
  show,
  modalContent,
  actions,
  onClose
}) => {
  return /* @__PURE__ */ jsxs(
    Modal,
    {
      isOpen: show,
      className: "relative",
      showCloseButton: true,
      closeOnEscape: true,
      closeOnOutsideClick: true,
      onClose: () => onClose(false),
      children: [
        modalContent,
        !!actions?.length && /* @__PURE__ */ jsx("div", { className: classNames67("pt-4 flex flex-row-reverse gap-2"), children: actions.map((item, idx) => /* @__PURE__ */ jsx(
          Button,
          {
            type: item.type,
            onClick: () => {
              item.callbackhandler();
              item.closePopup && onClose(false);
            },
            isDisabled: item?.isDisabled ?? false,
            children: item.content
          },
          idx
        )) })
      ]
    }
  );
};
var upgrade_modal_default = UpgradeModal;
var UpgradePopup = ({
  isAllowed,
  modalContent,
  upgradeIcon = "flash-on",
  children,
  tooltipContent,
  iconClassName,
  actions,
  renderIcon
}) => {
  const [showUgradePopup, setShowUpgradePopup] = useState(false);
  const handleClick = useCallback(
    (event) => {
      if (!isAllowed) {
        preventBubble(event);
        setShowUpgradePopup(true);
      }
    },
    [isAllowed, showUgradePopup]
  );
  const upgradeIconElement = !isAllowed ? /* @__PURE__ */ jsx(
    Icon3,
    {
      name: upgradeIcon,
      toolTip: tooltipContent,
      toolTipPlacement: "right",
      className: classNames67("text-lg", iconClassName)
    }
  ) : /* @__PURE__ */ jsx(Fragment, {});
  let content;
  if (renderIcon) {
    content = renderIcon(upgradeIconElement);
  } else {
    content = /* @__PURE__ */ jsxs(Fragment, { children: [
      children,
      upgradeIconElement
    ] });
  }
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx(
      "div",
      {
        className: "flex items-center justify-bewteen cursor-pointer",
        onClickCapture: handleClick,
        children: content
      }
    ),
    showUgradePopup && /* @__PURE__ */ jsx(
      upgrade_modal_default,
      {
        show: showUgradePopup,
        onClose: setShowUpgradePopup,
        modalContent,
        actions
      }
    )
  ] });
};
var upgrade_popup_default = UpgradePopup;
var themes = {
  light: "light",
  dark: "dark"
};
var ThemeContext = createContext({
  theme: themes.light,
  changeTheme: NOOP
});
function addDarkToClassList() {
  document.documentElement.classList.add("dark");
}
function removeDarkFromClassList() {
  document.documentElement.classList.remove("dark");
}
function matchMediaDarkTarget() {
  return window.matchMedia ? window.matchMedia("(prefers-color-scheme: dark)") : null;
}
function ThemeContextProvider({ children }) {
  const [theme, setTheme] = useState(
    matchMediaDarkTarget()?.matches ? themes.dark : themes.light
  );
  function changeTheme(newTheme) {
    setTheme(newTheme);
  }
  useEffect(() => {
    function listener(e) {
      setTheme(e.matches ? themes.dark : themes.light);
    }
    const target = matchMediaDarkTarget();
    target?.addEventListener("change", listener);
    return () => target?.removeEventListener("change", listener);
  }, []);
  const isDarkTheme = useMemo(() => theme == themes.dark, [theme]);
  useEffect(() => {
    if (isDarkTheme) addDarkToClassList();
    else removeDarkFromClassList();
    return () => {
      if (isDarkTheme) removeDarkFromClassList();
    };
  }, [isDarkTheme]);
  return /* @__PURE__ */ jsx(ThemeContext.Provider, { value: { theme, changeTheme }, children });
}

// src/step-results/carousel/utils.ts
var smoothScrollTo = (element, target, duration) => {
  target = Math.round(target);
  duration = Math.round(duration);
  const start_time = Date.now();
  const end_time = start_time + duration;
  const start_top = element.scrollLeft;
  const distance = target - start_top;
  const smooth_step = (start, end, point) => {
    if (point <= start) {
      return 0;
    }
    if (point >= end) {
      return 1;
    }
    const x = (point - start) / (end - start);
    return x * x * (3 - 2 * x);
  };
  return new Promise((resolve) => {
    const step = () => {
      const now = Date.now();
      if (now < end_time) {
        requestAnimationFrame(step);
        const point = smooth_step(start_time, end_time, now);
        element.scrollLeft = Math.round(start_top + distance * point);
      } else {
        element.scrollLeft = target;
        resolve();
      }
    };
    step();
  });
};
var styles = "w-full h-full object-contain";
var StepResultsCarousel = ({
  sources,
  coordinates,
  names,
  stepResultsCarouselClassName = ""
}) => {
  const containerRef = useRef(null);
  const imgRefs = [useRef(null), useRef(null)];
  const [isHovering, setIsHovering] = useState(false);
  useEffect(() => {
    let currentImageIndex = 0;
    let intervalId = null;
    if (!isHovering) {
      intervalId = setInterval(() => {
        currentImageIndex = (currentImageIndex + 1) % 2;
        const nextImage = imgRefs[currentImageIndex].current;
        smoothScrollTo(containerRef.current, nextImage.offsetLeft, 1e3);
      }, 2e3);
    }
    return () => intervalId && clearInterval(intervalId);
  }, [isHovering]);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      ref: containerRef,
      className: "flex overflow-x-auto",
      onMouseEnter: () => setIsHovering(true),
      onMouseLeave: () => setIsHovering(false),
      children: [
        /* @__PURE__ */ jsx(
          "img",
          {
            src: sources[0],
            alt: names[0],
            style: { display: "none" },
            className: classNames67(styles, stepResultsCarouselClassName)
          }
        ),
        /* @__PURE__ */ jsx(
          draw_rectangles_over_image_default,
          {
            src: sources[0],
            coordinates,
            ref: imgRefs[0],
            className: classNames67(styles, stepResultsCarouselClassName, "mr-2")
          }
        ),
        /* @__PURE__ */ jsx(
          "img",
          {
            ref: imgRefs[1],
            src: sources[1],
            alt: names[1],
            className: classNames67(styles, stepResultsCarouselClassName)
          }
        )
      ]
    }
  );
};
var carousel_default = StepResultsCarousel;
var Offline = () => {
  const [isOnline, setIsOnline] = useState(true);
  const { t } = useTranslation();
  const toggleStatusToOnline = () => {
    setIsOnline(true);
  };
  const toggleStatusToOffline = () => {
    setIsOnline(false);
  };
  useEffect(() => {
    window.addEventListener("online", toggleStatusToOnline);
    window.addEventListener("offline", toggleStatusToOffline);
    return () => {
      window.removeEventListener("online", toggleStatusToOnline);
      window.removeEventListener("offline", toggleStatusToOffline);
    };
  }, []);
  return /* @__PURE__ */ jsxs(
    "div",
    {
      className: classNames67(
        "absolute w-[380px] bottom-0 transition-all ease-in duration-400 right-10 shadow-lg border border-secondary-300 rounded-md p-4 z-[10000] bg-secondary-50",
        isOnline ? "invisible" : "-translate-y-4"
      ),
      children: [
        /* @__PURE__ */ jsxs("header", { className: "flex items-center justify-between w-full", children: [
          /* @__PURE__ */ jsxs("div", { className: "flex gap-x-3 items-center", children: [
            /* @__PURE__ */ jsx(Icon3, { name: "wifi-off", className: "text-lg text-unique-600" }),
            /* @__PURE__ */ jsx("h1", { className: "text-[15px] font-semibold text-unique-600", children: t("offline.header_text") })
          ] }),
          /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "close",
              className: "text-lg cursor-pointer text-secondary-500",
              onClick: toggleStatusToOnline
            }
          )
        ] }),
        /* @__PURE__ */ jsx("body", { className: "text-xs text-secondary-600 px-8 font-light mb-4 mt-1.5", children: t("offline.body_text") }),
        /* @__PURE__ */ jsx(
          "footer",
          {
            className: "flex justify-end text-xs font-medium text-secondary-500 cursor-pointer",
            onClick: toggleStatusToOnline,
            children: t("common.dismiss")
          }
        )
      ]
    }
  );
};
var offline_default = Offline;
var defaultDetails = {
  Critical: "Critical",
  Minor: "Minor",
  Serious: "Serious",
  Moderate: "Moderate",
  Success: "Success"
};
var DonutChartList = ({
  listItem,
  wrapperClassName,
  sperator,
  details = defaultDetails,
  textClassName = "",
  onClick = NOOP
}) => {
  return /* @__PURE__ */ jsxs("div", { className: classNames67(wrapperClassName), onClick, children: [
    /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
      /* @__PURE__ */ jsx("div", { className: "flex items-center", children: /* @__PURE__ */ jsx(
        Icon3,
        {
          name: "ellipse",
          className: `text-[8px]`,
          style: { color: listItem.color }
        }
      ) }),
      /* @__PURE__ */ jsxs(
        "div",
        {
          className: classNames67(
            "pl-3 text-sm text-[#626F86] font-normal whitespace-nowrap flex",
            textClassName
          ),
          children: [
            /* @__PURE__ */ jsx(
              TruncatedText,
              {
                value: details[listItem.name],
                className: "inline-block"
              }
            ),
            sperator && `  ${sperator}`
          ]
        }
      )
    ] }),
    /* @__PURE__ */ jsx("div", { className: "pl-5 text-base font-semibold whitespace-nowrap", children: listItem.count })
  ] });
};
var SearchableDropdown = ({
  loadMore,
  data,
  onSelectedOptionsChange,
  isLast,
  onSearchChange,
  totalElements,
  isStepLevelApproach,
  customLabel
}) => {
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const ALL_OPTIONS_UUIDS = ["all-urls", "all-testcases", "all-pages"];
  const selectedItems = useRef(null);
  const dropdownRef = useRef(null);
  const containerRef = useRef(null);
  const [dropdownHeight, setDropdownHeight] = useState("450px");
  useEffect(() => {
    if (selectedItems?.current && dropdownRef?.current) {
      const viewportHeight = window.innerHeight;
      const dropdownRect = dropdownRef.current.getBoundingClientRect();
      const availableHeight = viewportHeight - dropdownRect.top - 20;
      const contentHeight = Math.min(450, availableHeight);
      setDropdownHeight(`${contentHeight}px`);
    }
  }, [selectedItems?.current?.clientHeight, isDropdownOpen]);
  use_click_outside_default(
    containerRef,
    () => {
      setIsDropdownOpen(false);
    },
    isDropdownOpen
  );
  const toggleDropdown = useCallback(() => {
    setIsDropdownOpen((prevState) => !prevState);
  }, []);
  const handleCheckboxChange = useCallback(
    (uuid) => {
      setSelectedOptions((prevSelected) => {
        const isAllOption = ALL_OPTIONS_UUIDS.includes(uuid);
        if (isAllOption) {
          if (prevSelected.includes(uuid)) {
            return [];
          } else {
            return [
              uuid,
              ...data.filter((item) => !ALL_OPTIONS_UUIDS.includes(item.uuid)).map((item) => item.uuid)
            ];
          }
        }
        const newSelected = prevSelected.includes(uuid) ? prevSelected.filter(
          (option) => option !== uuid && !ALL_OPTIONS_UUIDS.includes(option)
        ) : [
          ...prevSelected.filter(
            (option) => !ALL_OPTIONS_UUIDS.includes(option)
          ),
          uuid
        ];
        const nonAllItems = data.filter(
          (item) => !ALL_OPTIONS_UUIDS.includes(item.uuid)
        );
        if (newSelected.length === nonAllItems.length) {
          const currentAllOption = data.find(
            (item) => ALL_OPTIONS_UUIDS.includes(item.uuid)
          )?.uuid;
          return currentAllOption ? [currentAllOption, ...newSelected] : newSelected;
        }
        return newSelected;
      });
    },
    [data]
  );
  const handleRemoveOption = useCallback(
    (uuid) => {
      setSelectedOptions((prevSelected) => {
        const newSelected = prevSelected.filter(
          (option) => option !== uuid && !ALL_OPTIONS_UUIDS.includes(option)
        );
        const nonAllItems = data.filter(
          (item) => !ALL_OPTIONS_UUIDS.includes(item.uuid)
        );
        if (newSelected.length === nonAllItems.length) {
          const currentAllOption = data.find(
            (item) => ALL_OPTIONS_UUIDS.includes(item.uuid)
          )?.uuid;
          return currentAllOption ? [currentAllOption, ...newSelected] : newSelected;
        }
        return newSelected;
      });
    },
    [data]
  );
  const handleSearchChange = (value) => {
    setSearchTerm(value);
    onSearchChange(value);
  };
  const prevDeps = useRef({ selectedOptions, data, onSelectedOptionsChange });
  const selectedOptionTitles = selectedOptions.reduce((acc, uuid) => {
    const option = data.find((opt) => opt.uuid === uuid);
    if (option) {
      acc.push(option.title ? option.title : "Untitled");
    }
    return acc;
  }, []).join(", ");
  useEffect(() => {
    const currentDeps = { selectedOptions, data, onSelectedOptionsChange };
    for (const key in currentDeps) {
      if (currentDeps[key] !== prevDeps.current[key]) {
        ({
          from: prevDeps.current[key],
          to: currentDeps[key]
        });
      }
    }
    prevDeps.current = currentDeps;
    const selectedOptionObjects = data.filter(
      (option) => selectedOptions.includes(option.uuid)
    );
    onSelectedOptionsChange(selectedOptionObjects);
  }, [selectedOptions, data]);
  const getDefaultLabel = () => {
    if (customLabel) {
      return `${customLabel} (${totalElements})`;
    }
    return isStepLevelApproach ? `All TestCases (${totalElements})` : `All URLs (${totalElements})`;
  };
  return /* @__PURE__ */ jsxs("div", { className: "relative", ref: containerRef, children: [
    /* @__PURE__ */ jsxs(
      SecondaryButton,
      {
        className: "border rounded bg-secondary-50 flex items-center justify-between w-full",
        onClick: toggleDropdown,
        children: [
          /* @__PURE__ */ jsx(
            TruncatedText,
            {
              className: "text-base font-medium text-secondary-unique-800 text-left",
              value: selectedOptions.length > 0 ? selectedOptionTitles : getDefaultLabel()
            }
          ),
          /* @__PURE__ */ jsx(
            Icon3,
            {
              name: "expand-more",
              className: classNames67("cursor-pointer text-unique-800 text-xl")
            }
          )
        ]
      }
    ),
    isDropdownOpen && /* @__PURE__ */ jsxs(
      "div",
      {
        ref: dropdownRef,
        className: "absolute p-2 rounded-md shadow-mi w-full bg-white z-10 overflow-hidden",
        style: { height: dropdownHeight },
        children: [
          /* @__PURE__ */ jsxs("div", { ref: selectedItems, children: [
            (data?.length > 10 || searchTerm) && /* @__PURE__ */ jsx(
              DebouncedSearchInput,
              {
                type: "text",
                placeholder: "Search",
                value: searchTerm,
                onChange: handleSearchChange,
                inputClassName: "!py-1.5 !px-2.5 leading-4 !text-medium",
                wrapperClassName: "flex-1 w-full",
                className: "w-full border border-gray-300 rounded-md",
                suffixIconName: "search",
                suffixIconClassName: "text-base text-secondary-600 flex items-center pr-2"
              }
            ),
            /* @__PURE__ */ jsx("div", { className: "flex flex-wrap mt-2 bg-secondary-50 max-h-[90px] overflow-y-auto items-start", children: selectedOptions.map((uuid) => {
              const option = data.find((opt) => opt.uuid === uuid);
              if (!option || ALL_OPTIONS_UUIDS.includes(option.uuid)) {
                return null;
              }
              return /* @__PURE__ */ jsxs(
                "div",
                {
                  className: "m-1.5 px-2 py-0.5 flex border items-center text-secondary-800 bg-white rounded-[18px] text-sm break-all",
                  children: [
                    option.title ? option.title : "Untitled",
                    /* @__PURE__ */ jsx(
                      "button",
                      {
                        className: "ml-2 text-secondary-600 leading-[0]",
                        onClick: () => handleRemoveOption(uuid),
                        children: /* @__PURE__ */ jsx(Icon3, { name: "close" })
                      }
                    )
                  ]
                },
                option.uuid
              );
            }) })
          ] }),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "flex-1 overflow-hidden",
              style: {
                height: `calc(100% - ${selectedItems?.current?.clientHeight || 0}px)`
              },
              children: data.length > 0 ? /* @__PURE__ */ jsx("div", { className: "h-full overflow-auto", children: /* @__PURE__ */ jsx(
                InfiniteScroll,
                {
                  rowHeight: 36,
                  itemRender: ({ item }) => /* @__PURE__ */ jsx(
                    Checkbox,
                    {
                      size: "small",
                      checked: selectedOptions.includes(item.uuid),
                      onChange: () => handleCheckboxChange(item.uuid),
                      labelClassName: "border-b-secondary-200 border-b-[0.5px] py-2 text-sm leading-4 truncate w-full",
                      label: /* @__PURE__ */ jsx(
                        TruncatedText,
                        {
                          className: "text-base font-medium text-secondary-unique-800 text-left inline-block",
                          value: /* @__PURE__ */ jsxs("span", { className: "w-full", children: [
                            item.title ? item.title : "Untitled",
                            item.pageUrl && /* @__PURE__ */ jsxs("span", { className: "text-gray-400", children: [
                              "(",
                              item.pageUrl,
                              ")"
                            ] })
                          ] })
                        }
                      )
                    },
                    item.uuid
                  ),
                  LoadingComponent: /* @__PURE__ */ jsx("div", { className: "empty-page-loader mt-[25%] mx-auto" }),
                  items: data,
                  loadMore,
                  hasMore: !isLast
                }
              ) }) : /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center text-small leading-[18px] mt-20 basis-full", children: [
                /* @__PURE__ */ jsx(
                  Icon3,
                  {
                    name: "search",
                    className: "inline-block cursor-pointer text-primary-500 text-5xl"
                  }
                ),
                /* @__PURE__ */ jsx(
                  "div",
                  {
                    className: "font-semibold text-secondary-700 py-6 basis-full text-center",
                    children: "Entities not found"
                  }
                )
              ] })
            }
          )
        ]
      }
    )
  ] });
};
var Bar2 = ({
  label,
  value,
  maxValue,
  isMobile
}) => {
  const percentage = Math.min(value / maxValue * 100, 100);
  return /* @__PURE__ */ jsx(Fragment, { children: isMobile ? /* @__PURE__ */ jsxs(
    "div",
    {
      className: "flex flex-col mb-3",
      role: "group",
      "aria-label": `${label}: ${value}`,
      children: [
        /* @__PURE__ */ jsx("div", { className: "text-sm text-secondary-500 mb-1 whitespace-normal break-words", children: label }),
        /* @__PURE__ */ jsxs("div", { className: "flex items-center", children: [
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "relative w-2/3 bg-secondary-100 h-2 rounded-md mr-2",
              "aria-hidden": "true",
              children: /* @__PURE__ */ jsx(
                "div",
                {
                  className: "absolute top-0 left-0 h-full bg-primary-500 rounded-md",
                  style: {
                    width: `${percentage}%`,
                    transition: "width 0.3s ease-in-out"
                  }
                }
              )
            }
          ),
          /* @__PURE__ */ jsx(
            "div",
            {
              className: "text-sm text-primary-900 ml-auto w-6 text-right",
              title: String(value),
              children: value
            }
          )
        ] })
      ]
    }
  ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center mb-3", children: [
    /* @__PURE__ */ jsx("div", { className: "text-sm text-secondary-500 w-1/3 pr-2", children: label }),
    /* @__PURE__ */ jsx("div", { className: "relative w-2/3 bg-secondary-100 h-2 rounded-md mr-2", children: /* @__PURE__ */ jsx(
      "div",
      {
        className: "absolute top-0 left-0 h-full bg-primary-500 rounded-md",
        style: {
          width: `${percentage}%`,
          transition: "width 0.3s ease-in-out"
        }
      }
    ) }),
    /* @__PURE__ */ jsx("div", { className: "text-sm text-primary-900 ml-auto w-3", children: value })
  ] }) });
};
var FieldLayout = ({
  row,
  fields,
  values = {},
  errors = {},
  onAction = noop
}) => {
  const renderField = (fieldId) => {
    const { renderOptions = {}, renderer: Field } = fields[fieldId];
    const {
      // size,
      fieldKey: fieldKeyFromRenderOptions,
      valuesSelector = [],
      valueFormatter = identity
    } = renderOptions;
    const fieldKey = fieldKeyFromRenderOptions || fieldId;
    if (!Field) return null;
    return /* @__PURE__ */ createElement(
      Field,
      {
        id: fieldId,
        ...renderOptions,
        ...pick(values, compact(valuesSelector)),
        key: fieldKey,
        error: get(errors, fieldId),
        value: valueFormatter(get(values, fieldId)),
        onAction
      }
    );
  };
  const renderColumn = (column) => {
    const { rows } = column;
    if (typeof column === "string") return renderField(column);
    return /* @__PURE__ */ jsx(Fragment, { children: compact(rows).map(renderRow) });
  };
  const renderRow = (row2) => {
    const { id, className: className2, columns } = row2;
    const _columns = compact(castArray(columns));
    if (isEmpty(_columns)) return null;
    return /* @__PURE__ */ jsx("div", { id: id || void 0, className: className2, children: _columns.map(renderColumn) });
  };
  return renderRow(row);
};
var field_layout_default = FieldLayout;
var Section = ({ id, rows, className: className2, ...rest }) => {
  const renderFieldLayout = (row, rowIndex) => /* @__PURE__ */ jsx(field_layout_default, { row, ...rest }, row?.key || rowIndex);
  const renderSectionChildren = (_rows) => map(_rows, renderFieldLayout);
  return /* @__PURE__ */ jsx("section", { id: id || void 0, className: classNames67("pb-3 py-0", className2), children: renderSectionChildren(compact(rows)) });
};
var section_default = Section;
var FormBuilder = ({
  sections,
  id,
  className: className2,
  style,
  innerRef,
  ...rest
}) => {
  const renderSection = (section, sectionIndex) => /* @__PURE__ */ createElement(section_default, { ...section, id: `section-${id}-${sectionIndex}`, key: sectionIndex, ...rest });
  return /* @__PURE__ */ jsx(
    "div",
    {
      id: id || void 0,
      "data-testid": id || void 0,
      className: classNames67("bg-transparent", className2),
      style,
      ref: innerRef,
      children: map(compact(sections), renderSection)
    }
  );
};
var form_builder_default = FormBuilder;

// src/form-builder/field-renderers/index.tsx
var field_renderers_exports = {};
__export(field_renderers_exports, {
  AutoComplete: () => auto_complete_default,
  Checkbox: () => checkbox_default,
  DropdownButton: () => dropdown_button_default,
  Icon: () => icon_default,
  Input: () => input_default,
  Label: () => label_default,
  Switch: () => switch_default,
  Textarea: () => textarea_default
});

// src/form-builder/constants.ts
var FORM_BUILDER_ACTION_TYPES = {
  INIT: "INIT",
  RESET: "RESET",
  SUBMIT_FORM: "SUBMIT_FORM",
  ON_FIELD_CHANGE: "ON_FIELD_CHANGE",
  ON_BULK_FIELD_CHANGE: "ON_BULK_FIELD_CHANGE",
  ON_FIELD_FOCUS: "ON_FIELD_FOCUS",
  ON_FIELD_BLUR: "ON_FIELD_BLUR",
  ON_FIELD_VALIDATE: "ON_FIELD_VALIDATE",
  ON_FETCH_OPTIONS_ASYNC: "ON_FETCH_OPTIONS_ASYNC",
  ON_CLICK: "ON_CLICK"
};
var Checkbox2 = (props) => {
  const { id: key, onAction } = props;
  const onChange = (value) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value }
    });
  };
  return /* @__PURE__ */ jsx(Checkbox, { ...props, onChange });
};
var checkbox_default = Checkbox2;
var Input3 = (props) => {
  const { id: key, onAction, error } = props;
  const onChange = (value) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value }
    });
  };
  return /* @__PURE__ */ jsx(
    Input,
    {
      ...props,
      hasError: !!error,
      errorText: error?.message,
      onChange
    }
  );
};
var input_default = Input3;
var DropdownButton2 = (props) => {
  const { id: key, onAction, error, options, value: selectedValue } = props;
  const { t } = useTranslation();
  const keyByOptions = useMemo(
    () => keyBy(options, ({ value }) => value),
    [options]
  );
  const onClick = (value) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value }
    });
  };
  return /* @__PURE__ */ jsx(
    DropdownButton,
    {
      ...props,
      hasError: !!error,
      errorText: error?.message,
      name: keyByOptions[selectedValue]?.i18n,
      children: map(options, ({ value, i18n: i18n2 }) => /* @__PURE__ */ jsx(
        DropdownItem,
        {
          onClick: () => onClick(value),
          isSelected: selectedValue == value,
          children: t(i18n2)
        },
        value
      ))
    }
  );
};
var dropdown_button_default = DropdownButton2;
var Label3 = ({
  label = "",
  iconName = "",
  containerClassName = "",
  iconClassName = "",
  labelClassName = ""
}) => {
  const className2 = classNames67(
    "text-unique-600 text-small leading-5 font-medium",
    labelClassName
  );
  return /* @__PURE__ */ jsxs("div", { className: classNames67("flex gap-2 items-center", containerClassName), children: [
    iconName && /* @__PURE__ */ jsx(
      Icon3,
      {
        name: iconName,
        className: classNames67("text-xl leading-5 text-unique-800", iconClassName)
      }
    ),
    /* @__PURE__ */ jsx("div", { className: className2, children: label })
  ] });
};
var label_default = Label3;
var Switch = (props) => {
  const { id: key, onAction, value } = props;
  const onChange = (value2) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value: value2 }
    });
  };
  return /* @__PURE__ */ jsx(ToggleSwitch, { ...props, onChange, checked: value });
};
var switch_default = Switch;
var Textarea = (props) => {
  const { id: key, onAction, error } = props;
  const onChange = (value) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value }
    });
  };
  return /* @__PURE__ */ jsx(
    TextArea,
    {
      ...props,
      hasError: !!error,
      errorText: error?.message,
      onChange
    }
  );
};
var textarea_default = Textarea;
var AutoComplete2 = (props) => {
  const { id: key, onAction } = props;
  const onSelect = (value) => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
      payload: { key, value }
    });
  };
  const optionsHook = async (searchQuery) => {
    try {
      const result = await onAction({
        type: FORM_BUILDER_ACTION_TYPES.ON_FETCH_OPTIONS_ASYNC,
        payload: { searchQuery }
      });
      return Array.isArray(result) ? result : [result];
    } catch (error) {
      return [];
    }
  };
  return /* @__PURE__ */ jsx(
    AutoComplete,
    {
      ...omit(props, ["onAction"]),
      onSelect,
      optionsHook
    }
  );
};
var auto_complete_default = AutoComplete2;
var Icon4 = (props) => {
  const { id: key, onAction, ...rest } = props;
  const onClick = () => {
    onAction({
      type: FORM_BUILDER_ACTION_TYPES.ON_CLICK,
      payload: { key }
    });
  };
  return /* @__PURE__ */ jsx(Icon3, { ...rest, onClick });
};
var icon_default = Icon4;

// src/form-builder/utils.ts
var onFieldChange = (onAction) => (newValues) => onAction({
  type: FORM_BUILDER_ACTION_TYPES.ON_FIELD_CHANGE,
  payload: newValues
});
var DropDownWithSearchAndPagination = ({
  selectedItemDisplay,
  label,
  className: className2,
  placement,
  onSearch,
  items: items2,
  selectedItem,
  onSelectItem,
  renderItem,
  isLoading,
  hasMore,
  loadMore,
  rowHeight = 35,
  totalPages,
  optionsFooter,
  disabled = false,
  isRequired = false,
  dropdownItemClassName = () => "",
  loadingComponent
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [value, setValue] = useState("");
  const { t } = useTranslation();
  const onInputChange = (val) => {
    setValue(val);
    onSearch(val);
  };
  return /* @__PURE__ */ jsx(
    DropdownButton,
    {
      name: selectedItemDisplay,
      label,
      isRequired,
      variant: "select-fill",
      placement: placement || "bottom",
      dropdownClassName: "h-full !overflow-hidden",
      wrapperClassName: className2,
      labelClassName: "mb-1",
      onClick: () => {
        setValue("");
        setIsOpen(!isOpen);
      },
      isOpen,
      hideOnChildClick: false,
      disabled,
      setIsOpen,
      children: /* @__PURE__ */ jsxs("div", { className: "w-full h-full", children: [
        /* @__PURE__ */ jsx(
          DebouncedSearchInput,
          {
            prefixIconName: "search",
            prefixIconClassName: "text-base text-secondary-600 flex items-center pl-3",
            inputClassName: "",
            showClearIcon: true,
            value,
            onChange: onInputChange,
            placeholder: t("common.search"),
            wrapperClassName: "outline-none w-full bg-white p-md sticky top-0 z-10",
            isDisabled: disabled
          }
        ),
        /* @__PURE__ */ jsx(
          "div",
          {
            className: classNames67("w-full h-content", {
              "!h-[calc(100%-120px)]": !!optionsFooter
            }),
            children: items2?.length ? /* @__PURE__ */ jsx(
              VirtualizedInfiniteLoader_default,
              {
                rowHeight,
                rowRenderer: (index) => {
                  const item = items2[index];
                  return /* @__PURE__ */ jsx(
                    DropdownItem,
                    {
                      onClick: () => {
                        onSelectItem(item);
                        setValue("");
                        setIsOpen(false);
                      },
                      className: dropdownItemClassName(
                        item,
                        item === selectedItem
                      ),
                      isSelected: item === selectedItem,
                      isDisabled: disabled,
                      children: renderItem(item)
                    }
                  );
                },
                ...loadingComponent && {
                  LoadingComponent: loadingComponent
                },
                rowCount: items2?.length || 0,
                items: items2,
                loadMore,
                hasMore,
                isLoading,
                totalPages
              }
            ) : /* @__PURE__ */ jsxs("div", { className: "flex items-center flex-wrap justify-center text-small leading-[18px] basis-full h-full", children: [
              /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "search",
                  className: "inline-block cursor-pointer text-primary-500 text-5xl"
                }
              ),
              /* @__PURE__ */ jsx(
                "div",
                {
                  className: "font-semibold text-secondary-700 py-6 basis-full text-center",
                  children: t("common.search_not_found")
                }
              )
            ] })
          }
        ),
        !!optionsFooter && /* @__PURE__ */ jsxs("div", { className: "w-full overflow-hidden sticky bottom-0 py-2 bg-white", children: [
          /* @__PURE__ */ jsx(Divider, { type: "solid", className: "pb-2" }),
          optionsFooter
        ] })
      ] })
    }
  );
};
var drop_down_with_search_pagination_default = DropDownWithSearchAndPagination;
var FilterAccordion = ({
  children,
  label,
  wrapperClassName = "",
  componentClassName = "",
  labelClassName = "",
  suffix
}) => {
  const [isExpanded, setIsExpanded] = useState(false);
  return /* @__PURE__ */ jsx(
    Expandable,
    {
      isExpanded,
      onChange: () => setIsExpanded(!isExpanded),
      wrapperClassName: classNames67(
        "py-2 px-3 mb-0.5 cursor-pointer",
        {
          "hover:bg-secondary-50": !isExpanded
        },
        wrapperClassName
      ),
      suffix,
      expandLabel: label,
      collapseLabel: label,
      labelClassName,
      children: /* @__PURE__ */ jsx(
        "div",
        {
          className: classNames67(
            "bg-secondary-50 mt-1 px-3 py-2 rounded-lg",
            componentClassName
          ),
          children
        }
      )
    }
  );
};
var filter_accordion_default = FilterAccordion;
var FilterAccordionWrapper = ({
  children,
  label,
  wrapperClassName,
  componentClassName,
  ...otherProps
}) => {
  const Component = children;
  return /* @__PURE__ */ jsx(
    filter_accordion_default,
    {
      label,
      wrapperClassName,
      componentClassName,
      children: /* @__PURE__ */ jsx(Component, { ...otherProps })
    }
  );
};
var filter_accordion_wrapper_default = FilterAccordionWrapper;
var FilterBody = ({ children, wrapperClassName = "" }) => {
  return /* @__PURE__ */ jsx(
    "div",
    {
      className: classNames67(
        "flex-1 overflow-y-auto max-h-[calc(100%_-_96px)]",
        wrapperClassName
      ),
      children
    }
  );
};
var filter_body_default = FilterBody;
var FilterFooter = ({ children, wrapperClassName = "" }) => {
  return /* @__PURE__ */ jsx(
    "footer",
    {
      className: classNames67(
        "px-4 py-3 shadow-xs sticky bottom-0 flex items-center justify-between bg-white w-full",
        wrapperClassName
      ),
      children
    }
  );
};
var filter_footer_default = FilterFooter;
var FilterHeader = ({ children, wrapperClassName = "" }) => {
  return /* @__PURE__ */ jsx(
    "header",
    {
      className: classNames67(
        "flex items-center justify-between border-b border-b-secondary-200 p-3 sticky top-0 bg-white",
        wrapperClassName
      ),
      children
    }
  );
};
var filter_header_default = FilterHeader;
var offsetModifier6 = [
  {
    name: "offset",
    options: {
      offset: [-6, 8]
    }
  }
];
var FilterRoot = ({
  showDropdown,
  isAnyFilterApplied,
  toggleDropdown,
  children,
  wrapperClassName = "",
  position = "bottom-end",
  title = "",
  tooltipContent = "",
  buttonClassName = "!px-[5px] !rounded-md shadow-sm border-secondary-300 !h-6.5 justify-center",
  filterAppliedClassName = "w-2 h-2 bg-error-600 rounded-full absolute top-2 left-4 right-1 border border-white"
}) => {
  const [dropdownRef, setDropdownRef] = useState(null);
  const buttonRef = useRef(null);
  const { styles: styles2, attributes } = usePopper(buttonRef.current, dropdownRef, {
    placement: position,
    strategy: "absolute",
    modifiers: offsetModifier6
  });
  const { t } = useTranslation();
  return /* @__PURE__ */ jsxs(Fragment, { children: [
    /* @__PURE__ */ jsx("div", { ref: buttonRef, className: "relative", children: /* @__PURE__ */ jsx(
      ToolTip,
      {
        content: tooltipContent || t("common.filters.label"),
        placement: "bottom",
        className: "flex align-baseline",
        children: /* @__PURE__ */ jsxs(
          Button,
          {
            onClick: () => toggleDropdown(true),
            type: "light",
            "aria-label": tooltipContent || t("common.filters.label"),
            className: classNames67(buttonClassName, {
              "w-auto": !title,
              "w-[auto] !min-w-[80px]": title
            }),
            children: [
              /* @__PURE__ */ jsx(
                Icon3,
                {
                  name: "filter-list",
                  className: "text-lg rotate-180 text-secondary-700 cursor-pointer mt-1"
                }
              ),
              title && /* @__PURE__ */ jsx("div", { className: "text-2xs font-medium ml-1", children: t(title) }),
              isAnyFilterApplied && /* @__PURE__ */ jsx("div", { className: filterAppliedClassName })
            ]
          }
        )
      }
    ) }),
    showDropdown && /* @__PURE__ */ jsx(
      Dropdown,
      {
        closeOnClickOutside: false,
        isAnimationEnabled: false,
        setRef: setDropdownRef,
        toggleDropdown,
        style: styles2.popper,
        buttonRef,
        className: classNames67(
          "w-[320px] z-[1000] border border-secondary-200 overflow-y-hidden rounded-lg !shadow-xl flex flex-col",
          wrapperClassName
        ),
        attributes: attributes.popper,
        children
      }
    )
  ] });
};
var filter_root_default = FilterRoot;

// src/filters/index.tsx
var Filters = {
  Root: filter_root_default,
  Header: filter_header_default,
  Body: filter_body_default,
  Footer: filter_footer_default,
  Accordion: filter_accordion_default,
  FilterAccordionWrapper: filter_accordion_wrapper_default
};

// src/hooks/use-input-text-validation/field-handlers/handle-field-update.ts
var handleFieldUpdate = ({
  setValue,
  fieldName,
  value,
  shouldTrigger,
  options = {
    shouldValidate: true,
    shouldDirty: true,
    shouldTouch: true
  }
}) => {
  const {
    shouldValidate = true,
    shouldDirty = true,
    shouldTouch = true
  } = options;
  setValue(fieldName, value, {
    shouldValidate,
    shouldDirty,
    shouldTouch
  });
  if (shouldTrigger) {
    shouldTrigger();
  }
};
var capitalizeFirstLetter = (string2) => {
  if (typeof string2 !== "string" || string2.length === 0) return string2;
  return capitalize(string2);
};
var useInputTextValidationSchema = (fieldLabel, options = {}) => {
  const { t } = useTranslation();
  const {
    isRequired = true,
    minLength = isRequired === false || options?.hasDescription ? 0 : 1,
    // Default minLength 0 for descriptions, 1 for names, 0 if isRequired specified as false
    maxLength = options?.hasDescription ? 1e3 : 250,
    // Default maxLength 1000 for descriptions, 250 for names
    allowNewline = options?.hasDescription ?? false
    // Allow new lines for descriptions
  } = options;
  let schema = yup.string().trim();
  if (!allowNewline) {
    schema = schema.test(
      "no-newline",
      t("user.name.nonewline", {
        fieldLabel: capitalizeFirstLetter(fieldLabel)
      }),
      (value) => !/\n/.test(value || "")
    );
  }
  if (minLength > 0) {
    if (isRequired) {
      schema = schema.test(
        "required",
        t("user.name.required", {
          fieldLabel: capitalizeFirstLetter(fieldLabel)
        }),
        (value) => Boolean(value)
      );
    }
    schema = schema.test(
      "min-length",
      t("user.name.minlength", {
        fieldLabel: capitalizeFirstLetter(fieldLabel),
        minLength
      }),
      (value) => value && value.length >= minLength
    ).min(
      minLength,
      t("user.name.minlength", {
        fieldLabel: capitalizeFirstLetter(fieldLabel),
        minLength
      })
    );
  }
  schema = schema.max(
    maxLength,
    t("user.name.maxlength", {
      fieldLabel: capitalizeFirstLetter(fieldLabel),
      maxLength
    })
  );
  return schema;
};

// src/hooks/use-input-text-validation/constants.ts
var FIELD_NAMES = {
  NAME: "name",
  DESCRIPTION: "description"
};

// src/tree/utils.ts
var find = (id, node) => {
  if (node.id == id) {
    return node;
  }
  if (!node.children) {
    return void 0;
  }
  for (let index = 0; index < (node.children?.length || 0); index++) {
    const result = find(id, node.children[index]);
    if (result) {
      return result;
    }
  }
  return void 0;
};
var findNode = (id, tree) => {
  let result = void 0;
  for (const element of tree) {
    result = find(id, element);
    if (result) {
      break;
    }
  }
  return result;
};
var deleteNode = (nodes, id) => nodes.filter((node) => node.id != id).map((node) => {
  if (node.children) {
    return { ...node, children: deleteNode(node.children, id) };
  }
  return node;
});
var sortAlphabetically = (array) => {
  const newArray = [...array];
  newArray.sort((a, b) => {
    const lowerCaseNameA = a.name.toLowerCase();
    const lowerCaseNameB = b.name.toLowerCase();
    if (lowerCaseNameA < lowerCaseNameB) {
      return -1;
    }
    if (lowerCaseNameA > lowerCaseNameB) {
      return 1;
    }
    return 0;
  });
  return newArray;
};
var addNode = (nodes, parentId, newNodes) => {
  if (!parentId) {
    const newArray = sortAlphabetically([...newNodes, ...nodes]);
    return newArray;
  }
  return nodes.map((node) => {
    if (node.id == parentId) {
      return {
        ...node,
        children: node.children ? sortAlphabetically([...newNodes, ...node.children]) : [...newNodes]
      };
    }
    if (node.children) {
      return {
        ...node,
        // @ts-ignore
        children: addNode(node.children, parentId, ...[newNodes])
      };
    }
    return node;
  });
};
var moveNode = (nodes, id, parentId) => {
  const deletedNode = findNode(id, nodes);
  const treeWithDeletedNode = deleteNode(nodes, id);
  const newTreeWithAddedNode = addNode(treeWithDeletedNode, parentId, [
    deletedNode
  ]);
  return newTreeWithAddedNode;
};
var bulkMoveNodes = (nodes, ids, parentId) => {
  const deletedNodes = [];
  let treeWithDeletedNodes = nodes;
  ids.forEach((id) => {
    const deletedNode = findNode(id, nodes);
    deletedNodes.push(deletedNode);
    treeWithDeletedNodes = deleteNode(treeWithDeletedNodes, id);
  });
  const newTreeWithAddedNodes = addNode(
    treeWithDeletedNodes,
    parentId,
    deletedNodes
  );
  return newTreeWithAddedNodes;
};
var renameNode = (nodes, id, name) => {
  const treeWithRenamedNode = nodes.map((node) => {
    if (node.id == id) {
      return {
        ...node,
        name
      };
    }
    if (node.children) {
      return {
        ...node,
        children: renameNode(node.children, id, name)
      };
    }
    return node;
  });
  return sortAlphabetically(treeWithRenamedNode);
};
var Tree = forwardRef(
  ({
    data,
    width,
    height,
    rowHeight,
    paddingTop,
    paddingBottom,
    overscanCount,
    disableDrag = true,
    disableDrop = true,
    openByDefault = false,
    selectionFollowsFocus = false,
    searchTerm = "",
    onScroll = NOOP,
    renderRow,
    searchMatch
  }, ref) => {
    return /* @__PURE__ */ jsx(
      Tree$1,
      {
        ref,
        data,
        renderRow,
        openByDefault,
        selectionFollowsFocus,
        width,
        height,
        overscanCount,
        rowHeight,
        paddingTop,
        paddingBottom,
        disableDrag,
        disableDrop,
        onScroll,
        searchTerm,
        searchMatch
      }
    );
  }
);
Tree.displayName = "Tree";
var DndContext = createContext({
  dragDropManager: void 0
});

// node_modules/dnd-core/dist/esm/interfaces.js
var HandlerRole;
(function(HandlerRole2) {
  HandlerRole2["SOURCE"] = "SOURCE";
  HandlerRole2["TARGET"] = "TARGET";
})(HandlerRole || (HandlerRole = {}));

// node_modules/@react-dnd/invariant/dist/invariant.esm.js
function invariant(condition, format6) {
  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }
  if (process.env.NODE_ENV !== "production") {
    if (format6 === void 0) {
      throw new Error("invariant requires an error message argument");
    }
  }
  if (!condition) {
    var error;
    if (format6 === void 0) {
      error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
    } else {
      var argIndex = 0;
      error = new Error(format6.replace(/%s/g, function() {
        return args[argIndex++];
      }));
      error.name = "Invariant Violation";
    }
    error.framesToPop = 1;
    throw error;
  }
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/types.js
var INIT_COORDS = "dnd-core/INIT_COORDS";
var BEGIN_DRAG = "dnd-core/BEGIN_DRAG";
var PUBLISH_DRAG_SOURCE = "dnd-core/PUBLISH_DRAG_SOURCE";
var HOVER = "dnd-core/HOVER";
var DROP = "dnd-core/DROP";
var END_DRAG = "dnd-core/END_DRAG";

// node_modules/dnd-core/dist/esm/actions/dragDrop/local/setClientOffset.js
function setClientOffset(clientOffset, sourceClientOffset) {
  return {
    type: INIT_COORDS,
    payload: {
      sourceClientOffset: sourceClientOffset || null,
      clientOffset: clientOffset || null
    }
  };
}

// node_modules/dnd-core/dist/esm/utils/js_utils.js
function _typeof(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof4(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof = function _typeof4(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof(obj);
}
function get2(obj, path, defaultValue) {
  return path.split(".").reduce(function(a, c) {
    return a && a[c] ? a[c] : defaultValue || null;
  }, obj);
}
function without(items2, item) {
  return items2.filter(function(i) {
    return i !== item;
  });
}
function isObject(input) {
  return _typeof(input) === "object";
}
function xor(itemsA, itemsB) {
  var map2 = /* @__PURE__ */ new Map();
  var insertItem = function insertItem2(item) {
    map2.set(item, map2.has(item) ? map2.get(item) + 1 : 1);
  };
  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  map2.forEach(function(count, key) {
    if (count === 1) {
      result.push(key);
    }
  });
  return result;
}
function intersection(itemsA, itemsB) {
  return itemsA.filter(function(t) {
    return itemsB.indexOf(t) > -1;
  });
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/beginDrag.js
var ResetCoordinatesAction = {
  type: INIT_COORDS,
  payload: {
    clientOffset: null,
    sourceClientOffset: null
  }
};
function createBeginDrag(manager) {
  return function beginDrag() {
    var sourceIds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [];
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
      publishSource: true
    };
    var _options$publishSourc = options.publishSource, publishSource = _options$publishSourc === void 0 ? true : _options$publishSourc, clientOffset = options.clientOffset, getSourceClientOffset2 = options.getSourceClientOffset;
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    manager.dispatch(setClientOffset(clientOffset));
    verifyInvariants(sourceIds, monitor, registry);
    var sourceId = getDraggableSource(sourceIds, monitor);
    if (sourceId === null) {
      manager.dispatch(ResetCoordinatesAction);
      return;
    }
    var sourceClientOffset = null;
    if (clientOffset) {
      if (!getSourceClientOffset2) {
        throw new Error("getSourceClientOffset must be defined");
      }
      verifyGetSourceClientOffsetIsFunction(getSourceClientOffset2);
      sourceClientOffset = getSourceClientOffset2(sourceId);
    }
    manager.dispatch(setClientOffset(clientOffset, sourceClientOffset));
    var source = registry.getSource(sourceId);
    var item = source.beginDrag(monitor, sourceId);
    if (item == null) {
      return void 0;
    }
    verifyItemIsObject(item);
    registry.pinSource(sourceId);
    var itemType = registry.getSourceType(sourceId);
    return {
      type: BEGIN_DRAG,
      payload: {
        itemType,
        item,
        sourceId,
        clientOffset: clientOffset || null,
        sourceClientOffset: sourceClientOffset || null,
        isSourcePublic: !!publishSource
      }
    };
  };
}
function verifyInvariants(sourceIds, monitor, registry) {
  invariant(!monitor.isDragging(), "Cannot call beginDrag while dragging.");
  sourceIds.forEach(function(sourceId) {
    invariant(registry.getSource(sourceId), "Expected sourceIds to be registered.");
  });
}
function verifyGetSourceClientOffsetIsFunction(getSourceClientOffset2) {
  invariant(typeof getSourceClientOffset2 === "function", "When clientOffset is provided, getSourceClientOffset must be a function.");
}
function verifyItemIsObject(item) {
  invariant(isObject(item), "Item must be an object.");
}
function getDraggableSource(sourceIds, monitor) {
  var sourceId = null;
  for (var i = sourceIds.length - 1; i >= 0; i--) {
    if (monitor.canDragSource(sourceIds[i])) {
      sourceId = sourceIds[i];
      break;
    }
  }
  return sourceId;
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/publishDragSource.js
function createPublishDragSource(manager) {
  return function publishDragSource() {
    var monitor = manager.getMonitor();
    if (monitor.isDragging()) {
      return {
        type: PUBLISH_DRAG_SOURCE
      };
    }
  };
}

// node_modules/dnd-core/dist/esm/utils/matchesType.js
function matchesType(targetType, draggedItemType) {
  if (draggedItemType === null) {
    return targetType === null;
  }
  return Array.isArray(targetType) ? targetType.some(function(t) {
    return t === draggedItemType;
  }) : targetType === draggedItemType;
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/hover.js
function createHover(manager) {
  return function hover(targetIdsArg) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, clientOffset = _ref.clientOffset;
    verifyTargetIdsIsArray(targetIdsArg);
    var targetIds = targetIdsArg.slice(0);
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    checkInvariants(targetIds, monitor, registry);
    var draggedItemType = monitor.getItemType();
    removeNonMatchingTargetIds(targetIds, registry, draggedItemType);
    hoverAllTargets(targetIds, monitor, registry);
    return {
      type: HOVER,
      payload: {
        targetIds,
        clientOffset: clientOffset || null
      }
    };
  };
}
function verifyTargetIdsIsArray(targetIdsArg) {
  invariant(Array.isArray(targetIdsArg), "Expected targetIds to be an array.");
}
function checkInvariants(targetIds, monitor, registry) {
  invariant(monitor.isDragging(), "Cannot call hover while not dragging.");
  invariant(!monitor.didDrop(), "Cannot call hover after drop.");
  for (var i = 0; i < targetIds.length; i++) {
    var targetId = targetIds[i];
    invariant(targetIds.lastIndexOf(targetId) === i, "Expected targetIds to be unique in the passed array.");
    var target = registry.getTarget(targetId);
    invariant(target, "Expected targetIds to be registered.");
  }
}
function removeNonMatchingTargetIds(targetIds, registry, draggedItemType) {
  for (var i = targetIds.length - 1; i >= 0; i--) {
    var targetId = targetIds[i];
    var targetType = registry.getTargetType(targetId);
    if (!matchesType(targetType, draggedItemType)) {
      targetIds.splice(i, 1);
    }
  }
}
function hoverAllTargets(targetIds, monitor, registry) {
  targetIds.forEach(function(targetId) {
    var target = registry.getTarget(targetId);
    target.hover(monitor, targetId);
  });
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/drop.js
function ownKeys(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function(key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function createDrop(manager) {
  return function drop() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyInvariants2(monitor);
    var targetIds = getDroppableTargets(monitor);
    targetIds.forEach(function(targetId, index) {
      var dropResult = determineDropResult(targetId, index, registry, monitor);
      var action = {
        type: DROP,
        payload: {
          dropResult: _objectSpread(_objectSpread({}, options), dropResult)
        }
      };
      manager.dispatch(action);
    });
  };
}
function verifyInvariants2(monitor) {
  invariant(monitor.isDragging(), "Cannot call drop while not dragging.");
  invariant(!monitor.didDrop(), "Cannot call drop twice during one drag operation.");
}
function determineDropResult(targetId, index, registry, monitor) {
  var target = registry.getTarget(targetId);
  var dropResult = target ? target.drop(monitor, targetId) : void 0;
  verifyDropResultType(dropResult);
  if (typeof dropResult === "undefined") {
    dropResult = index === 0 ? {} : monitor.getDropResult();
  }
  return dropResult;
}
function verifyDropResultType(dropResult) {
  invariant(typeof dropResult === "undefined" || isObject(dropResult), "Drop result must either be an object or undefined.");
}
function getDroppableTargets(monitor) {
  var targetIds = monitor.getTargetIds().filter(monitor.canDropOnTarget, monitor);
  targetIds.reverse();
  return targetIds;
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/endDrag.js
function createEndDrag(manager) {
  return function endDrag() {
    var monitor = manager.getMonitor();
    var registry = manager.getRegistry();
    verifyIsDragging(monitor);
    var sourceId = monitor.getSourceId();
    if (sourceId != null) {
      var source = registry.getSource(sourceId, true);
      source.endDrag(monitor, sourceId);
      registry.unpinSource();
    }
    return {
      type: END_DRAG
    };
  };
}
function verifyIsDragging(monitor) {
  invariant(monitor.isDragging(), "Cannot call endDrag while not dragging.");
}

// node_modules/dnd-core/dist/esm/actions/dragDrop/index.js
function createDragDropActions(manager) {
  return {
    beginDrag: createBeginDrag(manager),
    publishDragSource: createPublishDragSource(manager),
    hover: createHover(manager),
    drop: createDrop(manager),
    endDrag: createEndDrag(manager)
  };
}

// node_modules/dnd-core/dist/esm/classes/DragDropManagerImpl.js
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty2(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DragDropManagerImpl = /* @__PURE__ */ (function() {
  function DragDropManagerImpl2(store, monitor) {
    var _this = this;
    _classCallCheck(this, DragDropManagerImpl2);
    _defineProperty2(this, "store", void 0);
    _defineProperty2(this, "monitor", void 0);
    _defineProperty2(this, "backend", void 0);
    _defineProperty2(this, "isSetUp", false);
    _defineProperty2(this, "handleRefCountChange", function() {
      var shouldSetUp = _this.store.getState().refCount > 0;
      if (_this.backend) {
        if (shouldSetUp && !_this.isSetUp) {
          _this.backend.setup();
          _this.isSetUp = true;
        } else if (!shouldSetUp && _this.isSetUp) {
          _this.backend.teardown();
          _this.isSetUp = false;
        }
      }
    });
    this.store = store;
    this.monitor = monitor;
    store.subscribe(this.handleRefCountChange);
  }
  _createClass(DragDropManagerImpl2, [{
    key: "receiveBackend",
    value: function receiveBackend(backend) {
      this.backend = backend;
    }
  }, {
    key: "getMonitor",
    value: function getMonitor() {
      return this.monitor;
    }
  }, {
    key: "getBackend",
    value: function getBackend() {
      return this.backend;
    }
  }, {
    key: "getRegistry",
    value: function getRegistry() {
      return this.monitor.registry;
    }
  }, {
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      function bindActionCreator(actionCreator) {
        return function() {
          for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }
          var action = actionCreator.apply(manager, args);
          if (typeof action !== "undefined") {
            dispatch(action);
          }
        };
      }
      var actions = createDragDropActions(this);
      return Object.keys(actions).reduce(function(boundActions, key) {
        var action = actions[key];
        boundActions[key] = bindActionCreator(action);
        return boundActions;
      }, {});
    }
  }, {
    key: "dispatch",
    value: function dispatch(action) {
      this.store.dispatch(action);
    }
  }]);
  return DragDropManagerImpl2;
})();

// node_modules/dnd-core/node_modules/redux/es/redux.js
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or use the non-minified dev environment for full errors. ";
}
var $$observable = (function() {
  return typeof Symbol === "function" && Symbol.observable || "@@observable";
})();
var randomString = function randomString2() {
  return Math.random().toString(36).substring(7).split("").join(".");
};
var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString()};
function isPlainObject(obj) {
  if (typeof obj !== "object" || obj === null) return false;
  var proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto;
}
function miniKindOf(val) {
  if (val === void 0) return "undefined";
  if (val === null) return "null";
  var type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val)) return "array";
  if (isDate(val)) return "date";
  if (isError(val)) return "error";
  var constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return type.slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  var typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}
function createStore(reducer, preloadedState, enhancer) {
  var _ref2;
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }
    return enhancer(createStore)(reducer, preloadedState);
  }
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }
  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    var listeners = currentListeners = nextListeners;
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }
    currentReducer = nextReducer;
    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  function observable() {
    var _ref;
    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe2(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }
        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }
        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      }
    }, _ref[$$observable] = function() {
      return this;
    }, _ref;
  }
  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch,
    subscribe,
    getState,
    replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}

// node_modules/dnd-core/dist/esm/utils/equality.js
var strictEquality = function strictEquality2(a, b) {
  return a === b;
};
function areCoordsEqual(offsetA, offsetB) {
  if (!offsetA && !offsetB) {
    return true;
  } else if (!offsetA || !offsetB) {
    return false;
  } else {
    return offsetA.x === offsetB.x && offsetA.y === offsetB.y;
  }
}
function areArraysEqual(a, b) {
  var isEqual = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : strictEquality;
  if (a.length !== b.length) {
    return false;
  }
  for (var i = 0; i < a.length; ++i) {
    if (!isEqual(a[i], b[i])) {
      return false;
    }
  }
  return true;
}

// node_modules/dnd-core/dist/esm/reducers/dragOffset.js
function ownKeys2(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread3(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys2(Object(source), true).forEach(function(key) {
        _defineProperty4(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys2(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty4(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var initialState = {
  initialSourceClientOffset: null,
  initialClientOffset: null,
  clientOffset: null
};
function reduce() {
  var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : void 0;
  var payload = action.payload;
  switch (action.type) {
    case INIT_COORDS:
    case BEGIN_DRAG:
      return {
        initialSourceClientOffset: payload.sourceClientOffset,
        initialClientOffset: payload.clientOffset,
        clientOffset: payload.clientOffset
      };
    case HOVER:
      if (areCoordsEqual(state.clientOffset, payload.clientOffset)) {
        return state;
      }
      return _objectSpread3(_objectSpread3({}, state), {}, {
        clientOffset: payload.clientOffset
      });
    case END_DRAG:
    case DROP:
      return initialState;
    default:
      return state;
  }
}

// node_modules/dnd-core/dist/esm/actions/registry.js
var ADD_SOURCE = "dnd-core/ADD_SOURCE";
var ADD_TARGET = "dnd-core/ADD_TARGET";
var REMOVE_SOURCE = "dnd-core/REMOVE_SOURCE";
var REMOVE_TARGET = "dnd-core/REMOVE_TARGET";
function addSource(sourceId) {
  return {
    type: ADD_SOURCE,
    payload: {
      sourceId
    }
  };
}
function addTarget(targetId) {
  return {
    type: ADD_TARGET,
    payload: {
      targetId
    }
  };
}
function removeSource(sourceId) {
  return {
    type: REMOVE_SOURCE,
    payload: {
      sourceId
    }
  };
}
function removeTarget(targetId) {
  return {
    type: REMOVE_TARGET,
    payload: {
      targetId
    }
  };
}

// node_modules/dnd-core/dist/esm/reducers/dragOperation.js
function ownKeys3(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread4(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys3(Object(source), true).forEach(function(key) {
        _defineProperty5(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys3(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty5(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var initialState2 = {
  itemType: null,
  item: null,
  sourceId: null,
  targetIds: [],
  dropResult: null,
  didDrop: false,
  isSourcePublic: null
};
function reduce2() {
  var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : initialState2;
  var action = arguments.length > 1 ? arguments[1] : void 0;
  var payload = action.payload;
  switch (action.type) {
    case BEGIN_DRAG:
      return _objectSpread4(_objectSpread4({}, state), {}, {
        itemType: payload.itemType,
        item: payload.item,
        sourceId: payload.sourceId,
        isSourcePublic: payload.isSourcePublic,
        dropResult: null,
        didDrop: false
      });
    case PUBLISH_DRAG_SOURCE:
      return _objectSpread4(_objectSpread4({}, state), {}, {
        isSourcePublic: true
      });
    case HOVER:
      return _objectSpread4(_objectSpread4({}, state), {}, {
        targetIds: payload.targetIds
      });
    case REMOVE_TARGET:
      if (state.targetIds.indexOf(payload.targetId) === -1) {
        return state;
      }
      return _objectSpread4(_objectSpread4({}, state), {}, {
        targetIds: without(state.targetIds, payload.targetId)
      });
    case DROP:
      return _objectSpread4(_objectSpread4({}, state), {}, {
        dropResult: payload.dropResult,
        didDrop: true,
        targetIds: []
      });
    case END_DRAG:
      return _objectSpread4(_objectSpread4({}, state), {}, {
        itemType: null,
        item: null,
        sourceId: null,
        dropResult: null,
        didDrop: false,
        isSourcePublic: null,
        targetIds: []
      });
    default:
      return state;
  }
}

// node_modules/dnd-core/dist/esm/reducers/refCount.js
function reduce3() {
  var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  var action = arguments.length > 1 ? arguments[1] : void 0;
  switch (action.type) {
    case ADD_SOURCE:
    case ADD_TARGET:
      return state + 1;
    case REMOVE_SOURCE:
    case REMOVE_TARGET:
      return state - 1;
    default:
      return state;
  }
}

// node_modules/dnd-core/dist/esm/utils/dirtiness.js
var NONE = [];
var ALL = [];
NONE.__IS_NONE__ = true;
ALL.__IS_ALL__ = true;
function areDirty(dirtyIds, handlerIds) {
  if (dirtyIds === NONE) {
    return false;
  }
  if (dirtyIds === ALL || typeof handlerIds === "undefined") {
    return true;
  }
  var commonIds = intersection(handlerIds, dirtyIds);
  return commonIds.length > 0;
}

// node_modules/dnd-core/dist/esm/reducers/dirtyHandlerIds.js
function reduce4() {
  var action = arguments.length > 1 ? arguments[1] : void 0;
  switch (action.type) {
    case HOVER:
      break;
    case ADD_SOURCE:
    case ADD_TARGET:
    case REMOVE_TARGET:
    case REMOVE_SOURCE:
      return NONE;
    case BEGIN_DRAG:
    case PUBLISH_DRAG_SOURCE:
    case END_DRAG:
    case DROP:
    default:
      return ALL;
  }
  var _action$payload = action.payload, _action$payload$targe = _action$payload.targetIds, targetIds = _action$payload$targe === void 0 ? [] : _action$payload$targe, _action$payload$prevT = _action$payload.prevTargetIds, prevTargetIds = _action$payload$prevT === void 0 ? [] : _action$payload$prevT;
  var result = xor(targetIds, prevTargetIds);
  var didChange = result.length > 0 || !areArraysEqual(targetIds, prevTargetIds);
  if (!didChange) {
    return NONE;
  }
  var prevInnermostTargetId = prevTargetIds[prevTargetIds.length - 1];
  var innermostTargetId = targetIds[targetIds.length - 1];
  if (prevInnermostTargetId !== innermostTargetId) {
    if (prevInnermostTargetId) {
      result.push(prevInnermostTargetId);
    }
    if (innermostTargetId) {
      result.push(innermostTargetId);
    }
  }
  return result;
}

// node_modules/dnd-core/dist/esm/reducers/stateId.js
function reduce5() {
  var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0;
  return state + 1;
}

// node_modules/dnd-core/dist/esm/reducers/index.js
function ownKeys4(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread5(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys4(Object(source), true).forEach(function(key) {
        _defineProperty6(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys4(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _defineProperty6(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function reduce6() {
  var state = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : void 0;
  return {
    dirtyHandlerIds: reduce4(state.dirtyHandlerIds, {
      type: action.type,
      payload: _objectSpread5(_objectSpread5({}, action.payload), {}, {
        prevTargetIds: get2(state, "dragOperation.targetIds", [])
      })
    }),
    dragOffset: reduce(state.dragOffset, action),
    refCount: reduce3(state.refCount, action),
    dragOperation: reduce2(state.dragOperation, action),
    stateId: reduce5(state.stateId)
  };
}

// node_modules/dnd-core/dist/esm/utils/coords.js
function add(a, b) {
  return {
    x: a.x + b.x,
    y: a.y + b.y
  };
}
function subtract(a, b) {
  return {
    x: a.x - b.x,
    y: a.y - b.y
  };
}
function getSourceClientOffset(state) {
  var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset, initialSourceClientOffset = state.initialSourceClientOffset;
  if (!clientOffset || !initialClientOffset || !initialSourceClientOffset) {
    return null;
  }
  return subtract(add(clientOffset, initialSourceClientOffset), initialClientOffset);
}
function getDifferenceFromInitialOffset(state) {
  var clientOffset = state.clientOffset, initialClientOffset = state.initialClientOffset;
  if (!clientOffset || !initialClientOffset) {
    return null;
  }
  return subtract(clientOffset, initialClientOffset);
}

// node_modules/dnd-core/dist/esm/classes/DragDropMonitorImpl.js
function _classCallCheck2(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties2(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass2(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties2(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty7(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var DragDropMonitorImpl = /* @__PURE__ */ (function() {
  function DragDropMonitorImpl2(store, registry) {
    _classCallCheck2(this, DragDropMonitorImpl2);
    _defineProperty7(this, "store", void 0);
    _defineProperty7(this, "registry", void 0);
    this.store = store;
    this.registry = registry;
  }
  _createClass2(DragDropMonitorImpl2, [{
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      var _this = this;
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        handlerIds: void 0
      };
      var handlerIds = options.handlerIds;
      invariant(typeof listener === "function", "listener must be a function.");
      invariant(typeof handlerIds === "undefined" || Array.isArray(handlerIds), "handlerIds, when specified, must be an array of strings.");
      var prevStateId = this.store.getState().stateId;
      var handleChange = function handleChange2() {
        var state = _this.store.getState();
        var currentStateId = state.stateId;
        try {
          var canSkipListener = currentStateId === prevStateId || currentStateId === prevStateId + 1 && !areDirty(state.dirtyHandlerIds, handlerIds);
          if (!canSkipListener) {
            listener();
          }
        } finally {
          prevStateId = currentStateId;
        }
      };
      return this.store.subscribe(handleChange);
    }
  }, {
    key: "subscribeToOffsetChange",
    value: function subscribeToOffsetChange(listener) {
      var _this2 = this;
      invariant(typeof listener === "function", "listener must be a function.");
      var previousState = this.store.getState().dragOffset;
      var handleChange = function handleChange2() {
        var nextState = _this2.store.getState().dragOffset;
        if (nextState === previousState) {
          return;
        }
        previousState = nextState;
        listener();
      };
      return this.store.subscribe(handleChange);
    }
  }, {
    key: "canDragSource",
    value: function canDragSource(sourceId) {
      if (!sourceId) {
        return false;
      }
      var source = this.registry.getSource(sourceId);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));
      if (this.isDragging()) {
        return false;
      }
      return source.canDrag(this, sourceId);
    }
  }, {
    key: "canDropOnTarget",
    value: function canDropOnTarget(targetId) {
      if (!targetId) {
        return false;
      }
      var target = this.registry.getTarget(targetId);
      invariant(target, "Expected to find a valid target. targetId=".concat(targetId));
      if (!this.isDragging() || this.didDrop()) {
        return false;
      }
      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      return matchesType(targetType, draggedItemType) && target.canDrop(this, targetId);
    }
  }, {
    key: "isDragging",
    value: function isDragging() {
      return Boolean(this.getItemType());
    }
  }, {
    key: "isDraggingSource",
    value: function isDraggingSource(sourceId) {
      if (!sourceId) {
        return false;
      }
      var source = this.registry.getSource(sourceId, true);
      invariant(source, "Expected to find a valid source. sourceId=".concat(sourceId));
      if (!this.isDragging() || !this.isSourcePublic()) {
        return false;
      }
      var sourceType = this.registry.getSourceType(sourceId);
      var draggedItemType = this.getItemType();
      if (sourceType !== draggedItemType) {
        return false;
      }
      return source.isDragging(this, sourceId);
    }
  }, {
    key: "isOverTarget",
    value: function isOverTarget(targetId) {
      var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        shallow: false
      };
      if (!targetId) {
        return false;
      }
      var shallow = options.shallow;
      if (!this.isDragging()) {
        return false;
      }
      var targetType = this.registry.getTargetType(targetId);
      var draggedItemType = this.getItemType();
      if (draggedItemType && !matchesType(targetType, draggedItemType)) {
        return false;
      }
      var targetIds = this.getTargetIds();
      if (!targetIds.length) {
        return false;
      }
      var index = targetIds.indexOf(targetId);
      if (shallow) {
        return index === targetIds.length - 1;
      } else {
        return index > -1;
      }
    }
  }, {
    key: "getItemType",
    value: function getItemType() {
      return this.store.getState().dragOperation.itemType;
    }
  }, {
    key: "getItem",
    value: function getItem() {
      return this.store.getState().dragOperation.item;
    }
  }, {
    key: "getSourceId",
    value: function getSourceId() {
      return this.store.getState().dragOperation.sourceId;
    }
  }, {
    key: "getTargetIds",
    value: function getTargetIds() {
      return this.store.getState().dragOperation.targetIds;
    }
  }, {
    key: "getDropResult",
    value: function getDropResult() {
      return this.store.getState().dragOperation.dropResult;
    }
  }, {
    key: "didDrop",
    value: function didDrop() {
      return this.store.getState().dragOperation.didDrop;
    }
  }, {
    key: "isSourcePublic",
    value: function isSourcePublic() {
      return Boolean(this.store.getState().dragOperation.isSourcePublic);
    }
  }, {
    key: "getInitialClientOffset",
    value: function getInitialClientOffset() {
      return this.store.getState().dragOffset.initialClientOffset;
    }
  }, {
    key: "getInitialSourceClientOffset",
    value: function getInitialSourceClientOffset() {
      return this.store.getState().dragOffset.initialSourceClientOffset;
    }
  }, {
    key: "getClientOffset",
    value: function getClientOffset() {
      return this.store.getState().dragOffset.clientOffset;
    }
  }, {
    key: "getSourceClientOffset",
    value: function getSourceClientOffset2() {
      return getSourceClientOffset(this.store.getState().dragOffset);
    }
  }, {
    key: "getDifferenceFromInitialOffset",
    value: function getDifferenceFromInitialOffset2() {
      return getDifferenceFromInitialOffset(this.store.getState().dragOffset);
    }
  }]);
  return DragDropMonitorImpl2;
})();

// node_modules/dnd-core/dist/esm/utils/getNextUniqueId.js
var nextUniqueId = 0;
function getNextUniqueId() {
  return nextUniqueId++;
}

// node_modules/dnd-core/dist/esm/contracts.js
function _typeof3(obj) {
  "@babel/helpers - typeof";
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof3 = function _typeof4(obj2) {
      return typeof obj2;
    };
  } else {
    _typeof3 = function _typeof4(obj2) {
      return obj2 && typeof Symbol === "function" && obj2.constructor === Symbol && obj2 !== Symbol.prototype ? "symbol" : typeof obj2;
    };
  }
  return _typeof3(obj);
}
function validateSourceContract(source) {
  invariant(typeof source.canDrag === "function", "Expected canDrag to be a function.");
  invariant(typeof source.beginDrag === "function", "Expected beginDrag to be a function.");
  invariant(typeof source.endDrag === "function", "Expected endDrag to be a function.");
}
function validateTargetContract(target) {
  invariant(typeof target.canDrop === "function", "Expected canDrop to be a function.");
  invariant(typeof target.hover === "function", "Expected hover to be a function.");
  invariant(typeof target.drop === "function", "Expected beginDrag to be a function.");
}
function validateType(type, allowArray) {
  if (allowArray && Array.isArray(type)) {
    type.forEach(function(t) {
      return validateType(t, false);
    });
    return;
  }
  invariant(typeof type === "string" || _typeof3(type) === "symbol", allowArray ? "Type can only be a string, a symbol, or an array of either." : "Type can only be a string or a symbol.");
}

// node_modules/@react-dnd/asap/dist/esm/makeRequestCall.mjs
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
function makeRequestCallFromTimer(callback) {
  return function requestCall() {
    const timeoutHandle = setTimeout(handleTimer, 0);
    const intervalHandle = setInterval(handleTimer, 50);
    function handleTimer() {
      clearTimeout(timeoutHandle);
      clearInterval(intervalHandle);
      callback();
    }
  };
}
function makeRequestCallFromMutationObserver(callback) {
  let toggle = 1;
  const observer = new BrowserMutationObserver(callback);
  const node = document.createTextNode("");
  observer.observe(node, {
    characterData: true
  });
  return function requestCall() {
    toggle = -toggle;
    node.data = toggle;
  };
}
var makeRequestCall = typeof BrowserMutationObserver === "function" ? (
  // reliably everywhere they are implemented.
  // They are implemented in all modern browsers.
  //
  // - Android 4-4.3
  // - Chrome 26-34
  // - Firefox 14-29
  // - Internet Explorer 11
  // - iPad Safari 6-7.1
  // - iPhone Safari 7-7.1
  // - Safari 6-7
  makeRequestCallFromMutationObserver
) : (
  // task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
  // 11-12, and in web workers in many engines.
  // Although message channels yield to any queued rendering and IO tasks, they
  // would be better than imposing the 4ms delay of timers.
  // However, they do not work reliably in Internet Explorer or Safari.
  // Internet Explorer 10 is the only browser that has setImmediate but does
  // not have MutationObservers.
  // Although setImmediate yields to the browser's renderer, it would be
  // preferrable to falling back to setTimeout since it does not have
  // the minimum 4ms penalty.
  // Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
  // Desktop to a lesser extent) that renders both setImmediate and
  // MessageChannel useless for the purposes of ASAP.
  // https://github.com/kriskowal/q/issues/396
  // Timers are implemented universally.
  // We fall back to timers in workers in most engines, and in foreground
  // contexts in the following browsers.
  // However, note that even this simple case requires nuances to operate in a
  // broad spectrum of browsers.
  //
  // - Firefox 3-13
  // - Internet Explorer 6-9
  // - iPad Safari 4.3
  // - Lynx 2.8.7
  makeRequestCallFromTimer
);

// node_modules/@react-dnd/asap/dist/esm/AsapQueue.mjs
var AsapQueue = class {
  // Use the fastest means possible to execute a task in its own turn, with
  // priority over other events including IO, animation, reflow, and redraw
  // events in browsers.
  //
  // An exception thrown by a task will permanently interrupt the processing of
  // subsequent tasks. The higher level `asap` function ensures that if an
  // exception is thrown by a task, that the task queue will continue flushing as
  // soon as possible, but if you use `rawAsap` directly, you are responsible to
  // either ensure that no exceptions are thrown from your task, or to manually
  // call `rawAsap.requestFlush` if an exception is thrown.
  enqueueTask(task) {
    const { queue: q, requestFlush } = this;
    if (!q.length) {
      requestFlush();
      this.flushing = true;
    }
    q[q.length] = task;
  }
  constructor() {
    this.queue = [];
    this.pendingErrors = [];
    this.flushing = false;
    this.index = 0;
    this.capacity = 1024;
    this.flush = () => {
      const { queue: q } = this;
      while (this.index < q.length) {
        const currentIndex = this.index;
        this.index++;
        q[currentIndex].call();
        if (this.index > this.capacity) {
          for (let scan = 0, newLength = q.length - this.index; scan < newLength; scan++) {
            q[scan] = q[scan + this.index];
          }
          q.length -= this.index;
          this.index = 0;
        }
      }
      q.length = 0;
      this.index = 0;
      this.flushing = false;
    };
    this.registerPendingError = (err) => {
      this.pendingErrors.push(err);
      this.requestErrorThrow();
    };
    this.requestFlush = makeRequestCall(this.flush);
    this.requestErrorThrow = makeRequestCallFromTimer(() => {
      if (this.pendingErrors.length) {
        throw this.pendingErrors.shift();
      }
    });
  }
};

// node_modules/@react-dnd/asap/dist/esm/RawTask.mjs
var RawTask = class {
  call() {
    try {
      this.task && this.task();
    } catch (error) {
      this.onError(error);
    } finally {
      this.task = null;
      this.release(this);
    }
  }
  constructor(onError, release) {
    this.onError = onError;
    this.release = release;
    this.task = null;
  }
};

// node_modules/@react-dnd/asap/dist/esm/TaskFactory.mjs
var TaskFactory = class {
  create(task) {
    const tasks = this.freeTasks;
    const t1 = tasks.length ? tasks.pop() : new RawTask(
      this.onError,
      (t) => tasks[tasks.length] = t
    );
    t1.task = task;
    return t1;
  }
  constructor(onError) {
    this.onError = onError;
    this.freeTasks = [];
  }
};

// node_modules/@react-dnd/asap/dist/esm/asap.mjs
var asapQueue = new AsapQueue();
var taskFactory = new TaskFactory(asapQueue.registerPendingError);
function asap(task) {
  asapQueue.enqueueTask(taskFactory.create(task));
}

// node_modules/dnd-core/dist/esm/classes/HandlerRegistryImpl.js
function _classCallCheck3(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties3(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass3(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties3(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty8(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function getNextHandlerId(role) {
  var id = getNextUniqueId().toString();
  switch (role) {
    case HandlerRole.SOURCE:
      return "S".concat(id);
    case HandlerRole.TARGET:
      return "T".concat(id);
    default:
      throw new Error("Unknown Handler Role: ".concat(role));
  }
}
function parseRoleFromHandlerId(handlerId) {
  switch (handlerId[0]) {
    case "S":
      return HandlerRole.SOURCE;
    case "T":
      return HandlerRole.TARGET;
    default:
      invariant(false, "Cannot parse handler ID: ".concat(handlerId));
  }
}
function mapContainsValue(map2, searchValue) {
  var entries = map2.entries();
  var isDone = false;
  do {
    var _entries$next = entries.next(), done = _entries$next.done, _entries$next$value = _slicedToArray(_entries$next.value, 2), value = _entries$next$value[1];
    if (value === searchValue) {
      return true;
    }
    isDone = !!done;
  } while (!isDone);
  return false;
}
var HandlerRegistryImpl = /* @__PURE__ */ (function() {
  function HandlerRegistryImpl2(store) {
    _classCallCheck3(this, HandlerRegistryImpl2);
    _defineProperty8(this, "types", /* @__PURE__ */ new Map());
    _defineProperty8(this, "dragSources", /* @__PURE__ */ new Map());
    _defineProperty8(this, "dropTargets", /* @__PURE__ */ new Map());
    _defineProperty8(this, "pinnedSourceId", null);
    _defineProperty8(this, "pinnedSource", null);
    _defineProperty8(this, "store", void 0);
    this.store = store;
  }
  _createClass3(HandlerRegistryImpl2, [{
    key: "addSource",
    value: function addSource2(type, source) {
      validateType(type);
      validateSourceContract(source);
      var sourceId = this.addHandler(HandlerRole.SOURCE, type, source);
      this.store.dispatch(addSource(sourceId));
      return sourceId;
    }
  }, {
    key: "addTarget",
    value: function addTarget2(type, target) {
      validateType(type, true);
      validateTargetContract(target);
      var targetId = this.addHandler(HandlerRole.TARGET, type, target);
      this.store.dispatch(addTarget(targetId));
      return targetId;
    }
  }, {
    key: "containsHandler",
    value: function containsHandler(handler) {
      return mapContainsValue(this.dragSources, handler) || mapContainsValue(this.dropTargets, handler);
    }
  }, {
    key: "getSource",
    value: function getSource(sourceId) {
      var includePinned = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
      invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
      var isPinned = includePinned && sourceId === this.pinnedSourceId;
      var source = isPinned ? this.pinnedSource : this.dragSources.get(sourceId);
      return source;
    }
  }, {
    key: "getTarget",
    value: function getTarget(targetId) {
      invariant(this.isTargetId(targetId), "Expected a valid target ID.");
      return this.dropTargets.get(targetId);
    }
  }, {
    key: "getSourceType",
    value: function getSourceType(sourceId) {
      invariant(this.isSourceId(sourceId), "Expected a valid source ID.");
      return this.types.get(sourceId);
    }
  }, {
    key: "getTargetType",
    value: function getTargetType(targetId) {
      invariant(this.isTargetId(targetId), "Expected a valid target ID.");
      return this.types.get(targetId);
    }
  }, {
    key: "isSourceId",
    value: function isSourceId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.SOURCE;
    }
  }, {
    key: "isTargetId",
    value: function isTargetId(handlerId) {
      var role = parseRoleFromHandlerId(handlerId);
      return role === HandlerRole.TARGET;
    }
  }, {
    key: "removeSource",
    value: function removeSource2(sourceId) {
      var _this = this;
      invariant(this.getSource(sourceId), "Expected an existing source.");
      this.store.dispatch(removeSource(sourceId));
      asap(function() {
        _this.dragSources.delete(sourceId);
        _this.types.delete(sourceId);
      });
    }
  }, {
    key: "removeTarget",
    value: function removeTarget2(targetId) {
      invariant(this.getTarget(targetId), "Expected an existing target.");
      this.store.dispatch(removeTarget(targetId));
      this.dropTargets.delete(targetId);
      this.types.delete(targetId);
    }
  }, {
    key: "pinSource",
    value: function pinSource(sourceId) {
      var source = this.getSource(sourceId);
      invariant(source, "Expected an existing source.");
      this.pinnedSourceId = sourceId;
      this.pinnedSource = source;
    }
  }, {
    key: "unpinSource",
    value: function unpinSource() {
      invariant(this.pinnedSource, "No source is pinned at the time.");
      this.pinnedSourceId = null;
      this.pinnedSource = null;
    }
  }, {
    key: "addHandler",
    value: function addHandler(role, type, handler) {
      var id = getNextHandlerId(role);
      this.types.set(id, type);
      if (role === HandlerRole.SOURCE) {
        this.dragSources.set(id, handler);
      } else if (role === HandlerRole.TARGET) {
        this.dropTargets.set(id, handler);
      }
      return id;
    }
  }]);
  return HandlerRegistryImpl2;
})();

// node_modules/dnd-core/dist/esm/createDragDropManager.js
function createDragDropManager(backendFactory) {
  var globalContext = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : void 0;
  var backendOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
  var debugMode = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
  var store = makeStoreInstance(debugMode);
  var monitor = new DragDropMonitorImpl(store, new HandlerRegistryImpl(store));
  var manager = new DragDropManagerImpl(store, monitor);
  var backend = backendFactory(manager, globalContext, backendOptions);
  manager.receiveBackend(backend);
  return manager;
}
function makeStoreInstance(debugMode) {
  var reduxDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION__;
  return createStore(reduce6, debugMode && reduxDevTools && reduxDevTools({
    name: "dnd-core",
    instanceId: "dnd-core"
  }));
}

// node_modules/react-dnd/dist/esm/core/DndProvider.js
var _excluded = ["children"];
function _slicedToArray2(arr, i) {
  return _arrayWithHoles2(arr) || _iterableToArrayLimit2(arr, i) || _unsupportedIterableToArray2(arr, i) || _nonIterableRest2();
}
function _nonIterableRest2() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray2(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray2(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray2(o, minLen);
}
function _arrayLikeToArray2(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }
  return arr2;
}
function _iterableToArrayLimit2(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;
  var _s, _e;
  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);
      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }
  return _arr;
}
function _arrayWithHoles2(arr) {
  if (Array.isArray(arr)) return arr;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
var refCount = 0;
var INSTANCE_SYM = /* @__PURE__ */ Symbol.for("__REACT_DND_CONTEXT_INSTANCE__");
var DndProvider = memo(function DndProvider2(_ref) {
  var children = _ref.children, props = _objectWithoutProperties(_ref, _excluded);
  var _getDndContextValue = getDndContextValue(props), _getDndContextValue2 = _slicedToArray2(_getDndContextValue, 2), manager = _getDndContextValue2[0], isGlobalInstance = _getDndContextValue2[1];
  useEffect(function() {
    if (isGlobalInstance) {
      var context = getGlobalContext();
      ++refCount;
      return function() {
        if (--refCount === 0) {
          context[INSTANCE_SYM] = null;
        }
      };
    }
  }, []);
  return jsx(DndContext.Provider, Object.assign({
    value: manager
  }, {
    children
  }), void 0);
});
function getDndContextValue(props) {
  if ("manager" in props) {
    var _manager = {
      dragDropManager: props.manager
    };
    return [_manager, false];
  }
  var manager = createSingletonDndContext(props.backend, props.context, props.options, props.debugMode);
  var isGlobalInstance = !props.context;
  return [manager, isGlobalInstance];
}
function createSingletonDndContext(backend) {
  var context = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : getGlobalContext();
  var options = arguments.length > 2 ? arguments[2] : void 0;
  var debugMode = arguments.length > 3 ? arguments[3] : void 0;
  var ctx = context;
  if (!ctx[INSTANCE_SYM]) {
    ctx[INSTANCE_SYM] = {
      dragDropManager: createDragDropManager(backend, context, options, debugMode)
    };
  }
  return ctx[INSTANCE_SYM];
}
function getGlobalContext() {
  return typeof global !== "undefined" ? global : window;
}

// node_modules/react-dnd-html5-backend/dist/esm/utils/js_utils.js
function memoize(fn) {
  var result = null;
  var memoized = function memoized2() {
    if (result == null) {
      result = fn();
    }
    return result;
  };
  return memoized;
}
function without2(items2, item) {
  return items2.filter(function(i) {
    return i !== item;
  });
}
function union(itemsA, itemsB) {
  var set = /* @__PURE__ */ new Set();
  var insertItem = function insertItem2(item) {
    return set.add(item);
  };
  itemsA.forEach(insertItem);
  itemsB.forEach(insertItem);
  var result = [];
  set.forEach(function(key) {
    return result.push(key);
  });
  return result;
}

// node_modules/react-dnd-html5-backend/dist/esm/EnterLeaveCounter.js
function _classCallCheck4(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties4(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass4(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties4(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty9(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var EnterLeaveCounter = /* @__PURE__ */ (function() {
  function EnterLeaveCounter2(isNodeInDocument) {
    _classCallCheck4(this, EnterLeaveCounter2);
    _defineProperty9(this, "entered", []);
    _defineProperty9(this, "isNodeInDocument", void 0);
    this.isNodeInDocument = isNodeInDocument;
  }
  _createClass4(EnterLeaveCounter2, [{
    key: "enter",
    value: function enter(enteringNode) {
      var _this = this;
      var previousLength = this.entered.length;
      var isNodeEntered = function isNodeEntered2(node) {
        return _this.isNodeInDocument(node) && (!node.contains || node.contains(enteringNode));
      };
      this.entered = union(this.entered.filter(isNodeEntered), [enteringNode]);
      return previousLength === 0 && this.entered.length > 0;
    }
  }, {
    key: "leave",
    value: function leave(leavingNode) {
      var previousLength = this.entered.length;
      this.entered = without2(this.entered.filter(this.isNodeInDocument), leavingNode);
      return previousLength > 0 && this.entered.length === 0;
    }
  }, {
    key: "reset",
    value: function reset() {
      this.entered = [];
    }
  }]);
  return EnterLeaveCounter2;
})();

// node_modules/react-dnd-html5-backend/dist/esm/BrowserDetector.js
var isFirefox = memoize(function() {
  return /firefox/i.test(navigator.userAgent);
});
var isSafari = memoize(function() {
  return Boolean(window.safari);
});

// node_modules/react-dnd-html5-backend/dist/esm/MonotonicInterpolant.js
function _classCallCheck5(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties5(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass5(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties5(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty10(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var MonotonicInterpolant = /* @__PURE__ */ (function() {
  function MonotonicInterpolant2(xs, ys) {
    _classCallCheck5(this, MonotonicInterpolant2);
    _defineProperty10(this, "xs", void 0);
    _defineProperty10(this, "ys", void 0);
    _defineProperty10(this, "c1s", void 0);
    _defineProperty10(this, "c2s", void 0);
    _defineProperty10(this, "c3s", void 0);
    var length = xs.length;
    var indexes = [];
    for (var i = 0; i < length; i++) {
      indexes.push(i);
    }
    indexes.sort(function(a, b) {
      return xs[a] < xs[b] ? -1 : 1;
    });
    var dxs = [];
    var ms = [];
    var dx;
    var dy;
    for (var _i = 0; _i < length - 1; _i++) {
      dx = xs[_i + 1] - xs[_i];
      dy = ys[_i + 1] - ys[_i];
      dxs.push(dx);
      ms.push(dy / dx);
    }
    var c1s = [ms[0]];
    for (var _i2 = 0; _i2 < dxs.length - 1; _i2++) {
      var m2 = ms[_i2];
      var mNext = ms[_i2 + 1];
      if (m2 * mNext <= 0) {
        c1s.push(0);
      } else {
        dx = dxs[_i2];
        var dxNext = dxs[_i2 + 1];
        var common = dx + dxNext;
        c1s.push(3 * common / ((common + dxNext) / m2 + (common + dx) / mNext));
      }
    }
    c1s.push(ms[ms.length - 1]);
    var c2s = [];
    var c3s = [];
    var m;
    for (var _i3 = 0; _i3 < c1s.length - 1; _i3++) {
      m = ms[_i3];
      var c1 = c1s[_i3];
      var invDx = 1 / dxs[_i3];
      var _common = c1 + c1s[_i3 + 1] - m - m;
      c2s.push((m - c1 - _common) * invDx);
      c3s.push(_common * invDx * invDx);
    }
    this.xs = xs;
    this.ys = ys;
    this.c1s = c1s;
    this.c2s = c2s;
    this.c3s = c3s;
  }
  _createClass5(MonotonicInterpolant2, [{
    key: "interpolate",
    value: function interpolate(x) {
      var xs = this.xs, ys = this.ys, c1s = this.c1s, c2s = this.c2s, c3s = this.c3s;
      var i = xs.length - 1;
      if (x === xs[i]) {
        return ys[i];
      }
      var low = 0;
      var high = c3s.length - 1;
      var mid;
      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        var xHere = xs[mid];
        if (xHere < x) {
          low = mid + 1;
        } else if (xHere > x) {
          high = mid - 1;
        } else {
          return ys[mid];
        }
      }
      i = Math.max(0, high);
      var diff = x - xs[i];
      var diffSq = diff * diff;
      return ys[i] + c1s[i] * diff + c2s[i] * diffSq + c3s[i] * diff * diffSq;
    }
  }]);
  return MonotonicInterpolant2;
})();

// node_modules/react-dnd-html5-backend/dist/esm/OffsetUtils.js
var ELEMENT_NODE = 1;
function getNodeClientOffset(node) {
  var el = node.nodeType === ELEMENT_NODE ? node : node.parentElement;
  if (!el) {
    return null;
  }
  var _el$getBoundingClient = el.getBoundingClientRect(), top = _el$getBoundingClient.top, left = _el$getBoundingClient.left;
  return {
    x: left,
    y: top
  };
}
function getEventClientOffset(e) {
  return {
    x: e.clientX,
    y: e.clientY
  };
}
function isImageNode(node) {
  var _document$documentEle;
  return node.nodeName === "IMG" && (isFirefox() || !((_document$documentEle = document.documentElement) !== null && _document$documentEle !== void 0 && _document$documentEle.contains(node)));
}
function getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight) {
  var dragPreviewWidth = isImage ? dragPreview.width : sourceWidth;
  var dragPreviewHeight = isImage ? dragPreview.height : sourceHeight;
  if (isSafari() && isImage) {
    dragPreviewHeight /= window.devicePixelRatio;
    dragPreviewWidth /= window.devicePixelRatio;
  }
  return {
    dragPreviewWidth,
    dragPreviewHeight
  };
}
function getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint) {
  var isImage = isImageNode(dragPreview);
  var dragPreviewNode = isImage ? sourceNode : dragPreview;
  var dragPreviewNodeOffsetFromClient = getNodeClientOffset(dragPreviewNode);
  var offsetFromDragPreview = {
    x: clientOffset.x - dragPreviewNodeOffsetFromClient.x,
    y: clientOffset.y - dragPreviewNodeOffsetFromClient.y
  };
  var sourceWidth = sourceNode.offsetWidth, sourceHeight = sourceNode.offsetHeight;
  var anchorX = anchorPoint.anchorX, anchorY = anchorPoint.anchorY;
  var _getDragPreviewSize = getDragPreviewSize(isImage, dragPreview, sourceWidth, sourceHeight), dragPreviewWidth = _getDragPreviewSize.dragPreviewWidth, dragPreviewHeight = _getDragPreviewSize.dragPreviewHeight;
  var calculateYOffset = function calculateYOffset2() {
    var interpolantY = new MonotonicInterpolant([0, 0.5, 1], [
      // Dock to the top
      offsetFromDragPreview.y,
      // Align at the center
      offsetFromDragPreview.y / sourceHeight * dragPreviewHeight,
      // Dock to the bottom
      offsetFromDragPreview.y + dragPreviewHeight - sourceHeight
    ]);
    var y = interpolantY.interpolate(anchorY);
    if (isSafari() && isImage) {
      y += (window.devicePixelRatio - 1) * dragPreviewHeight;
    }
    return y;
  };
  var calculateXOffset = function calculateXOffset2() {
    var interpolantX = new MonotonicInterpolant([0, 0.5, 1], [
      // Dock to the left
      offsetFromDragPreview.x,
      // Align at the center
      offsetFromDragPreview.x / sourceWidth * dragPreviewWidth,
      // Dock to the right
      offsetFromDragPreview.x + dragPreviewWidth - sourceWidth
    ]);
    return interpolantX.interpolate(anchorX);
  };
  var offsetX = offsetPoint.offsetX, offsetY = offsetPoint.offsetY;
  var isManualOffsetX = offsetX === 0 || offsetX;
  var isManualOffsetY = offsetY === 0 || offsetY;
  return {
    x: isManualOffsetX ? offsetX : calculateXOffset(),
    y: isManualOffsetY ? offsetY : calculateYOffset()
  };
}

// node_modules/react-dnd-html5-backend/dist/esm/NativeTypes.js
var NativeTypes_exports = {};
__export(NativeTypes_exports, {
  FILE: () => FILE,
  HTML: () => HTML,
  TEXT: () => TEXT,
  URL: () => URL
});
var FILE = "__NATIVE_FILE__";
var URL = "__NATIVE_URL__";
var TEXT = "__NATIVE_TEXT__";
var HTML = "__NATIVE_HTML__";

// node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/getDataFromDataTransfer.js
function getDataFromDataTransfer(dataTransfer5, typesToTry, defaultValue) {
  var result = typesToTry.reduce(function(resultSoFar, typeToTry) {
    return resultSoFar || dataTransfer5.getData(typeToTry);
  }, "");
  return result != null ? result : defaultValue;
}

// node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/nativeTypesConfig.js
var _nativeTypesConfig;
function _defineProperty11(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var nativeTypesConfig = (_nativeTypesConfig = {}, _defineProperty11(_nativeTypesConfig, FILE, {
  exposeProperties: {
    files: function files(dataTransfer5) {
      return Array.prototype.slice.call(dataTransfer5.files);
    },
    items: function items(dataTransfer5) {
      return dataTransfer5.items;
    },
    dataTransfer: function dataTransfer(_dataTransfer) {
      return _dataTransfer;
    }
  },
  matchesTypes: ["Files"]
}), _defineProperty11(_nativeTypesConfig, HTML, {
  exposeProperties: {
    html: function html(dataTransfer5, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer5, matchesTypes, "");
    },
    dataTransfer: function dataTransfer2(_dataTransfer2) {
      return _dataTransfer2;
    }
  },
  matchesTypes: ["Html", "text/html"]
}), _defineProperty11(_nativeTypesConfig, URL, {
  exposeProperties: {
    urls: function urls(dataTransfer5, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer5, matchesTypes, "").split("\n");
    },
    dataTransfer: function dataTransfer3(_dataTransfer3) {
      return _dataTransfer3;
    }
  },
  matchesTypes: ["Url", "text/uri-list"]
}), _defineProperty11(_nativeTypesConfig, TEXT, {
  exposeProperties: {
    text: function text(dataTransfer5, matchesTypes) {
      return getDataFromDataTransfer(dataTransfer5, matchesTypes, "");
    },
    dataTransfer: function dataTransfer4(_dataTransfer4) {
      return _dataTransfer4;
    }
  },
  matchesTypes: ["Text", "text/plain"]
}), _nativeTypesConfig);

// node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/NativeDragSource.js
function _classCallCheck6(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties6(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass6(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties6(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty12(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var NativeDragSource = /* @__PURE__ */ (function() {
  function NativeDragSource2(config) {
    _classCallCheck6(this, NativeDragSource2);
    _defineProperty12(this, "item", void 0);
    _defineProperty12(this, "config", void 0);
    this.config = config;
    this.item = {};
    this.initializeExposedProperties();
  }
  _createClass6(NativeDragSource2, [{
    key: "initializeExposedProperties",
    value: function initializeExposedProperties() {
      var _this = this;
      Object.keys(this.config.exposeProperties).forEach(function(property) {
        Object.defineProperty(_this.item, property, {
          configurable: true,
          enumerable: true,
          get: function get3() {
            console.warn(`Browser doesn't allow reading "`.concat(property, '" until the drop event.'));
            return null;
          }
        });
      });
    }
  }, {
    key: "loadDataTransfer",
    value: function loadDataTransfer(dataTransfer5) {
      var _this2 = this;
      if (dataTransfer5) {
        var newProperties = {};
        Object.keys(this.config.exposeProperties).forEach(function(property) {
          newProperties[property] = {
            value: _this2.config.exposeProperties[property](dataTransfer5, _this2.config.matchesTypes),
            configurable: true,
            enumerable: true
          };
        });
        Object.defineProperties(this.item, newProperties);
      }
    }
  }, {
    key: "canDrag",
    value: function canDrag() {
      return true;
    }
  }, {
    key: "beginDrag",
    value: function beginDrag() {
      return this.item;
    }
  }, {
    key: "isDragging",
    value: function isDragging(monitor, handle) {
      return handle === monitor.getSourceId();
    }
  }, {
    key: "endDrag",
    value: function endDrag() {
    }
  }]);
  return NativeDragSource2;
})();

// node_modules/react-dnd-html5-backend/dist/esm/NativeDragSources/index.js
function createNativeDragSource(type, dataTransfer5) {
  var result = new NativeDragSource(nativeTypesConfig[type]);
  result.loadDataTransfer(dataTransfer5);
  return result;
}
function matchNativeItemType(dataTransfer5) {
  if (!dataTransfer5) {
    return null;
  }
  var dataTransferTypes = Array.prototype.slice.call(dataTransfer5.types || []);
  return Object.keys(nativeTypesConfig).filter(function(nativeItemType) {
    var matchesTypes = nativeTypesConfig[nativeItemType].matchesTypes;
    return matchesTypes.some(function(t) {
      return dataTransferTypes.indexOf(t) > -1;
    });
  })[0] || null;
}

// node_modules/react-dnd-html5-backend/dist/esm/OptionsReader.js
function _classCallCheck7(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties7(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass7(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties7(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty13(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var OptionsReader = /* @__PURE__ */ (function() {
  function OptionsReader2(globalContext, options) {
    _classCallCheck7(this, OptionsReader2);
    _defineProperty13(this, "ownerDocument", null);
    _defineProperty13(this, "globalContext", void 0);
    _defineProperty13(this, "optionsArgs", void 0);
    this.globalContext = globalContext;
    this.optionsArgs = options;
  }
  _createClass7(OptionsReader2, [{
    key: "window",
    get: function get3() {
      if (this.globalContext) {
        return this.globalContext;
      } else if (typeof window !== "undefined") {
        return window;
      }
      return void 0;
    }
  }, {
    key: "document",
    get: function get3() {
      var _this$globalContext;
      if ((_this$globalContext = this.globalContext) !== null && _this$globalContext !== void 0 && _this$globalContext.document) {
        return this.globalContext.document;
      } else if (this.window) {
        return this.window.document;
      } else {
        return void 0;
      }
    }
  }, {
    key: "rootElement",
    get: function get3() {
      var _this$optionsArgs;
      return ((_this$optionsArgs = this.optionsArgs) === null || _this$optionsArgs === void 0 ? void 0 : _this$optionsArgs.rootElement) || this.window;
    }
  }]);
  return OptionsReader2;
})();

// node_modules/react-dnd-html5-backend/dist/esm/HTML5BackendImpl.js
function ownKeys5(object2, enumerableOnly) {
  var keys = Object.keys(object2);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object2);
    if (enumerableOnly) {
      symbols = symbols.filter(function(sym) {
        return Object.getOwnPropertyDescriptor(object2, sym).enumerable;
      });
    }
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread6(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys5(Object(source), true).forEach(function(key) {
        _defineProperty14(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys5(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
function _classCallCheck8(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _defineProperties8(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}
function _createClass8(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties8(Constructor.prototype, protoProps);
  return Constructor;
}
function _defineProperty14(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, { value, enumerable: true, configurable: true, writable: true });
  } else {
    obj[key] = value;
  }
  return obj;
}
var HTML5BackendImpl = /* @__PURE__ */ (function() {
  function HTML5BackendImpl2(manager, globalContext, options) {
    var _this = this;
    _classCallCheck8(this, HTML5BackendImpl2);
    _defineProperty14(this, "options", void 0);
    _defineProperty14(this, "actions", void 0);
    _defineProperty14(this, "monitor", void 0);
    _defineProperty14(this, "registry", void 0);
    _defineProperty14(this, "enterLeaveCounter", void 0);
    _defineProperty14(this, "sourcePreviewNodes", /* @__PURE__ */ new Map());
    _defineProperty14(this, "sourcePreviewNodeOptions", /* @__PURE__ */ new Map());
    _defineProperty14(this, "sourceNodes", /* @__PURE__ */ new Map());
    _defineProperty14(this, "sourceNodeOptions", /* @__PURE__ */ new Map());
    _defineProperty14(this, "dragStartSourceIds", null);
    _defineProperty14(this, "dropTargetIds", []);
    _defineProperty14(this, "dragEnterTargetIds", []);
    _defineProperty14(this, "currentNativeSource", null);
    _defineProperty14(this, "currentNativeHandle", null);
    _defineProperty14(this, "currentDragSourceNode", null);
    _defineProperty14(this, "altKeyPressed", false);
    _defineProperty14(this, "mouseMoveTimeoutTimer", null);
    _defineProperty14(this, "asyncEndDragFrameId", null);
    _defineProperty14(this, "dragOverTargetIds", null);
    _defineProperty14(this, "lastClientOffset", null);
    _defineProperty14(this, "hoverRafId", null);
    _defineProperty14(this, "getSourceClientOffset", function(sourceId) {
      var source = _this.sourceNodes.get(sourceId);
      return source && getNodeClientOffset(source) || null;
    });
    _defineProperty14(this, "endDragNativeItem", function() {
      if (!_this.isDraggingNativeItem()) {
        return;
      }
      _this.actions.endDrag();
      if (_this.currentNativeHandle) {
        _this.registry.removeSource(_this.currentNativeHandle);
      }
      _this.currentNativeHandle = null;
      _this.currentNativeSource = null;
    });
    _defineProperty14(this, "isNodeInDocument", function(node) {
      return Boolean(node && _this.document && _this.document.body && _this.document.body.contains(node));
    });
    _defineProperty14(this, "endDragIfSourceWasRemovedFromDOM", function() {
      var node = _this.currentDragSourceNode;
      if (node == null || _this.isNodeInDocument(node)) {
        return;
      }
      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    });
    _defineProperty14(this, "handleTopDragStartCapture", function() {
      _this.clearCurrentDragSourceNode();
      _this.dragStartSourceIds = [];
    });
    _defineProperty14(this, "handleTopDragStart", function(e) {
      if (e.defaultPrevented) {
        return;
      }
      var dragStartSourceIds = _this.dragStartSourceIds;
      _this.dragStartSourceIds = null;
      var clientOffset = getEventClientOffset(e);
      if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
      _this.actions.beginDrag(dragStartSourceIds || [], {
        publishSource: false,
        getSourceClientOffset: _this.getSourceClientOffset,
        clientOffset
      });
      var dataTransfer5 = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer5);
      if (_this.monitor.isDragging()) {
        if (dataTransfer5 && typeof dataTransfer5.setDragImage === "function") {
          var sourceId = _this.monitor.getSourceId();
          var sourceNode = _this.sourceNodes.get(sourceId);
          var dragPreview = _this.sourcePreviewNodes.get(sourceId) || sourceNode;
          if (dragPreview) {
            var _this$getCurrentSourc = _this.getCurrentSourcePreviewNodeOptions(), anchorX = _this$getCurrentSourc.anchorX, anchorY = _this$getCurrentSourc.anchorY, offsetX = _this$getCurrentSourc.offsetX, offsetY = _this$getCurrentSourc.offsetY;
            var anchorPoint = {
              anchorX,
              anchorY
            };
            var offsetPoint = {
              offsetX,
              offsetY
            };
            var dragPreviewOffset = getDragPreviewOffset(sourceNode, dragPreview, clientOffset, anchorPoint, offsetPoint);
            dataTransfer5.setDragImage(dragPreview, dragPreviewOffset.x, dragPreviewOffset.y);
          }
        }
        try {
          dataTransfer5 === null || dataTransfer5 === void 0 ? void 0 : dataTransfer5.setData("application/json", {});
        } catch (err) {
        }
        _this.setCurrentDragSourceNode(e.target);
        var _this$getCurrentSourc2 = _this.getCurrentSourcePreviewNodeOptions(), captureDraggingState = _this$getCurrentSourc2.captureDraggingState;
        if (!captureDraggingState) {
          setTimeout(function() {
            return _this.actions.publishDragSource();
          }, 0);
        } else {
          _this.actions.publishDragSource();
        }
      } else if (nativeType) {
        _this.beginDragNativeItem(nativeType);
      } else if (dataTransfer5 && !dataTransfer5.types && (e.target && !e.target.hasAttribute || !e.target.hasAttribute("draggable"))) {
        return;
      } else {
        e.preventDefault();
      }
    });
    _defineProperty14(this, "handleTopDragEndCapture", function() {
      if (_this.clearCurrentDragSourceNode() && _this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    });
    _defineProperty14(this, "handleTopDragEnterCapture", function(e) {
      _this.dragEnterTargetIds = [];
      var isFirstEnter = _this.enterLeaveCounter.enter(e.target);
      if (!isFirstEnter || _this.monitor.isDragging()) {
        return;
      }
      var dataTransfer5 = e.dataTransfer;
      var nativeType = matchNativeItemType(dataTransfer5);
      if (nativeType) {
        _this.beginDragNativeItem(nativeType, dataTransfer5);
      }
    });
    _defineProperty14(this, "handleTopDragEnter", function(e) {
      var dragEnterTargetIds = _this.dragEnterTargetIds;
      _this.dragEnterTargetIds = [];
      if (!_this.monitor.isDragging()) {
        return;
      }
      _this.altKeyPressed = e.altKey;
      if (dragEnterTargetIds.length > 0) {
        _this.actions.hover(dragEnterTargetIds, {
          clientOffset: getEventClientOffset(e)
        });
      }
      var canDrop = dragEnterTargetIds.some(function(targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });
      if (canDrop) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      }
    });
    _defineProperty14(this, "handleTopDragOverCapture", function() {
      _this.dragOverTargetIds = [];
    });
    _defineProperty14(this, "handleTopDragOver", function(e) {
      var dragOverTargetIds = _this.dragOverTargetIds;
      _this.dragOverTargetIds = [];
      if (!_this.monitor.isDragging()) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = "none";
        }
        return;
      }
      _this.altKeyPressed = e.altKey;
      _this.lastClientOffset = getEventClientOffset(e);
      if (_this.hoverRafId === null && typeof requestAnimationFrame !== "undefined") {
        _this.hoverRafId = requestAnimationFrame(function() {
          if (_this.monitor.isDragging()) {
            _this.actions.hover(dragOverTargetIds || [], {
              clientOffset: _this.lastClientOffset
            });
          }
          _this.hoverRafId = null;
        });
      }
      var canDrop = (dragOverTargetIds || []).some(function(targetId) {
        return _this.monitor.canDropOnTarget(targetId);
      });
      if (canDrop) {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = _this.getCurrentDropEffect();
        }
      } else if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      } else {
        e.preventDefault();
        if (e.dataTransfer) {
          e.dataTransfer.dropEffect = "none";
        }
      }
    });
    _defineProperty14(this, "handleTopDragLeaveCapture", function(e) {
      if (_this.isDraggingNativeItem()) {
        e.preventDefault();
      }
      var isLastLeave = _this.enterLeaveCounter.leave(e.target);
      if (!isLastLeave) {
        return;
      }
      if (_this.isDraggingNativeItem()) {
        setTimeout(function() {
          return _this.endDragNativeItem();
        }, 0);
      }
    });
    _defineProperty14(this, "handleTopDropCapture", function(e) {
      _this.dropTargetIds = [];
      if (_this.isDraggingNativeItem()) {
        var _this$currentNativeSo;
        e.preventDefault();
        (_this$currentNativeSo = _this.currentNativeSource) === null || _this$currentNativeSo === void 0 ? void 0 : _this$currentNativeSo.loadDataTransfer(e.dataTransfer);
      } else if (matchNativeItemType(e.dataTransfer)) {
        e.preventDefault();
      }
      _this.enterLeaveCounter.reset();
    });
    _defineProperty14(this, "handleTopDrop", function(e) {
      var dropTargetIds = _this.dropTargetIds;
      _this.dropTargetIds = [];
      _this.actions.hover(dropTargetIds, {
        clientOffset: getEventClientOffset(e)
      });
      _this.actions.drop({
        dropEffect: _this.getCurrentDropEffect()
      });
      if (_this.isDraggingNativeItem()) {
        _this.endDragNativeItem();
      } else if (_this.monitor.isDragging()) {
        _this.actions.endDrag();
      }
    });
    _defineProperty14(this, "handleSelectStart", function(e) {
      var target = e.target;
      if (typeof target.dragDrop !== "function") {
        return;
      }
      if (target.tagName === "INPUT" || target.tagName === "SELECT" || target.tagName === "TEXTAREA" || target.isContentEditable) {
        return;
      }
      e.preventDefault();
      target.dragDrop();
    });
    this.options = new OptionsReader(globalContext, options);
    this.actions = manager.getActions();
    this.monitor = manager.getMonitor();
    this.registry = manager.getRegistry();
    this.enterLeaveCounter = new EnterLeaveCounter(this.isNodeInDocument);
  }
  _createClass8(HTML5BackendImpl2, [{
    key: "profile",
    value: function profile() {
      var _this$dragStartSource, _this$dragOverTargetI;
      return {
        sourcePreviewNodes: this.sourcePreviewNodes.size,
        sourcePreviewNodeOptions: this.sourcePreviewNodeOptions.size,
        sourceNodeOptions: this.sourceNodeOptions.size,
        sourceNodes: this.sourceNodes.size,
        dragStartSourceIds: ((_this$dragStartSource = this.dragStartSourceIds) === null || _this$dragStartSource === void 0 ? void 0 : _this$dragStartSource.length) || 0,
        dropTargetIds: this.dropTargetIds.length,
        dragEnterTargetIds: this.dragEnterTargetIds.length,
        dragOverTargetIds: ((_this$dragOverTargetI = this.dragOverTargetIds) === null || _this$dragOverTargetI === void 0 ? void 0 : _this$dragOverTargetI.length) || 0
      };
    }
    // public for test
  }, {
    key: "window",
    get: function get3() {
      return this.options.window;
    }
  }, {
    key: "document",
    get: function get3() {
      return this.options.document;
    }
    /**
     * Get the root element to use for event subscriptions
     */
  }, {
    key: "rootElement",
    get: function get3() {
      return this.options.rootElement;
    }
  }, {
    key: "setup",
    value: function setup() {
      var root = this.rootElement;
      if (root === void 0) {
        return;
      }
      if (root.__isReactDndBackendSetUp) {
        throw new Error("Cannot have two HTML5 backends at the same time.");
      }
      root.__isReactDndBackendSetUp = true;
      this.addEventListeners(root);
    }
  }, {
    key: "teardown",
    value: function teardown() {
      var root = this.rootElement;
      if (root === void 0) {
        return;
      }
      root.__isReactDndBackendSetUp = false;
      this.removeEventListeners(this.rootElement);
      this.clearCurrentDragSourceNode();
      if (this.asyncEndDragFrameId) {
        var _this$window;
        (_this$window = this.window) === null || _this$window === void 0 ? void 0 : _this$window.cancelAnimationFrame(this.asyncEndDragFrameId);
      }
    }
  }, {
    key: "connectDragPreview",
    value: function connectDragPreview(sourceId, node, options) {
      var _this2 = this;
      this.sourcePreviewNodeOptions.set(sourceId, options);
      this.sourcePreviewNodes.set(sourceId, node);
      return function() {
        _this2.sourcePreviewNodes.delete(sourceId);
        _this2.sourcePreviewNodeOptions.delete(sourceId);
      };
    }
  }, {
    key: "connectDragSource",
    value: function connectDragSource(sourceId, node, options) {
      var _this3 = this;
      this.sourceNodes.set(sourceId, node);
      this.sourceNodeOptions.set(sourceId, options);
      var handleDragStart = function handleDragStart2(e) {
        return _this3.handleDragStart(e, sourceId);
      };
      var handleSelectStart = function handleSelectStart2(e) {
        return _this3.handleSelectStart(e);
      };
      node.setAttribute("draggable", "true");
      node.addEventListener("dragstart", handleDragStart);
      node.addEventListener("selectstart", handleSelectStart);
      return function() {
        _this3.sourceNodes.delete(sourceId);
        _this3.sourceNodeOptions.delete(sourceId);
        node.removeEventListener("dragstart", handleDragStart);
        node.removeEventListener("selectstart", handleSelectStart);
        node.setAttribute("draggable", "false");
      };
    }
  }, {
    key: "connectDropTarget",
    value: function connectDropTarget(targetId, node) {
      var _this4 = this;
      var handleDragEnter = function handleDragEnter2(e) {
        return _this4.handleDragEnter(e, targetId);
      };
      var handleDragOver = function handleDragOver2(e) {
        return _this4.handleDragOver(e, targetId);
      };
      var handleDrop = function handleDrop2(e) {
        return _this4.handleDrop(e, targetId);
      };
      node.addEventListener("dragenter", handleDragEnter);
      node.addEventListener("dragover", handleDragOver);
      node.addEventListener("drop", handleDrop);
      return function() {
        node.removeEventListener("dragenter", handleDragEnter);
        node.removeEventListener("dragover", handleDragOver);
        node.removeEventListener("drop", handleDrop);
      };
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners(target) {
      if (!target.addEventListener) {
        return;
      }
      target.addEventListener("dragstart", this.handleTopDragStart);
      target.addEventListener("dragstart", this.handleTopDragStartCapture, true);
      target.addEventListener("dragend", this.handleTopDragEndCapture, true);
      target.addEventListener("dragenter", this.handleTopDragEnter);
      target.addEventListener("dragenter", this.handleTopDragEnterCapture, true);
      target.addEventListener("dragleave", this.handleTopDragLeaveCapture, true);
      target.addEventListener("dragover", this.handleTopDragOver);
      target.addEventListener("dragover", this.handleTopDragOverCapture, true);
      target.addEventListener("drop", this.handleTopDrop);
      target.addEventListener("drop", this.handleTopDropCapture, true);
    }
  }, {
    key: "removeEventListeners",
    value: function removeEventListeners(target) {
      if (!target.removeEventListener) {
        return;
      }
      target.removeEventListener("dragstart", this.handleTopDragStart);
      target.removeEventListener("dragstart", this.handleTopDragStartCapture, true);
      target.removeEventListener("dragend", this.handleTopDragEndCapture, true);
      target.removeEventListener("dragenter", this.handleTopDragEnter);
      target.removeEventListener("dragenter", this.handleTopDragEnterCapture, true);
      target.removeEventListener("dragleave", this.handleTopDragLeaveCapture, true);
      target.removeEventListener("dragover", this.handleTopDragOver);
      target.removeEventListener("dragover", this.handleTopDragOverCapture, true);
      target.removeEventListener("drop", this.handleTopDrop);
      target.removeEventListener("drop", this.handleTopDropCapture, true);
    }
  }, {
    key: "getCurrentSourceNodeOptions",
    value: function getCurrentSourceNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourceNodeOptions = this.sourceNodeOptions.get(sourceId);
      return _objectSpread6({
        dropEffect: this.altKeyPressed ? "copy" : "move"
      }, sourceNodeOptions || {});
    }
  }, {
    key: "getCurrentDropEffect",
    value: function getCurrentDropEffect() {
      if (this.isDraggingNativeItem()) {
        return "copy";
      }
      return this.getCurrentSourceNodeOptions().dropEffect;
    }
  }, {
    key: "getCurrentSourcePreviewNodeOptions",
    value: function getCurrentSourcePreviewNodeOptions() {
      var sourceId = this.monitor.getSourceId();
      var sourcePreviewNodeOptions = this.sourcePreviewNodeOptions.get(sourceId);
      return _objectSpread6({
        anchorX: 0.5,
        anchorY: 0.5,
        captureDraggingState: false
      }, sourcePreviewNodeOptions || {});
    }
  }, {
    key: "isDraggingNativeItem",
    value: function isDraggingNativeItem() {
      var itemType = this.monitor.getItemType();
      return Object.keys(NativeTypes_exports).some(function(key) {
        return NativeTypes_exports[key] === itemType;
      });
    }
  }, {
    key: "beginDragNativeItem",
    value: function beginDragNativeItem(type, dataTransfer5) {
      this.clearCurrentDragSourceNode();
      this.currentNativeSource = createNativeDragSource(type, dataTransfer5);
      this.currentNativeHandle = this.registry.addSource(type, this.currentNativeSource);
      this.actions.beginDrag([this.currentNativeHandle]);
    }
  }, {
    key: "setCurrentDragSourceNode",
    value: function setCurrentDragSourceNode(node) {
      var _this5 = this;
      this.clearCurrentDragSourceNode();
      this.currentDragSourceNode = node;
      var MOUSE_MOVE_TIMEOUT = 1e3;
      this.mouseMoveTimeoutTimer = setTimeout(function() {
        var _this5$rootElement;
        return (_this5$rootElement = _this5.rootElement) === null || _this5$rootElement === void 0 ? void 0 : _this5$rootElement.addEventListener("mousemove", _this5.endDragIfSourceWasRemovedFromDOM, true);
      }, MOUSE_MOVE_TIMEOUT);
    }
  }, {
    key: "clearCurrentDragSourceNode",
    value: function clearCurrentDragSourceNode() {
      if (this.currentDragSourceNode) {
        this.currentDragSourceNode = null;
        if (this.rootElement) {
          var _this$window2;
          (_this$window2 = this.window) === null || _this$window2 === void 0 ? void 0 : _this$window2.clearTimeout(this.mouseMoveTimeoutTimer || void 0);
          this.rootElement.removeEventListener("mousemove", this.endDragIfSourceWasRemovedFromDOM, true);
        }
        this.mouseMoveTimeoutTimer = null;
        return true;
      }
      return false;
    }
  }, {
    key: "handleDragStart",
    value: function handleDragStart(e, sourceId) {
      if (e.defaultPrevented) {
        return;
      }
      if (!this.dragStartSourceIds) {
        this.dragStartSourceIds = [];
      }
      this.dragStartSourceIds.unshift(sourceId);
    }
  }, {
    key: "handleDragEnter",
    value: function handleDragEnter(e, targetId) {
      this.dragEnterTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDragOver",
    value: function handleDragOver(e, targetId) {
      if (this.dragOverTargetIds === null) {
        this.dragOverTargetIds = [];
      }
      this.dragOverTargetIds.unshift(targetId);
    }
  }, {
    key: "handleDrop",
    value: function handleDrop(e, targetId) {
      this.dropTargetIds.unshift(targetId);
    }
  }]);
  return HTML5BackendImpl2;
})();

// node_modules/react-dnd-html5-backend/dist/esm/index.js
var HTML5Backend = function createBackend(manager, context, options) {
  return new HTML5BackendImpl(manager, context, options);
};
var LoadingOrEmptyHandler = ({
  isLoading,
  description,
  imageSource
}) => {
  return isLoading ? /* @__PURE__ */ jsx("div", { className: "empty-page-loader left-1/2 top-1/2 absolute" }) : /* @__PURE__ */ jsx(Empty, { description, imageSource });
};
var loading_or_empty_handler_default = LoadingOrEmptyHandler;
var If = ({ condition, children }) => {
  if (condition) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return null;
};
var Unless = ({
  condition,
  children
}) => {
  if (!condition) {
    return /* @__PURE__ */ jsx(Fragment, { children });
  }
  return null;
};

export { ARIA_LABELS, Accordion, ActiveItem, AutoComplete, AutoCompleteOption, AutoResizingDebouncedInput, Avatar, AvatarGroup, Badge, Bar2 as Bar, BarChart, Button, Calendar, Card, Carousel, Checkbox, ChipInput, column_default as Column, ConfirmationModal, custom_multi_select_default as CustomMultiSelect, DangerButton, DatePicker, DateRangePicker, DateTimeFormat, DebouncedSearchInput, Divider, DndProvider, DonutChart, DonutChartList, DownloadImageBtn, drag_and_drop_file_uploader_default as DragAndDropFileUploader, draw_rectangles_over_image_default as DrawRectanglesOverImage, Drawer, DrawerHeader, DrawerItem, drop_down_with_search_pagination_default as DropDownWithSearchAndPagination, Dropdown, DropdownButton, DropdownItem, DurationFormat, DynamicValueInput, EMPTY_OBJECT, Empty, ErrorToolTip, Expandable, ExpandableInput, FIELD_NAMES, FORM_BUILDER_ACTION_TYPES, field_renderers_exports as FieldRenderers, Filters, FixedField, form_builder_default as FormBuilder, FormatOption, freshchat_default as FreshChat, FullPagination, HTML5Backend, Icon3 as Icon, IconGroup, IconGroupItem, If, ImageViewer, InfiniteScroll, infinite_scroll_v2_exports as InfiniteScrollV2, Input, InputWithCheckbox, InputWithRef, Label, LineChart, loading_or_empty_handler_default as LoadingOrEmptyHandler, Modal, multi_select_default as MultiSelect, multi_select_group_label_default as MultiSelectGroupLabel, multi_select_item_default as MultiSelectItem, NOOP, Note, otp_input_default as OTPInput, offline_default as Offline, Overlay, PasswordInput, PasswordInputWithRef, PieChart, popover_default as Popover, PopoverTooltip, PrimaryButton, PrimaryOutlineButton, Radio, RadioGroup, RadioGroupSearch, SearchInput, SearchableDropdown, SecondaryButton, ShimmerCardTileLoader, ShimmerLoader, SimplePagination, sort_label_default as SortLabel, Spinner, SpotEdit, StatusLabel, carousel_default as StepResultsCarousel, Tab, TabItem, TabelContext, Table, TableBody, TableCell, TableHeader, TableRow, test_case_reader_exports as TestCaseReader, test_case_result_reader_exports as TestCaseResultReader, TextArea, ThemeContext, ThemeContextProvider, Timer, ToggleSwitch, ToolTip, Tree, TruncatedText, uc_tab_default as UcTab, UcTabContent, UcTabHeader, uc_tabs_default as UcTabs, Unless, upgrade_modal_default as UpgradeModal, upgrade_popup_default as UpgradePopup, UploadAvatar, UploadButton, user_preference_reader_exports as UserPreferenceReader, v2_exports as V2, Video, __, acceptedExt, addCollection, addNode, areValidFileTypes, bindActions, blocksToText, bulkMoveNodes, checkType, cloneString, convertValueToBlock, deleteNode, escapeRegExp, findNode, formatBytes, formatMillisecond, generateUniqueId, getFileSizeMB, getFormattedDate, getFormattedTime, getOrigin, getSelectionOffset, handleDownload, handleFieldUpdate, hasStepValidXpath, initTranslations, isAllowedAppTypeForHighlight, isChrome, isEdge, isFireFox, isStepAddon, isValidDate, isValidFileType, isValidJson, moveNode, onFieldChange, preventBubble, renameNode, setCaret, sortAlphabetically, textToBlock, themes, toastify, tsLog, unwrapTemplate, use_animated_class_default as useAnimatedClass, use_before_unload_warning_default as useBeforeUnloadWarning, useBindActions, use_click_outside_default as useClickOutside, use_debounce_default as useDebounce, use_external_events_default as useExternalEvents, use_focus_default as useFocus, use_highlight_default as useHighlight, useHorizontalResize, useInputTextValidationSchema, use_internal_events_default as useInternalEvents, use_key_press_default as useKeyPress, use_on_action_default as useOnAction, use_popstate_listener_default as usePopstateListener, usePrevious, use_toggle_default as useToggle, use_transition_end_default as useTransitionEnd, useVerticalResize, validateEmail, validateFileName, wrapWithTemplate };
